import Ganyu_Card from './images/Ganyu_Card.webp'
import Ganyu_Icon from './images/Ganyu_Icon.png'
import Kaeya_Card from './images/Kaeya_Card.webp'
import Kaeya_Icon from './images/Kaeya_Icon.png'
import Chongyun_Card from './images/Chongyun_Card.webp'
import Chongyun_Icon from './images/Chongyun_Icon.png'
import Ayaka_Card from './images/Ayaka_Card.webp'
import Ayaka_Icon from './images/Ayaka_Icon.png'
import Xingqiu_Card from './images/Xingqiu_Card.webp'
import Xingqiu_Icon from './images/Xingqiu_Icon.png'
import Mona_Icon from './images/Mona_Icon.png'
import Diluc_Icon from './images/Diluc_Icon.png'
import Xiangling_Icon from './images/Xiangling_Icon.png'
import Bennett_Icon from './images/Bennett_Icon.png'
import Yoimiya_Icon from './images/Yoimiya_Icon.png'
import Fischl_Icon from './images/Fischl_Icon.png'
import Razor_Icon from './images/Razor_Icon.png'
import Keqing_Icon from './images/Keqing_Icon.png'
import Sucrose_Icon from './images/Sucrose_Icon.png'
import Jean_Icon from './images/Jean_Icon.png'
import Ningguang_Icon from './images/Ningguang_Icon.png'
import Noelle_Icon from './images/Noelle_Icon.png'
import Collei_Icon from './images/Collei_Icon.png'
import Oceanoid_Icon from './images/Oceanoid_Icon.png'
import Pyroagent_Icon from './images/Pyroagent_Icon.png'
import Maguu_Icon from './images/Maguu_Icon.png'
import Stonehidelawachurl_Icon from './images/Stonehidelawachurl_Icon.png'
import Diona_Icon from './images/Diona_Icon.png'
import Cyno_Icon from './images/Cyno_Icon.png'
import Barbara_Icon from './images/Barbara_Icon.png'
import Mirrormaiden_Icon from './images/Mirrormaiden_Icon.png'
import Terrorshroom_Icon from './images/Terrorshroom_Icon.png'
import Klee_Icon from './images/Klee_Icon.png'
import Sara_Icon from './images/Sara_Icon.png'
import Eula_Icon from './images/Eula_Icon.png'
import Beidou_Icon from './images/Beidou_Icon.png'
import Kokomi_Icon from './images/Kokomi_Icon.png'
import Tighnari_Icon from './images/Tighnari_Icon.png'
import Itto_Icon from './images/Itto_Icon.png'
import Ayato_Icon from './images/Ayato_Icon.png'
import Amber_Icon from './images/Amber_Icon.png'
import Shenhe_Icon from './images/Shenhe_Icon.png'
import Childe_Icon from './images/Childe_Icon.png'
import Hutao_Icon from './images/Hutao_Icon.png'
import Raiden_Icon from './images/Raiden_Icon.png'
import Yae_Icon from './images/Yae_Icon.png'
import Venti_Icon from './images/Venti_Icon.png'
import Xiao_Icon from './images/Xiao_Icon.png'
import Zhongli_Icon from './images/Zhongli_Icon.png'
import Nahida_Icon from './images/Nahida_Icon.png'
import Cryocicin_Icon from './images/Cryocicin_Icon.png'
import Electrohypostasis_Icon from './images/ElectroHypostasis_Icon.png'
import Abysslector_Icon from './images/Abyssherald_Icon.png'
import Yanfei_Icon from './images/Yanfei_Icon.png'
import Kazuha_Icon from './images/Kazuha_Icon.png'
import Candace_Icon from './images/Candace_Icon.png'
import Albedo_Icon from './images/Albedo_Icon.png'
import Qiqi_Icon from './images/Qiqi_Icon.png'
import Lisa_Icon from './images/Lisa_Icon.png'
import Yaoyao_Icon from './images/Yaoyao_Icon.png'
import Dehya_Icon from './images/Dehya_Icon.png'
import Wanderer_Icon from './images/Wanderer_Icon.png'
import Baizhu_Icon from './images/Baizhu_Icon.png'
import Nilou_Icon from './images/Nilou_Icon.png'
import Dori_Icon from './images/Dori_Icon.png'
import Gorou_Icon from './images/Gorou_Icon.png'
import Signora_Icon from './images/Signora_Icon.png'
import Layla_Icon from './images/Layla_Icon.png'
import PyroEremite_Icon from './images/PyroEremite_Icon.png'
import Lynette_Icon from './images/Lynette_Icon.png'
import Lyney_Icon from './images/Lyney_Icon.png'
import ThunderManifestation_Icon from './images/ThunderManifestation_Icon.png'
import Alhaitham_Icon from './images/Alhaitham_Icon.png'
import Azhdaha_Icon from './images/Azhdaha_Icon.png'
import Dvalin_Icon from './images/Dvalin_Icon.png'
import Yelan_Icon from './images/Yelan_Icon.png'
import CryoCube_Icon from './images/CryoCube_Icon.png'
import Thoma_Icon from './images/Thoma_Icon.png'
import Sayu_Icon from './images/Sayu_Icon.png'
import Seahorse_Icon from './images/Seahorse_Icon.png'

import Nullchar_Icon from './images/Nullchar_Icon.png'

import Anemo_Sort from './images/Anemo_Sort.png'
import Anemo_Sort_Activated from './images/Anemo_Sort_Activated.png'
import Cryo_Sort from './images/Cryo_Sort.png'
import Cryo_Sort_Activated from './images/Cryo_Sort_Activated.png'
import Dendro_Sort from './images/Dendro_Sort.png'
import Dendro_Sort_Activated from './images/Dendro_Sort_Activated.png'
import Electro_Sort from './images/Electro_Sort.png'
import Electro_Sort_Activated from './images/Electro_Sort_Activated.png'
import Geo_Sort from './images/Geo_Sort.png'
import Geo_Sort_Activated from './images/Geo_Sort_Activated.png'
import Hydro_Sort from './images/Hydro_Sort.png'
import Hydro_Sort_Activated from './images/Hydro_Sort_Activated.png'
import Pyro_Sort from './images/Pyro_Sort.png'
import Pyro_Sort_Activated from './images/Pyro_Sort_Activated.png'

import NoElement_Sort from './images/NoElement_Sort.png'

import Fatui_Sort from './images/Fatui_Sort.png'
import Hilichurl_Sort from './images/Hilichurl_Sort.png'
import Inazuma_Sort from './images/Inazuma_Sort.png'
import Kairagi_Sort from './images/Kairagi_Sort.png'
import Liyue_Sort from './images/Liyue_Sort.png'
import Mond_Sort from './images/Mond_Sort.png'
import Monster_Sort from './images/Monster_Sort.png'
import Sumeru_Sort from './images/Sumeru_Sort.png'

import Ayaka_Summon from './images/Ayaka_Summon.png'
import Barbara_Summon from './images/Barbara_Summon.png'
import Collei_Summon from './images/Collei_Summon.png'
import Diona_Summon from './images/Diona_Summon.png'
import Fischl_Summon from './images/Fischl_Summon.png'
import Ganyu_Summon from './images/Ganyu_Summon.png'
import Hilichurl_Summon1 from './images/Hilichurl_Summon1.png'
import Hilichurl_Summon2 from './images/Hilichurl_Summon2.png'
import Hilichurl_Summon3 from './images/Hilichurl_Summon3.png'
import Hilichurl_Summon4 from './images/Hilichurl_Summon4.png'
import Jean_Summon from './images/Jean_Summon.png'
import Keqing_Summon from './images/Keqing_Summon.png'
import Mona_Summon from './images/Mona_Summon.png'
import Oceanoid_Summon1 from './images/Oceanoid_Summon1.png'
import Oceanoid_Summon2 from './images/Oceanoid_Summon2.png'
import Oceanoid_Summon3 from './images/Oceanoid_Summon3.png'
import Sucrose_Summon from './images/Sucrose_Summon.png'
import Xiangling_Summon from './images/Xiangling_Summon.png'
import Maguu_Summon1 from './images/Maguu_Summon1.png'
import Maguu_Summon2 from './images/Maguu_Summon2.png'
import Sara_Summon1 from './images/Sara_Summon1.png'
import Sara_Summon2 from './images/Sara_Summon2.png'
import Kokomi_Summon from './images/Kokomi_Summon.png'
import Kokomi_Status from './images/Kokomi_Status.png'
import Eula_Summon from './images/Eula_Summon.png'
import Ayato_Summon from './images/Ayato_Summon.png'
import Itto_Summon from './images/Itto_Summon.png'
import Tighnari_Summon from './images/Tighnari_Summon.png'
import Zhongli_Summon from './images/Zhongli_Summon.png'
import Shenhe_Summon from './images/Shenhe_Summon.png'
import Raiden_Summon from './images/Raiden_Summon.png'
import Yae_Summon from './images/Yae_Summon.png'
import Venti_Summon from './images/Venti_Summon.png'
import Cicin_Summon from './images/Cicin_Summon.png'
import Lector_Summon from './images/Lector_Summon.png'
import Hypostasis_Summon from './images/Hypostasis_Summon.png'
import Amber_Summon from './images/Amber_Summon.png'

import Bennett_BStatus from './images/Bennett_BStatus.png'
import Kaeya_BStatus from './images/Kaeya_BStatus.png'
import Mona_BStatus from './images/Mona_BStatus.png'
import Noelle_Status from './images/Noelle_Status.png'
import Razor_Status from './images/Razor_Status.png'
import Xiangling_BStatus from './images/Xiangling_BStatus.png'
import Xingqiu_BStatus1 from './images/Xingqiu_BStatus1.png'
import Yoimiya_BStatus from './images/Yoimiya_BStatus.png'
import Cyno_Status from './images/Cyno_Status.png'
import Terrorshroom_Status from './images/Terrorshroom_Status.png'
import Klee_Status from './images/Klee_Status.png'
import Beidou_BStatus from './images/Beidou_BStatus.png'

import Pyro_Dice from './images/Pyro_Dice.png'
import Hydro_Dice from './images/Hydro_Dice.png'
import Anemo_Dice from './images/Anemo_Dice.png'
import Electro_Dice from './images/Electro_Dice.png'
import Dendro_Dice from './images/Dendro_Dice.png'
import Cryo_Dice from './images/Cryo_Dice.png'
import Geo_Dice from './images/Geo_Dice.png'
import White_Dice from './images/White_Dice.png'
import Black_Dice from './images/Black_Dice.png'
import Omni_Dice from './images/Omni_Dice.png'
import Energy from './images/Energy.png'
import Arcane from './images/Arcane.png'

import Action_Block_Test from './images/Action_Block_Test.png'
import Char_Sort from './images/Char_Sort.png'
import Action_Sort from './images/Action_Sort.png'
import Char_Sort_Hover from './images/Char_Sort_Hover.png'
import Action_Sort_Hover from './images/Action_Sort_Hover.png'
import Joyous_Celebration from './images/Joyous_Celebration.png'
import Chevreuse_Icon from './images/Chevreuse_Icon.png'
import Navia_Icon from './images/Navia_Icon.png'
import FrostOperative_Icon from './images/FrostOperative_Icon.png'
import Freminet_Icon from './images/Freminet_Icon.png'
import Xianyun_Icon from './images/Xianyun_Icon.png'
import HydroHilichurlRogue_Icon from './images/HydroHilichurlRogue_Icon.png'
import Chiori_Icon from './images/Chiori_Icon.png'
import AbyssLectorVioletLightning_Icon from './images/AbyssLectorVioletLightning_Icon.png'
import EremiteFloralRingDancer_Icon from './images/EremiteFloralRingDancer_Icon.png'
import Rosaria_Icon from './images/Rosaria_Icon.png'
import Sigewinne_Icon from './images/Sigewinne_Icon.png'
import GoldenWolflord_Icon from './images/GoldenWolflord_Icon.png'
import Mualani_Icon from './images/Mualani_Icon.png'
import Clorinde_Icon from './images/Clorinde_Icon.png'
import Arlecchino_Icon from './images/Arlecchino_Icon.png'
import Kinich_Icon from './images/Kinich_Icon.png'
import Kachina_Icon from './images/Kachina_Icon.png'
import Emilie_Icon from './images/Emilie_Icon.png'
import Sethos_Icon from './images/Sethos_Icon.png'
import Xilonen_Icon from './images/Xilonen_Icon.png'
import Citlali_Icon from './images/Citlali_Icon.png'
import Mavuika_Icon from './images/Mavuika_Icon.png'
import Chasca_Icon from './images/Chasca_Icon.png'
import LanYan_Icon from './images/LanYan_Icon.png'
import ShikanoinHeizou_Icon from './images/ShikanoinHeizou_Icon.png'
import GluttonousYumkasaurMountainKing_Icon from './images/GluttonousYumkasaurMountainKing_Icon.png'
import Iansan_Icon from './images/Iansan_Icon.png'
import YumemizukiMizuki_Icon from './images/YumemizukiMizuki_Icon.png'
import LordOfErodedPrimalFire_Icon from './images/LordOfErodedPrimalFire_Icon.png'
import Varesa_Icon from './images/Varesa_Icon.png'
import Ifa_Icon from './images/Ifa_Icon.png'
import HydroTulpa_Icon from './images/HydroTulpa_Icon.png'
import Escoffier_Icon from './images/Escoffier_Icon.png'
import Gaming_Icon from './images/Gaming_Icon.png'
import BlackSerpentKnightRockbreakerAx_Icon from './images/BlackSerpentKnightRockbreakerAx_Icon.png'
import Skirk_Icon from './images/Skirk_Icon.png'
import Ororon_Icon from './images/Ororon_Icon.png'
import ConsecratedHornedCrocodile_Icon from './images/ConsecratedHornedCrocodile_Icon.png'
import Mika_Icon from './images/Mika_Icon.png'
import Ineffa_Icon from './images/Ineffa_Icon.png'
import GoldflameQucusaurTyrant_Icon from './images/GoldflameQucusaurTyrant_Icon.png'
import Dahlia_Icon from './images/Dahlia_Icon.png'
import Aino_Icon from './images/Aino_Icon.png'
import ConsecratedFangedBeast_Icon from './images/ConsecratedFangedBeast_Icon.png'
import Flins_Icon from './images/Flins_Icon.png'
import Lauma_Icon from './images/Lauma_Icon.png'
import ExperimentalFieldGenerator_Icon from './images/ExperimentalFieldGenerator_Icon.png'
import Nefer_Icon from './images/Nefer_Icon.png'
import WaywardHermeticSpiritspeaker_Icon from './images/WaywardHermeticSpiritspeaker_Icon.png'
import BlackSerpentKnightWindcutter_Icon from './images/BlackSerpentKnightWindcutter_Icon.png'
import Durin_Icon from './images/Durin_Icon.png'
import Jahoda_Icon from './images/Jahoda_Icon.png'
import HydroHypostasis_Icon from './images/HydroHypostasis_Icon.png'
import Columbina_Icon from './images/Columbina_Icon.png'
import Illuga_Icon from './images/Illuga_Icon.png'

if (!(window.location.hash.substring(1).includes("FCyyUCaTqdmauwye29RQ"))) {

    var db = {
        "chars": {
            "ganyu": {
                "name": "Ganyu",
                'na': 'Liutian Archery \n2 Black, 1 Cryo \nDeals 2 Physical DMG.',
                'skill': "Trail of the Qilin \n3 Cryo \nDeals 1 Cryo DMG, creates 1 'Ice Lotus'.",
                'burst': "Celestial Shower \n3 Cryo, 3 Energy \nDeals 2 Cryo DMG, deals 1 Piercing DMG to all opposing characters on standby, summons 1 Sacred Cryo Pearl.",
                'special': "Normal Attack: Frostflake Arrow \n5 Cryo \nDeals 2 Cryo DMG, deals 2 Piercing DMG to all opposing characters on standby.",
                'hi_res_image': '/cards/i_n330000_gcg_high_resolution.webp',
                "card": Ganyu_Card,
                "card_selected": '/cards/i_n334000.webp',
                "icon": Ganyu_Icon,
                "element": 'cryo',
                "region": 'liyue',
                'related': 'Ice Lotus, Sacred Cryo Pearl',
                "flavor": "“This press release is due tomorrow… I suppose I could work through the night and get it done.”",
                "id": '03',
                "keyword": "bow"
            },
    
            "diona": {
                "name": 'Diona',
                'na': "Kätzlein Style \n2 Black, 1 Cryo \nDeals 2 Physical DMG.",
                'skill': "Icy Paws \n3 Cryo \nDeals 2 Cryo DMG, creates 1 'Cat-Claw Shield'.",
                'burst': "Signature Mix \n3 Cryo, 3 Energy \nDeals 1 Cryo DMG, heals this character for 2 HP, summons 1 'Drunken Mist'.",
                'hi_res_image': "/cards/i_n330023_gcg_high_resolution.webp",
                "card": '/cards/i_n330023.webp',
                "card_selected": '/cards/i_n334023.webp',
                "icon": Diona_Icon,
                "element": 'cryo',
                "region": 'mondstadt',
                'related': 'Cat-Claw Shield, Drunken Mist',
                "flavor": "Dedicating 1% of her energy to mixing drinks, and 99% to... refusing to accept failure.",
                "id": '02',
                "keyword": "bow"
            },
    
            "kaeya": {
                "name": 'Kaeya',
                'na': "Ceremonial Bladework \n2 Black, 1 Cryo \nDeals 2 Physical DMG.",
                'skill': "Frostgnaw \n3 Cryo \nDeals 3 Cryo DMG.",
                'burst': "Glacial Waltz \n4 Cryo, 2 Energy \nDeals 1 Cryo DMG, creates 1 'Icicle'.",
                'hi_res_image': "/cards/i_n330001_gcg_high_resolution.webp",
                "card": Kaeya_Card,
                "card_selected": '/cards/i_n334001.webp',
                "icon": Kaeya_Icon,
                "element": 'cryo',
                "region": 'mondstadt',
                'related': 'Icicle',
                "flavor": "Specializes in awakening knightly virtues in others.",
                "id": '01',
                "keyword": "sword"
            },
    
            "chongyun": {
                "name": 'Chongyun',
                'na': 'Demonbane \n2 Black, 1 Cryo \nDeals 2 Physical DMG.',
                'skill': "Chonghua’s Layered Frost \n3 Cryo \nDeals 3 Cryo DMG, creates 1 'Chonghua Frost Field'.",
                'burst': "Cloud-Parting Star \n3 Cryo, 3 Energy \nDeals 7 Cryo DMG.",
                'hi_res_image': '/cards/i_n330002_gcg_high_resolution.webp',
                "card": Chongyun_Card,
                "card_selected": '/cards/i_n334002.webp',
                "icon": Chongyun_Icon,
                "element": 'cryo',
                "region": 'liyue',
                'related': 'Chonghua Frost Field',
                "flavor": "“Ugh, summer… Please pass us by in peace…”",
                "id": '04',
                "keyword": "claymore"
            },
    
            "ayaka": {
                "name": 'Kamisato Ayaka',
                'na': 'Kamisato Art: Kabuki \n2 Black, 1 Cryo \nDeals 2 Physical DMG.',
                'skill': 'Kamisato Art: Hyouka \n3 Cryo \nDeals 3 Cryo DMG.',
                'burst': "Kamisato Art: Soumetsu \n3 Cryo, 3 Energy\nDeals 4 Cryo DMG, summons 1 'Frostflake Seki no To'.",
                'special': "Kamisato Art: Senho \n(Passive) \nWhen switched to be the active character, this character gains Cryo Elemental Infusion. The next Normal Attack during this Round deals +1 DMG. (Twice per Round)",
                'hi_res_image': '/cards/i_n330003_gcg_high_resolution.webp',
                "card": Ayaka_Card,
                "card_selected": '/cards/i_n334003.webp',
                "icon": Ayaka_Icon,
                "element": 'cryo',
                "region": 'inazuma',
                'related': "Frostflake Seki no To, Kamisato Ayaka's Cryo Infusion",
                "flavor": "As graceful as the frost drifting in the wind, as elegant as a heron perched in a courtyard.",
                "id": '05',
                "keyword": "sword"
            },
    
            "eula": {
                "name": "Eula",
                "na": "Favonius Bladework - Edel\n2 Black, 1 Cryo\nDeals 2 Physical DMG.",
                "skill": "Icetide Vortex \n3 Cryo \nDeals 2 Cryo DMG. If this character has not yet gained Grimheart, they will gain Grimheart.",
                "burst": "Glacial Illumination\n3 Cryo, 2 Energy\n Deals 2 Cryo DMG, summons 1 Lightfall Sword.",
                'hi_res_image': '/cards/i_n330028_gcg_high_resolution.webp',
                "card": '/cards/i_n330028.webp',
                "card_selected": '/cards/i_n334030.webp',
                "icon": Eula_Icon,
                "element": "cryo",
                "region": 'mondstadt',
                "related": "Grimheart, Lightfall Sword",
                "flavor": "It's but a game. I won't hold a grudge should luck happen to be on your side.",
                "id": '49',
                "keyword": "claymore"
            },
    
            'shenhe': {
                'name': 'Shenhe',
                'na': "Dawnstar Piercer \n2 Black, 1 Cryo \nDeals 2 Physical DMG.",
                'skill': "Spring Spirit Summoning \n3 Cryo \nDeals 2 Cryo DMG, creates 1 Icy Quill.",
                'burst': "Divine Maiden's Deliverance \n3 Cryo, 2 Energy \nDeals 1 Cryo DMG, summons 1 Talisman Spirit.",
                'hi_res_image': '/cards/i_n330048_gcg_high_resolution.webp',
                'card': '/cards/i_n330048.webp',
                'card_selected': '/cards/i_n334048.webp',
                'icon': Shenhe_Icon,
                'element': 'cryo',
                'region': 'liyue',
                'related': 'Icy Quill, Talisman Spirit',
                'flavor': 'The mortal realm briefly gracing, like a wisp of smoke vanishing.',
                'id': '4Y',
                "keyword": "polearm"
            },

            'qiqi': {
                'name': 'Qiqi',
                'na': "Ancient Sword Art \n2 Black, 1 Cryo \nDeals 2 Physical DMG.",
                'skill': "Adeptus Art: Herald of Frost \n3 Cryo \nSummons Herald of Frost.",
                'burst': "Adeptus Art: Preserver of Fortune \n3 Cryo, 3 Energy \nDeals 3 Cryo DMG, creates 1 Fortune-Preserving Talisman.",
                'hi_res_image': '/cards/i_n330052_gcg_high_resolution.webp',
                'card': '/cards/i_n330052.webp',
                'card_selected': '/cards/i_n334052.webp',
                'icon': Qiqi_Icon,
                'element': 'cryo',
                'region': 'liyue',
                'related': 'Herald of Frost, Fortune-Preserving Talisman',
                'flavor': 'Circulating endlessly, life goes on.',
                'id': '6S',
                "keyword": "sword"
            },

            'layla': {
                'name': 'Layla',
                'na': "Sword of the Radiant Path \n2 Black, 1 Cryo \nDeals 2 Physical DMG.",
                'skill': "Nights of Formal Focus \n3 Cryo \nCreates 1 Curtain of Slumber Shield and Shooting Star.",
                'burst': "Dream of the Star-Stream Shaker \n3 Cryo, 2 Energy\nDeals 3 Cryo DMG, summons 1 Celestial Dreamsphere.",
                'hi_res_image': '/cards/i_n330062_gcg_high_resolution.webp',
                'card': '/cards/i_n330062.webp',
                'card_selected': '/cards/i_n334062.webp',
                'icon': Layla_Icon,
                'element': 'cryo',
                'region': 'sumeru',
                'related': 'Curtain of Slumber Shield, Shooting Star, Celestial Dreamsphere',
                'flavor': "As night falls, the stars swirl and the moon wanders amidst dreams.",
                'id': '7P',
                'keyword': 'sword',
            },

            'charlotte': {
                'name': 'Charlotte',
                'na': "Cool-Color Capture \n2 Black, 1 Cryo \nDeals 1 Cryo DMG.",
                'skill': "Framing: Freezing Point Composition \n3 Cryo \nDeals 1 Cryo DMG. Attach Snappy Silhouette to the target.",
                'burst': "Still Photo: Comprehensive Confirmation \n3 Cryo, 2 Energy\nDeals 1 Cryo DMG, heals all your characters for 1 HP, summons 1 Newsflash Field.",
                'hi_res_image': '/cards/i_n330075_gcg_high_resolution.webp',
                'card': '/cards/i_n330075.webp',
                'card_selected': '/cards/i_n334075.webp',
                'icon': 'https://act-webstatic.hoyoverse.com/hk4e/e20200928calculate/item_char_icon_u7ea0f/e932142691d6c9437c3e3803ec7816e5.png',
                'element': 'cryo',
                'region': 'fontaine',
                'related': 'Snappy Silhouette, Newsflash Field',
                'flavor': "\"Your credible source of the unbelievable truth!\"",
                'id': '9A',
                'keyword': 'catalyst',
            },

            'wrio': {
                'name': 'Wriothesley',
                'na': "Forceful Fists of Frost \n2 Black, 1 Cryo \nDeals 1 Cryo DMG.",
                'skill': "Icefang Rush \n3 Cryo \nDeals 2 Cryo DMG. This character gains Chilling Penalty.",
                'burst': "Darkgold Wolfbite \n3 Cryo, 3 Energy \nDeals 2 Cryo DMG, creates 1 Lingering Icicles. \n\nWhen this character takes DMG or is healed 2 times in total this Round: This Skill costs 1 fewer Elemental Die (Cost can be reduced by up to 2).",
                'special': "Darkgold Wolfbite \n(Passive) \nWhen this character takes DMG or is healed 2 times in total this Round: Elemental Burst costs 1 fewer Elemental Die (Cost can be reduced by up to 2).",
                'hi_res_image': '/cards/i_n330083_gcg_high_resolution.webp',
                'card': '/cards/i_n330083.webp',
                'card_selected': '/cards/i_n334083.webp',
                'icon': 'https://act-webstatic.hoyoverse.com/hk4e/e20200928calculate/item_char_icon_u63dbg/95116fbf8294d1b6f780563363ba38d3.png',
                'element': 'cryo',
                'region': 'fontaine',
                'related': 'Chilling Penalty, Lingering Icicles',
                'flavor': "Guilty waters run deep.",
                'id': '9S',
                'keyword': 'catalyst',
            },

            'freminet': {
                'name': "Freminet",
                'na': "Flowing Eddies \n2 Black, 1 Cryo \nDeals 2 Physical DMG.",
                'skill': "Pressurized Floe \n3 Cryo \nDeals 2 Cryo DMG. If this character has not yet gained Pers Timer, they will gain Pers Timer.",
                'burst': "Shadowhunter's Ambush \n3 Cryo, 2 Energy \nDeals 4 Cryo DMG. Attaches Subnautical Hunter Mode to this character.",
                'hi_res_image': '/cards/gcg_1112_hd.webp',
                'card': '/cards/gcg_1112.webp',
                'card_selected': '/cards/gcg_1112_golden.webp',
                'icon': Freminet_Icon,
                'element': 'cryo',
                'region': 'fatui',
                'related': "Pers Timer, Subnautical Hunter Mode",
                'flavor': "Alone under the cold light of stars.",
                'id': 'BB',
                'keyword': 'claymore',
            },

            'rosaria': {
                'name': "Rosaria",
                'na': "Spear of the Church \n2 Black, 1 Cryo \nDeals 2 Physical DMG.",
                'skill': "Ravaging Confession \n3 Cryo \nDeals 1 Cryo DMG, creates 1 stack of Scope Out Soft Spots. (When the Scope Out Soft Spots effect is triggered, creates Strike Where It Hurts.)",
                'burst': "Rites of Termination \n3 Cryo, 2 Energy \nDeals 1 Cryo DMG, creates 2 stacks of Scope Out Soft Spots, and summons Evercold Frostlance.",
                'hi_res_image': '/cards/gcg_1113_hd.webp',
                'card': '/cards/gcg_1113.webp',
                'card_selected': '/cards/gcg_1113_golden.webp',
                'icon': Rosaria_Icon,
                'element': 'cryo',
                'region': 'mondstadt',
                'related': "Scope Out Soft Spots, Strike Where It Hurts, Evercold Frostlance",
                'flavor': "\"Light creates shadow, but shadow will not be controlled by light.\"",
                'id': 'C0',
                'keyword': 'polearm',
            },

            'citlali': {
                'name': "Citlali",
                'na': "Shadow-Stealing Spirit Vessel \n2 Black, 1 Cryo \nDeals 1 Cryo DMG.",
                'skill': "Dawnfrost Darkstar \n3 Cryo \nDeals 1 Cryo DMG. \n\nEnters Nightsoul's Blessing, gains 1 Nightsoul point, and creates 1 point of Opal Shield and Itzpapa. (This skill cannot be used after the character enters Nightsoul's Blessing)",
                'burst': "Edict of Entwined Splendor \n3 Cryo, 2 Energy \nDeals 2 Cryo DMG, deals 1 Piercing DMG to all opposing characters on standby, and, if possible, gains 2 Nightsoul points.",
                'special': "Songs of Profound Mystery \n(Passive) \nAfter you Select or deal DMG with an Elemental Reaction: If possible, gain 1 Nightsoul point. (Once per Round)",
                'hi_res_image': '/cards/gcg_1114_hd.webp',
                'card': '/cards/gcg_1114.webp',
                'card_selected': '/cards/gcg_1114_golden.webp',
                'icon': Citlali_Icon,
                'element': 'cryo',
                'region': 'natlan',
                'related': "Nightsoul's Blessing, Opal Shield, Itzpapa",
                'flavor': "The vivid night-wind flows, obsidian reflects the heart.",
                'id': 'D9',
                'keyword': 'catalyst',
            },

            'escoffier': {
                'name': "Escoffier",
                'na': "Kitchen Skills \n2 Black, 1 Cryo \nDeals 2 Physical DMG.",
                'skill': "Low-Temperature Cooking \n3 Cryo \nDeals 1 Cryo DMG, summons Cooking Mek: Cold Storage Mode.",
                'burst': "Scoring Cuts \n3 Cryo, 2 Energy \nDeals 1 Cryo DMG, heals all your characters for 2 HP.",
                'special': "Constant Off-the-Cuff Cookery \n(Passive) \nWhen battle begins, create 1 All-Spectrum Multi-Use Cooking Mek.",
                'hi_res_image': '/cards/gcg_1115_hd.webp',
                'card': '/cards/gcg_1115.webp',
                'card_selected': '/cards/gcg_1115_golden.webp',
                'icon': Escoffier_Icon,
                'element': 'cryo',
                'region': 'fontaine',
                'related': "Cooking Mek: Cold Storage Mode, All-Spectrum Multi-Use Cooking Mek",
                'flavor': "Frosting and bake, the best taste to make.",
                'id': 'ET',
                'keyword': 'polearm',
            },

            'skirk': {
                'name': "Skirk",
                'na': "Havoc: Sunder \n2 Black, 1 Cryo \nDeals 2 Physical DMG.",
                'skill': "Havoc: Warp \n2 Cryo \nGains 2 Serpent's Subtlety, then creates 1 Mutual Weapons Mentorship and adds it to your Hand. (Once per Round)",
                'burst': "Havoc: Ruin \n3 Cryo, 2 Serpent's Subtlety \nConsumes all Serpent's Subtlety, deals Cryo DMG equal to the Serpent's Subtlety consumed, and deals 2 Piercing DMG to characters on standby. If 7 Serpent's Subtlety are consumed, deal 3 Piercing DMG to characters on standby instead.",
                'special': "Reason Beyond Reason \n(Passive) \nSkirk is unable to gain Energy but can now accumulate up to 7 points of Serpent's Subtlety. \n\nAfter you trigger Frozen, Cryo Swirl, Superconduct, or Cryo Crystallize reactions: Create 1 Void Rift in your hand. (3 times per Round)",
                'hi_res_image': '/cards/gcg_1116_hd.webp',
                'card': '/cards/gcg_1116.webp',
                'card_selected': '/cards/gcg_1116_golden.webp',
                'icon': Skirk_Icon,
                'element': 'cryo',
                'region': 'cosmic calamity',
                'related': "Mutual Weapons Mentorship, Void Rift",
                'flavor': "The stars fade to black.",
                'id': 'F4',
                'keyword': 'sword',
            },

            'mika': {
                'name': "Mika",
                'na': "Spear of Favonius - Arrow's Passage \n2 Black, 1 Cryo \nDeals 2 Physical DMG.",
                'skill': "Starfrost Swirl \n3 Cryo \nDeals 2 Cryo DMG and creates Soulwind.",
                'burst': "Skyfeather Song \n3 Cryo, 2 Energy \nHeals all your characters for 1 HP, creates Eagleplume Experience and Eagleplume Encomium.",
                'special': "Suppressive Barrage \n(Passive) \nAfter this character uses a Skill: +1 to the next instance of Physical DMG you deal. (Twice per Round)",
                'hi_res_image': '/cards/gcg_1117_hd.webp',
                'card': '/cards/gcg_1117.webp',
                'card_selected': '/cards/gcg_1117_golden.webp',
                'icon': Mika_Icon,
                'element': 'cryo',
                'region': 'mondstadt',
                'related': "Soulwind, Eagleplume Experience, Eagleplume Encomium",
                'flavor': "With a feather plume as gold as maize, uncharted borders are depicted as clear as day.",
                'id': 'FF',
                'keyword': 'polearm',
            },
    
            "barbara": {
                "name": "Barbara",
                'na': 'Whisper of Water \n2 Black, 1 Hydro \nDeals 1 Hydro DMG.',
                'skill': "Let the Show Begin♪ \n3 Hydro \nDeals 1 Hydro DMG, summons 1 'Melody Loop'.",
                'burst': "Shining Miracle♪ \n3 Hydro, 3 Energy \nHeals all of your characters for 4 HP.",
                'hi_res_image': '/cards/i_n330025_gcg_high_resolution.webp',
                "card": '/cards/i_n330025.webp',
                "card_selected": '/cards/i_n334025.webp',
                "icon": Barbara_Icon,
                "element": 'hydro',
                "region": 'mondstadt',
                'related': 'Melody Loop',
                "flavor": "Ready to heal hearts and soothe souls at any time.",
                "id": '07',
                "keyword": "catalyst"        
            },
    
            "xingqiu": {
                "name": 'Xingqiu',
                'na': 'Guhua Style \n2 Black, 1 Hydro \nDeals 2 Physical DMG.',
                'skill': "Fatal Rainscreen \n3 Hydro \nDeals 2 Hydro DMG, grants this character 'Hydro Application', creates 1 'Rain Sword'.",
                'burst': "Raincutter \n3 Hydro, 2 Energy \nDeals 2 Hydro DMG, grants this character 'Hydro Application', creates 1 'Rainbow Bladework'.",
                'hi_res_image': '/cards/i_n330004_gcg_high_resolution.webp',
                "card": Xingqiu_Card,
                "card_selected": '/cards/i_n334004.webp',
                "icon": Xingqiu_Icon,
                "element": 'hydro',
                "region": 'liyue',
                'related': 'Rain Sword, Rainbow Bladework',
                "flavor": "“Is it just me, or are the protagonists in novels nowadays all students of some private school or another…”",
                "id": '08',
                "keyword": "sword"        
            },
    
            "mona": {
                "name": "Mona",
                'na': 'Ripple of Fate \n2 Black, 1 Hydro \nDeals 1 Hydro DMG.',
                'skill': "Mirror Reflection of Doom \n3 Hydro \nDeals 1 Hydro DMG, summons 1 'Reflection'.",
                'burst': "Stellaris Phantasm \n3 Hydro, 3 Energy \nDeals 4 Hydro DMG, creates 1 'Illusory Bubble.",
                'special': "Illusory Torrent \n(Passive) \nWhen you perform \"Switch Character\" while Mona is your active character: This switch is considered a Fast Action instead of a Combat Action. (Once per Round)",
                'hi_res_image': '/cards/i_n330005_gcg_high_resolution.webp',
                "card": '/cards/i_n330005.webp',
                "card_selected": '/cards/i_n334005.webp',
                "icon": Mona_Icon,
                "element": 'hydro',
                "region": 'mondstadt',
                'related': 'Reflection, Illusory Bubble',
                "flavor": "Victory or defeat — it has all been written in the stars.",
                "id": '06',
                "keyword": "catalyst"        
            },

            'tartaglia': {
                'name': 'Tartaglia',
                'na': "Cutting Torrent \n2 Black, 1 Hydro \nDeals 2 Physical DMG.",
                'skill': 'Foul Legacy: Raging Tide \n3 Hydro \nSwitches to Melee Stance and deals 2 Hydro DMG, and attach Riptide to the target character.',
                'burst': "Havoc: Obliteration \n3 Hydro, 3 Energy \nPerforms different attacks based on the current stance that Tartaglia is in. \n\nRanged Stance - Flash of Havoc: Deal 5 Hydro DMG, reclaim 2 Energy, and apply Riptide to the target character. \n\nMelee Stance - Light of Obliteration: Deal 7 Hydro DMG.",
                'special': "Tide Withholder \n(Passive) \nWhen the battle begins, this character gains Ranged Stance. Once the Melee Stance attached to the character ends, reapplies Ranged Stance.",
                'hi_res_image': '/cards/i_n330029_gcg_high_resolution.webp',
                'card': '/cards/i_n330029.webp',
                'card_selected': '/cards/i_n334036.webp',
                'related': 'Melee Stance, Ranged Stance, Riptide',
                'icon': Childe_Icon,
                'element': 'hydro',
                'region': 'fatui',
                'flavor': 'Should this table be considered a battlefield, then may the strongest claim the win.',
                'id': '4Z',
                "keyword": "bow"
            },
    
            "kokomi": {
                "name": "Sangonomiya Kokomi",
                "na": "The Shape of Water\n2 Black, 1 Hydro \nDeals 1 Hydro DMG.",
                "skill": "Kurage's Oath\n3 Hydro \nThis character gains Hydro Application and summons 1 Bake-Kurage.",
                "burst": "Nereid's Ascension \n3 Hydro, 2 Energy \nDeals 2 Hydro DMG. Heals all allied characters for 1 point. This character gains Ceremonial Garment.",
                'hi_res_image': '/cards/i_n330030_gcg_high_resolution.webp',
                "card": "/cards/i_n330030.webp",
                "card_selected": "/cards/i_n334031.webp",
                "icon": Kokomi_Icon,
                "element": 'hydro',
                "region": "inazuma",
                'related': "Bake-Kurage, Ceremonial Garment",
                "flavor": "To survive hardship, you must prepare for hardship.",
                "id": '48',
                "keyword": "catalyst"
            },
    
            "ayato": {
                "name": "Kamisato Ayato",
                "na": "Kamisato Art: Marobashi\n2 Black, 1 Hydro \nDeals 2 Physical DMG.",
                'skill': "Kamisato Art: Kyouka\n3 Hydro \nDeals 2 Hydro DMG. This character gains 'Takimeguri Kanka'.",
                'burst': "Kamisato Art: Suiyuu\n3 Hydro, 2 Energy \nDeals 1 Hydro DMG, summons 1 'Garden of Purity'.",
                "hi_res_image": '/cards/i_n330031_gcg_high_resolution.webp',
                "card": '/cards/i_n330031.webp',
                "card_selected": '/cards/i_n334033.webp',
                'related': 'Takimeguri Kanka, Garden of Purity',
                "icon": Ayato_Icon,
                "element": 'hydro',
                "region": "inazuma",
                "flavor": "The divinely-blessed cypress sprouts new leaves.",
                "id": '4F',
                "keyword": "sword"
            },

            "candace": {
                "name": "Candace",
                "na": "Gleaming Spear - Guardian Stance\n2 Black, 1 Hydro \nDeals 2 Physical DMG.",
                'skill': "Sacred Rite: Heron's Sanctum \n3 Hydro \nAttaches a Heron Shield to this character and prepares Heron Strike.",
                'burst': "Sacred Rite: Wagtail's Tide\n3 Hydro, 2 Energy \nDeals 2 Hydro DMG and creates 1 Prayer of the Crimson Crown.",
                "special": "Heron Strike\n(Prepare for 1 turn)\nDeals 3 Hydro DMG.",
                "hi_res_image": '/cards/i_n330049_gcg_high_resolution.webp',
                "card": '/cards/i_n330049.webp',
                "card_selected": '/cards/i_n334049.webp',
                'related': 'Heron Shield, Prayer of the Crimson Crown',
                "icon": Candace_Icon,
                "element": 'hydro',
                "region": "sumeru",
                "flavor": "The crimson sand flows, an oath to defend.",
                "id": '6G',
                "keyword": "polearm "
            },

            "nilou": {
                "name": "Nilou",
                "na": "Dance of Samser\n2 Black, 1 Hydro \nDeals 2 Physical DMG.",
                'skill': "Dance of Haftkarsvar\n3 Hydro \nDeals 3 Hydro DMG, if the party includes Hydro Characters and Dendro Characters and characters from no other Elements, create 1 Golden Chalice's Bounty.",
                'burst': "Dance of Abzendegi: Distant Dreams, Listening Spring \n3 Hydro, 2 Energy \nDeals 2 Hydro DMG. The target character and the next character receives Lingering Aeon.",
                "hi_res_image": '/cards/i_n330057_gcg_high_resolution.webp',
                "card": '/cards/i_n330057.webp',
                "card_selected": '/cards/i_n334057.webp',
                'related': 'Golden Chalice\'s Bounty, Lingering Aeon',
                "icon": Nilou_Icon,
                "element": 'hydro',
                "region": "sumeru",
                "flavor": "Steps floating like lotus petals, emerging from an intoxicating dream.",
                "id": '7E',
                "keyword": "sword"
            },

            'yelan': {
                'name': 'Yelan',
                'na': "Stealthy Bowshot \n2 Black, 1 Hydro \nDeals 2 Physical DMG.",
                'skill': "Lingering Lifeline \n3 Hydro \nDeals 3 Hydro DMG. This character gains 2 Breakthrough stacks.",
                'burst': "Depth-Clarion Dice \n3 Hydro, 3 Energy \nDeals 3 Hydro DMG, creates 1 Exquisite Throw.",
                'special': "Breakthrough \n(Passive) \nWhen the battle begins, this character gains Breakthrough.",
                'hi_res_image': '/cards/i_n330063_gcg_high_resolution.webp',
                'card': '/cards/i_n330063.webp',
                'card_selected': '/cards/i_n334063.webp',
                'icon': Yelan_Icon,
                'element': 'hydro',
                'region': 'liyue',
                'related': 'Exquisite Throw, Breakthrough',
                'flavor': "The world is vast and infinite, the solitary one comes and goes as she pleases.",
                'id': '7Q',
                'keyword': 'bow',
            },

            'neuvillette': {
                'name': 'Neuvillette',
                'na': "As Water Seeks Equilibrium \n2 Black, 1 Hydro \nDeals 1 Hydro DMG.",
                'skill': "O Tears, I Shall Repay \n3 Hydro \nDeals 2 Hydro DMG, creates 1 Sourcewater Droplet.",
                'burst': "O Tides, I Have Returned \n3 Hydro, 2 Energy\nDeals 2 Hydro DMG, deals 1 Piercing DMG to all opposing characters on standby, then creates a Sourcewater Droplet with 2 Usages.",
                'special': "Equitable Judgment \n(Prepare for 1 turn) \nDeals 2 Hydro DMG. If this character has at least 6 HP, then this DMG is increased by 1 and this character deals 1 Piercing DMG to himself.",
                'hi_res_image': '/cards/i_n330076_gcg_high_resolution.webp',
                'card': '/cards/i_n330076.webp',
                'card_selected': '/cards/i_n334076.webp',
                'icon': 'https://act-webstatic.hoyoverse.com/hk4e/e20200928calculate/item_char_icon_u7ea0f/747d110614fba3a8dc79816d635fad5a.png',
                'element': 'hydro',
                'region': 'fontaine',
                'related': 'Sourcewater Droplet',
                'flavor': "He who looks down on all that are haughty.",
                'id': '9B',
                'keyword': 'catalyst',
            },

            'furina': {
                'name': 'Furina',
                'na': "Soloist's Solicitation \n2 Black, 1 Hydro \nDeals 2 Physical DMG. \n\nOnce per Round: If you do not have Seats Sacred and Secular in your Hand, create 1 Seats Sacred and Secular card in your Hand.",
                'skill': "Salon Solitaire \n3 Hydro \nFurina is currently in the Arkhe: Ousia state. Summons Salon Members. \n\n(When Furina is in the Arkhe: Pneuma state, she will summon Singer of Many Waters instead)",
                'burst': "Let the People Rejoice \n4 Hydro, 2 Energy\nDeals 2 Hydro DMG, creates 1 Universal Revelry.",
                'special': "Arkhe: Seats Sacred and Secular \n(Passive) \nWhen battle begins, create 1 Seats Sacred and Secular card in your Hand.",
                'hi_res_image': '/cards/i_n330084_gcg_high_resolution.webp',
                'card': '/cards/i_n330084.webp',
                'card_selected': '/cards/i_n334084.webp',
                'icon': 'https://act-webstatic.hoyoverse.com/hk4e/e20200928calculate/item_char_icon_u63dbg/930cb19854c6c3f8ba72d716a70ca4d6.png',
                'element': 'hydro',
                'region': 'fontaine',
                'related': "Seats Sacred and Secular, Salon Members, Singer of Many Waters, Universal Revelry",
                'flavor': "Perpetual muse of chansons and rondeaux.",
                'id': '9T',
                'keyword': 'sword',
            },

            'sigewinne': {
                'name': "Sigewinne",
                'na': "Targeted Treatment \n2 Black, 1 Hydro \nDeals 2 Physical DMG.",
                'skill': "Rebound Hydrotherapy \n3 Hydro \nCreate 1 Large Bolstering Bubblebalm and insert as the third card from the top of your deck. This character gains 3 stacks of Bond of Life. (After the Large Bolstering Bubblebalm effect is triggered, create a Medium Bolstering Bubblebalm and place in your opponent's deck. After the Medium Bolstering Bubblebalm effect is triggered, create a Small Bolstering Bubblebalm and place in your deck.)",
                'burst': "Super Saturated Syringing \n3 Hydro, 2 Energy \nDeals 2 Hydro DMG, then performs \"Prepare Skill\" for Medical Intervention of Pure Intention.",
                'special': "Medical Intervention of Pure Intention \nDeals 2 Hydro DMG. \n",
                'special2': "Detailed Diagnosis, Thorough Treatment \n(Passive) \nWhen you switch to this character: If your side has Sourcewater Droplet, -1 to their Usage(s), and this character gains 1 Energy.",
                'hi_res_image': '/cards/gcg_1213_hd.webp',
                'card': '/cards/gcg_1213.webp',
                'card_selected': '/cards/gcg_1213_golden.webp',
                'icon': Sigewinne_Icon,
                'element': 'hydro',
                'region': 'fontaine',
                'related': "Large Bolstering Bubblebalm, Bond of Life, Medium Bolstering Bubblebalm, Small Bolstering Bubblebalm, Sourcewater Droplet",
                'flavor': "\"Pure spirit, heed my wish.\"",
                'id': 'C1',
                'keyword': 'bow',
            },

            'mualani': {
                'name': "Mualani",
                'na': "Cooling Treatment \n2 Black, 1 Hydro \nDeals 1 Hydro DMG.",
                'skill': "Surfshark Wavebreaker \n2 Hydro \nAttach Bitey Shark to self, then enter Nightsoul's Blessing and gain 2 \"Nightsoul points.\" (This skill cannot be used after the character enters Nightsoul's Blessing) \n\n(Characters with Bitey Shark attached can use the Technique: Sharky Surfboard)",
                'burst': "Boomsharka-laka \n3 Hydro, 2 Energy \nDeals 2 Hydro DMG, summons Shark Missile.",
                'hi_res_image': '/cards/gcg_1214_hd.webp',
                'card': '/cards/gcg_1214.webp',
                'card_selected': '/cards/gcg_1214_golden.webp',
                'icon': Mualani_Icon,
                'element': 'hydro',
                'region': 'natlan',
                'related': "Bitey Shark, Nightsoul's Blessing, Shark Missile",
                'flavor': "Swellrider of Perennial Springs",
                'id': 'CC',
                'keyword': 'catalyst',
            },

            'dahlia': {
                'name': "Dahlia",
                'na': "Favonius Bladework - Ritual \n2 Black, 1 Hydro \nDeals 2 Physical DMG.",
                'skill': "Immersive Ordinance \n3 Hydro \nDeals 2 Hydro DMG and creates Sacramental Shower.",
                'burst': "Radiant Psalter \n3 Hydro, 2 Energy \nDeals 2 Hydro DMG, creates 2 stacks of Shield and 2 stacks of Favonian Favor.",
                'hi_res_image': '/cards/gcg_1215_hd.webp',
                'card': '/cards/gcg_1215.webp',
                'card_selected': '/cards/gcg_1215_golden.webp',
                'icon': Dahlia_Icon,
                'element': 'hydro',
                'region': 'mondstadt',
                'related': "Sacramental Shower, Shield, Favonian Favor",
                'flavor': "Let hymns of praise cast the winds as my ode.",
                'id': 'FU',
                'keyword': 'sword',
            },

            'aino': {
                'name': "Aino",
                'na': "Bish-Bash-Bosh Repair \n2 Black, 1 Hydro \nDeals 2 Physical DMG.",
                'skill': "Musecatcher \n3 Hydro \nDeal 2 Hydro DMG with 1 stack of Agile Switch created. If you have a card with Empowerment in your Hand, deal 3 Hydro DMG instead.",
                'burst': "Precision Hydronic Cooler \n3 Hydro, 2 Energy \nDeals 2 Hydro DMG and summons Cool Your Jets Ducky.",
                'special': "Modular Efficiency Protocol \n(Passive) \nWhen Empowerment is attached to your card: If there is Cool Your Jets Ducky on your side, it gains 1 Usage, otherwise, gains 1 Energy. (Once per Round)",
                'hi_res_image': '/cards/gcg_1216_hd.webp',
                'card': '/cards/gcg_1216.webp',
                'card_selected': '/cards/gcg_1216_golden.webp',
                'icon': Aino_Icon,
                'element': 'hydro',
                'region': 'nodkrai',
                'related': "Agile Switch, Cool Your Jets Ducky",
                'flavor': "Dreams spring to life with a clink-clank-clatter.",
                'id': 'FV',
                'keyword': 'claymore',
            },

            'columbina': {
                'name': "Columbina",
                'na': "Moondew Cascade \n2 Black, 1 Hydro \nDeals 1 Hydro DMG. \n\nDuring this match, after opposing characters have been affected by a total of 3 instances of Lunar Reactions, if there is a card with Cost Reduction attached to it in your Hand, place 1 random card in your Hand with Cost Reduction attached to it on top of your deck, then deal 1 Dendro DMG. (Once per Round)",
                'skill': "Eternal Tides \n3 Hydro \nDeals 1 Hydro DMG and creates Gravity Ripple.",
                'burst': "Moonlit Melancholy \n3 Hydro, 3 Energy \nDeals 3 Hydro DMG and creates Lunar Domain.",
                'special': "Moondew Cascade \n \n",
                'special2': "Moonsign Benediction: Moonlight, Lent Unto You \n(Passive) \nDuring this match, when the opponent is affected by the Electro-Charged Reaction/Bloom Reaction/Hydro Crystallize Reaction, the reaction will be converted to the Lunar-Charged/Lunar-Bloom/Lunar-Crystallize Reaction. \n\nWhen the opponent is affected by the Lunar-Charged/Lunar-Bloom/Lunar-Crystallize Reaction: Deals 1 Electro DMG/Dendro DMG/Geo DMG. (Once per Round)",
                'special3': "Moonsign Benediction: Moonlight, Lent Unto You \n(Passive) \n",
                'hi_res_image': '/cards/gcg_1217_hd.webp',
                'card': '/cards/gcg_1217.webp',
                'card_selected': '/cards/gcg_1217_golden.webp',
                'icon': Columbina_Icon,
                'element': 'hydro',
                'region': 'nodkrai',
                'related': "Gravity Ripple, Lunar Domain",
                'flavor': "Moonlit Dove, Where Lies Your Cove?",
                'id': 'H8',
                'keyword': 'catalyst',
            },
    
            "diluc": {
                "name": "Diluc",
                'na': 'Tempered Sword \n2 Black, 1 Pyro \nDeals 2 Physical DMG.',
                'skill': 'Searing Onslaught \n3 Pyro \nDeals 3 Pyro DMG. For the third use of this Skill each Round, deals +2 DMG.',
                'burst': "Dawn \n4 Pyro, 3 Energy \nDeals 8 Pyro DMG. This character gains 'Pyro Infusion'.",
                'hi_res_image': '/cards/i_n330006_gcg_high_resolution.webp',
                "card": '/cards/i_n330006.webp',
                "card_selected": '/cards/i_n334006.webp',
                "icon": Diluc_Icon,
                "element": 'pyro',
                "region": 'mondstadt',
                'related': "Diluc's Pyro Infusion",
                "flavor": "His heart is his greatest foe.",
                "id": '0B',
                "keyword": "claymore"
            },
    
            "xiangling": {
                "name": "Xiangling",
                'na': 'Dough-Fu \n2 Black, 1 Pyro \nDeals 2 Physical DMG.',
                'skill': "Guoba Attack \n3 Pyro \nSummons 1 'Guoba'.",
                'burst': "Pyronado \n4 Pyro, 2 Energy \nDeals 3 Pyro DMG, creates 1 'Pyronado'.",
                'hi_res_image': '/cards/i_n330007_gcg_high_resolution.webp',
                "card": '/cards/i_n330007.webp',
                "card_selected": '/cards/i_n334007.webp',
                "icon": Xiangling_Icon,
                "element": 'pyro',
                "region": 'liyue',
                'related': 'Guoba, Pyronado',
                "flavor": "As a chef, she is practically omnipotent.",
                "id": '0D',
                "keyword": "polearm"        
            },
    
            "bennett": {
                "name": "Bennett",
                'na': 'Strike of Fortune \n2 Black, 1 Pyro \nDeals 2 Physical DMG.',
                'skill': 'Passion Overload \n3 Pyro \nDeals 3 Pyro DMG.',
                'burst': "Fantastic Voyage \n4 Pyro, 2 Energy \nDeals 2 Pyro DMG, creates 1 'Inspiration Field'.",
                'hi_res_image': '/cards/i_n330008_gcg_high_resolution.webp',
                "card": '/cards/i_n330008.webp',
                "card_selected": '/cards/i_n334008.webp',
                "icon": Bennett_Icon,
                "element": 'pyro',
                "region": 'mondstadt',
                'related': 'Inspiration Field',
                "flavor": "Once you know that you will certainly lose, then you must certainly know the way to win.",
                "id": '0C',
                "keyword": "sword"        
            },
    
            "amber": {
                'name': 'Amber',
                'na': 'Sharpshooter \n2 Black, 1 Pyro \nDeals 2 Physical DMG.',
                'skill': 'Explosive Puppet \n3 Pyro \nSummons 1 Baron Bunny.',
                'burst': 'Fiery Rain \n3 Pyro, 2 Energy \nDeals 2 Pyro DMG, deals 2 Piercing DMG to all opposing characters on standby.',
                'hi_res_image': '/cards/i_n330009_gcg_high_resolution.webp',
                'card': '/cards/i_n330009.webp',
                "card_selected": '/cards/i_n334009.webp',
                "icon": Amber_Icon,
                "element": 'pyro',
                'region': 'mondstadt',
                'related': 'Baron Bunny',
                'flavor': 'If you want to be a great player...\nFirst, you have to have the courage to sit down and play.',
                'id': '4N',
                "keyword": "bow"
            },
    
            "yoimiya": {
                "name": 'Yoimiya',
                'na': 'Firework Flare-Up \n2 Black, 1 Pyro \nDeals 2 Physical DMG.',
                'skill': "Niwabi Fire-Dance \n1 Pyro \nThis character gains 'Niwabi Enshou'. (This Skill does not grant Energy)",
                'burst': "Ryuukin Saxifrage \n3 Pyro, 3 Energy \nDeals 3 Pyro DMG, creates 1 'Aurous Blaze'.",
                'hi_res_image': '/cards/i_n330010_gcg_high_resolution.webp',
                "card": '/cards/i_n330010.webp',
                "card_selected": '/cards/i_n334010.webp',
                "icon": Yoimiya_Icon,
                "element": 'pyro',
                "region": 'inazuma',
                'related': 'Niwabi Enshou, Aurous Blaze',
                "flavor": "Captain and Vanguard of Team Naganohara for the 11th Hanamizaka Street Invitational.",
                "id": '0E',
                "keyword": "bow"        
            },
    
            "klee": {
                "name": "Klee",
                "na": 'Kaboom!\n2 Black, 1 Pyro \nDeals 1 Pyro DMG.',
                "skill": "Jumpy Dumpty\n3 Pyro \nDeals 3 Pyro DMG. This character gains 'Explosive Spark'.",
                "burst": "Sparks'n'Splash\n3 Pyro, 3 Energy\nDeals 3 Pyro DMG, creates 1 'Sparks'n'Splash' at the opponent's play area.",
                'hi_res_image': '/cards/i_n330032_gcg_high_resolution.webp',
                "card": '/cards/i_n330032.webp',
                "card_selected": '/cards/i_n334029.webp',
                "icon": Klee_Icon,
                "element": 'pyro',
                "region": 'mondstadt',
                'related': "Explosive Spark, Sparks'n'Splash",
                "flavor": "Every card you draw may bring an “explosive surprise.”",
                "id": '43',
                "keyword": "catalyst"
            },
    
            "hutao": {
                'name': "Hu Tao",
                'na': "Secret Spear of Wangsheng \n2 Black, 1 Pyro \nDeals 2 Physical DMG.",
                'skill': "Guide to Afterlife \n2 Pyro \nThis character gains Paramita Papilio.",
                'burst': "Spirit Soother \n3 Pyro, 3 Energy \nDeals 4 Pyro DMG, heals herself for 2 HP. If this character's HP is no more than 6, DMG dealt and Healing are increased by 1.",
                'hi_res_image': '/cards/i_n330033_gcg_high_resolution.webp',
                'card': '/cards/i_n330033.webp',
                'card_selected': '/cards/i_n334037.webp',
                'icon': Hutao_Icon,
                'element': 'pyro',
                'region': "liyue",
                'related': 'Paramita Papilio, Blood Blossom',
                'flavor': '\"Send one, send \'em all!\"',
                'id': '4O',
                "keyword": "polearm"
            },

            "yanfei": {
                'name': "Yanfei",
                'na': "Seal of Approval \n2 Black, 1 Pyro \nDeals 1 Pyro DMG.",
                'skill': "Signed Edict \n3 Pyro \nDeals 3 Pyro DMG and attaches Scarlet Seal to this character.",
                'burst': "Done Deal \n3 Pyro, 2 Energy \nDeals 4 Pyro DMG, attaches Scarlet Seal and Brilliance to this character.",
                'hi_res_image': '/cards/i_n330050_gcg_high_resolution.webp',
                'card': '/cards/i_n330050.webp',
                'card_selected': '/cards/i_n334050.webp',
                'icon': Yanfei_Icon,
                'element': 'pyro',
                'region': "liyue",
                'related': 'Scarlet Seal, Brilliance',
                'flavor': 'One who fails to revise the classics is liable to fall foul of the law.',
                'id': '6H',
                "keyword": "catalyst"
            },

            "dehya": {
                'name': "Dehya",
                'na': "Sandstorm Assault \n2 Black, 1 Pyro \nDeals 2 Physical DMG.",
                'skill': "Molten Inferno \n3 Pyro \nSummon Fiery Sanctum Field. If Fiery Sanctum Field already exists, then first deal 1 Pyro DMG.",
                'burst': "Leonine Bite\n4 Pyro, 2 Energy \nDeals 3 Pyro DMG, then performs \"Prepare Skill\" for Incineration Drive.",
                'special': "Incineration Drive\n(Prepare for 1 turn)\nDeals 3 Pyro DMG.",
                'hi_res_image': '/cards/i_n330055_gcg_high_resolution.webp',
                'card': '/cards/i_n330055.webp',
                'card_selected': '/cards/i_n334054.webp',
                'icon': Dehya_Icon,
                'element': 'pyro',
                'region': "sumeru",
                'related': 'Fiery Sanctum Field',
                'flavor': "The eyes of a vulture, the spirit of a lion, an unbridled daughter of the desert.",
                'id': '73',
                "keyword": "claymore"
            },

            'lyney': { 
                'name': 'Lyney', 
                'na': "Card Force Translocation \n2 Black, 1 Pyro \nDeals 2 Physical DMG.", 
                'skill': "Bewildering Lights \n3 Pyro \nDeals 3 Pyro DMG.", 
                'burst': "Wondrous Trick: Miracle Parade\n3 Pyro, 2 Energy\nDeals 3 Pyro DMG, summons 1 Grin-Malkin Hat, and gains 1 stack of Prop Surplus.", 
                'special': "Normal Attack: Prop Arrow \n3 Pyro \nDeals 2 Pyro DMG, summons a Grin-Malkin Hat, and gains 1 stack of Prop Surplus. \n\nIf this character has at least 6 HP, then they deal 1 Piercing DMG to themself.", 
                'hi_res_image': '/cards/i_n330064_gcg_high_resolution.webp', 
                'card': '/cards/i_n330064.webp', 
                'card_selected': '/cards/i_n334064.webp', 
                'icon': Lyney_Icon, 
                'element': 'pyro',
                'region': 'fatui',
                'related': 'Prop Surplus, Grin-Malkin Hat', 
                'flavor': "Those flowers in the mirror... who are they for?", 
                'id': '7R', 
                'keyword': 'bow',
            },

            'thoma': { 
                'name': 'Thoma', 
                'na': "Swiftshatter Spear\n2 Black, 1 Pyro \nDeals 2 Physical DMG.", 
                'skill': "Blazing Blessing \n3 Pyro \nDeals 2 Pyro DMG, creates 1 Blazing Barrier.", 
                'burst': "Crimson Ooyoroi\n3 Pyro, 2 Energy\nDeals 2 Pyro DMG, creates 1 Blazing Barrier and Scorching Ooyoroi.", 
                'hi_res_image': '/cards/i_n330071_gcg_high_resolution.webp', 
                'card': '/cards/i_n330071.webp', 
                'card_selected': '/cards/i_n334071.webp', 
                'icon': Thoma_Icon, 
                'element': 'pyro',
                'region': 'inazuma',
                'related': 'Blazing Barrier, Scorching Ooyoroi', 
                'flavor': "A protector from abroad, loyal to the end.", 
                'id': '8V', 
                'keyword': 'polearm',
            },

            'xinyan': { 
                'name': 'Xinyan', 
                'na': "Dance on Fire\n2 Black, 1 Pyro \nDeals 2 Physical DMG.", 
                'skill': "Sweeping Fervor \n3 Pyro \nDeals 2 Pyro DMG, randomly Discard 1 card with the highest Current Elemental Dice Cost in your Hand and creates 1 Shield of Passion.",
                'burst': "Riff Revolution\n3 Pyro, 2 Energy\nDeals 3 Physical DMG, deals 2 Piercing DMG to all opposing characters on standby; Discard all cards in your Hand, creates 1 Festive Fires.", 
                'hi_res_image': '/cards/i_n330085_gcg_high_resolution.webp', 
                'card': '/cards/i_n330085.webp', 
                'card_selected': '/cards/i_n334085.webp', 
                'icon': 'https://act-webstatic.hoyoverse.com/hk4e/e20200928calculate/item_char_icon_u63dbg/64e3456560867fc7978ab5695d787608.png', 
                'element': 'pyro',
                'region': 'liyue',
                'related': 'Shield of Passion, Festive Fires', 
                'flavor': "Time to rock!", 
                'id': '9U', 
                'keyword': 'claymore',
            },

            'chevreuse': {
                'name': "Chevreuse",
                'na': "Line Bayonet Thrust EX \n2 Black, 1 Pyro \nDeals 2 Physical DMG.",
                'skill': "Short-Range Rapid Interdiction Fire \n3 Pyro \nDeals 2 Pyro DMG. \n\nAfter the Skill finalizes: If your Hand has Overcharged Ball: Discard 1 of them and heal the character on your team that has taken the most damage for 1 HP.",
                'burst': "Ring of Bursting Grenades \n3 Pyro, 2 Energy \nDeals 2 Pyro DMG, creates 1 Secondary Explosive Shells on the opponent's side of the field.",
                'special': "Vertical Force Coordination \n(Passive) \nAfter an opponent's character takes Overloaded reaction DMG: Create 1 Overcharged Ball card in your Hand (Once per Round)",
                'hi_res_image': '/cards/gcg_1313_hd.webp',
                'card': '/cards/gcg_1313.webp',
                'card_selected': '/cards/gcg_1313_golden.webp',
                'icon': Chevreuse_Icon,
                'element': 'pyro',
                'region': 'fontaine',
                'related': "Overcharged Ball, Secondary Explosive Shells",
                'flavor': "Righteous Enforcer of the Law.",
                'id': 'AZ',
                'keyword': 'polearm',
            },

            'arlecchino': {
                'name': "Arlecchino",
                'na': "Invitation to a Beheading \n2 Black, 1 Pyro \nDeal 2 Physical DMG. If possible, consume up to 3 stacks of the target's Bond of Life and increase DMG by the same amount.",
                'skill': "All Is Ash \n3 Pyro \nCreate 3 stacks of Blood-Debt Directive on the opponent's side of the field and deal 2 Pyro DMG.",
                'burst': "Balemoon Rising \n3 Pyro, 3 Energy \nDeal 4 Pyro DMG. Remove all of your stacks of Bond of Life and heal yourself for 1 HP per stack.",
                'special': "The Balemoon Alone May Know \n(Passive) \nCharacters won't receive healing from sources other than Balemoon Rising. \n\nWhen Bond of Life is attached to self: Physical DMG dealt by characters is converted to Pyro DMG.",
                'hi_res_image': '/cards/gcg_1314_hd.webp',
                'card': '/cards/gcg_1314.webp',
                'card_selected': '/cards/gcg_1314_golden.webp',
                'icon': Arlecchino_Icon,
                'element': 'pyro',
                'region': 'fatui',
                'related': "Bond of Life, Blood-Debt Directive",
                'flavor': "Solitary Balemoon in a Sky of Fading Stars.",
                'id': 'CM',
                'keyword': 'polearm',
            },

            'mavuika': {
                'name': "Mavuika",
                'na': "Flames Weave Life \n2 Black, 1 Pyro \nDeals 2 Physical DMG.",
                'skill': "The Named Moment \n3 Pyro \nEnters Nightsoul's Blessing and gains 2 \"Nightsoul points.\" Select 1 card from 3 Flamestrider cards to add to your Hand.",
                'burst': "Hour of Burning Skies \n4 Pyro, 3 Fighting Spirit \nThis character enters Nightsoul's Blessing, gains 1 Nightsoul point, and consumes all of their Fighting Spirit. They then deal Pyro DMG to the opponent's active character equal to the Fighting Spirit consumed. \n\nIf 6 points of Fighting Spirit are consumed, attach Crucible of Death and Life to this character.",
                'special': "Flamestrider: Full Throttle \nAt the start of the Action Phase: Create 2 Omni Dice. \n",
                'special2': "Fighting Spirit \n(Passive) \nThis character cannot gain Energy. \n\nEach time your characters consume Nightsoul points or use Normal Attacks, gain 1 Fighting Spirit. \n\nWhen this character uses an Elemental Skill or Elemental Burst, attach All-Fire Armaments: Ring of Searing Radiance.",
                'hi_res_image': '/cards/gcg_1315_hd.webp',
                'card': '/cards/gcg_1315.webp',
                'card_selected': '/cards/gcg_1315_golden.webp',
                'icon': Mavuika_Icon,
                'element': 'pyro',
                'region': 'natlan',
                'related': "Nightsoul's Blessing, Crucible of Death and Life, All-Fire Armaments: Ring of Searing Radiance",
                'flavor': "The brightest, most splendid, most resplendent flame reborn.",
                'id': 'DA',
                'keyword': 'claymore',
            },

            'gaming': {
                'name': "Gaming",
                'na': "Stellar Rend \n2 Black, 1 Pyro \nDeals 2 Physical DMG.",
                'skill': "Bestial Ascent \n3 Pyro \nDeals 1 Pyro DMG. Attaches Wushou Arts to self and switches to your next character.",
                'burst': "Suanni's Gilded Dance \n3 Pyro, 3 Energy \nDeals 2 Pyro DMG. Attaches Suanni: Man Chai to self.",
                'special': "Charmed Cloudstrider \nDeals 2 Pyro DMG. \n",
                'hi_res_image': '/cards/gcg_1316_hd.webp',
                'card': '/cards/gcg_1316.webp',
                'card_selected': '/cards/gcg_1316_golden.webp',
                'icon': Gaming_Icon,
                'element': 'pyro',
                'region': 'liyue',
                'related': "Wushou Arts, Suanni: Man Chai",
                'flavor': "\"Stalwart strider.\"",
                'id': 'EU',
                'keyword': 'claymore',
            },

            'durin': {
                'name': "Durin",
                'na': "Radiant Wingslash \n2 Black, 1 Pyro \nDeals 2 Physical DMG.",
                'skill': "Binary Form: Convergence and Division \n3 Pyro \nDeals 3 Pyro DMG. This character gains Essential Transmutation.",
                'burst': "Principle of Purity: As the Light Shifts \n3 Pyro, 2 Energy \nDeals 1 Pyro DMG and create Confirmation of Purity.",
                'special': "Light Manifest of the Divine Calculus \n(Passive) \nAfter this character uses a Normal Attack: Switch their Elemental Burst to Principle of Darkness: As the Stars Smolder. \n\nAfter this character uses an Elemental Skill: Switch their Elemental Burst to Principle of Purity: As the Light Shifts.",
                'hi_res_image': '/cards/gcg_1317_hd.webp',
                'card': '/cards/gcg_1317.webp',
                'card_selected': '/cards/gcg_1317_golden.webp',
                'icon': Durin_Icon,
                'element': 'pyro',
                'region': 'mondstadt',
                'related': "Essential Transmutation, Confirmation of Purity",
                'flavor': "Born from ink, he soars among the stars.",
                'id': 'GW',
                'keyword': 'sword',
            },
    
            "fischl": {
                "name": "Fischl",
                'na': 'Bolts of Downfall \n2 Black, 1 Electro \nDeals 2 Physical DMG.',
                'skill': "Nightrider \n3 Electro \nDeals 1 Electro DMG, summons 1 'Oz'.",
                'burst': "Midnight Phantasmagoria \n3 Electro, 3 Energy \nDeals 4 Electro DMG, deals 2 Piercing DMG to all opposing characters on standby.",
                'hi_res_image': '/cards/i_n330011_gcg_high_resolution.webp',
                "card": '/cards/i_n330011.webp',
                "card_selected": '/cards/i_n334011.webp',
                "icon": Fischl_Icon,
                "element": 'electro',
                "region": 'mondstadt',
                'related': 'Oz',
                "flavor": "“Oz, mine familiar, spread thine wings and weave for me a new fate in the gloom of this night!”\n“Mein Fräulein, you cannot expect me to fetch you a replacement card…”",
                "id": '0G',
                "keyword": "bow"        
            },
    
            "razor": {
                "name": "Razor",
                'na': 'Steel Fang \n2 Black, 1 Electro \nDeals 2 Physical DMG.',
                'skill': 'Claw and Thunder \n3 Electro \nDeals 3 Electro DMG.',
                'burst': "Lightning Fang \n3 Electro, 2 Energy \nDeals 3 Electro DMG. This character gains 'The Wolf Within'.",
                'hi_res_image': '/cards/i_n330012_gcg_high_resolution.webp',
                "card": '/cards/i_n330012.webp',
                "card_selected": '/cards/i_n334012.webp',
                "icon": Razor_Icon,
                "element": 'electro',
                "region": 'mondstadt',
                'related': 'The Wolf Within',
                "flavor": "“Cards, hard.”\n“But… friends…”",
                "id": '0H',
                "keyword": "claymore"        
            },
    
            "keqing": {
                "name": "Keqing",
                'na': 'Yunlai Swordsmanship \n2 Black, 1 Electro \nDeals 2 Physical DMG.',
                'skill': "Stellar Restoration \n3 Electro \nDeals 3 Electro DMG, creates 1 Lightning Stiletto.",
                'burst': "Starward Sword \n4 Electro, 3 Energy \nDeals 4 Electro DMG, deals 3 Piercing DMG to all opposing characters on standby.",
                'hi_res_image': '/cards/i_n330013_gcg_high_resolution.webp',
                "card": '/cards/i_n330013.webp',
                "card_selected": '/cards/i_n334013.webp',
                "icon": Keqing_Icon,
                "element": 'electro',
                "region": 'liyue',
                'related': "Lightning Stilleto, Keqing's Electro Infusion",
                "flavor": "She can build decks heretofore not conceived and win battles in which victory is unthinkable.",
                "id": '0I',
                "keyword": "sword"        
            },
    
            "cyno": {
                "name": "Cyno",
                'na': 'Invoker’s Spear\n2 Black, 1 Electro \nDeals 2 Physical DMG.',
                'skill': "Secret Rite: Chasmic Soulfarer \n3 Electro \nDeals 3 Electro DMG. \n\nPactsworn Pathclearer's Indwelling Level +1.",
                'burst': "Sacred Rite: Wolf’s Swiftness\n4 Electro, 2 Energy \nDeals 4 Electro DMG. Pactsworn Pathclearer's Indwelling Level +2.",
                'special': "Lawful Enforcer \n(Passive) \nWhen the battle begins, this character gains 'Pactsworn Pathclearer'.",
                'hi_res_image': '/cards/i_n330024_gcg_high_resolution.webp',
                "card": '/cards/i_n330024.webp',
                "card_selected": '/cards/i_n334024.webp',
                "icon": Cyno_Icon,
                "element": 'electro',
                "region": 'sumeru',
                'related': 'Pactsworn Pathclearer',
                "flavor": "The card bears the General Mahamatra's ardent fondness, which reminds one of the scorching sun hanging above the desert.",
                "id": '0J',
                "keyword": "polearm"        
            },
    
            "beidou": {
                "name": "Beidou",
                "na": 'Oceanborne\n2 Black, 1 Electro \nDeals 2 Physical DMG.',
                "skill": "Tidecaller \n3 Electro \nThis character gains a Tidecaller: Surf Embrace. Prepare Skill: Wavestrider.",
                "burst": "Stormbreaker\n3 Electro, 3 Energy\nDeals 2 Electro DMG, creates 1 'Thunderbeast's Targe'.",
                "special": "Wavestrider \n(Prepare for 1 turn) \nDeals 3 Electro DMG.",
                'hi_res_image': '/cards/i_n330034_gcg_high_resolution.webp',
                "card": '/cards/i_n330034.webp',
                "card_selected": '/cards/i_n334028.webp',
                "icon": Beidou_Icon,
                "element": 'electro',
                "region": 'liyue',
                'related': "Tidecaller: Surf Embrace, Thunderbeast's Targe",
                "flavor": "“Remember this day, you almost won money from the Captain of the Crux.”",
                "id": '44',
                "keyword": "claymore"
            },
    
            "sara": {
                "name": "Kujou Sara",
                "na": "Tengu Bowmanship \n2 Black, 1 Electro \nDeals 2 Physical DMG.",
                "skill": "Tengu Stormcall \n3 Electro \nDeals 1 Electro DMG, summons 1 Tengu Juurai: Ambush.",
                "burst": "Subjugation: Koukou Sendou \n4 Electro, 2 Energy \nDeals 2 Electro DMG, summons 1 Tengu Juurai: Stormcluster.",
                'hi_res_image': "/cards/i_n330035_gcg_high_resolution.webp",
                "card": "/cards/i_n330035.webp",
                "card_selected": "/cards/i_n334032.webp",
                "icon": Sara_Icon,
                "element": 'electro',
                "region": "inazuma",
                'related': "Tengu Jurrai: Ambush, Tengu Jurrai: Stormcluster, Crowfeather Cover",
                "flavor": "“This is an act of righteousness.”",
                "id": '47',
                "keyword": "bow"
            },
    
            "raiden": {
                'name': "Raiden Shogun",
                'na': "Origin \n2 Black, 1 Electro \nDeals 2 Physical DMG.",
                'skill': "Transcendence: Baleful Omen \n3 Electro \nSummons 1 Eye of Stormy Judgment.",
                'burst': "Secret Art: Musou Shinsetsu \n3 Electro, 2 Energy \nDeals 3 Electro DMG. All of your other characters gain 2 Energy.",
                'special': "Chakra Desiderata \n(Passive) \nWhen the battle begins, this character gains Chakra Desiderata.",
                'hi_res_image': '/cards/i_n330036_gcg_high_resolution.webp',
                'card': '/cards/i_n330036.webp',
                'card_selected': "/cards/i_n334038.webp",
                'icon': Raiden_Icon,
                'element': 'electro',
                'region': 'inazuma',
                'related': "Eye of Stormy Judgement, Chakra Desiderata",
                'flavor': 'The tranquil thunder shall scatter this world most ephemeral.',
                'id': '4P',
                "keyword": "polearm broken"
            },
    
            "yae": {
                'name': 'Yae Miko',
                'na': "Spiritfox Sin-Eater \n2 Black, 1 Electro \nDeals 1 Electro DMG.",
                'skill': "Yakan Evocation: Sesshou Sakura \n3 Electro \nSummons 1 Sesshou Sakura. If there is already 1 Sesshou Sakura in play, then increase the DMG dealt by +1. (Max +1)",
                'burst': "Great Secret Art: Tenko Kenshin \n3 Electro, 2 Energy \nDeals 4 Electro DMG. If your side of the field has a Sesshou Sakura, destroy it and create Tenko Thunderbolts.",
                'hi_res_image': '/cards/i_n330037_gcg_high_resolution.webp',
                'card': '/cards/i_n330037.webp',
                'card_selected': "/cards/i_n334039.webp",
                'icon': Yae_Icon,
                'element': 'electro',
                'region': 'inazuma',
                'related': 'Sesshou Sakura, Tenko Thunderbolts',
                'flavor': 'The wise and beautiful Yae Miko.',
                'id': '4Q',
                "keyword": "catalyst"
            },

            "lisa": {
                'name': 'Lisa',
                'na': "Lightning Touch \n2 Black, 1 Electro \nDeals 1 Electro DMG, attach Conductive to opposing active character.",
                'skill': "Violet Arc\n3 Electro \nDeals 2 Electro DMG. If Conductive is not attached to the opponent's active character, Conductive will be attached.",
                'burst': "Lightning Rose \n3 Electro, 2 Energy \nDeals 2 Electro DMG. Summons Lightning Rose. The opponent's active character gains Conductive.",
                'hi_res_image': '/cards/i_n330053_gcg_high_resolution.webp',
                'card': '/cards/i_n330053.webp',
                'card_selected': "/cards/i_n334053.webp",
                'icon': Lisa_Icon,
                'element': 'electro',
                'region': 'mond',
                'related': 'Conductive, Lightning Rose',
                'flavor': 'Pursuing the arcane mysteries of magic, and waiting quietly for an encounter with truth.',
                'id': '6T',
                "keyword": "catalyst"
            },

            "dori": {
                'name': 'Dori',
                'na': "Marvelous Sword-Dance (Modified) \n2 Black, 1 Electro \nDeals 2 Physical DMG.",
                'skill': "Spirit-Warding Lamp: Troubleshooter Cannon \n3 Electro \nDeals 2 Electro DMG, summons 1 After-Sales Service Rounds.",
                'burst': "Alcazarzaray's Exactitude \n3 Electro, 2 Energy \nDeals 1 Electro DMG, summons 1 Jinni.",
                'hi_res_image': '/cards/i_n330058_gcg_high_resolution.webp',
                'card': '/cards/i_n330058.webp',
                'card_selected': "/cards/i_n334058.webp",
                'icon': Dori_Icon,
                'element': 'electro',
                'region': 'sumeru',
                'related': "After-Sales Service Rounds, Jinni",
                'flavor': "The Mora, the merrier!",
                'id': '7F',
                "keyword": "claymore"
            },

            "kuki": {
                'name': 'Kuki Shinobu',
                'na': "Shinobu's Shadowsword\n2 Black, 1 Electro \nDeals 2 Physical DMG.",
                'skill': "Sanctifying Ring\n3 Electro \nSummons a Grass Ring of Sanctification. If this character has at least 6 HP, then she deals 2 Piercing DMG to herself.",
                'burst': "Gyoei Narukami Kariyama Rite\n3 Electro, 2 Energy \nDeals 4 Electro DMG, heals this character for 2 HP.",
                'hi_res_image': '/cards/i_n330079_gcg_high_resolution.webp',
                'card': '/cards/i_n330079.webp',
                'card_selected': "/cards/i_n334079.webp",
                'icon': 'https://act-webstatic.hoyoverse.com/hk4e/e20200928calculate/item_char_icon_u63dbg/592ca1fbffd8fe1c75c8a18209140f5c.png',
                'element': 'electro',
                'region': 'inazuma',
                'related': 'Grass Ring of Sanctification',
                'flavor': 'Master of all trades, deputy of the oni.',
                'id': '9O',
                "keyword": "sword"
            },

            'clorinde': {
                'name': "Clorinde",
                'na': "Oath of Hunting Shadows \n2 Black, 1 Electro \nDeals 1 Physical DMG. If this character has Night Vigil attached, this Skill costs 1 less Unaligned Element.",
                'skill': "Hunter's Vigil \n2 Electro \nAttach Night Vigil to self, then remove all of your Bond of Life. Based on the number of stacks removed, deal Electro DMG and heal yourself. (DMG and healing are capped at 4 points)",
                'burst': "Last Lightfall \n3 Electro, 2 Energy \nDeals 3 Electro DMG, and attaches 4 stacks of Bond of Life to self.",
                'hi_res_image': '/cards/gcg_1412_hd.webp',
                'card': '/cards/gcg_1412.webp',
                'card_selected': '/cards/gcg_1412_golden.webp',
                'icon': Clorinde_Icon,
                'element': 'electro',
                'region': 'fontaine',
                'related': "Night Vigil, Bond of Life",
                'flavor': "Vanquisher of Phantoms, Vigil of the Long Night",
                'id': 'CD',
                'keyword': 'sword',
            },

            'sethos': {
                'name': "Sethos",
                'na': "Royal Reed Archery \n2 Black, 1 Electro \nDeals 2 Physical DMG.",
                'skill': "Ancient Rite: The Thundering Sands \n2 Electro \nThe opposing active character gains Electro Application, and you switch to your next character. Attach Thunder Convergence to self.",
                'burst': "Secret Rite: Twilight Shadowpiercer \n3 Electro, 4 Energy \nDeals 3 Electro DMG. Attaches Twilight Meditation to self.",
                'special': "Black Kite's Enigma \n(Passive) \nCharacter's own Normal Attacks will not generate Energy. \n\nAfter performing a Normal Attack: If possible, consume all Energy and deal Piercing DMG equal to the amount consumed +1 to the enemy with the lowest HP.",
                'hi_res_image': '/cards/gcg_1413_hd.webp',
                'card': '/cards/gcg_1413.webp',
                'card_selected': '/cards/gcg_1413_golden.webp',
                'icon': Sethos_Icon,
                'element': 'electro',
                'region': 'sumeru',
                'related': "Thunder Convergence, Twilight Meditation",
                'flavor': "A visitor from the sea of sand, profound in providence.",
                'id': 'D1',
                'keyword': 'bow',
            },

            'iansan': {
                'name': "Iansan",
                'na': "Weighted Spike \n2 Black, 1 Electro \nDeals 2 Physical DMG.",
                'skill': "Thunderbolt Rush \n3 Electro \nDeals 2 Electro DMG, enters Nightsoul's Blessing, gains 1 Nightsoul point, and creates 1 stack of Agile Switch.",
                'burst': "The Three Principles of Power \n3 Electro, 2 Energy \nDeals 2 Electro DMG, enters Nightsoul's Blessing, gains 1 Nightsoul point, and creates Kinetic Energy Scale.",
                'special': "Caloric Balancing Plan \n(Passive) \nWhile this character is in Nightsoul's Blessing, after your character performs Prepare Skill or switches 2 times, if their Nightsoul points are 2, then heal the most damaged character on your side for 1 HP. Otherwise, gain 1 Nightsoul point. (3 times per Round)",
                'hi_res_image': '/cards/gcg_1414_hd.webp',
                'card': '/cards/gcg_1414.webp',
                'card_selected': '/cards/gcg_1414_golden.webp',
                'icon': Iansan_Icon,
                'element': 'electro',
                'region': 'natlan',
                'related': "Nightsoul's Blessing, Agile Switch, Kinetic Energy Scale",
                'flavor': "Early to bed, early to rise. Avoid anything high in sugar or sodium.",
                'id': 'E2',
                'keyword': 'polearm',
            },

            'varesa': {
                'name': "Varesa",
                'na': "By the Horns \n2 Black, 1 Electro \nDeals 1 Electro DMG. When the Skill used this time is Plunging Attack: Deal +1 DMG. This character enters Nightsoul's Blessing, and gains 1 Nightsoul point.",
                'skill': "Riding the Night-Rainbow \n3 Electro \nDeals 2 Electro DMG, applies Sudden Onrush to self, enters Nightsoul's Blessing, gains 1 Nightsoul point, then switches to the next character.",
                'burst': "Guardian Vent! \n3 Electro, 3 Energy \nDeals 3 Electro DMG, applies Apex Drive to self.",
                'special': "Guardian Vent: Volcano Kablam \nDeals 3 Electro DMG. This Skill is considered a Plunging Attack. \n",
                'special2': "Tag-Team Triple Jump! \n(Passive) \nAfter Varesa uses a Skill: If she has 2 Nightsoul points, she consumes 2 Nightsoul points and applies Apex Drive to herself.",
                'hi_res_image': '/cards/gcg_1415_hd.webp',
                'card': '/cards/gcg_1415.webp',
                'card_selected': '/cards/gcg_1415_golden.webp',
                'icon': Varesa_Icon,
                'element': 'electro',
                'region': 'natlan',
                'related': "Nightsoul's Blessing, Sudden Onrush, Apex Drive",
                'flavor': "Steadfast in defense, unshakeable in offense.",
                'id': 'EH',
                'keyword': 'catalyst',
            },

            'ororon': {
                'name': "Ororon",
                'na': "Spiritvessel Snapshot \n2 Black, 1 Electro \nDeals 2 Physical DMG.",
                'skill': "Night's Sling \n3 Electro \nDeals 2 Electro DMG and creates a Spirit Orb.",
                'burst': "Dark Voices Echo \n3 Electro, 2 Energy \nDeals 2 Electro DMG and summons Supersonic Oculus.",
                'special': "Nightshade Synesthesia \n(Passive) \nAfter you trigger Electro-Charged or Lunar-Charged: If possible, consume 2 Nightsoul points to deal 1 Electro DMG. \n\nAfter you deal Hydro DMG or Electro DMG from a source other than this skill, enter Nightsoul's Blessing and gain 1 Nightsoul point. (Once per Round)",
                'hi_res_image': '/cards/gcg_1416_hd.webp',
                'card': '/cards/gcg_1416.webp',
                'card_selected': '/cards/gcg_1416_golden.webp',
                'icon': Ororon_Icon,
                'element': 'electro',
                'region': 'natlan',
                'related': "Spirit Orb, Supersonic Oculus, Nightsoul's Blessing",
                'flavor': "Enigmatic Shadowwalker",
                'id': 'F5',
                'keyword': 'bow',
            },

            'ineffa': {
                'name': "Ineffa",
                'na': "Cyclonic Duster \n2 Black, 1 Electro \nDeals 2 Physical DMG.",
                'skill': "Cleaning Mode: Carrier Frequency \n3 Electro \nGenerates 2 Shield points, summons Birgitta.",
                'burst': "Supreme Instruction: Cyclonic Exterminator \n3 Electro, 2 Energy \nDeals 4 Electro DMG and summons Birgitta.",
                'special': "Moonsign Benediction: Assemblage Hub \n(Passive) \nDuring this game, when your opponent is affected by Electro-Charged reaction(s), it will be converted into the Lunar-Charged reaction. \n\nWhen this character's on the field, and the opponent's Action Card is attached with Electric Shock: Also attach the Untunable state.",
                'hi_res_image': '/cards/gcg_1417_hd.webp',
                'card': '/cards/gcg_1417.webp',
                'card_selected': '/cards/gcg_1417_golden.webp',
                'icon': Ineffa_Icon,
                'element': 'electro',
                'region': 'nodkrai',
                'related': "Shield, Birgitta",
                'flavor': "White iron forged the body, crimson heart cast the soul.",
                'id': 'FG',
                'keyword': 'polearm',
            },

            'flins': {
                'name': "Flins",
                'na': "Pocztowy Demonspear \n2 Black, 1 Electro \nDeals 2 Physical DMG.",
                'skill': "Ancient Rite: Arcane Light \n2 Electro \nThe first time this Skill is used each Round, deal 1 Electro DMG and attach Manifest Flame to this character. When this Skill is used again, consume 2 Energy and this character prepares: Thunderous Symphony.",
                'burst': "Ancient Ritual: Cometh the Night \n4 Electro, 4 Energy \nDeals 6 Electro DMG, deals 2 Piercing DMG to all opposing characters on standby.",
                'special': "Thunderous Symphony \nDeal 2 Electro DMG. If there is Thundercloud on your side, deal +2 DMG. \n",
                'special2': "Moonsign Benediction: Old World Secrets \n(Passive) \nDuring this game, when your opponent is affected by   Electro-Charged reaction(s), the reaction will be converted to the Lunar-Charged reaction. \n\nWhen this character is on the field, and Electric Shock is attached to the opponent's Action Card: Deal 1 Piercing DMG to the opposing character with the highest HP.",
                'hi_res_image': '/cards/gcg_1418_hd.webp',
                'card': '/cards/gcg_1418.webp',
                'card_selected': '/cards/gcg_1418_golden.webp',
                'icon': Flins_Icon,
                'element': 'electro',
                'region': 'nodkrai',
                'related': "Manifest Flame, Thundercloud",
                'flavor': "The graven light leads into fathomless night.",
                'id': 'G8',
                'keyword': 'polearm',
            },
    
            "sucrose": {
                "name": "Sucrose",
                'na': 'Wind Spirit Creation \n2 Black, 1 Anemo \nDeals 1 Anemo DMG.',
                'skill': 'Astable Anemohypostasis Creation – 6308 \n3 Anemo \nDeals 3 Anemo DMG, the target is forcibly switched to the previous character.',
                'burst': "Forbidden Creation – Isomer 75 / Type II \n3 Anemo, 2 Energy \nDeals 1 Anemo DMG, summons 1 'Large Wind Spirit.'",
                'hi_res_image': '/cards/i_n330014_gcg_high_resolution.webp',
                "card": '/cards/i_n330014.webp',
                "card_selected": '/cards/i_n334014.webp',
                "icon": Sucrose_Icon,
                "element": 'anemo',
                "region": 'mondstadt',
                'related': 'Large Wind Spirit',
                "flavor": "“You can’t rate the strength of an as-yet untested deck!”",
                "id": '0K',
                "keyword": "catalyst"        
            },
    
            "jean": {
                "name": "Jean",
                'na': 'Favonius Bladework \n2 Black, 1 Anemo \nDeals 2 Physical DMG.',
                'skill': 'Gale Blade \n3 Anemo \nDeals 3 Anemo DMG, the target is forcibly switched to the next character.',
                'burst': "Dandelion Breeze \n4 Anemo, 2 Energy \nHeals all your characters for 2 HP, summons 1 Dandelion Field.",
                'hi_res_image': '/cards/i_n330015_gcg_high_resolution.webp',
                "card": '/cards/i_n330015.webp',
                "card_selected": '/cards/i_n334015.webp',
                "icon": Jean_Icon,
                "element": 'anemo',
                "region": 'mondstadt',
                'related': 'Dandelion Field',
                "flavor": "Never believes that she has done well enough — not until final victory is hers, anyway.",
                "id": '0L',
                "keyword": "sword"        
            },
    
            "venti": {
                'name': "Venti",
                'na': "Divine Marksmanship \n2 Black, 1 Anemo \nDeals 2 Physical DMG.",
                'skill': "Skyward Sonnet \n3 Anemo \nDeals 2 Anemo DMG, creates 1 Stormzone.",
                'burst': "Wind's Grand Ode \n3 Anemo, 2 Energy \nDeals 2 Anemo DMG, summons 1 Stormeye.",
                'hi_res_image': '/cards/i_n330038_gcg_high_resolution.webp',
                'card': '/cards/i_n330038.webp',
                'card_selected': '/cards/i_n334040.webp',
                'icon': Venti_Icon,
                'element': 'anemo',
                'region': 'mondstadt',
                'related': 'Stormzone, Stormeye',
                'flavor': '"As the four seasons in turn shall say their piece, so the four winds too shall never cease. \n"Of course, to look at it differently, I am the one who should be credited here, and not they."\nCredits should be given where credits belong — if not for the bard who pens the song, then who shall ensure that these tales are passed on!?"',
                'id': '4R',
                "keyword": "bow"
            },
    
            "xiao": {
                'name': "Xiao",
                'na': "Whirlwind Thrust \n2 Black, 1 Anemo \nDeals 2 Physical DMG.",
                'skill': "Lemniscatic Wind Cycling \n3 Anemo \nDeals 3 Anemo DMG.",
                'burst': "Bane of All Evil \n3 Anemo, 2 Energy \nDeals 4 Anemo DMG. This character gains Yaksha's Mask.",
                'hi_res_image': '/cards/i_n330039_gcg_high_resolution.webp',
                'card': '/cards/i_n330039.webp',
                'card_selected': '/cards/i_n334041.webp',
                'icon': Xiao_Icon,
                'element': 'anemo',
                'region': 'liyue',
                'related': "Yaksha's Mask",
                'flavor': 'The Vigilant Yaksha, the bane of all evil',
                'id': '4S',
                "keyword": "polearm"
            },

            "kazuha": {
                'name': "Kaedehara Kazuha",
                'na': "Garyuu Bladework \n2 Black, 1 Anemo \nDeals 2 Physical DMG.",
                'skill': "Chihayaburu \n3 Anemo \nDeals 1 Anemo DMG, attaches Midare Ranzan to this character.  \n\nIf this skill triggers Swirl, Midare Ranzan is converted to the Swirled Element. \n\nAfter the Skill DMG is finalized: Your team switches to the next character.",
                'burst': "Kazuha Slash \n3 Anemo, 2 Energy \nDeals 1 Anemo DMG and summons Autumn Whirlwind.",
                'hi_res_image': '/cards/i_n330051_gcg_high_resolution.webp',
                'card': '/cards/i_n330051.webp',
                'card_selected': '/cards/i_n334051.webp',
                'icon': Kazuha_Icon,
                'element': 'anemo',
                'region': 'inazuma',
                'related': "Midare Ranzan, Autumn Whirlwind",
                'flavor': 'Flowers and birds are a dear pleasure to one winding under the moonlight.',
                'id': '6I',
                "keyword": "sword"
            },

            "wanderer": {
                'name': "Wanderer",
                'na': "Yuuban Meigen \n2 Black, 1 Anemo \nDeals 1 Anemo DMG.",
                'skill': "Hanega: Song of the Wind\n3 Anemo \nDeals 2 Anemo DMG. This character gains Windfavored.",
                'burst': "Kyougen: Five Ceremonial Plays\n3 Anemo, 3 Energy \nDeals 7 Anemo DMG. If the character has Windfavored attached, then remove it and increase DMG by 1.",
                'hi_res_image': '/cards/i_n330054_gcg_high_resolution.webp',
                'card': '/cards/i_n330054.webp',
                'card_selected': '/cards/i_n334055.webp',
                'icon': Wanderer_Icon,
                'element': 'anemo',
                'region': 'sumeru',
                'related': "Windfavored",
                'flavor': 'Tribulations Uncounted, Trials Unknowable.',
                'id': '72',
                "keyword": "catalyst"
            },

            'lynette': {
                'name': 'Lynette',
                'na': "Rapid Ritesword \n2 Black, 1 Anemo \nDeals 2 Physical DMG.",
                'skill': "Enigmatic Feint \n3 Anemo \nDeals 3 Anemo DMG. The first time this Skill is used this Round, heal the character for 2 HP if they have no more than 8 HP, but apply Overawing Assault to said character.",
                'burst': "Magic Trick: Astonishing Shift \n3 Anemo, 2 Energy\nDeals 2 Anemo DMG, summons 1 Bogglecat Box.",
                'hi_res_image': '/cards/i_n330065_gcg_high_resolution.webp',
                'card': '/cards/i_n330065.webp',
                'card_selected': '/cards/i_n334065.webp',
                'icon': Lynette_Icon,
                'element': 'anemo',
                'region': 'fatui',
                'related': 'Overawing Assault, Bogglecat Box',
                'flavor': "The firmament glimpsed in a reflected moon.",
                'id': '7S',
                'keyword': 'sword',
            },

            'sayu': {
                'name': 'Sayu',
                'na': "Shuumatsuban Ninja Blade \n2 Black, 1 Anemo \nDeals 2 Physical DMG.",
                'skill': "Yoohoo Art: Fuuin Dash \n3 Anemo \nDeals 1 Anemo DMG, and this character begins to Prepare Skill: Fuufuu Whirlwind Kick. \n\nIf this usage of the skill triggers Swirl, then Fuufuu Whirlwind Kick is converted to DMG of the Swirled Element.",
                'burst': "Yoohoo Art: Mujina Flurry\n3 Anemo, 2 Energy\nDeals 1 Anemo DMG, summons 1 Muji-Muji Daruma.",
                'special': "Fuufuu Whirlwind Kick \n(Prepare for 1 turn) \nDeals 2 Anemo DMG (or the Swirled Element's DMG)",
                'hi_res_image': '/cards/i_n330072_gcg_high_resolution.webp',
                'card': '/cards/i_n330072.webp',
                'card_selected': '/cards/i_n334072.webp',
                'icon': Sayu_Icon,
                'element': 'anemo',
                'region': 'inazuma',
                'related': 'Muji-Muji Daruma',
                'flavor': "By your side without a trace, like a character from a dream.",
                'id': '8W',
                'keyword': 'claymore',
            },

            'faruzan': {
                'name': 'Faruzan',
                'na': "Parthian Shot \n2 Black, 1 Anemo \nDeals 2 Physical DMG.",
                'skill': "Wind Realm of Nasamjnin\n3 Anemo \nDeals 3 Anemo DMG. This character gains Manifest Gale.",
                'burst': "The Wind's Secret Ways\n3 Anemo, 2 Energy\nDeals 1 Anemo DMG, summons 1 Dazzling Polyhedron.",
                'special': "Fuufuu Whirlwind Kick\n(Prepare for 1 turn)\nDeals 2 Anemo DMG.",
                'hi_res_image': '/cards/i_n330080_gcg_high_resolution.webp',
                'card': '/cards/i_n330080.webp',
                'card_selected': '/cards/i_n334080.webp',
                'icon': 'https://act-webstatic.hoyoverse.com/hk4e/e20200928calculate/item_char_icon_u63dbg/66c94f71e6b0786fe749483fe5d8584a.png',
                'element': 'anemo',
                'region': 'sumeru',
                'related': 'Manifest Gale, Dazzling Polyhedron',
                'flavor': "Simple machines, mysterious world",
                'id': '9P',
                'keyword': 'bow',
            },

            'xianyun': {
                'name': "Xianyun",
                'na': "Word of Wind and Flower \n2 Black, 1 Anemo \nDeals 1 Anemo DMG.",
                'skill': "White Clouds at Dawn \n3 Anemo \nDeals 1 Anemo DMG. Creates Skyladder. This character gains Driftcloud Wave.",
                'burst': "Stars Gather at Dusk \n3 Anemo, 2 Energy \nDeals 1 Anemo DMG. Heals all allied characters for 1 HP. Creates 1 Starwicker in your Hand. \n\n(Characters with Starwicker equipped can use the Technique: Adeptal Assistance)",
                'hi_res_image': '/cards/gcg_1510_hd.webp',
                'card': '/cards/gcg_1510.webp',
                'card_selected': '/cards/gcg_1510_golden.webp',
                'icon': Xianyun_Icon,
                'element': 'anemo',
                'region': 'liyue',
                'related': "Skyladder, Driftcloud Wave, Starwicker",
                'flavor': "Chivalrous shadow, shrouded in cloud.",
                'id': 'BC',
                'keyword': 'catalyst',
            },

            'chasca': {
                'name': "Chasca",
                'na': "Phantom Feather Flurry \n2 Black, 1 Anemo \nDeals 2 Physical DMG.",
                'skill': "Spirit Reins, Shadow Hunt \n3 Anemo \nDeal 1 Anemo DMG and draw 1 card. \n\nAttach Soulsniper: Ritual Staff to this character, who then enters Nightsoul's Blessing and gains 2 Nightsoul points. (This skill cannot be used after the character enters Nightsoul's Blessing) (Characters with Soulsniper: Ritual Staff attached can use the Technique: Multitarget Fire) \n\nThe next 2 times you switch Characters: Draw 1 card.",
                'burst': "Soul Reaper's Fatal Round \n3 Anemo, 2 Energy \nDeals 1 Anemo DMG, deals 1 Piercing DMG to all opposing characters on standby. Draw 3 cards.",
                'special': "Shadowhunt Shell \n(Passive) \nAt the start of each match, add 6 random Shadowhunt Shell to your Deck.",
                'hi_res_image': '/cards/gcg_1511_hd.webp',
                'card': '/cards/gcg_1511.webp',
                'card_selected': '/cards/gcg_1511_golden.webp',
                'icon': Chasca_Icon,
                'element': 'anemo',
                'region': 'natlan',
                'related': "Soulsniper: Ritual Staff, Nightsoul's Blessing, Shadowhunt Shell",
                'flavor': "Grace and power resound, feathered wings skybound.",
                'id': 'DB',
                'keyword': 'bow',
            },

            'lanyan': {
                'name': "Lan Yan",
                'na': "Black Pheasant Strides on Water \n2 Black, 1 Anemo \nDeals 1 Anemo DMG.",
                'skill': "Swallow-Wisp Pinion Dance \n3 Anemo \nCreate 2 stacks of Swallow-Wisp Shield, gain 1 stack of Efficient Switch, and deal 1 Anemo DMG. If this skill triggers Swirl, create 1 additional stack of Swallow-Wisp Shield.",
                'burst': "Lustrous Moonrise \n3 Anemo, 2 Energy \nDeals 3 Anemo DMG, creates 2 stacks of Swallow-Wisp Shield.",
                'hi_res_image': '/cards/gcg_1512_hd.webp',
                'card': '/cards/gcg_1512.webp',
                'card_selected': '/cards/gcg_1512_golden.webp',
                'icon': LanYan_Icon,
                'element': 'anemo',
                'region': 'liyue',
                'related': "Swallow-Wisp Shield, Efficient Switch",
                'flavor': "The brilliant swallow bears branches of joy to fill the home.",
                'id': 'DO',
                'keyword': 'catalyst',
            },

            'shikanoinheizou': {
                'name': "Shikanoin Heizou",
                'na': "Fudou Style Martial Arts \n2 Black, 1 Anemo \nDeals 1 Anemo DMG.",
                'skill': "Heartstopper Strike \n3 Anemo \nPrepare Skill: Heartstopper Strike: Charge",
                'burst': "Windmuster Kick \n3 Anemo, 2 Energy \nDeals 4 Anemo DMG. If this Skill triggers Anemo-Related Reactions, attach a Windmuster Iris of the corresponding element to the opponent's active character.",
                'special': "Heartstopper Strike: Charge \nDeals 4 Anemo DMG. \n",
                'special2': "Paradoxical Practice \n(Passive) \nAfter you trigger Anemo-Related Reactions: Attach 1 stack of Declension to self.",
                'hi_res_image': '/cards/gcg_1513_hd.webp',
                'card': '/cards/gcg_1513.webp',
                'card_selected': '/cards/gcg_1513_golden.webp',
                'icon': ShikanoinHeizou_Icon,
                'element': 'anemo',
                'region': 'inazuma',
                'related': "Declension",
                'flavor': "The heavenly robes, though seamlessly sewn, still fear the winds that with coldness are blown.",
                'id': 'DP',
                'keyword': 'catalyst',
            },

            'yumemizukimizuki': {
                'name': "Yumemizuki Mizuki",
                'na': "Pure Heart, Pure Dreams \n2 Black, 1 Anemo \nDeals 1 Anemo DMG.",
                'skill': "Aisa Utamakura Pilgrimage \n3 Anemo \nDeals 2 Anemo DMG. Attaches Dreamdrifter to self.",
                'burst': "Anraku Secret Spring Therapy \n3 Anemo, 2 Energy \nDeals 3 Anemo DMG, creates 1 Yumemi Style Special Snacks and places it on top of your deck, and summons Mini Baku.",
                'hi_res_image': '/cards/gcg_1514_hd.webp',
                'card': '/cards/gcg_1514.webp',
                'card_selected': '/cards/gcg_1514_golden.webp',
                'icon': YumemizukiMizuki_Icon,
                'element': 'anemo',
                'region': 'inazuma',
                'related': "Dreamdrifter, Yumemi Style Special Snacks, Mini Baku",
                'flavor': "Clouds of doubt depart, moonlight amidst dreams unveiled, to grace dreamers' hearts.",
                'id': 'E3',
                'keyword': 'catalyst',
            },

            'ifa': {
                'name': "Ifa",
                'na': "Rite of Dispelling Winds \n2 Black, 1 Anemo \nDeals 1 Anemo DMG.",
                'skill': "Airborne Disease Prevention \n3 Anemo \nDeals 2 Anemo DMG, enters Nightsoul's Blessing, gains 2 Nightsoul points, and applies Cacucu to self. (This skill cannot be used after the character enters Nightsoul's Blessing.) \n\n(Characters with Cacucu attached can use the Technique: Supporting Fire)",
                'burst': "Compound Sedation Field \n3 Anemo, 2 Energy \nDeals 2 Anemo DMG, heals the character on your team who has taken the most DMG for 2 HP. If this Skill triggers Anemo-Related Reactions, attach a Sedation Mark of the corresponding element to the opponent's active character.",
                'hi_res_image': '/cards/gcg_1515_hd.webp',
                'card': '/cards/gcg_1515.webp',
                'card_selected': '/cards/gcg_1515_golden.webp',
                'icon': Ifa_Icon,
                'element': 'anemo',
                'region': 'natlan',
                'related': "Nightsoul's Blessing, Cacucu",
                'flavor': "Rescue rapid as a raid.",
                'id': 'EI',
                'keyword': 'catalyst',
            },

            'jahoda': {
                'name': "Jahoda",
                'na': "Strike While the Arrow's Hot \n2 Black, 1 Anemo \nDeals 2 Physical DMG.",
                'skill': "Savvy Strategy: Splitting the Spoils \n3 Anemo \nDeals 2 Anemo DMG, creates 1 stack of Agile Switch, and switch to your next character. If you do not have Purr-loined Treasure Flask of any element in your Hand, create 1 Purr-loined Treasure Flask in your Hand. Otherwise, grant Cost Reduction to all Purr-loined Treasure Flask in your Hand.",
                'burst': "Hidden Aces: Seven Tools of the Hunter \n3 Anemo, 2 Energy \nDeals 3 Anemo DMG and creates Purrsonal Coordinated Assistance Robots.",
                'special': "Moonsign Benediction: Rooftop Dash \n(Passive) \nWhen battle begins, create 1 Purr-loined Treasure Flask in your Hand. \n\nAfter you trigger a Lunar Reaction or Swirl Reaction, attach Cost Reduction to all Purr-loined Treasure Flask in your Hand. (Twice per Round)",
                'hi_res_image': '/cards/gcg_1516_hd.webp',
                'card': '/cards/gcg_1516.webp',
                'card_selected': '/cards/gcg_1516_golden.webp',
                'icon': Jahoda_Icon,
                'element': 'anemo',
                'region': 'nodkrai',
                'related': "Agile Switch, Purr-loined Treasure Flask, Purrsonal Coordinated Assistance Robots",
                'flavor': "Persistent thought brings light to even the deepest secrets.",
                'id': 'GX',
                'keyword': 'bow',
            },

            "ningguang": {
                "name": "Ningguang",
                'na': 'Sparkling Scatter \n2 Black, 1 Geo \nDeals 1 Geo DMG.',
                'skill': "Jade Screen \n3 Geo \nDeals 2 Geo DMG, creates 1 'Jade Screen'.",
                'burst': "Starshatter \n3 Geo, 3 Energy \nDeals 6 Geo DMG. If 'Jade Screen' is on the field, deals +2 DMG.",
                'hi_res_image': '/cards/i_n330016_gcg_high_resolution.webp',
                "card": '/cards/i_n330016.webp',
                "card_selected": '/cards/i_n334016.webp',
                "icon": Ningguang_Icon,
                "element": 'geo',
                "region": 'liyue',
                'related': 'Jade Screen',
                "flavor": "The greatest secret she keeps is that she keeps a great many of Liyue’s secrets.",
                "id": '0O',
                "keyword": "catalyst"        
            },
    
            "noelle": {
                "name": "Noelle",
                'na': 'Favonius Bladework – Maid \n2 Black, 1 Geo \nDeals 2 Physical DMG.',
                'skill': "Breastplate \n3 Geo \nDeals 1 Geo DMG, creates 1 'Full Plate'.",
                'burst': "Sweeping Time \n4 Geo, 2 Energy \nDeals 4 Geo DMG. This character gains 'Sweeping Time'.",
                'hi_res_image': '/cards/i_n330017_gcg_high_resolution.webp',
                "card": '/cards/i_n330017.webp',
                "card_selected": '/cards/i_n334017.webp',
                "icon": Noelle_Icon,
                "element": 'geo',
                "region": 'mondstadt',
                'related': 'Full Plate, Sweeping Time',
                "flavor": "You can leave arranging the table to her — really, you can.",
                "id": '0N',
                "keyword": "claymore"        
            },

            "zhongli": {
                'name': "Zhongli",
                'na': "Rain of Stone \n2 Black, 1 Geo \nDeals 2 Physical DMG.",
                'skill': "Dominus Lapidis \n3 Geo \nDeals 1 Geo DMG, summons 1 Stone Stele.",
                'special': "Dominus Lapidis: Striking Stone \n5 Geo \nDeals 3 Geo DMG, summons 1 Stone Stele, creates 1 Jade Shield.",       
                'burst': "Planet Befall \n3 Geo, 3 Energy \nDeals 4 Geo DMG. The target character receives Petrification.",
                'hi_res_image': '/cards/i_n330040_gcg_high_resolution.webp',
                'card': '/cards/i_n330040.webp',
                'card_selected': '/cards/i_n334042.webp',
                'icon': Zhongli_Icon,
                'element': 'geo',
                'region': 'liyue',
                'related': 'Stone Stele, Jade Shield, Petrification',
                'flavor': 'A hidden gemstone can illuminate the whole earth, bright and unrivaled as a star.',
                'id': '4T',
                "keyword": "polearm"
            },

            "albedo": {
                "name": "Albedo",
                'na': 'Favonius Bladework - Weiss \n2 Black, 1 Geo \n Deals 2 Physical DMG.',
                'skill': "Abiogenesis: Solar Isotoma \n3 Geo \nSummons Solar Isotoma.",
                'burst': "Rite of Progeniture: Tectonic Tide\n3 Geo, 2 Energy \nDeals 4 Geo DMG. If Solar Isotoma is on the field, deals +2 DMG.",
                'hi_res_image': '/cards/i_n330041_gcg_high_resolution.webp',
                "card": '/cards/i_n330041.webp',
                "card_selected": '/cards/i_n334043.webp',
                "icon": Albedo_Icon,
                "element": 'geo',
                "region": 'mond',
                'related': "Solar Isotoma",
                'flavor': "Nigredo and calx, rubedo and citrinitas.",
                "id": '6R',
                "keyword": "sword"
            },
    
            "itto": {
                "name": "Arataki Itto",
                'na': 'Fight Club Legend \n2 Black, 1 Geo \n Deals 2 Physical DMG.',
                'skill': "Masatsu Zetsugi: Akaushi Burst! \n3 Geo \nDeals 1 Geo DMG. Summons 'Ushi'. This character gains 'Superlative Superstrength'.",
                'burst': "Royal Descent: Behold, Itto the Evil! \n3 Geo, 3 Energy \nDeals 4 Geo DMG. This character gains Raging Oni King.",
                'hi_res_image': '/cards/i_n330042_gcg_high_resolution.webp',
                "card": '/cards/i_n330042.webp',
                "card_selected": '/cards/i_n334034.webp',
                "icon": Itto_Icon,
                "element": 'geo',
                "region": 'inazuma',
                'related': "Ushi, Superlative Superstrength, Raging Oni King",
                'flavor': "Arataki \"The Ultimate TCG Champion\" Itto",
                "id": '4G',
                "keyword": "claymore"
            },

            'gorou': {
                'name': 'Gorou',
                'na': "Ripping Fang Fletching \n2 Black, 1 Geo \nDeals 2 Physical DMG.",
                'skill': "Inuzaka All-Round Defense \n3 Geo \nDeals 2 Geo DMG, creates 1 General's War Banner.",
                'burst': "Juuga: Forward Unto Victory \n3 Geo, 2 Energy\nDeals 2 Geo DMG, creates 1 General's War Banner, summons General's Glory.",
                'hi_res_image': '/cards/i_n330066_gcg_high_resolution.webp',
                'card': '/cards/i_n330066.webp',
                'card_selected': '/cards/i_n334066.webp',
                'icon': Gorou_Icon,
                'element': 'geo',
                'region': 'inazuma',
                'related': "General's War Banner, General's Glory",
                'flavor': "The leader of the pack, leading the soldiers onward!",
                'id': '7T',
                'keyword': 'bow',
            },

            'yunjin': {
                'name': 'Yun Jin',
                'na': "Cloud-Grazing Strike \n2 Black, 1 Geo \nDeals 2 Physical DMG.",
                'skill': "Opening Flourish \n3 Geo \nCreates 1 Flying Cloud Flag Formation, attaches Shield of Swirling Clouds to this character and Prepare Skill: Spear Flourish.",
                'burst': "Cliffbreaker's Banner \n3 Geo, 2 Energy \nDeals 3 Geo DMG, creates 3 stacks of Flying Cloud Flag Formation.",
                'special': "Spear Flourish \n(Prepare for 1 turn) \nDeals 2 Geo DMG. If you have Discarded or used at least 1 card for Tune this Round, this deals +1 DMG.",
                'hi_res_image': '/cards/i_n330086_gcg_high_resolution.webp',
                'card': '/cards/i_n330086.webp',
                'card_selected': '/cards/i_n334086.webp',
                'icon': 'https://act-webstatic.hoyoverse.com/hk4e/e20200928calculate/item_char_icon_u63dbg/d922820faae7a81272e68eb72e9e2fb8.png',
                'element': 'geo',
                'region': 'liyue',
                'related': "Flying Cloud Flag Formation, Shield of Swirling Clouds",
                'flavor': "Elegance on the stage, in decorous harmony.",
                'id': '9V',
                'keyword': 'polearm',
            },

            'navia': {
                'name': "Navia",
                'na': "Blunt Refusal \n2 Black, 1 Geo \nDeals 2 Physical DMG.",
                'skill': "Ceremonial Crystalshot \n3 Geo \nDeals 3 Geo DMG, attaches Geo Infusion to this character. Discard up to 5 Crystal Shrapnel from your Hand. Each card you Discard causes this to deal +1 DMG, and you draw 1 card.",
                'burst': "As the Sunlit Sky's Singing Salute \n3 Geo, 2 Energy \nDeals 1 Geo DMG, deals 1 Piercing DMG to all opposing characters on standby. Summons 1 Rosula Dorata Salute and creates 1 Crystal Shrapnel card before adding it to your Hand.",
                'special': "Mutual Assistance Network \n(Passive) \nAfter an opponent's character takes Crystallize reaction DMG: Create 3 Crystal Shrapnel and randomly place them into your deck.",
                'hi_res_image': '/cards/gcg_1608_hd.webp',
                'card': '/cards/gcg_1608.webp',
                'card_selected': '/cards/gcg_1608_golden.webp',
                'icon': Navia_Icon,
                'element': 'geo',
                'region': 'fontaine',
                'related': "Geo Infusion, Crystal Shrapnel, Rosula Dorata Salute",
                'flavor': "\"The Soaring Yellow Rose.\"",
                'id': 'B0',
                'keyword': 'claymore',
            },

            'chiori': {
                'name': "Chiori",
                'na': "Weaving Blade \n2 Black, 1 Geo \nDeals 2 Physical DMG.",
                'skill': "Fluttering Hasode \n3 Geo \nSelect 1 Summon from 3 Chiori's Automaton Dolls.",
                'burst': "Hiyoku: Twin Blades \n3 Geo, 2 Energy \nDeals 5 Geo DMG.",
                'hi_res_image': '/cards/gcg_1609_hd.webp',
                'card': '/cards/gcg_1609.webp',
                'card_selected': '/cards/gcg_1609_golden.webp',
                'icon': Chiori_Icon,
                'element': 'geo',
                'region': 'inazuma',
                'related': "Chiori's Automaton Dolls",
                'flavor': "Couturiere of Countless Colors",
                'id': 'BO',
                'keyword': 'sword',
            },

            'kachina': {
                'name': "Kachina",
                'na': "Cragbiter \n2 Black, 1 Geo \nDeals 2 Physical DMG.",
                'skill': "Go, Go Turbo Twirly! \n2 Geo \nAttach Turbo Twirly to self, then enter Nightsoul's Blessing and gain 2 \"Nightsoul points.\" (This skill cannot be used after the character enters Nightsoul's Blessing) \n\n(Characters with Turbo Twirly attached can use the Technique: Twirly Twirly Bam Bam)",
                'burst': "Time to Get Serious! \n3 Geo, 3 Energy \nDeal 3 Geo DMG and create 1 Turbo Drill Field.",
                'hi_res_image': '/cards/gcg_1610_hd.webp',
                'card': '/cards/gcg_1610.webp',
                'card_selected': '/cards/gcg_1610_golden.webp',
                'icon': Kachina_Icon,
                'element': 'geo',
                'region': 'natlan',
                'related': "Turbo Twirly, Nightsoul's Blessing, Turbo Drill Field",
                'flavor': "Wrought of tears and mettle.",
                'id': 'CT',
                'keyword': 'polearm',
            },

            'xilonen': {
                'name': "Xilonen",
                'na': "Ehecatl's Roar \n2 Black, 1 Geo \nDeals 2 Physical DMG. If Nightsoul's Blessing is attached to self, then regain 1 Nightsoul point.",
                'skill': "Yohual's Scratch \n2 Geo \nAttach Combat Blading Gear to this character, then enter Nightsoul's Blessing and gain 1 Nightsoul point. (This skill cannot be used after the character enters Nightsoul's Blessing) \n\n(Characters with Combat Blading Gear attached can use the Technique: High-Speed Leap)",
                'burst': "Ocelotlicue Point! \n3 Geo, 2 Energy \nDeals 2 Geo DMG. Draw 1 card and heal the most damaged character on your side for 1 HP. Draw 1 additional card for each stack of Source Sample: Geo, and heal 1 additional HP for each stack of Source Sample of another Element.",
                'special': "Source Sample \n(Passive) \nWhen the battle begins, create 3 stacks of Source Sample: Geo. When you have Pyro, Hydro, Cryo, or Electro characters on your side, then convert 1 stack of Source Sample: Geo to a Source Sample of the corresponding Element.",
                'hi_res_image': '/cards/gcg_1611_hd.webp',
                'card': '/cards/gcg_1611.webp',
                'card_selected': '/cards/gcg_1611_golden.webp',
                'icon': Xilonen_Icon,
                'element': 'geo',
                'region': 'natlan',
                'related': "Nightsoul's Blessing, Combat Blading Gear, Source Sample: Geo",
                'flavor': "The peaks resound, their golden veins gleaming.",
                'id': 'D2',
                'keyword': 'sword',
            },

            'illuga': {
                'name': "Illuga",
                'na': "Oathkeeper's Spear \n2 Black, 1 Geo \nDeals 2 Physical DMG.",
                'skill': "Dawnbearing Songbird \n3 Geo \nDeals 3 Geo DMG, creates 1 Aedon to your Hand.",
                'burst': "Shadowless Reflection \n3 Geo, 2 Energy \nDeals 3 Geo DMG and creates Nightingale's Song with 3 Usage(s).",
                'special': "Moonsign Benediction: Unwithering in Winter \n(Passive) \nWhen a card whose name was not in your initial deck is added to your Hand, apply Cost Reduction to it. (Once per Round)",
                'hi_res_image': '/cards/gcg_1612_hd.webp',
                'card': '/cards/gcg_1612.webp',
                'card_selected': '/cards/gcg_1612_golden.webp',
                'icon': Illuga_Icon,
                'element': 'geo',
                'region': 'nodkrai',
                'related': "Aedon, Nightingale's Song",
                'flavor': "Shining Through Nightmares, Herald of the Day.",
                'id': 'H9',
                'keyword': 'polearm',
            },
    
            "collei": {
                "name": "Collei",
                'na': 'Supplicant’s Bowmanship \n2 Black, 1 Dendro \nDeals 2 Physical DMG.',
                'skill': 'Floral Brush \n3 Dendro \nDeals 3 Dendro DMG.',
                'burst': "Trump-Card Kitty \n3 Dendro, 2 Energy \nDeals 2 Dendro DMG, summons 1 'Cuilein-Anbar.",
                'hi_res_image': '/cards/i_n330018_gcg_high_resolution.webp',
                "card": '/cards/i_n330018.webp',
                "card_selected": '/cards/i_n334018.webp',
                "icon": Collei_Icon,
                "element": 'dendro',
                "region": 'sumeru',
                'related': 'Cuilein-Anbar',
                "flavor": "“‘Shouting the name of your card loudly will increase its power many-fold”… You’ve got to be kidding, right?”",
                "id": '0Q',
                "keyword": "bow"        
            },
    
            "tighnari": {
                "name": "Tighnari",
                "na": "Khanda Barrier-Buster\n2 Black, 1 Dendro \nDeals 2 Physical DMG.",
                "skill": "Vijnana-Phala Mine \n3 Dendro \nDeals 2 Dendro DMG. This character gains 'Vijnana Suffusion'.",
                "burst": "Fashioner's Tanglevine Shaft \n 3 Dendro, 2 Energy \n Deals 4 Dendro DMG, deals 1 Piercing DMG to all opposing characters on standby.",
                'hi_res_image': '/cards/i_n330043_gcg_high_resolution.webp',
                "card": '/cards/i_n330043.webp',
                "card_selected": '/cards/i_n334035.webp',
                "icon": Tighnari_Icon,
                "element": 'dendro',
                "region": 'sumeru',
                'related': 'Vijnana Suffusion, Clusterbloom Arrow',
                "flavor": "From a certain perspective, experience does not hold parity with wisdom.",
                "id": '4H',
                "keyword": "bow"  
            },
    
            "nahida": {
                'name': "Nahida",
                'na': "Akara \n2 Black, 1 Dendro \nDeals 1 Dendro DMG.",
                'skill': "All Schemes to Know \n3 Dendro \nDeals 2 Dendro DMG, applies Seed of Skandha to target character. If the target character already has Seed of Skandha applied to them, then apply Seed of Skandha to all opposing characters instead.",
                'special': "All Schemes to Know: Tathata \n5 Dendro \nDeals 3 Dendro DMG. Applies Seed of Skandha to all opposing characters.",
                'burst': "Illusory Heart \n3 Dendro, 2 Energy \nDeals 4 Dendro DMG, creates 1 Shrine of Maya.",
                'hi_res_image': '/cards/i_n330044_gcg_high_resolution.webp',
                'card': '/cards/i_n330044.webp',
                'card_selected': '/cards/i_n334044.webp',
                'icon': Nahida_Icon,
                'element': 'dendro',
                'region': 'sumeru',
                'related': 'Seed of Skandha, Shrine of Maya',
                'flavor': 'The panacea brings purity, and from the palace depths is spring renewed.',
                'id': '4U',
                "keyword": "catalyst"
            },

            "yaoyao": {
                'name': "Yaoyao",
                'na': "Toss 'N' Turn Spear\n2 Black, 1 Dendro \nDeals 2 Physical DMG.",
                'skill': "Raphanus Sky Cluster \n3 Dendro \nSummons 1 Yuegui: Throwing Mode.",
                'burst': "Moonjade Descent \n4 Dendro, 2 Energy \nDeals 1 Dendro DMG, creates 1 Adeptal Legacy.",
                'hi_res_image': '/cards/i_n330056_gcg_high_resolution.webp',
                'card': '/cards/i_n330056.webp',
                'card_selected': '/cards/i_n334056.webp',
                'icon': Yaoyao_Icon,
                'element': 'dendro',
                'region': 'liyue',
                'related': 'Yuegui: Throwing Mode, Adeptal Legacy',
                'flavor': "An adeptal constitution.",
                'id': '74',
                "keyword": "polearm"
            },

            "baizhu": {
                'name': "Baizhu",
                'na': "The Classics of Acupuncture \n2 Black, 1 Dendro \nDeals 1 Dendro DMG.",
                'skill': "Universal Diagnosis \n3 Dendro \nDeals 1 Dendro DMG, summons 1 Gossamer Sprite.",
                'burst': "Holistic Revivification \n4 Dendro, 2 Energy \nCreates 1 Pulsing Clarity and Seamless Shield.",
                'hi_res_image': '/cards/i_n330059_gcg_high_resolution.webp',
                'card': '/cards/i_n330059.webp',
                'card_selected': '/cards/i_n334059.webp',
                'icon': Baizhu_Icon,
                'element': 'dendro',
                'region': 'liyue',
                'related': "Gossamer Sprite, Pulsing Clarity, Seamless Shield",
                'flavor': "Living with many maladies, where will one find a cure?",
                'id': '7G',
                "keyword": "catalyst"
            },

            'alhaitham': {
                'name': 'Alhaitham',
                'na': "Abductive Reasoning \n2 Black, 1 Dendro \nDeals 2 Physical DMG.",
                'skill': "Universality: An Elaboration on Form \n3 Dendro \nDeals 2 Dendro DMG. This character gains Chisel-Light Mirror.",
                'burst': "Particular Field: Fetters of Phenomena \n3 Dendro, 2 Energy\nDeals 4 Dendro DMG, consumes Chisel-Light Mirror, with the DMG bonus based on Chisel-Light Mirror's Duration (Rounds) consumed. \nIf Chisel-Light Mirror Duration (Rounds) consumed is 0/1/2, then apply Chisel-Light Mirror with 3/2/1 Duration (Rounds) to this character.",
                'hi_res_image': '/cards/i_n330067_gcg_high_resolution.webp',
                'card': '/cards/i_n330067.webp',
                'card_selected': '/cards/i_n334067.webp',
                'icon': Alhaitham_Icon,
                'element': 'dendro',
                'region': 'sumeru',
                'related': 'Chisel-Light Mirror',
                'flavor': "Learning, thinking, and taking care of business.",
                'id': '7U',
                'keyword': 'sword',
            },

            'kirara': {
                'name': 'Kirara',
                'na': "Boxcutter \n2 Black, 1 Dendro \nDeals 2 Physical DMG.",
                'skill': "Meow-teor Kick \n3 Dendro \nCreates 1 Urgent Neko Parcel and 2 stacks of Shield of Safe Transport.",
                'burst': "Secret Art: Surprise Dispatch \n3 Dendro, 2 Energy\nDeals 4 Dendro DMG, creates 1 Cat Grass Cardamom on the opponent's side of the field.",
                'hi_res_image': '/cards/i_n330077_gcg_high_resolution.webp',
                'card': '/cards/i_n330077.webp',
                'card_selected': '/cards/i_n334077.webp',
                'icon': 'https://act-webstatic.hoyoverse.com/hk4e/e20200928calculate/item_char_icon_u7ea0f/0d003592955031c4bea218648819935c.png',
                'element': 'dendro',
                'region': 'inazuma',
                'related': 'Urgent Neko Parcel, Shield of Safe Transport, Cat Grass Cardamom',
                'flavor': "On tails twain and padded feet, to all doors shall she deliver.",
                'id': '9C',
                'keyword': 'sword',
            },

            'kaveh': {
                'name': 'Kaveh',
                'na': "Schematic Setup \n2 Black, 1 Dendro \nDeals 2 Physical DMG.",
                'skill': "Artistic Ingenuity \n3 Dendro \nDeals 2 Dendro DMG, creates 1 Burst Scan.",
                'burst': "Painted Dome \n3 Dendro, 2 Energy\nDeals 3 Dendro DMG. This character gains Mehrak's Assistance, creating 2 stacks of Burst Scan.",
                'hi_res_image': '/cards/i_n330087_gcg_high_resolution.webp',
                'card': '/cards/i_n330087.webp',
                'card_selected': '/cards/i_n334087.webp',
                'icon': 'https://act-webstatic.hoyoverse.com/hk4e/e20200928calculate/item_char_icon_u63dbg/0e100880f8e84434ef1b534b59d69a58.png',
                'element': 'dendro',
                'region': 'sumeru',
                'related': "Burst Scan, Mehrak's Assistance",
                'flavor': "Knowledge of comprehension, benevolence, and aesthetics.",
                'id': '9W',
                'keyword': 'claymore',
            },

            'kinich': {
                'name': "Kinich",
                'na': "Nightsun Style \n2 Black, 1 Dendro \nDeals 2 Physical DMG.",
                'skill': "Canopy Hunter: Riding High \n3 Dendro \nSelect one of your characters, attach Grapple Link to self, and enter the Nightsoul's Blessing state. Deal 1 Dendro DMG, then switch position with the selected character.",
                'burst': "Hail to the Almighty Dragonlord \n3 Dendro, 2 Energy \nDeals 1 Dendro DMG, summons Almighty Dragonlord, Ajaw.",
                'hi_res_image': '/cards/gcg_1709_hd.webp',
                'card': '/cards/gcg_1709.webp',
                'card_selected': '/cards/gcg_1709_golden.webp',
                'icon': Kinich_Icon,
                'element': 'dendro',
                'region': 'natlan',
                'related': "Grapple Link, Nightsoul's Blessing, Almighty Dragonlord (Ajaw)",
                'flavor': "Fulfiller of Commissions, Flame Bearer of the Canopy.",
                'id': 'CN',
                'keyword': 'claymore',
            },

            'emilie': {
                'name': "Emilie",
                'na': "Shadow-Hunting Spear (Custom) \n2 Black, 1 Dendro \nDeals 2 Physical DMG.",
                'skill': "Fragrance Extraction \n3 Dendro \nSummons 1 Lumidouce Case: Level 1.",
                'burst': "Aromatic Explication \n3 Dendro, 2 Energy \nDeals 1 Dendro DMG, summons Lumidouce Case: Level 3.",
                'special': "Lingering Fragrance \n(Passive) \nWhen your Burning Flame enters play: After the next time either side uses a Skill, trigger 1 instance of Burning Flame's End of Round effect. (Twice per Round)",
                'hi_res_image': '/cards/gcg_1710_hd.webp',
                'card': '/cards/gcg_1710.webp',
                'card_selected': '/cards/gcg_1710_golden.webp',
                'icon': Emilie_Icon,
                'element': 'dendro',
                'region': 'fontaine',
                'related': "Lumidouce Case: Level 1, Lumidouce Case: Level 3, Burning Flame",
                'flavor': "Like fragrance fading, like mist dissipating.",
                'id': 'CU',
                'keyword': 'polearm',
            },

            'lauma': {
                'name': "Lauma",
                'na': "Peregrination of Linnunrata \n2 Black, 1 Dendro \nDeals 1 Dendro DMG.",
                'skill': "Runo: Dawnless Rest of Karsikko \n3 Dendro \nDeal 1 Dendro DMG, as well as generate Frostgrove Sanctuary. If you have a card in your Hand with Cost Reduction, remove Cost Reduction from a random card and instead generate a Frostgrove Sanctuary that deals 2 DMG.",
                'burst': "Runo: All Hearts Become the Beating Moon \n3 Dendro, 2 Energy \nApply Cost Reduction to 3 random cards with Current Elemental Dice Cost greater than 0 in your Hand. Generate 3 stacks of Pale Hymn.",
                'special': "Moonsign Benediction: Nature's Chorus \n(Passive) \nDuring this game, when your opponent is affected by  Bloom reaction(s), the reaction will be converted to the Lunar-Bloom reaction. \n\nWhen the opponent is affected by Lunar-Bloom reaction: Apply Cost Reduction to 1 random card in your Deck.",
                'hi_res_image': '/cards/gcg_1711_hd.webp',
                'card': '/cards/gcg_1711.webp',
                'card_selected': '/cards/gcg_1711_golden.webp',
                'icon': Lauma_Icon,
                'element': 'dendro',
                'region': 'nodkrai',
                'related': "Frostgrove Sanctuary, Pale Hymn",
                'flavor': "The mirrored moon fractures in the water.",
                'id': 'G9',
                'keyword': 'catalyst',
            },

            'nefer': {
                'name': "Nefer",
                'na': "Striking Serpent \n2 Black, 1 Dendro \nDeals 1 Dendro DMG.",
                'skill': "Senet Strategy: Dance of a Thousand Nights \n3 Dendro \nDeal 1 Dendro DMG. Attach 1 stack of RES to self. Before your next action, grant Cost Reduction to up to 3 highest-cost Seeds of Deceit in your Hand.",
                'burst': "Sacred Vow: True Eye's Phantasm \n3 Dendro, 2 Energy \nDeal 4 Dendro DMG. Deal +1 DMG for each Seeds of Deceit in your Hand (max +2)",
                'special': "Phantasm Performance \nDeals 4 Dendro DMG. \n",
                'special2': "Moonsign Benediction: Dusklit Eaves \n(Passive) \nDuring this game, when your opponent is affected by  Bloom reaction(s), the reaction will be converted to the Lunar-Bloom reaction. \n\nWhen your Hand contains fewer than 3 Seeds of Deceit and the opponent is affected by the Lunar-Bloom reaction: Create 1 Seeds of Deceit in your Hand. (Twice per Round)",
                'hi_res_image': '/cards/gcg_1712_hd.webp',
                'card': '/cards/gcg_1712.webp',
                'card_selected': '/cards/gcg_1712_golden.webp',
                'icon': Nefer_Icon,
                'element': 'dendro',
                'region': 'sumeru',
                'related': "RES, Seeds of Deceit",
                'flavor': "Seeking hidden secrets, to know all hearts.",
                'id': 'GK',
                'keyword': 'catalyst',
            },
    
            'cryocicinmage': {
                'name': "Fatui Cryo Cicin Mage",
                'na': "Cicin Icicle \n2 Black, 1 Cryo \nDeals 1 Cryo DMG.",
                'skill': "Misty Summons \n3 Cryo \nDeals 1 Cryo DMG, summons Cryo Cicins.",
                'burst': "Blizzard, Branch, Blossom \n3 Cryo, 3 Energy \nDeals 5 Cryo DMG, grants this character Cryo Application, creates 1 Flowing Cicin Ward.",
                'hi_res_image': '/cards/i_n330045_gcg_high_resolution.webp',
                'card': '/cards/i_n330045.webp',
                'card_selected': '/cards/i_n334045.webp',
                'icon': Cryocicin_Icon,
                'element': 'cryo',
                'region': 'fatui',
                'related': 'Cryo Cicin, Flowing Cicin Shield',
                'flavor': 'And so long as the Mist Grass yet lingers, the Cryo Cicins will not abandon her.',
                'id': '4V',
                "keyword": ""
            },

            'signora': {
                'name': 'La Signora',
                'na': "Frostblade Hailstorm \n2 Black, 1 Cryo \nDeals 1 Cryo DMG.",
                'skill': "Biting Shards \n3 Cryo \nDeals 2 Cryo DMG. The target character receives Sheer Cold.",
                'burst': "Carmine Chrysalis \n3 Cryo, 2 Energy\nDeals 4 Cryo DMG, heals this character for 2 HP. Removes Ice-Sealed Crimson Witch of Embers. This character permanently switches to Crimson Witch of Embers state.",
                'special': "Might of Delusion \n(Passive) \nWhen the battle begins,  this character gains Ice-Sealed Crimson Witch of Embers.",
                'hi_res_image': '/cards/i_n330060_gcg_high_resolution.webp',
                'card': '/cards/i_n330060.webp',
                'card_selected': '/cards/i_n334060.webp',
                'icon': Signora_Icon,
                'element': 'cryo',
                'region': 'fatui',
                'related': 'Blazing Heat, Sheer Cold, Ice-Sealed Crimson Witch of Embers',
                'flavor': "The crimson dawn was reflected in her pupils, and at last, she unfolded her flaming wings and flew towards the light.\n\"But that light is not the dawn, dear Rosalyne. That is a sea of flame that will consume everything.\"\nYet it mattered not, for she knew in her heart that the flames had devoured her long ago.",
                'id': '7V',
                'keyword': '',
            },

            'cryohypo': {
                'name': 'Cryo Hypostasis',
                'na': "Icespike Shot \n2 Black, 1 Cryo \nDeals 1 Cryo DMG.",
                'skill': "Ice Ring Waltz \n3 Cryo \nDeals 3 Cryo DMG. This character gains Overwhelming Ice.",
                'burst': "Plunging Ice Shards \n3 Cryo, 2 Energy\nDeals 2 Cryo DMG, deals 1 Piercing DMG to all opposing characters on standby, summons 1 Piercing Iceridge.",
                'special': "Cryo Crystal Core \n(Passive) \nWhen the battle begins, this character gains Cryo Crystal Core.",
                'hi_res_image': '/cards/i_n330073_gcg_high_resolution.webp',
                'card': '/cards/i_n330073.webp',
                'card_selected': '/cards/i_n334073.webp',
                'icon': CryoCube_Icon,
                'element': 'cryo',
                'region': 'monster',
                'related': "Overwhelming Ice, Piercing Iceridge, Cryo Crystal Core",
                'flavor': "Code name: Daleth. A high-purity Cryo entity.\nIt doesn't seem all that good at ball sports...",
                'id': '8X',
                'keyword': '',
            },

            'frostoperative': {
                'name': "Frost Operative",
                'na': "Swift Point \n2 Black, 1 Cryo \nDeals 2 Physical DMG.",
                'skill': "Frosty Interjection \n3 Cryo \nDeals 3 Cryo DMG.",
                'burst': "Thorny Onslaught \n3 Cryo, 2 Energy \nDeals 5 Cryo DMG. Attaches Onslaught Stance to this character.",
                'special': "Blood-Bonded Shadow \n(Passive) \nAfter this character uses a Skill: Attach Bond of Life to the opponent's active character with Usage(s) equal to (this Skill's finalized DMG total -2). (Max 5 stacks)",
                'hi_res_image': '/cards/gcg_2104_hd.webp',
                'card': '/cards/gcg_2104.webp',
                'card_selected': '/cards/gcg_2104_golden.webp',
                'icon': FrostOperative_Icon,
                'element': 'cryo',
                'region': 'fatui',
                'related': "Onslaught Stance, Bond of Life",
                'flavor': "Selected while still children, they can only become an \"Operative\" after many long years of training and teaching, after countless rounds have winnowed the field.",
                'id': 'B1',
                'keyword': '',
            },

            'waywardhermeticspiritspeaker': {
                'name': "Wayward Hermetic Spiritspeaker",
                'na': "Spiritspeaking: Frost Star \n2 Black, 1 Cryo \nDeals 1 Cryo DMG.",
                'skill': "Radiance in Flux \n3 Cryo \nDeals 1 Cryo DMG, places 1 Radiant Hues third from the top of your deck. If this is one of the first 4 times this skill is being used this game, then Select 1 of 3 random Radiant Hues enhancement effects.",
                'burst': "Chilling Illustration \n3 Cryo, 2 Energy \nDeals 4 Cryo DMG, and adds 1 Radiant Hues to your Hand.",
                'special': "Iridescent Silhouette \n(Passive) \nWhen battle begins, create 3 Radiant Hues and place them evenly into your deck.",
                'hi_res_image': '/cards/gcg_2105_hd.webp',
                'card': '/cards/gcg_2105.webp',
                'card_selected': '/cards/gcg_2105_golden.webp',
                'icon': WaywardHermeticSpiritspeaker_Icon,
                'element': 'cryo',
                'region': 'monster',
                'related': "Radiant Hues",
                'flavor': "A priestess of the Masters of the Night-Wind who has lived apart from her tribe, honing her abilities in utter solitude. It is said that her Spiritspeaking powers surpass those of ordinary priests and shamans, a result of having had the protection of the Masters of the Night-Wind's Wayob bestowed upon her.",
                'id': 'GL',
                'keyword': '',
            },
    
            "oceanid": {
                "name": "Rhodeia of Loch",
                'na': 'Surge \n2 Black, 1 Hydro \nDeals 1 Hydro DMG.',
                'skill': "Oceanid Mimic Summoning \n3 Hydro \nRandomly summons 1 'Oceanid Mimic' (Prioritizes summoning a different type from preexisting ones).",
                'burst': "Tide and Torrent \n3 Hydro, 3 Energy \nDeals 4 Hydro DMG. For each friendly Summon on the field, deals +1 additional DMG.",
                'special': "The Myriad Wilds \n5 Hydro \nRandomly summons 2 Oceanid Mimic (Prioritizes summoning different types).",
                'hi_res_image': '/cards/i_n330019_gcg_high_resolution.webp',
                "card": '/cards/i_n330019.webp',
                "card_selected": '/cards/i_n334019.webp',
                "icon": Oceanoid_Icon,
                "element": 'hydro',
                "region": 'monster',
                'related': 'Oceanic Mimic: Squirrel, Oceanic Mimic: Raptor, Oceanic Mimic: Frog',
                "flavor": "“As long as rain falls and rivers flow… water will exist forever… “",
                "id": '09',
                "keyword": ""        
            },
    
            "mirrormaiden": {
                "name": "Mirror Maiden",
                'na': 'Water Ball \n2 Black, 1 Hydro \nDeals 1 Hydro DMG.',
                'skill': "Influx Blast \n3 Hydro \nDeals 3 Hydro DMG. The target character receives Refraction.",
                'burst': "Rippled Reflection \n3 Hydro, 2 Energy \nDeals 5 Hydro DMG.",
                'hi_res_image': '/cards/i_n330026_gcg_high_resolution.webp',
                "card": '/cards/i_n330026.webp',
                "card_selected": '/cards/i_n334026.webp',
                "icon": Mirrormaiden_Icon,
                "element": 'hydro',
                "region": 'fatui',
                'related': 'Refraction',
                "flavor": "All secrets shall be concealed within the mirror of glaring brightness…",
                "id": '0A',
                "keyword": ""        
            },

            "abyssherald": {
                "name": "Abyss Herald: Wicked Torrents",
                'na': 'Rippling Slash \n2 Black, 1 Hydro \nDeals 2 Physical DMG.',
                'skill': "Vortex Edge \n3 Hydro \nDeals 1 Hydro DMG, then performs \"Prepare Skill\" for Rippling Blades.",
                'burst': "Torrential Shock \n3 Hydro, 2 Energy \nDeals 3 Hydro DMG. Creates 1 Curse of the Undercurrent on the opponent's side of the field.",
                'special': "Watery Rebirth\n(Passive) \n When the battle begins, this character gains Watery Rebirth.\n\nNote: This character begins the battle with 6 HP.",
                'special2': "Rippling Blades \n3 Hydro \nDeals 1 Hydro DMG.",
                'hi_res_image': '/cards/i_n330081_gcg_high_resolution.webp',
                "card": '/cards/i_n330081.webp',
                "card_selected": '/cards/i_n334081.webp',
                "icon": 'https://act-webstatic.hoyoverse.com/hk4e/e20200928calculate/item_char_icon_u63dbg/4a2bee284e8e6401ff2bf17068131e39.png',
                "element": 'hydro',
                "region": 'monster',
                'related': 'Curse of the Undercurrent, Watery Rebirth',
                "flavor": "The world shall be severed, and all shall be obliterated.",
                "id": '9Q',
                "keyword": ""        
            },

            "narwhal": {
                "name": "All Devouring Narwhal",
                'na': 'Shattering Waves \n2 Black, 1 Hydro \nDeals 2 Physical DMG.',
                'skill': "Starfall Shower \n3 Hydro \nDeals 1 Hydro DMG. This character deals +1 DMG for every 3 additional Max HP provided by Insatiable Appetite (Max +3.) After this, Discard 1 card from your Hand with the highest Current Elemental Dice Cost.",
                'burst': "Ravaging Devourer \n3 Hydro, 2 Energy \nDeals 1 Hydro DMG, deals 1 Piercing DMG to all opposing characters on standby. Summons 1 Dark Shadow.",
                'special': "Insatiable Appetite\n(Passive) \nWhen battle begins, create 1 Deep Devourer's Domain.",
                'hi_res_image': '/cards/i_n330088_gcg_high_resolution.webp',
                "card": '/cards/i_n330088.webp',
                "card_selected": '/cards/i_n334088.webp',
                "icon": 'https://act-webstatic.hoyoverse.com/hk4e/e20200928calculate/item_char_icon_u63dbg/5a90163e9aa049a36054c8b6c1366656.png',
                "element": 'hydro',
                "region": 'monster',
                'related': "Dark Shadow, Deep Devourer's Domain",
                "flavor": "In the most fantastical of fables, or perhaps in the most rabid of ravings, the true stars in the depths of cosmos are just as full of life as on Teyvat, while the universe itself is akin to an ocean.\nPerhaps the universe's infiltration of Teyvat has never ceased, and perhaps the drawing of borders around this world was the work of a higher will, meant to protect it.",
                "id": '9X',
                "keyword": ""        
            },

            'hydrohilichurlrogue': {
                'name': "Hydro Hilichurl Rogue",
                'na': "Whirling Scythe \n2 Black, 1 Hydro \nDeals 2 Physical DMG.",
                'skill': "Slash of Surging Tides \n3 Hydro \nDeals 3 Hydro DMG. \n\nIf an opposing character has Frozen or Mist Bubble Prison attached, this character gains 1 Energy. (Once per Round)",
                'burst': "Bubblefloat Blitz \n3 Hydro, 2 Energy \nDeals 4 Hydro DMG. Creates 1 Mist Bubble Slime in your Hand. \n\n(Characters with Mist Bubble Slime equipped can use the Technique: Bubble Battle Tactics)",
                'hi_res_image': '/cards/gcg_2205_hd.webp',
                'card': '/cards/gcg_2205.webp',
                'card_selected': '/cards/gcg_2205_golden.webp',
                'icon': HydroHilichurlRogue_Icon,
                'element': 'hydro',
                'region': 'monster',
                'related': "Frozen, Mist Bubble Prison, Mist Bubble Slime",
                'flavor': "Hilichurl wanderers unaffiliated with any specific tribe. They can often be found roving the wilds as if in voluntary exile.",
                'id': 'BD',
                'keyword': '',
            },

            'hydrotulpa': {
                'name': "Hydro Tulpa",
                'na': "Savage Swell \n2 Black, 1 Hydro \nDeals 1 Hydro DMG.",
                'skill': "Storm Surge \n3 Hydro \nDeals 2 Hydro DMG, and randomly triggers the End Phase effect for 1 of your Summons. If this character's HP is not lower than 2, they will receive 1 Piercing DMG.",
                'burst': "Thundering Tide \n3 Hydro, 3 Energy \nDeals 4 Hydro DMG, triggers the End Phase effect for all of your Summons.",
                'special': "Branching Flow \n(Passive) \nWhen this character's HP is not lower than 3, and your Summon apart from Half-Tulpa leaves play: This character receives 2 Piercing DMG and summons 1 independent Half-Tulpa. (Once per Round)",
                'hi_res_image': '/cards/gcg_2206_hd.webp',
                'card': '/cards/gcg_2206.webp',
                'card_selected': '/cards/gcg_2206_golden.webp',
                'icon': HydroTulpa_Icon,
                'element': 'hydro',
                'region': 'monster',
                'related': "Half-Tulpa",
                'flavor': "A human-shaped monster formed from the agglomeration of countless drops of water.",
                'id': 'EJ',
                'keyword': '',
            },

            'consecratedhornedcrocodile': {
                'name': "Consecrated Horned Crocodile",
                'na': "Fang Bite \n2 Black, 1 Hydro \nDeals 2 Physical DMG.",
                'skill': "Saw-Toothed Surge \n3 Hydro \nDeals 3 Hydro DMG, puts up to 1 card with the highest Current Elemental Dice Cost in your Hand at the bottom of your deck, then creates 1 Bonecruncher's Energy Block and adds it to your Hand.",
                'burst': "Reptilian Rage \n3 Hydro, 2 Energy \nDeals 4 Hydro DMG, then Discards up to 3 Bonecruncher's Energy Block cards. For each of those cards Discarded, heal the character on your team that has taken the most damage for 1 HP and increase their Max HP by 1.",
                'special': "Consecrated Senses \n(Passive) \nAfter you play or Discard a Bonecruncher's Energy Block card, heal the character on your team that has taken the most damage for 1 HP.",
                'hi_res_image': '/cards/gcg_2207_hd.webp',
                'card': '/cards/gcg_2207.webp',
                'card_selected': '/cards/gcg_2207_golden.webp',
                'icon': ConsecratedHornedCrocodile_Icon,
                'element': 'hydro',
                'region': 'monster',
                'related': "Bonecruncher's Energy Block",
                'flavor': "A reptile that has mutated after feeding from greater lifeforms, controlling the ever-changing flow of water.",
                'id': 'F6',
                'keyword': '',
            },

            'hydrohypostasis': {
                'name': "Hydro Hypostasis",
                'na': "Droplet Diffusion \n2 Black, 1 Hydro \nDeals 1 Hydro DMG.",
                'skill': "Surging Tides \n3 Hydro \nDeals 2 Hydro DMG, then performs \"Prepare Skill\" for Overflow.",
                'burst': "Calamitous Tides \n3 Hydro, 2 Energy \nDeals 3 Hydro DMG and summons Water Droplet.",
                'special': "Overflow \nDeals 1 Hydro DMG. \n",
                'special2': "Hydro Crystal Core \n(Passive) \nWhen the battle begins, this character starts with Hydro Crystal Core attached. If Water Droplet is on the field when Hydro Crystal Core is consumed: Reattach Hydro Crystal Core, and decreases the Usage(s) of Water Droplet by 1.",
                'hi_res_image': '/cards/gcg_2208_hd.webp',
                'card': '/cards/gcg_2208.webp',
                'card_selected': '/cards/gcg_2208_golden.webp',
                'icon': HydroHypostasis_Icon,
                'element': 'hydro',
                'region': 'monster',
                'related': "Water Droplet, Hydro Crystal Core",
                'flavor': "Code Name: He. A high-purity Hydro entity. They have strong rejection properties, and will mercilessly expel any that test them.",
                'id': 'GY',
                'keyword': '',
            },
    
            "pyroagent": {
                "name": "Fatui Pyro Agent",
                'na': 'Thrust \n2 Black, 1 Pyro \nDeals 2 Physical DMG.',
                'skill': "Prowl \n3 Pyro \nDeals 1 Pyro DMG. This character gains 'Stealth'.",
                'burst': "Blade Ablaze \n3 Pyro, 2 Energy \nDeals 5 Pyro DMG.",
                'special': "Stealth Master \n(Passive) \nWhen the battle begins, this character gains 'Stealth'.",
                'hi_res_image': '/cards/i_n330020_gcg_high_resolution.webp',
                "card": '/cards/i_n330020.webp',
                "card_selected": '/cards/i_n334020.webp',
                "icon": Pyroagent_Icon,
                "element": 'pyro',
                "region": 'fatui',
                'related': 'Stealth',
                "flavor": "“There is no running from your debt, be you living or otherwise.”",
                "id": '0F',
                "keyword": ""        
            },
    
            'abysslector': {
                'name': "Abyss Lector: Fathomless Flames",
                'na': "Flame of Salvation \n2 Black, 1 Pyro \nDeals 1 Pyro DMG.",
                'skill': "Searing Precept \n3 Pyro \nDeals 3 Pyro DMG.",
                'burst': "Ominous Star \n4 Pyro, 2 Energy \nDeals 3 Pyro DMG, summons 1 Darkfire Furnace.",
                'special': "Fiery Rebirth \n(Passive) \nWhen the battle begins, this character gains Fiery Rebirth.\n\nNote: This character starts the battle with 6 HP.",
                'hi_res_image': '/cards/i_n330046_gcg_high_resolution.webp',
                'card': '/cards/i_n330046.webp',
                'card_selected': '/cards/i_n334046.webp',
                'icon': Abysslector_Icon,
                'element': 'pyro',
                'region': 'monster',
                'related': 'Fiery Rebirth, Darkfire Furnace',
                'flavor': "From chapters of canon revealed come much heeded admonishments.",
                'id': '4W',
                "keyword": ""
            },

            'eremitescorchingloremaster': {
                'name': 'Eremite Scorching Loremaster',
                'na': "Searing Glare \n2 Black, 1 Pyro \nDeals 1 Pyro DMG.",
                'skill': "Blazing Strike \n3 Pyro \nDeals 3 Pyro DMG, creates 1 stack of Scorpion Blessing.",
                'burst': "Spirit of Omen's Awakening: Pyro Scorpion \n3 Pyro, 2 Energy \nDeals 3 Pyro DMG. Once each Match, add 1 Spirit of Omen: Pyro Scorpion card to your Hand. \n\n(Characters with Spirit of Omen: Pyro Scorpion equipped can use the Technique: Burning Assault)",
                'special': "Spirit of Omen's Power \n(Passive) \nAfter this character takes DMG: If this character has no more than 7 HP, they gain 1 Energy. (Once per Round)",
                'hi_res_image': '/cards/i_n330068_gcg_high_resolution.webp',
                'card': '/cards/i_n330068.webp',
                'card_selected': '/cards/i_n334068.webp',
                'icon': PyroEremite_Icon,
                'element': 'pyro',
                'region': 'the eremites',
                'related': 'Spirit of Omen: Pyro Scorpion',
                'flavor': "Those who still remember will never betray the spirit of the sands yet flowing through their veins.",
                'id': '7W',
                'keyword': '',
            },

            'crab': {
                'name': 'Emperor of Fire and Iron',
                'na': "Shatterclamp Strike \n2 Black, 1 Pyro \nDeals 2 Physical DMG.",
                'skill': "Buster Blaze \n3 Pyro \nDeals 1 Pyro DMG. If this character has at least 7 Armored Crab Carapace stacks, this DMG +1. \n\nAfter that, this character gains 2 Armored Crab Carapace stacks.",
                'burst': "Battle-Line Detonation \n3 Pyro, 2 Energy \nThis character's Prepare Skill: Searing Blast.",
                'special': "Imperial Panoply \n(Passive) \nWhen combat begins: Gain 5 initial Armored Crab Carapace stacks. \n\nAfter your side performs any action: If your side has any Shield Status or Shield Combat Status other than Armored Crab Carapace, these other effects will be canceled. For each effect canceled, this character gains 2 Armored Crab Carapace stacks.",
                'special2': "Searing Blast \n(Prepare for 1 turn) \nDeals 1 Pyro DMG, deals 2 Piercing DMG to all opposing standby characters. This skill deals +1 Pyro DMG for every 2 Armored Crab Carapace stacks this character has.",
                'hi_res_image': '/cards/i_n330082_gcg_high_resolution.webp',
                'card': '/cards/i_n330082.webp',
                'card_selected': '/cards/i_n334082.webp',
                'icon': 'https://act-webstatic.hoyoverse.com/hk4e/e20200928calculate/item_char_icon_u63dbg/9c42ebc08b146bbef2026474a4a2c852.png',
                'element': 'pyro',
                'region': 'monster',
                'related': 'Armored Crab Carapace',
                'flavor': "One of the two sovereigns who once stood at the apex of the aberrant species of the Fontemer. An Armored Crab that has avoided predation, and has constantly partaken in hunting and eating. Its imperial title is made half in awe, and half in jest.",
                'id': '9R',
                'keyword': '',
            },

            'lordoferodedprimalfire': {
                'name': "Lord of Eroded Primal Fire",
                'na': "Void Claw Strike \n2 Black, 1 Pyro \nDeals 2 Physical DMG.",
                'skill': "Eroded Flaming Feathers \n3 Pyro \nDeal 3 Pyro DMG and Discard the top 1 card from your deck.",
                'burst': "Severing Primal Fire \n3 Pyro, 2 Energy \nDeals 1 Pyro DMG, and deals 1 Piercing DMG to all the opponent's off-field characters. Both sides Discard the top 3 cards from their decks. Attaches 1 stack of Resentment to self.",
                'hi_res_image': '/cards/gcg_2305_hd.webp',
                'card': '/cards/gcg_2305.webp',
                'card_selected': '/cards/gcg_2305_golden.webp',
                'icon': LordOfErodedPrimalFire_Icon,
                'element': 'pyro',
                'region': 'monster',
                'related': "Resentment",
                'flavor': "A monster of the void, known as both the Reaper of the Abyss and \"Gosoythoth.\" It is able to corrupt memories contained within the Ley Lines, congealing them into tangible forces of catastrophic portent.",
                'id': 'E4',
                'keyword': '',
            },

            'goldflamequcusaurtyrant': {
                'name': "Goldflame Qucusaur Tyrant",
                'na': "Wingcleave \n2 Black, 1 Pyro \nDeals 2 Physical DMG.",
                'skill': "Rising Scorchwind \n3 Pyro \nDeals 1 Pyro DMG, and attaches 2 stacks of Flying Swirl to self.",
                'burst': "Goldflame Detonation \n3 Pyro, 2 Energy \nDeals 3 Pyro DMG, and deals 1 Piercing DMG to all opponent's off-field characters. Attaches 1 stack of Goldflame State to self.",
                'special': "Ancient Bloodline \n(Passive) \nAt the start of even-numbered Action Phases, attach 1 stack of Goldflame State to self.",
                'hi_res_image': '/cards/gcg_2306_hd.webp',
                'card': '/cards/gcg_2306.webp',
                'card_selected': '/cards/gcg_2306_golden.webp',
                'icon': GoldflameQucusaurTyrant_Icon,
                'element': 'pyro',
                'region': 'monster',
                'related': "Flying Swirl, Goldflame State",
                'flavor': "A Qucusaurus whose body has attained a supernatural form due to enduring forces that the bodies of modern Saurians cannot control.",
                'id': 'FH',
                'keyword': '',
            },

            "electrohypostasis": {
                'name': "Electro Hypostasis",
                'na': "Electro Crystal Projection \n2 Black, 1 Electro \nDeals 1 Electro DMG.",
                'skill': "Rock-Paper-Scissors Combo \n5 Electro \nDeals 2 Electro DMG and then separately performs \"Prepare Skill\" for Rock-Paper-Scissors Combo: Scissors and Rock-Paper-Scissors Combo: Paper.",
                'burst': "Lightning Lockdown \n3 Electro, 2 Energy \nDeals 2 Electro DMG, summons Chains of Warding Thunder.",
                'special': "Electro Crystal Core \n(Passive) \nWhen the battle begins, this character gains an Electro Crystal Core. \n\nNote: This character begins the battle with 8 HP.",
                'special2': "Rock-Paper-Scissors Combo: Scissors \n(Prepare for 1 turn) \nDeals 2 Electro DMG. Then, perform \"Prepare Skill\" for Rock-Paper-Scissors Combo: Paper.",
                'special3': "Rock-Paper-Scissors Combo: Paper \n(Prepare for 1 turn) \nDeals 3 Electro DMG.",
                'hi_res_image': '/cards/i_n330047_gcg_high_resolution.webp',
                'card': '/cards/i_n330047.webp',
                'card_selected': '/cards/i_n334047.webp',
                'icon': Electrohypostasis_Icon,
                'element': 'electro',
                'region': 'monster',
                'related': 'Electro Crystal Core, Chains of Warding Thunder',
                'flavor': "Code name: Aleph. A high-purity Electro entity.\nEven if you win at rock-paper-scissors, Aleph is not one to admit defeat.",
                'id': '4X',
                "keyword": ""
            },

            'thundermanifestation': {
                'name': 'Thunder Manifestation',
                'na': "Thunderous Wingslash \n2 Black, 1 Electro \nDeals 1 Electro DMG.",
                'skill': "Strifeful Lightning \n3 Electro \nDeals 3 Electro DMG to the opposing character affected by Lightning Rod. (If there are no eligible opposing characters, deals DMG to the active character instead)",
                'burst': "Thundering Shackles \n3 Electro, 2 Energy \nDeals 2 Electro DMG, summons 1 Thundering Shackles.",
                'special': "Lightning Probe \n(Passive) \nWhen battle begins, create a Lightning Strike Probe on the opponent's side of the field.",
                'hi_res_image': '/cards/i_n330069_gcg_high_resolution.webp',
                'card': '/cards/i_n330069.webp',
                'card_selected': '/cards/i_n334069.webp',
                'icon': ThunderManifestation_Icon,
                'element': 'electro',
                'region': 'monster',
                'related': 'Lightning Rod, Thundering Shackles, Lightning Strike Probe',
                'flavor': "As long as the grudges of the land do not fade, so will the roaring thunder persist.",
                'id': '7X',
                'keyword': '',
            },

            'seahorse': {
                'name': 'Millennial Pearl Seahorse',
                'na': "Tail Sweep \n2 Black, 1 Electro \nDeals 2 Physical DMG.",
                'skill': "Swirling School of Fish \n3 Electro \nDeals 3 Electro DMG. \n\nIf this character has Fontemer Pearl attached, that Usage(s) +1. (Once per Round)",
                'burst': "Fontemer Hoarthunder \n3 Electro, 2 Energy\nDeals 1 Electro DMG, attaches Fontemer Pearl to this character, and summons 1 Resonant Coral Orb.",
                'special': "Pearl Armor \n(Passive) \nWhen the battle begins, attach Fontemer Pearl to this character.",
                'hi_res_image': '/cards/i_n330074_gcg_high_resolution.webp',
                'card': '/cards/i_n330074.webp',
                'card_selected': '/cards/i_n334074.webp',
                'icon': Seahorse_Icon,
                'element': 'electro',
                'region': 'monster',
                'related': 'Fontemer Pearl, Resonant Coral Orb',
                'flavor': "One of the two sovereigns standing at the apex of the Fontemer Aberrants. Poets and authors view it as a proud and noble creature, thus bestowing it with its high-flown title.",
                'id': '8Y',
                'keyword': '',
            },

            'ecicinmage': {
                'name': 'Fatui Electro Cicin Mage',
                'na': "Hurtling Bolts \n2 Black, 1 Electro \nDeals 1 Electro DMG.",
                'skill': "Misty Call\n3 Electro \nSummons 1 Electro Cicin.",
                'burst': "Thundering Shield \n3 Electro, 2 Energy \nDeals 1 Electro DMG, applies Electro Application to this character, creates 1 Electro Cicin Ward and prepares Surging Thunder.",
                'special': "Surging Thunder \n(Prepare for 1 turn) \nDeals 2 Electro DMG.",
                'hi_res_image': '/cards/i_n330078_gcg_high_resolution.webp',
                'card': '/cards/i_n330078.webp',
                'card_selected': '/cards/i_n334078.webp',
                'icon': 'https://act-webstatic.hoyoverse.com/hk4e/e20200928calculate/item_char_icon_u7ea0f/f4a39288a3be8589c4f458c757418460.png',
                'element': 'electro',
                'region': 'fatui',
                'related': 'Electro Cicin, Electro Cicin Shield',
                'flavor': "...Just as the scent of Mist Grass intoxicates the Electro Cicins, so too does the sadistic mage hanker after the pleasure of toying with her foe...",
                'id': '9D',
                'keyword': '',
            },

            'consecratedscorpion': {
                'name': 'Consecrated Scorpion',
                'na': "Scorpion Strike \n2 Black, 1 Electro \nDeals 2 Physical DMG.",
                'skill': "Stinging Spine\n3 Electro \nDeals 3 Electro DMG. Create 1 Bonecruncher's Energy Block card and randomly place it within the top 2 cards of your deck.",
                'burst': "Thunderbore Blast \n3 Electro, 2 Energy\nDeals 3 Electro DMG. Discard up to 3 Bonecruncher's Energy Block cards from your Hand, and create 1 Thunderbore Trap on the opposing side of the field.",
                'special': "Immortal Remnants: Electro \n(Passive) \nWhen the Round ends, create 2 Bonecruncher's Energy Block cards and randomly place them within the top 10 cards of your deck.",
                'hi_res_image': '/cards/i_n330089_gcg_high_resolution.webp',
                'card': '/cards/i_n330089.webp',
                'card_selected': '/cards/i_n334089.webp',
                'icon': 'https://act-webstatic.hoyoverse.com/hk4e/e20200928calculate/item_char_icon_u63dbg/86bf0cac1018425736b647057355f796.png',
                'element': 'electro',
                'region': 'monster',
                'related': "Bonecruncher's Energy Block, Thunderbore Trap",
                'flavor': "A poisonous scorpion that became twisted and warped by eating some great being. It now commands perilous lightning.",
                'id': '9Y',
                'keyword': '',
            },

            'abysslectorvioletlightning': {
                'name': "Abyss Lector: Violet Lightning",
                'na': "Den of Thunder \n2 Black, 1 Electro \nDeals 1 Electro DMG.",
                'skill': "Shock of the Enigmatic Abyss \n3 Electro \nDeals 3 Electro DMG. \n\nIf the target is already affected by Electro, steal 1 Energy from them. (If this character's Energy is already full, then the stolen Energy will be given to the next character who does not have full Energy)",
                'burst': "Wild Thunderburst \n3 Electro, 2 Energy \nDeals 3 Electro DMG. \n\nIf the target has no more than 1 Energy, deals +2 DMG.",
                'special': "Electric Rebirth \n(Passive) \nWhen the battle begins, this character gains Electric Rebirth.",
                'hi_res_image': '/cards/gcg_2406_hd.webp',
                'card': '/cards/gcg_2406.webp',
                'card_selected': '/cards/gcg_2406_golden.webp',
                'icon': AbyssLectorVioletLightning_Icon,
                'element': 'electro',
                'region': 'monster',
                'related': "Electric Rebirth",
                'flavor': "Praise be unto the Abyss, the Wisdom of Corrosion.",
                'id': 'BP',
                'keyword': '',
            },
    
            "maguu": {
                "name": 'Maguu Kenki',
                'na': 'Ichimonji\n2 Black, 1 Anemo \nDeals 2 Physical DMG.',
                'skill': "Blustering Blade\n3 Anemo \nSummons 1 'Shadowsword: Lone Gale'.",
                'burst': "Pseudo Tengu Sweeper \n3 Anemo, 3 Energy \nDeals 4 Anemo DMG, triggers the effect(s) of all your Shadowsword Summon(s). (Does not consume their Usages)",
                'special': "Frosty Assault \n3 Anemo \nSummons 1 Shadowsword: Galloping Frost.",
                'hi_res_image': '/cards/i_n330021_gcg_high_resolution.webp',
                "card": '/cards/i_n330021.webp',
                "card_selected": '/cards/i_n334021.webp',
                "icon": Maguu_Icon,
                "element": 'anemo',
                "region": 'monster',
                'related': 'Shadowsword: Lone Gale, Shadowsword: Galloping Frost',
                "flavor": "Even today, it still patrols the place where fate was severed.",
                "id": '0M',
                "keyword": ""        
            },

            'dvalin': {
                'name': 'Dvalin',
                'na': "Lacerating Slash \n2 Black, 1 Anemo \nDeals 2 Physical DMG.",
                'skill': "Tempestuous Barrage \n3 Anemo \nDeals 2 Anemo DMG. The target character receives Total Collapse.",
                'burst': "Caelestinum Finale Termini \n4 Anemo, 2 Energy\nDeals 5 Anemo DMG. Applies Total Collapse to all opposing standby characters.",
                'special': "Dvalin's Cleansing \n5 Anemo \nDeals 2 Anemo DMG and then separately performs \"Prepare Skill\" for Perpetual Cleansing and Ultimate Cleansing.",
                'special2': "Perpetual Cleansing \n(Prepare for 1 turn) \nDeals 1 Anemo DMG to the next opposing character on standby. After this, Prepare Skill: Ultimate Cleansing. (If there are no opposing characters on standby, deals DMG to active character instead)",
                'special3': "Ultimate Cleansing \n(Prepare for 1 turn) \nDeals 2 Anemo DMG to the previous opposing character on standby. (If there are no opposing characters on standby, deals DMG to the active character instead)",
                'hi_res_image': '/cards/i_n330070_gcg_high_resolution.webp',
                'card': '/cards/i_n330070.webp',
                'card_selected': '/cards/i_n334070.webp',
                'icon': Dvalin_Icon,
                'element': 'anemo',
                'region': 'monster',
                'related': 'Total Collapse',
                'flavor': "\"How wonderful it would have been if you were as I, witnessing your noble, beautiful form as you soared through the blue sky.\n\"Then you would know that this sky and this earth are both things worth fighting for.\"",
                'id': '7Y',
                'keyword': '',
            },

            'consecratedserpent': {
                'name': 'Consecrated Flying Serpent',
                'na': "Whirling Tail \n2 Black, 1 Anemo \nDeals 2 Physical DMG.",
                'skill': "Swirling Squall \n3 Anemo \nDeal 3 Anemo DMG and draw 1 card.",
                'burst': "Scattershot Vortex \n3 Anemo, 2 Energy\nDeals 2 Anemo DMG. Discard all Bonecruncher's Energy Block cards in your Hand. Double the DMG dealt once for every 2 cards you Discard.",
                'special': "Immortal Remnants: Anemo \n(Passive) When battle begins, create 6 Bonecruncher's Energy Block and place them evenly into your deck.",
                'hi_res_image': '/cards/i_n330090_gcg_high_resolution.webp',
                'card': '/cards/i_n330090.webp',
                'card_selected': '/cards/i_n334090.webp',
                'icon': 'https://act-webstatic.hoyoverse.com/hk4e/e20200928calculate/item_char_icon_u63dbg/a2f57e5985093eae7334c50d02e6280f.png',
                'element': 'anemo',
                'region': 'monster',
                'related': "Bonecruncher's Energy Block",
                'flavor': "A flying serpent that became twisted and warped by eating some great being. Now, it commands the fearsome winds.",
                'id': '9Z',
                'keyword': '',
            },

            'blackserpentknightwindcutter': {
                'name': "Black Serpent Knight: Windcutter",
                'na': "Half-Sword Technique \n2 Black, 1 Anemo \nDeals 2 Physical DMG.",
                'skill': "Rising Slash \n3 Anemo \nDeal 3 Anemo DMG and draw 1 card.",
                'burst': "Guard Stance \n3 Anemo, 2 Energy \nPrepare Skill: Reckless Stance, then Prepare Skill: Gale Pursuit.",
                'special': "Reckless Stance \nDeal 3 Anemo DMG. Discard 1 card with the highest Current Elemental Dice Cost in your Hand. Prepare Skill: Gale Pursuit. \n",
                'special2': "Gale Pursuit \nDeal 3 Anemo DMG. Discard 1 card with the highest Current Elemental Dice Cost in your Hand. \n",
                'special3': "Vanguard Momentum \n(Passive) \nWhen you trigger a Swirl reaction, or when the opponent loses their Shield, DMG Negation, or Combat Status, draw 1 card. (Twice per Round)",
                'hi_res_image': '/cards/gcg_2504_hd.webp',
                'card': '/cards/gcg_2504.webp',
                'card_selected': '/cards/gcg_2504_golden.webp',
                'icon': BlackSerpentKnightWindcutter_Icon,
                'element': 'anemo',
                'region': 'monster',
                'related': "",
                'flavor': "\"A guard of some standing in the court. The Twilight Sword was once one of their number.\"",
                'id': 'GM',
                'keyword': '',
            },
    
            "stonehidelawachurl": {
                "name": "Stonehide Lawachurl",
                'na': 'Plama Lawa \n2 Black, 1 Geo \nDeals 2 Physical DMG.',
                'skill': 'Movo Lawa \n3 Geo \nDeals 3 Physical DMG.',
                'burst': "Upa Shato \n3 Geo, 2 Energy \nDeals 5 Physical DMG.",
                'special': "Infused Stonehide \n(Passive) \nWhen the battle begins, this character gains 'Stonehide' and 'Stone Force'.\n\nNote: This character starts the battle with 8 HP.",
                'hi_res_image': '/cards/i_n330022_gcg_high_resolution.webp',
                "card": '/cards/i_n330022.webp',
                "card_selected": '/cards/i_n334022.webp',
                "icon": Stonehidelawachurl_Icon,
                "element": 'geo',
                "region": 'monster',
                'related': 'Stonehide, Stone Force',
                "flavor": "Go around — the way ahead is the realm of the “king.”",
                "id": '0P',
                "keyword": ""        
            },

            'azhdaha': {
                'name': 'Azhdaha',
                'na': "Sundering Charge \n2 Black, 1 Geo \nDeals 2 Physical DMG.",
                'skill': "Aura of Majesty \n3 Geo \nDeals 3 Geo DMG. If a Crystallize reaction occurs, then this character will perform Elemental Absorption. \n\nIf during the usage of this skill, the character hasn't absorbed an element's power yet, then Stone Facets: Elemental Crystallization will be attached.",
                'burst': "Decimating Rockfall \n3 Geo, 2 Energy\nDeals 4 Geo DMG. DMG +1 for each element previously absorbed.",
                'special': "Stone Facets \n(Passive) \nWhen the battle begins, this character gains Stone Facets: Elemental Absorption.",
                'hi_res_image': '/cards/i_n330061_gcg_high_resolution.webp',
                'card': '/cards/i_n330061.webp',
                'card_selected': '/cards/i_n334061.webp',
                'icon': Azhdaha_Icon,
                'element': 'geo',
                'region': 'monster',
                'related': 'Stone Facets: Elemental Crystallization, Stone Facets: Elemental Absorption',
                'flavor': "The faint rattling of this dragon lord's shackles and his deep, angry growl echo through the bowels of the mountains like memories of a bygone era.",
                'id': '7Z',
                'keyword': '',
            },

            'goldenwolflord': {
                'name': "Golden Wolflord",
                'na': "Wolflord's Strike \n2 Black, 1 Geo \nDeals 2 Physical DMG.",
                'skill': "Howling Riftcall \n3 Geo \nDeals 2 Geo DMG, attaches 2 stacks of Golden Corrosion to target character, and summons Rifthound Skull.",
                'burst': "Golden Cankerbind \n3 Geo, 2 Energy \nDeals 3 Geo DMG, deals 1 Piercing DMG to all opposing characters on standby, then attaches Golden Corrosion to all opposing characters.",
                'hi_res_image': '/cards/gcg_2603_hd.webp',
                'card': '/cards/gcg_2603.webp',
                'card_selected': '/cards/gcg_2603_golden.webp',
                'icon': GoldenWolflord_Icon,
                'element': 'geo',
                'region': 'monster',
                'related': "Golden Corrosion, Rifthound Skull",
                'flavor': "A twisted beast from another world. This creature is the ruler of the Riftwolves, and wields the power to command them to dissolve space itself.",
                'id': 'C2',
                'keyword': '',
            },

            'blackserpentknightrockbreakerax': {
                'name': "Black Serpent Knight: Rockbreaker Ax",
                'na': "Supreme Strike \n2 Black, 1 Geo \nDeals 2 Physical DMG.",
                'skill': "Axe and Aegis \n3 Geo \nDeals 3 Geo DMG.",
                'burst': "Stone Stance \n3 Geo, 2 Energy \nPerform Geo Application on self and prepares the Skill Greataxe Strike, then prepares the Skill Master's Strike.",
                'special': "Greataxe Strike \nDeals 3 Geo DMG and prepares the Skill Master's Strike. \n",
                'special2': "Master's Strike \nDeals 3 Geo DMG. \n",
                'special3': "Attacking Momentum \n(Passive) \nIf the opponent has Damage Negation or Shield Status on their side of the field, or they have Damage Negation or Shield Combat Status, attach 1 stack of Might of Stone to self after your character uses a Skill.",
                'hi_res_image': '/cards/gcg_2604_hd.webp',
                'card': '/cards/gcg_2604.webp',
                'card_selected': '/cards/gcg_2604_golden.webp',
                'icon': BlackSerpentKnightRockbreakerAx_Icon,
                'element': 'geo',
                'region': 'monster',
                'related': "Might of Stone",
                'flavor': "A guard of some standing in the court, sundering the foes of the nation's rulers using a sword art known as \"Truthseeker.\"",
                'id': 'EV',
                'keyword': '',
            },

            'experimentalfieldgenerator': {
                'name': "Experimental Field Generator",
                'na': "Gravity Application: Crush \n2 Black, 1 Geo \nDeals 2 Physical DMG.",
                'skill': "Gravity Application: Point Null \n3 Geo \nDeal 2 Geo DMG and generate 2 stacks of Efficient Switch.",
                'burst': "Gravity Application: Field Reduction \n3 Geo, 2 Energy \nDeal 3 Geo DMG, as well as generate Low Gravity Background and Shock Blast. During this Round, all your characters on standby use 1 less Unaligned Element when using their next Normal Attack.",
                'hi_res_image': '/cards/gcg_2605_hd.webp',
                'card': '/cards/gcg_2605.webp',
                'card_selected': '/cards/gcg_2605_golden.webp',
                'icon': ExperimentalFieldGenerator_Icon,
                'element': 'geo',
                'region': 'monster',
                'related': "Efficient Switch, Low Gravity Background, Shock Blast",
                'flavor': "A product of the Fontaine Research Institute of Kinetic Energy Engineering that has gone out of control due to an accident. It has the ability to \"counteract\" the effects of gravity.",
                'id': 'GA',
                'keyword': '',
            },
    
            "terrorshroom": {
                "name": "Jadeplume Terrorshroom",
                'na': 'Majestic Dance\n2 Black, 1 Dendro \nDeals 2 Physical DMG.',
                'skill': 'Volatile Spore Cloud\n3 Dendro \nDeals 3 Dendro DMG.',
                'burst': "Feather Spreading \n3 Dendro, 2 Energy \nDeals 4 Dendro DMG, then consumes all Radical Vitality stacks. For each stack consumed, this instance deals +1 DMG.",
                'special': "Radical Vitality \n(Passive) \nWhen the battle begins, this character gains Radical Vitality.",
                'hi_res_image': '/cards/i_n330027_gcg_high_resolution.webp',
                "card": '/cards/i_n330027.webp',
                "card_selected": '/cards/i_n334027.webp',
                "icon": Terrorshroom_Icon,
                "element": 'dendro',
                "region": 'monster',
                'related': 'Radical Vitality',
                "flavor": "If you keep silent and listen closely, you can hear the sound of the ruler of the Shroom-Kin inspecting its territory...",
                "id": '0R'        
            },

            "apep": {
                "name": "Guardian of Apep's Oasis",
                'na': 'Strike of the Dispossessed\n2 Black, 1 Dendro \nDeals 2 Physical DMG.',
                'skill': 'Life Stream\n3 Dendro \nDeals 2 Dendro DMG, draw 1 Awaken, My Kindred card and create 1 stack of Oasis Nourishment.',
                'burst': "The End Falls \n3 Dendro, 2 Energy \nDeals 4 Dendro DMG, draw 1 Awaken, My Kindred card and create 2 stacks of Oasis Nourishment.",
                'special': "Invokation of Propagation \n(Passive) \nWhen battle begins, create 5 Awaken, My Kindred and place them randomly into your deck. After you summon 4 Proliferated Organism, this character gains Reignited Heart of Oasis and obtains 1 Shield point.",
                'hi_res_image': '/cards/i_n330091_gcg_high_resolution.webp',
                "card": '/cards/i_n330091.webp',
                "card_selected": '/cards/i_n334091.webp',
                "icon": 'https://act-webstatic.hoyoverse.com/hk4e/e20200928calculate/item_char_icon_u63dbg/d74dc7f6784b9cd02cd7e4e0da980654.png',
                "element": 'dendro',
                "region": 'monster',
                'related': 'Awaken My Kindred, Oasis Nourishment, Proliferated Organism, Reignited Heart of Oasis',
                "flavor": "Apep found itself swallowed alone amidst the scenery of the catastrophe. All the people, gods, dragons, beasts, birds, and fish. All memories, wisdom, words, and hatred were ground into colorless dust, and the last of the moonlight burned away into a rain of pale fire, falling on the barren land.\n...\nApep once deemed the bottom of the sea of sand to be its grave, not the palace of a dispossessed king. The poison of \"wisdom\" would soon free Apep from the hatred and anger festering within it over countless moons. Apep had grown weary of the colorless apocalypse. Then, finally, the young god and the golden Traveler let it recall once again, even though the verdant land it once ruled had been reduced to this gilded wasteland, even though Apep and its many offspring had grown twisted and wretched to secure their continued survival therein, Apep still treasured the sight and scenes of the oasis sparkling in its heart.",
                "id": 'A0'        
            },

            'eremitefloralringdancer': {
                'name': "Eremite Floral Ring-Dancer",
                'na': "Floral-Ring Caress \n2 Black, 1 Dendro \nDeals 2 Physical DMG.",
                'skill': "Spiraling Whirl \n3 Dendro \nDeals 3 Dendro DMG, creates 1 stack of Spirit-Serpent's Blessing.",
                'burst': "Spirit of Omen's Awakening: Dendro Spirit-Serpent \n3 Dendro, 2 Energy \nDeals 4 Dendro DMG. Once each Match, add 1 Spirit of Omen: Dendro Spirit-Serpent card to your Hand. \n\n(Characters with Spirit of Omen: Dendro Spirit-Serpent equipped can use the Technique: Viny Razorscale)",
                'special': "Spirit of Omen's Power \n(Passive) \nAfter this character takes DMG: If this character has no more than 7 HP, they gain 1 Energy. (Once per Round)",
                'hi_res_image': '/cards/gcg_2703_hd.webp',
                'card': '/cards/gcg_2703.webp',
                'card_selected': '/cards/gcg_2703_golden.webp',
                'icon': EremiteFloralRingDancer_Icon,
                'element': 'dendro',
                'region': 'the eremites',
                'related': "Spirit-Serpent's Blessing, Spirit of Omen: Dendro Spirit-Serpent",
                'flavor': "\"The children of the desert have a rich tradition of song and dance. Originally used to praise and serve the gods, the crafts were later adapted for battle and the seduction of kings.\"",
                'id': 'BQ',
                'keyword': '',
            },

            'gluttonousyumkasaurmountainking': {
                'name': "Gluttonous Yumkasaur Mountain King",
                'na': "Crushing Tail Attack \n2 Black, 1 Dendro \nDeals 2 Physical DMG.",
                'skill': "Flying Fruit \n3 Dendro \nDeal 2 Dendro DMG and draw 1 Food Card.",
                'burst': "Flamegranate Conflagration \n3 Dendro, 2 Energy \nDeals 5 Pyro DMG.",
                'special': "Gluttonous Rex \n(Passive) \nCannot be satiated. \n\nAfter you play a Food Card: Randomly attach 1 stack of Well Fed and Strong or Well Fed and Sturdy, or gain 1 additional Max HP. (Twice per Round)",
                'hi_res_image': '/cards/gcg_2704_hd.webp',
                'card': '/cards/gcg_2704.webp',
                'card_selected': '/cards/gcg_2704_golden.webp',
                'icon': GluttonousYumkasaurMountainKing_Icon,
                'element': 'dendro',
                'region': 'monster',
                'related': "Well Fed and Strong, Well Fed and Sturdy",
                'flavor': "A mighty Yumkasaurus that has survived since ancient times and seen countless battles.",
                'id': 'DQ',
                'keyword': '',
            },

            'consecratedfangedbeast': {
                'name': "Consecrated Fanged Beast",
                'na': "Claw Slash \n2 Black, 1 Dendro \nDeals 2 Physical DMG.",
                'skill': "Siphon Wave \n3 Dendro \nDeals 2 Dendro DMG and draws 1 Bonecruncher's Energy Block.",
                'burst': "Sprawling Blighted Vines \n3 Dendro, 2 Energy \nDeal 4 Dendro DMG. If there are Bonecruncher's Energy Block in your Hand, Discard 1 and prepare Skill: Sprouts of the Blighted Rot.",
                'special': "Sprouts of the Blighted Rot \nDeals 2 Dendro DMG. \n",
                'special2': "Hunger from the Remains \n(Passive) \nWhen battle begins, create 2 Bonecruncher's Energy Block and place them at the bottom of your Deck. You can play 1 extra Bonecruncher's Energy Block each Round.",
                'special3': "Hunger From the Remains \n(Passive) \nWhen battle begins, create 2 Bonecruncher's Energy Block and place them at the bottom of your Deck. You can play 1 extra Bonecruncher's Energy Block each Round.",
                'hi_res_image': '/cards/gcg_2705_hd.webp',
                'card': '/cards/gcg_2705.webp',
                'card_selected': '/cards/gcg_2705_golden.webp',
                'icon': ConsecratedFangedBeast_Icon,
                'element': 'dendro',
                'region': 'monster',
                'related': "Bonecruncher's Energy Block",
                'flavor': "A predator that has mutated after feeding from greater lifeforms. It now wields the power of frenzied vines.",
                'id': 'FW',
                'keyword': '',
            },
        },
    
        "actions": {
            "undividedheart": {
                "name": "Undivided Heart",
                "tags": ['modify', 'talent', 'slowly'],
                "image": "/cards/i_n330500.webp",
                "golden_image": "/cards/i_n334500.webp",
                "hi_res_image": "/cards/i_n330500_gcg_high_resolution.webp",
                "cost": '5 Cryo',
                "description": "'Combat Action': When your active character is Ganyu, equip this card.\n\nAfter Ganyu equips this card, immediately use 'Normal Attack: Frostflake Arrow' once.\n\nWhen your Ganyu, who has this card equipped, uses 'Normal Attack: Frostflake Arrow': If this Skill has been used before during this match, the Piercing DMG dealt to all opposing characters on standby is changed to 3.\n\n(You must have Ganyu in your deck to add this card to your deck.)",
                "flavor": "First the arrow strikes, and then it turns to frost.",
                "required": "ganyu",
                "id": '0S'     
            },
    
            "shakennotpurred": {
                "name": "Shaken, Not Purred",
                "tags": ['modify', 'talent', 'slowly'],
                "image": "/cards/i_n330523.webp",
                "golden_image": "/cards/i_n334523.webp",
                "hi_res_image": "/cards/i_n330523_gcg_high_resolution.webp",
                "cost": '3 Cryo',
                "description": "'Combat Action': When your active character is Diona, equip this card.\n\nAfter Diona equips this card, immediately use 'Elemental Skill: Icy Paws' once.\n\nWhen your Diona, who has this card equipped, creates a 'Cat-Claw Shield', its 'Shield' points +1.\n\n(You must have Diona in your deck to add this card to your deck.)",
                "flavor": "Shake and stir till its all evenly mixed… and there! Your refill’s ready!",
                "required": "diona",
                "id": '1E'        
            },
            
            "coldbloodedstrike": {
                "name": "Cold-Blooded Strike",
                "tags": ['modify', 'talent', 'slowly'],
                "image": "/cards/i_n330501.webp",
                "golden_image": "/cards/i_n334501.webp",
                "hi_res_image": "/cards/i_n330501_gcg_high_resolution.webp",
                "cost": "3 Cryo",
                "description": "'Combat Action': When your active character is Kaeya, equip this card.\n\nAfter Kaeya equips this card, immediately use 'Elemental Skill: Frostgnaw' once.\n\nAfter your Kaeya, who has this card equipped, uses 'Elemental Skill: Frostgnaw', he heals himself for 2 HP. (Once per Round)\n\n(You must have Kaeya in your deck to add this card to your deck.)",
                "flavor": "A slightly cold joke.",
                "required": "kaeya",
                "id": '0T'        
            },
            
            "steadybreathing": {
                "name": "Steady Breathing",
                "tags": ['modify', 'talent', 'slowly'],
                "image": "/cards/i_n330502.webp",
                "golden_image": "/cards/i_n334502.webp",
                "hi_res_image": "/cards/i_n330502_gcg_high_resolution.webp",
                "cost": '3 Cryo',
                "description": "Combat Action: When your active character is Chongyun, equip this card. \n\nAfter Chongyun equips this card, immediately use Chonghua's Layered Frost once. \n\nWhen your Chongyun, who has this card equipped, creates a Chonghua Frost Field, it will have the following effects: Your Sword, Claymore, and Polearm-wielding characters' Normal Attacks to deal +1 DMG. \n\n(You must have Chongyun in your deck to add this card to your deck.)",
                "flavor": "Steady breathing makes a steady heart.",
                "required": "chongyun",
                "id": '0U'        
            },
            
            "kantensenmyoublessing": {
                "name": "Kanten Senmyou Blessing",
                "tags": ['modify', 'talent'],
                "image": "/cards/i_n330503.webp",
                "golden_image": "/cards/i_n334503.webp",
                "hi_res_image": "/cards/i_n330503_gcg_high_resolution.webp",
                "cost": '2 Cryo',
                "description": "The Cryo Elemental Infusion created by your Kamisato Ayaka, who has this card equipped, allows the character to which it is attached to deal +1 Cryo DMG. \n\nWhen you switch to Kamisato Ayaka, who has this card equipped: Spend 1 fewer Elemental Die. (Once per Round) \n\n(You must have Kamisato Ayaka in your deck to add this card to your deck.)",
                "flavor": "The heron holds upon the ice on elegant wing.",
                "required": "ayaka",
                "id": '0V'
            },
    
            "wellspringofwarlust": {
                "name": "Wellspring of War-Lust",
                "tags": ['modify', 'talent', 'slowly'],
                "image": "/cards/i_n330528.webp",
                "golden_image": "/cards/i_n334530.webp",
                "hi_res_image": "/cards/i_n330528_gcg_high_resolution.webp",
                "cost": '3 Cryo 2 Energy',
                "description": "Combat Action: When your active character is Eula, equip this card. \n\nAfter Eula equips this card, immediately use Glacial Illumination once. \n\nWhen your Eula, who has this card equipped, uses Icetide Vortex, this will generate 1 more Zeal stack for Lightfall Sword. \n\n(You must have Eula in your deck to add this card to your deck.)",
                "flavor": "Flood of frost will ensure that vengeance is mine.",
                "required": "eula",
                "id": '4A' 
            },
    
            "mysticalabandon": {
                "name": "Mystical Abandon",
                "tags": ['modify', 'talent', 'slowly'],
                "image": "/cards/i_n330540.webp",
                "golden_image": "/cards/i_n334540.webp",
                "hi_res_image": "/cards/i_n330540_gcg_high_resolution.webp",
                "cost": '3 Cryo',
                "description": "Combat Action: When your active character is Shenhe, equip this card. \n\nAfter Shenhe equips this card, immediately use Spring Spirit Summoning once. \n\nWhen the Icy Quill created by your Shenhe, who has this card equipped, is triggered by your characters' Normal Attacks, its Usages will not decrease. (Once per Round) \n\n(You must have Shenhe in your deck to add this card to your deck.)",
                "flavor": 'Transfigure, and let my will be embodied!',
                'required': 'shenhe',
                'related': 'Icy Quill',
                'id': '55'
            },

            "riteofresurrection": {
                "name": "Rite of Resurrection",
                "tags": ['modify', 'talent', 'slowly'],
                "image": "/cards/i_n330552.webp",
                "golden_image": "/cards/i_n334552.webp",
                "hi_res_image": "/cards/i_n330552_gcg_high_resolution.webp",
                "cost": "4 Cryo 3 Energy",
                "description": "Combat Action: When your active character is Qiqi, equip this card. \n\nAfter Qiqi equips this card, immediately use Adeptus Art: Preserver of Fortune once. \n\nAfter your Qiqi, who has this card equipped, uses Adeptus Art: Preserver of Fortune, she revives all your fallen characters and heals them for 2 HP. (Can happen 2 times per match) \n\n(You must have Qiqi in your deck to add this card to your deck.)",
                "flavor": "\"I must... live on...\"",
                'required': 'qiqi',
                'id': '6V'
            },

            'lightsremit': { 
                'name': 'Light\'s Remit',
                'tags': ['modify', 'talent', 'slowly'],
                'hi_res_image': '/cards/i_n330560_gcg_high_resolution.webp',
                'image': '/cards/i_n330560.webp',
                'golden_image': '/cards/i_n334560.webp',
                'cost': '3 Cryo',
                'description': "Combat Action: When your active character is Layla, equip this card.\nAfter Layla equips this card, immediately use Nights of Formal Focus.\nWhen Layla is on the field and has this card equipped, every time Shooting Star deals DMG, draw 1 card.\n(You must have Layla in your deck to add this card to your deck.)",
                'flavor': "\"My guiding stars.\"",
                'required': 'layla',
                'id': '80',
            },

            'asummationofinterest': { 
                'name': 'A Summation of Interest',
                'tags': ['modify', 'talent', 'slowly'],
                'hi_res_image': '/cards/i_n330575_gcg_high_resolution.webp',
                'image': '/cards/i_n330575.webp',
                'golden_image': '/cards/i_n334575.webp',
                'cost': '3 Cryo',
                'description': "Combat Action: When your active character is Charlotte, equip this card. \n\nAfter Charlotte equips this card, immediately use Framing: Freezing Point Composition once. \n\nWhen your Charlotte, who has this card equipped, is on the field, and after any of your characters uses a Normal Attack: If your opponent has a character on the field with Snappy Silhouette attached, heal your active character for 2 HP. (Once per Round) \n\n(You must have Charlotte in your deck to add this card to your deck.)",
                'flavor': "\"Breaking news!\"",
                'required': 'charlotte',
                'id': '9E',
            },

            'terrorfortheevildoers': { 
                'name': 'Terror for the Evildoers',
                'tags': ['modify', 'talent', 'slowly'],
                'hi_res_image': '/cards/i_n330583_gcg_high_resolution.webp',
                'image': '/cards/i_n330583.webp',
                'golden_image': '/cards/i_n334583.webp',
                'cost': '1 Cryo 2 Black',
                'description': "Combat Action: When Wriothesley is your active character, equip this card. \n\nAfter Wriothesley equips this card, immediately use Forceful Fists of Frost once. \n\nWhen Wriothesley, who has this card equipped, takes DMG or is healed, accumulate 1 \"Penalty\" point. \n\nWhen Wriothesley, with this card equipped, uses a Skill: If there are 3 \"Penalty\" points, consume 3 points to cause this Skill to deal +1 DMG. \n\n(You must have Wriothesley in your deck to add this card to your deck.)",
                'flavor': "\"Stay cool and face your guilt!\"",
                'required': 'wrio',
                'id': 'A5',
            },

            "momentofwakingandresolve": {
                'name': "Moment of Waking and Resolve",
                'tags': ['modify', 'talent', 'slowly'],
                'hi_res_image': '/cards/gcg_211121_hd.webp',
                'image': '/cards/gcg_211121.webp',
                'golden_image': '/cards/gcg_211121_golden.webp',
                'cost': '3 Cryo',
                'description': "Combat Action: When your active character is Freminet, equip this card. \n\nAfter Freminet equips this card, immediately use Pressurized Floe once. \n\nAfter your Freminet, who has this card equipped, uses a Skill: Draw 1 card. (Twice per Round) \n\n(You must have Freminet in your deck to add this card to your deck.)",
                'flavor': "\"Going under.\"",
                'required': "freminet",
                'id': 'BE',
            },

            "divineretribution": {
                'name': "Divine Retribution",
                'tags': ['modify', 'talent', 'slowly'],
                'hi_res_image': '/cards/gcg_211131_hd.webp',
                'image': '/cards/gcg_211131.webp',
                'golden_image': '/cards/gcg_211131_golden.webp',
                'cost': '3 Cryo',
                'description': "Combat Action: When your active character is Rosaria, equip this card. \n\nAfter Rosaria equips this card, immediately use Ravaging Confession once. \n\nWhen your Rosaria, who has this card equipped, is on the field: Uses Ravaging Confession, or after you generate Strike Where It Hurts, create 1 Changing Shifts card in your Hand. (Once per Round) \n\n(You must have Rosaria in your deck to add this card to your deck.)",
                'flavor': "\"Lights out...\"",
                'required': "rosaria",
                'id': 'C3',
            },

            "mamaloacosfrigidrain": {
                'name': "Mamaloaco's Frigid Rain",
                'tags': ['modify', 'talent'],
                'hi_res_image': '/cards/gcg_211141_hd.webp',
                'image': '/cards/gcg_211141.webp',
                'golden_image': '/cards/gcg_211141_golden.webp',
                'cost': '2 Cryo',
                'description': "After your opponent takes DMG from Frozen or Melt: +1 to your next 2 instances of Hydro DMG and Pyro DMG dealt, and Citlali gains 1 Nightsoul point. (Once per Round) \n\n(You must have Citlali in your deck to add this card to your deck)",
                'flavor': "\"Citlalin, Itzpapa, get 'em!\"",
                'required': "citlali",
                'id': 'DC',
            },

            "teapartiesburstingwithcolor": {
                'name': "Tea Parties Bursting With Color",
                'tags': ['modify', 'talent', 'slowly'],
                'hi_res_image': '/cards/gcg_211151_hd.webp',
                'image': '/cards/gcg_211151.webp',
                'golden_image': '/cards/gcg_211151_golden.webp',
                'cost': '4 Cryo',
                'description': "Combat Action: When your active character is Escoffier, equip this card. \n\nAfter Escoffier equips this card, immediately use Low-Temperature Cooking once. \n\nWhen your other character uses a Normal Attack: Triggers your Cooking Mek: Cold Storage Mode's End Phase effect. (Its Usages will not decrease, once per Round) \n\n(You must have Escoffier in your deck to add this card to your deck.)",
                'flavor': "The pinnacle of excellence!",
                'required': "escoffier",
                'id': 'EW',
            },

            "fartofall": {
                'name': "Far to Fall",
                'tags': ['modify', 'talent'],
                'hi_res_image': '/cards/gcg_211161_hd.webp',
                'image': '/cards/gcg_211161.webp',
                'golden_image': '/cards/gcg_211161_golden.webp',
                'cost': '1 Cryo',
                'description': "Fast Action: Equip this to your Skirk. \n\nWhen your Skirk has this card equipped and is on the field, when you play or Discard Void Rift: Deal 1 Cryo DMG to the opponent's active character. (Once per Round) \n\n(You must have Skirk in your deck to add this card to your deck.)",
                'flavor': "\"Another star goes out.\"",
                'required': "skirk",
                'id': 'F7',
            },

            "companionscounsel": {
                'name': "Companion's Counsel",
                'tags': ['modify', 'talent', 'slowly'],
                'hi_res_image': '/cards/gcg_211171_hd.webp',
                'image': '/cards/gcg_211171.webp',
                'golden_image': '/cards/gcg_211171_golden.webp',
                'cost': '3 Cryo',
                'description': "Combat Action: When your active character is Mika, equip this card. \n\nAfter Mika equips this card, immediately use Starfrost Swirl once. \n\nWhen your Mika, who has this card equipped, is on the field, triggering Soulwind will cause the next Normal Attack by that character this turn to deal Physical DMG +2 DMG.  \n\n(You must have Mika in your deck to add this card to your deck.)",
                'flavor': "\"Let's keep going, team!\"",
                'required': "mika",
                'id': 'FI',
            },
    
            "gloriousseason": {
                "name": "Glorious Season",
                "tags": ['modify', 'talent', 'slowly'],
                "image": "/cards/i_n330525.webp",
                "golden_image": "/cards/i_n334525.webp",
                "hi_res_image": "/cards/i_n330525_gcg_high_resolution.webp",
                "cost": '3 Hydro',
                "description": "Combat Action: When your active character is Barbara, equip this card. \n\nAfter Barbara equips this card, immediately use Let the Show Begin♪ once. \n\nWhen your Barbara, who has this card equipped, is on the field, Melody Loop will allow you to spend 1 fewer Elemental Die the next time you use \"Switch Character.\" (Once per round) \n\n(You must have Barbara in your deck to add this card to your deck.)",
                "flavor": "Here’s a song for you~",
                "required": "barbara",
                "id": '1G'        
            },
            
            "thescentremained": {
                "name": "The Scent Remained",
                "tags": ['modify', 'talent', 'slowly'],
                "image": "/cards/i_n330504.webp",
                "golden_image": "/cards/i_n334504.webp",
                "hi_res_image": "/cards/i_n330504_gcg_high_resolution.webp",
                "cost": '3 Hydro',
                "description": "Combat Action: When your active character is Xingqiu, equip this card. \n\nAfter Xingqiu equips this card, immediately use Fatal Rainscreen once. \n\nWhen your Xingqiu has this card equipped, the Rain Sword created can block DMG of at least 2 and its starting Usage(s) +1. \n\n(You must have Xingqiu in your deck to add this card to your deck.)",
                "flavor": "His penmanship leaves quite the impression.",
                "required": "xingqiu",
                "id": '0W'        
            },
            
            "prophecyofsubmersion": {
                "name": "Prophecy of Submersion",
                "tags": ['modify', 'talent', 'slowly'],
                "image": "/cards/i_n330505.webp",
                "golden_image": "/cards/i_n334505.webp",
                "hi_res_image": "/cards/i_n330505_gcg_high_resolution.webp",
                "cost": '3 Hydro 3 Energy',
                "description": "Combat Action: When your active character is Mona, equip this card. \n\nWhen Mona equips this card, immediately use Stellaris Phantasm once. \n\nWhen your Mona, who has this card equipped, is the active character, the Hydro-Related Reactions you trigger deal +2 additional DMG. \n\n(You must have Mona in your deck to add this card to your deck.)",
                "flavor": "“Hey! You should be playing that card!”\n“…Well, alright then, do what you want.”",
                "required": "mona",
                "id": '0X'
            },

            "genesisofstarsigns": {
                'name': "Genesis of Starsigns",
                'tags': ['modify', 'talent', 'hexerei', 'slowly'],
                'hi_res_image': '/cards/gcg_212032_hd.webp',
                'image': '/cards/gcg_212032.webp',
                'golden_image': '/cards/gcg_212032_golden.webp',
                'cost': '1 Black 1 Hydro',
                'description': "Combat Action: When your active character is Mona, equip this card. \n\nAfter Mona equips this card, your next Vaporize Reaction deals +2 DMG and immediately use Ripple of Fate once. \n\nWhen Mona uses a Normal Attack, spend 1 fewer Unaligned Element. After the Normal Attack, your next Vaporize Reaction deals +2 DMG. \n\n(You must have Mona in your deck to add this card to your deck.)",
                'flavor': "If the fortune teller in the story truly takes on an apprentice in the future, surely she wouldn't test her in such bizarre, nonsensical ways... Right? Yes, presumably not.",
                'required': "mona",
                'id': 'H2',
            },

            "abyssalmayhemhydrosprout": {
                "name": "Abyssal Mayhem: Hydrospout",
                "tags": ['modify', 'talent', 'slowly'],
                "image": "/cards/i_n330541.webp",
                "golden_image": "/cards/i_n334541.webp",
                "hi_res_image": "/cards/i_n330541_gcg_high_resolution.webp",
                "cost": '3 Hydro',
                "description": "Combat Action: When your active character is Tartaglia, equip this card.\n\nAfter Tartaglia equips this card, immediately use Foul Legacy: Raging Tide once.\n\nEnd Phase: When Tartaglia is on the field and has this card equipped, deal 1 Piercing DMG to the opponent's active character if they have Riptide attached.\n\n(You must have Tartaglia in your deck to add this card to your deck.)",
                "flavor": 'A reckless yet precise blow.',
                'required': 'tartaglia',
                'id': '56'
            },
    
            "tamakushicasket": {
                "name": "Tamakushi Casket",
                "tags": ['modify', 'talent', 'slowly'],
                "image": "/cards/i_n330529.webp",
                "golden_image": "/cards/i_n334531.webp",
                "hi_res_image": "/cards/i_n330529_gcg_high_resolution.webp",
                "cost": '3 Hydro 2 Energy',
                "description": "Combat Action: When your active character is Sangonomiya Kokomi, equip this card. \n\nAfter Sangonomiya Kokomi equips this card, immediately use Nereid's Ascension once. \n\nWhen your Sangonomiya Kokomi, who has this card equipped, uses Nereid's Ascension: Summon a Bake-Kurage with a Usage(s) of 1; if Bake-Kurage is already on the field, then increase its Usage(s) by 1 instead. \n\nWhile Ceremonial Garment exists, Bake-Kurage deals +1 DMG. \n\n(You must have Sangonomiya Kokomi in your deck to add this card to your deck.)",
                "flavor": "Wisdom yet revealed from the casket parallels tides yet unfolded by the sea.",
                "required": "kokomi",
                "id": '4B'
            },
    
            "kyoukafuushi": {
                "name": "Kyouka Fuushi",
                "tags": ['modify', 'talent', 'slowly'],
                "image": "/cards/i_n330538.webp",
                "golden_image": "/cards/i_n334533.webp",
                "hi_res_image": "/cards/i_n330538_gcg_high_resolution.webp",
                "cost": '3 Hydro',
                "description": "Combat Action: When your active character is Kamisato Ayato, equip this card. \n\nAfter Kamisato Ayato equips this card, immediately use Kamisato Art: Kyouka once. \n\nAfter Kamisato Ayato, who has Takimeguri Kanka attached, uses a Normal Attack: The character to which this is attached spends 2 fewer Unaligned Element the next time they use a Normal Attack this Round. (That Normal Attack will not trigger this card's effect) \n\n(You must have Kamisato Ayato in your deck to add this card to your deck.)",
                "flavor": "The courtyard remains fragrant even in the bitterest winter.",
                "required": "ayato",
                "id": '4I'
            },

            "theoverflow": {
                "name": "The Overflow",
                "tags": ['modify', 'talent', 'slowly'],
                "image": "/cards/i_n330549.webp",
                "golden_image": "/cards/i_n334549.webp",
                "hi_res_image": "/cards/i_n330549_gcg_high_resolution.webp",
                "cost": '3 Hydro 2 Energy',
                "description": "Combat Action: When Candace is your active character, equip this card. \n\nAfter Candace equips this card, she will immediately use Sacred Rite: Wagtail's Tide once. \n\nWhen this card is equipped by Candace, her Prayer of the Crimson Crown has the following extra effect: After your character uses a Normal Attack: Deals 1 Hydro DMG. (Once per Round) \n\n(You must have Candace in your deck to add this card to your deck.)",
                "flavor": "Those who do not respect the regulations at cards...\nAre the enemy of all who love the game.",
                "required": "candace",
                "id": '6J'
            },

            "thestarryskiestheirflowersrain": { //needs update
                "name": "The Starry Skies Their Flowers Rain",
                "tags": ['modify', 'talent', 'slowly'],
                "image": "/cards/i_n330557.webp",
                "golden_image": "/cards/i_n334557.webp",
                "hi_res_image": "/cards/i_n330557_gcg_high_resolution.webp",
                "cost": '3 Hydro',
                "description": "Combat Action: When your active character is Nilou, equip this card. \n\nAfter Nilou equips this card, immediately use Dance of Haftkarsvar. \n\nWhen there is Nilou on the field who has this card equipped, the damage dealt by your Bountiful Core is increased by 1. \n\n(You must have Nilou in your deck to add this card to your deck.)",
                "flavor": "Seven heavens, passing like a radiant stream, as though a dream drawn into being.",
                "required": "nilou",
                "id": '7H'
            },

            'turncontrol': { 
                'name': 'Turn Control',
                'tags': ['modify', 'talent', 'slowly'],
                'hi_res_image': '/cards/i_n330561_gcg_high_resolution.webp',
                'image': '/cards/i_n330561.webp',
                'golden_image': '/cards/i_n334561.webp',
                'cost': '3 Hydro',
                'description': "Combat Action: When your active character is Yelan, equip this card. \n\nAfter Yelan equips this card, immediately use Lingering Lifeline once. \n\nRoll Phase: If Yelan, who has this card equipped, is on the field, 1 Elemental Dice will be rolled as Omni Element for each Elemental Type in your party. (Max 3) \n\n(You must have Yelan in your deck to add this card to your deck.)",
                'flavor': "\"Things are about to get dicey.\"",
                'required': 'yelan',
                'id': '81',
            },

            'heirtotheancientseasauthority': { 
                'name': 'Heir to the Ancient Sea\'s Authority',
                'tags': ['modify', 'talent', 'slowly'],
                'hi_res_image': '/cards/i_n330576_gcg_high_resolution.webp',
                'image': '/cards/i_n330576.webp',
                'golden_image': '/cards/i_n334576.webp',
                'cost': '2 Black 1 Hydro',
                'description': "Combat Action: When your active character is Neuvillette, equip this card. \n\nAfter Neuvillette equips this card, immediately use As Water Seeks Equilibrium once. \n\nAfter your characters trigger Hydro-Related Reactions: Neuvillette, who has this card equipped, deals +1 DMG for the next 2 instances. \n\n(You must have Neuvillette in your deck to add this card to your deck.)",
                'flavor': "\"The tides beckon.\"",
                'required': 'neuvillette',
                'id': '9F',
            },

            'furinatalent': { 
                'name': '"Hear Me — Let Us Raise the Chalice of Love!"',
                'tags': ['modify', 'talent', 'slowly'],
                'hi_res_image': '/cards/i_n330584_gcg_high_resolution.webp',
                'image': '/cards/i_n330584.webp',
                'golden_image': '/cards/i_n334584.webp',
                'cost': "3 Hydro",
                'description': "Combat Action: When your active character is Furina, equip this card. \n\nAfter Furina equips this card, immediately use Salon Solitaire once. \n\nWhen Furina, who has this card equipped, uses Salon Solitaire, she will apply Center of Attention to herself. (Normal Attack will trigger different effects depending on state) \n\n(You must have Furina in your deck to add this card to your deck.)",
                'flavor': "\"Let the world come alive, hehe!\"",
                'required': 'furina',
                'id': 'A6',
            },

            "requiresappropriaterest": {
                'name': "Requires Appropriate Rest",
                'tags': ['modify', 'talent', 'slowly'],
                'hi_res_image': '/cards/gcg_212131_hd.webp',
                'image': '/cards/gcg_212131.webp',
                'golden_image': '/cards/gcg_212131_golden.webp',
                'cost': '3 Hydro',
                'description': "Combat Action: When your active character is Sigewinne, equip this card. \n\nAfter Sigewinne equips this card, immediately use Rebound Hydrotherapy once. \n\nAfter your Sigewinne, who has this card equipped, uses Rebound Hydrotherapy: Your next 2 instances of Elemental Skill or Summon DMG deal +1 DMG. \n\n(You must have Sigewinne in your deck to add this card to your deck.)",
                'flavor': "\"Don't be nervous! Just relax.\"",
                'required': "sigewinne",
                'id': 'C4',
            },

            "nightrealmsgiftcrestsandtroughs": {
                'name': "Night Realm's Gift: Crests and Troughs",
                'tags': ['modify', 'talent'],
                'hi_res_image': '/cards/gcg_212141_hd.webp',
                'image': '/cards/gcg_212141.webp',
                'golden_image': '/cards/gcg_212141_golden.webp',
                'cost': '1 Hydro',
                'description': "When Mualani, who has this card equipped, switches to be the \"Active Character\": Trigger the \"End Phase\" effect of a random \"Summon\" on your side. (Once per Round) \n\n(You must have Mualani in your deck to add this card to your deck.)",
                'flavor': "\"Catch an epic wave! Woosh~!\"",
                'required': "mualani",
                'id': 'CE',
            },

            "youshallgooutwithjoy": {
                'name': "You Shall Go Out With Joy",
                'tags': ['modify', 'talent', 'slowly'],
                'hi_res_image': '/cards/gcg_212151_hd.webp',
                'image': '/cards/gcg_212151.webp',
                'golden_image': '/cards/gcg_212151_golden.webp',
                'cost': '3 Hydro 2 Energy',
                'description': "Combat Action: When your active character is Dahlia, equip this card. \n\nAfter Dahlia equips this card, immediately use Radiant Psalter once. \n\nWhen your Dahlia, who has this card equipped, is on the field, and your character is defeated: If you have Favonian Favor on the field, consume all Favonian Favor to grant the character Immunity to Defeat, and heal them to 2 HP. \n\n(You must have Dahlia in your deck to add this card to your deck.)",
                'flavor': "\"May the Archon protect you!\"",
                'required': "dahlia",
                'id': 'FX',
            },

            "theburdenofcreativegenius": {
                'name': "The Burden of Creative Genius",
                'tags': ['modify', 'talent', 'slowly'],
                'hi_res_image': '/cards/gcg_212161_hd.webp',
                'image': '/cards/gcg_212161.webp',
                'golden_image': '/cards/gcg_212161_golden.webp',
                'cost': '3 Hydro 2 Energy',
                'description': "Combat Action: When your active character is Aino, equip this card. \n\nAfter Aino equips this card, immediately use Precision Hydronic Cooler once. \n\nWhen your Aino, who has this card equipped, is on the field, and you trigger an Electro-Charged, Lunar-Charged, Bloom, Lunar-Bloom, Hydro Crystallize, or Lunar-Crystallize reaction: Deal +2 DMG for this instance and attach Empowerment to the 1 card with the highest Current Elemental Dice Cost from your Hand. (Once per Round) \n\n(You must have Aino in your deck to add this card to your deck.)",
                'flavor': "\"Look, a rainbow!\"",
                'required': "aino",
                'id': 'FY',
            },

            "radianceoverblossomsandpeaks": {
                'name': "Radiance Over Blossoms and Peaks",
                'tags': ['modify', 'talent', 'slowly'],
                'hi_res_image': '/cards/gcg_212171_hd.webp',
                'image': '/cards/gcg_212171.webp',
                'golden_image': '/cards/gcg_212171_golden.webp',
                'cost': '3 Hydro',
                'description': "Combat Action: When your active character is Columbina, equip this card. \n\nAfter Columbina equips this card, immediately use Eternal Tides once. \n\nWhile your Columbina with this card equipped is on the field, after the opponent is affected by Lunar-Charged: One of your characters without maximum Energy gains 1 Energy. \n\nAfter the opponent is affected by Lunar-Bloom: Your active character takes 1 less DMG the next time they take DMG. \n\nAfter the opponent is affected by Lunar-Crystallize: Automatically play the Moondrift Harmony with the highest Current Elemental Dice Cost from your Hand for free. (Twice per Round) \n\n(You must have Columbina in your deck to add this card to your deck.)",
                'flavor': "\"A moonlit night for all.\"",
                'required': "columbina",
                'id': 'HA',
            },
            
            "flowingflame": {
                "name": "Flowing Flame",
                "tags": ['modify', 'talent', 'slowly'],
                "image": "/cards/i_n330506.webp",
                "golden_image": "/cards/i_n334506.webp",
                "hi_res_image": "/cards/i_n330506_gcg_high_resolution.webp",
                "cost": '3 Pyro',
                "description": "Combat Action: When your active character is Diluc, equip this card. \n\nAfter Diluc equips this card, immediately use Searing Onslaught once. \n\nWhen your Diluc, who has this card equipped, uses Searing Onslaught for the second and third times in one Round, spend 1 less Pyro Die. \n\n(You must have Diluc in your deck to add this card to your deck.)",
                "flavor": "A simple way out of perilous situations.",
                "required": "diluc",
                "id": '0Y'        
            },
            
            "crossfire": {
                "name": "Crossfire",
                "tags": ['modify', 'talent', 'slowly'],
                "image": "/cards/i_n330507.webp",
                "golden_image": "/cards/i_n334507.webp",
                "hi_res_image": "/cards/i_n330507_gcg_high_resolution.webp",
                "cost": '3 Pyro',
                "description": "'Combat Action': When your active character is Xiangling, equip this card.\n\nAfter Xiangling equips this card, immediately use 'Elemental Skill: Guoba Attack' once.\n\nWhen your Xiangling, who has this card equipped, uses 'Elemental Skill: Guoba Attack', she will also deal 1 'Pyro DMG'.\n\n(You must have Xiangling in your deck to add this card to your deck.)",
                "flavor": "This heat’s just normal for a restaurant’s standards!",
                "required": "xiangling",
                "id": '0Z'        
            },
            
            "grandexpectation": {
                "name": "Grand Expectation",
                "tags": ['modify', 'talent', 'slowly'],
                "image": "/cards/i_n330508.webp",
                "golden_image": "/cards/i_n334508.webp",
                "hi_res_image": "/cards/i_n330508_gcg_high_resolution.webp",
                "cost": '4 Pyro 2 Energy',
                "description": "'Combat Action': When your active character is Bennett, equip this card.\n\nAfter Bennett equips this card, immediately use 'Elemental Burst: Fantastic Voyage' once.\n\nWhen your Bennett, who has this card equipped, creates an 'Inspiration Field', its DMG Bonus is now always active and will no longer have an HP restriction.\n\n(You must have Bennett in your deck to add this card to your deck.)",
                "flavor": "The best adventure is always yet to be.",
                "required": "bennett",
                "id": '10'        
            },
    
            "bunnytriggered": {
                "name": "Bunny Triggered",
                "tags": ['modify', 'talent', 'slowly'],
                "image": "/cards/i_n330509.webp",
                "golden_image": "/cards/i_n334509.webp",
                "hi_res_image": "/cards/i_n330509_gcg_high_resolution.webp",
                "cost": '3 Pyro',
                "description": "Combat Action: When your active character is Amber, equip this card. \n\nAfter Amber equips this card, immediately use Explosive Puppet once. \n\nAfter you use a Normal Attack: If this card and Baron Bunny are still on the field, then Baron Bunny explodes and deals 4 Pyro DMG. \n\n(You must have Amber in your deck to add this card to your deck.)",
                "flavor": '"Go go Baron Bunny!"',
                "required": "amber",
                'id': '50'
            },
            
            "naganoharameteorswarm": {
                "name": "Naganohara Meteor Swarm",
                "tags": ['modify', 'talent', 'slowly'],
                "image": "/cards/i_n330510.webp",
                "golden_image": "/cards/i_n334510.webp",
                "hi_res_image": "/cards/i_n330510_gcg_high_resolution.webp",
                "cost": "1 Pyro",
                "description": "Combat Action: When your active character is Yoimiya, equip this card. \n\nAfter Yoimiya equips this card, immediately use Niwabi Fire-Dance once. \n\nAfter the Niwabi Enshou created by your Yoimiya, who has this card equipped, triggers: Deal 1 additional Pyro DMG. \n\n(You must have Yoimiya in your deck to add this card to your deck.)",
                "flavor": "Naganohara Ideal Firework Reserve Theory.",
                "required": "yoimiya",
                "id": '11'        
            },
    
            "poundingsurprise": {
                "name": "Pounding Surprise",
                "tags": ['modify', 'talent', 'slowly'],
                "image": "/cards/i_n330530.webp",
                "golden_image": "/cards/i_n334529.webp",
                "hi_res_image": "/cards/i_n330530_gcg_high_resolution.webp",
                "cost": '3 Pyro',
                "description": "'Combat Action': When your active character is Klee, equip this card.\n\nAfter Klee equips this card, immediately use 'Elemental Skill: Jumpy Dumpty' once.\n\nWhen your Klee, who has this card equipped, creates an 'Explosive Spark', its Usage(s) +1.\n\n(You must have Klee in your deck to add this card to your deck.)",
                "flavor": "Let out a good laugh when you draw this card!",
                "required": "klee",
                "id": '45'     
            },

            "sparkbornemagic": {
                'name': "Sparkborne Magic",
                'tags': ['modify', 'talent', 'hexerei'],
                'hi_res_image': '/cards/gcg_213062_hd.webp',
                'image': '/cards/gcg_213062.webp',
                'golden_image': '/cards/gcg_213062_golden.webp',
                'cost': '1 Pyro',
                'description': "Fast Action: Equip this to your Klee. \n\nAttach Explosive Spark to Klee. \n\nWhen the attached character uses a Charged Attack: Deals 2 Pyro DMG. (Twice per Round) \n\n(You must have Klee in your deck to add this card to your deck.)",
                'flavor': "\"And just like that, the cutest little Dodo-Sorcerer passed her qualification exam with the help of her friends. Now she's a real, full-fledged Dodo-Sorcerer! Congratulations!\"\n\"Wait, weren't we supposed to be writing commentary? What does any of this have to do with the little witch!?\"",
                'required': "klee",
                'id': 'H3',
            },
    
            "sanguinerouge": {
                "name": "Sanguine Rouge",
                "tags": ['modify', 'talent', 'slowly'],
                "image": "/cards/i_n330542.webp",
                "golden_image": "/cards/i_n334542.webp",
                "hi_res_image": "/cards/i_n330542_gcg_high_resolution.webp",
                "cost": '2 Pyro',
                "description": "Combat Action: When your active character is Hu Tao, equip this card. \n\nAfter Hu Tao equips this card, immediately use Guide to Afterlife once. \n\nWhen your Hu Tao, who has this card equipped, has no more than 6 HP: Deal +1 Pyro DMG. \n\n(You must have Hu Tao in your deck to add this card to your deck.)",
                "flavor": 'Director Hu needs a bit more firepower to settle certain unique affairs.',
                'required': 'hutao',
                'id': '57'
            },

            "rightoffinalinterpretation": {
                "name": "Right of Final Interpretation",
                "tags": ['modify', 'talent', 'slowly'],
                "image": "/cards/i_n330550.webp",
                "golden_image": "/cards/i_n334550.webp",
                "hi_res_image": "/cards/i_n330550_gcg_high_resolution.webp",
                "cost": '2 Black 1 Pyro',
                "description": "Combat Action: When Yanfei is your active character, equip this card. \n\nAfter Yanfei equips this card, she will immediately use Seal of Approval once. \n\nWhen Yanfei uses a Charged Attack with this card equipped: Deal +1 DMG to enemies with 6 or less HP. If Scarlet Seal is triggered, then draw 1 card after the skill finishes calculating. \n\n(You must have Yanfei in your deck to add this card to your deck.)",
                "flavor": '"When it comes to cards... Well, anything is permissible, so long as the rules don\'t forbid it."',
                'required': 'yanfei',
                'id': '6K'
            },

            "stalwartandtrue": {
                "name": "Stalwart and True",
                "tags": ['modify', 'talent', 'slowly'],
                "image": "/cards/i_n330554.webp",
                "golden_image": "/cards/i_n334554.webp",
                "hi_res_image": "/cards/i_n330554_gcg_high_resolution.webp",
                "cost": '4 Pyro',
                "description": "Combat Action: When your active character is Dehya, equip this card.\n\nAfter Dehya equips this card, immediately use Molten Inferno once.\n\nEnd Phase: If your Dehya, who has this card equipped, has no more than 6 HP, heal that character for 2HP.\n\n(You must have Dehya in your deck to add this card to your deck.)",
                "flavor": "\"Don't hold back, let's go!\"",
                'required': 'dehya',
                'id': '75'
            },
            

            'conclusiveovation': { 
                'name': 'Conclusive Ovation',
                'tags': ['modify', 'talent', 'slowly'],
                'hi_res_image': '/cards/i_n330562_gcg_high_resolution.webp',
                'image': '/cards/i_n330562.webp',
                'golden_image': '/cards/i_n334562.webp',
                'cost': '3 Pyro',
                'description': "Combat Action: When your active character is Lyney, equip this card. \n\nAfter Lyney equips this card, immediately use Prop Arrow. \n\nWhen Lyney is on the field and has this card equipped, the DMG dealt by Lyney and your Grin-Malkin Hat will deal +2 DMG to characters affected by Pyro. (Once per Round) \n\n(You must have Lyney in your deck to add this card to your deck.)",
                'flavor': "\"A round of applause!\"",
                'required': 'lyney',
                'id': '82',
            },

            'asubordinate\'sskills': { 
                'name': 'A Subordinate\'s Skills',
                'tags': ['modify', 'talent', 'slowly'],
                'hi_res_image': '/cards/i_n330571_gcg_high_resolution.webp',
                'image': '/cards/i_n330571.webp',
                'golden_image': '/cards/i_n334571.webp',
                'cost': '3 Pyro 2 Energy',
                'description': "Combat Action: When your active character is Thoma, equip this card. \n\nAfter Thoma equips this card, immediately use Crimson Ooyoroi once. \n\nWhen your Thoma, who has this card equipped, creates a Scorching Ooyoroi, its starting Usage(s) +1. \n\n(You must have Thoma in your deck to add this card to your deck.)",
                'flavor': "\"It looks like I'm responsible for another smile.\"",
                'required': 'thoma',
                'id': '8Z',
            },

            'Rockin\'inaFlamingWorld': { 
                'name': 'Rockin\' in a Flaming World',
                'tags': ['modify', 'talent', 'slowly'],
                'hi_res_image': '/cards/i_n330585_gcg_high_resolution.webp',
                'image': '/cards/i_n330585.webp',
                'golden_image': '/cards/i_n334585.webp',
                'cost': '1 Pyro 2 Black',
                'description': "Combat Action: When your active character is Xinyan, equip this card. \n\nAfter Xinyan equips this card, immediately use Dance on Fire. \n\nWhen Xinyan, who has this card equipped, uses a Skill: If you have no more than 1 card in your Hand, deal +2 DMG. (Once per Round) \n\n(You must have Xinyan in your deck to add this card to your deck.)",
                'flavor': "\"Amp it up!\"",
                'required': 'xinyan',
                'id': 'A7',
            },

            "vanguardscoordinatedtactics": {
                'name': "Vanguard's Coordinated Tactics",
                'tags': ['modify', 'talent'],
                'hi_res_image': '/cards/gcg_213131_hd.webp',
                'image': '/cards/gcg_213131.webp',
                'golden_image': '/cards/gcg_213131_golden.webp',
                'cost': '2 Pyro',
                'description': "You can only play this card if your party consists of only Pyro and Electro characters: Equip this card to Chevreuse. \n\nWhen Chevreuse, who has this card equipped, is in play, and after opposing characters take Overloaded reaction DMG: Your next 2 instances of Pyro DMG or Electro DMG dealt +1. (Including Pyro DMG or Electro DMG dealt through Swirl reactions) \n\n(You must have Chevreuse in your deck to add this card to your deck)",
                'flavor': "\"The Special Security and Surveillance Patrol deals with a whole host of heinous crimes and dangerous criminals. As such, the methods we employ to enforce the law can be a bit on the... harsher side.\"",
                'required': "chevreuse",
                'id': 'B2',
            },

            "allreprisalsandarrearsminetobear": {
                'name': "All Reprisals and Arrears, Mine to Bear",
                'tags': ['modify', 'talent', 'slowly'],
                'hi_res_image': '/cards/gcg_213141_hd.webp',
                'image': '/cards/gcg_213141.webp',
                'golden_image': '/cards/gcg_213141_golden.webp',
                'cost': '1 Pyro',
                'description': "Combat Action: When your active character is Arlecchino, play this card on them. Attach 3 stacks of Bond of Life to Arlecchino. \n\nWhen your Arlecchino, who has this card equipped, takes DMG: If Arlecchino has Bond of Life attached, consume 1 stack of Bond of Life and negate 1 DMG. \n\n(You must have Arlecchino in your deck to add this card to your deck.)",
                'flavor': "\"Everlasting as the moon.\"",
                'required': "arlecchino",
                'id': 'CO',
            },

            "humanitysnameunfettered": {
                'name': "\"Humanity's Name\" Unfettered",
                'tags': ['modify', 'talent'],
                'hi_res_image': '/cards/gcg_213151_hd.webp',
                'image': '/cards/gcg_213151.webp',
                'golden_image': '/cards/gcg_213151_golden.webp',
                'cost': '1 Pyro',
                'description': "Select 1 card from 3 Flamestrider cards to add to your Hand. \n\nAfter you play a Technique card: If possible, Mavuika recovers 1 Nightsoul point. (Once per Round) \n\n(You must have Mavuika in your deck to add this card to your deck)",
                'flavor': "\"Light of the blazing sun!\"",
                'required': "mavuika",
                'id': 'DD',
            },

            "bringerofblessing": {
                'name': "Bringer of Blessing",
                'tags': ['modify', 'talent', 'slowly'],
                'hi_res_image': '/cards/gcg_213161_hd.webp',
                'image': '/cards/gcg_213161.webp',
                'golden_image': '/cards/gcg_213161_golden.webp',
                'cost': '3 Pyro 3 Energy',
                'description': "Combat Action: When your active character is Gaming, equip this card. \n\nAfter Gaming equips this card, immediately use Suanni's Gilded Dance once. \n\nWhen the attached character uses a Plunging Attack: Deals an additional +1 DMG. \n\nWhen the attached character uses an Elemental Skill: Heal the attached character for 2 HP. (Once per Round) \n\n(You must have Gaming in your deck to add this card to your deck.)",
                'flavor': "\"Hop to it, Man Chai!\"",
                'required': "gaming",
                'id': 'EX',
            },

            "adamahsredemption": {
                'name': "Adamah's Redemption",
                'tags': ['modify', 'talent', 'slowly'],
                'hi_res_image': '/cards/gcg_213171_hd.webp',
                'image': '/cards/gcg_213171.webp',
                'golden_image': '/cards/gcg_213171_golden.webp',
                'cost': '4 Pyro 2 Energy',
                'description': "Combat Action: When your active character is Durin, equip this card. \n\nAfter Durin equips this card, immediately use Principle of Purity: As the Light Shifts or Principle of Darkness: As the Stars Smolder once based on the character's current Elemental Burst. \n\nWhen the character to which this is attached uses Principle of Purity: As the Light Shifts: Your next 4 instances of DMG gain +1. \n\nWhen the character to which this is attached uses Principle of Darkness: As the Stars Smolder: Your Durin and Denial of Darkness deal +2 DMG. \n\n(You must have Durin in your deck to add this card to your deck.)",
                'flavor': "\"A turning point in fate.\"",
                'required': "durin",
                'id': 'GZ',
            },
            
            "stellarpredator": {
                "name": "Stellar Predator",
                "tags": ['modify', 'talent', 'slowly'],
                "image": "/cards/i_n330511.webp",
                "golden_image": "/cards/i_n334511.webp",
                "hi_res_image": "/cards/i_n330511_gcg_high_resolution.webp",
                "cost": '3 Electro',
                "description": "Combat Action: When your active character is Fischl, equip this card. \n\nAfter Fischl equips this card, immediately use Nightrider once. \n\nWhen your Fischl, who has this card equipped, creates an Oz, Oz will gain the following effect: after Fischl uses a Normal Attack: Deal 2 Electro DMG. (Consumes Usage(s)) \n\n(You must have Fischl in your deck to add this card to your deck.)",
                "flavor": "“The instant in which Ozvaldo Hrafnavins shows his great might.”",
                "required": "fischl",
                "id": '12'        
            },

            "phantasmalnocturne": {
                'name': "Phantasmal Nocturne",
                'tags': ['modify', 'talent', 'hexerei'],
                'hi_res_image': '/cards/gcg_214012_hd.webp',
                'image': '/cards/gcg_214012.webp',
                'golden_image': '/cards/gcg_214012_golden.webp',
                'cost': '2 Electro',
                'description': "Fast Action: Equip this to your Fischl. \n\nSummon Oz. \n\nWhile Oz is on the field, your Electro-Related Reactions deals +1 DMG. (3 times per Round) \n\n(You must have Fischl in your deck to add this card to your deck.)",
                'flavor': "\"Still, while every question is unexpected, some are definitely more unexpected than others. For instance, one little witch might be asked to use the primordial light to create her own material world. Meanwhile, another might be told to grant a 'soul' to a being that only exists in the imagination.\"",
                'required': "fischl",
                'id': 'H4',
            },
            
            "awakening": {
                "name": "Awakening",
                "tags": ['modify', 'talent', 'slowly'],
                "image": "/cards/i_n330512.webp",
                "golden_image": "/cards/i_n334512.webp",
                "hi_res_image": "/cards/i_n330512_gcg_high_resolution.webp",
                "cost": '3 Electro',
                "description": "Combat Action: When your active character is Razor, equip this card. \n\nAfter Razor equips this card, immediately use Claw and Thunder once. \n\nAfter your Razor, who has this card equipped, uses Claw and Thunder: One of your Electro characters gains 1 Energy. (One per Round, active character prioritized) \n\n(You must have Razor in your deck to add this card to your deck.)",
                "flavor": "The hunt is about to begin.",
                "required": "razor",
                "id": '13'        
            },

            "surgeoflightning": {
                'name': "Surge of Lightning",
                'tags': ['modify', 'talent', 'hexerei', 'slowly'],
                'hi_res_image': '/cards/gcg_214022_hd.webp',
                'image': '/cards/gcg_214022.webp',
                'golden_image': '/cards/gcg_214022_golden.webp',
                'cost': '2 Electro',
                'description': "Combat Action: When your active character is Razor, equip this card. \n\nIf your Razor does not have The Wolf Within attached, attach The Wolf Within with 1 Duration. \n\nWhile your Razor has The Wolf Within attached with this card equipped, DMG dealt by your The Wolf Within is increased by 1. \n\n(You must have Razor in your deck to add this card to your deck.)",
                'flavor': "\"Through the long years, the immortal witch has lost more than she can ever count. This is no exaggeration, for nothing in this world, once lost, can truly be found again. In distant worlds, even children raised together by wolves would one day bare their fangs at each other. But at least here in this world, the wolves' child may still find the warmth of home.\"",
                'required': "razor",
                'id': 'HB',
            },
            
            "thunderingpenance": {
                "name": "Thundering Penance",
                "tags": ['modify', 'talent', 'slowly'],
                "image": "/cards/i_n330513.webp",
                "golden_image": "/cards/i_n334513.webp",
                "hi_res_image": "/cards/i_n330513_gcg_high_resolution.webp",
                "cost": '3 Electro',
                "description": "Combat Action: When your active character is Keqing, equip this card. \n\nAfter Keqing equips this card, immediately use Stellar Restoration once. \n\nWhen your Keqing, who has this card equipped, creates an Electro Elemental Infusion, it will have the following effects: \n\nStarting Duration (Rounds) +1, Electro DMG dealt by the character to which this is attached +1. \n\n(You must have Keqing in your deck to add this card to your deck.)",
                "flavor": "As long as you’re not actually cheating, this is just the name of a card.",
                "required": "keqing",
                "id": '14'        
            },
    
            "featherfalljudgment": {
                "name": "Featherfall Judgment",
                "tags": ['modify', 'talent', 'slowly'],
                "image": "/cards/i_n330524.webp",
                "golden_image": "/cards/i_n334524.webp",
                "hi_res_image": "/cards/i_n330524_gcg_high_resolution.webp",
                "cost": '3 Electro',
                "description": "Combat Action: When your active character is Cyno, equip this card. \n\nAfter Cyno equips this card, immediately use Secret Rite: Chasmic Soulfarer once. \n\nWhen your Cyno, who has this card equipped, uses Secret Rite: Chasmic Soulfarer while having at least 2 levels of Pactsworn Pathclearer's Indwelling effect, DMG dealt by Secret Rite: Chasmic Soulfarer +1. (Max twice per Round) \n\n(You must have Cyno in your deck to add this card to your deck.)",
                "flavor": "“This is my duel soul.”",
                "required": "cyno",
                "id": '1F'        
            },
    
            "lightningstorm": {
                "name": "Lightning Storm",
                "tags": ['modify', 'talent', 'slowly'],
                "image": "/cards/i_n330531.webp",
                "golden_image": "/cards/i_n334528.webp",
                "hi_res_image": "/cards/i_n330531_gcg_high_resolution.webp",
                "cost": '3 Electro',
                "description": "Combat Action: When your active character is Beidou, equip this card. \n\nAfter Beidou equips this card, immediately use Tidecaller once. \n\nAfter Beidou, who has this card equipped, uses Wavestrider: Beidou's Normal Attacks this Round will cost 1 less Unaligned Element. (Can be triggered 2 times) \n\n(You must have Beidou in your deck to add this card to your deck.)",
                "flavor": "Rumbling thunder goes well with lightning storms!",
                "required": "beidou",
                "id": '46'     
            },
    
            "sinofpride": {
                "name": "Sin of Pride",
                "tags": ['modify', 'talent', 'slowly'],
                "image": "/cards/i_n330537.webp",
                "golden_image": "/cards/i_n334532.webp",
                "hi_res_image": "/cards/i_n330537_gcg_high_resolution.webp",
                "cost": '3 Electro',
                "description": "Combat Action: When your active character is Kujou Sara, equip this card. \n\nAfter Kujou Sara equips this card, immediately use Tengu Stormcall once. \n\nWhen Kujou Sara is active and has this card equipped, all allied characters with Crowfeather Cover will deal +1 additional Elemental Skill and Elemental Burst DMG. \n\n(You must have Kujou Sara in your deck to add this card to your deck.)",
                "flavor": "“With this unity between my mind, arrow, and bow, any enemy will be struck down!”",
                "required": "sara",
                "id": '4C' 
            },
    
            "wishesunnumbered": {
                "name": "Wishes Unnumbered",
                "tags": ['modify', 'talent', 'slowly'],
                "image": "/cards/i_n330543.webp",
                "golden_image": "/cards/i_n334543.webp",
                "hi_res_image": "/cards/i_n330543_gcg_high_resolution.webp",
                "cost": "3 Electro 2 Energy",
                "description": "Combat Action: When your active character is Raiden Shogun, equip this card.\n\nAfter Raiden Shogun equips this card, immediately use Secret Art: Musou Shinsetsu once.\n\nWhen your Raiden Shogun, who has this card equipped, uses Secret Art: Musou Shinsetsu, it will deal +1 additional DMG for every point of Resolve consumed.\n\n(You must have Raiden Shogun in your deck to add this card to your deck.)",
                "flavor": "Shine down, baleful omen!",
                'required': 'raiden',
                'id': '58'
            },
    
            "theshrinessacredshade": {
                "name": "The Shrine's Sacred Shade",
                "tags": ['modify', 'talent', 'slowly'],
                "image": "/cards/i_n330544.webp",
                "golden_image": "/cards/i_n334544.webp",
                "hi_res_image": "/cards/i_n330544_gcg_high_resolution.webp",
                "cost": '3 Electro 2 Energy',
                "description": "Combat Action: When your active character is Yae Miko, equip this card. \n\nAfter Yae Miko equips this card, immediately use Great Secret Art: Tenko Kenshin once. \n\nAfter your Yae Miko, who has this card equipped, destroys a Sesshou Sakura through Great Secret Art: Tenko Kenshin: The next use of Yakan Evocation: Sesshou Sakura this Round will cost 2 fewer Elemental Dice. \n\n(You must have Yae Miko in your deck to add this card to your deck.)",
                "flavor": '"Ah... A sight to behold..."',
                'required': 'yae',
                'id': '59'
            },

            "pulsatingwitch": {
                "name": "Pulsating Witch",
                "tags": ['modify', 'talent'],
                "image": "/cards/i_n330553.webp",
                "golden_image": "/cards/i_n334553.webp",
                "hi_res_image": "/cards/i_n330553_gcg_high_resolution.webp",
                "cost": '1 Electro',
                "description": "After you switch to Lisa, who has this card equipped: Attach Conductive to the opposing active character. (Once per Round) \n\n(You must have Lisa in your deck to add this card to your deck.)",
                "flavor": 'As a Librarian who has read through tens of thousands of volumes, of course it\'s trivial for me to remember how to win...',
                'required': 'lisa',
                'id': '6W'
            },

            "discretionarysupplement": {
                "name": "Discretionary Supplement",
                "tags": ['modify', 'talent', 'slowly'],
                "image": "/cards/i_n330558.webp",
                "golden_image": "/cards/i_n334558.webp",
                "hi_res_image": "/cards/i_n330558_gcg_high_resolution.webp",
                "cost": '3 Electro 2 Energy',
                "description": "Combat Action: When your active character is Dori, equip this card. \n\nAfter Dori equips this card, immediately use Alcazarzaray's Exactitude once. \n\nThe Jinni summoned by your Dori who has this card equipped heals 1 more HP when healing characters with no more than 6 HP, and increases the amount of Energy gained by characters with no Energy by 1 when Energy is gained. \n\n(You must have Dori in your deck to add this card to your deck)",
                "flavor": "\"First raise the price by 30%, then sell at a 20% discount!\"",
                'required': 'dori',
                'id': '7I'
            },

            "towardweakness": {
                "name": "To Ward Weakness",
                "tags": ['modify', 'talent', 'slowly'],
                "image": "/cards/i_n330579.webp",
                "golden_image": "/cards/i_n334579.webp",
                "hi_res_image": "/cards/i_n330579_gcg_high_resolution.webp",
                "cost": "4 Electro 2 Energy",
                "description": "Combat Action: When your active character is Kuki Shinobu, equip this card. \n\nAfter Kuki Shinobu equips this card, immediately use Gyoei Narukami Kariyama Rite once. \n\nWhen Kuki Shinobu, who has this card equipped, is defeated, she will not be defeated but will instead heal herself to 1 HP. (Once per Round) \n\nIf Kuki Shinobu, who has this card equipped, does not have more than 5 HP, deal +1 DMG. \n\n(You must have Kuki Shinobu in your deck to add this card to your deck.)",
                "flavor": '"Lightning... purifies!"',
                'required': 'kuki',
                'id': 'A1'
            },

            "darkshatteringflame": {
                'name': "Dark-Shattering Flame",
                'tags': ['modify', 'talent', 'slowly'],
                'hi_res_image': '/cards/gcg_214121_hd.webp',
                'image': '/cards/gcg_214121.webp',
                'golden_image': '/cards/gcg_214121_golden.webp',
                'cost': '2 Electro',
                'description': "Combat Action: When your active character is Clorinde, equip this card. \n\nAfter Clorinde equips this card, immediately use Hunter's Vigil once. \n\nAfter your characters trigger Electro-Related Reactions, +1 to the next instance of DMG Clorinde deals this Round. (Up to 3 stacks, +3 DMG total) \n\n(You must have Clorinde in your deck to add this card to your deck.)",
                'flavor': "\"Where evil lurks, shoot on sight!\"",
                'required': "clorinde",
                'id': 'CF',
            },

            "pylonofthesojourningsuntemple": {
                'name': "Pylon of the Sojourning Sun Temple",
                'tags': ['modify', 'talent'],
                'hi_res_image': '/cards/gcg_214131_hd.webp',
                'image': '/cards/gcg_214131.webp',
                'golden_image': '/cards/gcg_214131_golden.webp',
                'cost': '1 Electro',
                'description': "Your Sethos gains 1 Energy. \n\nAfter your Sethos loses Energy due to Black Kite's Enigma, gain 1 Energy. (Once per Round) \n\n(You must have Sethos in your deck to add this card to your deck.)",
                'flavor': "\"Glory to Al-Ahmar!\"",
                'required': "sethos",
                'id': 'D3',
            },

            "teachingsofthecollectiveofplenty": {
                'name': "Teachings of the Collective of Plenty",
                'tags': ['modify', 'talent', 'slowly'],
                'hi_res_image': '/cards/gcg_214141_hd.webp',
                'image': '/cards/gcg_214141.webp',
                'golden_image': '/cards/gcg_214141_golden.webp',
                'cost': '3 Electro 2 Energy',
                'description': "Combat Action: When your active character is Iansan, equip this card. \n\nAfter Iansan equips this card, immediately use The Three Principles of Power once. \n\nWhen your Iansan, who has this card equipped, creates a Kinetic Energy Scale, its starting Usage(s) +1. \n\n(You must have Iansan in your deck to add this card to your deck.)",
                'flavor': "\"On my mark!\"",
                'required': "iansan",
                'id': 'E5',
            },

            "aheroofjusticestriumph": {
                'name': "A Hero of Justice's Triumph",
                'tags': ['modify', 'talent'],
                'hi_res_image': '/cards/gcg_214151_hd.webp',
                'image': '/cards/gcg_214151.webp',
                'golden_image': '/cards/gcg_214151_golden.webp',
                'cost': '1 Electro',
                'description': "Fast Action: Equip this to your Varesa. \n\nAfter Varesa triggers Tag-Team Triple Jump!: Gain 1 Energy. \n\nElemental Bursts from Varesa, who has this card equipped, deal +1 DMG. \n\n(You must have Varesa in your deck to add this card to your deck.)",
                'flavor': "\"Ultimate flying kick!\"",
                'required': "varesa",
                'id': 'EK',
            },

            "trailsamidsttheforestfog": {
                'name': "Trails Amidst the Forest Fog",
                'tags': ['modify', 'talent'],
                'hi_res_image': '/cards/gcg_214161_hd.webp',
                'image': '/cards/gcg_214161.webp',
                'golden_image': '/cards/gcg_214161_golden.webp',
                'cost': '1 Electro',
                'description': "Fast Action: Equip this to your Ororon. \n\nThe first Electro-Charged reaction you trigger each Round deals +1 Piercing DMG. \n\n(You must have Ororon in your deck to add this card to your deck.)",
                'flavor': "\"Go, you're free now.\"",
                'required': "ororon",
                'id': 'F8',
            },

            "rectifyingprocessor": {
                'name': "Rectifying Processor",
                'tags': ['modify', 'talent'],
                'hi_res_image': '/cards/gcg_214171_hd.webp',
                'image': '/cards/gcg_214171.webp',
                'golden_image': '/cards/gcg_214171_golden.webp',
                'cost': '1 Electro',
                'description': "Fast Action: Equip this to your Ineffa. \n\nApply Electric Shock to 1 random card in your opponent's Hand, then repeat once. \n\nAfter you trigger a Lunar-Charged reaction: Apply Cost Increase to 1 random card in your opponent's Hand. \n\n(You must have Ineffa in your deck to add this card to your deck.)",
                'flavor': "\"Ultimatum protocol.\"",
                'required': "ineffa",
                'id': 'FJ',
            },

            "parttheveilofsnow": {
                'name': "Part the Veil of Snow",
                'tags': ['modify', 'talent'],
                'hi_res_image': '/cards/gcg_214181_hd.webp',
                'image': '/cards/gcg_214181.webp',
                'golden_image': '/cards/gcg_214181_golden.webp',
                'cost': '1 Electro',
                'description': "Fast Action: Equip this to your Flins. \n\nFlins gains 1 Energy. \n\nAfter you trigger a Lunar-Charged reaction: Flins gains 1 Energy. (Once per Round) \n\n(You must have Flins in your deck to add this card to your deck)",
                'flavor': "\"The long sleep beckons.\"",
                'required': "flins",
                'id': 'GB',
            },
            
            "chaoticentropy": {
                "name": "Chaotic Entropy",
                "tags": ['modify', 'talent', 'slowly'],
                "image": "/cards/i_n330514.webp",
                "golden_image": "/cards/i_n334514.webp",
                "hi_res_image": "/cards/i_n330514_gcg_high_resolution.webp",
                "cost": '3 Anemo 2 Energy',
                "description": "Combat Action: When your active character is Sucrose, equip this card. \n\nAfter Sucrose equips this card, immediately use Forbidden Creation - Isomer 75 / Type II once. \n\nAfter the Large Wind Spirit created by your Sucrose, who had this card equipped, has converted to another Elemental Type: Deal +1 DMG of this Elemental Type. \n\n(You must have Sucrose in your deck to add this card to your deck.)",
                "flavor": "The wild winds gather — and amidst the chaos, victory.",
                "required": "sucrose",
                "id": '15'        
            },

            "sevenfoldtransmutation": {
                'name': "Sevenfold Transmutation",
                'tags': ['modify', 'talent', 'hexerei'],
                'hi_res_image': '/cards/gcg_215012_hd.webp',
                'image': '/cards/gcg_215012.webp',
                'golden_image': '/cards/gcg_215012_golden.webp',
                'cost': '3 Anemo',
                'description': "Fast Action: Equip this to your Sucrose. \n\nSummon Large Wind Spirit. \n\nWhile Large Wind Spirit is on the field, characters on your side with  Talent attached deal +1 DMG. \n\n(You must have Sucrose in your deck to add this card to your deck.)",
                'flavor': "\"Reproducibility is the cornerstone of any experiment. That's why the 'Mimic Demon King' mentioned in the third volume of the original work is, honestly... rather unsound. A single experiment can't prove that the swarm intelligence of the mold falls below standard expectations, and the rules about changes after inhaling the spore dust were never clearly defined. I must have been completely out of my mind at the time. Please, don't follow my example...\"",
                'required': "sucrose",
                'id': 'HC',
            },
            
            "landsofdandelion": {
                "name": "Lands of Dandelion",
                "tags": ['modify', 'talent', 'slowly'],
                "image": "/cards/i_n330515.webp",
                "golden_image": "/cards/i_n334515.webp",
                "hi_res_image": "/cards/i_n330515_gcg_high_resolution.webp",
                "cost": '4 Anemo 2 Energy',
                "description": "'Combat Action': When your active character is Jean, equip this card.\n\nAfter Jean equips this card, immediately use 'Elemental Burst: Dandelion Breeze' once.\n\nWhen your Jean, who has this card equipped, is on the field, 'Dandelion Field' will cause you to deal +1 'Anemo DMG'.\n\n(You must have Jean in your deck to add this card to your deck.)",
                "flavor": "“Wind, hear me!”",
                "required": "jean",
                "id": '16'        
            },
    
            "embraceofwinds": {
                "name": "Embrace of Winds",
                "tags": ['modify', 'talent', 'slowly'],
                "image": "/cards/i_n330532.webp",
                "golden_image": "/cards/i_n334536.webp",
                "hi_res_image": "/cards/i_n330532_gcg_high_resolution.webp",
                "cost": '3 Anemo',
                "description": "Combat Action: When your active character is Venti, equip this card. \n\nAfter Venti equips this card, immediately use Skyward Sonnet once. \n\nAfter a Stormzone created by your Venti, who has this card equipped, is triggered, the next Normal Attack performed by your character in this Round will cost 1 less Unaligned Element. \n\n(You must have Venti in your deck to add this card to your deck.)",
                "flavor": '"Watch your step."',
                'required': 'venti',
                'id': '51'
            },

            "temporalwindseulogy": {
                'name': "Temporal Wind's Eulogy",
                'tags': ['modify', 'talent', 'hexerei'],
                'hi_res_image': '/cards/gcg_215032_hd.webp',
                'image': '/cards/gcg_215032.webp',
                'golden_image': '/cards/gcg_215032_golden.webp',
                'cost': '3 Anemo',
                'description': "Fast Action: Equip this to your Venti. \n\nSummon Stormeye. \n\nAfter you summon Stormeye, the attached character's Physical DMG is converted to Anemo DMG for their next two Normal Attacks during this Round, and these attacks cost 2 fewer Unaligned Element. \n\n(You must have Venti in your deck to add this card to your deck.)",
                'flavor': "\"Therefore, the so-called 'Unrevealed' can mean only two things: a future not anchored by the stars, or one deliberately obscured by those with ill intentions. The latter is truly infuriating. I do hope the little witch in the story never becomes someone like that.\"",
                'required': "venti",
                'id': 'H5',
            },
    
            "conquerorofevilguardianyaksha": {
                "name": "Conqueror of Evil: Guardian Yaksha",
                "tags": ['modify', 'talent', 'slowly'],
                "image": "/cards/i_n330533.webp",
                "golden_image": "/cards/i_n334537.webp",
                "hi_res_image": "/cards/i_n330533_gcg_high_resolution.webp",
                "cost": '3 Anemo 2 Energy',
                "description": "Combat Action: When your active character is Xiao, equip this card. \n\nAfter Xiao equips this card, immediately use Bane of All Evil once. \n\nWhile your Xiao has Yaksha's Mask attached, your use of Lemniscatic Wind Cycling will cost 1 less Anemo Die. (Every attachment of Yaksha's Mask allows the effect to be triggered twice) \n\n(You must have Xiao in your deck to add this card to your deck.)",
                "flavor": 'Evil shall be dispersed, and the vile will be scattered.',
                'required': 'xiao',
                'id': '52'
            },

            'poeticsoffuubutsu': {
                "name": "Poetics of Fuubutsu",
                "tags": ['modify', 'talent', 'slowly'],
                "image": "/cards/i_n330551.webp",
                "golden_image": "/cards/i_n334551.webp",
                "hi_res_image": "/cards/i_n330551_gcg_high_resolution.webp",
                "cost": '3 Anemo',
                "description": "Combat Action: When Kaedehara Kazuha is your active character, equip this card. \n\nAfter Kaedehara Kazuha equips this card, he will immediately use Chihayaburu once. \n\nAfter Kaedehara Kazuha triggers Swirl with this card equipped: For the next 2 instances, your Characters and Summons will deal +1 DMG for the Elemental Type Swirled. (Each Elemental Type is counted independently) \n\n(You must have Kaedehara Kazuha in your deck to add this card to your deck.)",
                "flavor": 'There is something elegant about this match.\nIf nothing else, both sides may concede defeat without regrets.',
                'required': 'kazuha',
                'id': '6L'
            },

            'galesofreverie': {
                "name": "Gales of Reverie",
                "tags": ['modify', 'talent', 'slowly'],
                "image": "/cards/i_n330555.webp",
                "golden_image": "/cards/i_n334555.webp",
                "hi_res_image": "/cards/i_n330555_gcg_high_resolution.webp",
                "cost": '4 Anemo',
                "description": "Combat Action: When your active character is {REALNAME[ID(1), equip this card. \n\nAfter #{REALNAME[ID(1) equips this card, immediately use Hanega: Song of the Wind once. \n\nWhen your #{REALNAME[ID(1), who has this card equipped, is in Windfavored state and after using Charged Attack: you will spend 1 fewer Elemental Die the next time you use \"Switch Character\" and deal 1 Anemo DMG. \n\n(You must have #{REALNAME[ID(1) in your deck to add this card to your deck.)",
                "flavor": '"Squall and fury!"',
                'required': 'wanderer',
                'id': '76'
            },

            'acoldbladelikeashadow': {
                "name": "A Cold Blade Like a Shadow",
                "tags": ['modify', 'talent', 'slowly'],
                "image": "/cards/i_n330563.webp",
                "golden_image": "/cards/i_n334563.webp",
                "hi_res_image": "/cards/i_n330563_gcg_high_resolution.webp",
                "cost": '3 Anemo',
                "description": "Combat Action: When your active character is Lynette, equip this card. \nAfter Lynette equips this card, immediately use Enigmatic Feint once. \nAfter your Lynette, who has this card equipped, uses Enigmatic Feint for the second time this Round: deals +2 DMG and forces your opponent to switch to their previous character. \n(You must have Lynette in your deck to add this card to your deck.)",
                "flavor": '"Step on up!"',
                'required': 'lynette',
                'id': '83'
            },

            'skivingnewandimproved': {
                "name": "Skiving: New and Improved",
                "tags": ['modify', 'talent', 'slowly'],
                "image": "/cards/i_n330572.webp",
                "golden_image": "/cards/i_n334572.webp",
                "hi_res_image": "/cards/i_n330572_gcg_high_resolution.webp",
                "cost": '3 Anemo',
                "description": "Combat Action: When your active character is Sayu, equip this card. \n\nWhen Sayu equips this card, immediately use Yoohoo Art: Fuuin Dash once. \n\nWhen your Sayu who has this card equipped is the active character, draw 2 cards when you trigger a Swirl reaction. (Once per Round) \n\n(You must have Sayu in your deck to add this card to your deck.)",
                "flavor": '"I should have just stayed in bed today."',
                'required': 'sayu',
                'id': '90'
            },

            'wondrouspathoftruth': {
                "name": "The Wondrous Path of Truth",
                "tags": ['modify', 'talent', 'slowly'],
                "image": "/cards/i_n330580.webp",
                "golden_image": "/cards/i_n334580.webp",
                "hi_res_image": "/cards/i_n330580_gcg_high_resolution.webp",
                "cost": '3 Anemo 2 Energy',
                "description": "Combat Action: When your active character is Faruzan, equip this card. \n\nAfter Faruzan equips this card, immediately use The Wind's Secret Ways. \n\nWhen the Dazzling Polyhedron created by Faruzan who has this card equipped enters play and when the Action Phase begins: Create 1 Anemo Die. \n\n(You must have Faruzan in your deck to add this card to your deck.)",
                "flavor": '"Truth repeats its course."',
                'required': 'faruzan',
                'id': 'A2'
            },

            "theycallhercloudretainer": {
                'name': "They Call Her Cloud Retainer",
                'tags': ['modify', 'talent', 'slowly'],
                'hi_res_image': '/cards/gcg_215101_hd.webp',
                'image': '/cards/gcg_215101.webp',
                'golden_image': '/cards/gcg_215101_golden.webp',
                'cost': '3 Anemo',
                'description': "Combat Action: When your active character is Xianyun, equip this card. \n\nAfter Xianyun equips this card, immediately use White Clouds at Dawn once. \n\nWhen you switch characters, this card gains 1 Storm Pinion stack. (Max 2 stacks gained per Round) \n\nWhen your Xianyun, who has this card equipped, uses Word of Wind and Flower, consume all Storm Pinion stacks. Each consumed stack increases DMG dealt by 1. \n\n(You must have Xianyun in your deck to add this card to your deck.)",
                'flavor': "\"Stray clouds, converge.\"",
                'required': "xianyun",
                'id': 'BF',
            },

            "bullettrick": {
                'name': "Bullet Trick",
                'tags': ['modify', 'talent'],
                'hi_res_image': '/cards/gcg_215111_hd.webp',
                'image': '/cards/gcg_215111.webp',
                'golden_image': '/cards/gcg_215111_golden.webp',
                'cost': '1 Anemo',
                'description': "Fast Action: When your Chasca is on the field, play this card on them. Add 1 Shadowhunt Shell to your Hand. \n\n(You must have Chasca in your deck to add this card to your deck)",
                'flavor': "\"Fire in the hole!\"",
                'required': "chasca",
                'id': 'DE',
            },

            "dancevestmentsbillowlikerainbowjade": {
                'name': "Dance Vestments Billow Like Rainbow Jade",
                'tags': ['modify', 'talent', 'slowly'],
                'hi_res_image': '/cards/gcg_215121_hd.webp',
                'image': '/cards/gcg_215121.webp',
                'golden_image': '/cards/gcg_215121_golden.webp',
                'cost': '3 Anemo',
                'description': "Combat Action: When your active character is Lan Yan, equip this card. \n\nAfter Lan Yan equips this card, immediately use Swallow-Wisp Pinion Dance once. \n\nWhen Lan Yan, who has this card equipped, is on the field and your character uses a Normal Attack: Gain 1 stack of Swallow-Wisp Shield. (Once per Round) \n\n(You must have Lan Yan in your deck to add this card to your deck.)",
                'flavor': "\"Ills, be gone!\"",
                'required': "lanyan",
                'id': 'DR',
            },

            "curiouscasefiles": {
                'name': "Curious Casefiles",
                'tags': ['modify', 'talent', 'slowly'],
                'hi_res_image': '/cards/gcg_215131_hd.webp',
                'image': '/cards/gcg_215131.webp',
                'golden_image': '/cards/gcg_215131_golden.webp',
                'cost': '3 Anemo',
                'description': "Combat Action: When your active character is Shikanoin Heizou, equip this card. \n\nAfter Shikanoin Heizou equips this card, immediately use Heartstopper Strike once. \n\nThe DMG increased by Declension is further increased by 1. \n\n(You must have Shikanoin Heizou in your deck to add this card to your deck.)",
                'flavor': "\"Can't fool me!\"",
                'required': "shikanoinheizou",
                'id': 'DS',
            },

            "yourechoimeetindreams": {
                'name': "Your Echo I Meet in Dreams",
                'tags': ['modify', 'talent', 'slowly'],
                'hi_res_image': '/cards/gcg_215141_hd.webp',
                'image': '/cards/gcg_215141.webp',
                'golden_image': '/cards/gcg_215141_golden.webp',
                'cost': '3 Anemo',
                'description': "Combat Action: When your active character is Yumemizuki Mizuki, equip this card. \n\nAfter Yumemizuki Mizuki equips this card, immediately use Aisa Utamakura Pilgrimage once. \n\nIf Yumemizuki Mizuki is the active character, you deal +1 Cryo DMG, Hydro DMG, Pyro DMG, and Electro DMG. (Includes DMG from Swirl Reactions of any element that you trigger. Twice per Round.) \n\n(You must have Yumemizuki Mizuki in your deck to add this card to your deck.)",
                'flavor': "\"Cast your worries to the wind.\"",
                'required': "yumemizukimizuki",
                'id': 'E6',
            },

            "tacticalwarmcompressbandaging": {
                'name': "Tactical Warm Compress Bandaging",
                'tags': ['modify', 'talent'],
                'hi_res_image': '/cards/gcg_215151_hd.webp',
                'image': '/cards/gcg_215151.webp',
                'golden_image': '/cards/gcg_215151_golden.webp',
                'cost': '1 Anemo',
                'description': "Fast Action: Equip this to your Ifa to heal the character on your team who has taken the most DMG for 1 HP. \n\nWhen your Ifa, who has this card equipped, is on the field and you trigger Anemo-Related Reactions, Electro-Charged, or Lunar-Charged, heal the character on your team who has taken the most DMG for 1 HP. (Twice per Round) \n\n(You must have Ifa in your deck to add this card to your deck.)",
                'flavor': "\"Mind your step!\"",
                'required': "ifa",
                'id': 'EL',
            },

            "backstreetguile": {
                'name': "Backstreet Guile",
                'tags': ['modify', 'talent', 'slowly'],
                'hi_res_image': '/cards/gcg_215161_hd.webp',
                'image': '/cards/gcg_215161.webp',
                'golden_image': '/cards/gcg_215161_golden.webp',
                'cost': '3 Anemo',
                'description': "Combat Action: When your active character is Jahoda, equip this card. \n\nAfter Jahoda equips this card, immediately use Savvy Strategy: Splitting the Spoils once. \n\nWhen Jahoda switches to the active character, if the number of cards in your opponent's Hand is greater than or equal to yours, randomly copy 2 cards from their Hand. (Once per Round) \n\n(You must have Jahoda in your deck to add this card to your deck.)",
                'flavor': "\"Finders keepers!\"",
                'required': "jahoda",
                'id': 'H0',
            },
            
            "strategicreserve": {
                "name": "Strategic Reserve",
                "tags": ['modify', 'talent', 'slowly'],
                "image": "/cards/i_n330516.webp",
                "golden_image": "/cards/i_n334516.webp",
                "hi_res_image": "/cards/i_n330516_gcg_high_resolution.webp",
                "cost": "3 Geo",
                "description": "'Combat Action': When your active character is Ningguang, equip this card.\n\nAfter Ningguang equips this card, immediately use 'Elemental Skill: Jade Screen' once.\n\nWhen your Ningguang, who has this card equipped, is on the field, 'Jade Screen' will cause you to deal +1 'Geo DMG'.\n\n(You must have Ningguang in your deck to add this card to your deck.)",
                "flavor": "Abundance is synonymous with confidence.",
                "required": "ningguang",
                "id": '17'        
            },
            
            "igotyourback": {
                "name": "I Got Your Back",
                "tags": ['modify', 'talent', 'slowly'],
                "image": "/cards/i_n330517.webp",
                "golden_image": "/cards/i_n334517.webp",
                "hi_res_image": "/cards/i_n330517_gcg_high_resolution.webp",
                "cost": '3 Geo',
                "description": "Combat Action: When your active character is Noelle, equip this card. \n\nAfter Noelle equips this card, immediately use Breastplate once. \n\nAfter Noelle uses a Normal Attack: If this card and Full Plate are both still in play, heal all your characters for 1 HP. (Once per Round) \n\n(You must have Noelle in your deck to add this card to your deck.)",
                "flavor": "A stout heart is the sternest armor.",
                "required": "noelle",
                "id": '18'        
            },

            "dominanceofearth": {
                "name": "Dominance of Earth",
                "tags": ['modify', 'talent', 'slowly'],
                "image": "/cards/i_n330534.webp",
                "golden_image": "/cards/i_n334538.webp",
                "hi_res_image": "/cards/i_n330534_gcg_high_resolution.webp",
                "cost": '5 Geo',
                "description": "Combat Action: When your active character is Zhongli, equip this card. \n\nAfter Zhongli equips this card, immediately use Dominus Lapidis: Striking Stone once. \n\nWhen your Zhongli, who has this card equipped, has at least 7 HP, the DMG dealt by Zhongli and the Geo DMG from your Summons +1. (3 times per Round) \n\n(You must have Zhongli in your deck to add this card to your deck.)",
                "flavor": 'The vastness of rivers flows endless, perpetual upon the tapestry of eons.',
                'required': 'zhongli',
                'id': '53'
            },

            "descentofdivinity": {
                "name": "Descent of Divinity",
                "tags": ['modify', 'talent', 'slowly'],
                "image": "/cards/i_n330545.webp",
                "golden_image": "/cards/i_n334545.webp",
                "hi_res_image": "/cards/i_n330545_gcg_high_resolution.webp",
                "cost": '3 Geo',
                "description": "Combat Action: When your active character is Albedo, equip this card. \n\nAfter Albedo equips this card, immediately use Abiogenesis: Solar Isotoma. \n\nWhen there is Albedo on the field who has this card equipped, if your side of the field has Solar Isotoma, then your characters' Plunging Attack costs 1 less Unaligned Element and deals +1 DMG. \n\n(You must have Albedo in your deck to add this card to your deck.)",
                "flavor": '	"The process of confirming the strategy for a duel also requires meticulous calculations..."',
                'required': 'albedo',
                'id': '6U'
            },

            "bookofblindinglight": {
                'name': "Book of Blinding Light",
                'tags': ['modify', 'talent', 'hexerei'],
                'hi_res_image': '/cards/gcg_216042_hd.webp',
                'image': '/cards/gcg_216042.webp',
                'golden_image': '/cards/gcg_216042_golden.webp',
                'cost': '2 Geo',
                'description': "Fast Action: Equip this to your Albedo. \n\nSummon Solar Isotoma. \n\nWhen you summon Solar Isotoma, create 2 stacks of Silver Isotoma, and generate 1 random basic Elemental Die. \n\n(You must have Albedo in your deck to add this card to your deck.)",
                'flavor': "\"Alice asked me to set you a task in the form of a story annotation, but I'm no storyteller, and I can't remember what that strange tale was about. Your performance has already far exceeded my expectations, and unlike Barbeloth, I have no odd hobby of teasing my apprentices. So, keep up the good work. I'm looking forward to seeing what kind of 'homework' you'll bring me next time we meet.\"",
                'required': "albedo",
                'id': 'HD',
            },
    
            "aratakiichiban": {
                "name": "Arataki Ichiban",
                "tags": ['modify', 'talent', 'slowly'],
                "image": "/cards/i_n330539.webp",
                "golden_image": "/cards/i_n334534.webp",
                "hi_res_image": "/cards/i_n330539_gcg_high_resolution.webp",
                "cost": '2 Black 1 Geo',
                "description": "'Combat Action': When your active character is Arataki Itto, equip this card.\n\nAfter Arataki Itto equips this card, immediately use 'Normal Attack: Fight Club Legend' once.\n\nAfter your Arataki Itto, who has this card equipped, uses 'Fight Club Legend' for the second time or more in one Round: If 'Superlative Superstrength' is triggered, deal +1 additional DMG.\n\n(You must have Arataki Itto in your deck to add this card to your deck.)",
                "flavor": "Whatever you do, remember to ride the momentum.",
                "required": "itto",
                "id": '4J'        
            },

            'rushinghound:swiftasthewind': { 
                'name': 'Rushing Hound: Swift as the Wind',
                'tags': ['modify', 'talent', 'slowly'],
                'hi_res_image': '/cards/i_n330564_gcg_high_resolution.webp',
                'image': '/cards/i_n330564.webp',
                'golden_image': '/cards/i_n334564.webp',
                'cost': '3 Geo',
                'description': "Combat Action: When your active character is Gorou, equip this card. \nAfter Gorou equips this card, immediately use Inuzaka All-Round Defense once. \nWhen your Gorou, who has this card equipped, is on the field, and after any of your characters deals Geo DMG: If General's War Banner is in play, draw 1 card. (Once per Round) \n(You must have Gorou in your deck to add this card to your deck.)",
                'flavor': "\"Rally!\"",
                'required': 'gorou',
                'id': '84',
            },

            'decorousharmony': { 
                'name': 'Decorous Harmony',
                'tags': ['modify', 'talent', 'slowly'],
                'hi_res_image': '/cards/i_n330586_gcg_high_resolution.webp',
                'image': '/cards/i_n330586.webp',
                'golden_image': '/cards/i_n334586.webp',
                'cost': '3 Geo 2 Energy',
                'description': "Combat Action: When your active character is Yun Jin, equip this card. \n\nAfter Yun Jin equips this card, immediately use Cliffbreaker's Banner. \n\nWhen Yun Jin, who has this card equipped, is on the field, and you trigger Flying Cloud Flag Formation: If you have no cards in your Hand, this Skill deals +2 additional DMG. \n\n(You must have Yun Jin in your deck to add this card to your deck.)",
                'flavor': "\"Strike as one!\"",
                'required': 'yunjin',
                'id': 'A8',
            },

            "undiscloseddistributionchannels": {
                'name': "Undisclosed Distribution Channels",
                'tags': ['modify', 'talent', 'slowly'],
                'hi_res_image': '/cards/gcg_216081_hd.webp',
                'image': '/cards/gcg_216081.webp',
                'golden_image': '/cards/gcg_216081_golden.webp',
                'cost': '3 Geo',
                'description': "Combat Action: When your active character is Navia, equip this card. \n\nAfter Navia equips this card, immediately use Ceremonial Crystalshot once. \n\nAfter your Navia, who has this card equipped, uses a Skill: Draw 2 Crystal Shrapnel cards. (Once per Round) \n\n(You must have Navia in your deck to add this card to your deck.)",
                'flavor': "\"Where'd that come from!?\"",
                'required': "navia",
                'id': 'B3',
            },

            "infivecolorsdyed": {
                'name': "In Five Colors Dyed",
                'tags': ['modify', 'talent', 'slowly'],
                'hi_res_image': '/cards/gcg_216091_hd.webp',
                'image': '/cards/gcg_216091.webp',
                'golden_image': '/cards/gcg_216091_golden.webp',
                'cost': '4 Geo',
                'description': "Combat Action: When your active character is Chiori, equip this card. \n\nAfter Chiori equips this card, immediately use Fluttering Hasode once. \n\nWhen your Chiori, who has this equipped, uses Fluttering Hasode: Summon 1 additional Tranquilly Taking Ten Tamoto, and Select 1 of 4 Chiori's Automaton Dolls before also summoning it. \n\n(You must have Chiori in your deck to add this card to your deck.)",
                'flavor': "\"Scraps of color, scatter!\"",
                'required': "chiori",
                'id': 'BR',
            },

            "nightrealmsgiftheartofunity": {
                'name': "Night Realm's Gift: Heart of Unity",
                'tags': ['modify', 'talent'],
                'hi_res_image': '/cards/gcg_216101_hd.webp',
                'image': '/cards/gcg_216101.webp',
                'golden_image': '/cards/gcg_216101_golden.webp',
                'cost': '1 Geo',
                'description': "When Turbo Twirly or Turbo Twirly: Let It Rip is triggered, draw 1 card. (Once per Round) \n\n(You must have Kachina in your deck to add this card to your deck.)",
                'flavor': "\"Clear the area!\"",
                'required': "kachina",
                'id': 'CV',
            },

            "touroftepeilhuitl": {
                'name': "Tour of Tepeilhuitl",
                'tags': ['modify', 'talent', 'slowly'],
                'hi_res_image': '/cards/gcg_216111_hd.webp',
                'image': '/cards/gcg_216111.webp',
                'golden_image': '/cards/gcg_216111_golden.webp',
                'cost': '2 Geo',
                'description': "Combat Action: When your active character is Xilonen, equip this card. \n\nAfter Xilonen equips this card, immediately use Yohual's Scratch once. \n\nWhen your Xilonen, who has this card equipped, is on the field: When you switch to Xilonen or switch from Xilonen to another character, if the target is in the Nightsoul's Blessing state, regain 1 Nightsoul point. (Twice per Round) \n\n(You must have Xilonen in your deck to add this card to your deck.)",
                'flavor': "\"Let the mountain's veins boil!\"",
                'required': "xilonen",
                'id': 'D4',
            },

            "elkwithfangedantlers": {
                'name': "Elk With Fanged Antlers",
                'tags': ['modify', 'talent'],
                'hi_res_image': '/cards/gcg_216121_hd.webp',
                'image': '/cards/gcg_216121.webp',
                'golden_image': '/cards/gcg_216121_golden.webp',
                'cost': '1 Geo',
                'description': "Fast Action: When your active character is Illuga, equip this card. \n\nCreate 1 stack of Nightingale's Song. \n\nWhile your Illuga with this card equipped is on the field: For every 2 stacks of Nightingale's Song consumed, create 1 Aedon to your Hand. \n\n(You must have Illuga in your deck to add this card to your deck.)",
                'flavor': "\"Behold the dawn!\"",
                'required': "illuga",
                'id': 'HE',
            },
            
            "floralsidewinder": {
                "name": "Floral Sidewinder",
                "tags": ['modify', 'talent', 'slowly'],
                "image": "/cards/i_n330518.webp",
                "golden_image": "/cards/i_n334518.webp",
                "hi_res_image": "/cards/i_n330518_gcg_high_resolution.webp",
                "cost": "3 Dendro",
                "description": "Combat Action: When your active character is Collei, equip this card. \n\nAfter Collei equips this card, immediately use Floral Brush once. \n\nAfter your Collei, who has this card equipped, uses Floral Brush, during this Round, when your characters' Skills trigger Dendro-Related Reactions: Deal 1 Dendro DMG. (Once per Round) \n\n(You must have Collei in your deck to add this card to your deck.)",
                "flavor": "Never underestimate Collei, and never underestimate her cat.",
                "required": "collei",
                "id": '19'        
            },
    
            "keensight": {
                "name": "Keen Sight",
                "tags": ['modify', 'talent', 'slowly'],
                "image": "/cards/i_n330535.webp",
                "golden_image": "/cards/i_n334535.webp",
                "hi_res_image": "/cards/i_n330535_gcg_high_resolution.webp",
                "cost": "3 Dendro",
                "description": "'Combat Action': When your active character is Tighnari, equip this card.\n\nAfter Tighnari equips this card, immediately use 'Elemental Skill: Vijnana-Phala Mine' once.\n\nWhen your Tighnari, who has this card equipped, is affected by 'Vijnana Suffusion', the character's Charged Attack costs 1 less Unaligned Element.\n\n(You must have Tighnari in your deck to add this card to your deck.)",
                "flavor": "Mistakes are part of learning... However, these mistakes should be corrected upon being discovered.",
                "required": "tighnari",
                "id": '4K'        
            },
    
            "theseedofstoredknowledge": {
                "name": "The Seed of Stored Knowledge",
                "tags": ['modify', 'talent', 'slowly'],
                "image": "/cards/i_n330546.webp",
                "golden_image": "/cards/i_n334546.webp",
                "hi_res_image": "/cards/i_n330546_gcg_high_resolution.webp",
                "cost": '3 Dendro 2 Energy',
                "description": "Combat Action: When your active character is Nahida, equip this card. \n\nAfter Nahida equips this card, immediately use Illusory Heart once. \n\nWhen your Nahida, who has this card equipped, is on the field, the following effects will take place based on your party's Elemental Types: \n\nPyro: When the Shrine of Maya is on the field, opposing characters who trigger the Seed of Skandha due to Elemental Reactions they are affected by will have the Piercing DMG they take from the Seed of Skandha converted to Dendro DMG. \n\nElectro: When the Shrine of Maya enters the field, the Seed of Skandha currently present of the opposition will gain 1 Usage(s). \n\nHydro: After your Nahida, who has this card equipped unleashes Shrine of Maya, Duration (Rounds) +1. \n\n(You must have Nahida in your deck to add this card to your deck.)",
                "flavor": '"Share in my knowledge."',
                'required': 'nahida',
                'id': '5A'
            },

            "beneficent": {
                "name": "Beneficent",
                "tags": ['modify', 'talent', 'slowly'],
                "image": "/cards/i_n330556.webp",
                "golden_image": "/cards/i_n334556.webp",
                "hi_res_image": "/cards/i_n330556_gcg_high_resolution.webp",
                "cost": '3 Dendro',
                "description": "Combat Action: When your active character is Yaoyao, equip this card.\n\nAfter Yaoyao equips this card, immediately use Raphanus Sky Cluster once.\n\nWhen Yuegui: Throwing Mode is created by your Yaoyao, who has this card equipped, and it has only 1 Usage(s) remaining, it deals +1 DMG and healing is increased by 1.\n\n(You must have Yaoyao in your deck to add this card to your deck.)",
                "flavor": '"Pain, pain, go away!"',
                'required': 'yaoyao',
                'id': '77'
            },

            "allthingsareoftheearth": {
                "name": "All Things Are of the Earth",
                "tags": ['modify', 'talent', 'slowly'],
                "image": "/cards/i_n330559.webp",
                "golden_image": "/cards/i_n334559.webp",
                "hi_res_image": "/cards/i_n330559_gcg_high_resolution.webp",
                "cost": '4 Dendro 2 Energy',
                "description": "Combat Action: When your active character is Baizhu, equip this card. \n\nAfter Baizhu equips this card, immediately use Holistic Revivification once. \n\nWhen your Baizhu, who has this card equipped, is on the field, when Seamless Shield activates a healing effect, generate 1 Elemental Dice of the same type as your active character. \n\n(You must have Baizhu in your deck to add this card to your deck)",
                "flavor": "\"If you can perceive the heavens and the earth, defend against malignant auras with the flow of qi, and keep your mind clear, surely nothing can hinder you.\"",
                'required': 'baizhu',
                'id': '7J'
            },

            'structuration': { 
                'name': 'Structuration',
                'tags': ['modify', 'talent', 'slowly'],
                'hi_res_image': '/cards/i_n330565_gcg_high_resolution.webp',
                'image': '/cards/i_n330565.webp',
                'golden_image': '/cards/i_n334565.webp',
                'cost': '3 Dendro 2 Energy',
                'description': "Combat Action: When your active character is Alhaitham, equip this card. \n\nAfter Alhaitham equips this card, immediately use Particular Field: Fetters of Phenomena once. \n\nWhen your Alhaitham, who has this card equipped, uses Particular Field: Fetters of Phenomena, if the character consumes a Chisel-Light Mirror with at least 1 Duration (Rounds), then always attach Chisel-Light Mirror with 3 Duration (Rounds) and draw 1 card. \n\n(You must have Alhaitham in your deck to add this card to your deck.)",
                'flavor': "\"A process of elimination.\"",
                'required': 'alhaitham',
                'id': '85',
            },

            'countlesssightstosee': { 
                'name': 'Countless Sights to See',
                'tags': ['modify', 'talent', 'slowly'],
                'hi_res_image': '/cards/i_n330577_gcg_high_resolution.webp',
                'image': '/cards/i_n330577.webp',
                'golden_image': '/cards/i_n334577.webp',
                'cost': '3 Dendro',
                'description': "Combat Action: When your active character is Kirara, equip this card. \n\nAfter Kirara equips this card, immediately use Meow-teor Kick once. \n\nWhen your Kirara who has this card equipped is the active character, spend 1 fewer Elemental Die when switching characters. (Once per Round) \n\n(You must have Kirara in your deck to add this card to your deck.)",
                'flavor': "\"Service with a smile!\"",
                'required': 'kirara',
                'id': '9G',
            },

            'theartofbudgeting': { 
                'name': 'The Art of Budgeting',
                'tags': ['modify', 'talent', 'slowly'],
                'hi_res_image': '/cards/i_n330587_gcg_high_resolution.webp',
                'image': '/cards/i_n330587.webp',
                'golden_image': '/cards/i_n334587.webp',
                'cost': '3 Dendro',
                'description': "Combat Action: When your active character is Kaveh, equip this card. \n\nAfter Kaveh equips this card, immediately use Artistic Ingenuity once. \n\nWhen Kaveh, who has this card equipped, is on the field, and after you trigger Burst Scan's effects: Add 1 copy of the Discarded card into your Hand. If this card is a Location Card, then the next Location Card you play this Round will cost 2 fewer Elemental Dice. (Once per Round) \n\n(You must have Kaveh in your deck to add this card to your deck.)",
                'flavor': "\"Feast your eyes!\"",
                'required': 'kaveh',
                'id': 'A9',
            },

            "nightrealmsgiftrepaidinfull": {
                'name': "Night Realm's Gift: Repaid in Full",
                'tags': ['modify', 'talent'],
                'hi_res_image': '/cards/gcg_217091_hd.webp',
                'image': '/cards/gcg_217091.webp',
                'golden_image': '/cards/gcg_217091_golden.webp',
                'cost': '1 Dendro',
                'description': "When your Kinich, who has this equipped, switches to become your active character or uses Canopy Hunter: Riding High: If you have the same amount or fewer cards in your Hand than your opponent, steal 1 card from their Hand with the highest Current Elemental Dice Cost, after which your opponent draws 1 card. (Once per Round) \n\n(You must have Kinich in your deck to add this card to your deck.)",
                'flavor': "\"For the Lord of the Night.\"",
                'required': "kinich",
                'id': 'CP',
            },

            "marcottesillage": {
                'name': "Marcotte Sillage",
                'tags': ['modify', 'talent'],
                'hi_res_image': '/cards/gcg_217101_hd.webp',
                'image': '/cards/gcg_217101.webp',
                'golden_image': '/cards/gcg_217101_golden.webp',
                'cost': '2 Dendro',
                'description': "The character to which this is attached has their Physical DMG dealt converted to Dendro DMG. \n\nAfter Emilie, who has this card equipped, uses her Normal Attack: Your highest level Lumidouce Case can immediately take action 1 time. (Once per Round) \n\n(You must have Emilie in your deck to add this card to your deck.)",
                'flavor': "\"A little ambience.\"",
                'required': "emilie",
                'id': 'CW',
            },

            "olipsweavemesongsandpsalms": {
                'name': "\"O Lips, Weave Me Songs and Psalms\"",
                'tags': ['modify', 'talent', 'slowly'],
                'hi_res_image': '/cards/gcg_217111_hd.webp',
                'image': '/cards/gcg_217111.webp',
                'golden_image': '/cards/gcg_217111_golden.webp',
                'cost': '3 Dendro',
                'description': "Combat Action: When your active character is Lauma, equip this card. \n\nAfter Lauma equips this card, immediately use Runo: Dawnless Rest of Karsikko once. \n\nAfter you trigger Bloom or Lunar-Bloom: Heal your most injured character for 2 HP. (Once per Round) \n\n(You must have Lauma in your deck to add this card to your deck.)",
                'flavor': "\"With one heart, we pray.\"",
                'required': "lauma",
                'id': 'GC',
            },

            "victoryflowsfromtheturningoftides": {
                'name': "Victory Flows from the Turning of Tides",
                'tags': ['modify', 'talent'],
                'hi_res_image': '/cards/gcg_217121_hd.webp',
                'image': '/cards/gcg_217121.webp',
                'golden_image': '/cards/gcg_217121_golden.webp',
                'cost': '3 Dendro',
                'description': "Fast Action: Equip this to your Nefer. \n\nCreate 3 Seeds of Deceit, place them evenly into your deck, and grant Cost Reduction to all Seeds of Deceit cards in your Hand and deck. \n\nAfter your Nefer deals DMG with Phantasm Performance: Draw 1 card, and grant Cost Reduction to all Seeds of Deceit cards in your Hand and deck. (Twice per Round) \n\n(You must have Nefer in your deck to add this card to your deck.)",
                'flavor': "\"The mystery unravels.\"",
                'required': "nefer",
                'id': 'GN',
            },
    
            "cicinscoldglare": {
                "name": "Cicin's Cold Glare",
                "tags": ['modify', 'talent', 'slowly'],
                "image": "/cards/i_n330547.webp",
                "golden_image": "/cards/i_n334547.webp",
                "hi_res_image": "/cards/i_n330547_gcg_high_resolution.webp",
                "cost": '3 Cryo',
                "description": "Combat Action: When your active character is Fatui Cryo Cicin Mage, equip this card. \n\nAfter Fatui Cryo Cicin Mage equips this card, immediately use Misty Summons once. \n\nAfter your Fatui Cryo Cicin Mage, who has this card equipped, uses a Skill: If Cryo Cicins' Usage(s) have exceeded their upper limit, deal 2 Cryo DMG. \n\n(You must have Fatui Cryo Cicin Mage in your deck to add this card to your deck.)",
                "flavor": "More Mist Grass means more friendly Cryo Cicins.\n...But what happens when the Mist Grass is used up?\nPerhaps she never considered this.",
                'required': 'cryocicinmage',
                'id': '5B'
            },

            'painforpain': { 
                'name': 'Pain for Pain',
                'tags': ['modify', 'talent'],
                'hi_res_image': '/cards/i_n330566_gcg_high_resolution.webp',
                'image': '/cards/i_n330566.webp',
                'golden_image': '/cards/i_n334566.webp',
                'cost': '3 White',
                'description': "Can only be played if your active character is La Signora: When entering play, generate 3 Elemental Dice of the same Type as La Signora. \n\nWhen this character takes at least 3 DMG: Negates 1 DMG, then apply Sheer Cold or Blazing Heat to the opposing active character based on La Signora's state. (Once per Round) \n(Your deck must contain La Signora to add this card to your deck)",
                'flavor': "\"You too will experience this suffering.\"",
                "required": "signora",
                'id': '86',
            },

            'sternfrostprism': { 
                'name': 'Sternfrost Prism',
                'tags': ['modify', 'talent'],
                'hi_res_image': '/cards/i_n330573_gcg_high_resolution.webp',
                'image': '/cards/i_n330573.webp',
                'golden_image': '/cards/i_n334573.webp',
                'cost': '1 Cryo',
                'description': "Can only be played if your active character is Cryo Hypostasis: Attach Cryo Crystal Core to them. \n\nAfter Cryo Hypostasis, who has this card equipped, triggers Cryo Crystal Core: Attach Sheer Cold to the opposing active character. \n\n(Your deck must contain Cryo Hypostasis to add this card to your deck)",
                'flavor': "Despite its highly stable form and almost machine-like movements, it must still meticulously defend its weak spot...",
                "required": "cryohypo",
                'id': '91',
            },

            "rimeflowrapier": {
                'name': "Rimeflow Rapier",
                'tags': ['modify', 'talent', 'slowly'],
                'hi_res_image': '/cards/gcg_221041_hd.webp',
                'image': '/cards/gcg_221041.webp',
                'golden_image': '/cards/gcg_221041_golden.webp',
                'cost': '3 Cryo',
                'description': "Combat Action: Equip this card when your active character is Frost Operative \n\nAfter equipping this card, immediately use Frosty Interjection once. \n\nAfter your Frost Operative, who has this card equipped, triggers Blood-Bonded Shadow: Causes the Bond of Life stacks the opponent's active character has to double. \n\n(You must have Frost Operative in your deck to add this card to your deck.)",
                'flavor': "\"Forgive my prior inconsideration.\"",
                'required': "frostoperative",
                'id': 'B4',
            },

            "flowofforms": {
                'name': "Flow of Forms",
                'tags': ['modify', 'talent'],
                'hi_res_image': '/cards/gcg_221051_hd.webp',
                'image': '/cards/gcg_221051.webp',
                'golden_image': '/cards/gcg_221051_golden.webp',
                'cost': '1 Cryo',
                'description': "Fast Action: Equip this to your Wayward Hermetic Spiritspeaker. \n\nCreate 1 Radiant Hues and add it to your Hand. \n\nAfter you play Radiant Hues, create 2 stacks of Shield. (Once per Round) (You must have Wayward Hermetic Spiritspeaker in your deck to add this card to your deck)",
                'flavor': "\"Night and day, in a place of exile far from worldly clamor, a hermit contemplates an ever-changing flow of forms and the metaphors they contain. Any warrior with the courage to step up and accept her challenge will face the colorful trials she has woven.\"",
                'required': "waywardhermeticspiritspeaker",
                'id': 'GO',
            },
            
            "streamingsurge": {
                "name": "Streaming Surge",
                "tags": ['modify', 'talent', 'slowly'],
                "image": "/cards/i_n330519.webp",
                "golden_image": "/cards/i_n334519.webp",
                "hi_res_image": "/cards/i_n330519_gcg_high_resolution.webp",
                "cost": '4 Hydro 3 Energy',
                "description": "'Combat Action': When your active character is Rhodeia of Loch, equip this card.\n\nAfter Rhodeia of Loch equips this card, immediately use 'Elemental Burst: Tide and Torrent' once.\n\nWhen your Rhodeia of Loch, who has this card equipped, uses 'Elemental Burst: Tide and Torrent', all of your Summon(s) gain +1 Usage(s).\n\n(You must have Rhodeia of Loch in your deck to add this card to your deck.)",
                "flavor": "The racing waters are a display of love toward a deceased deity.",
                "required": "oceanid",
                "id": '1A'        
            },
    
            "mirrorcage": {
                "name": "Mirror Cage",
                "tags": ['modify', 'talent', 'slowly'],
                "image": "/cards/i_n330526.webp",
                "golden_image": "/cards/i_n334526.webp",
                "hi_res_image": "/cards/i_n330526_gcg_high_resolution.webp",
                "cost": '3 Hydro',
                "description": "Combat Action: When your active character is Mirror Maiden, equip this card. \n\nAfter Mirror Maiden equips this card, immediately use Influx Blast once. \n\nWhen your Mirror Maiden, who has this card equipped, creates a Refraction, it will have +1 starting Duration (Rounds). It will also increase the Hydro DMG the character to which this is attached takes by 1. \n\n(You must have Mirror Maiden in your deck to add this card to your deck.)",
                "flavor": "“Mirror, mirror, in my hand, where do our foes lurk in this land?”",
                "required": "mirrormaiden",
                "id": '1H'        
            },

            "surgingundercurrent": {
                "name": "Surging Undercurrent",
                "tags": ['modify', 'talent'],
                "image": "/cards/i_n330581.webp",
                "golden_image": "/cards/i_n334581.webp",
                "hi_res_image": "/cards/i_n330581_gcg_high_resolution.webp",
                "cost": '1 Hydro',
                "description": "When played: If Abyss Herald: Wicked Torrents, who has this card equipped, has already triggered Watery Rebirth, then create 1 Curse of the Undercurrent on the opposing playing field. \n\nWhen Abyss Herald: Wicked Torrents, who has this card equipped, is defeated or triggers Watery Rebirth: Create 1 Curse of the Undercurrent on the opposing playing field. \n\n(You must have Abyss Herald: Wicked Torrents in your deck to add this card to your deck.)",
                "flavor": "\"Destruction inexorable!\"",
                "required": "abyssherald",
                "id": 'A3'        
            },

            "lightlessfeeding": {
                "name": "Lightless Feeding",
                "tags": ['modify', 'talent', 'slowly'],
                "image": "/cards/i_n330588.webp",
                "golden_image": "/cards/i_n334588.webp",
                "hi_res_image": "/cards/i_n330588_gcg_high_resolution.webp",
                "cost": '4 Hydro',
                "description": "Combat Action: When your active character is All-Devouring Narwhal, equip this card. \n\nAfter All-Devouring Narwhal equips this card, immediately use Starfall Shower once. \n\nAfter your All-Devouring Narwhal, who has this card equipped, uses Starfall Shower to Discard 1 card: Heal this character for that card's Current Elemental Dice Cost. (Once per Round) \n\n(You must have All-Devouring Narwhal in your deck to add this card to your deck.)",
                "flavor": "Phosphorescent creatures float all about the dark, moonless seas of dreams — perhaps they are as food for some titanic leviathan.",
                "required": "narwhal",
                "id": 'AA'        
            },

            "featherweightfoam": {
                'name': "Featherweight Foam",
                'tags': ['modify', 'talent', 'slowly'],
                'hi_res_image': '/cards/gcg_222051_hd.webp',
                'image': '/cards/gcg_222051.webp',
                'golden_image': '/cards/gcg_222051_golden.webp',
                'cost': '3 Hydro',
                'description': "Combat Action: When your active character is Hydro Hilichurl Rogue, equip this card. \n\nAfter Hydro Hilichurl Rogue equips this card, immediately use Slash of Surging Tides once. \n\nWhen your Hydro Hilichurl Rogue, who has this card equipped, is on the field, spend 1 fewer Elemental Die when using a Technique. (Once per Round) \n\n(You must have Hydro Hilichurl Rogue in your deck to add this card to your deck.)",
                'flavor': "\"Slimo movo!\"",
                'required': "hydrohilichurlrogue",
                'id': 'BG',
            },

            "flowconvergence": {
                'name': "Flow Convergence",
                'tags': ['modify', 'talent'],
                'hi_res_image': '/cards/gcg_222061_hd.webp',
                'image': '/cards/gcg_222061.webp',
                'golden_image': '/cards/gcg_222061_golden.webp',
                'cost': '2 Hydro',
                'description': "Fast Action: Equip this to your Hydro Tulpa to attach Elemental Lifeform: Hydro to them. (This character is always affected by Hydro and is immune to Hydro DMG. Duration (Rounds): 2) \n\nWhen your Hydro Tulpa, who has this card equipped, is on the field, after you declare the end of your round, if the attached character's HP is not less than 3, they will receive 2 Piercing DMG and summon 1 independent Half-Tulpa. \n\n(You must have Hydro Tulpa in your deck to add this card to your deck.)",
                'flavor': "\"Countless wills dissolved in the water, which, like the universe, was full of souls that wished to be born.\"",
                'required': "hydrotulpa",
                'id': 'EM',
            },

            "deathlyoverflow": {
                'name': "Deathly Overflow",
                'tags': ['modify', 'talent'],
                'hi_res_image': '/cards/gcg_222071_hd.webp',
                'image': '/cards/gcg_222071.webp',
                'golden_image': '/cards/gcg_222071_golden.webp',
                'cost': '1 Hydro',
                'description': "Fast Action: Equip to your Consecrated Horned Crocodile. \n\nWhen played: Create 1 Bonecruncher's Energy Block and add it to your Hand. \n\nWhen your Consecrated Horned Crocodile, who has this card equipped, is on the field and after you use Bonecruncher's Energy Block, heal the character on your team who has taken the most DMG for 1 HP. \n\n(You must have Consecrated Horned Crocodile in your deck to add this card to your deck.)",
                'flavor': "\"To devour, to merge, to seek yet another immortal carcass — the Consecrated Beasts enact this evolution in ceaseless repetition. Little do they know that the end of this cycle may never come...\"",
                'required': "consecratedhornedcrocodile",
                'id': 'F9',
            },

            "treacheroustorrent": {
                'name': "Treacherous Torrent",
                'tags': ['modify', 'talent'],
                'hi_res_image': '/cards/gcg_222081_hd.webp',
                'image': '/cards/gcg_222081.webp',
                'golden_image': '/cards/gcg_222081_golden.webp',
                'cost': '1 Hydro',
                'description': "Fast Action: Equip this to your Hydro Hypostasis. \n\nAfter your Hydro Hypostasis or Water Droplet deals DMG, heal your Monster with the lowest HP for 1 HP. (3 times per Round) \n\n(You must have Hydro Hypostasis in your deck to add this card to your deck.)",
                'flavor': "Beneath the stealthily swelling waters, a catastrophic wave silently builds its strength...",
                'required': "hydrohypostasis",
                'id': 'H1',
            },
            
            "paidinfull": {
                "name": "Paid in Full",
                "tags": ['modify', 'talent', 'slowly'],
                "image": "/cards/i_n330520.webp",
                "golden_image": "/cards/i_n334520.webp",
                "hi_res_image": "/cards/i_n330520_gcg_high_resolution.webp",
                "cost": '3 Pyro',
                "description": "Combat Action: When your active character is Fatui Pyro Agent, equip this card. \n\nAfter Fatui Pyro Agent equips this card, immediately use Prowl once. \n\nWhen your Fatui Pyro Agent, who has this card equipped, creates a Stealth, it will have the following effects: \n\nStarting Usage(s) +1, the Physical DMG the character to which this is attached deals will be converted to Pyro DMG. \n\n(You must have Fatui Pyro Agent in your deck to add this card to your deck.)",
                "flavor": "Remember this for so long as you live: You know who it is you owe, and you know when you must pay.",
                "required": "pyroagent",
                "id": '1B'        
            },
    
            "embersrekindled": {
                "name": "Embers Rekindled",
                "tags": ['modify', 'talent'],
                "image": "/cards/i_n330548.webp",
                "golden_image": "/cards/i_n334548.webp",
                "hi_res_image": "/cards/i_n330548_gcg_high_resolution.webp",
                "cost": '2 Pyro',
                "description": "When played: If Abyss Lector: Fathomless Flames, who equips this card, has already triggered Fiery Rebirth, immediately discard this card and apply Aegis of Abyssal Flame to the character.\n\nWhen Abyss Lector: Fathomless Flames, who has this card equipped, triggers Fiery Rebirth: discard this card and apply Aegis of Abyssal Flame to the character.\n\n(You must have Abyss Lector: Fathomless Flames in your deck to add this card to your deck.)",
                "flavor": 'The path toward sowing grace is not assured to be one free of obstructions.',
                'required': 'abysslector',
                'related': 'Aegis of Abyssal Flame',
                'id': '5C'
            },

            'scorpocalypse': { 
                'name': 'Scorpocalypse',
                'tags': ['modify', 'talent', 'slowly'],
                'hi_res_image': '/cards/i_n330567_gcg_high_resolution.webp',
                'image': '/cards/i_n330567.webp',
                'golden_image': '/cards/i_n334567.webp',
                'cost': "3 Pyro",
                'description': "Combat Action: When your active character is Eremite Scorching Loremaster, equip this card. \n\nAfter Eremite Scorching Loremaster equips this card, immediately use Blazing Strike once. \n\nWhen your Eremite Scorching Loremaster, who has this card equipped, is on the field and after you use Burning Assault to defeat an opposing character: Add 1 Spirit of Omen: Pyro Scorpion card to your Hand. \n\nAt the end of the Round: Generate 1 Scorpion Blessing stack. \n\n(You must have Eremite Scorching Loremaster in your deck to add this card to your deck.)",
                'flavor': "\"For the Eternal Oasis!\"",
                "required": "eremitescorchingloremaster",
                'id': '87',
            },

            'moltenmail': { 
                'name': 'Molten Mail',
                'tags': ['modify', 'talent'],
                'hi_res_image': '/cards/i_n330582_gcg_high_resolution.webp',
                'image': '/cards/i_n330582.webp',
                'golden_image': '/cards/i_n334582.webp',
                'cost': '1 Pyro',
                'description': "When played: Apply Pyro Application to the Emperor of Fire and Iron with this card equipped. \n\nAfter your Shield Status other than Armored Crab Carapace or Shield Combat Status is removed: The Emperor of Fire and Iron with this card equipped gains 2 stacks of Armored Crab Carapace. (Once per Round) \n\n(You must have Emperor of Fire and Iron in your deck to add this card to your deck.)",
                'flavor': "\"Imagine this world: All of humanity has been purged from Teyvat, and the ever-growing Emperor of Fire and Iron eventually wears the Palais Mermonia upon its body like a luxurious coat of white stone.\"",
                "required": "crab",
                'id': 'A4',
            },

            "undyingfury": {
                'name': "Undying Fury",
                'tags': ['modify', 'talent'],
                'hi_res_image': '/cards/gcg_223051_hd.webp',
                'image': '/cards/gcg_223051.webp',
                'golden_image': '/cards/gcg_223051_golden.webp',
                'cost': '1 Pyro',
                'description': "Fast Action: Equip this to your Lord of Eroded Primal Fire. \n\nWhen your opponent plays a card whose name was not in the initial deck at the start of this match: The character to which this is attached gains 1 Energy and +1 to the next instance of DMG. (Once per Round) \n\n(You must have Lord of Eroded Primal Fire in your deck to add this card to your deck.)",
                'flavor': "\"Trapped perpetually in the final day of its existence by this pitch-black gospel, its boundless fury has consumed all reason. Now, what remains is its unrelenting lust for battle, burning on without end.\"",
                'required': "lordoferodedprimalfire",
                'id': 'E7',
            },

            "flamelordsblessing": {
                'name': "Flamelord's Blessing",
                'tags': ['modify', 'talent', 'slowly'],
                'hi_res_image': '/cards/gcg_223061_hd.webp',
                'image': '/cards/gcg_223061.webp',
                'golden_image': '/cards/gcg_223061_golden.webp',
                'cost': '3 Pyro 2 Energy',
                'description': "Combat Action: When your active character is Goldflame Qucusaur Tyrant, equip this card. \n\nAfter Goldflame Qucusaur Tyrant equips this card, immediately use Goldflame Detonation once. \n\nWhen you trigger Goldflame State, also Discard 1 random card from your Hand. The DMG dealt by Goldflame State is increased by the Current Elemental Dice Cost of the card you Discarded from your Hand. \n\n(You must have Goldflame Qucusaur Tyrant in your deck to add this card to your deck.)",
                'flavor': "\"However, judging from his current title of 'Tyrant,' that story did not have a happy ending...\"",
                'required': "goldflamequcusaurtyrant",
                'id': 'FK',
            },
    
            "absorbingprism": {
                "name": "Absorbing Prism",
                "tags": ['modify', 'talent', 'slowly'],
                "image": "/cards/i_n330536.webp",
                "golden_image": "/cards/i_n334539.webp",
                "hi_res_image": "/cards/i_n330536_gcg_high_resolution.webp",
                "cost": '2 Electro',
                "description": "Combat Action: When your active character is Electro Hypostasis, heal that character for 3 HP and attach the Electro Crystal Core to them. \n\n(You must have Electro Hypostasis in your deck to add this card to your deck.)",
                "flavor": '"Here\'s our chance!"\n"Hey, it\'s on our side!"',
                'required': 'electrohypostasis',
                'related': 'Electro Crystal Core',
                'id': '54'
            },

            'grievingecho': { 
                'name': 'Grieving Echo',
                'tags': ['modify', 'talent'],
                'hi_res_image': '/cards/i_n330568_gcg_high_resolution.webp',
                'image': '/cards/i_n330568.webp',
                'golden_image': '/cards/i_n334568.webp',
                'cost': '3 Electro',
                'description': "Combat Action: When your active character is Thunder Manifestation, equip this card. \n\nAfter Thunder Manifestation equips this card, immediately use Strifeful Lightning once. \n\nWhen your Thunder Manifestation is on the field and has this card equipped, when an opponent with Lightning Rod attached takes DMG: You draw 1 card. (Once per Round) \n\n(You must have Thunder Manifestation in your deck to add this card to your deck.)",
                'flavor': "That which drives the Thunder Manifestation is a much more primal fury...",
                "required": "thundermanifestation",
                'id': '88',
            },

            'pearlsolidification': { 
                'name': 'Pearl Solidification',
                'tags': ['modify', 'talent'],
                'hi_res_image': '/cards/i_n330574_gcg_high_resolution.webp',
                'image': '/cards/i_n330574.webp',
                'golden_image': '/cards/i_n334574.webp',
                'cost': '0 White',
                'description': "Can only be played if your active character is Millennial Pearl Seahorse: When played, Millennial Pearl Seahorse will have Fontemer Pearl with 1 Usage(s) attached to them. If they already have Fontemer Pearl attached, Usage(s) +1 instead. \n\nWhen the Fontemer Pearl attached to Millennial Pearl Seahorse negates DMG from Summons, change to Usage(s) not being consumed twice per Round. \n\n(Your deck must contain Millennial Pearl Seahorse to add this card to your deck)",
                'flavor': "Xenomare Pearl, Fontemer Hoarthunder... The seahorse-shaped phantasmal beast, though a solitary king, has neither an opulent court nor the ruins of one. What it does have, however, is the majesty and might to send other Fontemer Aberrants skittering away from it in terror...",
                "required": "seahorse",
                'id': '92',
            },

            'electrocicinsgleam': { 
                'name': 'Electro Cicin\'s Gleam',
                'tags': ['modify', 'talent', 'slowly'],
                'hi_res_image': '/cards/i_n330578_gcg_high_resolution.webp',
                'image': '/cards/i_n330578.webp',
                'golden_image': '/cards/i_n334578.webp',
                'cost': '3 Electro',
                'description': "Combat Action: When your active character is Fatui Electro Cicin Mage, equip this card. \n\nAfter Fatui Electro Cicin Mage equips this card, immediately use Misty Call once. \n\nIf your Fatui Electro Cicin Mage who has this card equipped is on the field, before you choose an action: If Electro Cicin's Usage(s) is at least 3, then Electro Cicin will immediately deal 1 Electro DMG. (Usage(s) will be consumed, once per Round) \n\n(You must have Fatui Electro Cicin Mage in your deck to add this card to your deck.)",
                'flavor': "\"Are you... here to play with me?\"",
                "required": "ecicinmage",
                'id': '9H',
            },

            'fatalfulmination': { 
                'name': 'Fatal Fulmination',
                'tags': ['modify', 'talent'],
                'hi_res_image': '/cards/i_n330589_gcg_high_resolution.webp',
                'image': '/cards/i_n330589.webp',
                'golden_image': '/cards/i_n334589.webp',
                'cost': '1 Electro',
                'description': "When played: Create 1 Bonecruncher's Energy Block and place it into your Hand. \n\nWhen your Consecrated Scorpion, who has this card equipped, is on the field and after you play Bonecruncher's Energy Block: Draw 1 card, then create 1 Bonecruncher's Energy Block and randomly place it into your deck. \n\n(You must have Consecrated Scorpion in your deck to add this card to your deck)",
                'flavor': "Lifeforms are governed by the laws of evolution, Consecrated Beasts exploited these rules by being fortunate enough to discover a long-dead carcass of a greater being before any of their competition ever did.",
                "required": "consecratedscorpion",
                'id': 'AB',
            },

            "chainlightningcascade": {
                'name': "Chain Lightning Cascade",
                'tags': ['modify', 'talent'],
                'hi_res_image': '/cards/gcg_224061_hd.webp',
                'image': '/cards/gcg_224061.webp',
                'golden_image': '/cards/gcg_224061_golden.webp',
                'cost': '1 Electro',
                'description': "When played: If Abyss Lector: Violet Lightning, who has this card equipped, has already triggered Electric Rebirth, cause the opponent's active character to lose 1 Energy. \n\nWhen Abyss Lector: Violet Lightning, who has this card equipped, triggers Electric Rebirth or is defeated: Discard this card, and cause the opponent's active character to lose 1 Energy. \n\n(You must have Abyss Lector: Violet Lightning in your deck to add this card to your deck.)",
                'flavor': "\"Their violent lightning strikes the hearts of unbelievers with dark wisdom, warped by the shadowy depths of an eternal night, its violet glow proclaiming the existence of a great power that corrodes human intellect.\"",
                'required': "abysslectorvioletlightning",
                'id': 'BS',
            },
            
            "transcendentautomaton": {
                "name": "Transcendent Automaton",
                "tags": ['modify', 'talent', 'slowly'],
                "image": "/cards/i_n330521.webp",
                "golden_image": "/cards/i_n334521.webp",
                "hi_res_image": "/cards/i_n330521_gcg_high_resolution.webp",
                "cost": "3 Anemo",
                "description": "Combat Action: When your active character is Maguu Kenki, equip this card. \n\nAfter Maguu Kenki equips this card, immediately use Blustering Blade once. \n\nAfter your Maguu Kenki, who has this card equipped, uses Blustering Blade, you will switch to your next character. You will switch to your previous character when your Maguu Kenki, who has this card equipped, uses Frosty Assault. \n\n(You must have Maguu Kenki in your deck to add this card to your deck.)",
                "flavor": "That unerring strike has been delivered countless times.",
                "required": "maguu",
                "id": '1C'        
            },

            'rendingvortex': { 
                'name': 'Rending Vortex',
                'tags': ['modify', 'talent', 'slowly'],
                'hi_res_image': '/cards/i_n330569_gcg_high_resolution.webp',
                'image': '/cards/i_n330569.webp',
                'golden_image': '/cards/i_n334569.webp',
                'cost': '3 Anemo',
                'description': "Combat Action: When your active character is Dvalin, equip this card. \n\nAfter Dvalin equips this card, immediately use Tempestuous Barrage once. \n\nWhen your Dvalin, who has this card equipped, is on the field, when Total Collapse attached to an opposing character is removed: Apply Total Collapse to the next opposing standby character. (Once per Round) \n\n(You must have Dvalin in your deck to add this card to your deck.)",
                'flavor': "But never forget that dust can be wiped away, and the power of doubt and poison can be shattered.",
                "required": "dvalin",
                'id': '89',
            },

            'deathlycyclone': { 
                'name': 'Deathly Cyclone',
                'tags': ['modify', 'talent'],
                'hi_res_image': '/cards/i_n330590_gcg_high_resolution.webp',
                'image': '/cards/i_n330590.webp',
                'golden_image': '/cards/i_n334590.webp',
                'cost': '1 Anemo',
                'description': "When played: Create 1 Bonecruncher's Energy Block and place it into your Hand. \n\nWhen your Consecrated Flying Serpent, who has this card equipped, is on the field and after you play Bonecruncher's Energy Block: The next time you switch characters this Round, create 1 Elemental Die of your active character's Elemental Type. \n\n(You must have Consecrated Flying Serpent in your deck to add this card to your deck)",
                'flavor': "Though now imbued with the power of elemental manipulation, the Consecrated Beasts themselves still cannot fully digest the pieces of flesh they devoured from immortal carcasses. Instead, the pieces slowly fused with the beasts themselves, changing them...",
                "required": "consecratedserpent",
                'id': 'AC',
            },

            "oncethelonewindthatkeptthedarkcalamityatbay": {
                'name': "\"Once, the Lone Wind That Kept the Dark Calamity at Bay...\"",
                'tags': ['modify', 'talent', 'slowly'],
                'hi_res_image': '/cards/gcg_225041_hd.webp',
                'image': '/cards/gcg_225041.webp',
                'golden_image': '/cards/gcg_225041_golden.webp',
                'cost': '3 Anemo',
                'description': "Combat Action: When your active character is Black Serpent Knight: Windcutter, equip this card. \n\nAfter Black Serpent Knight: Windcutter equips this card, immediately use Rising Slash once. \n\nAt the start of the Action Phase: If your opponent has at least 7 cards in their Hand, attach 1 stack of RES to their active character. If you have at least 7 cards in your Hand, attach 2 stacks of RES to your active character. \n\n(You must have Black Serpent Knight: Windcutter in your deck to add this card to your deck)",
                'flavor': "\"When a kingdom's glory has all but faded, warriors who still hold honor in their hearts often find themselves led, by different roads, to the same choice...\"",
                'required': "blackserpentknightwindcutter",
                'id': 'GP',
            },
            
            "stonehidereforged": {
                "name": "Stonehide Reforged",
                "tags": ['modify', 'talent', 'slowly'],
                "image": "/cards/i_n330522.webp",
                "golden_image": "/cards/i_n334522.webp",
                "hi_res_image": "/cards/i_n330522_gcg_high_resolution.webp",
                "cost": "4 Geo 2 Energy",
                "description": "'Combat Action': When your active character is Stonehide Lawachurl, equip this card.\n\nAfter Stonehide Lawachurl equips this card, immediately use 'Elemental Burst: Upa Shato' once.\n\nWhen your Stonehide Lawachurl, who has this card equipped, defeats an opposing character: Stonehide Lawachurl will re-attach 'Stonehide' and 'Stone Force'.\n\n(You must have Stonehide Lawachurl in your deck to add this card to your deck.)",
                "flavor": "An enduring force flows through that craggy form.",
                "required": "stonehidelawachurl",
                "id": '1D'        
            },

            'lunarcyclesunending': { 
                'name': 'Lunar Cycles Unending',
                'tags': ['modify', 'talent', 'slowly'],
                'hi_res_image': '/cards/i_n330570_gcg_high_resolution.webp',
                'image': '/cards/i_n330570.webp',
                'golden_image': '/cards/i_n334570.webp',
                'cost': '2 White',
                'description': "Combat Action: When your active character is Azhdaha, play this card on them. Attach Stone Facets: Elemental Crystallization to Azhdaha, then create 1 Elemental Die for each Elemental Type your characters have. \n\n(Deck must contain Azhdaha to add this card to it)",
                'flavor': "\"Today is the day... We settle this now!\"",
                "required": "azhdaha",
                'id': '8A',
            },

            "beastlycorrosion": {
                'name': "Beastly Corrosion",
                'tags': ['modify', 'talent', 'slowly'],
                'hi_res_image': '/cards/gcg_226031_hd.webp',
                'image': '/cards/gcg_226031.webp',
                'golden_image': '/cards/gcg_226031_golden.webp',
                'cost': '4 Geo',
                'description': "Combat Action: When your active character is Golden Wolflord, equip this card. \n\nAfter Golden Wolflord equips this card, immediately use Howling Riftcall. \n\nWhen there is Golden Wolflord on the field who has this card equipped, your opponent's Golden Corrosion can stack up to 5 times. This will affect them even if they are on the field. \n\n(You must have Golden Wolflord in your deck to add this card to your deck.)",
                'flavor': "\"The Wolflord has no name, for it was but one of \"Gold\"'s unintentional creations, and that is precisely why it is obsessed with invading worlds that do not belong to it and making a name for itself.\"",
                'required': "goldenwolflord",
                'id': 'C5',
            },

            "oncestoodagainstthetideofdarkwaterslikebedrock": {
                'name': "\"Once Stood Against the Tide of Dark Waters Like Bedrock...\"",
                'tags': ['modify', 'talent', 'slowly'],
                'hi_res_image': '/cards/gcg_226041_hd.webp',
                'image': '/cards/gcg_226041.webp',
                'golden_image': '/cards/gcg_226041_golden.webp',
                'cost': '1 Geo',
                'description': "Combat Action: When your active character is Black Serpent Knight: Rockbreaker Ax, equip this card. \n\nWhen this card is played or the Action Phase begins: Black Serpent Knight: Rockbreaker AxPerform Geo Application. \n\n(You must have Black Serpent Knight: Rockbreaker Ax in your deck to add this card to your deck.)",
                'flavor': "\"And in the realm's darkest hour, those who had to protect their homeland had little room to be fussy anyway.\"",
                'required': "blackserpentknightrockbreakerax",
                'id': 'EY',
            },

            "gravityfield": {
                'name': "Gravity Field",
                'tags': ['modify', 'talent'],
                'hi_res_image': '/cards/gcg_226051_hd.webp',
                'image': '/cards/gcg_226051.webp',
                'golden_image': '/cards/gcg_226051_golden.webp',
                'cost': '1 Geo',
                'description': "Fast Action: Equip this to your Experimental Field Generator. \n\nAfter either side declares the end of their Round: That side switches to the next character. \n\nYour character's Plunging Attack deals +1 DMG. (Twice per Round) \n\n(You must have Experimental Field Generator in your deck to add this card to your deck.)",
                'flavor': "According to the original design intentions, this was the first step in a plan to turn Fontaine into a city in the sky, so never again would the people have to worry about the waves that once swept over the land. Even if all seven nations were to be swallowed by the deeps, the elegant Court of Fontaine would float above it all, just like Celestia. Even the secrets of the universe would no longer seem so distant.",
                'required': "experimentalfieldgenerator",
                'id': 'GD',
            },
                    
            "proliferatingspores": {
                "name": "Proliferating Spores",
                "tags": ['modify', 'talent', 'slowly'],
                "image": "/cards/i_n330527.webp",
                "golden_image": "/cards/i_n334527.webp",
                "hi_res_image": "/cards/i_n330527_gcg_high_resolution.webp",
                "cost": '3 Dendro',
                "description": "Combat Action: When your active character is Jadeplume Terrorshroom, equip this card. \n\nAfter Jadeplume Terrorshroom equips this card, immediately use Volatile Spore Cloud once. \n\nYour Jadeplume Terrorshroom, who has this card equipped, can accumulate 1 more stack of Radical Vitality. \n\n(You must have Jadeplume Terrorshroom in your deck to add this card to your deck.)",
                "flavor": "Few can safely traverse the traps laid by the Fungus with intelligence above that of the average living being.",
                "required": "terrorshroom",
                "id": '1I'        
            },

            'athousandyoung': { 
                'name': 'A Thousand Young',
                'tags': ['modify', 'talent'],
                'hi_res_image': '/cards/i_n330591_gcg_high_resolution.webp',
                'image': '/cards/i_n330591.webp',
                'golden_image': '/cards/i_n334591.webp',
                'cost': '2 Dendro',
                'description': "When played: Create 4 Awaken, My Kindred cards and randomly place them in your deck. \n\nWhen your Guardian of Apep's Oasis, who has this card equipped, is on the field: Your Proliferated Organism deals +1 DMG. \n\n(You must have Guardian of Apep's Oasis in your deck to add this card to your deck)",
                'flavor': "Apep once walked through an ocean of fragrant grass, gigantic trees, and unimaginably long vines like a fish with its many offspring swimming through the sea. Finally, the grass, trees, and vines withered and turned to dust, while countless beings as minute as grains of gravel built a fragile kingdom upon Apep's land.\nApep and its offspring made the sea of sand rage like boiling water and swept houses down as if they were falling leaves. Until the day when the new Lord of Sand reconciled with the king who lost their homeland, the dunes under the sun belonged to humanity, while the dragon's oasis remained in the hearts of the dragons.\nApep shared the knowledge of evolution with its many offspring, because spreading knowledge ensures dissemination while the stagnation of hoarded wisdom courted only decay. Till the day the promise between it and the Lord of Sand was finally attained, with ultimate wisdom claimed. Henceforth, it reaped only sights of oblivion, of an endless calamity...",
                "required": "apep",
                'id': 'AD',
            },

            "spiritserpentsswirl": {
                'name': "Spirit Serpent's Swirl",
                'tags': ['modify', 'talent', 'slowly'],
                'hi_res_image': '/cards/gcg_227031_hd.webp',
                'image': '/cards/gcg_227031.webp',
                'golden_image': '/cards/gcg_227031_golden.webp',
                'cost': '3 Dendro',
                'description': "Combat Action: When your active character is Eremite Floral Ring-Dancer, equip this card. \n\nAfter Eremite Floral Ring-Dancer equips this card, immediately use Spiraling Whirl once. \n\nWhen your Eremite Floral Ring-Dancer, who has this card equipped, is on the field, when you switch your active character to one with Spirit of Omen: Dendro Spirit-Serpent equipped: Deal 1 Dendro DMG. (Once per Round) \n\n(You must have Eremite Floral Ring-Dancer in your deck to add this card to your deck.)",
                'flavor': "\"...Even though all such gods and kings have now faded into the flowing sands, the memory of dance yet persists in the desert-dwellers' veins.\"",
                'required': "eremitefloralringdancer",
                'id': 'BT',
            },

            "thealldevourer": {
                'name': "The All-Devourer",
                'tags': ['modify', 'talent'],
                'hi_res_image': '/cards/gcg_227041_hd.webp',
                'image': '/cards/gcg_227041.webp',
                'golden_image': '/cards/gcg_227041_golden.webp',
                'cost': '1 Dendro',
                'description': "Fast Action: Equip this to your Gluttonous Yumkasaur Mountain King. Your opponent draws 1 card, then you steal 1 card from your opponent's Hand with the highest Current Elemental Dice Cost. \n\nWhen you play a card whose name was not in the initial deck at the start of the match: Trigger Gluttonous Rex once. (Once per Round) \n\n(You must have Gluttonous Yumkasaur Mountain King in your deck to add this card to your deck.)",
                'flavor': "\"Some tribe members believe that it has its current body shape because it has a unique physique, like the Qucusaur Tyrant... Though in fact, this is simply because it's lived for so long, and eaten way, WAY too much.\"",
                'required': "gluttonousyumkasaurmountainking",
                'id': 'DT',
            },

            "witheredreedseclipsethesun": {
                'name': "Withered Reeds Eclipse the Sun",
                'tags': ['modify', 'talent'],
                'hi_res_image': '/cards/gcg_227051_hd.webp',
                'image': '/cards/gcg_227051.webp',
                'golden_image': '/cards/gcg_227051_golden.webp',
                'cost': '1 Dendro',
                'description': "Fast Action: Equip this to your Consecrated Fanged Beast. \n\nAfter you play or Discard Bonecruncher's Energy Block: Draw 1 card. (Once per Round) \n\n(You must have Consecrated Fanged Beast in your deck to add this card to your deck.)",
                'flavor': "\"Human beings' baits and the remains of immortal beings are essentially deliberate or unintentional traps. The price of coveting the gift of the strongest is much more painful than being locked in a cage.\"",
                'required': "consecratedfangedbeast",
                'id': 'FZ',
            },
            
            "magicguide": {
                "name": "Magic Guide",
                "tags": ['modify', 'weapon', 'weapon_catalyst'],
                "image": "/cards/i_n331000.webp",
                "golden_image": "/cards/i_n335000.webp",
                "hi_res_image": "/cards/i_n331000_gcg_high_resolution.webp",
                "cost": '2 White',
                "description": "The character deals +1 DMG.\n\n(Only Catalyst Characters can equip this. A character can equip a maximum of 1 Weapon)",
                "flavor": "The 12th edition of the Magic Guide.\nIt contains a great detail of errors, but nonetheless remains the most authoritative guide to magic in existence.",
                "id": '1J'
            },
            
            "sacrificialfragments": {
                "name": "Sacrificial Fragments",
                "tags": ['modify', 'weapon', 'weapon_catalyst'],
                "image": "/cards/i_n331001.webp",
                "golden_image": "/cards/i_n335001.webp",
                "hi_res_image": "/cards/i_n331001_gcg_high_resolution.webp",
                "cost": '3 White',
                "description": "The character deals +1 DMG.\n\nAfter the character uses an Elemental Skill: Create 1 Elemental Die of the same Elemental Type as this character. (Once per Round)\n\n(Only Catalyst Characters can equip this. A character can equip a maximum of 1 Weapon)",
                "flavor": "A weathered musical score, the content of which is no longer legible.",
                "id": '1K'        
            },
            
            "skywardatlas": {
                "name": "Skyward Atlas",
                "tags": ['modify', 'weapon', 'weapon_catalyst'],
                "image": "/cards/i_n331002.webp",
                "golden_image": "/cards/i_n335002.webp",
                "hi_res_image": "/cards/i_n331002_gcg_high_resolution.webp",
                "cost": '3 White',
                "description": "The character deals +1 DMG.\n\nOnce per Round: This character’s Normal Attacks deal +1 additional DMG.\n\n(Only Catalyst Characters can equip this. A character can equip a maximum of 1 Weapon)",
                "flavor": "Its full name is the “An atlas of the winds and clouds.”\nThis text records the winds and clouds of the northern lands’ skies in poetic and archival forms.",
                "id": '1L'        
            },
    
            "athousandfloatingdreams": {
                "name": "A Thousand Floating Dreams",
                "tags": ['modify', 'weapon', 'weapon_catalyst'],
                "image": "/cards/i_n331038.webp",
                "golden_image": "/cards/i_n335039.webp",
                "hi_res_image": "/cards/i_n331038_gcg_high_resolution.webp",
                "cost": '3 White',
                "description": "The character deals +1 DMG.\n\nWhen your character triggers an Elemental Reaction: Deal +1 DMG. (Twice per Round)\n\n(Only Catalyst Characters can equip this. A character can equip a maximum of 1 Weapon)",
                "flavor": "\"There is an appointed time for all things to live and die, just like the ceaseless cycles of night and dawn.\"\n\"May the stories within this lamp grant you dreams worth looking forward to.\"",
                'id': '5E'
            },

            "fruitoffulfillment": {
                "name": "Fruit of Fulfillment",
                "tags": ['modify', 'weapon', 'weapon_catalyst'],
                "image": "/cards/i_n331052.webp",
                "golden_image": "/cards/i_n335052.webp",
                "hi_res_image": "/cards/i_n331052_gcg_high_resolution.webp",
                "cost": '3 Black',
                "description": "Character deals +1 DMG.\n\nWhen played: Draw 2 cards.\n\n(Can only be equipped by Catalyst characters. Characters can equip at most 1 Weapon)",
                "flavor": '"Even the most bitter of stories contain courage and strength... the story of the good Golden Nara\'s adventures with us will help good Nara defend the forest."',
                'id': '6M'
            },

            'lostprayertothesacredwinds': { 
                'name': 'Lost Prayer to the Sacred Winds',
                'tags': ['modify', 'weapon', 'weapon_catalyst'],
                'hi_res_image': '/cards/i_n331058_gcg_high_resolution.webp',
                'image': '/cards/i_n331058.webp',
                'golden_image': '/cards/i_n335058.webp',
                'cost': "2 White",
                'description': "For each point of \"Bonus DMG\" this card has, character deals +1 DMG. \n\nEnd Phase: This card gains 1 point of \"Bonus DMG.\" (Max 2 points) \n\n(Can only be equipped by Catalyst Characters. Each Character can equip at most 1 Weapon.",
                'flavor': "\"When flowers bloom, when leaves sway, that is me who sings the songs of freedom, of the winds.\"",
                'id': '8B',
            },

            'tulaytullahsremembrance': { 
                'name': 'Tulaytullah\'s Remembrance',
                'tags': ['modify', 'weapon', 'weapon_catalyst'],
                'hi_res_image': '/cards/i_n331059_gcg_high_resolution.webp',
                'image': '/cards/i_n331059.webp',
                'golden_image': '/cards/i_n335059.webp',
                'cost': '3 White',
                'description': "The character deals +1 DMG. \n\nWhen the character uses a Charged Attack: Spend 1 less Unaligned Element. (Can be triggered up to twice per Round) \n\n(Only Catalyst Characters can equip this. A character can equip a maximum of 1 Weapon)",
                'flavor': "\"In the end, all people, good or evil, will find themselves ground beneath the wheels of fate, and the sapphire city would fade, dissipating like tears beneath the scorching sun.\"",
                'id': '8C',
            },

            'tomeoftheeternalflow': { 
                'name': 'Tome of the Eternal Flow',
                'tags': ['modify', 'weapon', 'weapon_catalyst'],
                'hi_res_image': '/cards/i_n331070_gcg_high_resolution.webp',
                'image': '/cards/i_n331070.webp',
                'golden_image': '/cards/i_n335070.webp',
                'cost': '3 White',
                'description': "The character deals +1 DMG. \n\nAfter this character takes DMG or is healed: If this character has already been damaged or healed 2 times this Round, then this character's next attack this Round deals +2 additional DMG. (Once per Round) \n\n(Only Catalyst Characters can equip this. A character can equip a maximum of 1 Weapon)",
                'flavor': "\"...For if the harbinger of the apocalypse would indeed one day arrive, the flood would wash everything away.\"\n\"And we would fight with both duty and joy in our hearts, just as the goddess had found empathy for us in hers.\"",
                'id': '9I',
            },

            'cashflowsupervision': { 
                'name': 'Cashflow Supervision',
                'tags': ['modify', 'weapon', 'weapon_catalyst'],
                'hi_res_image': '/cards/i_n331074_gcg_high_resolution.webp',
                'image': '/cards/i_n331074.webp',
                'golden_image': '/cards/i_n335074.webp',
                'cost': '2 White',
                'description': "After this character takes DMG or is healed: This character's next Normal Attack this Round costs 1 less Unaligned Element and deals +1 DMG. (Max 2 times per Round) \n\n(Only Catalyst Characters can equip this. A character can equip a maximum of 1 Weapon)",
                'flavor': "\"The overseer made of precision machinery rumbles as it observes the monetary flow of the tiny nation,\nTirelessly recording the movement of every amount of money, the savings and spending of all,\nThe changes in value, and the number of times each piece of currency is circulated over a specific period.\"",
                'id': 'AG',
            },

            "flowingpurity": {
                'name': "Flowing Purity",
                'tags': ['modify', 'weapon', 'weapon_catalyst'],
                'hi_res_image': '/cards/gcg_311110_hd.webp',
                'image': '/cards/gcg_311110.webp',
                'golden_image': '/cards/gcg_311110_golden.webp',
                'cost': '1 White',
                'description': "When played and when the Round ends: The character gains 1 Bond of Life stack. \n\nBefore both sides choose their actions: If the character to which this is attached does not have Bond of Life attached, then generate 1 random basic Elemental Die, and the character will deal +1 DMG the next time they deal DMG. (Once per Round) \n\n(Only Catalyst Characters can equip this. A character can equip a maximum of 1 Weapon)",
                'flavor': "\"...This heart of mine, which beats as though it were ensconced in a vessel of flesh and blood, has already been stained with the same sin on this journey. This heart of mine, so tortured by the pain of regret — where could it ever hope to find peace?\"",
                'id': 'C6',
            },

            "everlastingmoonglow": {
                'name': "Everlasting Moonglow",
                'tags': ['modify', 'weapon', 'weapon_catalyst'],
                'hi_res_image': '/cards/gcg_311111_hd.webp',
                'image': '/cards/gcg_311111.webp',
                'golden_image': '/cards/gcg_311111_golden.webp',
                'cost': '2 White',
                'description': "When the character to which this is attached has at least 11 HP: DMG +2. (Once per Round) \n\nWhen played: The character to which this is attached gains 1 Max HP. \n\n(Only Catalyst characters can equip this. A character can equip a maximum of 1 Weapon)",
                'flavor': "\"Even if the storm clouds should gather, and even if the violet lightning's ferocity be perilous and unpredictable.\nThe silver moon of Watatsumi shall still pierce through the clouds and scatter forth its light.\"",
                'id': 'EN',
            },

            "starcallerswatch": {
                'name': "Starcaller's Watch",
                'tags': ['modify', 'weapon', 'weapon_catalyst'],
                'hi_res_image': '/cards/gcg_311112_hd.webp',
                'image': '/cards/gcg_311112.webp',
                'golden_image': '/cards/gcg_311112_golden.webp',
                'cost': '1 White',
                'description': "The first time each round you play a card whose name was not in your initial deck: That card costs 1 fewer Elemental Die. The attached character deals +1 DMG the next time they deal DMG. (Can stack up to 2 stacks) \n\n(Only Catalyst Characters can equip this. A character can equip a maximum of 1 Weapon)",
                'flavor': "\"I shall watch over you always, O hero solely mine, bound to your shoulder always, like a silken string...\"\n\"Until our souls are entwined eternally in profoundest peace, where even death shall not do us part.\"",
                'id': 'FA',
            },
            
            "ravenbow": {
                "name": "Raven Bow",
                "tags": ['modify', 'weapon', 'weapon_bow'],
                "image": "/cards/i_n331003.webp",
                "golden_image": "/cards/i_n335003.webp",
                "hi_res_image": "/cards/i_n331003_gcg_high_resolution.webp",
                "cost": '2 White',
                "description": "The character deals +1 DMG.\n\n(Only Bow Characters can equip this. A character can equip a maximum of 1 Weapon)",
                "flavor": "Ravens are known to be the ferrymen of the dead. As such, hunters would decorate their bows’ limbs with feathers which forebode the imminent death of their targets.",
                "id": '1M'        
            },
            
            "sacrificialbow": {
                "name": "Sacrificial Bow",
                "tags": ['modify', 'weapon', 'weapon_bow'],
                "image": "/cards/i_n331004.webp",
                "golden_image": "/cards/i_n335004.webp",
                "hi_res_image": "/cards/i_n331004_gcg_high_resolution.webp",
                "cost": '3 White',
                "description": "The character deals +1 DMG.\n\nAfter the character uses an Elemental Skill: Create 1 Elemental Die of the same Elemental Type as this character. (Once per Round)\n\n(Only Bow Characters can equip this. A character can equip a maximum of 1 Weapon)",
                "flavor": "A ceremonial hunting bow that has seen the passage of many years. The trinkets on it are still visible.",
                "id": '1N'        
            },
            
            "skywardharp": {
                "name": "Skyward Harp",
                "tags": ['modify', 'weapon', 'weapon_bow'],
                "image": "/cards/i_n331005.webp",
                "golden_image": "/cards/i_n335005.webp",
                "hi_res_image": "/cards/i_n331005_gcg_high_resolution.webp",
                "cost": '3 White',
                "description": "The character deals +1 DMG.\n\nOnce per Round: This character’s Normal Attacks deal +1 additional DMG.\n\n(Only Bow Characters can equip this. A character can equip a maximum of 1 Weapon)",
                "flavor": "The sound of this sky-piercing lyre firing is music to the Anemo Archon’s ears.",
                "id": '1O'        
            },
    
            "amosbow": {
                "name": "Amos' Bow",
                "tags": ['modify', 'weapon', 'weapon_bow'],
                "image": "/cards/i_n331037.webp",
                "golden_image": "/cards/i_n335038.webp",
                "hi_res_image": "/cards/i_n331037_gcg_high_resolution.webp",
                "cost": '3 White',
                "description": "The character deals +1 DMG.\n\nWhen the character uses a Skill that costs at least a total of 5 Elemental Dice and Energy, +2 additional DMG. (Once per Round)\n\n(Only Bow Characters can equip this. A character can equip a maximum of 1 Weapon)",
                "flavor": '"I dreamt of ocean waves and sand, of lush forests and land."\n"I dreamt of boars playing in berry bushes, of a towering spire."',
                'id': '5D'
            },
    
            "elegyfortheend": {
                "name": "Elegy for the End",
                "tags": ['modify', 'weapon', 'weapon_bow'],
                "image": "/cards/i_n331039.webp",
                "golden_image": "/cards/i_n335040.webp",
                "hi_res_image": "/cards/i_n331039_gcg_high_resolution.webp",
                "cost": '3 White',
                "description": "The character deals +1 DMG.\n\nAfter the character uses an Elemental Burst: Create Millennial Movement: Farewell Song. (Your character deals +1 DMG, Duration (Rounds): 2)\n\n(Only Bow Characters can equip this. A character can equip a maximum of 1 Weapon)",
                "flavor": '"...But no wind in any season on earth"\n"Shall have you gaze upon me again."',
                'id': '5F'
            },

            "kingssquire": {
                "name": "King's Squire",
                "tags": ['modify', 'weapon', 'weapon_bow'],
                "image": "/cards/i_n331053.webp",
                "golden_image": "/cards/i_n335053.webp",
                "hi_res_image": "/cards/i_n331053_gcg_high_resolution.webp",
                "cost": '3 White',
                "description": "Character deals +1 DMG. \n\nWhen played: During this Round, the next time you play a Talent card or a Character using an Elemental Skill, spend 2 fewer Elemental Dice. \n\n(Only Bow Characters can equip this. A character can equip a maximum of 1 Weapon.)",
                "flavor": "A weapon you obtained from an Aranara tale. It has taken on the shape of a bow.\n\"Remember, this whole world is but a dream of the forest... Please pass on the forest's language and the responsibility of protecting the King's land to future successors.\"",
                'id': '6X'
            },

            "eotl": {
                "name": "End of the Line",
                "tags": ['modify', 'weapon', 'weapon_bow'],
                "image": "/cards/i_n331075.webp",
                "golden_image": "/cards/i_n335075.webp",
                "hi_res_image": "/cards/i_n331075_gcg_high_resolution.webp",
                "cost": '2 White',
                "description": "After you play an Action Card and no cards of the same name were in your initial deck for this match: This card gains 1 Catch point. (Max 2 stacks, up to 2 stacks gained per Round) \n\nWhen a character uses a Skill: If there are Catch points already, consume all points for this Skill to deal +1 DMG, then draw 1 card for each point consumed. \n\n(Only Bow Characters can equip this. A character can equip a maximum of 1 Weapon)",
                "flavor": '"...The fish that once shot forth like an arrow across a huge lake on the plateau,\nThat would stretch out as straight as a spear, cruising back and forth between the sacred sites,\nWould see its stream seep into the sand, its lake shrink into a puddle,\nTill at last, it wound up curled in a little plash, at the mercy of passing pilgrims."',
                'id': 'AH'
            },

            "aquasimulacra": {
                'name': "Aqua Simulacra",
                'tags': ['modify', 'weapon', 'weapon_bow'],
                'hi_res_image': '/cards/gcg_311208_hd.webp',
                'image': '/cards/gcg_311208.webp',
                'golden_image': '/cards/gcg_311208_golden.webp',
                'cost': '2 White',
                'description': "When the character to which this is attached has at least 11 HP: DMG +2. \n\nWhen played: The character to which this is attached gains 1 Max HP. \n\n(Only Bow characters can equip this. A character can equip a maximum of 1 Weapon)",
                'flavor': "\"It is in defense of the purity of the source that water's gentleness can also become as blade and bow.\nConspiracy and coded language are interwoven with ease under the pale blue full moon — this is the wisdom of water's shape.\"",
                'id': 'EG',
            },

            "snarehook": {
                'name': "Snare Hook",
                'tags': ['modify', 'weapon', 'weapon_bow'],
                'hi_res_image': '/cards/gcg_311209_hd.webp',
                'image': '/cards/gcg_311209.webp',
                'golden_image': '/cards/gcg_311209_golden.webp',
                'cost': '2 Black',
                'description': "The character deals +2 DMG with their Elemental Burst. \n\nWhen you trigger an Elemental Reaction: Gain 1 stack of Phantom Flash. When Phantom Flash is at 2 or more stacks, consume 2 stacks of Phantom Flash to grant the attached character 1 Energy. \n\n(Only Bow characters can equip this. A character can equip a maximum of 1 Weapon)",
                'flavor': "\"There are few truly inescapable traps in this world, for even the densest web can be threaded with a needle.\nGlimmers of hope can be found between the hooks and cages of even a trap set to kill.\nJust as no one can fully lock away their heart, even the most cautious defenses must eventually falter.\"",
                'id': 'G0',
            },
            
            "whiteirongreatsword": {
                "name": "White Iron Greatsword",
                "tags": ['modify', 'weapon', 'weapon_claymore'],
                "image": "/cards/i_n331006.webp",
                "golden_image": "/cards/i_n335006.webp",
                "hi_res_image": "/cards/i_n331006_gcg_high_resolution.webp",
                "cost": '2 White',
                "description": "The character deals +1 DMG.\n\n(Only Claymore Characters can equip this. A character can equip a maximum of 1 Weapon)",
                "flavor": "A lightweight greatsword made of white iron with a silver sheen.",
                "id": '1P'        
            },
            
            "sacrificialgreatsword": {
                "name": "Sacrificial Greatsword",
                "tags": ['modify', 'weapon', 'weapon_claymore'],
                "image": "/cards/i_n331007.webp",
                "golden_image": "/cards/i_n335007.webp",
                "hi_res_image": "/cards/i_n331007_gcg_high_resolution.webp",
                "cost": '3 White',
                "description": "The character deals +1 DMG.\n\nAfter the character uses an Elemental Skill: Create 1 Elemental Die of the same Elemental Type as this character. (Once per Round)\n\n(Only Claymore Characters can equip this. A character can equip a maximum of 1 Weapon)",
                "flavor": "This greatsword has seen the passage of many years, and was once owned by a clan of brave and gifted warriors who fought hard and died young.",
                "id": '1Q'        
            },
            
            "wolfsgravestone": {
                "name": "Wolf’s Gravestone",
                "tags": ['modify', 'weapon', 'weapon_claymore'],
                "image": "/cards/i_n331008.webp",
                "golden_image": "/cards/i_n335008.webp",
                "hi_res_image": "/cards/i_n331008_gcg_high_resolution.webp",
                "cost": '3 White',
                "description": "The character deals +1 DMG.\n\nDeal +2 additional DMG if the target’s remaining HP is equal to or less than 6.\n\n(Only Claymore Characters can equip this. A character can equip a maximum of 1 Weapon)",
                "flavor": "A longsword said to have been used by the knight of the north wind. It became endowed with legendary power owing to his friendship with the wolves.",
                "id": '1R'        
            },
    
            "skywardpride": {
                "name": "Skyward Pride",
                "tags": ['modify', 'weapon', 'weapon_claymore'],
                "image": "/cards/i_n331040.webp",
                "golden_image": "/cards/i_n335041.webp",
                "hi_res_image": "/cards/i_n331040_gcg_high_resolution.webp",
                "cost": '3 White',
                "description": "The character deals +1 DMG.\n\nOnce per Round: This character's Normal Attacks deal +1 additional DMG.\n\n(Only Claymore Characters can equip this. A character can equip a maximum of 1 Weapon)",
                "flavor": "This is a tale of sky-shaking valor. Bearing the will to defend all, let the wind dragon bestow wrath upon its vile nemesis.",
                'id': '5G'
            },
    
            "thebell": {
                "name": "The Bell",
                "tags": ['modify', 'weapon', 'weapon_claymore'],
                "image": "/cards/i_n331041.webp",
                "golden_image": "/cards/i_n335042.webp",
                "hi_res_image": "/cards/i_n331041_gcg_high_resolution.webp",
                "cost": '3 White',
                "description": "The character deals +1 DMG.\n\nAfter the character uses a skill: Gives 1 Shield point to your active character. (Once per Round, stacks up to 2 points)\n\n(Only Claymore Characters can equip this. A character can equip a maximum of 1 Weapon)",
                "flavor": "There once was a traitor who brandished a blade against his fallen clan.\nThough this individual was eventually cast out from his clan, rumor has it that his organization continued their chosen duties.\nLegend claims that even the Wolf Pup Rostam might have been involved...",
                'id': '5H'
            },

            'beaconofthereedsea': { 
                'name': 'Beacon of the Reed Sea',
                'tags': ['modify', 'weapon', 'weapon_claymore'],
                'hi_res_image': '/cards/i_n331060_gcg_high_resolution.webp',
                'image': '/cards/i_n331060.webp',
                'golden_image': '/cards/i_n335060.webp',
                'cost': '3 White',
                'description': "The character deals +1 DMG. \n\nAfter the character uses an Elemental Skill: +1 additional DMG dealt by character this Round the next time they deal DMG. (Once per Round) \n\nAfter this character takes DMG: +1 additional DMG dealt by character this Round the next time they deal DMG. (Once per Round) \n\n(Only Claymore Characters can equip this. A character can equip a maximum of 1 Weapon)",
                'flavor': "\"On top of the ruins of the pool where the regalia of past executions of offenders was excavated, those who had lost the dream of the desert, yet were unwilling to give up their vast sea of sand gathered.\nIn the name of the Reed Sea that never existed, they connected with the dream that was promised to them...\"",
                'id': '8D',
            },

            'forestregalia': { 
                'name': 'Forest Regalia',
                'tags': ['modify', 'weapon', 'weapon_claymore'],
                'hi_res_image': '/cards/i_n331076_gcg_high_resolution.webp',
                'image': '/cards/i_n331076.webp',
                'golden_image': '/cards/i_n335076.webp',
                'cost': '3 Black',
                'description': "The character deals +1 DMG. \n\nWhen played: When the character to which this is attached next uses a Normal Attack during this Round: Create 2 Elemental Dice of this character's Elemental Type. \n\n(Only Claymore Characters can equip this. A character can equip a maximum of 1 Weapon)",
                'flavor': "\"...Then the current changed and the moon's reflection was scattered. Much has changed, and yet, much will now remain unchanged forevermore.\nBut even if you, like me, have never met a king, you would still get the impression that Tiger was a noble and powerful king of the forest.\"",
                'id': 'AI',
            },

            "ultimateoverlordsmegamagicsword": {
                'name': "\"Ultimate Overlord's Mega Magic Sword\"",
                'tags': ['modify', 'weapon', 'weapon_claymore'],
                'hi_res_image': '/cards/gcg_311308_hd.webp',
                'image': '/cards/gcg_311308.webp',
                'golden_image': '/cards/gcg_311308_golden.webp',
                'cost': '2 White',
                'description': "This card will record the number of Action Cards with different names you have played in this match whose names are not in your original deck for said match, with each type granting 1 Support. \n\nIf this card's Support value is at least 2/4/9, then the Character will deal +1/2/3 DMG. \n\n(Only Claymore Characters can equip this. A character can only equip 1 Weapon.)",
                'flavor': "\"... Uh, what? A cheap cardboard claymore? No, no, no, this is... Well, it's... the Ultimate Overlord's Mega Magic Sword, once used to triumph over the Crab Emperor!\"\nAfter some discussion, the Melusines reached a consensus. This, the mightiest sword in Merusea Village, that had shone so illustriously in the shadowed mists of the past, should be given to an unparalleled hero, as a memorial to their friendship.",
                'id': 'B5',
            },

            "portablepowersaw": {
                'name': "Portable Power Saw",
                'tags': ['modify', 'weapon', 'weapon_claymore', 'damage reduction'],
                'hi_res_image': '/cards/gcg_311309_hd.webp',
                'image': '/cards/gcg_311309.webp',
                'golden_image': '/cards/gcg_311309_golden.webp',
                'cost': '2 White',
                'description': "When the character to which this is attached takes DMG: If possible, Discard 1 card from your Hand with the highest Current Elemental Dice Cost to negate 1 DMG, and then gain 1 Stoic's Symbol point. (Once per Round) \n\nWhen the character deals DMG: If there are Stoic's Symbol points already, consume all points and increase DMG dealt this instance by 1, then draw 1 card for each point consumed. \n\n(Only Claymore Characters can equip this. A character can equip a maximum of 1 Weapon)",
                'flavor': "\"A chainsaw favored by workers of the past to cut through keels and pipes... Grab the handle tightly with both hands, and even hard steel shall split before you.\"",
                'id': 'BU',
            },

            "flameforgedinsight": {
                'name': "Flame-Forged Insight",
                'tags': ['modify', 'weapon', 'weapon_claymore'],
                'hi_res_image': '/cards/gcg_311310_hd.webp',
                'image': '/cards/gcg_311310.webp',
                'golden_image': '/cards/gcg_311310_golden.webp',
                'cost': '2 Black',
                'description': "The character deals +2 DMG with their Elemental Burst. \n\nWhen you trigger an Elemental Reaction: Gain 1 stack of Mind in Bloom. When Mind in Bloom is at 2 or more stacks, consume 2 stacks of Mind in Bloom to grant the attached character 1 Energy. \n\n(Only Claymore characters can equip this. A character can equip a maximum of 1 Weapon)",
                'flavor': "\"Let the memories of the past accompany you on your journey, in place of forebears who now lack the strength to...\"\n\"The past flows through the blood into each new generation, like an unquenchable fire passed down through rituals that never cease to burn.\"",
                'id': 'FB',
            },
            
            "whitetassel": {
                "name": "White Tassel",
                "tags": ['modify', 'weapon', 'weapon_pole'],
                "image": "/cards/i_n331009.webp",
                "golden_image": "/cards/i_n335009.webp",
                "hi_res_image": "/cards/i_n331009_gcg_high_resolution.webp",
                "cost": '2 White',
                "description": "The character deals +1 DMG.\n\n(Only Polearm Characters can equip this. A character can equip a maximum of 1 Weapon)",
                "flavor": "A standard-issue weapon of the Millelith soldiers. It has a sturdy shaft and sharp spearhead. It’s a reliable weapon.",
                "id": '1S'        
            },
            
            "lithicspear": {
                "name": "Lithic Spear",
                "tags": ['modify', 'weapon', 'weapon_pole'],
                "image": "/cards/i_n331010.webp",
                "golden_image": "/cards/i_n335010.webp",
                "hi_res_image": "/cards/i_n331010_gcg_high_resolution.webp",
                "cost": '3 White',
                "description": "The character deals +1 DMG. \n\nWhen played: For each of your party members from Liyue, grant 1 point of Shield to the character to which this is attached. (Max 3 points) \n\n(Only Polearm Characters can equip this. A character can equip a maximum of 1 Weapon)",
                "flavor": "These spears were forged from the rocks of the Guyun Stone Forest, and were favored by the Millelith of old. Their hardness knows no equal.",
                "id": '1T'        
            },
            
            "skywardspine": {
                "name": "Skyward Spine",
                "tags": ['modify', 'weapon', 'weapon_pole'],
                "image": "/cards/i_n331011.webp",
                "golden_image": "/cards/i_n335011.webp",
                "hi_res_image": "/cards/i_n331011_gcg_high_resolution.webp",
                "cost": '3 White',
                "description": "The character deals +1 DMG.\n\nOnce per Round: This character’s Normal Attacks deal +1 additional DMG.\n\n(Only Polearm Characters can equip this. A character can equip a maximum of 1 Weapon)",
                "flavor": "A spear that can hold up the skies. It was this unshakable resolve that sustained the wind dragon through its mortal battle against its vile nemesis.",
                "id": '1U'        
            },
    
            "vortexvanquisher": {
                "name": "Vortex Vanquisher",
                "tags": ['modify', 'weapon', 'weapon_pole'],
                "image": "/cards/i_n331042.webp",
                "golden_image": "/cards/i_n335043.webp",
                "hi_res_image": "/cards/i_n331042_gcg_high_resolution.webp",
                "cost": '3 White',
                "description": "The character deals +1 DMG. \n\nWhen your active character is protected by a Shield Character Status or a Shield Combat Status, you deal +1 DMG. \n\nAfter the character uses an Elemental Skill: If you have a Combat Status that grants a Shield on your side, add 1 Shield point to that Combat Status. (Once per Round) \n\n(Only Polearm Characters can equip this. A character can equip a maximum of 1 Weapon)",
                "flavor": 'Folklore spoke of a vast shadow entrenched in the depths of the ocean capable of swallowing passing warships...\nAt tale\'s end, they believe that Rex Lapis once wielded a spear that pierced the rainbow, pinning the churning vortex that had once terrorized the oceans in the center of the deep sea.',
                'id': '5I'
            },
    
            "engulfinglightning": {
                "name": "Engulfing Lightning",
                "tags": ['modify', 'weapon', 'weapon_pole'],
                "image": "/cards/i_n331043.webp",
                "golden_image": "/cards/i_n335044.webp",
                "hi_res_image": "/cards/i_n331043_gcg_high_resolution.webp",
                "cost": '3 White',
                "description": "The character deals +1 DMG.\n\nTriggers automatically once per Round: If the character to which this is attached does not have Energy, they will gain 1 Energy.\n\n(Only Polearm Characters can equip this. A character can equip a maximum of 1 Weapon)",
                "flavor": 'The naginata was a lethal weapon by which scattered dross might be cut away.\nAnd the one who wielded that naginata was one who guarded the path to eternity.',
                'id': '5J'
            },

            "moonpiercer": {
                "name": "Moonpiercer",
                "tags": ['modify', 'weapon', 'weapon_pole'],
                "image": "/cards/i_n331054.webp",
                "golden_image": "/cards/i_n335054.webp",
                "hi_res_image": "/cards/i_n331054_gcg_high_resolution.webp",
                "cost": '3 White',
                "description": "Character deals +1 DMG. \n\nWhen played: During this Round, the next time you play a Talent card or a Character uses an Elemental Skill, spend 2 fewer Elemental Dice. \n\n(Only Polearm Characters can equip this. A character can equip a maximum of 1 Weapon.)",
                "flavor": '"Children fascinated by the moon will weep when they gaze upon it, for the moon has turned into fine sand and entered their eyes. In many stories, no tears are shed in vain."',
                'id': '78'
            },

            'primordialjadewinged-spear': { 
                'name': 'Primordial Jade Winged-Spear',
                'tags': ['modify', 'weapon', 'weapon_pole'],
                'hi_res_image': '/cards/i_n331061_gcg_high_resolution.webp',
                'image': '/cards/i_n331061.webp',
                'golden_image': '/cards/i_n335061.webp',
                'cost': '3 White',
                'description': "The character deals +1 DMG. \n\nAfter this character uses a Skill: Until the end of this Round, +1 additional DMG provided by this card. (Up to +2 DMG total.) \n\n(Only Polearm Characters can equip this. A character can equip a maximum of 1 Weapon)",
                'flavor': "\"The stone bird took to the unbound skies once forged. Into the heart of the ocean it dove, into the battlefield with the behemoth and the whale. Into the depths of the sea the behemoth sank, there to stay forever. Released from its thundering roars were the people of Liyue.\"",
                'id': '8E',
            },

            'rightfulreward': { 
                'name': 'Rightful Reward',
                'tags': ['modify', 'weapon', 'weapon_pole'],
                'hi_res_image': '/cards/i_n331072_gcg_high_resolution.webp',
                'image': '/cards/i_n331072.webp',
                'golden_image': '/cards/i_n335072.webp',
                'cost': '2 White',
                'description': "Character's Elemental Burst deals +2 DMG. \n\nAfter your active character takes DMG or is healed: Gain 1 Principle of Justice point. If this card has already accumulated 4 such points, consume 4 points and grant this character 1 Energy. \n\n(Only Polearm Characters can equip this. A character can equip a maximum of 1 Weapon)",
                'flavor': "\"That is how the world ought to operate, and how righteousness should be.\"\n\"But when it comes to \"how things ought to be,\" it is always fiendishly difficult to get ideal results.\"",
                'id': 'AE',
            },

            "prospectorsdrill": {
                'name': "Prospector's Drill",
                'tags': ['modify', 'weapon', 'weapon_pole', 'damage reduction'],
                'hi_res_image': '/cards/gcg_311409_hd.webp',
                'image': '/cards/gcg_311409.webp',
                'golden_image': '/cards/gcg_311409_golden.webp',
                'cost': '2 White',
                'description': "When the character to which this is attached takes DMG: If possible, Discard 1 card from your Hand with the highest Current Elemental Dice Cost to negate 1 damage, and then gain 1 Solidarity point. (Once per Round) \n\nWhen a character deals DMG: If there are Solidarity points already, consume all points and increase DMG dealt this instance by 1, then draw 1 card for each point consumed. \n\n(Only Polearm Characters can equip this. A character can equip a maximum of 1 Weapon)",
                'flavor': "\"The tool's piercing and cutting power were unmatched.\nSince it could pierce through even rocks like a hot knife through butter,\nit made quick work out of penetrating through even softer materials.\"",
                'id': 'B6',
            },
            
            "travelershandysword": {
                "name": "Traveler’s Handy Sword",
                "tags": ['modify', 'weapon', 'weapon_sword'],
                "image": "/cards/i_n331012.webp",
                "golden_image": "/cards/i_n335012.webp",
                "hi_res_image": "/cards/i_n331012_gcg_high_resolution.webp",
                "cost": '2 White',
                "description": "The character deals +1 DMG.\n\n(Only Sword Characters can equip this. A character can equip a maximum of 1 Weapon)",
                "flavor": "A handy steel sword that contains all manner of useful items in its sheath.",
                "id": '1V'        
            },
            
            "sacrificialsword": {
                "name": "Sacrificial Sword",
                "tags": ['modify', 'weapon', 'weapon_sword'],
                "image": "/cards/i_n331013.webp",
                "golden_image": "/cards/i_n335013.webp",
                "hi_res_image": "/cards/i_n331013_gcg_high_resolution.webp",
                "cost": '3 White',
                "description": "The character deals +1 DMG.\n\nAfter the character uses an Elemental Skill: Create 1 Elemental Die of the same Elemental Type as this character. (Once per Round)\n\n(Only Sword Characters can equip this. A character can equip a maximum of 1 Weapon)",
                "flavor": "This blade was just a prop before its blade was sharpened by the passage of time.",
                "id": '1W'        
            },
            
            "aquilafavonia": {
                "name": "Aquila Favonia",
                "tags": ['modify', 'weapon', 'weapon_sword'],
                "image": "/cards/i_n331014.webp",
                "golden_image": "/cards/i_n335014.webp",
                "hi_res_image": "/cards/i_n331014_gcg_high_resolution.webp",
                "cost": '3 White',
                "description": "The character deals +1 DMG.\n\nAfter the opposing character uses a Skill: If the character with this attached is the active character, heal this character for 1 HP. (Max twice per Round)\n\n(Only Sword Characters can equip this. A character can equip a maximum of 1 Weapon)",
                "flavor": "This sword was ever at the hip of the warrior from another land, and it bore witness to her achievement in spreading justice and freedom across Mondstadt.",
                "id": '1X'        
            },

            "skywardblade": {
                "name": "Skyward Blade",
                "tags": ['modify', 'weapon', 'weapon_sword'],
                "image": "/cards/i_n331044.webp",
                "golden_image": "/cards/i_n335045.webp",
                "hi_res_image": "/cards/i_n331044_gcg_high_resolution.webp",
                "cost": '3 White',
                "description": "The character deals +1 DMG.\n\nOnce per Round: This character's Normal Attacks deal +1 additional DMG.\n\n(Only Sword Characters can equip this. A character can equip a maximum of 1 Weapon)",
                "flavor": "The sky-piercing fang. With nemesis vanquished, the wind dragon fell into a deep slumber.\nCenturies passed, and Dvalin's sacrifice was all but forgotten by Mondstadt.\nA prayer, this sword is. May Dvalin's name be restored.",
                'id': '5K'
            },
    
            "favoniussword": {
                "name": "Favonius Sword",
                "tags": ['modify', 'weapon', 'weapon_sword'],
                "image": "/cards/i_n331045.webp",
                "golden_image": "/cards/i_n335037.webp",
                "hi_res_image": "/cards/i_n331045_gcg_high_resolution.webp",
                "cost": '3 White',
                "description": "The character deals +1 DMG.\n\nAfter the character uses an Elemental Skill: The character gains 1 additional Energy. (Once per Round)\n\n(Only Sword Characters can equip this. A character can equip a maximum of 1 Weapon)",
                "flavor": "\"Legend has it that the knight that bore the title of Wolf Pup could cleave even raindrops with his blade, and the gales spurred by his blows were strong enough to snap roses. Though none could match the heights of the Wolf Pup's prowess, the knights bear his oath of protection yet, his legacy lasting even to the present.\"",
                "id": '4L'
            },

            'lightoffoliarincision': { 
                'name': 'Light of Foliar Incision',
                'tags': ['modify', 'weapon', 'weapon_sword'],
                'hi_res_image': '/cards/i_n331062_gcg_high_resolution.webp',
                'image': '/cards/i_n331062.webp',
                'golden_image': '/cards/i_n335062.webp',
                'cost': '3 White',
                'description': "The character deals +1 DMG. \n\nAfter the character uses a Normal Attack: Create 1 random basic Elemental Die. (Can be triggered up to twice per Round) \n\n(Only Sword Characters can equip this. A character can equip a maximum of 1 Weapon)",
                'flavor': "\"If you believe that he yet has the potential to reclaim his honor in the maze, then guide him to break off the pale branch...\nOnly then can the bright moon and the newborn stars grant him pure wisdom and help him shed his bitter memories and desires.\"",
                'id': '8F',
            },

            'sapwoodblade': { 
                'name': 'Sapwood Blade',
                'tags': ['modify', 'weapon', 'weapon_sword'],
                'hi_res_image': '/cards/i_n331068_gcg_high_resolution.webp',
                'image': '/cards/i_n331068.webp',
                'golden_image': '/cards/i_n335068.webp',
                'cost': '3 Black',
                'description': "The character deals +1 DMG. \n\nWhen entering play: When the character to which this is attached next uses a Normal Attack during this Round: Create 2 Elemental Dice of this character's Elemental Type. \n\n(Only Sword Characters can equip this. A character can equip a maximum of 1 Weapon)",
                'flavor': "\"...Even so, your stories and mine will leave their traces in the depths of the desert, like the footprints of the Forest Kind.\"\n\"So shall past friendships peacefully sleep, like an Aranara transformed into a seed.\"",
                'id': '93',
            },

            'splendor': { 
                'name': "Splendor of Tranquil Waters",
                'tags': ['modify', 'weapon', 'weapon_sword'],
                'hi_res_image': '/cards/i_n331077_gcg_high_resolution.webp',
                'image': '/cards/i_n331077.webp',
                'golden_image': '/cards/i_n335077.webp',
                'cost': '2 White',
                'description': "After your characters take DMG or are healed: This card gains 1 Lakelight point. \n\nWhen this character uses a Normal Attack: If you have already accumulated 12 Lakelight points, consume 12 points, and this Skill costs 2 less Unaligned Element, deals +1 DMG, and heals the equipping character for 1 HP (once per Round). \n\n(Only Sword Characters can equip this. A character can equip a maximum of 1 Weapon)",
                'flavor': "\"...On a morning clear as the light reflected on the lake, the Mistress of Many Waters was moved by that pained plea.\nAnd so the kindly goddess granted her wish and gave her blessing to the journey ahead.\nFor the Mistress of Many Waters knew that a fair judgment was the greatest leniency one could give a selfless soul.\nAnd perhaps that is why that noble verdict dyed fate in its colors.\"",
                'id': 'AJ',
            },

            "thedockhandsassistant": {
                'name': "The Dockhand's Assistant",
                'tags': ['modify', 'weapon', 'weapon_sword', 'damage reduction'],
                'hi_res_image': '/cards/gcg_311509_hd.webp',
                'image': '/cards/gcg_311509.webp',
                'golden_image': '/cards/gcg_311509_golden.webp',
                'cost': '2 White',
                'description': "When the character to which this is attached takes DMG: If possible, Discard 1 card from your Hand with the highest Current Elemental Dice Cost to negate 1 damage, and then gain 1 Solidarity point. (Once per Round) \n\nWhen the character deals DMG: If there are Solidarity points already, consume all points and increase DMG dealt this instance by 1, then draw 1 card for each point consumed. \n\n(Only Sword Characters can equip this. A character can equip a maximum of 1 Weapon)",
                'flavor': "\"Although such blades were not owned by their wielders, those who depended on them saw them as extensions of their limbs, and so they often inscribed their names onto the hilts and blades to avoid losing them. The name inscribed on this blade belongs to one of Poisson's former mayors.\"",
                'id': 'DF',
            },
            
            "adventurersbandana": {
                "name": "Adventurer’s Bandana",
                "tags": ['modify', 'artifact'],
                "image": "/cards/i_n331015.webp",
                "golden_image": "/cards/i_n335015.webp",
                "hi_res_image": "/cards/i_n331015_gcg_high_resolution.webp",
                "cost": '1 White',
                "description": "After the character uses a Normal Attack: Heal self for 1 HP. (Max 3 times per Round) \n\n(A character can equip a maximum of 1 Artifact)",
                "flavor": "“All the secrets of the stars and the abyss await discovery by mere mortals.”",
                "id": '1Y'        
            },
            
            "luckydogssilvercirclet": {
                "name": "Lucky Dog’s Silver Circlet",
                "tags": ['modify', 'artifact'],
                "image": "/cards/i_n331016.webp",
                "golden_image": "/cards/i_n335016.webp",
                "hi_res_image": "/cards/i_n331016_gcg_high_resolution.webp",
                "cost": '2 Black',
                "description": "After the character uses an Elemental Skill: Heal self for 2 HP. (Once per Round) \n\n(A character can equip a maximum of 1 Artifact)",
                "flavor": "“One who is favored by fortune can even find priceless treasures in the most deadly of traps.”",
                "id": '1Z'        
            },
            
            "travelingdoctorshandkerchief": {
                "name": "Traveling Doctor’s Handkerchief",
                "tags": ['modify', 'artifact'],
                "image": "/cards/i_n331017.webp",
                "golden_image": "/cards/i_n335017.webp",
                "hi_res_image": "/cards/i_n331017_gcg_high_resolution.webp",
                "cost": '1 White',
                "description": "After the character uses an Elemental Burst: Heal all your characters for 1 HP. (Once per Round) \n\n(A character can equip a maximum of 1 Artifact)",
                "flavor": "“Come sun or rain, nothing could stay the traveling doctor’s steps.”",
                "id": '20'        
            },
            
            "gamblersearrings": {
                "name": "Gambler’s Earrings",
                "tags": ['modify', 'artifact'],
                "image": "/cards/i_n331018.webp",
                "golden_image": "/cards/i_n335018.webp",
                "hi_res_image": "/cards/i_n331018_gcg_high_resolution.webp",
                "cost": '1 White',
                "description": "After an opposing character is defeated: If the character this card is attached to is the active character, create 'Omni Element' ×2.(Can happen 3 times per match)\n\n(A character can equip a maximum of 1 Artifact)",
                "flavor": "“In games where one gambles with life and death, remaining calm and composed is key to increasing one’s odds of victory.”",
                "id": '21'          
            },
            
            "instructorscap": {
                "name": "Instructor’s Cap",
                "tags": ['modify', 'artifact'],
                "image": "/cards/i_n331019.webp",
                "golden_image": "/cards/i_n335019.webp",
                "hi_res_image": "/cards/i_n331019_gcg_high_resolution.webp",
                "cost": '2 Black',
                "description": "After the character triggers an Elemental Reaction: Create 1 Elemental Die that matches this Character's Elemental Type. (Max 3 times per Round) \n\n(A character can equip a maximum of 1 Artifact)",
                "flavor": "“I don’t have the talent to command an army as its general, nor am I qualified for anything beyond being a soldier.”\n“All I can do is to be a strict instructor to these children, so that they might survive on the battlefield a bit longer.”",
                "id": '22'        
            },
            
            "exilescirclet": {
                "name": "Exile’s Circlet",
                "tags": ['modify', 'artifact'],
                "image": "/cards/i_n331020.webp",
                "golden_image": "/cards/i_n335020.webp",
                "hi_res_image": "/cards/i_n331020_gcg_high_resolution.webp",
                "cost": '2 Black',
                "description": "After the character uses an Elemental Burst: All your characters on standby gain 1 Energy. (Once per Round) \n\n(A character can equip a maximum of 1 Artifact)",
                "flavor": "“Woe to thee, oh great hall with silver piled high! Why is your crown drenched in blood?”",
                "id": '23'        
            },
    
            "ornatekabuto": {
                "name": "Ornate Kabuto",
                "tags": ['modify', 'artifact'],
                "image": "/cards/i_n331035.webp",
                "golden_image": "/cards/i_n335035.webp",
                "hi_res_image": "/cards/i_n331035_gcg_high_resolution.webp",
                "cost": '1 White',
                "description": "After another character of yours uses an Elemental Burst: The character to which this is attached gains 1 Energy. (A character can equip a maximum of 1 Artifact)",
                "flavor": "\"Thirteen years went by like a dream. The scarlet snow flies through the shadowed pass like smoke. You have now gone afar.\"",
                "id": '4D'        
            },
    
            "emblemofseveredfate": {
                "name": "Emblem of Severed Fate",
                "tags": ['modify', 'artifact'],
                "image": "/cards/i_n331046.webp",
                "golden_image": "/cards/i_n335046.webp",
                "hi_res_image": "/cards/i_n331046_gcg_high_resolution.webp",
                "cost": '2 White',
                "description": "After another character of yours uses an Elemental Burst: The character to which this is attached gains 1 Energy.\n\nThe DMG dealt by the character's Elemental Bursts is increased by 2 (once per Round).\n\n(A character can equip a maximum of 1 Artifact)",
                "flavor": 'Thirteen years went by like a dream.\nThe scarlet snow flies through the shadowed pass like smoke.\nYou have now gone afar.',
                'id': '5L'
            },
    
            "generalsancienthelm": {
                "name": "General's Ancient Helm",
                "tags": ['modify', 'artifact'],
                "image": "/cards/i_n331036.webp",
                "golden_image": "/cards/i_n335036.webp",
                "hi_res_image": "/cards/i_n331036_gcg_high_resolution.webp",
                "cost": '2 White',
                "description": "When Action Phase begins: The character to which this is attached gains Unmovable Mountain that provides 2 Shield points. \n\n(A character can equip a maximum of 1 Artifact)",
                "flavor": "\"The last drop of blood had soaked into the battlefield, and the glazed sands shone gloriously once more.\"",
                "id": '4E' 
            },
    
            "tenacityofthemillelith": {
                "name": "Tenacity of the Millelith",
                "tags": ['modify', 'artifact'],
                "image": "/cards/i_n331047.webp",
                "golden_image": "/cards/i_n335047.webp",
                "hi_res_image": "/cards/i_n331047_gcg_high_resolution.webp",
                "cost": '3 White',
                "description": "When Action Phase begins: The character to which this is attached gains Unmovable Mountain that provides 2 Shield points. \n\nAfter this character takes DMG: If the character this card is attached to is the active character, create 1 Elemental Die matching this character's Elemental Type. (Once per Round) \n\n(A character can equip a maximum of 1 Artifact)",
                "flavor": '"...To ensure that the afflicted civilians could safely escape, and to maintain their honor in the eyes of the Lord of Geo, the helmet-clad troops of the front line took the lead, pointing their spears towards the Abyss and charging into battle."',
                'id': '5M',
            },
    
            "thunderingpoise": {
                "name": "Thundering Poise",
                "tags": ['modify', 'artifact'],
                "image": "/cards/i_n331048.webp",
                "golden_image": "/cards/i_n335048.webp",
                "hi_res_image": "/cards/i_n331048_gcg_high_resolution.webp",
                "cost": '2 Black',
                "description": "When you play a Talent card or a Character uses a Normal Attack: Spend 1 fewer Elemental Die. (Once per Round) \n\n(A character can equip a maximum of 1 Artifact)",
                "flavor": '"...Tianqiu once played host to a Yaksha, four-armed and mighty."\n"He came to The Chasm from afar, to the praises of the tribes."',
                'id': '5N'
            },
    
            "vermillionhereafter": {
                "name": "Vermillion Hereafter",
                "tags": ['modify', 'artifact'],
                "image": "/cards/i_n331049.webp",
                "golden_image": "/cards/i_n335049.webp",
                "hi_res_image": "/cards/i_n331049_gcg_high_resolution.webp",
                "cost": '3 Black',
                "description": "When you play a Talent card or a Character uses a Normal Attack: Spend 1 fewer Elemental Die. (Once per Round) \n\nAfter a character is switched to the active character: During this Round, character deals +1 Normal Attack DMG. \n\n(A character can equip a maximum of 1 Artifact)",
                "flavor": "\"Do you not hear? The drums die in the north wind, the hero sinks into the vortex.\"\n\"Have you not seen? The Yaksha's battle for the dawn — alas for a life so spent.\"",
                'id': '5O'
            },
            "capriciousvisage": {
                "name": "Capricious Visage",
                "tags": ['modify', 'artifact'],
                "image": "/cards/i_n331050.webp",
                "golden_image": "/cards/i_n335050.webp",
                "hi_res_image": "/cards/i_n331050_gcg_high_resolution.webp",
                "cost": '2 Black',
                "description": "When you play a Talent card or a Character uses an Elemental Skill: Spend 1 fewer Elemental Die. (Once per Round) \n\n(A character can equip a maximum of 1 Artifact)",
                "flavor": 'Even a faint smile could not conceal her sorrow.\nThough this is a festive day, it seems more like a farewell...',
                'id': '5P'
            },
            "shimenawasreminiscence": {
                "name": "Shimenawa's Reminiscence",
                "tags": ['modify', 'artifact'],
                "image": "/cards/i_n331051.webp",
                "golden_image": "/cards/i_n335051.webp",
                "hi_res_image": "/cards/i_n331051_gcg_high_resolution.webp",
                "cost": '3 Black',
                "description": "When you play a Talent card or a Character uses an Elemental Skill: Spend 1 fewer Elemental Die. (Once per Round) \n\nIf the character has at least 2 Energy, this character's Normal Attacks and Elemental Skills will deal +1 DMG. \n\n(A character can equip a maximum of 1 Artifact)",
                "flavor": '"...Losing one\'s memory is no different from losing one\'s life. It is like death amidst darkness eternal."\n"Life is full of uncertainty. Love is fleeting, and even lasting memories may be lost..."',
                'id': '5Q'
            },
            "crownofwatatsumi": {
                "name": "Crown of Watatsumi",
                "tags": ['modify', 'artifact'],
                "image": "/cards/i_n331055.webp",
                "golden_image": "/cards/i_n335055.webp",
                "hi_res_image": "/cards/i_n331055_gcg_high_resolution.webp",
                "cost": '1 White',
                "description": "For every 3 HP of healing your characters receive, this card accumulates 1 Sea-Dyed Foam. (Maximum of 2) \n\nWhen this character deals DMG: Consume all Sea-Dyed Foam. DMG is increased by 1 for each one consumed. \n\n(A character can equip a maximum of 1 Artifact)",
                "flavor": "\"The people of the sea sing that these crowns of pearls and coral will never be stained by any dirt.\"",
                'id': '79'
            },

            "oceanhuedclam": {
                "name": "Ocean Hued Clam",
                "tags": ['modify', 'artifact'],
                "image": "/cards/i_n331056.webp",
                "golden_image": "/cards/i_n335056.webp",
                "hi_res_image": "/cards/i_n331056_gcg_high_resolution.webp",
                "cost": '3 Black',
                "description": "When played: Heal the character to which this is attached for 2 HP. \n\nFor every 3 HP of healing your characters receive, this card accumulates 1 Sea-Dyed Foam. (Maximum of 2) \n\nWhen this character deals DMG: Consume all Sea-Dyed Foam. DMG is increased by 1 for each one consumed. \n\n(A character can equip a maximum of 1 Artifact)",
                "flavor": '"Bringing hopes and memories from the depths, permeating long-lost civilizations and history, these graceful and exquisite crowns slide into the forgotten rifts with their owners."',
                'id': '7K'
            },

            "shadowofthesandking": {
                "name": "Shadow of the Sand King",
                "tags": ['modify', 'artifact'],
                "image": "/cards/i_n331057.webp",
                "golden_image": "/cards/i_n335057.webp",
                "hi_res_image": "/cards/i_n331057_gcg_high_resolution.webp",
                "cost": '1 White',
                "description": "When played: Draw a card. \n\nWhen the character to which this card is attached is your active character, then when an opposing character takes Elemental Reaction DMG: Draw a card. (Once per Round) \n\n(A character can equip a maximum of 1 Artifact)",
                "flavor": "\"Once, the wise mortal king and the clergy received divine oracles personally, and they were the masters of the land.\"\n\"Today, those who rule as proxies in the oases are the shadows of the gods.\"",
                'id': '7L'
            },

            'gildeddreams': { 
                'name': 'Gilded Dreams',
                'tags': ['modify', 'artifact'],
                'hi_res_image': '/cards/i_n331063_gcg_high_resolution.webp',
                'image': '/cards/i_n331063.webp',
                'golden_image': '/cards/i_n335063.webp',
                'cost': '3 White',
                'description': "When played: Generate 1 Die of the same Element as the character to which this is attached. If you have 3 different Elemental Types in your party, generate 2 such Dice instead. \n\nWhen the character to which this card is attached is your active character, then when an opposing character takes Elemental Reaction DMG: Draw 1 card. (Up to twice per Round) \n\n(A character can equip a maximum of 1 Artifact)",
                'flavor': "\"Some time later, absurd decisions would be issued alongside illusory madness, using lovely expectations as bait to lead the people towards a bitter end.\"",
                'id': '8G',
            },

            'flowingrings': { 
                'name': 'Flowing Rings',
                'tags': ['modify', 'artifact'],
                'hi_res_image': '/cards/i_n331064_gcg_high_resolution.webp',
                'image': '/cards/i_n331064.webp',
                'golden_image': '/cards/i_n335064.webp',
                'cost': '0 White',
                'description': "After the character uses a Normal Attack: Draw 1 card. (Once per Round) \n\n(A character can equip a maximum of 1 Artifact)",
                'flavor': "\"...And the stone that had been lost to the waters may have been a lesser jade, or perhaps just a simple cup. Some even say that the \"jade\" in the tale is in fact an analogy for a beautiful person.\"",
                'id': '8H',
            },

            'echoesofanoffering': { 
                'name': 'Echoes of an Offering',
                'tags': ['modify', 'artifact'],
                'hi_res_image': '/cards/i_n331065_gcg_high_resolution.webp',
                'image': '/cards/i_n331065.webp',
                'golden_image': '/cards/i_n335065.webp',
                'cost': '2 White',
                'description': "After this character uses Normal Attack: Draw 1 card. (Once per Round) \n\nAfter this character uses a Skill: If you do not have more Elemental Dice than cards in your Hand, you will gain 1 Elemental Die of the attached character's Type. (Once per Round) \n\n(A character can equip a maximum of 1 Artifact)",
                'flavor': "\"The wide river of a legend will oft produce many tributaries. One of these goes like this: This gem was once jade from a sacred mountain, carved into its current shape only by the hand of Rex Lapis himself.\"", 
                'id': '8I',
            },

            'heartofkhvarenasbrilliance': { 
                'name': 'Heart of Khvarena\'s Brilliance',
                'tags': ['modify', 'artifact'],
                'hi_res_image': '/cards/i_n331066_gcg_high_resolution.webp',
                'image': '/cards/i_n331066.webp',
                'golden_image': '/cards/i_n335066.webp',
                'cost': '0 White',
                'description': "After this character takes DMG: If the character to which this is attached is the active character, then draw 1 card. (Once per Round) \n\n(A character can equip a maximum of 1 Artifact)",
                'flavor': "\"If the darkness of death did not threaten it, no life would have any importance.\nIf the waves of forgetfulness did not surge against them, there would be no histories worth recording...\"",
                'id': '8J',
            },

            'vourukashasglow': { 
                'name': 'Vourukasha\'s Glow',
                'tags': ['modify', 'artifact'],
                'hi_res_image': '/cards/i_n331067_gcg_high_resolution.webp',
                'image': '/cards/i_n331067.webp',
                'golden_image': '/cards/i_n335067.webp',
                'cost': '1 White',
                'description': "After this character takes DMG: If the character to which this is attached is the active character, then draw 1 card. During this End Phase, heal the attached character for 1 HP. (Once per Round) \n\n(A character can equip a maximum of 1 Artifact)",
                'flavor': "\"Many spirits dwell in the sea, and they carry the wishes of grass, tree, and dew, cleansing all filth.\nMany spirits dwell in the sea, and they sing of the three mothers — of verdure, of sweet dew, and of fresh flowers.\"",
                'id': '8K',
            },

            'veteransvisage': { 
                'name': 'Veteran\'s Visage',
                'tags': ['modify', 'artifact'],
                'hi_res_image': '/cards/i_n331069_gcg_high_resolution.webp',
                'image': '/cards/i_n331069.webp',
                'golden_image': '/cards/i_n335069.webp',
                'cost': '2 Black',
                'description': "After the character takes DMG or is healed: Based on the number of times this effect has been triggered this Round, the effects will be different. \n\nFirst Trigger: Create 1 Elemental Die of the character's Elemental Type. \n\nSecond Trigger: Draw 1 card. \n\n(A character can equip a maximum of 1 Artifact)",
                'flavor': "\"Yet even though the scars can be covered, the wounds laid on one's heart will not disappear.\"",
                'id': '94',
            },

            'goldentroupesreward': { 
                'name': 'Golden Troupe\'s Reward',
                'tags': ['modify', 'artifact'],
                'hi_res_image': '/cards/i_n331071_gcg_high_resolution.webp',
                'image': '/cards/i_n331071.webp',
                'golden_image': '/cards/i_n335071.webp',
                'cost': '0 White',
                'description': "End Phase: If the character to which this is attached is on standby, this card gains 1 \"Recompense\" point. (Max 2 points) \n\nWhen you play a Talent card or a Character uses an Elemental Skill: For each \"Recompense\" point this card has, consume it to spend 1 fewer Elemental Die. \n\n(A character can equip a maximum of 1 Artifact)",
                'flavor': "\"When the great golden symphony plays once more, the Golden Troupe will receive the rightful rewards owed to the true and loyal.\"\n\"When the perfect order separates humanity into master and servant, prosperity and beauty shall make the kingdom glorious once more...\"",
                'id': '9J',
            },

            'amethystcrown': { 
                'name': 'Amethyst Crown',
                'tags': ['modify', 'artifact'],
                'hi_res_image': '/cards/i_n331073_gcg_high_resolution.webp',
                'image': '/cards/i_n331073.webp',
                'golden_image': '/cards/i_n335073.webp',
                'cost': "0 White",
                'description': "After an opponent takes DMG: If this DMG is Dendro DMG or triggers Dendro-Related Reactions, Gain 1 Crowning Crystal. (Max 2 stacks.) \n\nWhen the Action Phase begins: If your Crowning Crystal count is 2, the next Elemental Reaction you trigger deals +2 DMG during this Round. \n\n(A character can equip a maximum of 1 Artifact)",
                'flavor': "\"In honor of the eternal oasis and the flourishing Padisarahs, the Lord of Flowers wore an amethyst crown.\"",
                'id': 'AF',
            },

            'marechausseehunter': { 
                'name': 'Marechaussee Hunter',
                'tags': ['modify', 'artifact'],
                'hi_res_image': '/cards/i_n331078_gcg_high_resolution.webp',
                'image': '/cards/i_n331078.webp',
                'golden_image': '/cards/i_n335078.webp',
                'cost': '3 Black',
                'description': "After the character takes DMG or is healed: Based on the number of times this effect has been triggered this Round, the effects will be different. \n\nFirst Trigger: Create 1 Elemental Die of this character's Elemental Type. \n\nSecond Trigger: Draw 1 card. \n\nFourth Trigger: Create 1 Elemental Die of this character's Elemental Type. \n\n(A character can equip a maximum of 1 Artifact)",
                'flavor': "\"'Pursue the phantoms in the dark, expel them all, and hunt them down.'\nSuch is the origin of the name 'Marechaussee Hunter,'\nCredited to one Cassiodor, who would be elevated to the revered title of 'Golden Hunter,'\nBut who saw the name as a humiliation.\"",
                'id': 'AK',
            },

            'goldentroupe': { 
                'name': 'Golden Troupe',
                'tags': ['modify', 'artifact'],
                'hi_res_image': '/cards/i_n331079_gcg_high_resolution.webp',
                'image': '/cards/i_n331079.webp',
                'golden_image': '/cards/i_n335079.webp',
                'cost': '2 White',
                'description': "End Phase: If the character to which this is attached is on standby, this card gains 2 \"Recompense\" point. (Max 4 points) \n\nWhen you play a Talent card or a Character uses an Elemental Skill: For each \"Recompense\" point this card has, consume it to spend 1 fewer Elemental Die. \n\n(A character can equip a maximum of 1 Artifact)",
                'flavor': "\"Abide until that day... Abide until that day...\nWhen every member of the Golden Troupe shall win the whole future as their prize.\"",
                'id': 'AL',
            },

            'flop': { 
                'name': 'Flower of Paradise Lost',
                'tags': ['modify', 'artifact'],
                'hi_res_image': '/cards/i_n331080_gcg_high_resolution.webp',
                'image': '/cards/i_n331080.webp',
                'golden_image': '/cards/i_n335080.webp',
                'cost': '2 White',
                'description': "After an opponent takes DMG: If this DMG is Dendro DMG DMG or triggers Dendro-Related Reactions, Gain 1 Crowning Crystal. (Max 5 stacks.) \n\nWhen the Action Phase begins or when your character triggers an Elemental Reaction: If your Crowning Crystal count is 5, create 1 Omni Element and draw 1 card. (Twice per Round) \n\n(A character can equip a maximum of 1 Artifact)",
                'flavor': "\"But 'eternity' is ultimately a lie. Intoxication and love could only grind memories down to broken dreams.\"",
                'id': 'AM',
            },

            "gladiatorstriumphus": {
                'name': "Gladiator's Triumphus",
                'tags': ['modify', 'artifact'],
                'hi_res_image': '/cards/gcg_312029_hd.webp',
                'image': '/cards/gcg_312029.webp',
                'golden_image': '/cards/gcg_312029_golden.webp',
                'cost': '0 White',
                'description': "When the character uses a Normal Attack: Spend 1 fewer Elemental Die if you have no more than 2 cards in your Hand. (Once per Round) \n\n(A character can equip a maximum of 1 Artifact)",
                'flavor': "\"Only in moments of victory could the slave have a taste of what it felt like to be a master. But the cost of this vain aspiration was for the faint glow of freedom to be shrouded by darkness.\nOn the day of his triumph, the gladiator finally caught a glimpse of the world outside his cell. He was a step closer to freedom.\"",
                'id': 'B7',
            },

            "conductorstophat": {
                'name': "Conductor's Top Hat",
                'tags': ['modify', 'artifact'],
                'hi_res_image': '/cards/gcg_312030_hd.webp',
                'image': '/cards/gcg_312030.webp',
                'golden_image': '/cards/gcg_312030_golden.webp',
                'cost': '1 White',
                'description': "After you switch to the character to which this is attached: Discard the card with the highest Current Elemental Dice Cost in your Hand and change 2 Elemental Dice into Omni Element, and spend 1 fewer Elemental Die the next time the character uses a Skill or plays a Talent. (Once per Round) \n\n(A character can equip a maximum of 1 Artifact)",
                'flavor': "\"The members then turned the notes into words and recorded their journey in a book.\nThis book, The Widsith as they called it, was still held tightly in the conductor's hands even after his death.\"",
                'id': 'BV',
            },

            "maidensfadingbeauty": {
                'name': "Maiden's Fading Beauty",
                'tags': ['modify', 'artifact'],
                'hi_res_image': '/cards/gcg_312031_hd.webp',
                'image': '/cards/gcg_312031.webp',
                'golden_image': '/cards/gcg_312031_golden.webp',
                'cost': '1 White',
                'description': "After the character to which this is attached receives healing from a source other than an Artifact: Heal the most damaged character on your side for 1 HP (Can be triggered up to twice per Round) \n\n(A character can equip a maximum of 1 Artifact)",
                'flavor': "\"...As time passed, fewer and fewer courters visited her with flowers. What did it matter? For her, time had already stopped long ago on that fateful day.\"",
                'id': 'C7',
            },

            "demonwarriorsfeathermask": {
                'name': "Demon-Warrior's Feather Mask",
                'tags': ['modify', 'artifact'],
                'hi_res_image': '/cards/gcg_312032_hd.webp',
                'image': '/cards/gcg_312032.webp',
                'golden_image': '/cards/gcg_312032_golden.webp',
                'cost': '1 White',
                'description': "After the character to which this is attached uses a Technique: Gain 1 Energy. (Once per Round) \n\n(A character can equip a maximum of 1 Artifact)",
                'flavor': "\"...Nonetheless, someone had to shoulder the responsibility, and the strong naturally should bear a greater burden.\nIt was only after witnessing true war that he first felt the weight of destiny.\"",
                'id': 'CG',
            },

            "crownofthesaints": {
                'name': "Crown of the Saints",
                'tags': ['modify', 'artifact'],
                'hi_res_image': '/cards/gcg_312033_hd.webp',
                'image': '/cards/gcg_312033.webp',
                'golden_image': '/cards/gcg_312033_golden.webp',
                'cost': '1 White',
                'description': "After the character to which this is attached consumes Nightsoul points: The character's next Skill or Technique deals +1 DMG. (Twice per Round) \n\n(A character can equip a maximum of 1 Artifact)",
                'flavor': "\"Under the sun's radiance did the tribes make a pact of armistice, and thus did the sacred ones of the night realm lay their arguments aside and offer him the crown.\"",
                'id': 'DG',
            },

            "scrolloftheheroofcindercity": {
                'name': "Scroll of the Hero of Cinder City",
                'tags': ['modify', 'artifact'],
                'hi_res_image': '/cards/gcg_312034_hd.webp',
                'image': '/cards/gcg_312034.webp',
                'golden_image': '/cards/gcg_312034_golden.webp',
                'cost': '3 Black',
                'description': "After the character to which this is attached consumes Nightsoul points: One of your characters without maximum Energy gains 1 Energy. Repeats once. (Once per Round) \n\n(A character can equip a maximum of 1 Artifact)",
                'flavor': "\"The gates of hell are stained red by the flowing blood of the brave. Let me offer my blood, and leave the key to those gates with my child.\"",
                'id': 'DH',
            },

            "crownlesscrown": {
                'name': "Crownless Crown",
                'tags': ['modify', 'artifact'],
                'hi_res_image': '/cards/gcg_312035_hd.webp',
                'image': '/cards/gcg_312035.webp',
                'golden_image': '/cards/gcg_312035_golden.webp',
                'cost': '0 White',
                'description': "After you trigger Burning: The opponent's current active character will receive +1 DMG the next time they take DMG. (Once per Round) \n\n(A character can equip a maximum of 1 Artifact)",
                'flavor': "\"And with those things bearing his name, she walked into the dark night, never to return.\"",
                'id': 'DU',
            },

            "whimsicaldanceofthewithered": {
                'name': "Whimsical Dance of the Withered",
                'tags': ['modify', 'artifact'],
                'hi_res_image': '/cards/gcg_312036_hd.webp',
                'image': '/cards/gcg_312036.webp',
                'golden_image': '/cards/gcg_312036_golden.webp',
                'cost': '0 White',
                'description': "After the character to which this is attached uses a Skill: Both sides' active characters gain 1 stack of Bond of Life. (Once per Round) \n\n(A character can equip a maximum of 1 Artifact)",
                'flavor': "\"In the end, all dreams shall merge into one, bringing ultimate salvation to all the people of the world.\"",
                'id': 'DV',
            },

            "royalmasque": {
                'name': "Royal Masque",
                'tags': ['modify', 'artifact'],
                'hi_res_image': '/cards/gcg_312037_hd.webp',
                'image': '/cards/gcg_312037.webp',
                'golden_image': '/cards/gcg_312037_golden.webp',
                'cost': '0 White',
                'description': "After the character to which this is attached uses an Elemental Burst: Your next character deals +1 DMG during this Round. (Once per Round) \n\n(A character can equip a maximum of 1 Artifact)",
                'flavor': "\"In that golden age, the nobles shared with the people their knowledge and profits.\nBut the later nobles were seduced by power. Their banquets were exclusively for their own pleasure.\"",
                'id': 'E8',
            },

            "unfinishedreverie": {
                'name': "Unfinished Reverie",
                'tags': ['modify', 'artifact'],
                'hi_res_image': '/cards/gcg_312038_hd.webp',
                'image': '/cards/gcg_312038.webp',
                'golden_image': '/cards/gcg_312038_golden.webp',
                'cost': '2 White',
                'description': "Your Burning Flame and Burning reactions deal +1 DMG. (Twice per Round) \n\n(A character can equip a maximum of 1 Artifact)",
                'flavor': "\"Do not break faith with the eyes of those still willing to gaze upon the burning flames.\"",
                'id': 'E9',
            },

            "fragmentofharmonicwhimsy": {
                'name': "Fragment of Harmonic Whimsy",
                'tags': ['modify', 'artifact'],
                'hi_res_image': '/cards/gcg_312039_hd.webp',
                'image': '/cards/gcg_312039.webp',
                'golden_image': '/cards/gcg_312039_golden.webp',
                'cost': '2 White',
                'description': "After the character to which this is attached uses a Skill: All your characters gain 1 stack of Bond of Life, and you consume 1 fewer Elemental Dice the next time your character uses a Skill. (Once per Round) \n\n(A character can equip a maximum of 1 Artifact)",
                'flavor': "\"If I truly did have a chance to choose, then I would be able to change the unchangeable end of which you spoke.\"",
                'id': 'EA',
            },

            "felldragonsmonocle": {
                'name': "Fell Dragon's Monocle",
                'tags': ['modify', 'artifact'],
                'hi_res_image': '/cards/gcg_312040_hd.webp',
                'image': '/cards/gcg_312040.webp',
                'golden_image': '/cards/gcg_312040_golden.webp',
                'cost': '1 White',
                'description': "After the character to which this is attached uses an Elemental Skill: Adventure: Once (Once per Round) \n\n(A character can equip a maximum of 1 Artifact)",
                'flavor': "\"I will surely return to save all souls. Ten years, even a hundred years may pass, but I shall be reborn as a new universe.\"",
                'id': 'EO',
            },

            "noblesseoblige": {
                'name': "Noblesse Oblige",
                'tags': ['modify', 'artifact'],
                'hi_res_image': '/cards/gcg_312041_hd.webp',
                'image': '/cards/gcg_312041.webp',
                'golden_image': '/cards/gcg_312041_golden.webp',
                'cost': '3 Black',
                'description': "When played: The character to which this is attached gains 1 Energy. \n\nAfter the character to which this is attached uses an Elemental Burst: Your characters deal +1 DMG the next 3 times they deal DMG. \n\n(A character can equip a maximum of 1 Artifact)",
                'flavor': "\"They were noble not only in lineage, but also in their commitment to virtues and principles.\nThe longevity of the nobles was cut short by their endless self-indulgence. Ostentation gave way to devolution.\"",
                'id': 'EP',
            },

            "nymphsdream": {
                'name': "Nymph's Dream",
                'tags': ['modify', 'artifact'],
                'hi_res_image': '/cards/gcg_312043_hd.webp',
                'image': '/cards/gcg_312043.webp',
                'golden_image': '/cards/gcg_312043_golden.webp',
                'cost': '2 White',
                'description': "When the attached character uses a Skill: Starts an Adventure. (Twice per Round) \n\nIf you have completed an Adventure, the attached character deals +1 DMG. \n\n(A character can equip a maximum of 1  Artifact)",
                'flavor': "\"And just as how some people treasure withered flowers, some still reminisce endlessly over the afternoon adventures that have yet to continue...\"",
                'id': 'EZ',
            },

            "dyedtassel": {
                'name': "Dyed Tassel",
                'tags': ['modify', 'artifact'],
                'hi_res_image': '/cards/gcg_312044_hd.webp',
                'image': '/cards/gcg_312044.webp',
                'golden_image': '/cards/gcg_312044_golden.webp',
                'cost': '2 Black',
                'description': "When the character to which this is attached uses a Charged Attack: Deals +1 DMG. (Once per Round) \n\nAfter the attached character uses a Plunging Attack: Create 1 stack of Efficient Switch. (Once per Round) \n\n(A character can equip a maximum of 1  Artifact)",
                'flavor': "\"That ghostly blue wildfire of which ancient legends spoke would burn brightly anew on fresh fields of battle...\"",
                'id': 'FC',
            },

            "gladiatorsfinale": {
                'name': "Gladiator's Finale",
                'tags': ['modify', 'artifact'],
                'hi_res_image': '/cards/gcg_312045_hd.webp',
                'image': '/cards/gcg_312045.webp',
                'golden_image': '/cards/gcg_312045_golden.webp',
                'cost': '2 Black',
                'description': "The character to which this is attached deals +1 Physical DMG. \n\nWhen the character to which this is attached is your only character still not defeated: Their Normal Attack costs 1 fewer Unaligned Element and deals +1 DMG. (Twice per Round) \n\n(A character can equip a maximum of 1  Artifact)",
                'flavor': "\"The gladiator's healing wounds were covered with invisible feathers.\nHe eventually set off on a journey, finally as free as a bird. His destination was the place where flowers bloom and birds soar.\"",
                'id': 'GE',
            },

            "recollectionofdayspast": {
                'name': "Recollection of Days Past",
                'tags': ['modify', 'artifact'],
                'hi_res_image': '/cards/gcg_312046_hd.webp',
                'image': '/cards/gcg_312046.webp',
                'golden_image': '/cards/gcg_312046_golden.webp',
                'cost': '1 White',
                'description': "After your character receives healing from a source other than an Artifact: This card gains 1 stack of Yearning (max 4). At the start of the round, for every 2 stacks of Yearning, heal the attached character for 1 HP. \n\n(A character can equip a maximum of 1 Artifact)",
                'flavor': "\"No matter what price I must pay, I will save you from those freezing fetters, your eternal chains. And when we finally enjoy the embrace of the Queen of All Waters once more, we shall take leave of trouble and sorrow.\"",
                'id': 'HF',
            },
            
            "brokenrimesecho": {
                "name": "Broken Rime’s Echo",
                "tags": ['modify', 'artifact'],
                "image": "/cards/i_n331021.webp",
                "golden_image": "/cards/i_n335021.webp",
                "hi_res_image": "/cards/i_n331021_gcg_high_resolution.webp",
                "cost": '2 Black',
                "description": "When you play a Talent card or a Character uses a Skill: Spend 1 less Cryo Die. (Once per Round) \n\n(A character can equip a maximum of 1 Artifact)",
                "flavor": "“Past the ice-sealed door, walking down the corridors to the depths, he will break off a branch of silver-white, and bring hope to the snowy land.”",
                "id": '24'        
            },
            
            "blizzardstrayer": {
                "name": "Blizzard Strayer",
                "tags": ['modify', 'artifact'],
                "image": "/cards/i_n331022.webp",
                "golden_image": "/cards/i_n335022.webp",
                "hi_res_image": "/cards/i_n331022_gcg_high_resolution.webp",
                "cost": '2 White',
                "description": "When you play a Talent card or a Character uses a Skill: Spend 1 less Cryo Die. (Once per Round) \n\nRoll Phase: 2 of the starting Elemental Dice you roll are always guaranteed to be Cryo. \n\n(A character can equip a maximum of 1 Artifact)",
                "flavor": "“…Then please, live on. Do not accompany us unto our doom — to languish forgotten in the snow.”",
                "id": '25'        
            },
            
            "winestainedtricorne": {
                "name": "Wine-Stained Tricorne",
                "tags": ['modify', 'artifact'],
                "image": "/cards/i_n331023.webp",
                "golden_image": "/cards/i_n335023.webp",
                "hi_res_image": "/cards/i_n331023_gcg_high_resolution.webp",
                "cost": '2 Black',
                "description": "When you play a Talent card or a Character uses a Skill: Spend 1 less Hydro Die. (Once per Round) \n\n(A character can equip a maximum of 1 Artifact)",
                "flavor": "“The wine-sodden sea hat was thrust by a storm into the sky, and then carried away on the roiling waves, while those fated to lose their homelands engaged in battles bereft of hope and want.”",
                "id": '26'        
            },
            
            "heartofdepth": {
                "name": "Heart of Depth",
                "tags": ['modify', 'artifact'],
                "image": "/cards/i_n331024.webp",
                "golden_image": "/cards/i_n335024.webp",
                "hi_res_image": "/cards/i_n331024_gcg_high_resolution.webp",
                "cost": '2 White',
                "description": "When you play a Talent card or a Character uses a Skill: Spend 1 less Hydro Die. (Once per Round) \n\nRoll Phase: 2 of the starting Elemental Dice you roll are always guaranteed to be Hydro. \n\n(A character can equip a maximum of 1 Artifact)",
                "flavor": "“For all deaths are in vain. There is no saving those who indulge in the past.”",
                "id": '27'        
            },
            
            "witchsscorchinghat": {
                "name": "Witch’s Scorching Hat",
                "tags": ['modify', 'artifact'],
                "image": "/cards/i_n331025.webp",
                "golden_image": "/cards/i_n335025.webp",
                "hi_res_image": "/cards/i_n331025_gcg_high_resolution.webp",
                "cost": '2 Black',
                "description": "When you play a Talent card or a Character uses a Skill: Spend 1 less Pyro Die. (Once per Round) \n\n(A character can equip a maximum of 1 Artifact)",
                "flavor": "“…You ashes who dance so wildly, answer me — why have you taken all that I love?”",
                "id": '28'        
            },
            
            "crimsonwitchofflames": {
                "name": "Crimson Witch of Flames",
                "tags": ['modify', 'artifact'],
                "image": "/cards/i_n331026.webp",
                "golden_image": "/cards/i_n335026.webp",
                "hi_res_image": "/cards/i_n331026_gcg_high_resolution.webp",
                "cost": '2 White',
                "description": "When you play a Talent card or a Character uses a Skill: Spend 1 less Pyro Die. (Once per Round) \n\nRoll Phase: 2 of the starting Elemental Dice you roll are always guaranteed to be Pyro. \n\n(A character can equip a maximum of 1 Artifact)",
                "flavor": "“I will sing no elegies. I refuse laments. I shall not sigh. I have no use for pointless noise.\nIf justice is long dead, then to whom can I offer redemption?”",
                "id": '29'        
            },
            
            "thundersummonerscrown": {
                "name": "Thunder Summoner’s Crown",
                "tags": ['modify', 'artifact'],
                "image": "/cards/i_n331027.webp",
                "golden_image": "/cards/i_n335027.webp",
                "hi_res_image": "/cards/i_n331027_gcg_high_resolution.webp",
                "cost": '2 Black',
                "description": "When you play a Talent card or a Character uses a Skill: Spend 1 less Electro Die. (Once per Round) \n\n(A character can equip a maximum of 1 Artifact)",
                "flavor": "“The song pierced the storm’s low hum, ripped through the clouds, and bestowed upon it, light.”",
                "id": '2A'        
            },
            
            "thunderingfury": {
                "name": "Thundering Fury",
                "tags": ['modify', 'artifact'],
                "image": "/cards/i_n331028.webp",
                "golden_image": "/cards/i_n335028.webp",
                "hi_res_image": "/cards/i_n331028_gcg_high_resolution.webp",
                "cost": '2 White',
                "description": "When you play a Talent card or a Character uses a Skill: Spend 1 less Electro Die. (Once per Round) \n\nRoll Phase: 2 of the starting Elemental Dice you roll are always guaranteed to be Electro. \n\n(A character can equip a maximum of 1 Artifact)",
                "flavor": "“Then I shall sing you another tune — when you come again with thunder and rain!”",
                "id": '2B'        
            },
            
            "viridescentvenerersdiadem": {
                "name": "Viridescent Venerer’s Diadem",
                "tags": ['modify', 'artifact'],
                "image": "/cards/i_n331029.webp",
                "golden_image": "/cards/i_n335029.webp",
                "hi_res_image": "/cards/i_n331029_gcg_high_resolution.webp",
                "cost": '2 Black',
                "description": "When you play a Talent card or a Character uses a Skill: Spend 1 less Anemo Die. (Once per Round) \n\n(A character can equip a maximum of 1 Artifact)",
                "flavor": "“None could ever bestow a crown upon the queen of hunters, for only earth and heaven were higher than she.”",
                "id": '2C'        
            },
            
            "viridescentvenerer": {
                "name": "Viridescent Venerer",
                "tags": ['modify', 'artifact'],
                "image": "/cards/i_n331030.webp",
                "golden_image": "/cards/i_n335030.webp",
                "hi_res_image": "/cards/i_n331030_gcg_high_resolution.webp",
                "cost": '2 White',
                "description": "When you play a Talent card or a Character uses a Skill: Spend 1 less Anemo Die. (Once per Round) \n\nRoll Phase: 2 of the starting Elemental Dice you roll are always guaranteed to be Anemo. \n\n(A character can equip a maximum of 1 Artifact)",
                "flavor": "“One day, in those boundless hunting grounds… we will meet again.”",
                "id": '2D'        
            },
            
            "maskofsolitudebasalt": {
                "name": "Mask of Solitude Basalt",
                "tags": ['modify', 'artifact'],
                "image": "/cards/i_n331031.webp",
                "golden_image": "/cards/i_n335031.webp",
                "hi_res_image": "/cards/i_n331031_gcg_high_resolution.webp",
                "cost": '2 Black',
                "description": "When you play a Talent card or a Character uses a Skill: Spend 1 less Geo Die. (Once per Round) \n\n(A character can equip a maximum of 1 Artifact)",
                "flavor": "“He knew right from wrong, and he never missed his mark.”",
                "id": '2E'        
            },
            
            "archaicpetra": {
                "name": "Archaic Petra",
                "tags": ['modify', 'artifact'],
                "image": "/cards/i_n331032.webp",
                "golden_image": "/cards/i_n335032.webp",
                "hi_res_image": "/cards/i_n331032_gcg_high_resolution.webp",
                "cost": '2 White',
                "description": "When you play a Talent card or a Character uses a Skill: Spend 1 less Geo Die. (Once per Round) \n\nRoll Phase: 2 of the starting Elemental Dice you roll are always guaranteed to be Geo. \n\n(A character can equip a maximum of 1 Artifact)",
                "flavor": "“While the Millelith stands guard, evil shall never prevail!”",
                "id": '2F'        
            },
            
            "laurelcoronet": {
                "name": "Laurel Coronet",
                "tags": ['modify', 'artifact'],
                "image": "/cards/i_n331033.webp",
                "golden_image": "/cards/i_n335033.webp",
                "hi_res_image": "/cards/i_n331033_gcg_high_resolution.webp",
                "cost": '2 Black',
                "description": "When you play a Talent card or a Character uses a Skill: Spend 1 less Dendro Die. (Once per Round) \n\n(A character can equip a maximum of 1 Artifact)",
                "flavor": "“There is a time appointed for all things to live and die, and the cycle continues on forever.”",
                "id": '2G'        
            },
            
            "deepwoodmemories": {
                "name": "Deepwood Memories",
                "tags": ['modify', 'artifact'],
                "image": "/cards/i_n331034.webp",
                "golden_image": "/cards/i_n335034.webp",
                "hi_res_image": "/cards/i_n331034_gcg_high_resolution.webp",
                "cost": '2 White',
                "description": "When you play a Talent card or a Character uses a Skill: Spend 1 less Dendro Die. (Once per Round) \n\nRoll Phase: 2 of the starting Elemental Dice you roll are always guaranteed to be Dendro. \n\n(A character can equip a maximum of 1 Artifact)",
                "flavor": "“For all those who follow nature must pass through the maze of the forest and reach that endless plain.”",
                "id": '2H'        
            },

            "xenochromatichuntersray": {
                'name': "Xenochromatic Hunter's Ray",
                'tags': ['modify', 'technique'],
                'hi_res_image': '/cards/gcg_313001_hd.webp',
                'image': '/cards/gcg_313001.webp',
                'golden_image': '/cards/gcg_313001_golden.webp',
                'cost': '0 White',
                'description': "Technique: Fontemer Water Blades \n\nUsage(s): 2 \n\n(A character can only equip 1 Technique at a time)",
                'flavor': "Among the Fontemer Aberrants, there are certain strange \"Xenochromatic\" lifeforms. It is said that these are not actually living creatures, but rather spirits from the ocean that have neither taken physical form nor swallowed bait. They are said to bestow blessings upon those accepted by the Fontemer as well as those that are able to control it.\nThe Xenochromatic Hunter's Ray's Ability allows the wielder to release Fontemer Water Blades that are long and sharp.",
                'id': 'BH',
            },

            "yumkasaurus": {
                'name': "Yumkasaurus",
                'tags': ['modify', 'technique'],
                'hi_res_image': '/cards/gcg_313002_hd.webp',
                'image': '/cards/gcg_313002.webp',
                'golden_image': '/cards/gcg_313002_golden.webp',
                'cost': '1 White',
                'description': "Technique: Artful Grapple \n\nUsage(s): 2 \n\n(A character can only equip 1 Technique at a time)",
                'flavor': "Yumkasaurs are extremely skilled at latching onto heavy objects, then pulling themselves forward to move with great rapidity. They're also a great way to retrieve items from afar...",
                'id': 'BI',
            },

            "koholasaurus": {
                'name': "Koholasaurus",
                'tags': ['modify', 'technique'],
                'hi_res_image': '/cards/gcg_313003_hd.webp',
                'image': '/cards/gcg_313003.webp',
                'golden_image': '/cards/gcg_313003_golden.webp',
                'cost': '2 White',
                'description': "Technique: Spiritway \n\nUsage(s): 2 \n\n(A character can only equip 1 Technique at a time)",
                'flavor': "Only the Koholasaurs — and some adults from the People of the Springs who have mastered a variety of different skills — are able to use the Spiritways with unfettered facility, swiftly traversing these pathways of constantly flowing phlogiston...",
                'id': 'BJ',
            },

            "tepetlisaurus": {
                'name': "Tepetlisaurus",
                'tags': ['modify', 'technique'],
                'hi_res_image': '/cards/gcg_313004_hd.webp',
                'image': '/cards/gcg_313004.webp',
                'golden_image': '/cards/gcg_313004_golden.webp',
                'cost': '2 White',
                'description': "Technique: Burrowing Assault \n\nUsage(s): 2 \n\n(A character can only equip 1 Technique at a time)",
                'flavor': "\"Tepetlisaurs are skilled diggers, and as they tunnel through the earth, they occasionally uncover buried treasures...\"",
                'id': 'BW',
            },

            "iktomisaurus": {
                'name': "Iktomisaurus",
                'tags': ['modify', 'technique'],
                'hi_res_image': '/cards/gcg_313005_hd.webp',
                'image': '/cards/gcg_313005.webp',
                'golden_image': '/cards/gcg_313005_golden.webp',
                'cost': '2 White',
                'description': "Technique: Spiritual Support \n\nUsage(s): 2 \n\n(A character can only equip 1 Technique at a time)",
                'flavor': "\"According to legend, their ancestors did not have a physical form, and instead could drift like spirits between reality and the spiritual realm...\"",
                'id': 'C8',
            },

            "qucusaurus": {
                'name': "Qucusaurus",
                'tags': ['modify', 'technique'],
                'hi_res_image': '/cards/gcg_313006_hd.webp',
                'image': '/cards/gcg_313006.webp',
                'golden_image': '/cards/gcg_313006_golden.webp',
                'cost': '1 White',
                'description': "When played: Attach Target to the opposing active character. \n\nWhen an opposing character with Target attached switches to become the active character: You gain 1 stack of Efficient Switch and Agile Switch, and then cancel all Target attached to opposing characters. \n\nTechnique: Swift Glide \n\nUsage(s): 2 \n\n(A character can only equip 1 Technique at a time)",
                'flavor': "It is said that the ancestors of the Qucusaurs were the closest in form to the mighty winged dragons, and that they could soar through the sky like clouds.",
                'id': 'CH',
            },

            "waverider": {
                'name': "Waverider",
                'tags': ['modify', 'technique'],
                'hi_res_image': '/cards/gcg_313007_hd.webp',
                'image': '/cards/gcg_313007.webp',
                'golden_image': '/cards/gcg_313007_golden.webp',
                'cost': '5 White',
                'description': "When played: Grants the character to which this is attached 2 Shield points. \n\nWhen the character to which this is attached is switched out: This card gains Usage(s) +1.  \n\nTechnique: Waverider: Swiftstrike Cannon \n\nUsage(s): 2 \n\n(A character can only equip 1 Technique at a time)",
                'flavor': "A mysterious waterborne vehicle equipped with a magical weapon. With its deck beneath your feet, there is no waterway you cannot effortlessly traverse.",
                'id': 'CX',
            },

            "tatankasaurus": {
                'name': "Tatankasaurus",
                'tags': ['modify', 'technique'],
                'hi_res_image': '/cards/gcg_313008_hd.webp',
                'image': '/cards/gcg_313008.webp',
                'golden_image': '/cards/gcg_313008_golden.webp',
                'cost': '4 Black',
                'description': "Technique: Spirited State \n\nUsage(s): 2 \n\n(A character can only equip 1 Technique at a time)",
                'flavor': "To a charging Tatankasaurus, solid Pulverite is no more imposing an obstacle than gently wafting steam, while the surfaces of water and liquid Phlogiston alike are as stable and supportive as a road.",
                'id': 'D5',
            },

            "rawrrawr": {
                'name': "Rawr! Rawr!",
                'tags': ['modify', 'technique'],
                'hi_res_image': '/cards/gcg_313009_hd.webp',
                'image': '/cards/gcg_313009.webp',
                'golden_image': '/cards/gcg_313009_golden.webp',
                'cost': '2 White',
                'description': "When this card is played: Create Yikes!. (When you play a Technique card: If you've played a total of 6 Technique cards this match, your active character gains 3 Shield, and deals 3 Physical DMG) \n\nTechnique: Rawr! Rawr! \n\nUsage(s): 2 \n\n(A character can only equip 1 Technique at a time)",
                'flavor': "\"Get ready to meet your best travel companion in Natlan! Ahem, make that second best...\"",
                'id': 'DI',
            },

            "blubberbeast": {
                'name': "Blubberbeast",
                'tags': ['modify', 'technique'],
                'hi_res_image': '/cards/gcg_313010_hd.webp',
                'image': '/cards/gcg_313010.webp',
                'golden_image': '/cards/gcg_313010_golden.webp',
                'cost': '1 White',
                'description': "Technique: Sonar Waves \n\nUsage(s): 2 \n\n(A character can only equip 1 Technique at a time)",
                'flavor': "\"A type of mammal that resides in the watery regions of Fontaine. It communicates with its companions through melodious sounds.\"",
                'id': 'G1',
            },
            
            "liyueharborwharf": {
                "name": "Liyue Harbor Wharf",
                "tags": ['assist', 'place'],
                "image": "/cards/i_n332000.webp",
                "golden_image": "/cards/i_n336000.webp",
                "hi_res_image": "/cards/i_n332000_gcg_high_resolution.webp",
                "cost": '2 White',
                "description": "End Phase: Draw 2 cards.\n\nUsage(s): 2",
                "flavor": "“Nature provides, the mountains rejoice, we are blessed by heaven’s good grace.”",
                "id": '2I'        
            },
            
            "knightsoffavoniuslibrary": {
                "name": "Knights of Favonius Library",
                "tags": ['assist', 'place'],
                "image": "/cards/i_n332001.webp",
                "golden_image": "/cards/i_n336001.webp",
                "hi_res_image": "/cards/i_n332001_gcg_high_resolution.webp",
                "cost": '0 White',
                "description": "When played: Select any Elemental Dice to reroll. \n\nRoll Phase: Gain another chance to reroll.",
                "flavor": "“Most of the books here can be lent out, but do bear in mind that you will have to return them… on time.”",
                "id": '2J'        
            },
            
            "jadechamber": {
                "name": "Jade Chamber",
                "tags": ['assist', 'place'],
                "image": "/cards/i_n332002.webp",
                "golden_image": "/cards/i_n336002.webp",
                "hi_res_image": "/cards/i_n332002_gcg_high_resolution.webp",
                "cost": '0 White',
                "description": "Roll Phase: 2 initial Elemental Dice will be of the same Elemental type as your active character. \n\nWhen Action Phase begins: If you have no more than 3 cards in your Hand, discard this card and create 1 Omni Element.",
                "flavor": "\"They say that it contains a thousand dazzling jewels.\"",
                "id": '2K'        
            },
            
            "dawnwinery": {
                "name": "Dawn Winery",
                "tags": ['assist', 'place'],
                "image": "/cards/i_n332003.webp",
                "golden_image": "/cards/i_n336003.webp",
                "hi_res_image": "/cards/i_n332003_gcg_high_resolution.webp",
                "cost": "3 Black",
                "description": "When you perform \"Switch Character\": Spend 1 fewer Elemental Die. (Twice per Round)",
                "flavor": "“The best wine will always be brewed next year.”",
                "id": '2L'        
            },
            
            "wangshuinn": {
                "name": "Wangshu Inn",
                "tags": ['assist', 'place'],
                "image": "/cards/i_n332004.webp",
                "golden_image": "/cards/i_n336004.webp",
                "hi_res_image": "/cards/i_n332004_gcg_high_resolution.webp",
                "cost": '2 White',
                "description": "End Phase: Heal the most injured character on standby for 2 HP.\n\nUsage(s): 2",
                "flavor": "“Folk stories also have it that even ones as august as the adepti sometimes bask in the moonlight here.”",
                "id": '2M'        
            },
            
            "favoniuscathedral": {
                "name": "Favonius Cathedral",
                "tags": ['assist', 'place'],
                "image": "/cards/i_n332005.webp",
                "golden_image": "/cards/i_n336005.webp",
                "hi_res_image": "/cards/i_n332005_gcg_high_resolution.webp",
                "cost": '2 White',
                "description": "End Phase: Heals your active character for 2 HP. \n\nUsage(s): 2",
                "flavor": "“If you speak sincerely into the wind, your words will surely reach the archon’s ear one day.”",
                "id": '2N'        
            },

            "tenshukaku": {
                "name": "Tenshukaku",
                "tags": ['assist', 'place'],
                "image": "/cards/i_n332021.webp",
                "golden_image": "/cards/i_n336021.webp",
                "hi_res_image": "/cards/i_n332021_gcg_high_resolution.webp",
                "cost": '2 White',
                "description": "When the Action Phase begins: If you have 5 different kinds of Elemental Die, create 1 Omni Element.",
                "flavor": '"What matters is that I tread the path of eternity on my people\'s behalf."',
                'id': '5R'
            },
    
            "grandnarukamishrine": {
                "name": "Grand Narukami Shrine",
                "tags": ['assist', 'place'],
                "image": "/cards/i_n332020.webp",
                "golden_image": "/cards/i_n336020.webp",
                "hi_res_image": "/cards/i_n332020_gcg_high_resolution.webp",
                "cost": "3 Black",
                "description": "After your character uses a Skill: If the total number of Elemental Dice is odd, then generate 1 Omni Element. (Twice per Round)",
                "flavor": "\"May Mt. Yougou flourish eternal, and may its glory be everlasting.\"",
                "id": '4M'
            },
    
            "sangonomiyashrine": {
                "name": "Sangonomiya Shrine",
                "tags": ['assist', 'place'],
                "image": "/cards/i_n332022.webp",
                "golden_image": "/cards/i_n336022.webp",
                "hi_res_image": "/cards/i_n332022_gcg_high_resolution.webp",
                "cost": '2 White',
                "description": "End Phase: Heal all your characters for 1 HP.\n\nUsage(s): 2", 
                "flavor": '"Sangonomiya was once an ocean abyss, until the Great Serpent came, forming a vortex with its spiral movements, and fashioning the coral into an island."',
                'id': '5S'
            },
    
            "sumerucity": {
                "name": "Sumeru City",
                "tags": ['assist', 'place'],
                "image": "/cards/i_n332023.webp",
                "golden_image": "/cards/i_n336023.webp",
                "hi_res_image": "/cards/i_n332023_gcg_high_resolution.webp",
                "cost": '2 White',
                "description": "When you play a Talent card or your character uses a Skill: If you do not have more Elemental Dice than cards in your hand, spend 1 fewer Elemental Die. (Once per Round)",
                "flavor": 'Under the luxuriant Divine Tree, the sages of the academy city have accumulated all the knowledge there is to be gathered.',
                'id': '5T'
            },
    
            "vanarana": {
                "name": "Vanarana",
                "tags": ['assist', 'place'],
                "image": "/cards/i_n332024.webp",
                "golden_image": "/cards/i_n336024.webp",
                "hi_res_image": "/cards/i_n332024_gcg_high_resolution.webp",
                "cost": '0 White',
                "description": "End Phase: Collect up to 2 unused Elemental Dice. \n\nWhen the Action Phase begins: Reclaim the dice you collected using this card.",
                "flavor": "\"Enter the memories of the trees in the forest, descend into seedbeds sprouting the dreams of slumbering leaves, and dive into a world free of woes.\"",
                'id': '5U'
            },
    
            "chinjuforest": {
                "name": "Chinju Forest",
                "tags": ['assist', 'place'],
                "image": "/cards/i_n332025.webp",
                "golden_image": "/cards/i_n336025.webp",
                "hi_res_image": "/cards/i_n332025_gcg_high_resolution.webp",
                "cost": "2 White",
                "description": "Before you choose your action: If the current total number of Elemental Dice is even, your character's Normal Attacks will cost 1 fewer Unaligned Element. \n\nUsage(s): 4",
                "flavor": 'Legend has it that this sacred forest was once home to many demons.',
                'id': '5V'
            },

            "goldenhouse": {
                "name": "Golden House",
                "tags": ['assist', 'place'],
                "image": "/cards/i_n332034.webp",
                "golden_image": "/cards/i_n336034.webp",
                "hi_res_image": "/cards/i_n332034_gcg_high_resolution.webp",
                "cost": '0 White',
                "description": "When you play a Weapon card or an Artifact card with a Current Elemental Dice Cost of at least 3: Spend 1 fewer Elemental Die. (Once per Round) \n\nUsage(s): 2",
                "flavor": 'All the contracts that circulate throughout the land are forged here.',
                'id': '6Y'
            },

            "gandharvaville": {
                "name": "Gandharva Ville",
                "tags": ['assist', 'place'],
                "image": "/cards/i_n332036.webp",
                "golden_image": "/cards/i_n336036.webp",
                "hi_res_image": "/cards/i_n332036_gcg_high_resolution.webp",
                "cost": '1 White',
                "description": "Before you choose your action, when the number of Elemental Dice you have is 0: Create 1 Omni Element (once per Round).\n\nUsage(s): 3",
                "flavor": "The place where travelers and Forest Rangers meet in joy — the village that listens to the heartbeat of the rainforest.",
                'id': '7A'
            },

            "stormterrorslair": {
                "name": "Stormterror's Lair",
                "tags": ['assist', 'place'],
                "image": "/cards/i_n332038.webp",
                "golden_image": "/cards/i_n336038.webp",
                "hi_res_image": "/cards/i_n332038_gcg_high_resolution.webp",
                "cost": '2 White',
                "description": "When played: Draw 1 random Talent card from your deck. \n\nWhen you play a Talent card, or when your character uses a Skill with an original cost of at least 4 Elemental Dice: Spend 1 fewer Elemental Die. (Once per Round) \n\nUsage(s): 3",
                "flavor": "The ambitious dream was built proudly upon the capital of the God of Storms, and collapsed to ruin under the lofty song of freedom.",
                'id': '7M'
            },

            'weepingwillowofthelake': { 
                'name': 'Weeping Willow of the Lake',
                'tags': ['assist', 'place'],
                'hi_res_image': '/cards/i_n332039_gcg_high_resolution.webp',
                'image': '/cards/i_n332039.webp',
                'golden_image': '/cards/i_n336039.webp',
                'cost': '1 White',
                'description': "End Phase: If your Hand has no more than 2 cards, draw 2 cards. \n\nUsage(s): 2",
                'flavor': "In ancient times, the weeping willow of the lake was an object of reverence. All the water veins converge upon Erinnyes and the weeping willow flourishes or withers when the waters are sweet or bitter.",        
                'id': '8L',
            },

            'operaepiclese': { 
                'name': 'Opera Epiclese',
                'tags': ['assist', 'place'],
                'hi_res_image': '/cards/i_n332040_gcg_high_resolution.webp',
                'image': '/cards/i_n332040.webp',
                'golden_image': '/cards/i_n336040.webp',
                'cost': '1 White',
                'description': "Before you choose an action: If the original Elemental Dice cost of the cards equipped to your characters is not less than that of the opposing side, create 1 Elemental Die of your active character's element. (Once per Round) \n\nUsage(s): 3",
                'flavor': "The true and the fantastical, the comedic and tragic find a stage here equally. Perhaps it truly is as an ancient Fontainian playwright once said \"All the world's a stage, and all of us merely players.\"",      
                'id': '8M',
            },

            'fortressofmeropide': { 
                'name': 'Fortress of Meropide',
                'tags': ['assist', 'place'],
                'hi_res_image': '/cards/i_n332046_gcg_high_resolution.webp',
                'image': '/cards/i_n332046.webp',
                'golden_image': '/cards/i_n336046.webp',
                'cost': '1 White',
                'description': "When your active character takes DMG or is healed: This card gains 1 point of Prohibition (Can stack. Max 6 stacks). If this card has accumulated 6 Prohibition points, consume 6 Prohibition points and apply Invalidation to 1 random card in your opponent's Hand.",
                'flavor': "\"A fastness of bronze and iron will collapse one day, but a city of law and justice will never fall.\"",      
                'id': '9K',
            },

            'seiraiisland': { 
                'name': 'Seirai Island',
                'tags': ['assist', 'place'],
                'hi_res_image': '/cards/i_n332048_gcg_high_resolution.webp',
                'image': '/cards/i_n332048.webp',
                'golden_image': '/cards/i_n336048.webp',
                'cost': '1 White',
                'description': "After any character on either side is healed: That character gains Distant Storm. (Takes 2 Piercing DMG at the End Phase. Can be used once) \n\nDuration (Rounds): 2",
                'flavor': "\"The great battle where the sea and sky changed color have become lost to time, but the vast storms that were called upon at this time still remain.\"",      
                'id': 'AN',
            },

            'mausoleum': { 
                'name': 'The Mausoleum of King Deshret',
                'tags': ['assist', 'place'],
                'hi_res_image': '/cards/i_n332051_gcg_high_resolution.webp',
                'image': '/cards/i_n332051.webp',
                'golden_image': '/cards/i_n336051.webp',
                'cost': '1 White',
                'description': "After your opponent draws 4 cards cumulatively: Discard this card and create 2 Forbidden Knowledge at the top of your opponent's deck. After that, until this Round ends, for every 1 card your opponent draws, 1 Forbidden Knowledge will be created immediately and randomly placed within their deck.",
                'flavor': "\"The huge cone is like a supporting pillar between the high sky and the yellow sands that has stood in the middle of the desert since time immemorial. Standing in front of it, be you a commoner, a wealthy man, or a well-informed researcher, you shall feel that you are but a few grains of sand all the same.\"",      
                'id': 'AQ',
            },

            'centrallaboratoryruins': { 
                'name': 'Central Laboratory Ruins',
                'tags': ['assist', 'place'],
                'hi_res_image': '/cards/i_n332052_gcg_high_resolution.webp',
                'image': '/cards/i_n332052.webp',
                'golden_image': '/cards/i_n336052.webp',
                'cost': '1 White',
                'description': "After you Discard or use 1 card for Tune: This card gains 1 Experimental Progress point. Whenever you reach 3, 6, and 9 points, you will gain 1 Omni Element. After that, if Experimental Progress is at least 9, discard this card.",
                'flavor': "...When excess intelligence and passion came together, research brought about results in a manner that surpassed everyone's expectations. Now, however, there remains no one to applaud that achievement.\nWhen an ideal is destroyed, its most important responsibility is to hold its peace...",      
                'id': 'AR',
            },

            "stadiumofthesacredflame": {
                'name': "Stadium of the Sacred Flame",
                'tags': ['assist', 'place'],
                'hi_res_image': '/cards/gcg_321022_hd.webp',
                'image': '/cards/gcg_321022.webp',
                'golden_image': '/cards/gcg_321022_golden.webp',
                'cost': '2 White',
                'description': "After you use a Skill or Technique: This card gains 1 Contending Fire. \n\nWhen your Contending Fire reaches 2: Create 1 random basic Elemental Die. \n\nWhen it reaches 4: Heal your active character for 2 HP. \n\nWhen it reaches 6: Discard this card, your current active character deals +1 DMG for 2 Rounds.",
                'flavor': "\"Seize victory and glory for Natlan!\"",
                'id': 'BK',
            },

            "stagetepetl": {
                'name': "Stage Tepetl",
                'tags': ['assist', 'place'],
                'hi_res_image': '/cards/gcg_321023_hd.webp',
                'image': '/cards/gcg_321023.webp',
                'golden_image': '/cards/gcg_321023_golden.webp',
                'cost': '0 White',
                'description': "After you play a card whose name was not in the initial deck at the start of the match: This card gains 1 Attention point. \n\nAfter the opponent plays a card whose name was not in the initial deck at the start of the match: This card loses 1 Attention point. \n\nWhen the Action Phase begins: If this card has at least 3 points of Attention, then generate 1 random basic Elemental Die; and if this card has at least 1 point of Attention, convert 1 Elemental Die to an Omni Element.",
                'flavor': "\"Get up on stage, and dance, dance, dance! Become a member of the Drillbit Dance! Show us your courage and resolve, and you can also become a legend of the stage!\"",
                'id': 'BX',
            },

            "scionsofthecanopy": {
                'name': "\"Scions of the Canopy\"",
                'tags': ['assist', 'place'],
                'hi_res_image': '/cards/gcg_321024_hd.webp',
                'image': '/cards/gcg_321024.webp',
                'golden_image': '/cards/gcg_321024_golden.webp',
                'cost': '0 White',
                'description': "When you play a card this match whose Name did not exist in your initial deck: If that card's Current Elemental Dice Cost is not less than this card's Daredevil Count, then generate 1 random basic Elemental Die, and +1 to this card's Daredevil Count.",
                'flavor': "\"Legend has it that the warriors of the Scions of the Canopy, along with one hundred Yumkasaurs, spent a hundred days and a hundred ropes moving the 'Obsidian Totem Pole,' the symbol of their faith, to its current location.\"",
                'id': 'C9',
            },

            "peopleofthesprings": {
                'name': "\"People of the Springs\"",
                'tags': ['assist', 'place'],
                'hi_res_image': '/cards/gcg_321025_hd.webp',
                'image': '/cards/gcg_321025.webp',
                'golden_image': '/cards/gcg_321025_golden.webp',
                'cost': '2 White',
                'description': "When your Summon enters play: its Usage(s) +1. \n\nUsage(s): 3",
                'flavor': "Natlan's best vacation destination, and a happy home for the Koholasaurus and hot spring enthusiasts!",
                'id': 'CI',
            },

            "flowerfeatherclan": {
                'name': "\"Flower-Feather Clan\"",
                'tags': ['assist', 'place'],
                'hi_res_image': '/cards/gcg_321026_hd.webp',
                'image': '/cards/gcg_321026.webp',
                'golden_image': '/cards/gcg_321026_golden.webp',
                'cost': '0 White',
                'description': "After you Discard 2 cards: Your next off-field character gains 1 stack of \"The next time this character switches to become your active character, recover 1 Elemental Die of the corresponding color.\" (Can stack. Triggers 1 stack each time.)",
                'flavor': "A tribe of Qucusaur Riders — swift and aloof — who venerate the Wayob who dictate the flow of heat and scorching winds...\nEvery day, members of the tribe fly with the Qucusaurs, patrolling their territory from the air.",
                'id': 'CQ',
            },

            "mastersofthenightwind": {
                'name': "\"Masters of the Night-Wind\"",
                'tags': ['assist', 'place'],
                'hi_res_image': '/cards/gcg_321027_hd.webp',
                'image': '/cards/gcg_321027.webp',
                'golden_image': '/cards/gcg_321027_golden.webp',
                'cost': '0 White',
                'description': "This card begins with 4 Spiritspeaking. \n\nAfter you Select: Spiritspeaking -1. \n\nAt the start of the Action Phase: If Spiritspeaking is 0, this card is removed, and you can Select 1 of 3 random 2-cost Support Cards to be created.",
                'flavor': "A tribe renowned for its mastery of the arcane arts. It is said that in their domain, one can listen to the echoes of the silent kingdom of the night.",
                'id': 'CY',
            },

            "collectiveofplenty": {
                'name': "\"Collective of Plenty\"",
                'tags': ['assist', 'place'],
                'hi_res_image': '/cards/gcg_321028_hd.webp',
                'image': '/cards/gcg_321028.webp',
                'golden_image': '/cards/gcg_321028_golden.webp',
                'cost': '3 Black',
                'description': "When your character prepares a Skill: This character gains 3 Workout. \n\nAfter your character switches to become the active character: This character gains 2 Workout. \n\n(When Workout stacks reach 3, heal the corresponding character for 1 HP. When Workout stacks reach 5, the corresponding character deals +1 DMG)",
                'flavor': "A tribe that prizes strength and muscular physiques, it's said that nearly every member regularly works out.",
                'id': 'D6',
            },

            "calligraphytavern": {
                'name': "Calligraphy Tavern",
                'tags': ['assist', 'place'],
                'hi_res_image': '/cards/gcg_321029_hd.webp',
                'image': '/cards/gcg_321029.webp',
                'golden_image': '/cards/gcg_321029_golden.webp',
                'cost': '2 Black',
                'description': "When played: Randomly create 1 Origami Flying Squirrel, Pop-Up Paper Frog, or Origami Hamster, and add it to your Hand. \n\nWhen you declare the end of your Round: Randomly trigger 1 of your Simulanka Summon's \"End Phase\" effects. \n\nUsage(s): 3",
                'flavor': "\"Well, if you're offering... Paimon will take a glass of Bulle Fruit Tonic! ...Um, but hold the Tonic, hehe!\"",
                'id': 'DW',
            },

            "constellationmetropole": {
                'name': "Constellation Metropole",
                'tags': ['assist', 'place'],
                'hi_res_image': '/cards/gcg_321030_hd.webp',
                'image': '/cards/gcg_321030.webp',
                'golden_image': '/cards/gcg_321030_golden.webp',
                'cost': '2 White',
                'description': "When played: Create 1 Toy Guard and add it to your Hand. \n\nAfter your character uses an Elemental Skill: Spend 1 fewer Elemental Die the next time Toy Guard is played. (Cannot stack) \n\nAfter your character uses an Elemental Burst: The next Toy Guard you play gains +1 to its number of effects. (Cannot stack)",
                'flavor': "\"The heroes gazed upon the skies of gray, and in carriages bright they went their way.\"",
                'id': 'DX',
            },

            "adventurersguild": {
                'name': "Adventurers' Guild",
                'tags': ['assist', 'place'],
                'hi_res_image': '/cards/gcg_321031_hd.webp',
                'image': '/cards/gcg_321031.webp',
                'golden_image': '/cards/gcg_321031_golden.webp',
                'cost': '2 White',
                'description': "End Phase: Adventure: Once. \n\nUsage(s): 3",
                'flavor': "They boldly venture \"up to the stars, down to the abyss,\" or so their motto would have you believe. In truth, they take on jobs ranging from finding kittens to exploring domains. Well, you cannot afford to gaze at the stars or the abyss without an honest job.",
                'id': 'EQ',
            },

            "silvermoonhall": {
                'name': "Silvermoon Hall",
                'tags': ['assist', 'place'],
                'hi_res_image': '/cards/gcg_321035_hd.webp',
                'image': '/cards/gcg_321035.webp',
                'golden_image': '/cards/gcg_321035_golden.webp',
                'cost': '0 White',
                'description': "When Cost Reduction or Empowerment is attached to your card: +1 stack. \n\nAt the start of the Action Phase, if the stack of this card reaches 3: Remove 3 stacks and generate 1 random basic Elemental Die.",
                'flavor': "And still the moonlight flows as ever.",
                'id': 'FL',
            },

            "tidesealstone": {
                'name': "Tideseal Stone",
                'tags': ['assist', 'place'],
                'hi_res_image': '/cards/gcg_321036_hd.webp',
                'image': '/cards/gcg_321036.webp',
                'golden_image': '/cards/gcg_321036_golden.webp',
                'cost': '0 White',
                'description': "When Action Phase begins: Attach Cost Increase and Untunable to 1 random card in the opponent's Hand. \n\nUsage(s): 2",
                'flavor': "\"The night sky has been devoured by deathly silence. We knead blood and bone for fuel, and so proclaim: The Long Night flows dark and deep. With these lanterns we wield, no specter shall stir from their sleep. By the lunar spirits, this pact is sealed.\"",
                'id': 'FM',
            },

            "frostmoonenclave": {
                'name': "Frostmoon Enclave",
                'tags': ['assist', 'place'],
                'hi_res_image': '/cards/gcg_321037_hd.webp',
                'image': '/cards/gcg_321037.webp',
                'golden_image': '/cards/gcg_321037_golden.webp',
                'cost': '4 White',
                'description': "When played: Draw 2 cards, heal the character on your side who has taken the most DMG for 2 HP. \n\nEnd Phase: Attach Cost Reduction to 2 random cards in your Hand. \n\nUsage(s): 2.",
                'flavor': "Here, the Frostmoon Scions gather, listening to the teachings of moonlight.",
                'id': 'FN',
            },

            "nashatown": {
                'name': "Nasha Town",
                'tags': ['assist', 'place'],
                'hi_res_image': '/cards/gcg_321038_hd.webp',
                'image': '/cards/gcg_321038.webp',
                'golden_image': '/cards/gcg_321038_golden.webp',
                'cost': '1 White',
                'description': "End Phase: Attach Empowerment to 2 random cards in your Hand with a Current Elemental Dice Cost of 2 or more. \n\nUsage(s): 2 \n\nWhen this card is discarded: If this card has 0 Usages, deal 2 Physical DMG.",
                'flavor': "This town sits like a ship run aground on the world's edge — a place where drifters gather to scavenge fragments of elysium from the wreckage of history and fabricated pasts.",
                'id': 'FO',
            },

            "kuuvahkiexperimentaldesignbureau": {
                'name': "Kuuvahki Experimental Design Bureau",
                'tags': ['assist', 'place'],
                'hi_res_image': '/cards/gcg_321039_hd.webp',
                'image': '/cards/gcg_321039.webp',
                'golden_image': '/cards/gcg_321039_golden.webp',
                'cost': '2 White',
                'description': "End Phase: Attach Empowerment to 2 random cards in your deck. \n\nUsage(s): 2 \n\nWhen this card is discarded while on the field: Draw 2 cards with Empowerment attached, and attach 1 stack of Battle Plan to your active character.",
                'flavor': "This leviathan forged of white iron and black steel hungrily devours all in its sight – energy, blood, and tears alike. Yet what it seeks is not plunder, but power enough to withstand the looming calamity.",
                'id': 'FP',
            },

            "nightmareomen": {
                'name': "Nightmare Omen",
                'tags': ['assist', 'place'],
                'hi_res_image': '/cards/gcg_321041_hd.webp',
                'image': '/cards/gcg_321041.webp',
                'golden_image': '/cards/gcg_321041_golden.webp',
                'cost': '0 White',
                'description': "When played or when the Action Phase begins: Grants Cost Increase to the card with the highest Current Elemental Dice Cost in opponent's Hand, and grant Cost Increase to the top card of your deck.",
                'flavor': "\"A colossal, lidless eye it was, its gaze unflinching, piercing through the clouds, the mist, the land, and the mountains alike. It was a vision both omniscient and omnipresent.\"",
                'id': 'GQ',
            },
            
            "paimon": {
                "name": "Paimon",
                "tags": ['assist', 'companion'],
                "image": "/cards/i_n332006.webp",
                "golden_image": "/cards/i_n336006.webp",
                "hi_res_image": "/cards/i_n332006_gcg_high_resolution.webp",
                "cost": '3 White',
                "description": "When Action Phase begins: Create 'Omni Element' ×2.\n\nUsage(s): 2",
                "flavor": "“That’s right! Your fortune is Paimon’s fortune! And vice versa, Paimon’s fortune is also your fortune.”",
                "id": '2O'        
            },
            
            "katheryne": {
                "name": "Katheryne",
                "tags": ['assist', 'companion'],
                "image": "/cards/i_n332007.webp",
                "golden_image": "/cards/i_n336007.webp",
                "hi_res_image": "/cards/i_n332007_gcg_high_resolution.webp",
                "cost": '1 White',
                "description": "When you perform \"Switch Character\": This switch is considered a Fast Action instead of a Combat Action. (Once per Round)",
                "flavor": "“Ad astra abyssosque! Welcome to the Adventurers’ Guild.”",
                "id": '2P'        
            },
            
            "timaeus": {
                "name": "Timaeus",
                "tags": ['assist', 'companion'],
                "image": "/cards/i_n332008.webp",
                "golden_image": "/cards/i_n336008.webp",
                "hi_res_image": "/cards/i_n332008_gcg_high_resolution.webp",
                "cost": '2 White',
                "description": "When played: Comes with 2 Transmutation Materials. If your deck originally includes at least 6 Artifact cards, you will randomly also draw 1 Artifact Card from your deck. \n\nEnd Phase: This card will gain 1 Transmutation Material. \n\nWhen playing an Artifact Card: If possible, spend Transmutation Materials equal to the total cost of the Artifact and equip this Artifact for free. (Once per Round)",
                "flavor": "“Hello there… Oh, you’d like to use the Crafting Bench? Sure, be my guest.”",
                "id": '2Q'        
            },
            
            "wagner": {
                "name": "Wagner",
                "tags": ['assist', 'companion'],
                "image": "/cards/i_n332009.webp",
                "golden_image": "/cards/i_n336009.webp",
                "hi_res_image": "/cards/i_n332009_gcg_high_resolution.webp",
                "cost": '2 White',
                "description": "When played: Comes with 2 Forging Billets. If your deck originally includes at least 3 different types of Weapons, you will randomly also draw 1 Weapon Card from your deck. \n\nEnd Phase: This card will gain 1 Forging Billet. \n\nWhen playing a Weapon Card: If possible, spend Forging Billets equal to the total cost of the Weapon and equip this Weapon for free. (Once per Round)",
                "flavor": "“Smithing is not dependent on brute strength. You need the sweat on your brow from constant hard work, and perseverance stronger than the metals we forge!”",
                "id": '2R'        
            },
            
            "chefmao": {
                "name": "Chef Mao",
                "tags": ['assist', 'companion'],
                "image": "/cards/i_n332010.webp",
                "golden_image": "/cards/i_n336010.webp",
                "hi_res_image": "/cards/i_n332010_gcg_high_resolution.webp",
                "cost": '1 White',
                "description": "After playing a Food Event Card: Create 1 random Basic Elemental Die (once per Round). \n\nAfter playing a Food Event Card: Draw 1 random Food Event Card from your deck (once per match).",
                "flavor": "“We just concern ourselves with making the most delicious food imaginable using everyday ingredients, universally loved flavors, and truly excellent cooking.”",
                "id": '2S'        
            },
            
            "tubby": {
                "name": "Tubby",
                "tags": ['assist', 'companion'],
                "image": "/cards/i_n332011.webp",
                "golden_image": "/cards/i_n336011.webp",
                "hi_res_image": "/cards/i_n332011_gcg_high_resolution.webp",
                "cost": '2 White',
                "description": "When playing a Location Support Card: Spend 2 fewer Elemental Dice. (Once per Round)",
                "flavor": "“Steeping a pot of tea, watching over the abode, accompanying the Traveler and Paimon to await the arrival of Ping and the others, watching the cloud-filled sky. These days of not having to concern myself with matters of adeptal import truly are ones of leisure…”\n“Oh! Oh dear, I must have fallen asleep again. It’s a good thing that no one noticed…”",
                "id": '2T'        
            },
            
            "timmie": {
                "name": "Timmie",
                "tags": ['assist', 'companion'],
                "image": "/cards/i_n332012.webp",
                "golden_image": "/cards/i_n336012.webp",
                "hi_res_image": "/cards/i_n332012_gcg_high_resolution.webp",
                "cost": '0 White',
                "description": "Triggers automatically once per Round: This card gains 1 Pigeon.\n\nWhen this card gains 3 Pigeons, discard this card, then draw 1 card and create 'Omni Element' ×1.",
                "flavor": "“Will pigeons that have flown away come back?”",
                "id": '2U'        
            },
            
            "liben": {
                "name": "Liben",
                "tags": ['assist', 'companion'],
                "image": "/cards/i_n332013.webp",
                "golden_image": "/cards/i_n336013.webp",
                "hi_res_image": "/cards/i_n332013_gcg_high_resolution.webp",
                "cost": '0 White',
                "description": "End Phase: Collect your unused Elemental Dice (Max 1 of each Elemental Type).\n\nWhen Action Phase begins: If this card has collected 3 Elemental Dice, draw 2 cards and create 'Omni Element' ×2, then discard this card.",
                "flavor": "Big things are about to happen, big things! Oh, and I have an excellent business proposition for you, so, if I could just have a moment of your time?",
                "id": '2V'        
            },
            
            "changtheninth": {
                "name": "Chang the Ninth",
                "tags": ['assist', 'companion'],
                "image": "/cards/i_n332014.webp",
                "golden_image": "/cards/i_n336014.webp",
                "hi_res_image": "/cards/i_n332014_gcg_high_resolution.webp",
                "cost": '0 White',
                "description": "After either side uses a Skill: If Physical DMG or Piercing DMG was dealt, or an Elemental Reaction was triggered, this card gains 1 Inspiration. \n\nWhen this card gains 3 Inspiration, then discard this card and draw 2 cards.",
                "flavor": "“He who has not known poverty has yet to become a true man, and at least this man has books to keep him company!”",
                "id": '2W'        
            },
            
            "ellin": {
                "name": "Ellin",
                "tags": ['assist', 'companion'],
                "image": "/cards/i_n332015.webp",
                "golden_image": "/cards/i_n336015.webp",
                "hi_res_image": "/cards/i_n332015_gcg_high_resolution.webp",
                "cost": '2 White',
                "description": "When you use a Skill that has already been used in this Round: Spend 1 fewer Elemental Die. (Once per Round)",
                "flavor": "“I’ve got to hone my spirit and strength both if my sword arm is to be as steady as Master Jean’s!”",
                "id": '2X'        
            },
            
            "irontonguetian": {
                "name": "Iron Tongue Tian",
                "tags": ['assist', 'companion'],
                "image": "/cards/i_n332016.webp",
                "golden_image": "/cards/i_n336016.webp",
                "hi_res_image": "/cards/i_n332016_gcg_high_resolution.webp",
                "cost": '2 Black',
                "description": "End Phase: One of your characters without maximum energy gains 1 Energy. (Active Character prioritized) \n\nUsage(s): 2",
                "flavor": "“Listen, I’ll tell you how is it… Let me show you real storytelling tradition!”",
                "id": '2Y'        
            },
            
            "liusu": {
                "name": "Liu Su",
                "tags": ['assist', 'companion'],
                "image": "/cards/i_n332017.webp",
                "golden_image": "/cards/i_n336017.webp",
                "hi_res_image": "/cards/i_n332017_gcg_high_resolution.webp",
                "cost": '1 White',
                "description": "After you switch to a character that lacks Energy: Your active character gains 1 Energy. (Once per Round) \n\nUsage(s): 2",
                "flavor": "“Well then, dear guests, what would you all like to hear next?”",
                "id": '2Z'        
            },
    
            "hanachirusato": {
                "name": "Hanachirusato",
                "tags": ['assist', 'companion'],
                "image": "/cards/i_n332026.webp",
                "golden_image": "/cards/i_n336026.webp",
                "hi_res_image": "/cards/i_n332026_gcg_high_resolution.webp",
                "cost": '0 White',
                "description": "When a Summon disappears: This card gains 1 Cleansing Ritual Progress. (Max 3) \n\nWhen you play a Weapon or Artifact Card: If you already have 3 Cleansing Ritual Progress, discard this card and cause the card you play to cost 2 fewer Elemental Dice.",
                "flavor": '"When shall we meet again after this parting? For life is like the morning dew."',
                'id': '5W'
            },
            "kidkujirai": {
                "name": "Kid Kujirai",
                "tags": ['assist', 'companion'],
                "image": "/cards/i_n332027.webp",
                "golden_image": "/cards/i_n336027.webp",
                "hi_res_image": "/cards/i_n332027_gcg_high_resolution.webp",
                "cost": '0 White',
                "description": "When the Action Phase begins: Create 1 Omni Element. Then if your opponent's Support Zone is not full, transfer this card to your opponent's Support Zone.",
                "flavor": '"When you hide a Temari, you have to hide it within the time of a Temari song. The person who is looking for it will also find it within a song\'s time. That will make the game fair!"',
                'id': '5X'
            },
            "xudong": {
                "name": "Xudong",
                "tags": ['assist', 'companion'],
                "image": "/cards/i_n332028.webp",
                "golden_image": "/cards/i_n336028.webp",
                "hi_res_image": "/cards/i_n332028_gcg_high_resolution.webp",
                "cost": '2 Black',
                "description": "When playing a Food Event Card: Spend 2 fewer Elemental Dice. (Once per Round)",
                "flavor": '"Hmm? A problem. Agh. We can deal with it after we finish eating."',
                'id': '5Y'
            },
            "dunyarzad": {
                "name": "Dunyarzad",
                "tags": ['assist', 'companion'],
                "image": "/cards/i_n332029.webp",
                "golden_image": "/cards/i_n336029.webp",
                "hi_res_image": "/cards/i_n332029_gcg_high_resolution.webp",
                "cost": '1 White',
                "description": "When playing a Companion Support Card: Spend 1 fewer Elemental Die (once per Round). \n\nAfter playing a Companion Support Card: Draw 1 random Companion Support Card from your deck (once per match).",
                "flavor": '"The point of living is to not leave behind any regrets."',
                'id': '5Z'
            },
            "rana": {
                "name": "Rana",
                "tags": ['assist', 'companion'],
                "image": "/cards/i_n332030.webp",
                "golden_image": "/cards/i_n336030.webp",
                "hi_res_image": "/cards/i_n332030_gcg_high_resolution.webp",
                "cost": '2 White',
                "description": "After your character uses an Elemental Skill: Create 1 Elemental Die of the same Type as your next off-field character. (Once per Round)",
                "flavor": '"We still have a lot of time with each other. We can explore the vastness of the forest, the world, and the future together."',
                'id': '60'
            },

            "masterzhang": {
                "name": "Master Zhang",
                "tags": ['assist', 'companion'],
                "image": "/cards/i_n332033.webp",
                "golden_image": "/cards/i_n336033.webp",
                "hi_res_image": "/cards/i_n332033_gcg_high_resolution.webp",
                "cost": '1 White',
                "description": "When playing a Weapon card: Spend 1 fewer Elemental Die. On top of that, for each of your characters already equipped with a Weapon on the field, you spend 1 fewer Elemental Die. (Once per Round.)",
                "flavor": 'Much burning frustration must transpire before a hunk of metal may become a keen blade.',
                'id': '6N'
            },

            "setaria": {
                "name": "Setaria",
                "tags": ['assist', 'companion'],
                "image": "/cards/i_n332035.webp",
                "golden_image": "/cards/i_n336035.webp",
                "hi_res_image": "/cards/i_n332035_gcg_high_resolution.webp",
                "cost": '1 White',
                "description": "After either player performs any action, if you have 0 cards in your hand: Draw 1 card. \n\nUsage(s): 3",
                "flavor": 'A genius from the desert, deep within the rainforest\'s temple...',
                'id': '6Z'
            },

            "yayoinanatsuki": {
                "name": "Yayoi Nanatsuki",
                "tags": ['assist', 'companion'],
                "image": "/cards/i_n332037.webp",
                "golden_image": "/cards/i_n336037.webp",
                "hi_res_image": "/cards/i_n332037_gcg_high_resolution.webp",
                "cost": '1 White',
                "description": "When playing an Artifact card: Spend 1 fewer Elemental Die. If two of your characters on the field already have an equipped Artifact, you additionally spend 1 fewer Elemental Die (Once per Round).",
                "flavor": '"If my skill can reach that apex, I am sure that my lacquerware will bear out the pattern of the truth..."',
                'id': '7B'
            },

            'mamere': { 
                'name': 'Mamere',
                'tags': ['assist', 'companion'],
                'hi_res_image': '/cards/i_n332041_gcg_high_resolution.webp',
                'image': '/cards/i_n332041.webp',
                'golden_image': '/cards/i_n336041.webp',
                'cost': '0 White',
                'description': "After you play a Food/Location/Companion/Item Action Card other than Mamere: Randomly create 1 Food/Location/Companion/Item Action Card other than Mamere, and add it to your hand. (Once per Round). \n\nUsage(s): 3",
                'flavor': "A Melusine that paints every day. \n\"Because painting the things that I want to brings me happiness!\"",
                'id': '8N',
            },

            'jeht': { 
                'name': 'Jeht',
                'tags': ['assist', 'companion'],
                'hi_res_image': '/cards/i_n332044_gcg_high_resolution.webp',
                'image': '/cards/i_n332044.webp',
                'golden_image': '/cards/i_n336044.webp',
                'cost': '1 White',
                'description': "This card will record the number of cards discarded from your Support Zone during this match as Sophistication points. (Max 6 points) \n\nAfter your characters use an Elemental Burst: If this card has recorded at least 6 Sophistication points, discard this card and attach Sand and Dreams to your active character.",
                'flavor': "\"Here's a thousand hugs! We will meet again!\"\n\"May we meet again under a lovelier sun.\"",
                'id': '95',
            },

            'silverandmelus': { 
                'name': 'Silver and Melus',
                'tags': ['assist', 'companion'],
                'hi_res_image': '/cards/i_n332045_gcg_high_resolution.webp',
                'image': '/cards/i_n332045.webp',
                'golden_image': '/cards/i_n336045.webp',
                'cost': '1 White',
                'description': "This card will record the number of types of Elemental DMG opposing characters have taken during this match as points of Attendant's Attentiveness. (Max 4 points) \n\nEnd Phase: If you have at least 3 Attendant's Attentiveness points, discard this card and draw cards equal to the amount of Attendant's Attentiveness points.",
                'flavor': "\"Don't be afraid. We will protect you to the very end.\"",
                'id': '96',
            },

            'taroumaru': { 
                'name': 'Taroumaru',
                'tags': ['assist', 'companion'],
                'hi_res_image': '/cards/i_n332049_gcg_high_resolution.webp',
                'image': '/cards/i_n332049.webp',
                'golden_image': '/cards/i_n336049.webp',
                'cost': '2 Black',
                'description': "When played: Create 4 Taroumaru's Savings and distribute them evenly in your deck. \n\nAfter you have played 2 Taroumaru's Savings cards: Discard this card and summon 1 Taroumaru Enraged.",
                'flavor': "The boss of Komore Teahouse, with whom all staff members are said to have signed a \"contract\"...\nFew people know that back in the day, Taroumaru would accompany powerful ninja of the Shuumatsuban, striving in service of the Yashiro Commission...",
                'id': 'AO',
            },

            'tingsfavoritecard': { 
                'name': 'The White Glove and the Fisherman',
                'tags': ['assist', 'companion'],
                'hi_res_image': '/cards/i_n332050_gcg_high_resolution.webp',
                'image': '/cards/i_n332050.webp',
                'golden_image': '/cards/i_n336050.webp',
                'cost': '0 White',
                'description': "End Phase: Create 1 \"Called In For Cleanup\" and place it randomly amongst the 5 cards at the top of your deck. If this card has only 1 Usage(s) remaining, draw 1 card. \n\nUsage(s): 2",
                'flavor': "\"Amongst us, there is our own justice.\"",
                'id': 'AP',
            },

            'sirarthur': { 
                'name': 'Sir Arthur',
                'tags': ['assist', 'companion'],
                'hi_res_image': '/cards/i_n332053_gcg_high_resolution.webp',
                'image': '/cards/i_n332053.webp',
                'golden_image': '/cards/i_n336053.webp',
                'cost': '0 White',
                'description': "After you Discard or use 1 card for Tune: This card gains 1 News Lead point. (Max 2 points) \n\nEnd Phase: If this card already has 2 News Lead points, deduct 2 points, then copy 1 card at the top of your opponent's deck and add it to your Hand",
                'flavor': "\"Hello! Hello!\"",
                'id': 'AS',
            },

            "serene": {
                'name': "Serene",
                'tags': ['assist', 'companion'],
                'hi_res_image': '/cards/gcg_322027_hd.webp',
                'image': '/cards/gcg_322027.webp',
                'golden_image': '/cards/gcg_322027_golden.webp',
                'cost': '2 Black',
                'description': "Triggers automatically once per Round: 1 random Melusine Support is added to your Hand. \n\nUsage(s): 3",
                'flavor': "\"We're going to solve everyone's troubles today, too!\"",
                'id': 'B8',
            },

            "atea": {
                'name': "Atea",
                'tags': ['assist', 'companion'],
                'hi_res_image': '/cards/gcg_322028_hd.webp',
                'image': '/cards/gcg_322028.webp',
                'golden_image': '/cards/gcg_322028_golden.webp',
                'cost': '1 White',
                'description': "When you use a Technique: Spend 1 fewer Elemental Die. (Once per Round)",
                'flavor': "A tribal warrior known as the \"Candlekeeper,\" the pride of the People of the Springs.",
                'id': 'BL',
            },

            "forestblessing": {
                'name': "Forest Blessing",
                'tags': ['assist', 'companion'],
                'hi_res_image': '/cards/gcg_322029_hd.webp',
                'image': '/cards/gcg_322029.webp',
                'golden_image': '/cards/gcg_322029_golden.webp',
                'cost': '2 Black',
                'description': "When played and after your character triggers an Elemental Reaction: Randomly create 1 Origami Flying Squirrel, Pop-Up Paper Frog, or Origami Hamster and add it to your Hand.",
                'flavor': "\"I bestow upon you the blessings of the forest, and offer you a home in this land...\"",
                'id': 'DY',
            },

            "giftofthegoddessofprophecy": {
                'name': "Gift of the Goddess of Prophecy",
                'tags': ['assist', 'companion'],
                'hi_res_image': '/cards/gcg_322030_hd.webp',
                'image': '/cards/gcg_322030.webp',
                'golden_image': '/cards/gcg_322030_golden.webp',
                'cost': '2 Black',
                'description': "When played: Create 2 Toy Guard and add them to your Hand, then create another 2 Toy Guard and randomly place them into your deck. \n\nAfter you play Simulanka Summon, add 1 to its number of effects. \n\nUsage(s): 2",
                'flavor': "\"When that time comes, I shall dance, and return the tracks beneath my people's feet back to the stars in the sky...\"",
                'id': 'DZ',
            },

            "seymour": {
                'name': "Seymour",
                'tags': ['assist', 'companion'],
                'hi_res_image': '/cards/gcg_322031_hd.webp',
                'image': '/cards/gcg_322031.webp',
                'golden_image': '/cards/gcg_322031_golden.webp',
                'cost': '1 White',
                'description': "When played: Copy 1 card from the top of your opponent's deck and add it to your Hand. \n\nWhen you play a card whose name is not in the original deck at the start of the game: Adventure once. (Once per Round, up to twice)",
                'flavor': "\"Welcome back, milady. You are as gentle, lovely, and radiant as ever.\"",
                'id': 'F0',
            },

            "bonaandcocouik": {
                'name': "Bona and Cocouik",
                'tags': ['assist', 'companion'],
                'hi_res_image': '/cards/gcg_322032_hd.webp',
                'image': '/cards/gcg_322032.webp',
                'golden_image': '/cards/gcg_322032_golden.webp',
                'cost': '2 Black',
                'description': "When played: Adventure once. \n\nAfter you use a Technique: Adventure once. (Once per Round)",
                'flavor': "\"For starters, one needs enough curiosity, a thirst for knowledge, and a sense of responsibility to help others.\nBut most importantly, you need the courage to take that first step! Once you make the decision and start on a journey, you've become an adventurer.\"",
                'id': 'FD',
            },

            "lepinepauline": {
                'name': "Lepine-Pauline",
                'tags': ['assist', 'companion'],
                'hi_res_image': '/cards/gcg_322033_hd.webp',
                'image': '/cards/gcg_322033.webp',
                'golden_image': '/cards/gcg_322033_golden.webp',
                'cost': '0 White',
                'description': "When played: Select 1 Investment Plan.",
                'flavor': "\"I'm begging you! Begging you like the beggiest beggar in all of begdom!\"",
                'id': 'G2',
            },

            "netochka": {
                'name': "Netochka",
                'tags': ['assist', 'companion'],
                'hi_res_image': '/cards/gcg_322034_hd.webp',
                'image': '/cards/gcg_322034.webp',
                'golden_image': '/cards/gcg_322034_golden.webp',
                'cost': '1 White',
                'description': "When you trigger a Lunar-Charged, Lunar-Bloom, or Lunar-Crystallize reaction: Attach Battle Plan to your active character. (Once per Round)",
                'flavor': "\"Just as the oppressive, greedy governor here stole treasures from the Frostmoon Scions all those years ago, the Fatui now have seized things that don't belong to them.\nI must retrieve the Proof of the Cognoscenti from them and find Reed Miller's Great Treasure, so that his name, now forgotten, will be held in esteem once more throughout the world!\"",
                'id': 'GF',
            },
            
            "parametrictransformer": {
                "name": "Parametric Transformer",
                "tags": ['assist', 'item'],
                "image": "/cards/i_n332018.webp",
                "golden_image": "/cards/i_n336018.webp",
                "hi_res_image": "/cards/i_n332018_gcg_high_resolution.webp",
                "cost": '2 Black',
                "description": "When either side uses a Skill: If Elemental DMG was dealt, this card gains 1 Qualitative Progress. \n\nIf this card has gained 3 Qualitative Progress, then discard this card and create 3 different Basic Elemental Dice.",
                "flavor": "“Simply put, everything on this earth and below it has cycles. Memories and elements surge throughout the Ley Lines.”\n“Perhaps the ancient civilizations were attempting to uncover the cycle that governs the conversion of dust to treasure.”",
                "id": '30'        
            },
            
            "nre": {
                "name": "NRE",
                "tags": ['assist', 'item'],
                "image": "/cards/i_n332019.webp",
                "golden_image": "/cards/i_n336019.webp",
                "hi_res_image": "/cards/i_n332019_gcg_high_resolution.webp",
                "cost": '1 White',
                "description": "When played: Draw 1 random Food Event Card from your deck. \n\nWhen you play a Food Event Card: Draw 1 random Food Event Card from your deck (once per Round).",
                "flavor": "“Regular nutrition helps in case of physical exertion.”",
                "id": '31'        
            },
    
            "redfeatherfan": {
                "name": "Red Feather Fan",
                "tags": ['assist', 'item'],
                "image": "/cards/i_n332031.webp",
                "golden_image": "/cards/i_n336031.webp",
                "hi_res_image": "/cards/i_n332031_gcg_high_resolution.webp",
                "cost": '2 White',
                "description": "After you switch characters: Gain 1 stack of Efficient Switch and Agile Switch. (Once per Round)",
                "flavor": "Legend has it that this fan is capable of unleashing various effects in the hands of a tengu warrior.\nBut in the hands of an ordinary person, it only possesses the power to \"make one's body lighter.\"\nEven so, this degree of power is more than useful for the average individual.",
                'id': '61'
            },
    
            "treasureseekingseelie": {
                "name": "Treasure-Seeking Seelie",
                "tags": ['assist', 'item'],
                "image": "/cards/i_n332032.webp",
                "golden_image": "/cards/i_n336032.webp",
                "hi_res_image": "/cards/i_n332032_gcg_high_resolution.webp",
                "cost": '1 White',
                "description": "After your character uses a skill: This card will accumulate 1 Treasure Clue. \n\nIf this card has stored 3 Treasure Clues, then discard this card and draw 3 cards.",
                "flavor": 'Strange Seelie capable of guiding people toward treasure. Legend has it that some individuals know how to communicate with these Seelie...',
                'id': '62'
            },

            'seeddispensary': { 
                'name': 'Seed Dispensary',
                'tags': ['assist', 'item'],
                'hi_res_image': '/cards/i_n332042_gcg_high_resolution.webp',
                'image': '/cards/i_n332042.webp',
                'golden_image': '/cards/i_n336042.webp',
                'cost': '0 White',
                'description': "When you play a Support Card with a Current Elemental Dice Cost of 2 or more: Spend 1 fewer Elemental Die. (Once per Round) \n\nUsage(s): 2",
                'flavor': "A special container obtained from Madame Ping. According to her, this dispensary has the power to \"generate seeds\"...",
                'id': '8O',
            },

            'mementolens': { 
                'name': 'Memento Lens',
                'tags': ['assist', 'item'],
                'hi_res_image': '/cards/i_n332043_gcg_high_resolution.webp',
                'image': '/cards/i_n332043.webp',
                'golden_image': '/cards/i_n336043.webp',
                'cost': '1 White',
                'description': "When you play a Weapon/Artifact/Location/Companion card: If you have played a card with the same name previously during this match, spend 2 fewer Elemental Dice to play it. (Once per Round) \n\nUsage(s): 2",
                'flavor': "They say that in the distant past, the legendary Kitsune Saiguu left a catalyst for the then-Hiiragi Clan head, Hiroshi, as a tool to be used in exorcisms.\nThe Hiiragis would have a special Kamera made to order from overseas with that catalyst mounted on its lens assembly, before giving it back to the Grand Narukami Shrine as a symbol of their friendship.",
                'id': '8P',
            },

            'lumenstoneadjuvent': { 
                'name': 'Lumenstone Adjuvant',
                'tags': ['assist', 'item'],
                'hi_res_image': '/cards/i_n332047_gcg_high_resolution.webp',
                'image': '/cards/i_n332047.webp',
                'golden_image': '/cards/i_n336047.webp',
                'cost': "3 Black",
                'description': "After you play an Action Card: If, while this card is on the field, you have already played 3 Action Cards this Round, draw 1 card and create 1 Omni Element. (Once per Round) \n\nUsage(s): 3",
                'flavor': "\"May it be as a sun in your palm, lighting the way through the lightless tunnels and bringing comfort where all is dark.\"",
                'id': '9L',
            },

            'kusava': { 
                'name': 'Kusava',
                'tags': ['assist', 'item'],
                'hi_res_image': '/cards/i_n332054_gcg_high_resolution.webp',
                'image': '/cards/i_n332054.webp',
                'golden_image': '/cards/i_n336054.webp',
                'cost': "1 White",
                'description': "When Action Phase begins: Discard a maximum of 2 cards with the highest Current Elemental Dice Cost in your Hand. For each card you Discard, this card accumulates 1 Memories and Dreams point (maximum of 2). \n\nWhen your character uses a Skill: If you haven't played an Action Card this round, consume 1 Memories and Dreams point, and this Skill costs 1 less Elemental Die.",
                'flavor': "Kusava, Kusava~♪\nMemories and dreams are full of power.\nIt is the fruit of flowering plants, and also the seed of new life.\nThey are the temporary dwelling place of Aranara memories, and they give Aranara strength.",
                'id': 'AT',
            },

            "elementaltransfigurationsuperconductblessing": {
                'name': "Elemental Transfiguration: Superconduct Blessing",
                'tags': ['assist', 'elemental transfiguration'],
                'hi_res_image': '/cards/gcg_331004_hd.webp',
                'image': '/cards/gcg_331004.webp',
                'golden_image': '/cards/gcg_331004_golden.webp',
                'cost': '2 White',
                'description': "Elemental Transfiguration: Cryo Electro \n\nRoll Phase: Always roll 2 Cryo Dice and 2 Electro Dice. \n\nAfter you trigger Superconduct reaction(s): Discard this card, then choose either Superconduct Blessing: Deep Freeze or Superconduct Blessing: Electric Surge and add it to your Hand.",
                'flavor': "The thunder borrows the might of ice, piercing clouds and splitting rocks.",
                'id': 'FQ',
            },

            "elementaltransfigurationvaporizeblessing": {
                'name': "Elemental Transfiguration: Vaporize Blessing",
                'tags': ['assist', 'elemental transfiguration'],
                'hi_res_image': '/cards/gcg_331005_hd.webp',
                'image': '/cards/gcg_331005.webp',
                'golden_image': '/cards/gcg_331005_golden.webp',
                'cost': '2 White',
                'description': "Elemental Transfiguration: Hydro Pyro \n\nRoll Phase: Always roll 2 Hydro Dice and 2 Pyro Dice. \n\nAfter you trigger Vaporize reaction(s): Discard this card, then choose either Vaporize Blessing: Wild Waves or Vaporize Blessing: Searing Burn and add it to your Hand.",
                'flavor': "When water and fire meet in concord, no venture shall fail.",
                'id': 'FR',
            },

            "elementaltransfigurationbloomblessing": {
                'name': "Elemental Transfiguration: Bloom Blessing",
                'tags': ['assist', 'elemental transfiguration'],
                'hi_res_image': '/cards/gcg_331006_hd.webp',
                'image': '/cards/gcg_331006.webp',
                'golden_image': '/cards/gcg_331006_golden.webp',
                'cost': '2 White',
                'description': "Elemental Transfiguration: Hydro Dendro \n\nRoll Phase: Always roll 2 Hydro Dice and 2 Dendro Dice. \n\nAfter you trigger Bloom or Lunar-Bloom reaction(s): Discard this card, then choose either Bloom Blessing: Amrita or Bloom Blessing: Overgrow and add it to your Hand.",
                'flavor': "Nurtured by rain and soil, life thrives in endless bloom.",
                'id': 'G3',
            },

            "elementaltransfigurationlavablessing": {
                'name': "Elemental Transfiguration: Lava Blessing",
                'tags': ['assist', 'elemental transfiguration'],
                'hi_res_image': '/cards/gcg_331007_hd.webp',
                'image': '/cards/gcg_331007.webp',
                'golden_image': '/cards/gcg_331007_golden.webp',
                'cost': '2 White',
                'description': "Elemental Transfiguration: Pyro Geo \n\nRoll Phase: Always roll 2 Pyro Dice and 2 Geo Dice. \n\nAfter you trigger a Pyro Crystallize reaction: Discard this card, then choose either Lava Blessing: Turnfire or Lava Blessing: Remelting and add it to your Hand.",
                'flavor': "Forged of fire and stone, might stands unyielding and eternal.",
                'id': 'G4',
            },

            "elementaltransfigurationrimegrassblessing": {
                'name': "Elemental Transfiguration: Rimegrass Blessing",
                'tags': ['assist', 'elemental transfiguration'],
                'hi_res_image': '/cards/gcg_331008_hd.webp',
                'image': '/cards/gcg_331008.webp',
                'golden_image': '/cards/gcg_331008_golden.webp',
                'cost': '2 White',
                'description': "Elemental Transfiguration: Cryo Dendro \n\nRoll Phase: Always roll 2 Cryo Dice and 2 Dendro Dice. \n\nBefore you choose an action, if there is an opposing character affected by both Cryo and Dendro: Discard this card, then choose either Rimegrass Blessing: Thorn Frost or Rimegrass Blessing: Cold Vine and add it to your Hand.",
                'flavor': "As rime seals the land and the grasses fall still, all sounds are hushed.",
                'id': 'GG',
            },

            "elementaltransfigurationstormgaleblessing": {
                'name': "Elemental Transfiguration: Stormgale Blessing",
                'tags': ['assist', 'elemental transfiguration'],
                'hi_res_image': '/cards/gcg_331009_hd.webp',
                'image': '/cards/gcg_331009.webp',
                'golden_image': '/cards/gcg_331009_golden.webp',
                'cost': '2 White',
                'description': "Elemental Transfiguration: Electro Anemo \n\nRoll Phase: Always roll 2 Electro Dice and 2 Anemo Dice. \n\nAfter you trigger an Electro Swirl reaction: Discard this card, then choose either Stormgale Blessing: Swift Bolt or Stormgale Blessing: Wind Force and add it to your Hand.",
                'flavor': "Wind and thunder surge, swift and unrelenting.",
                'id': 'GH',
            },

            "elementaltransfigurationaquabreezeblessing": {
                'name': "Elemental Transfiguration: Aquabreeze Blessing",
                'tags': ['assist', 'elemental transfiguration'],
                'hi_res_image': '/cards/gcg_331010_hd.webp',
                'image': '/cards/gcg_331010.webp',
                'golden_image': '/cards/gcg_331010_golden.webp',
                'cost': '2 White',
                'description': "Elemental Transfiguration: Hydro Anemo \n\nRoll Phase: Always roll 2 Hydro Dice and 2 Anemo Dice. \n\nAfter you trigger a Swirl (Hydro) reaction: Discard this card, then choose either Aquabreeze Blessing: Waterburst or Aquabreeze Blessing: Vortex and add it to your Hand.",
                'flavor': "Winds rage, waves surge, and the sea rises to meet the sky.",
                'id': 'GR',
            },

            "elementaltransfigurationthunderbloomblessing": {
                'name': "Elemental Transfiguration: Thunderbloom Blessing",
                'tags': ['assist', 'elemental transfiguration'],
                'hi_res_image': '/cards/gcg_331011_hd.webp',
                'image': '/cards/gcg_331011.webp',
                'golden_image': '/cards/gcg_331011_golden.webp',
                'cost': '2 White',
                'description': "Elemental Transfiguration:ElectroDendro \n\nRoll Phase: Always roll 2 Electro Dice and 2 Dendro Dice. \n\nAfter you trigger a Catalyze reaction: Discard this card, then choose either Thunderbloom Blessing: Shatterbolt or Thunderbloom Blessing: Nexus and add it to your Hand.",
                'flavor': "Thunder cracks, and creeping vines burst forth.",
                'id': 'GS',
            },

            "elementaltransfigurationoverloadblessing": {
                'name': "Elemental Transfiguration: Overload Blessing",
                'tags': ['assist', 'elemental transfiguration'],
                'hi_res_image': '/cards/gcg_331012_hd.webp',
                'image': '/cards/gcg_331012.webp',
                'golden_image': '/cards/gcg_331012_golden.webp',
                'cost': '2 White',
                'description': "Elemental Transfiguration:ElectroPyro \n\nRoll Phase: Always roll 2 Electro Dice and 2 Pyro Dice. \n\nAfter you trigger a Overloaded reaction: Discard this card, then choose either Overloaded: Pursuing Fire or Overloaded: Thunderstrike and add it to your Hand.",
                'flavor': "\"Lightning and fire bite as one, bursting forth in dazzling light.\"",
                'id': 'HG',
            },

            "ancientcourtyardMAX1": {
                "name": "Ancient Courtyard",
                "tags": ['event', 'arcane legend'],
                "image": "/cards/i_n333050.webp",
                "golden_image": "/cards/i_n337050.webp",
                "hi_res_image": "/cards/i_n333050_gcg_high_resolution.webp",
                "cost": '0 White',
                "description": "You must have a character who has already equipped a Weapon or Artifact: The next time you play a Weapon or Artifact card in this Round: Spend 2 fewer Elemental Dice. \n\n(Only one \"Arcane Legend\" card can be played for the entire game. This card will be in your starting hand.)",
                "flavor": '"Is mortal life not an empty shell, as unto a dream?"',
                'id': '6O'
            },

            "covenantofrockMAX1": {
                "name": "Covenant of Rock",
                "tags": ['event', 'arcane legend'],
                "image": "/cards/i_n333051.webp",
                "golden_image": "/cards/i_n337051.webp",
                "hi_res_image": "/cards/i_n333051_gcg_high_resolution.webp",
                "cost": '0 White',
                "description": "Can only be played when you have 0 Elemental Dice left: Generate 2 different basic Elemental Dice.\n\n(Only one \"Arcane Legend\" card can be played for the entire game. This card will be in your starting hand.)",
                "flavor": '"Rex Lapis bestowed him with a pair of eyes to see the world, and came to an agreement with him. The dragon then accompanied the Lord of Geo, fighting campaigns alongside him in the four corners of the world..."',
                'id': '6P'
            },

            'joyouscelebrationMAX1': {
                'name': "Joyous Celebration",
                "tags": ['event', 'arcane legend'],
                "image": Joyous_Celebration,
                "golden_image": "/cards/i_n337053.webp",
                "hi_res_image": "/cards/i_n333053_gcg_high_resolution.webp",
                "cost": '0 White',
                "description": "Your active character must be one of the following elemental types to play this card:Cryo/Hydro/Pyro/Electro/Dendro The element corresponding to your active character's Elemental Type will be applied to all your characters affected by elements. \n\n(Only one \"Arcane Legend\" card can be played per match. This card will be in your starting hand.)",
                "flavor": '"Celebration should be shared with everyone."',
                'id': '70'
            },

            'freshwindoffreedomMAX1': {
                'name': "Fresh Wind of Freedom",
                "tags": ['event', 'arcane legend'],
                "image": "/cards/i_n333055.webp",
                "golden_image": "/cards/i_n337055.webp",
                "hi_res_image": "/cards/i_n333055_gcg_high_resolution.webp",
                "cost": '0 White',
                "description": "In this Round, when an opposing character is defeated during your Action, you can continue to act again when that Action ends.\n\nUsage(s)：1\n\n(Only one \"Arcane Legend\" card can be played for the entire game. This card will be in your starting hand.)",
                "flavor": "\"The heavenly bard brushed the strings of the lyre, summoning forth the gale, dispersing the ice and snow, cleaving the peaks, and making the new Mondstadt the home of freedom.\"",
                'id': '7C'
            },

            'ineveryhouseastoveMAX1': {
                'name': "In Every House a Stove",
                "tags": ['event', 'arcane legend'],
                "image": "/cards/i_n333057.webp",
                "golden_image": "/cards/i_n337057.webp",
                "hi_res_image": "/cards/i_n333057_gcg_high_resolution.webp",
                "cost": '0 White',
                "description": "When this card is played in the first Round: If your deck initially contains at least 4/2 different Talent cards, draw 2/1 Talent Card. \n\nWhen this card is played in the second Round or later: Draw a number of cards equal to the current Round number minus 1. (Up to 4 cards can be drawn in this way) \n\n(Only one \"Arcane Legend\" card can be played per match. This card will be in your starting hand.)",
                "flavor": "\"The Stove God cared for the people, turning himself into minions who went into every home, fostering food and solidarity alike.\"",
                'id': '7N'
            },

            'passingofjudgmentMAX1': { 
                'name': 'Passing of Judgment',
                'tags': ['event', 'arcane legend'],
                'hi_res_image': '/cards/i_n333059_gcg_high_resolution.webp',
                'image': '/cards/i_n333059.webp',
                'golden_image': '/cards/i_n337059.webp',
                'cost': "0 White",
                'description': "After the next time the opponent plays an Event Card this Round: Grant Invalidation to all Event Cards in the opponent's Hand. \n\nAfter the opponent Discards from their Hand in this Round: Place the 2 cards with the highest Current Elemental Dice Cost from the opponent's Hand to the bottom of their deck. \n\n(Only one Arcane Legend card can be played per match. This card will be in your starting hand.)",
                'flavor': "\"It is time to make the final decision on this case.\"",
                'id': '8Q',
            },

            'dayofresistancemomentofshattereddreamsMAX1': { 
                'name': 'Day of Resistance: Moment of Shattered Dreams',
                'tags': ['event', 'arcane legend'],
                'hi_res_image': '/cards/i_n333067_gcg_high_resolution.webp',
                'image': '/cards/i_n333067.webp',
                'golden_image': '/cards/i_n337067.webp',
                'cost': '0 White',
                'description': "During this Round, your targeted character takes -1 DMG. (Max 4 times) \n\n(Only one \"Arcane Legend\" card can be played per match. This card will be in your starting hand.)",
                'flavor': "Victorious were we who fought to be free... Thus did the dream of eternal prosperity fall with this mighty capital...",
                'id': '9M',
            },

            'viciousancientbattleMAX1': { 
                'name': 'Vicious Ancient Battle',
                'tags': ['event', 'arcane legend'],
                'hi_res_image': '/cards/i_n333071_gcg_high_resolution.webp',
                'image': '/cards/i_n333071.webp',
                'golden_image': '/cards/i_n337071.webp',
                'cost': '0 White',
                'description': "The opposing active character loses 1 Energy. \n\n(Only one \"Arcane Legend\" card can be played per match. This card will be in your starting hand.)",
                'flavor': "The god whom the people of Watatsumi Island once trusted fought a bitter battle against the ruler of Narukami...\nMusoujin Gorge, that yawning chasm in Yashiori Island, is the lasting scar of that conflict...",
                'id': 'AU',
            },

            "edictofabsolutionMAX1": {
                'name': "Edict of Absolution",
                'tags': ['event', 'arcane legend'],
                'hi_res_image': '/cards/gcg_330009_hd.webp',
                'image': '/cards/gcg_330009.webp',
                'golden_image': '/cards/gcg_330009_golden.webp',
                'cost': '1 White',
                'description': "Heal the target character for 2 HP. \n\nThe target character is immune to Frozen, Stun, Petrification, and other effects that prevent the use of Skills. Also, if this character is the active character, they will not be switched out due to effects. This effect persists for 2 Rounds. \n\n(Only one \"Arcane Legend\" card can be played per match. This card will be in your starting hand.)",
                'flavor': "\"Every last Fontainian is guilty, with judgment and doom certain to one day fall upon them — this is neither metaphor nor rhetoric.\"",
                'id': 'BN',
            },

            "pilgrimageofthereturnofthesacredflameMAX1": {
                'name': "Pilgrimage of the Return of the Sacred Flame",
                'tags': ['event', 'arcane legend'],
                'hi_res_image': '/cards/gcg_330010_hd.webp',
                'image': '/cards/gcg_330010.webp',
                'golden_image': '/cards/gcg_330010_golden.webp',
                'cost': '0 White',
                'description': "Generates Flames of War on both sides. +1 Fighting Spirit to the Flames of War on your side. (Each Flames of War tallies the damage dealt by its side to the other as \"Fighting Spirit.\" At the start of each Round's Action Phase, the side with more \"Fighting Spirit\" will clear their \"Fighting Spirit,\" causing their currently active character to deal +1 DMG in this Round.) \n\n(Only one \"Arcane Legend\" card can be played per match. This card will be in your starting hand.)",
                'flavor': "\"Every participant, whether they win or lose, contributes to the defense of our nation. That's what makes it such an honor to take part.\"",
                'id': 'CJ',
            },

            "fightfordeathMAX1": {
                'name': "Fight for Death",
                'tags': ['event', 'arcane legend'],
                'hi_res_image': '/cards/gcg_330011_hd.webp',
                'image': '/cards/gcg_330011.webp',
                'golden_image': '/cards/gcg_330011_golden.webp',
                'cost': '1 White',
                'description': "Draw 1 card. \n\nFor every character on your side of the field that is defeated: All your remaining characters gain +2 Max HP. \n\n(Only one \"Arcane Legend\" card can be played per match. This card will be in your starting hand.)",
                'flavor': "\"No hero should have to wander alone.\"",
                'id': 'DJ',
            },

            "lostlegaciesinthesandMAX1": {
                'name': "Lost Legacies in the Sand",
                'tags': ['event', 'arcane legend'],
                'hi_res_image': '/cards/gcg_330012_hd.webp',
                'image': '/cards/gcg_330012.webp',
                'golden_image': '/cards/gcg_330012_golden.webp',
                'cost': '0 White',
                'description': "Select one of the following: \n\nPlace 1 card with the highest Current Elemental Dice Cost from your opponent's Hand at the bottom of their deck. \n\nOr \n\nPlace all cards from your Hand at the bottom of your deck and then draw the same number of cards plus 1. \n\n(Only one \"Arcane Legend\" card can be played per match. This card will be in your starting hand.)",
                'flavor': "\"Children of the desert, cling no longer to past grievances. But hold tight to the memory of this act of benevolence...\"",
                'id': 'F1',
            },

            "theothersideofthefrostmoonMAX1": {
                'name': "The Other Side of the Frostmoon",
                'tags': ['event', 'arcane legend'],
                'hi_res_image': '/cards/gcg_330013_hd.webp',
                'image': '/cards/gcg_330013.webp',
                'golden_image': '/cards/gcg_330013_golden.webp',
                'cost': '0 White',
                'description': "When played, and at the start of each Action Phase: Attach Cost Reduction to 1 random card in your Hand. \n\n(Only one \"Arcane Legend\" card can be played per match. This card will be in your starting hand.)",
                'flavor': "\"We are all tainted by sin... How could we ever hope to behold the moonlight in its purest form?\"",
                'id': 'GI',
            },

            "returnofthethreemoonsMAX1": {
                'name': "Return of the Three Moons",
                'tags': ['event', 'arcane legend'],
                'hi_res_image': '/cards/gcg_330014_hd.webp',
                'image': '/cards/gcg_330014.webp',
                'golden_image': '/cards/gcg_330014_golden.webp',
                'cost': '3 White',
                'description': "Discard the 3 cards with the highest Current Elemental Dice Cost in your Hand. \n\nAt the start of your next Round, heal all your characters on the field for 3. \n\nAt the start of the Round after that, add the 3 Discarded cards to your Hand and give each of them 3 stacks of Cost Reduction. \n\n(Only one  \"Arcane Legend\" card can be played per match. This card will be in your starting hand.)",
                'flavor': "\"I turn my body into moonlight, and pour it over Nod-Krai...\"\n\"My soul, I leave here... To inform my future friends...\"\n\"Lastly... I will hide the Trilune authority within the Frost Moon...\"\n\"And when my body, soul, and authority are reunited...\"\n\"Finally...\"",
                'id': 'HH',
            },
            
            "elementalresonancewovenice": {
                "name": "Elemental Resonance: Woven Ice",
                "tags": ['event', 'resonance'],
                "image": "/cards/i_n333000.webp",
                "golden_image": "/cards/i_n337000.webp",
                "hi_res_image": "/cards/i_n333000_gcg_high_resolution.webp",
                "cost": '0 White',
                "description": "Create 1 Cryo Die.\n\n(You must have at least 2 Cryo characters in your deck to add this card to your deck.)",
                "flavor": "Even the sky shall shiver before the ice.",
                "required": "2cryo",
                "id": '32'        
            },
            
            "elementalresonanceshatteringice": {
                "name": "Elemental Resonance: Shattering Ice",
                "tags": ['event', 'resonance'],
                "image": "/cards/i_n333001.webp",
                "golden_image": "/cards/i_n337001.webp",
                "hi_res_image": "/cards/i_n333001_gcg_high_resolution.webp",
                "cost": '1 Cryo',
                "description": "During this Round, your current active character will deal +2 DMG for the next instance.\n\n(You must have at least 2 Cryo characters in your deck to add this card to your deck.)",
                "flavor": "The frost flower blooms as a heart undivided.",
                "required": "2cryo",
                "id": '33'            
            },
            
            "elementalresonancewovenwaters": {
                "name": "Elemental Resonance: Woven Waters",
                "tags": ['event', 'resonance'],
                "image": "/cards/i_n333002.webp",
                "golden_image": "/cards/i_n337002.webp",
                "hi_res_image": "/cards/i_n333002_gcg_high_resolution.webp",
                "cost": '0 White',
                "description": "Create 1 Hydro Die.\n\n(You must have at least 2 Hydro characters in your deck to add this card to your deck.)",
                "flavor": "The dance of water nourishes life.",
                "required": "2hydro",
                "id": '34'        
            },
            
            "elementalresonancesoothingwater": {
                "name": "Elemental Resonance: Soothing Water",
                "tags": ['event', 'resonance'],
                "image": "/cards/i_n333003.webp",
                "golden_image": "/cards/i_n337003.webp",
                "hi_res_image": "/cards/i_n333003_gcg_high_resolution.webp",
                "cost": '1 Hydro',
                "description": "Heal your active character for 2 HP and all your characters on standby for 1 HP. \n\n(You must have at least 2 Hydro characters in your deck to add this card to your deck.)",
                "flavor": "With purest water flows prosperity.",
                "required": "2hydro",
                "id": '35'        
            },
            
            "elementalresonancewovenflames": {
                "name": "Elemental Resonance: Woven Flames",
                "tags": ['event', 'resonance'],
                "image": "/cards/i_n333004.webp",
                "golden_image": "/cards/i_n337004.webp",
                "hi_res_image": "/cards/i_n333004_gcg_high_resolution.webp",
                "cost": '0 White',
                "description": "Create 1 Pyro Die.\n\n(You must have at least 2 Pyro characters in your deck to add this card to your deck.)",
                "flavor": "The scarlet flame reduces the vanquished to dust.",
                "required": "2pyro",
                "id": '36'        
            },
            
            "elementalresonanceferventflames": {
                "name": "Elemental Resonance: Fervent Flames",
                "tags": ['event', 'resonance'],
                "image": "/cards/i_n333005.webp",
                "golden_image": "/cards/i_n337005.webp",
                "hi_res_image": "/cards/i_n333005_gcg_high_resolution.webp",
                "cost": '1 Pyro',
                "description": "During this round, the next instance of Pyro-Related Reactions your current active character triggers deals +3 DMG. \n\n(You must have at least 2 Pyro characters in your deck to add this card to your deck.)",
                "flavor": "A burning heart may match the sun and moon.",
                "required": "2pyro",
                "id": '37'        
            },
            
            "elementalresonancewoventhunder": {
                "name": "Elemental Resonance: Woven Thunder",
                "tags": ['event', 'resonance'],
                "image": "/cards/i_n333006.webp",
                "golden_image": "/cards/i_n337006.webp",
                "hi_res_image": "/cards/i_n333006_gcg_high_resolution.webp",
                "cost": '0 White',
                "description": "Create 1 Electro Die.\n\n(You must have at least 2 Electro characters in your deck to add this card to your deck.)",
                "flavor": "Lightning falls on the land of eternity.",
                "required": "2electro",
                "id": '38'        
            },
            
            "elementalresonancehighvoltage": {
                "name": "Elemental Resonance: High Voltage",
                "tags": ['event', 'resonance'],
                "image": "/cards/i_n333007.webp",
                "golden_image": "/cards/i_n337007.webp",
                "hi_res_image": "/cards/i_n333007_gcg_high_resolution.webp",
                "cost": '1 Electro',
                "description": "Your active character and your next character without maximum Energy gain 1 Energy. \n\n(You must have at least 2 Electro characters in your deck to add this card to your deck.)",
                "flavor": "The storm rises in majesty.",
                "required": "2electro",
                "id": '39'        
            },
            
            "elementalresonancewovenwinds": {
                "name": "Elemental Resonance: Woven Winds",
                "tags": ['event', 'resonance'],
                "image": "/cards/i_n333008.webp",
                "golden_image": "/cards/i_n337008.webp",
                "hi_res_image": "/cards/i_n333008_gcg_high_resolution.webp",
                "cost": '0 White',
                "description": "Create 1 Anemo Die.\n\n(You must have at least 2 Anemo characters in your deck to add this card to your deck.)",
                "flavor": "The wind sings like a leisurely lyre.",
                "required": "2anemo",
                "id": '3A'        
            },
            
            "elementalresonanceimpetuouswinds": {
                "name": "Elemental Resonance: Impetuous Winds",
                "tags": ['event', 'resonance'],
                "image": "/cards/i_n333009.webp",
                "golden_image": "/cards/i_n337009.webp",
                "hi_res_image": "/cards/i_n333009_gcg_high_resolution.webp",
                "cost": '1 Anemo',
                "description": "The next time you perform \"Switch Character\": This action will be considered a Fast Action instead of a Combat Action. It will also cost 1 fewer Elemental Die. \n\nThe next Swirl Reaction you trigger deals +1 DMG to all opposing characters except the target. \n\n(You must have at least 2 Anemo characters in your deck to add this card to your deck.)",
                "flavor": "The gale gallops through the woods.",
                "required": "2anemo",
                "id": '3B'        
            },
            
            "elementalresonancewovenstone": {
                "name": "Elemental Resonance: Woven Stone",
                "tags": ['event', 'resonance'],
                "image": "/cards/i_n333010.webp",
                "golden_image": "/cards/i_n337010.webp",
                "hi_res_image": "/cards/i_n333010_gcg_high_resolution.webp",
                "cost": '0 White',
                "description": "Create 1 Geo Die.\n\n(You must have at least 2 Geo characters in your deck to add this card to your deck.)",
                "flavor": "The jagged mountains sign a lasting pact.",
                "required": "2geo",
                "id": '3C'        
            },
            
            "elementalresonanceenduringrock": {
                "name": "Elemental Resonance: Enduring Rock",
                "tags": ['event', 'resonance'],
                "image": "/cards/i_n333011.webp",
                "golden_image": "/cards/i_n337011.webp",
                "hi_res_image": "/cards/i_n333011_gcg_high_resolution.webp",
                "cost": '1 Geo',
                "description": "Grants 3 Shield points to your active character. \n\n(You must have at least 2 Geo characters in your deck to add this card to your deck.)",
                "flavor": "Bedrock shall make the hills unshakable.",
                "required": "2geo",
                "id": '3D'        
            },
            
            "elementalresonancewovenweeds": {
                "name": "Elemental Resonance: Woven Weeds",
                "tags": ['event', 'resonance'],
                "image": "/cards/i_n333012.webp",
                "golden_image": "/cards/i_n337012.webp",
                "hi_res_image": "/cards/i_n333012_gcg_high_resolution.webp",
                "cost": '0 White',
                "description": "Create 1 Dendro Die.\n\n(You must have at least 2 Dendro characters in your deck to add this card to your deck.)",
                "flavor": "All shall dance in the dream forest.",
                "required": "2dendro",
                "id": '3E'        
            },
            
            "elementalresonancesprawlinggreenery": {
                "name": "Elemental Resonance: Sprawling Greenery",
                "tags": ['event', 'resonance'],
                "image": "/cards/i_n333013.webp",
                "golden_image": "/cards/i_n337013.webp",
                "hi_res_image": "/cards/i_n333013_gcg_high_resolution.webp",
                "cost": '1 Dendro',
                "description": "If you have Burning Flame/Dendro Core or Bountiful Core/Catalyzing Field on the field, deal 1 Pyro DMG/Hydro DMG/Electro DMG to the opposing active character. \n\n(You must have at least 2 Dendro characters in your deck to add this card to your deck.)",
                "flavor": "New branches and sprouts grow into a forest.",
                "required": "2dendro",
                "id": '3F'        
            },

            "moonsignascendantgleam": {
                'name': "Moonsign: Ascendant Gleam",
                'tags': ['event', 'resonance'],
                'hi_res_image': '/cards/gcg_331721_hd.webp',
                'image': '/cards/gcg_331721.webp',
                'golden_image': '/cards/gcg_331721_golden.webp',
                'cost': '0 White',
                'description': "Attach Cost Reduction to 1 random card in your Hand and the top card in your Deck. \n\n(You must have at least 2 Nod-Krai characters in your deck to add this card to your Deck.)",
                'flavor': "\"Come night or day, may the moonlight connect us.\"",
                'required': "2nodkrai",
                'id': 'G5',
            },

            "windandfreedom": {
                "name": "Wind and Freedom",
                "tags": ['event'],
                "image": "/cards/i_n333037.webp",
                "golden_image": "/cards/i_n337037.webp",
                "hi_res_image": "/cards/i_n333037_gcg_high_resolution.webp",
                "cost": '0 White',
                "description": "During this turn, after one of your characters uses a Skill: Switch your next character in to be the active character. \n\n(You must have at least 2 characters from Mondstadt in your deck to add this card to your deck.)",
                "required": '2mond',
                "flavor": '"Someday, the winds will blow towards a brighter future."',
                'id': '63'
            },
    
            "stoneandcontracts": {
                "name": "Stone and Contracts",
                "tags": ['event'],
                "image": "/cards/i_n333038.webp",
                "golden_image": "/cards/i_n337038.webp",
                "hi_res_image": "/cards/i_n333038_gcg_high_resolution.webp",
                "cost": '3 Black',
                "description": "When the Action Phase of the next Round begins: Create 3 Omni Element and draw 1 card. \n\n(You must have at least 2 Liyue characters in your deck to add this card to your deck.)",
                "required": '2liyue',
                "flavor": "\"This is the trust I have placed in them. Betray it, and you taint my blood.\"",
                'id': '64'
            },
    
            "thunderandeternity": {
                "name": "Thunder and Eternity",
                "tags": ['event'],
                "image": "/cards/i_n333039.webp",
                "golden_image": "/cards/i_n337039.webp",
                "hi_res_image": "/cards/i_n333039_gcg_high_resolution.webp",
                "cost": '0 White',
                "description": "Convert all your Elemental Dice to Omni Element. \n\n(You must have at least 2 Inazuman characters in your deck to add this card to your deck.)",
                "required": '2inazuma',
                "flavor": '"It once promised its people a dream: the never-changing \'eternity.\'"',
                'id': '65'
            },
    
            "natureandwisdom": {
                "name": "Nature and Wisdom",
                "tags": ['event'],
                "image": "/cards/i_n333040.webp",
                "golden_image": "/cards/i_n337040.webp",
                "hi_res_image": "/cards/i_n333040_gcg_high_resolution.webp",
                "cost": '1 White',
                "description": "Draw 1 card. After that, switch any cards in your hand.\n\n(You must have at least 2 Sumeru characters in your deck to add this card to your deck.)",
                "required": '2sumeru',
                "flavor": '"That dancing circle embodied everything about the universe. Life has always been the end, while it is wisdom that shall be the means."',
                'id': '66'
            },

            "waterandjustice": {
                "name": "Water and Justice",
                "tags": ['event'],
                "image": "/cards/i_n333072.webp",
                "golden_image": "/cards/i_n337072.webp",
                "hi_res_image": "/cards/i_n333072_gcg_high_resolution.webp",
                "cost": '2 Black',
                "description": "Distributes the HP of all your undefeated characters equally, and then heals all of them for 1 HP. \n\n(You must have at least 2 Fontaine characters in your deck to add this card to your deck.)",
                "required": '2fontaine',
                "flavor": "\"'Existence' was Egeria's justice... and to me, justice is the 'continuation' of that existence.\"",
                'id': 'AX'
            },

            "fireandwar": {
                'name': "Fire and War",
                'tags': ['event'],
                'hi_res_image': '/cards/gcg_331806_hd.webp',
                'image': '/cards/gcg_331806.webp',
                'golden_image': '/cards/gcg_331806_golden.webp',
                'cost': '1 White',
                'description': "Select one of your characters and attach an Ode of Resurrection with 1 \"Reignite\" to them. (When this character is defeated during this Round, consume Elemental Dice equal to the value of \"Reignite,\" grant this character Immunity to Defeat, heal this character to 1 HP, and then gain \"Reignite\" +1.) \n\n(You must have at least 2 Natlan characters in your deck to add this card to your deck)",
                'flavor': "\"We are the inheritors of memory and legend. Those who grew alongside sun and wind. Those who forged our own destiny and future. That is Natlan's fire, the lifeblood of our nation.\"",
                'required': "2natlan",
                'id': 'DL',
            },

            "moonandhomeland": {
                'name': "Moon and Homeland",
                'tags': ['event'],
                'hi_res_image': '/cards/gcg_331807_hd.webp',
                'image': '/cards/gcg_331807.webp',
                'golden_image': '/cards/gcg_331807_golden.webp',
                'cost': '0 White',
                'description': "After you play the next card in this Round: At the start of the next Round, create 1 card that has been played and add it to your Hand. \n\n(You must have at least 2  Nod-Krai characters in your deck to add this card to your deck)",
                'flavor': "\"My moon, my beloved song,\nabandon me not in this dark night.\nMy little doves, bring from that golden city\nthe song of my homeland.\"",
                'required': "2nodkrai",
                'id': 'G6',
            },
            
            "thebestesttravelcompanion": {
                "name": "The Bestest Travel Companion!",
                "tags": ['event'],
                "image": "/cards/i_n333014.webp",
                "golden_image": "/cards/i_n337014.webp",
                "hi_res_image": "/cards/i_n333014_gcg_high_resolution.webp",
                "cost": '2 Black',
                "description": "Create 2 Omni Element.",
                "flavor": "“You might be only one of countless stars, but you’re Paimon’s whole world!”",
                "id": '3G'        
            },
            
            "changingshifts": {
                "name": "Changing Shifts",
                "tags": ['event'],
                "image": "/cards/i_n333015.webp",
                "golden_image": "/cards/i_n337015.webp",
                "hi_res_image": "/cards/i_n333015_gcg_high_resolution.webp",
                "cost": '0 White',
                "description": "The next time you perform \"Switch Character\": Spend 1 fewer Elemental Die.",
                "flavor": "“It’s time for the adults to get to work, and for the kids to get some sleep.”",
                "id": '3H'        
            },
            
            "tossup": {
                "name": "Toss-Up",
                "tags": ['event'],
                "image": "/cards/i_n333016.webp",
                "golden_image": "/cards/i_n337016.webp",
                "hi_res_image": "/cards/i_n333016_gcg_high_resolution.webp",
                "cost": '0 White',
                "description": "Select any Elemental Dice to reroll. Can reroll 2 times.",
                "flavor": "Before the dice are thrown, none can know their own destiny.",
                "id": '3I'        
            },
            
            "strategize": {
                "name": "Strategize",
                "tags": ['event'],
                "image": "/cards/i_n333017.webp",
                "golden_image": "/cards/i_n337017.webp",
                "hi_res_image": "/cards/i_n333017_gcg_high_resolution.webp",
                "cost": '1 White',
                "description": "Draw 2 cards.",
                "flavor": "“This might look quite complicated, but in truth, the possible scenarios do not exceed 187 in number.”",
                "id": '3J'        
            },
            
            "ihaventlostyet": {
                "name": "I Haven’t Lost Yet!",
                "tags": ['event'],
                "image": "/cards/i_n333018.webp",
                "golden_image": "/cards/i_n337018.webp",
                "hi_res_image": "/cards/i_n333018_gcg_high_resolution.webp",
                "cost": '0 White',
                "description": "Only playable if one of your characters is defeated this Round:\n\nCreate 'Omni Element' ×1 and your current active character gains 1 Energy. (Only one copy of I Haven't Lost Yet! can be played each round.)",
                "flavor": "Arataki “He Might Lose but He’ll Never Admit Defeatto” is always game for another round!",
                "id": '3K'        
            },
            
            "leaveittome": {
                "name": "Leave It to Me!",
                "tags": ['event'],
                "image": "/cards/i_n333019.webp",
                "golden_image": "/cards/i_n337019.webp",
                "hi_res_image": "/cards/i_n333019_gcg_high_resolution.webp",
                "cost": '0 White',
                "description": "The next time you perform 'Switch Character': This switch will be considered a 'Fast Action' instead of a 'Combat Action'.",
                "flavor": "“It’s fine, leave everything to me!” — This ranks first among “lines to put Mondstadter hearts at ease.”",
                "id": '3L'        
            },
            
            "whenthecranereturned": {
                "name": "When the Crane Returned",
                "tags": ['event'],
                "image": "/cards/i_n333020.webp",
                "golden_image": "/cards/i_n337020.webp",
                "hi_res_image": "/cards/i_n333020_gcg_high_resolution.webp",
                "cost": '1 White',
                "description": "The next time you use a Skill: Switch your next character in to be the active character.",
                "flavor": "“The crane once returned, and once, she was spurned, she turned, and left alone; now, she might be found, with friends all around, to whom she is bound — a home.”",
                "id": '3M'        
            },
            
            "starsigns": {
                "name": "Starsigns",
                "tags": ['event'],
                "image": "/cards/i_n333021.webp",
                "golden_image": "/cards/i_n337021.webp",
                "hi_res_image": "/cards/i_n333021_gcg_high_resolution.webp",
                "cost": '2 Black',
                "description": "Your current active character gains 1 Energy.",
                "flavor": "“This is destiny, and it cannot be defied.”",
                "id": '3N'        
            },
            
            "calxsarts": {
                "name": "Calx’s Arts",  
                "tags": ['event'],
                "image": "/cards/i_n333022.webp",
                "golden_image": "/cards/i_n337022.webp",
                "hi_res_image": "/cards/i_n333022_gcg_high_resolution.webp",
                "cost": '1 White',
                "description": "Shift 1 Energy from at most 2 of your characters on standby to your active character.",
                "flavor": "“Not to worry. The experiment has been completed, and it is — if I may say so — a great success.”",
                "id": '3O'        
            },
            
            "masterofweaponry": {
                "name": "Master of Weaponry",
                "tags": ['event'],
                "image": "/cards/i_n333023.webp",
                "golden_image": "/cards/i_n337023.webp",
                "hi_res_image": "/cards/i_n333023_gcg_high_resolution.webp",
                "cost": '0 White',
                "description": "Shift 1 Weapon Equipment Card that has been equipped to one of your characters to another one of your characters of the same Weapon Type, and reset the \"usages per Round\" limit on its effects.",
                "flavor": "“Watch and learn, comrade! A real warrior isn’t picky about their weapons!”",
                "id": '3P'        
            },
            
            "blessingofthedivinerelicsinstallation": {
                "name": "Blessing of the Divine Relic’s Installation",
                "tags": ['event'],
                "image": "/cards/i_n333024.webp",
                "golden_image": "/cards/i_n337024.webp",
                "hi_res_image": "/cards/i_n333024_gcg_high_resolution.webp",
                "cost": '0 White',
                "description": "Shift 1 Artifact Card that has been equipped to one of your characters to another one of your characters, and reset the \"usages per Round\" limit on its effects.",
                "flavor": "“Hehe… Well now, isn’t this finally getting interesting?”",
                "id": '3Q'        
            },
            
            "quickknit": {
                "name": "Quick Knit",
                "tags": ['event'],
                "image": "/cards/i_n333025.webp",
                "golden_image": "/cards/i_n337025.webp",
                "hi_res_image": "/cards/i_n333025_gcg_high_resolution.webp",
                "cost": '1 White',
                "description": "Choose one Summon on your side and grant it +1 Usage(s).",
                "flavor": "‘Tis the secret to Baron Bunny the 893rd’s longevity.",
                "id": '3R'        
            },
            
            "sendoff": {
                "name": "Send Off",
                "tags": ['event'],
                "image": "/cards/i_n333026.webp",
                "golden_image": "/cards/i_n337026.webp",
                "hi_res_image": "/cards/i_n333026_gcg_high_resolution.webp",
                "cost": "2 Black",
                "description": "Choose one Summon on the opposing side and cause it to lose 2 Usage(s).",
                "flavor": "“Here at Wangsheng Funeral Parlor, you can count on us to go full send! Satisfaction guaranteed!”",
                "id": '3S'        
            },
            
            "guardiansoath": {
                "name": "Guardian’s Oath",
                "tags": ['event'],
                "image": "/cards/i_n333027.webp",
                "golden_image": "/cards/i_n337027.webp",
                "hi_res_image": "/cards/i_n333027_gcg_high_resolution.webp",
                "cost": '4 White',
                "description": "Destroy all Summons. (Affects both you and your opponent!)",
                "flavor": "“Adeptus Xiao. I will be here when you call.”",
                "id": '3T'        
            },
            
            "abyssalsummons": {
                "name": "Abyssal Summons",
                "tags": ['event'],
                "image": "/cards/i_n333028.webp",
                "golden_image": "/cards/i_n337028.webp",
                "hi_res_image": "/cards/i_n333028_gcg_high_resolution.webp",
                "cost": '2 White',
                "description": "Summon 1 'Random Hilichurl Summon'!\n\n(You must have at least 2 Monster characters in your deck to add this card to your deck.)",
                "related": "Electro Hilichurl Shooter, Cryo Hilichurl Shooter, Hilichurl Berserker, Hydro Samachurl, ",
                "flavor": "“Yaya ika!”",
                "required": "2monster",
                "id": '3U'        
            },
    
            "fatuiconspiracy": {
                "name": "Fatui Conspiracy",
                "tags": ['event'],
                "image": "/cards/i_n333041.webp",
                "golden_image": "/cards/i_n337041.webp",
                "hi_res_image": "/cards/i_n333041_gcg_high_resolution.webp",
                "cost": '2 White',
                "description": "Create 1 Fatui Ambusher of a random type on the opponent's field. \n\n(You must have at least 2 Fatui characters in your deck to add this card to your deck.)",
                'required': '2fatui',
                'related': 'Cryo Cicin Mage, Mirror Maiden, Pyroslinger Bracer, Electrohammer Vanguard',
                "flavor": '...But none know the intricacies of what they are plotting.',
                'id': '67'
            },
    
            "plungingstrike": {
                "name": "Plunging Strike",
                "tags": ['event', 'slowly'],
                "image": "/cards/i_n333042.webp",
                "golden_image": "/cards/i_n337042.webp",
                "hi_res_image": "/cards/i_n333042_gcg_high_resolution.webp",
                "cost": '3 White',
                "description": "Combat Action: Switch to the target character. That character then uses a Normal Attack.",
                "flavor": '"...Don\'t deploy your Wind Glider halfway down! You\'ll get discovered!"',
                'id': '68'
            },
    
            "heavystrike": {
                "name": "Heavy Strike",
                "tags": ['event'],
                "image": "/cards/i_n333043.webp",
                "golden_image": "/cards/i_n337043.webp",
                "hi_res_image": "/cards/i_n333043_gcg_high_resolution.webp",
                "cost": '1 White',
                "description": "During this round, your current active character's next Normal Attack deals +1 DMG. \n\nWhen this Normal Attack is a Charged Attack: Deal +1 additional DMG.",
                "flavor": 'For those that aren\'t so strong...\nIt\'s best to regard the "The Shatterstone Method" as just a "metaphor."',
                'id': '69'
            },
    
            "thelegendofvennessa": {
                "name": "The Legend of Vennessa",
                "tags": ['event'],
                "image": "/cards/i_n333044.webp",
                "golden_image": "/cards/i_n337044.webp",
                "hi_res_image": "/cards/i_n333044_gcg_high_resolution.webp",
                "cost": '3 White',
                "description": "Create 4 basic Elemental Dice of different types.",
                "flavor": '"Lonely forest breezes converged, jointly they overthrew the tyrant\'s tower from the sky."\n"Broken free from shackles at last, the young lioness stood firm in the winds with her head held high."',
                'id': '6A'
            },

            "friendshipeternal": {
                "name": "Friendship Eternal",
                "tags": ['event'],
                "image": "/cards/i_n333045.webp",
                "golden_image": "/cards/i_n337045.webp",
                "hi_res_image": "/cards/i_n333045_gcg_high_resolution.webp",
                "cost": "2 White",
                "description": "Players with less than 4 cards in their hand draw cards until their hand has 4 cards in it.",
                "flavor": "Good friends never truly leave. They stay with us in another form.",
                "id": '6F'
            },

            "rhythmofthegreatdream": {
                "name": "Rhythm of the Great Dream",
                "tags": ['event'],
                "image": "/cards/i_n333052.webp",
                "golden_image": "/cards/i_n337052.webp",
                "hi_res_image": "/cards/i_n333052_gcg_high_resolution.webp",
                "cost": "0 White",
                "description": "The next time you play a Weapon or Artifact card: Spend 1 fewer Elemental Die.",
                "flavor": "\"Enter our dreams, our world.\"\n\"Write of deeds good, brave, and honest.\"",
                "id": '6Q'
            },

            "whereistheunseenrazor": {
                "name": "Where Is the Unseen Razor?",
                "tags": ['event'],
                "image": "/cards/i_n333054.webp",
                "golden_image": "/cards/i_n337054.webp",
                "hi_res_image": "/cards/i_n333054_gcg_high_resolution.webp",
                "cost": "0 White",
                "description": "Return a Weapon card equipped by your character to your Hand. \n\nDuring this Round, the next time you play a Weapon card: Spend 2 fewer Elemental Dice.",
                "flavor": "The origins of this Branch Master of the Adventurers' Guild are shrouded in mystery, yet she keeps looking for clues about the sword, constantly challenging powerful enemies along the way...",
                "id": '71'
            },

            "pankration": {
                "name": "Pankration!",
                "tags": ['event'],
                "image": "/cards/i_n333056.webp",
                "golden_image": "/cards/i_n337056.webp",
                "hi_res_image": "/cards/i_n333056_gcg_high_resolution.webp",
                "cost": "0 White",
                "description": "Can only be played when you have at least 8 Elemental Dice remaining, and your opponent has not yet ended their Round: After a player announces the end of their Round first, the other player, who has yet to announce the end of their Round, draws 2 cards.",
                "flavor": "\"For victory, Credit Coupons, and the hottest goods in the Rag and Bone Shop... and the freedom that may come someday, strike!\"",
                "id": '7D'
            },

            "lyresong": {
                "name": "Lyresong",
                "tags": ['event'],
                "image": "/cards/i_n333058.webp",
                "golden_image": "/cards/i_n337058.webp",
                "hi_res_image": "/cards/i_n333058_gcg_high_resolution.webp",
                "cost": "0 White",
                "description": "Return an Artifact card equipped by your character to your Hand. \n\nDuring this Round, the next time you play an Artifact card from your hand: Spend 1 fewer Elemental Die. If you have not played any other Action Cards before playing this card, spend 2 fewer Elemental Dice.",
                "flavor": "\"The traditions of song and poetry, flowing onward in clear, moving melodies.\"",
                "id": '7O'
            },

            'theboarprincess': { 
                'name': 'The Boar Princess',
                'tags': ['event'],
                'hi_res_image': '/cards/i_n333060_gcg_high_resolution.webp',
                'image': '/cards/i_n333060.webp',
                'golden_image': '/cards/i_n337060.webp',
                'cost': '0 White',
                'description': "Each time you discard 1 Equipment Card from one of your characters during this Round: Gain 1 Omni Element. (Max 2) \n\n(This effect can be triggered by the loss of an Equipment Card from a character falling or from having their Weapon, Artifact, or Technique replaced.)",
                'flavor': "In ancient legends, the Boar Kingdom was prosperous and filled with joy. The young princess of the Kingdom took the wise Fox and long-lived Tortoise, and set out on the road to the north, hoping to turn the little wolf back into that good child...",
                'id': '8R',
            },

            'fallsandfortune': { 
                'name': 'Falls and Fortune',
                'tags': ['event'],
                'hi_res_image': '/cards/i_n333061_gcg_high_resolution.webp',
                'image': '/cards/i_n333061.webp',
                'golden_image': '/cards/i_n337061.webp',
                'cost': "0 White",
                'description': "Can only be played when you have at least 8 Elemental Dice remaining and your opponent has not ended their Round: In this Round, both sides must spend 1 extra Elemental Die when switching characters.",
                'flavor': "The accident of falling into a pit can also be a chance to reveal the buried past beneath the dust.",
                'id': '8S',
            },

            'flickeringfour-leafsigil': { 
                'name': 'Flickering Four-Leaf Sigil',
                'tags': ['event'],
                'hi_res_image': '/cards/i_n333062_gcg_high_resolution.webp',
                'image': '/cards/i_n333062.webp',
                'golden_image': '/cards/i_n337062.webp',
                'cost': '0 White',
                'description': "Attach Four-Leaf Sigil to target character: At the End Phase of Every Round, you will switch to this character.",
                'flavor': "A wondrous symbol shaped like a four-leaf clover, it is of great assistance to one who manipulates the elements.",
                'related': 'Four-Leaf Sigil',
                'id': '8T',
            },

            'machineassemblyline': { 
                'name': 'Machine Assembly Line',
                'tags': ['event'],
                'hi_res_image': '/cards/i_n333064_gcg_high_resolution.webp',
                'image': '/cards/i_n333064.webp',
                'golden_image': '/cards/i_n337064.webp',
                'cost': "1 White",
                'description': "Deals 1 Physical DMG to your active character. Draw 1 random Artifact card from your deck.",
                'flavor': "Countless widgets, heated and forged, eventually go into making these exceptional machines, and to the inmates of the Fortress of Meropide, they mean valuable Credit Coupons...",
                'id': '97',
            },

            'sunyataflower': { 
                'name': 'Sunyata Flower',
                'tags': ['event'],
                'hi_res_image': '/cards/i_n333065_gcg_high_resolution.webp',
                'image': '/cards/i_n333065.webp',
                'golden_image': '/cards/i_n337065.webp',
                'cost': '0 White',
                'description': "Select a card from your Support Zone and discard it. After that, randomly generate 2 Support Cards in your hand. \n\nDuring the Round, the next time you play a Support Card: Spend 1 fewer Elemental Die.",
                'flavor': "\"This vibrant color is the miracle of life's flowing springs.\"\n\"Abide with me, sing and caper with me, and let us weave eternal joy\"...",
                'id': '98',
            },

            'controlleddirectionalblast': { 
                'name': 'Controlled Directional Blast',
                'tags': ['event'],
                'hi_res_image': '/cards/i_n333068_gcg_high_resolution.webp',
                'image': '/cards/i_n333068.webp',
                'golden_image': '/cards/i_n337068.webp',
                'cost': '1 White',
                'description': "Can only be played when there is a total of at least 4 cards in your opponent's Support Zone and Summons Zone: All Summons on both sides lose 1 Usage.",
                'flavor': "\"...haven't hidden anything. All the Arkhium has been handled appropriately. This explosion was always a 'controllable hazard removal directional blast.'\"",
                'id': '9N',
            },

            'underwatertreasurehunt': { 
                'name': 'Underwater Treasure Hunt',
                'tags': ['event'],
                'hi_res_image': '/cards/i_n333069_gcg_high_resolution.webp',
                'image': '/cards/i_n333069.webp',
                'golden_image': '/cards/i_n337069.webp',
                'cost': '2 White',
                'description': "Create 6 Undersea Treasure and place them into your deck at random.",
                'flavor': "Beryl Conches, Lumitoiles, and the occasional treasure chest hidden within a shell...",
                'id': 'AV',
            },

            'countdown': { 
                'name': 'Countdown to the Show: 3',
                'tags': ['event'],
                'hi_res_image': '/cards/i_n333073_gcg_high_resolution.webp',
                'image': '/cards/i_n333073.webp',
                'golden_image': '/cards/i_n337073.webp',
                'cost': '3 White',
                'description': "Convert all your Elemental Dice to Omni Element and draw 4 cards. \n\nAfter you Discard this card from your Hand or deck: Place 1 \"Countdown to the Show\" card that costs 1 fewer Elemental Die than this one on the top of your deck.",
                'flavor': "\"Would you like to see a magic trick? Now then, count down with me — three... two... one!\"",
                'id': 'AY',
            },

            "idratherlosemoneymyself": {
                'name': "\"I'd Rather Lose Money Myself...\"",
                'tags': ['event'],
                'hi_res_image': '/cards/gcg_332036_hd.webp',
                'image': '/cards/gcg_332036.webp',
                'golden_image': '/cards/gcg_332036_golden.webp',
                'cost': '0 White',
                'description': "Each time your opponent gains 1 Elemental Die during this Round: If you have not declared the end of your Round, you will create 1 Omni Element. Otherwise, create 1 Shield. \n\nUsage(s): 3",
                'flavor': "\"...than see that rascal make some!\"",
                'id': 'B9',
            },

            "tada": {
                'name': "Tada!",
                'tags': ['event'],
                'hi_res_image': '/cards/gcg_332037_hd.webp',
                'image': '/cards/gcg_332037.webp',
                'golden_image': '/cards/gcg_332037_golden.webp',
                'cost': '0 White',
                'description': "Deal 1 Physical DMG to your active character. Draw 1 card during the End Phase of this Round.",
                'flavor': "\"Surprise.\"",
                'id': 'BA',
            },

            "sauriandiningbuddies": {
                'name': "Saurian Dining Buddies",
                'tags': ['event'],
                'hi_res_image': '/cards/gcg_332039_hd.webp',
                'image': '/cards/gcg_332039.webp',
                'golden_image': '/cards/gcg_332039_golden.webp',
                'cost': '0 White',
                'description': "Select 1 Technique equipped to your characters and increase its Usage(s) by 1.",
                'flavor': "\"...Last but not least: Get 'em some good grub! The way to a Saurian's heart is through the stomach, after all!\"",
                'id': 'BM',
            },

            "eremiteteatime": {
                'name': "Eremite Teatime",
                'tags': ['event'],
                'hi_res_image': '/cards/gcg_332040_hd.webp',
                'image': '/cards/gcg_332040.webp',
                'golden_image': '/cards/gcg_332040_golden.webp',
                'cost': '2 White',
                'description': "If you have multiple characters of the same Elemental Type, then Select 1 Location card from 3 to add to your Hand; \n\nIf you have multiple characters that use the same type of weapon, then Select 1 Item card from 3 to add to your Hand; \n\nIf you have characters that belong to the same faction, then Select 1 Food card from 3 to add to your Hand.",
                'flavor': "\"Join the Eremites and Embrace a Wonderful New Life!\"",
                'id': 'BY',
            },

            "ultimatesurfingbuddy": {
                'name': "Ultimate Surfing Buddy!",
                'tags': ['event', 'slowly'],
                'hi_res_image': '/cards/gcg_332041_hd.webp',
                'image': '/cards/gcg_332041.webp',
                'golden_image': '/cards/gcg_332041_golden.webp',
                'cost': '0 White',
                'description': "Combat Action: Can only be played when there are at least a total of 2 Summons on the field (Both sides' Summons count) Randomly triggers an End Phase effect of one of your and the opponent's Summons each.",
                'flavor': "\"Just find yourself a good swell, pick up a suitable surfboard, and you too can experience the joys of surfing whenever you want!\"",
                'id': 'CA',
            },

            "abundantphlogiston": {
                'name': "Abundant Phlogiston",
                'tags': ['event'],
                'hi_res_image': '/cards/gcg_332042_hd.webp',
                'image': '/cards/gcg_332042.webp',
                'golden_image': '/cards/gcg_332042_golden.webp',
                'cost': '0 White',
                'description': "After the next time your character uses Nightsoul points this Round: This character will regain 1 Nightsoul point.",
                'flavor': "A special high-temperature thermal energy that can be found throughout Natlan. It comes in all shapes and sizes, and has many wondrous uses...\nAfter Nightsoul points are fully depleted, warriors will switch to consuming Phlogiston to maintain their Nightsoul's Blessing.",
                'id': 'CK',
            },

            "littletepetlisaurtreasurehunteratlarge": {
                'name': "Little Tepetlisaur — Treasure Hunter at Large",
                'tags': ['event'],
                'hi_res_image': '/cards/gcg_332043_hd.webp',
                'image': '/cards/gcg_332043.webp',
                'golden_image': '/cards/gcg_332043_golden.webp',
                'cost': '1 White',
                'description': "Add 2 Abundant Phlogiston cards to both your and your opponent's Decks, after which both of you draw 2 cards.",
                'flavor': "\"Shiny stones that gleam like gold!\"",
                'id': 'CR',
            },

            "inthenameoftheextreme": {
                'name': "In the Name of the Extreme",
                'tags': ['event'],
                'hi_res_image': '/cards/gcg_332044_hd.webp',
                'image': '/cards/gcg_332044.webp',
                'golden_image': '/cards/gcg_332044_golden.webp',
                'cost': '4 White',
                'description': "Exchange Hands with your opponent, then the player with fewer cards in their Hand draws until they have the same number of cards as the other player.",
                'flavor': "\"Relax your body and embrace the storm! Together with your companions, chase the tailwinds of extremity.\"",
                'id': 'CZ',
            },

            "artofsleepymeditation": {
                'name': "Art of Sleepy Meditation",
                'tags': ['event'],
                'hi_res_image': '/cards/gcg_332045_hd.webp',
                'image': '/cards/gcg_332045.webp',
                'golden_image': '/cards/gcg_332045_golden.webp',
                'cost': '1 White',
                'description': "Select 1 from 3 random Technique Cards. \n\nSpend 2 fewer Elemental Dice the next time you play a card that was not in your initial deck at the start of the match.",
                'flavor': "\"What is the nature of meditation... Hey! Whatever it is, it sure as heck isn't sleeping!\"",
                'id': 'D7',
            },

            "flyingsquadattack": {
                'name': "Flying Squad, Attack!",
                'tags': ['event'],
                'hi_res_image': '/cards/gcg_332046_hd.webp',
                'image': '/cards/gcg_332046.webp',
                'golden_image': '/cards/gcg_332046_golden.webp',
                'cost': '3 Black',
                'description': "Randomly Discard up to 2 cards from your hand with the highest Current Elemental Dice Cost, then draw cards until there are 4 cards in your Hand. \n\nAfter you Discard this card from your Hand: Draw 1 card.",
                'flavor': "\"Back when the Flower-Feather Clan was responsible for patrolling and defending all of Natlan, the flying squad was the best of the best — the fiercest warriors in the nation.\"",
                'id': 'DK',
            },

            "fruitsoftraining": {
                'name': "Fruits of Training",
                'tags': ['event'],
                'hi_res_image': '/cards/gcg_332048_hd.webp',
                'image': '/cards/gcg_332048.webp',
                'golden_image': '/cards/gcg_332048_golden.webp',
                'cost': '0 White',
                'description': "Select one of your characters. When your other characters prepare a Skill: Your selected character's next Elemental Skill will cost 1 fewer Elemental Die. (Can be triggered up to 2 times, cannot stack)",
                'flavor': "\"I keep telling them it's down to the training... Why doesn't anybody listen?\"",
                'id': 'DM',
            },

            "harvesttime": {
                'name': "Harvest Time",
                'tags': ['event'],
                'hi_res_image': '/cards/gcg_332049_hd.webp',
                'image': '/cards/gcg_332049.webp',
                'golden_image': '/cards/gcg_332049_golden.webp',
                'cost': '1 White',
                'description': "Select 1 out of 3 Food Cards. \n\nEnd Phase: Create 1 Harvest Time and randomly place it into your deck.",
                'flavor': "\"Very good. Exactly like that. Keep it up.\"",
                'id': 'E0',
            },

            "awesomebro": {
                'name': "Awesome, Bro",
                'tags': ['event'],
                'hi_res_image': '/cards/gcg_332050_hd.webp',
                'image': '/cards/gcg_332050.webp',
                'golden_image': '/cards/gcg_332050_golden.webp',
                'cost': '1 White',
                'description': "Draw 1  Technique card. The next time you play a  Technique card, create 1 Omni Element.",
                'flavor': "\"Alright, come here, sit still, open up, and say 'ah'!\"",
                'id': 'E1',
            },

            "felldragonsawakening": {
                'name': "Fell Dragon's Awakening",
                'tags': ['event', 'simulanka'],
                'hi_res_image': '/cards/gcg_332051_hd.webp',
                'image': '/cards/gcg_332051.webp',
                'golden_image': '/cards/gcg_332051_golden.webp',
                'cost': '2 White',
                'description': "Summon Fell Dragon. \n\nDuring this match, for each card you discard from the Support Zone, Fell Dragon gains 1 Usage. For each card you discard from the Summon Zone, Fell Dragon gains 1 Effect. (Can stack. Max 4 stacks.) \n\n(Fell Dragon: End Phase: Deal 1 Piercing DMG. \n\nUsage(s): 1)",
                'flavor': "\"It came down from the skies in an ominous black mist and ravaged our homeland...\"",
                'id': 'EB',
            },

            "narrationfootnotes": {
                'name': "Narration Footnotes",
                'tags': ['event', 'simulanka'],
                'hi_res_image': '/cards/gcg_332052_hd.webp',
                'image': '/cards/gcg_332052.webp',
                'golden_image': '/cards/gcg_332052_golden.webp',
                'cost': '0 White',
                'description': "Both sides summon 1 Toy Guard. \n\n(Toy Guard: End Phase: Deal 1 Physical DMG. \n\nUsage(s): 2)",
                'flavor': "\"Suspect, try and look more serious. Heroes, more natural please, happy smiles! ...But no smiling from the victim or their friends and family, thank you. No, no, don't get up! Stay on the ground, we need to capture the crime scene as-is!\"",
                'id': 'EC',
            },

            "brokensea": {
                'name': "Broken Sea",
                'tags': ['event', 'simulanka'],
                'hi_res_image': '/cards/gcg_332053_hd.webp',
                'image': '/cards/gcg_332053.webp',
                'golden_image': '/cards/gcg_332053_golden.webp',
                'cost': '1 White',
                'description': "Select a card from your Support Zone and discard it. Then all of your Simulanka Summons gain +1 Usage and +1 Effect.",
                'flavor': "\"We surge through different bushes and shrubs like a gust of wind, like rivers passing through another lake... We encounter different things, and we, too, become different people.\"",
                'id': 'ED',
            },

            "ablessingfromm": {
                'name': "\"A Blessing From 'M'\"",
                'tags': ['event', 'simulanka'],
                'hi_res_image': '/cards/gcg_332054_hd.webp',
                'image': '/cards/gcg_332054.webp',
                'golden_image': '/cards/gcg_332054_golden.webp',
                'cost': '0 White',
                'description': "Select a summon on your side to discard, convert its Usage(s) into up to 2 basic Elemental Dice of different types. If its usage count is no less than 3, then heal the most damaged character on your side for 2 HP.",
                'flavor': "\"Go forth and witness this world, my child... Make sure to be nice to everyone...\nYou'll meet good friends one day, I'm sure of it... That is my wish for your future.\"",
                'id': 'EE',
            },

            "revelrousbeats": {
                'name': "\"Revelrous Beats\"",
                'tags': ['event'],
                'hi_res_image': '/cards/gcg_332055_hd.webp',
                'image': '/cards/gcg_332055.webp',
                'golden_image': '/cards/gcg_332055_golden.webp',
                'cost': '2 Black',
                'description': "Draw 2 cards. If you have more than 1 Weapon or Artifact card in your hand, create 1 Omni Element for each.",
                'flavor': "\"Come on! Follow the beat!\"",
                'id': 'EF',
            },

            "anancientsacrificeofsacredbrocade": {
                'name': "An Ancient Sacrifice of Sacred Brocade",
                'tags': ['event'],
                'hi_res_image': '/cards/gcg_332056_hd.webp',
                'image': '/cards/gcg_332056.webp',
                'golden_image': '/cards/gcg_332056_golden.webp',
                'cost': '1 White',
                'description': "Adventure: Once. If your Adventure Experience is not less than 4, change to deal 1 Physical DMG to your Active Character, and Adventure: Twice.",
                'flavor': "\"Have you noticed them, seen them? The children who wash their little feet in the streams, fishermen laughing beneath the light of the rainbow's arc, the moonlight trysts of lovebirds, their figures painted silver... Humans, too, are creatures of this land. Just how different is their innocence from ours?\"",
                'id': 'ER',
            },

            "thenarzissenkreuzadventure": {
                'name': "The Narzissenkreuz Adventure",
                'tags': ['event'],
                'hi_res_image': '/cards/gcg_332057_hd.webp',
                'image': '/cards/gcg_332057.webp',
                'golden_image': '/cards/gcg_332057_golden.webp',
                'cost': '1 White',
                'description': "If you have multiple characters of the same Elemental Type, then heal your most damaged character for 1 HP. \n\nIf you have multiple characters that use the same type of weapon, then draw 1 card. \n\nIf you have characters that belong to the same faction, then Adventure once.",
                'flavor': "\"Before you arrived, I had a dream. I dreamed that I was a small, brave Oceanid, and we set out to save the Princess...\"",
                'id': 'F2',
            },

            "plantosavetheworld": {
                'name': "Plan to Save the World",
                'tags': ['event'],
                'hi_res_image': '/cards/gcg_332058_hd.webp',
                'image': '/cards/gcg_332058.webp',
                'golden_image': '/cards/gcg_332058_golden.webp',
                'cost': '2 White',
                'description': "At the End Phase of the next Round, each side's active character's HP is set to 5.",
                'flavor': "\"I refuse. The world is not as weak as you think.\"",
                'id': 'F3',
            },

            "anadventurethroughthemorningmist": {
                'name': "\"An Adventure Through the Morning Mist\"",
                'tags': ['event'],
                'hi_res_image': '/cards/gcg_332059_hd.webp',
                'image': '/cards/gcg_332059.webp',
                'golden_image': '/cards/gcg_332059_golden.webp',
                'cost': '0 White',
                'description': "Put at most 2 cards with the lowest Current Elemental Dice Cost in your Hand at the bottom of your deck, then draw the same number of cards. \n\nAfter this card is Discarded: Adventure once.",
                'flavor': "\"...I won't let you get it! Because we're going to stop your plan, right here!\"",
                'id': 'FE',
            },

            "geniussupgradetechnique": {
                'name': "Genius's Upgrade Technique",
                'tags': ['event'],
                'hi_res_image': '/cards/gcg_332060_hd.webp',
                'image': '/cards/gcg_332060.webp',
                'golden_image': '/cards/gcg_332060_golden.webp',
                'cost': '0 White',
                'description': "Generate 1 random Item Card. Grant Empowerment to the 2 cards with the highest Current Elemental Dice Cost in your Hand.",
                'flavor': "\"Alright, upgrade complete! Time to treat myself to a tasty snack.\"",
                'id': 'FS',
            },

            "clinkclanklegion": {
                'name': "Clink Clank Legion",
                'tags': ['event'],
                'hi_res_image': '/cards/gcg_332061_hd.webp',
                'image': '/cards/gcg_332061.webp',
                'golden_image': '/cards/gcg_332061_golden.webp',
                'cost': '1 White',
                'description': "Create 3 random cards with an original Elemental Dice cost of 3 and add them to your Hand. \n\nIf this card has Empowerment attached, attach Empowerment to the 3 cards in your Hand with the highest Current Elemental Dice Cost.",
                'flavor': "\"Clink Clank Legion, move out!\"",
                'id': 'FT',
            },

            "cleaningtime": {
                'name': "Cleaning Time",
                'tags': ['event'],
                'hi_res_image': '/cards/gcg_332062_hd.webp',
                'image': '/cards/gcg_332062.webp',
                'golden_image': '/cards/gcg_332062_golden.webp',
                'cost': '0 White',
                'description': "For each type of effect status applied to your Hand, create 1 random basic Elemental Die. (Max 2)",
                'flavor': "\"Cleanup sequence in progress... Based on data from past incidents, please avoid dropping small items such as: Mora, screws, gears, minerals, toys, gummies, snacks, hairbands, socks, and slippers.\"",
                'id': 'G7',
            },

            "lilfungisfuntasticfiesta": {
                'name': "Lil' Fungi's Fun-Tastic Fiesta",
                'tags': ['event'],
                'hi_res_image': '/cards/gcg_332063_hd.webp',
                'image': '/cards/gcg_332063.webp',
                'golden_image': '/cards/gcg_332063_golden.webp',
                'cost': '5 White',
                'description': "Increase DMG dealt by your targeted Monster characters by 1. (Cannot stack) \n\n While this card is in your Hand, whenever your Monster characters use Skills: Grants Cost Reduction to this card. \n\nWhen this card is Discarded: A random one of your Monster characters gains +1 Max HP. \n\n(Can only be added to your deck if it contains at least 2 Monster characters)",
                'flavor': "\"Lil' Fungi, Loads of Fun!\"",
                'id': 'GT',
            },

            "thepowerofresearch": {
                'name': "The Power of Research",
                'tags': ['event'],
                'hi_res_image': '/cards/gcg_332064_hd.webp',
                'image': '/cards/gcg_332064.webp',
                'golden_image': '/cards/gcg_332064_golden.webp',
                'cost': '1 White',
                'description': "The next 3 times you play a card with a Current Elemental Dice Cost of 3 or more, create 1 random basic Elemental Die.",
                'flavor': "\"Science, of course! That's the only way!\"",
                'id': 'GU',
            },

            "witchshomework": {
                'name': "Witch's Homework",
                'tags': ['event'],
                'hi_res_image': '/cards/gcg_332065_hd.webp',
                'image': '/cards/gcg_332065.webp',
                'golden_image': '/cards/gcg_332065_golden.webp',
                'cost': '1 White',
                'description': "Draw 1  Talent card. If your deck initially contains at least 3  Talent cards, grant Cost Reduction to a random  Talent card with the highest Current Elemental Dice Cost in your Hand.",
                'flavor': "\"Rather than a scenario where we jump in and save the day out of nowhere, it makes more sense to lay the groundwork over time...\"",
                'id': 'H6',
            },

            "feastinginasharedtoast": {
                'name': "Feasting in a Shared Toast",
                'tags': ['event'],
                'hi_res_image': '/cards/gcg_332066_hd.webp',
                'image': '/cards/gcg_332066.webp',
                'golden_image': '/cards/gcg_332066_golden.webp',
                'cost': '0 White',
                'description': "When the next Round begins: Both sides draw 2 cards and gain 2 random Elemental Dice.",
                'flavor': "Always the last one, as usual! Grab a seat, we've been waiting ages for you!",
                'id': 'H7',
            },
            
            "jueyunguoba": {
                "name": "Jueyun Guoba",
                "tags": ['event', 'food'],
                "image": "/cards/i_n333029.webp",
                "golden_image": "/cards/i_n337029.webp",
                "hi_res_image": "/cards/i_n333029_gcg_high_resolution.webp",
                "cost": '0 White',
                "description": "During this Round, the target character’s next Normal Attack deals +1 DMG.\n\n(A character can consume at most 1 Food per Round)",
                "flavor": "Flavorful and crispy Jueyun Guoba — with Guoba’s stamp of approval.",
                "id": '3V'        
            },
            
            "adeptustemptation": {
                "name": "Adeptus’ Temptation",
                "tags": ['event', 'food'],
                "image": "/cards/i_n333030.webp",
                "golden_image": "/cards/i_n337030.webp",
                "hi_res_image": "/cards/i_n333030_gcg_high_resolution.webp",
                "cost": '2 Black',
                "description": "During this Round, the target character’s next Elemental Burst deals +3 DMG.\n\n(A character can consume at most 1 Food per Round)",
                "flavor": "It is said that this name was derived from this dish’s ability to tempt an adeptus to return to the mortal realm. But that begs the question… Which adeptus was that?",
                "id": '3W'        
            },
            
            "lotusflowercrisp": {
                "name": "Lotus Flower Crisp",
                "tags": ['event', 'food'],
                "image": "/cards/i_n333031.webp",
                "golden_image": "/cards/i_n337031.webp",
                "hi_res_image": "/cards/i_n333031_gcg_high_resolution.webp",
                "cost": '1 White',
                "description": "During this Round, the target character takes -3 DMG the next time. \n\n(A character can consume at most 1 Food per Round)",
                "flavor": "Dough is formed into bud-like shapes and placed into a pot of oil as if upon the surface of a lake, causing them to slowly bloom layer by layer… A pleasing sight indeed.",
                "id": '3X'        
            },
            
            "northernsmokedchicken": {
                "name": "Northern Smoked Chicken",
                "tags": ['event', 'food'],
                "image": "/cards/i_n333032.webp",
                "golden_image": "/cards/i_n337032.webp",
                "hi_res_image": "/cards/i_n333032_gcg_high_resolution.webp",
                "cost": '0 White',
                "description": "During this Round, the target character’s next Normal Attack costs 1 less 'Unaligned Element'.\n\n(A character can consume at most 1 Food per Round)",
                "flavor": "This dish makes for a warm welcome for guests who come to the northern regions. Now, what manner of guests shall be “treated” to this hospitality this time?",
                "id": '3Y'        
            },
            
            "sweetmadame": {
                "name": "Sweet Madame",
                "tags": ['event', 'food'],
                "image": "/cards/i_n333033.webp",
                "golden_image": "/cards/i_n337033.webp",
                "hi_res_image": "/cards/i_n333033_gcg_high_resolution.webp",
                "cost": '0 White',
                "description": "Heal the target character for 1 HP.\n\n(A character can consume at most 1 Food per Round)",
                "flavor": "Perhaps some have never seen a chicken run… But there’s no one who hasn’t tried a Sweet Madame!",
                "id": '3Z'        
            },
            
            "mondstadthashbrown": {
                "name": "Mondstadt Hash Brown",
                "tags": ['event', 'food'],
                "image": "/cards/i_n333034.webp",
                "golden_image": "/cards/i_n337034.webp",
                "hi_res_image": "/cards/i_n333034_gcg_high_resolution.webp",
                "cost": '1 White',
                "description": "Heal the target character for 2 HP.\n\n(A character can consume at most 1 Food per Round)",
                "flavor": "The sweet taste verifies the famous words of a certain famous gourmet known throughout Teyvat — a dish that may be called a regional specialty cannot taste bad.",
                "id": '40'        
            },
            
            "mushroompizza": {
                "name": "Mushroom Pizza",
                "tags": ['event', 'food'],
                "image": "/cards/i_n333035.webp",
                "golden_image": "/cards/i_n337035.webp",
                "hi_res_image": "/cards/i_n333035_gcg_high_resolution.webp",
                "cost": '1 White',
                "description": "Heal the target character for 1 HP. For the next two Rounds, heal this character for 1 HP again at the End Phase.\n\n(A character can consume at most 1 Food per Round)",
                "flavor": "They say that a researcher once used very precise calculations to uncover the “fairest way to cut pizza,” but as the process is far too bothersome, basically no one uses it…",
                "id": '41'        
            },
            
            "mintymeatrolls": {
                "name": "Minty Meat Rolls",
                "tags": ['event', 'food'],
                "image": "/cards/i_n333036.webp",
                "golden_image": "/cards/i_n337036.webp",
                "hi_res_image": "/cards/i_n333036_gcg_high_resolution.webp",
                "cost": '1 White',
                "description": "Before this Round ends, the target character's next 3 Normal Attacks cost 1 fewer Unaligned Element. \n\n(A character can consume at most 1 Food per Round)",
                "flavor": "Though this might be its current form, think about it for a moment: did this dish first start as mint rolled around meat, or meat rolled around mint?",
                "id": '42'        
            },  
    
            "teyvatfriedegg": {
                "name": "Teyvat Fried Egg",
                "tags": ['event', 'food'],
                "image": "/cards/i_n333046.webp",
                "golden_image": "/cards/i_n337046.webp",
                "hi_res_image": "/cards/i_n333046_gcg_high_resolution.webp",
                "cost": '2 White',
                'description': "Revives the target character and heals that character for 1 HP. \n\n(You can only revive 1 character via Food per Round, and a character can consume at most 1 Food per Round)",
                "flavor": "With a taste of the summer sun, it invigorates you from the first bite.\nTake care to eat this meal slowly, and avoid choking the throat of destiny when impelled by the fullness of life's vitality.",
                'id': '6B'
            },
    
            "sashimiplatter": {
                "name": "Sashimi Platter",
                "tags": ['event', 'food'],
                "image": "/cards/i_n333047.webp",
                "golden_image": "/cards/i_n337047.webp",
                "hi_res_image": "/cards/i_n333047_gcg_high_resolution.webp",
                "cost": '1 White',
                "description": "Before this Round ends, the target character's Normal Attacks deal +1 DMG.\n\n(A character can consume at most 1 Food per Round)",
                "flavor": 'Under the blade of a master chef, the texture of the ingredients remains pristine. Upon consumption, it is as if something living is leaping inside your mouth...\nHold on, could these ingredients still be...',
                'id': '6C'
            },
    
            "tandooriroastchicken": {
                "name": "Tandoori Roast Chicken",
                "tags": ['event', 'food'],
                "image": "/cards/i_n333048.webp",
                "golden_image": "/cards/i_n337048.webp",
                "hi_res_image": "/cards/i_n333048_gcg_high_resolution.webp",
                "cost": '2 Black',
                "description": "During this Round, all your characters' next Elemental Skills deal +2 DMG.\n\n(A character can consume at most 1  Food per Round)",
                "flavor": "The chicken and spices are capable of performing a mysterious Sumeru dance on the tip of your tongue, evoking the image of a festive banquet...\nBut even a dish so delicious has its last bite, and every feast has its end.",
                'id': '6D'
            },
            "buttercrab": {
                "name": "Butter Crab",
                "tags": ['event', 'food'],
                "image": "/cards/i_n333049.webp",
                "golden_image": "/cards/i_n337049.webp",
                "hi_res_image": "/cards/i_n333049_gcg_high_resolution.webp",
                "cost": '2 Black',
                "description": "During this Round, all your characters take -2 DMG the next time.\n\n(A character can consume at most 1 Food per Round)",
                "flavor": "The butter-infused crab legs have a rich aroma that washes over the taste buds so seductively that none can resist its allure.\n\"Another helping, please!\"",
                'id': '6E'
            },

            'fishandchips': { 
                'name': 'Fish and Chips',
                'tags': ['event', 'food'],
                'hi_res_image': '/cards/i_n333063_gcg_high_resolution.webp',
                'image': '/cards/i_n333063.webp',
                'golden_image': '/cards/i_n337063.webp',
                'cost': '2 Black',
                'description': "During this Round, all your characters will use 1 fewer Elemental Die when using their Skill next time. \n\n(A character can consume at most 1 Food per Round)",
                'flavor': "Fish fried until golden and crispy, with chips and a smorgasbord of sauces. Every single bite is suffused with savory satisfaction...",
                'id': '8U',
            },

            'matsutakemeatrolls': { 
                'name': 'Matsutake Meat Rolls',
                'tags': ['event', 'food'],
                'hi_res_image': '/cards/i_n333066_gcg_high_resolution.webp',
                'image': '/cards/i_n333066.webp',
                'golden_image': '/cards/i_n337066.webp',
                'cost': '2 White',
                'description': "Heal the target character for 2 HP. For the next 3 Rounds, heal this character for 1 HP again during the End Phase. \n\n(A character can consume at most 1 Food per Round)",
                'flavor': "Ground meat is put on the Matsutake and gently pan-fried on low heat so the Matsutake can fully take in the aromatic juice of the meat. It's a mouthwatering delicacy in all of its glory.",
                'id': '99',
            },

            'macarons': { 
                'name': 'Rainbow Macarons',
                'tags': ['event', 'food'],
                'hi_res_image': '/cards/i_n333070_gcg_high_resolution.webp',
                'image': '/cards/i_n333070.webp',
                'golden_image': '/cards/i_n337070.webp',
                'cost': '2 Black',
                'description': "Heal the target character for 1 HP. The next 3 times this character takes DMG, they will also heal 1 HP afterward. \n\n(A character can consume at most 1 Food per Round)",
                'flavor': "Small, multicolored little pastries. Their crispy outer shell packages a sweet, soft center, each refined to perfection.\nThere is a saying in Fontaine that \"a dessert spread without macarons is like having the many waters bereft of their source.\"",
                'id': 'AW',
            },

            "sauruscrackers": {
                'name': "Saurus Crackers",
                'tags': ['event', 'food'],
                'hi_res_image': '/cards/gcg_333016_hd.webp',
                'image': '/cards/gcg_333016.webp',
                'golden_image': '/cards/gcg_333016_golden.webp',
                'cost': '0 White',
                'description': "During this Round, the target character will use 1 fewer Elemental Die the next time they use a Technique. \n\n(A character can consume at most 1 Food per Round)",
                'flavor': "Crackers shaped like little Saurians. Light, crispy, sweet, and fragrant, with adorable patterns on top to boot — how could the people of Natlan not be won over by such delectable snacks?",
                'id': 'BZ',
            },

            "glitteringgemstones": {
                'name': "Glittering Gemstones",
                'tags': ['event', 'food'],
                'hi_res_image': '/cards/gcg_333017_hd.webp',
                'image': '/cards/gcg_333017.webp',
                'golden_image': '/cards/gcg_333017_golden.webp',
                'cost': '1 White',
                'description': "The target character gains 1 additional Max HP. \n\n(A character can consume at most 1 Food per Round)",
                'flavor': "Multicolored biscuits. The sour and sweet jam gives off the clear luster of crystalline form, adding a shine to the crunchy treats. Such radiance! Such tastiness! What could this be but equal even to the most precious jewels?",
                'id': 'CB',
            },

            "puffpops": {
                'name': "Puff Pops",
                'tags': ['event', 'food'],
                'hi_res_image': '/cards/gcg_333018_hd.webp',
                'image': '/cards/gcg_333018.webp',
                'golden_image': '/cards/gcg_333018_golden.webp',
                'cost': '1 White',
                'description': "The next 3 times a card whose name was not in your initial deck is added to your Hand, heal your target character for 1 HP. \n\n(A character can consume at most 1 Food per Round)",
                'flavor': "A snack with lots of different flavors. If you close your eyes, you won't be able to guess what flavor you'll get next, and eating them is sure to increase your heart rate. The \"pop\" part of the name comes from the sound of Grainfruit kernels bursting open under high temperatures.",
                'id': 'CL',
            },

            "hotspringoclock": {
                'name': "Hot Spring O'Clock",
                'tags': ['event', 'food'],
                'hi_res_image': '/cards/gcg_333019_hd.webp',
                'image': '/cards/gcg_333019.webp',
                'golden_image': '/cards/gcg_333019_golden.webp',
                'cost': '1 White',
                'description': "Heal the target for HP equal to the number of your summons on the field. \n\n(A character can consume at most 1 Food per Round)",
                'flavor': "A pizza made using Grainfruit. Grainfruit is scattered across the crust before a thick layer of cheese is poured on top, and the whole thing is delivered into the oven. The final touch is to then draw a little Koholasaurus picture on it. Eat it while it's hot — the warmth will remind you of a serene time spent enjoying a soothing soak in a hot spring.",
                'id': 'CS',
            },

            "mystiquesoup": {
                'name': "Mystique Soup",
                'tags': ['event', 'food'],
                'hi_res_image': '/cards/gcg_333020_hd.webp',
                'image': '/cards/gcg_333020.webp',
                'golden_image': '/cards/gcg_333020_golden.webp',
                'cost': '1 White',
                'description': "Select 1 of 3 random effects to be performed on the target character. \n\n(A character can consume at most 1 Food per Round)",
                'flavor': "A drink made from Grainfruit. Originally invented as a type of medicine by a certain shaman of the Masters of the Night-Wind, the recipe has been altered with the passage of time and is now a common drink at social gatherings.",
                'id': 'D0',
            },

            "singyourheartout": {
                'name': "Sing Your Heart Out",
                'tags': ['event', 'food'],
                'hi_res_image': '/cards/gcg_333027_hd.webp',
                'image': '/cards/gcg_333027.webp',
                'golden_image': '/cards/gcg_333027_golden.webp',
                'cost': '3 Black',
                'description': "All of your characters gain Satiated. Draw 2 cards and use 1 fewer Elemental Die for the next 2 character switches. \n\n(A character can consume at most 1 Food per Round)",
                'flavor': "A cool-flavored throat lozenge. Said to be the Flower-Feather Clan's secret weapon for soothing their throats and protecting their vocal cords — so eat one and go sing your heart out! Just make sure you don't go overboard, as too much sugar can leave your throat feeling hoarse.",
                'id': 'D8',
            },

            "harvestsboon": {
                'name': "Harvest's Boon",
                'tags': ['event', 'food'],
                'hi_res_image': '/cards/gcg_333028_hd.webp',
                'image': '/cards/gcg_333028.webp',
                'golden_image': '/cards/gcg_333028_golden.webp',
                'cost': '1 White',
                'description': "Heal the target character for 1 HP. For the target character's next 2 instances of Prepare Skill: Heal self for 1 HP. \n\n(A character can consume at most 1 Food per Round)",
                'flavor': "A rich and comforting meal held together by the humble Grainfruit. Minced meat is stir-fried and placed in a baking pan with larger chunks of meat and eggs. The whole thing is then covered with a layer of mashed Grainfruit and baked until a tantalizing golden brown. This hearty dish can often be found on the tables of the Collective of Plenty during harvest festivals.",
                'id': 'DN',
            },

            "chenyubrew": {
                'name': "Chenyu Brew",
                'tags': ['event', 'food'],
                'hi_res_image': '/cards/gcg_333029_hd.webp',
                'image': '/cards/gcg_333029.webp',
                'golden_image': '/cards/gcg_333029_golden.webp',
                'cost': '0 White',
                'description': "Choose one of your characters. The next 2 times you Adventure, or during the End Phase, heal the target character for 1 HP. \n\n(A character can consume at most 1 Food per Round.)",
                'flavor': "Your initial sip brings forth flavor on an elegant light breeze, the sweet fragrances of Chenyu Vale alighting upon your lips and tongue. Hark — is that the sweet tinkling of the mountain springs singing in your ear?",
                'id': 'ES',
            },

            "roulettespecial": {
                'name': "Roulette Special",
                'tags': ['event', 'food'],
                'hi_res_image': '/cards/gcg_333030_hd.webp',
                'image': '/cards/gcg_333030.webp',
                'golden_image': '/cards/gcg_333030_golden.webp',
                'cost': '4 White',
                'description': "The target character gains 4 random buffs from the following effects: \n\nHeal the target character for 2 HP. \n\nThe target character gains +1 Max HP. \n\nThe next Skill the target character uses costs 1 less Elemental Die. \n\nThe target character deals +1 DMG the next time they do damage. \n\n(A character can consume at most 1 Food per Round)",
                'flavor': "Colorful drinks. It might be more accurate to call this a table game than nourishment of any sort, one where the rules are to drink whatever drink the pointer falls on.",
                'id': 'GJ',
            },

            "lakkaberrypie": {
                'name': "Lakkaberry Pie",
                'tags': ['event', 'food'],
                'hi_res_image': '/cards/gcg_333031_hd.webp',
                'image': '/cards/gcg_333031.webp',
                'golden_image': '/cards/gcg_333031_golden.webp',
                'cost': '4 White',
                'description': "During this Round, the target character will use 2 fewer Elemental Dice the next 2 times they use Skills. \n\n(A character can consume at most 1 Food per Round)",
                'flavor': "A sweet treat from the borderlands. Once made using nothing but Lakkaberries, the recipe was later enhanced by adding Midsommar Berries to the mix. The two fruits complement each other perfectly, giving this sweet pie a rich, enticing flavor. The original name, however, remains unchanged.",
                'id': 'GV',
            },
        },
    
        "misc": {
            "lightningstilleto": {
                "name": "Lightning Stilleto",
                "type": "Event",
                "cost": "3 Electro",
                "description": "'Combat Action': Switch your Keqing in to be the active character and immediately use 'Stellar Restoration' once. This instance of 'Stellar Restoration' will grant Keqing 'Electro Infusion' without creating another Lightning Stiletto.\n\n(When Keqing uses 'Stellar Restoration' with this card in Hand: Instead of creating another Lightning Stiletto, discard this card and Keqing gains 'Electro Infusion'.)",
                "related": "Keqing",
                "image": Keqing_Summon
            },
            "electroinfusion": {
                "name": "Keqing's Electro Infusion",
                "type": "Status",
                "description": "The character to which this is attached has their Physical DMG dealt converted to Electro DMG. \n\n'Duration (Rounds)': 2",
                "related": "Keqing",
            },
            "oz": {
                "name": "Oz",
                "type": "Summon",
                "description": "End Phase: Deal 1 Electro DMG. \n\nUsage(s): 2",
                "related": "Fischl",
                "image": Fischl_Summon
            },
            "thewolfwithin": {
                "name": "The Wolf Within",
                "type": "Status",
                "description": "After the character to which this is attached uses a Normal Attack or Elemental Skill: Deal 2 additional Electro DMG. \n\n'Duration (Rounds)': 2",
                "related": "Razor",
                "image": Razor_Status
            },
            "pactswornpathclearer": {
                "name": "Pactsworn Pathclearer",
                "type": "Status",
                "description": "End Phase: Gain 1 level of 'Indwelling'. \n\nCreate the following effects based on the 'Indwelling' Level: \n -If equal to or greater than 2: Physical DMG dealt is converted to Electro DMG. \n -If equal to or greater than 4: DMG dealt +2 \n -If equal to or greater than 6: 'Indwelling' Level -4",
                "related": "Razor",
                "image": Cyno_Status
            },
            "icelotus": {
                "name": "Ice Lotus",
                "type": "Combat Status",
                "description": "When your active character receives DMG: reduce that DMG by 1. \n\nUsage(s): 2",
                "related": "Ganyu"
            },
            "sacredcryopearl": {
                "name": "Sacred Cryo Pearl",
                "type": "Summon",
                "description": "End Phase: Deal 1 Cryo DMG, and 1 Piercing DMG to all characters on standby. \n\nUsage(s): 2",
                "related": "Ganyu",
                "image": Ganyu_Summon
            },
            "frostflake": {
                "name": "Frostflake Seki no To",
                "type": "Summon",
                "description": "End Phase: Deal 2 Cryo DMG. \n\nUsage(s): 2",
                "related": "Ayaka",
                "image": Ayaka_Summon
            },
            "cryoinfusion": {
                "name": "Kamisato Ayaka's Cryo Infusion",
                "type": "Status",
                "description": "The character to which this is attached has their Physical DMG dealt converted to Cryo DMG. \n\n(Lasts until the Round ends)",
                "related": "Ayaka",
            },
            "catclawshield": {
                "name": "Cat-Claw Shield",
                "type": "Combat Status",
                "description": "Provides 1 Shield Point for your active character.",
                "related": "Diona"
            },
            "drunkenmist": {
                "name": "Drunken Mist",
                "type": "Summon",
                "description": "End Phase: Deal 1 Cryo DMG, and heal your active character for 2. \n\nUsage(s): 2",
                "related": "Diona",
                "image": Diona_Summon
            },
            "chonghuafrostfield": {
                "name": "Chonghua Frost Field",
                "type": "Combat Status",
                "description": "Physical DMG caused by your active sword, claymore, and polearm characters is converted to Cryo DMG. \n\n'Duration (Rounds)': 2",
                "related": "Chongyun"
            },
            "Icicle": {
                "name": "Icicle",
                "type": "Combat Status",
                "description": "After you switch characters: Deal 2 Cryo DMG. \n\nUsage(s): 3",
                "related": "Kaeya",
                "image": Kaeya_BStatus
            },
            "reflection": {
                "name": "Reflection",
                "type": "Summon",
                "description": "When your active character receives DMG: Decrease DMG taken by 1.\n\nUsage(s): 1. When this card's Usage(s) are depleted, this card will not be discarded.\n\nDuring the End Phase: Discard this card, deal 1 Hydro DMG.",
                "related": "Mona",
                "image": Mona_Summon
            },
            "illusorybubble": {
                "name": "Illusory Bubble",
                "type": "Combat Status",
                "description": "When you deal Skill DMG: remove this Combat Status and double the DMG dealt for the instance.",
                "related": "Mona",
                "image": Mona_BStatus
            },
            "melodyloop": {
                "name": "Melody Loop",
                "type": "Summon",
                "description": "End Phase: Heal all your characters for 1, then apply 'Hydro Application' on your active character. \n\nUsage(s): 2",
                "related": "Barbara",
                "image": Barbara_Summon
            },
            "rainsword": {
                "name": "Rain Sword",
                "type": "Combat Status",
                "description": "When your active character receives 3 or more DMG: reduce that DMG by 1. \n\nUsage(s): 2",
                "related": "Xingqiu",
            },
            "rainbowbladework": {
                "name": "Rainbow Bladework",
                "type": "Combat Status",
                "description": "After your active character uses a normal attack: Deal 1 Hydro DMG. \n\nUsage(s): 3",
                "related": "Xingqiu",
                "image": Xingqiu_BStatus1
            },
            "niwabienshou": {
                "name": "Niwabi Enshou",
                "type": "Status",
                "description": "The attached character's normal attacks deal +1 DMG and any Physical DMG becomes Pyro DMG. \n\nUsage(s): 2",
                "related": "Yoimiya"
            },
            "aurousblaze": {
                "name": "Aurous Blaze",
                "type": "Combat Status",
                "description": "After a character other than Yoimiya uses any skill: Deal 1 additional Pyro DMG. \n\n'Duration (Rounds)': 2",
                "related": "Yoimiya",
                "image": Yoimiya_BStatus
            },
            "guoba": {
                "name": "Guoba",
                "type": "Summon",
                "description": "End Phase: Deal 2 Pyro DMG. \n\nUsage(s): 2",
                "related": "Xiangling",
                "image": Xiangling_Summon
            },
            "pyronado": {
                "name": "Pyronado",
                "type": "Combat Status",
                "description": "After your active character uses any skill: Deal 2 additional Pyro DMG. \n\nUsage(s): 2",
                "related": "Xiangling",
                "image": Xiangling_BStatus
            },
            "inspirationfield": {
                "name": "Inspiration Field",
                "type": "Combat Status",
                "description": "When your active character uses any skill while they have 7 or more HP: Increase the DMG by 2. If your active character is at 6 or lower HP after performing an skill: Heal that character for 2. \n\n'Duration (Rounds)': 2",
                "related": "Bennett",
                "image": Bennett_BStatus
            },
            "dandelionfield": {
                "name": "Dandelion Field",
                "type": "Summon",
                "description": "End Phase: Deal 2 Anemo DMG, then restore 1 HP to your active character. \n\nUsage(s): 2",
                "related": "Jean",
                "image": Jean_Summon
            },
            "largewindspirit": {
                "name": "Large Wind Spirit",
                "type": "Summon",
                "description": "End Phase: Deal 2 Anemo DMG. \n\nUsage(s): 3. \n\nAfter this card or your active character triggers a swirl reaction: Convert the DMG dealt by this card to that element. (Only once)",
                "related": "Sucrose",
                "image": Sucrose_Summon
            },
            "jadescreen": {
                "name": "Jade Screen",
                "type": "Combat Status",
                "description": "After your active character recieves 2 or more DMG: reduce that DMG by 1. \n\nUsage(s): 2",
                "related": "Ningguang"
            },
            "fullplate": {
                "name": "Full Plate",
                "type": "Combat Status",
                "description": "Provides 2 shield points for your active character. While this shield is up, any Physical DMG recieves is halved.",
                "related": "Noelle"
            },
            "sweepingtime": {
                "name": "Sweeping Time",
                "type": "Status",
                "description": "Once per round: when the character this is attached to performs a normal attack, spend 1 less Geo Die. The DMG caused by this character's normal attacks deal +2 DMG and the Physical DMG is converted to Geo DMG. \n\n'Duration (Rounds)': 2",
                "related": "Noelle",
                "image": Noelle_Status
            },
            "stonehide": {
                "name": "Stonehide",
                "type": "Status",
                "description": "When the character to which this is attached to recieves DMG: Decrease DMG taken by 1. When Geo DMG is decreased, comsume 1 additional Usage(s). \n\nUsage(s): 3",
                "related": "Stonehide Lawachurl"
            },
            "stoneforce": {
                "name": "Stone Force",
                "type": "Status",
                "description": "The character to which this is attached has their Physical DMG converted to Geo DMG. \n\nOnce per Round: The character deals +1 DMG. \n\nOnce the Stonehide attached to this character is removed, this status is removed alongside it.",
                "related": "Stonehide Lawachurl"
            },
            "cuileinanbar": {
                "name": "Cuilein-Anbar",
                "type": "Summon",
                "description": "End Phase: Deal 2 Dendro DMG. \n\nUsage(s): 2",
                "related": "Collei",
                "image": Collei_Summon
            },
            "radicalvitality": {
                "name": "Radical Vitality",
                "type": "Status",
                "description": "When this character takes or deals Elemental DMG: gain 1 stack of 'Radical Vitality' (max 3 stacks). \n\nEnd Phase: If 'Radical Vitality' stacks reach maximum, they will be cleared and the character will lose all energy.",
                "related": "Jadeplume Terrorshroom",
                "image": Terrorshroom_Status
            },
            "hydromimicsquirrel": {
                "name": "Oceanic Mimic: Squirrel",
                "type": "Summon",
                "description": "End Phase: Deal 2 Hydro DMG. \n\nUsage(s): 2",
                "related": "Rhodeia of Loch",
                "image": Oceanoid_Summon1
            },
            "hydromimicraptor": {
                "name": "Oceanic Mimic: Raptor",
                "type": "Summon",
                "description": "End Phase: Deal 1 Hydro DMG. \n\nUsage(s): 3",
                "related": "Rhodeia of Loch",
                "image": Oceanoid_Summon2
            },
            "hydromimicfrog": {
                "name": "Oceanic Mimic: Frog",
                "type": "Summon",
                "description": "When your active character receives DMG: Reduce that DMG taken by 1.\n\nUsage(s): 2. When this card's Usage(s) are depleted, this card will not be discarded.\n\nDuring the End Phase, if this card's Usage(s) have been depleted: Discard this card and deal 2 Hydro DMG.\n\nNote: THE WORDING ON THIS SUMMON IN GAME IS SUPER WEIRD. AT THE MOMENT IT IS EXTREMELY SUBJECT TO CHANGE.",
                "related": "Rhodeia of Loch",
                "image": Oceanoid_Summon3
            },
            "stealth": {
                "name": "Stealth",
                "type": "Status",
                "description": "Reduce any DMG received by 1, and increase any DMG dealt by 1. \n\nUsage(s): 2",
                "related": "Fatui Pyro Agent"
            },
            "refraction": {
                "name": "Refraction",
                "type": "Status",
                "description": "Incoming Hydro DMG +1. \n\n'Duration (Rounds)': 2",
                "related": "Mirror Maiden"
            },
            "pyroinfusion": {
                "name": "Diluc's Pyro Infusion",
                "type": "Status",
                "description": "The character to which this is attached has their Physical DMG dealt converted to Pyro DMG. \n\n'Duration (Rounds)': 2",
                "related": "Diluc",
            },
            "maguuanemo": {
                "name": "Shadowsword: Lone Gale",
                "type": "Summon",
                "description": "End Phase: Deal 1 Anemo DMG.\n\nUsage(s): 2 \n",
                "related": "Maguu Kenki",
                "image": Maguu_Summon2
            },
            "maguucryo": {
                "name": "Shadowsword: Galloping Frost",
                "type": "Summon",
                "description": "End Phase: Deal 1 Cryo DMG. \n\nUsage(s): 2",
                "related": "Maguu Kenki",
                "image": Maguu_Summon1
            },
            "cryohilichurlshooter": {
                "name": "Cryo Hilichurl Shooter",
                "type": "Summon",
                "description": "End Phase: Deal 1 Cryo DMG. \n\nUsage(s): 2",
                "related": "Abyssal Summons",
                "image": Hilichurl_Summon1
            },
            "hydrosamachurl": {
                "name": "Hydro Samachurl",
                "type": "Summon",
                "description": "End Phase: Deal 1 Hydro DMG. \n\nUsage(s): 2",
                "related": "Abyssal Summons",
                "image": Hilichurl_Summon2
            },
            "hilichurlberserker": {
                "name": "Hilichurl Berserker",
                "type": "Summon",
                "description": "End Phase: Deal 1 Pyro DMG. \n\nUsage(s): 2",
                "related": "Abyssal Summons",
                "image": Hilichurl_Summon3
            },
            "electrohilichurlshooter": {
                "name": "Electro Hilichurl Shooter",
                "type": "Summon",
                "description": "End Phase: Deal 1 Electro DMG. \n\nUsage(s): 2",
                "related": "Abyssal Summons",
                "image": Hilichurl_Summon4
            },
            "explosivespark": {
                "name": "Explosive Spark",
                "type": "Status",
                "description": "When the character to which this is attached uses a Charged Attack: Spend 1 less Pyro Die and deal +1 DMG. \n\nUsage(s): 1 \n\nCharged Attack: When the total number of your Elemental Dice is even, the Normal Attack to use will be considered a Charged Attack.",
                "related": "Klee"
            },
            "sparks'n'splash": {
                "name": "Sparks'n'Splash",
                "type": "Combat Status",
                "description": "After a character to which Sparks 'n' Splash is attached uses a Skill: Deals 2 Pyro DMG to their team's active character. \n\nUsage(s): 2",
                "related": "Klee",
                "image": Klee_Status
            },
            "tidecallersurfembrace": {
                "name": "Tidecaller: Surf Embrace",
                "type": "Status",
                "description": "The next time this character acts, they will immediately use the Skill Wavestrider. While preparing this Skill: Grant 2 Shield points to the character to which this is attached.",
                "related": "Beidou"
            },
            "thunderbeaststarge": {
                "name": "Thunderbeast's Targe",
                "type": "Combat Status",
                "description": "After your character uses a Normal Attack: Deal 1 Electro DMG. When your character takes at least 3 DMG: Decrease DMG taken by 1. \n\nDuration (Rounds): 2",
                "related": "Beidou",
                "image": Beidou_BStatus
            },
            "tengujurraiambush": {
                "name": "Tengu Jurrai: Ambush",
                "type": "Summon",
                "description": "End Phase: Deal 1 Electro DMG, applies Crowfeather Cover to friendly active character. \n\nUsage(s): 1",
                "related": "Kujou Sara",
                "image": Sara_Summon1
            },
            "tengujurraistormcluster": {
                "name": "Tengu Jurrai: Stormcluster",
                "type": "Summon",
                "description": "End Phase: Deal 2 Electro DMG, applies Crowfeather Cover to friendly active character. \n\nUsage(s): 2",
                "related": "Kujou Sara",
                "image": Sara_Summon2
            },
            "crowfeathercover": {
                "name": "Crowfeather Cover",
                "type": "Status",
                "description": "The character with this attached deals +1 Elemental Skill and Elemental Burst DMG. \n\nUsage(s): 2 \n\nAfter this card effect is triggered: 1 Usage of it will be consumed. This card will be discarded immediately once it has 0 Usages remaining.",
                "related": "Kujou Sara"
            },
            "bakekurage": {
                "name": "Bake-Kurage",
                "type": "Summon",
                "description": "End Phase: Deal 1 Hydro DMG, heal your active character for 1 HP. \n\nUsage(s): 2",
                "related": "Sangonomiya Kokomi",
                "image": Kokomi_Summon
            },
            "ceremonialgarment": {
                "name": "Ceremonial Garment",
                "type": "Status",
                "description": "The character to which this is attached has their Normal Attacks deal +1 DMG, and after using a Normal Attack, heal 1 HP for all characters. \n\nDuration (Rounds): 2",
                "related": "Sangonomiya Kokomi",
                "image": Kokomi_Status
            },
            "grimheart": {
                "name": "Grimheart",
                "type": "Status",
                "description": "After the character to which this is attached uses Icetide Vortex: Remove this status, DMG +3.",
                "related": "Eula",
            },
            "lightfallsword": {
                "name": "Lightfall Sword",
                "type": "Summon",
                "description": "When Eula uses a Skill, this card will accumulate 2 Zeal stacks, but Eula will be unable to receive Energy. End Phase: Discard this card and deal 3 Physical DMG. Each Zeal stack adds 1 DMG to this damage instance.",
                "related": "Eula",
                "image": Eula_Summon
            },
            "takimegurikanka": {
                "name": "Takimeguri Kanka",
                "type": "Status",
                "description": "The character to which this is attached has their Normal Attacks deal +1 DMG, and their Physical DMG dealt converted to Hydro DMG. \n\nUsage(s): 3",
                "related": "Kamisato Ayato",
            },
            "gardenofpurity": {
                "name": "Garden of Purity",
                "type": "Summon",
                "description": "End Phase: Deal 2 Hydro DMG. \n\nUsage(s): 2 \n\nWhen this Summon is on the field: Your characters' Normal Attacks deal +1 DMG.",
                "related": "Kamisato Ayato",
                "image": Ayato_Summon
            },
            "ushi": {
                "name": "Ushi",
                "type": "Summon",
                "description": "When your active character receives DMG: Decrease DMG taken by 1. \n\nUsage(s): 1. \n\nWhen the Usage is depleted, this card will not be discarded. \n\nCan be triggered once while this Summon is present: When your character receives DMG, Arataki Itto gains Superlative Superstrength. \n\nEnd Phase: Discard this card, deal 1 Geo DMG.",
                "related": "Arataki Itto",
                "image": Itto_Summon
            },  
            "superlativesuperstrength": {
                "name": "Superlative Superstrength",
                "type": "Status",
                "description": "When the character to which this is attached uses a Charged Attack: Deal +1 DMG. If the Usage(s) are no less than 2, expend 1 less Unaligned Element. \n\nUsage(s): 1 (Can stack. Max 3 stacks.)\n\nCharged Attack: When the total number of your Elemental Dice is even, the Normal Attack to use will be considered a Charged Attack.",
                "related": "Arataki Itto"
            },
            "ragingoniking": {
                "name": "Raging Oni King",
                "type": "Status",
                "description": "The character to which this is attached has their Normal Attacks deal +2 DMG, and their Physical DMG dealt converted to Geo DMG. \n\nDuration (Rounds): 2 \n\nAfter the character to which this is attached uses a Normal Attack: Gains Superlative Superstrength. (Once per Round)",
                "related": "Arataki Itto"
            },
            'vijnanasuffusion': {
                "name": "Vijnana Suffusion",
                "type": "Status", 
                "description": "When the character to which this is attached uses a Charged Attack: Their Physical DMG dealt will be converted to Dendro DMG and after the Skill DMG is finalized, summon 1 'Clusterbloom Arrow'. \n\nUsage(s): 2\n\nCharged Attack: When the total number of your Elemental Dice is even, the Normal Attack to use will be considered a Charged Attack.",
                "related": "Tighnari"
            },
            'clusterbloomarrow': {
                "name": "Clusterbloom Arrow",
                "type": "Summon",
                "description": "End Phase: Deal 1 Dendro DMG. \n\nUsage(s): 1 (Can stack. Max 2 stacks.)",
                "related": "Tighnari",
                "image": Tighnari_Summon
            },
            'baronbunny': {
                "name": "Baron Bunny",
                "type": "Summon",
                "description": "When your active character takes DMG: Decrease DMG taken by 2. \n\nUsage(s): 1. When the Usages are depleted, this card will not be discarded. \n\nAt the End Phase, if Usage(s) have been depleted: Discard this card to deal 2 Pyro DMG.",
                "related": "Amber",
                "image": Amber_Summon
            },
            "paramitapapilio": {
                "name": "Paramita Papilio",
                "type": "Status",
                "description": "The character to which this is attached has their Physical DMG dealt converted to Pyro DMG, and they will deal +1 Pyro DMG. When the character to which this is attached uses a Charged Attack: Apply Blood Blossom to target character. \n\nDuration (Rounds): 2",
                "related": "Hu Tao"
            },
            "bloodblossom": {
                "name": "Blood Blossom",
                "type": "Status",
                "description": "End Phase: Deal 1 Pyro DMG to the character to which this is attached. \n\nUsage(s): 1",
                'related': "Hu Tao"
            },
            "eyeofstormyjudgement": {
                "name": "Eye of Stormy Judgement",
                "type": "Summon",
                "description": "End Phase: Deal 1 Electro DMG. \n\nUsage(s): 3 \n\nWhen this Summon is on the field: Your characters' Elemental Bursts deal +1 DMG.",
                "related": "Raiden Shogun",
                "image": Raiden_Summon
            },
            "chakradesiderata": {
                "name": "Chakra Desiderata",
                "type": "Status",
                "description": "After your other characters use Elemental Bursts: Gain 1 Resolve. (Max 3) \n\nWhen the character to which this is attached uses Secret Art: Musou Shinsetsu: Consume all Resolve and deal +1 DMG per Resolve.",
                "related": "Raiden Shogun"
            },
            "sesshousakura": {
                "name": "Sesshou Sakura",
                "type": "Summon",
                "description": "End Phase: Deal 1 Electro DMG. \n\nUsage(s): 3 (Can stack, max 6 stacks) \n\nWhen you declare the end of your Round: If this card's Usage(s) is at least 4, deal 1 Electro DMG. (Consumes Usage(s)s)",
                "related": "Yae Miko",
                "image": Yae_Summon
            },
            "tenkothunderbolts": {
                "name": "Tenko Thunderbolts",
                "type": "Combat Status",
                "description": "Before you choose your action: Deal 3 Electro DMG. \n\nUsage(s): 1",
                "related": "Yae Miko"
            },
            "stormzone": {
                "name": "Stormzone",
                "type": "Combat Status",
                "description": "When you perform \"Switch Character\": Spend 1 less Elemental Die. \n\nUsage(s): 2",
                "related": "Venti"
            },
            "stormeye": {
                "name": "Stormeye",
                "type": "Summon",
                "description": "End Phase: Deal 2 Anemo DMG, switch opposing character to Character closest to your current active character. \n\nUsage(s): 2 \n\nAfter your character or Summon triggers a Swirl reaction: Convert the Elemental Type of this card and change its DMG dealt to the element Swirled. (Can only be converted once before leaving the field)",
                "related": "Venti",
                "image": Venti_Summon
            },
            'yakshasmask': {
                'name': "Yaksha's Mask",
                "type": "Status",
                "description": "The character to which this is attached has their Physical DMG dealt converted to Anemo DMG, and they will deal +1 Anemo DMG. \n\nWhen the character to which this is attached uses a Plunging Attack: +2 extra DMG.\n\nIf the character to which this is attached is the active character, when you perform \"Switch Character\": Spend 1 less Elemental Die. (Once per Round)\n\nDuration (Rounds): 2",
                'related': "Xiao"
            },
            'stonestele': {
                'name': 'Stone Stele',
                'type': "Summon",
                "description": "End Phase: Deal 1  Geo DMG. \n\nUsage(s): 2",
                "related": "Zhongli",
                "image": Zhongli_Summon
            },
            'jadeshield': {
                'name': 'Jade Shield',
                'type': 'Combat Status',
                'description': 'Grants 2 Shield points for your active character.',
                'related': "Zhongli"
            },
            "petrification": {
                'name': 'Petrification',
                'type': "Status",
                'description': "Character cannot use Skills. (Lasts until the end of this Round)",
                "related": "Zhongli"
            },
            'seedsofskandha': {
                'name': 'Seed of Skandha',
                'type': 'Status',
                'description': 'After any character who has a Seed of Skandha takes Elemental Reaction DMG: Deals 1 Piercing DMG to the character(s) to which the Seed of Skandha is attached on the same side of the field. \n\nUsage(s): 2',
                'related': 'Nahida'
            },
            'shrineofmaya': {
                'name': 'Shrine of Maya',
                'type': 'Combat Status',
                'description': 'When your character triggers an Elemental Reaction: +1 additional DMG. \n\nDuration (Rounds): 2',
                'related': "Nahida"
            },
            'cryocicin': {
                'name': 'Cryo Cicin', 
                'type': 'Summon',
                'description': 'End Phase: Deal 1 Cryo DMG. \n\nUsage(s): 2 (Can stack, max 3 stacks) \n\nAfter Fatui Cryo Cicin Mage performs a Normal Attack: This card gains 1 Usage(s). After Fatui Cryo Cicin Mage takes Elemental Reaction DMG: This card loses 1 Usage(s).',
                'related': 'Fatui Cryo Cicin Mage',
                "image": Cicin_Summon
            },
            'flowingcicinshield': {
                'name': 'Flowing Cicin Shield',
                'type': 'Combat Status',
                'description': 'Provides 1 Shield for your active character. \n\nWhen created: If you have Cryo Cicin on the field, additionally increase Shield by the amount of Usage(s) it has. (Adds a maximum of 3 additional Shield)',
                'related': 'Fatui Cryo Cicin Mage'
            },
            'fieryrebirth': {
                'name': 'Fiery Rebirth',
                'type': 'Status',
                'description': 'When the character to which this is attached is defeated: Remove this effect, ensure the character will not be defeated, and heal them until they reach 3 HP.',
                'related': 'Abyss Lector: Fathomless Flames'
            },
            'darkfirefurnace': {
                'name': 'Darkfire Furnace',
                'type': 'Summon',
                'description': 'End Phase: Deal 1 Pyro DMG, deal 1 Piercing DMG to all opposing characters on standby. \n\nUsage(s): 2',
                'related': 'Abyss Lecor: Fathomless Flames',
                "image": Lector_Summon
            },
            'chainsofwardingthunder': {
                'name': 'Chains of Warding Thunder',
                'type': 'Summon',
                'description': 'End Phase: Deal 1 Electro DMG. \n\nUsage(s): 2 \n\nWhen this Summon is on the field: When your opponent uses Switch Character, they will have to spend 1 extra Elemental Die. (Once per Round)',
                'related': 'Electro Hypostasis',
                "image": Hypostasis_Summon
            },
            'electrocrystalcore': {
                'name': 'Electro Crystal Core',
                'type': 'Status',
                'description': 'When the character to which this is attached is defeated: Remove this effect, ensure the character will not be defeated, and heal them until they reach 1 HP.',
                'related': 'Electro Hypostasis'
            },
            'icyquill': {
                'name': 'Icy Quill',
                'type': 'Combat Status',
                'description': 'Your character deals 1 increased Cryo DMG (Includes the DMG triggered by Cryo-infused Swirl reactions) \n\nUsage(s): 3',
                'related': 'Shenhe'
            },
            'talismanspirit': {
                'name': 'Talisman Spirit',
                'type': 'Summon',
                'description': 'End Phase: Deal 1 Cryo DMG. \n\nUsage(s): 2 \n\nWhen this Summon is on the field: Opposing character(s) take +1 Cryo DMG and Physical DMG.',
                'related': 'Shenhe',
                "image": Shenhe_Summon
            },
            'meleestance': {
                'name': 'Melee Stance',
                'type': 'Status',
                'description': 'Physical DMG dealt by character is converted to Hydro DMG.\n\nAfter the character to which this is attached uses Charged Attack: Apply Riptide to target character.\n\nCharacter deals +1 DMG to target characters with Riptide attached.\n\nAfter Skills are used against characters affected by Riptide: Deal 1 Piercing DMG to the next opposing off-field character. (Twice per Round)\n\nDuration (Rounds): 2, switch back to Ranged Stance once 0 Usages remain.',
                'related': "Tartaglia"
            },
            'rangedstance': {
                'name': "Ranged Stance",
                'type': 'Status',
                'description': 'After the character to which this is attached uses Charged Attack: Apply Riptide to target character.',
                'related': 'Tartaglia'
            },
            'riptide': {
                'name': 'Riptide',
                'type': 'Status',
                'description': 'When the character to which this is attached is defeated: Apply Riptide to active character. \n\nWhen Tartaglia is in Melee Stance, he will deal additional DMG when attacking the character to which this is attached. \n\nDuration (Rounds): 2',
                'related': 'Tartaglia'
            },
            'cryocicinmage': {
                'name': 'Cryo Cicin Mage',
                'type': 'Combat Status',
                'description': "After a character to which Cryo Cicin Mage is attached uses a Skill: Deals 1 Cryo DMG to their team's active character. (Once per Round)\n\nUsage(s): 2"
            },
            'mirrormaiden': {
                'name': 'Mirror Maiden',
                'type': 'Combat Status',
                'description': "After a character to which Mirror Maiden is attached uses a Skill: Deals 1 Hydro DMG to their team's active character. (Once per Round)\n\nUsage(s): 2"
            },
            'pyroslingerbracker': {
                'name': 'Pyroslinger Bracer',
                'type': 'Combat Status',
                'description': "After a character to which Pyroslinger Bracer is attached uses a Skill: Deals 1 Pyro DMG to their team's active character. (Once per Round)\n\nUsage(s): 2"
            },
            'electrohammervanguard': {
                'name': 'Electrohammer Vanguard',
                'type': 'Combat Status',
                'description': "After a character to which Electrohammer Vanguard is attached uses a Skill: Deals 1 Electro DMG to their team's active character. (Once per Round)\n\nUsage(s): 2"
            },
            'aegisofabyssalflame': {
                'name': "Aegis of Abyssal Flame",
                "type": "Status",
                "description": "Grant the character to which this is attached 3 Shield points. \n\nBefore this Shield is depleted, the character to which this is attached will deal +1 Pyro DMG.",
                'related': 'Abyss Lector: Fathomless Flames'
            },
            'heronshield': {
                'name': "Heron Shield",
                "type": "Status",
                "description": "The next time this character acts, they will immediately use the Skill Heron Strike. While preparing this Skill: Grant 2 Shield points to the character to which this is attached.",
                'related': 'Candace'
            },
            "prayerofthecrimsoncrown": {
                'name': "Prayer of the Crimson Crown",
                "type": "Combat Status",
                "description": "Your characters' Normal Attacks deal +1 DMG. \nYour Sword, Claymore, and Polearm-wielding characters' Physical DMG is converted to Hydro DMG. \nAfter you switch characters, you deal 1 Hydro DMG. (Once per Round) \n\nDuration (Rounds): 2.",
                'related': 'Candace'
            },
            'scarletseal': {
                'name': "Scarlet Seal",
                "type": "Status",
                "description": "When the character uses a Charged Attack: Damage dealt +2. \n\nUsage(s): 1.",
                'related': 'Yanfei'
            },
            'brilliance': {
                'name': 'Brilliance',
                'type': 'Status',
                "description": "When the character uses a Charged Attack: Use 1 less Pyro Die. (Once every round.) \nEnd Phase: Attach Scarlet Seal to this character. \n\nDuration (Rounds): 2.",
                'related': 'Yanfei'
            },
            'midareranzan': {
                'name': "Midare Ranzan",
                "type": "Status",
                "description": "When the attached character uses a Plunging Attack: Physical DMG dealt becomes Anemo DMG, and deals +1 DMG. After the character uses a skill: This effect is removed.",
                'related': 'Kaedehara Kazuha'
            },
            'autumnwhirlwind': {
                'name': "Autumn Whirlwind",
                "type": "Summon",
                "description": "End Phase: Deal 1 Anemo DMG. \nUsage(s): 3 \n\nAfter your character or Summon triggers a Swirl reaction: Convert the Elemental Type of this card and change its DMG dealt to the element Swirled. (Can only be converted once before leaving the field)",
                'related': 'Kaedehara Kazuha'
            },
            'solarisotoma': {
                'name': 'Solar Isotoma',
                "type": 'Summon',
                "description": "Ending Phase: Deal 1 Geo DMG. \n\nUsage(s): 3 \n\nWhen this Summon is on the field: Your character's Plunging Attack spends 1 less Unaligned Element. (Once per Round)",
                'related': 'Albedo'
            },
            'heraldoffrost': {
                'name': 'Herald of Frost',
                "type": "Summon",
                "description": "End Phase: Deal 1 Cryo DMG. \n\nUsage(s): 3 \n\nWhen this Summon is on the field, after Qiqi uses Normal Attack: Heals your character who took the most DMG for 1 HP.",
                'related': 'Qiqi'
            },
            'fortunepreservingtalisman': {
                'name': 'Fortune-Preserving Talisman',
                "type": 'Combat Status',
                "description": "After your character uses a Skill: If that character does not have full HP, heal that character for 2 HP. \n\nUsage(s): 3",
                'related': 'Qiqi'
            },
            "conductive": {
                'name': 'Conductive',
                'type': 'Status',
                "description": 'This status starts with 2 stacks of Conductive. When attached repeatedly, Conductive stacks +1. Conductive can be stacked to a maximum of 4 stacks. \nEnd Phase: Accumulate 1 stack of Conductive.\n\nWhen the character attached by Conductive takes DMG from Violet Arc: Remove this status and DMG +1 for each stack of Conductive.',
                'related': 'Lisa'
            },
            "lightningrose": {
                'name': 'Lightning Rose',
                "type": "Summon",
                "description": "End Phase: Deal 2 Electro DMG. \n\nUsage(s): 2",
                'related': 'Lisa'
            },
            "windfavored": {
                'name': 'Windfavored',
                "type": "Status",
                "description": "When the character to which this is attached performs a Normal Attack: DMG dealt +2. If the opponent has characters on standby, then this Skill will deal damage to the next opposing character on standby instead.\n\nUsage(s): 2",
                'related': 'Wanderer'
            },
            "fierysanctumfield": {
                'name': 'Fiery Sanctum Field',
                "type": "Summon",
                "description": "End Phase:Deal 1 Pyro DMG.\n\nUsage(s): 3\n\nWhen this Summon is on the field and Dehya is on standby on your side, then when your active character takes damage: Decrease DMG taken by 1, and if Dehya has at least 7 HP, deal 1 Piercing DMG to the her (once per round).",
                'related': 'Dehya'
            },
            "yueguithrowingmode": {
                'name': 'Yuegui: Throwing Mode',
                "type": "Summon",
                "description": "End Phase: Deal 1 Dendro DMG, heal the character on your team that has taken the most damage for 1 HP.\n\nUsage(s): 2",
                'related': 'Yaoyao'
            },
            "adeptallegacy": {
                'name': 'Adeptal Legacy',
                "type": "Combat Status",
                "description": "After you switch characters: Deal 1 Dendro DMG, heal your active character for 1 HP.\n\nUsage(s): 3",
                'related': 'Yaoyao'
            },
            'curtainofslumbershield': {
                "name": 'Curtain of Slumber Shield',
                "type": 'Combat Status',
                "description": "Grants 2 Shield points to defend your active character.",
                'related': 'Layla',
            },
            'shootingstar': {
                "name": 'Shooting Star',
                "type": 'Combat Status',
                "description": "After your character uses a Skill: Accumulate 1 Night Star. If you have at least 4 Night Stars, consume 4 Night Stars and deal 1 Cryo DMG. (The Skill that causes this Combat Status will also trigger this effect) \n\nWhen causing this Combat Status again: Accumulate 2 Night Stars.",
                'related': 'Layla',
            },
            'celestialdreamsphere': {
                "name": 'Celestial Dreamsphere',
                "type": 'Summon',
                "description": "End Phase: Deal 1 Cryo DMG. If Shooting Star is in play, it will let it gain 1 Night Star.\n\nUsage(s): 2",  
                'related': 'Layla',
            },
            'exquisitethrow': {
                "name": 'Exquisite Throw',
                "type": 'Combat Status',
                "description": "After your character uses a Normal Attack: Deal 2 Hydro DMG. \n\nDuration (Rounds): 2",
                'related': 'Yelan',
            },
            'breakthrough': {
                "name": 'Breakthrough',
                "type": 'Status',
                "description": "This state starts with 1 Breakthrough stack. When re-attached, add 1 Breakthrough stack. Breakthrough can have a maximum of 3 stacks.\nEnd Phase: Gain 1 Breakthrough stack.\n\nWhen the character to which this is attached uses a Normal Attack: If Breakthrough has at least 2 stacks, consume 2 Breakthrough stacks to convert Physical DMG dealt into Hydro DMG and draw 1 card.",
                'related': 'Yelan',
            },
            'propsurplus': {
                "name": 'Prop Surplus',
                "type": 'Status',
                "description": "Prop Surplus can stack up to 3 times.\nWhen this character uses Bewildering Lights: +1 DMG for each Prop Surplus stack. After the skill is finalized, consume all Prop Surplus, healing 1 HP for this character per stack.", 
                'related': 'Lyney',
            },
            'grin-malkinhat': {
                "name": 'Grin-Malkin Hat',
                "type": 'Summon',
                "description": "End Phase: Deal 1 Pyro DMG.\n\nUsage(s): 1 (Can stack. Max 2 stacks.)",
                'related': 'Lyney',
            },
            'overawingassault': {
                "name": 'Overawing Assault',
                "type": 'Status',
                "description": "End Phase: If this character's HP is at least 6, then they will take 2 Piercing DMG.\n\nDuration (Rounds): 1",    
                'related': 'Lynette',
            },
            'bogglecatbox': {
                "name": 'Bogglecat Box',
                "type": 'Summon',
                "description": "End Phase: Deal 1 Anemo DMG.\n\nUsage(s): 2\n\nWhen your active character takes DMG: Decreases DMG taken by 1. (Once per Round)\nWhen your character(s) take Cryo/Hydro/Pyro/Electro DMG: Change the Elemental Type of this card to the element of the damage taken. (Once before leaving play)",
                'related': 'Lynette',
            },
            'generalswarbanner': {
                "name": "General's War Banner",
                "type": 'Combat Status',
                "description": "Your party's characters deal +1 Geo DMG.\n\nDuration (Rounds): 2 (Can stack, can stack till 3 Rounds)",
                'related': 'Gorou',
            },
            'generalsglory': {
                "name": "General's Glory",
                "type": 'Summon',
                "description": "End Phase: Deal 1 Geo DMG. If your party has 2 Geo characters, create 1 Crystallize.\n\nUsage(s): 2",
                'related': 'Gorou',
            },
            'chisel-lightmirror': {
                "name": 'Chisel-Light Mirror',
                "type": 'Status',
                "description": "Physical DMG dealt by the character is converted to Dendro DMG.\nAfter this character performs a Normal Attack: Deal 1 Dendro DMG. If it is a Charged Attack, this state's Duration (Rounds) +1.\nDuration (Rounds): 2 (Can stack, max 3 stacks)",
                'related': 'Alhaitham',
            },
            'blazingheat': {
                "name": 'Blazing Heat',
                "type": 'Status',
                "description": "End Phase: Deals 1 Pyro DMG to attached character.\n\nUsage(s): 1\n\nWhen attached character has Sheer Cold attached, remove this effect.",
                'related': 'Signora',
            },
            'sheercold': {
                "name": 'Sheer Cold',
                "type": 'Status',
                "description": "End Phase: Deals 1 Cryo DMG to attached character.\n\nUsage(s): 1\n\nWhen attached character has Blazing Heat attached, remove this effect.",
                'related': 'Signora',
            },
            'ice-sealedcrimsonwitchofembers': {
                "name": 'Ice-Sealed Crimson Witch of Embers',
                "type": 'Status',
                "description": "When the Action Phase starts: If the attached character has no more than 4 HP, remove this effect.\nWhen attached character is defeated: Remove this effect, ensure that character is not defeated and heal them to 1 HP.\n\nWhen this effect is removed: Attached character will transform into the Crimson Witch of Embers state.",
                'related': 'Signora',
            },

            'spiritofomen:pyroscorpion': {
                "name": 'Spirit of Omen: Pyro Scorpion',
                "type": 'Summon',
                "description": "End Phase: Deal 1 Pyro DMG.\n\nUsage(s): 2\n\nWhen entering play, when the Action Phase starts: Attach Pyro Scorpion: Guardian Stance to your Eremite Scorching Loremaster. (When Spirit of Omen: Pyro Scorpion is in play, the character will take -1 DMG, once per Round.)",
                'related': 'Eremite Scorching Loremaster',
            },
            'lightningrod': {
                "name": 'Lightning Rod',
                "type": 'Status',
                "description": "While this status is active, can be triggered once: The character to which it is attached will receive +1 DMG from Thunder Manifestation or its summons.\n\n(Only one of this status can exist on the field at once. Some of Thunder Manifestation's skills will target the character to which this is attached.)",
                'related': 'Thunder Manifestation',
            },
            'thunderingshackles': {
                "name": 'Thundering Shackles',
                "type": 'Summon',
                "description": "End Phase: Deals 3 Electro DMG to opposing characters affected by Lightning Rod. (If there are no eligible opposing characters, deals DMG to the active character instead)\n\nUsage(s): 1",
                'related': 'Thunder Manifestation',
            },
            'lightningstrikeprobe': {
                "name": 'Lightning Strike Probe',
                "type": 'Combat Status',
                "description": "After a character on whose side of the field this card is on uses a Skill: Attach Lightning Rod to the active character on that side. (Once per Round)",
                'related': 'Thunder Manifestation',
            },
            'totalcollapse': {
                "name": 'Total Collapse',
                "type": 'Status',
                "description": "Physical and Anemo DMG taken by the affected character increased by 2.\n\nUsage(s): 1",
                'related': 'Dvalin',
            },
            'stonefacets:elementalcrystallization': {
                "name": 'Stone Facets: Elemental Crystallization',
                "type": 'Status',
                "description": "After this character takes Cryo/Hydro/Pyro/Electro DMG: If this character currently has not absorbed the power of this element, remove this effect, and then this character performs Elemental Absorption.",
                'related': 'Azhdaha',
            },
            'stonefacets:elementalabsorption': {
                "name": 'Stone Facets: Elemental Absorption',
                "type": 'Status',
                "description": "The character can absorb the power of the Elements, including Cryo/Hydro/Pyro/Electro, and then based on the element absorbed, gain the skills Frostspike Wave/Torrential Rebuke/Blazing Rebuke/Thunderstorm Wave. (The character can only have one Elemental Type absorbed at once, and this status will record the Elemental Type previously absorbed) \n\nAfter this character absorbs an element of a different type than the currently absorbed element: Generate 1 Elemental Die of the same type as the Element that was just absorbed.",
                'related': 'Azhdaha',
            },
            'fourleafsigil': {
                "name": 'Four-Leaf Sigil',
                "type": 'Status',
                "description": "End Phase: Switch to the attached character.",
                'related': 'Flickering Four-Leaf Sigil',
            },
            'blazingbarrier': {
                "name": 'Blazing Barrier',
                "type": 'Combat Status',
                "description": "Grants 1 Shield point to your active character. (Can stack. Max 3 points.).",
                'related': 'Thoma',
            },
            'scorchingooyoroi': {
                "name": 'Scorching Ooyoroi',
                "type": "Combat Status",
                "description": "After your character uses a Normal Attack: Deal 1 Pyro DMG and create a Blazing Barrier. \n\nUsage(s): 2",
                "related": "Thoma"
            },
            'mujimujidaruma': {
                "name": "Muji-Muji Daruma",
                "type": "Summon",
                "description": "End Phase: Deal 1 Anemo DMG, heal the character on your team that has taken the most damage for 2 HP. \n\nUsage(s): 2",
                "related": "Sayu"
            },
            'overwhelmingice': {
                "name": " Overwhelming Ice",
                "type": "Status",
                "description": "When the character uses a Normal Attack: Deal 1 Piercing DMG to all opposing characters on standby. \n\nUsage(s): 1",
                "related": "Cryo Hypostasis"
            },
            'piercingiceridge': {
                "name": "Piercing Iceridge",
                "type": "Summon",
                "description": "End Phase: Deal 1 Cryo DMG to the opposing Character Closest to Your Current Active Character. \n\nUsage(s): 2",
                "related": "Cryo Hypostasis"
            },
            'cryocrystalcore': {
                "name": "Cryocrystal Core",
                "type": "Status",
                "description": "When the character to which this is attached would be defeated: Remove this effect, ensure the character is not defeated, and heal them to 1 HP.",
                "related": "Cryo Hypostasis"
            },
            'fontemerpearl': {
                "name": "Fontemer Pearl",
                "type": "Status",
                "description": "When the character to which this is attached takes DMG: Negate 1 DMG. Once per Round, Usage(s) will not be used when negating DMG from Summons. \n\nUsage(s): 2 \n\nWhen you declare the end of your Round: If the character to which this is attached is the active character, draw 1 card.",
                "related": "Millennial Pearl Seahorse"
            },
            'resonantcoralorb': {
                "name": "Resonant Coral Orb",
                "type": "Summon",
                "description": "End Phase: Deal 1 Electro DMG. \n\nUsage(s): 2",
                "related": "Millennial Pearl Seahorse"
            },
            'snappysilhouette': {
                "name": "Snappy Silhouette",
                "type": "Status",
                "description": "End Phase: Deal 1 Cryo DMG to the character(s) to which this is attached. If only 1 Usage(s) is remaining and the attached character is affected by Cryo, this instance of DMG +1. \n\nUsage(s): 2",
                "related": "Charlotte"
            },
            'newsflashfield': {
                "name": "Newsflash Field",
                "type": "Summon",
                "description": "End Phase: Deal 1 Cryo DMG, heal your active character for 1 HP. \n\nUsage(s): 2",
                "related": "Charlotte"
            },
            'sourcewaterdroplet': {
                "name": "Sourcewater Droplet",
                "type": "Combat Status",
                "description": "After Neuvillette uses a Normal Attack: Heals the character for 2 HP. After this, Prepare Skill: Equitable Judgment. \n\nUsage(s): 1 (Can stack. Max 3 stacks.)",
                "related": "Neuvillette"
            },
            'urgentnekoparcel': {
                "name": "Urgent Neko Parcel",
                "type": "Combat Status",
                "description": "When Kirara is your active character, after you switch characters: Deal 1 Dendro DMG and draw 1 card. \n\nUsage(s): 1 (Can stack. Max 2 stacks.)",
                "related": "Kirara"
            },
            'shieldofsafetransport': {
                "name": "Shield of Safe Transport",
                "type": "Combat Status",
                "description": "Grants 2 Shield points to your active character.",
                "related": "Kirara"
            },
            'catgrasscardamom': {
                "name": "Cat Grass Cardamom",
                "type": "Combat Status",
                "description": "After the side of the field that this card is on has played 2 Action Cards: Deal 1 Dendro DMG to the active character on that side. \n\nUsage(s): 2",
                "related": "Kirara"
            },
            'electrocicin': {
                "name": "Electro Cicin",
                "type": "Summon",
                "description": "End Phase: Deal 1 Electro DMG. \n\nUsage(s): 3 \n\nAfter your opponent plays a total of 3 Action Cards: This card gains 1 Usage(s). (Max 3 stacks) \n\nAfter Fatui Electro Cicin Mage takes Elemental Reaction DMG: This card loses 1 Usage(s).",
                "related": "Fatui Electro Cicin Mage"
            },
            'electrocicinshield': {
                "name": "Electro Cicin Shield",
                "type": "Combat Status",
                "description": "Provides 1 Shield point for your active character. \n\nWhen created: If you have Electro Cicin on the field, additionally increase Shield by the amount of Usage(s) it has. (Adds a maximum of 3 additional Shield)",
                "related": "Fatui Electro Cicin Mage"
            },
            'grassringofsanctification': {
                "name": "Grass Ring of Sanctification",
                "type": "Combat Status",
                "description": "After you switch characters: Deal 1 Electro DMG, heal the character on your team that has taken the most damage for 1 HP. (Once per Round) \n\nUsage(s): 3",
                "related": "Kuki Shinobu"
            },
            'DazzlingPolyhedron': {
                "name": "Dazzling Polyhedron",
                "type": "Summon",
                "description": "End Phase: Deal 1 Anemo DMG. \n\nUsage(s): 3 \n\nWhen this Summon is on the field: Opposing character(s) take +1 Anemo DMG.",
                "related": "Faruzan"
            },
            'manifestgale': {
                "name": "Manifest Gale",
                "type": "Status",
                "description": "When the character to which this is attached uses Charged Attack: Spend 1 less Unaligned Element, Physical DMG dealt converted to Anemo DMG, and attaches Pressurized Collapse to the target character. \n\nUsage(s): 1",
                "related": "Faruzan"
            },
            "overchargedball": {
                "name": "Overcharged Ball",
                "type": "Event",
                "cost": "2 Pyro",
                "description": "Combat Action: Deal 1 Pyro DMG to the opponent's active character. \n\nWhen this card is Discarded: Deal 1 Pyro DMG to the opponent's active character.",
                "related": "Chevreuse"
            },
            "secondaryexplosiveshells": {
                "name": "Secondary Explosive Shells",
                "type": "Combat Status",
                "description": "After a character switch takes place on this side of the field: Deal 1 Pyro DMG to the character switched to. \n\nUsage(s): 2",
                "related": "Chevreuse"
            },
            "geoinfusion": {
                "name": "Geo Infusion",
                "type": "Status",
                "description": "The character to which this is attached has their Physical DMG dealt converted to Geo DMG. \n\nDuration (Rounds): 2",
                "related": "Navia"
            },
            "crystalshrapnel": {
                "name": "Crystal Shrapnel",
                "type": "Event",
                "cost": "1 White",
                "description": "Deal 1 Physical DMG to the opponent's active character and draw 1 card.",
                "related": "Navia"
            },
            "rosuladoratasalute": {
                "name": "Rosula Dorata Salute",
                "type": "Summon",
                "description": "End Phase: Deal 1 Geo DMG, draw 1 Crystal Shrapnel card. \n\nUsage(s): 2",
                "related": "Navia"
            },
            "onslaughtstance": {
                "name": "Onslaught Stance",
                "type": "Status",
                "description": "End Phase: Deals 1 Piercing DMG to all opposing characters affected by Bond of Life. \n\nDuration (Rounds): 2",
                "related": "Frost Operative"
            },
            "bondoflife": {
                "name": "Bond of Life",
                "type": "Status",
                "description": "When the character to which this is attached is healed: This effect will be consumed once for every Usage(s) it has to negate 1 HP of healing received. (Cannot negate revives or healing caused by redistribution of HP) \n\nUsage(s): 1 (Can stack, no stack limit).",
                "related": "Frost Operative"
            },
            "perstimer": {
                "name": "Pers Timer",
                "type": "Status",
                "description": "For every 1 card you draw: This card will gain 1 Pressure Level. \n\nWhen the character to which this is attached uses Pressurized Floe: If Pressure Level is at least 2, cancel this effect, and the Skill costs 1 fewer Elemental Die. If, after the Skill is finalized, the Pressure Level is at least 4, deal 3 additional Physical DMG.",
                "related": "Freminet"
            },
            "subnauticalhuntermode": {
                "name": "Subnautical Hunter Mode",
                "type": "Status",
                "description": "After you draw 3 cards: Grants 1 Shield point to defend the character to which this is attached. (Can stack. Max 2 points.) \n\nAfter the character to which this is attached uses a Normal Attack or Elemental Skill: Place up to 2 cards with the highest Current Elemental Dice Cost in your Hand at the bottom of your deck, then draw the same number of cards. \n\nDuration (Rounds): 2",
                "related": "Freminet"
            },
            "skyladder": {
                "name": "Skyladder",
                "type": "Combat Status",
                "description": "When you perform \"Switch Character\": Spend 1 fewer Elemental Die. \n\nUsage(s): 1 (Can stack. Max 2 stacks.)",
                "related": "Xianyun"
            },
            "driftcloudwave": {
                "name": "Driftcloud Wave",
                "type": "Status",
                "description": "When you switch to the character to which this is attached: Deal 1 Anemo DMG. \n\nUsage(s): 1 (Can stack. Max 2 stacks.)",
                "related": "Xianyun"
            },
            "starwicker": {
                "name": "Starwicker",
                "type": "Event",
                "cost": "0 White",
                "description": "Technique: Adeptal Assistance \n\nUsage(s): 2 \n\n(A character can only equip 1 Technique at a time)",
                "related": "Xianyun"
            },
            "frozen": {
                "name": "Frozen",
                "type": "Status",
                "description": "Character cannot use Skills. (Lasts until the end of this Round) \n\nWhen this character receives Pyro DMG or Physical DMG, removes this effect and increases DMG taken by 2.",
                "related": "Hydro Hilichurl Rogue"
            },
            "mistbubbleprison": {
                "name": "Mist Bubble Prison",
                "type": "Status",
                "description": "Character cannot use Skills. (Lasts until the end of this Round)",
                "related": "Hydro Hilichurl Rogue"
            },
            "mistbubbleslime": {
                "name": "Mist Bubble Slime",
                "type": "Event",
                "cost": "0 White",
                "description": "Technique: Bubble Battle Tactics \n\nUsage(s): 2 \n\n(A character can only equip 1 Technique at a time)",
                "related": "Hydro Hilichurl Rogue"
            },
            "chiorisautomatondolls": {
                "name": "Chiori's Automaton Dolls",
                "type": "Summon",
                "description": "Varied humanoid automatons of Chiori's that can not only attack autonomously but also provide varied buffs.",
                "related": "Chiori"
            },
            "electricrebirth": {
                "name": "Electric Rebirth",
                "type": "Status",
                "description": "When the character to which this is attached would be defeated: Remove this effect, ensure the character gains Immunity to Defeat, and heals them to 4 HP. After this effect is triggered, this character deals +1 Electro DMG.",
                "related": "Abyss Lector: Violet Lightning"
            },
            "spiritserpentsblessing": {
                "name": "Spirit-Serpent's Blessing",
                "type": "Combat Status",
                "description": "When your Spirit of Omen: Dendro Spirit-Serpent uses Technique: The DMG dealt by this Technique +1, and does not consume Usage(s) of Spirit of Omen: Dendro Spirit-Serpent. \n\nUsage(s): 1 (Can stack, no limit)",
                "related": "Eremite Floral Ring-Dancer"
            },
            "spiritofomendendrospiritserpent": {
                "name": "Spirit of Omen: Dendro Spirit-Serpent",
                "type": "Event",
                "cost": "0 White",
                "description": "Technique: Viny Razorscale \n\nUsage(s): 2 \n\n(A character can only equip 1 Technique at a time)",
                "related": "Eremite Floral Ring-Dancer"
            },
            "scopeoutsoftspots": {
                "name": "Scope Out Soft Spots",
                "type": "Combat Status",
                "description": "After your characters use a Skill: For each stack of this effect, there is a 10% chance of creating Strike Where It Hurts. If Strike Where It Hurts is created, the number of stacks of this effect is halved. (Rounded down)",
                "related": "Rosaria"
            },
            "strikewhereithurts": {
                "name": "Strike Where It Hurts",
                "type": "Combat Status",
                "description": "When dealing Skill DMG: Remove this status and double the DMG dealt for this instance.",
                "related": "Rosaria"
            },
            "evercoldfrostlance": {
                "name": "Evercold Frostlance",
                "type": "Summon",
                "description": "End Phase: Deal 1 Cryo DMG, create 2 stacks of Scope Out Soft Spots \n\nUsage(s): 2",
                "related": "Rosaria"
            },
            "largebolsteringbubblebalm": {
                "name": "Large Bolstering Bubblebalm",
                "type": "Event",
                "cost": "0 White",
                "description": "When this card is drawn: Heal your active character for 3 HP. Create 1 Medium Bolstering Bubblebalm and insert it as the second card from the top of your opponent's deck.",
                "related": "Sigewinne"
            },
            "mediumbolsteringbubblebalm": {
                "name": "Medium Bolstering Bubblebalm",
                "type": "Event",
                "cost": "0 White",
                "description": "When this card is drawn: Deals 2 Hydro DMG to the active character on the side of the field this card is on. Create 1 Small Bolstering Bubblebalm and place it at the top of your opponent's deck.",
                "related": "Sigewinne"
            },
            "smallbolsteringbubblebalm": {
                "name": "Small Bolstering Bubblebalm",
                "type": "Event",
                "cost": "0 White",
                "description": "When this card is drawn: Heal all your characters for 1 HP. Create Sourcewater Droplet.",
                "related": "Sigewinne"
            },
            "goldencorrosion": {
                "name": "Golden Corrosion",
                "type": "Status",
                "description": "End Phase: If the character to which this is attached is on standby, then that character will take 1 Piercing DMG for every Usage(s) that this effect has. \n\nUsage(s): 1 (Can stack. Max 3 stacks.)",
                "related": "Golden Wolflord"
            },
            "rifthoundskull": {
                "name": "Rifthound Skull",
                "type": "Summon",
                "description": "End Phase: Deal 1 Geo DMG. Attach Golden Corrosion to target character. \n\nUsage(s): 2",
                "related": "Golden Wolflord"
            },
            "biteyshark": {
                "name": "Bitey Shark",
                "type": "Event",
                "cost": "0 White",
                "description": "After either side switches characters, and Mualani is the active character: Spend 1 Nightsoul point to apply Bite Target to the opposing active character. \n\nTechnique: Sharky Surfboard \n\nWhen the character to which this is attached has 0 Nightsoul points, discard this card. When this card is discarded, the character to which this is attached has their Nightsoul's Blessing end.",
                "related": "Mualani"
            },
            "nightsoulsblessing": {
                "name": "Nightsoul's Blessing",
                "type": "Status",
                "description": "The character to which this is attached accumulates \"Nightsoul points.\" (Max 2 points)",
                "related": "Mualani"
            },
            "sharkmissile": {
                "name": "Shark Missile",
                "type": "Summon",
                "description": "End Phase: Deal 2 Hydro DMG. \n\nUsage(s): 2 (Can stack, no stack limit)",
                "related": "Mualani"
            },
            "nightvigil": {
                "name": "Night Vigil",
                "type": "Status",
                "description": "When a character receives healing apart from Hunter's Vigil, it is replaced by an equivalent amount of Bond of Life. \n\nAfter the character to which this is attached uses a Normal Attack: The Physical DMG dealt is converted to Electro DMG, and said character gains 2 stacks of Bond of Life. \n\nDuration (Rounds): 1",
                "related": "Clorinde"
            },
            "blooddebtdirective": {
                "name": "Blood-Debt Directive",
                "type": "Combat Status",
                "description": "After your character receives DMG: Attach 2 stacks of Bond of Life to the character who took DMG and the opponent's Arlecchino. \n\nUsage(s): 3",
                "related": "Arlecchino"
            },
            "grapplelink": {
                "name": "Grapple Link",
                "type": "Status",
                "description": "After the opposing side takes Burning DMG, or your other characters use a Technique: The character to which this is attached gains 1 Nightsoul point. \n\nWhen Nightsoul points are at 2: Attach Grapple Prepare to the character to which this is attached, then consume 2 Nightsoul points. (After Grapple Prepare is attached, before your characters select their actions, if the attached character is the active character: Deal 3 Dendro DMG to the nearest opponent) \n\nDuration (Rounds): 2",
                "related": "Kinich"
            },
            "almightydragonlordajaw": {
                "name": "Almighty Dragonlord (Ajaw)",
                "type": "Summon",
                "description": "End Phase: Deal 1 Dendro DMG, then deal 1 Dendro DMG to your opponent's next character. \n\nUsage(s): 2",
                "related": "Kinich"
            },
            "turbotwirly": {
                "name": "Turbo Twirly",
                "type": "Event",
                "cost": "0 White",
                "description": "When the character to which this is attached is switched out: Consume 1 Nightsoul point, and summon 1 Turbo Twirly: Let It Rip. \n\nTechnique: Twirly Twirly Bam Bam \n\n(A character can only equip 1 Technique at a time) \n\nWhen the attached character has 0 Nightsoul points, discard this card. When this card is discarded, the attached character's Nightsoul's Blessing ends.",
                "related": "Kachina"
            },
            "turbodrillfield": {
                "name": "Turbo Drill Field",
                "type": "Combat Status",
                "description": "Your Turbo Twirly deals Geo DMG +1, and deals Piercing DMG +1. \n\nUsage(s): 3",
                "related": "Kachina"
            },
            "lumidoucecaselevel1": {
                "name": "Lumidouce Case: Level 1",
                "type": "Summon",
                "description": "End Phase: Deal 1 Dendro DMG. \n\nAfter you deal Burning reaction DMG: This card levels up to become Lumidouce Case: Level 2. \n\nUsage(s): 3 (Can stack. Max 6 stacks.)",
                "related": "Emilie"
            },
            "lumidoucecaselevel3": {
                "name": "Lumidouce Case: Level 3",
                "type": "Summon",
                "description": "End Phase: Deal 1 Dendro DMG to all opponents. \n\nUsage(s): 1",
                "related": "Emilie"
            },
            "burningflame": {
                "name": "Burning Flame",
                "type": "Summon",
                "description": "End Phase: Deal 1 Pyro DMG. \n\nUsage(s): 1 (Can stack. Max 2 stacks.)",
                "related": "Emilie"
            },
            "thunderconvergence": {
                "name": "Thunder Convergence",
                "type": "Status",
                "description": "After your characters trigger Electro-Related Reactions: The character to which this is attached gains 1 Energy. \n\nUsage(s): 1",
                "related": "Sethos"
            },
            "twilightmeditation": {
                "name": "Twilight Meditation",
                "type": "Status",
                "description": "When the character to which this is attached used a Normal Attack: Physical DMG dealt is converted to Electro DMG, DMG +1, Unaligned Element cost -1, and deal 1 Piercing DMG to the opposing character with the lowest HP. \n\nDuration (Rounds): 2",
                "related": "Sethos"
            },
            "combatbladinggear": {
                "name": "Combat Blading Gear",
                "type": "Event",
                "cost": "0 White",
                "description": "The character to which this is attached has their Physical DMG dealt converted to Geo DMG. \n\nTechnique: High-Speed Leap \n\nWhen the attached character has 0 Nightsoul points, discard this card. When this card is discarded, the attached character's Nightsoul's Blessing ends.",
                "related": "Xilonen"
            },
            "sourcesamplegeo": {
                "name": "Source Sample: Geo",
                "type": "Status",
                "description": "When the Round begins: If the character to which this is attached has 2 Nightsoul points, create 1 Take Extra Geo DMG on the opponent's side of the field. After activating all Source Samples, consume 2 Nightsoul points.",
                "related": "Xilonen"
            },
            "opalshield": {
                "name": "Opal Shield",
                "type": "Combat Status",
                "description": "Grants 1 Shield point to your active character. (Can stack)",
                "related": "Citlali"
            },
            "itzpapa": {
                "name": "Itzpapa",
                "type": "Combat Status",
                "description": "After your characters take DMG: Deduct 1 Nightsoul point from Citlali and create 1 stack of Opal Shield. \n\nWhen Citlali gains Nightsoul points and her Nightsoul points reach 2, prioritize dealing 1 Cryo DMG to the opponent's active character. \n\nDuration (Rounds): 2",
                "related": "Citlali"
            },
            "crucibleofdeathandlife": {
                "name": "Crucible of Death and Life",
                "type": "Status",
                "description": "All your characters' Skills no longer consume Nightsoul points. \n\nAll your characters' Normal Attacks deal +1 DMG. \n\nUsage(s): 2",
                "related": "Mavuika"
            },
            "allfirearmamentsringofsearingradiance": {
                "name": "All-Fire Armaments: Ring of Searing Radiance",
                "type": "Combat Status",
                "description": "After another of your characters uses a Normal Attack or Technique: Mavuika consumes 1 Nightsoul point and deals 1 Pyro DMG. (Destroys self after Mavuika exits Nightsoul's Blessing.)",
                "related": "Mavuika"
            },
            "soulsniperritualstaff": {
                "name": "Soulsniper: Ritual Staff",
                "type": "Event",
                "cost": "0 White",
                "description": "Technique: Multitarget Fire. \n\nWhen this card is discarded, the Nightsoul's Blessing of the character to which this is attached ends. \n\n(A character can only equip 1 Technique at a time)",
                "related": "Chasca"
            },
            "shadowhuntshell": {
                "name": "Shadowhunt Shell",
                "type": "Event",
                "cost": "3 Anemo",
                "description": "When this card is added to your Hand: If your active character is Pyro/Hydro/Electro/Cryo, convert this card to the corresponding element. \n\nWhen this card is played or you Discard it from your Hand: Prioritize dealing 1 Anemo DMG to the opponent's active character, then randomly add 1 Shadowhunt Shell to your deck.",
                "related": "Chasca"
            },
            "swallowwispshield": {
                "name": "Swallow-Wisp Shield",
                "type": "Combat Status",
                "description": "Grants 1 Shield point to your active character. (Can stack, no stack limit)",
                "related": "Lan Yan"
            },
            "efficientswitch": {
                "name": "Efficient Switch",
                "type": "Combat Status",
                "description": "The next time you perform \"Switch Character\": Spend 1 fewer Elemental Die. (Can stack, no stack limit)",
                "related": "Lan Yan"
            },
            "declension": {
                "name": "Declension",
                "type": "Status",
                "description": "If this state has 2 stacks, then consume 2 stacks of this state, and the next Heartstopper Strike this character performs will be considered a Fast Action, while DMG for this Heartstopper Strike: Charge will be increased by 1. (Can stack, no limit)",
                "related": "Shikanoin Heizou"
            },
            "wellfedandstrong": {
                "name": "Well Fed and Strong",
                "type": "Status",
                "description": "Each stack causes this character to deal +1 DMG the next time they deal DMG. (Can stack, no stack limit, max 2 stacks each time)",
                "related": "Gluttonous Yumkasaur Mountain King"
            },
            "wellfedandsturdy": {
                "name": "Well Fed and Sturdy",
                "type": "Status",
                "description": "Next time you take damage: -1 DMG. (Can stack. No stack limit)",
                "related": "Gluttonous Yumkasaur Mountain King"
            },
            "agileswitch": {
                "name": "Agile Switch",
                "type": "Combat Status",
                "description": "The next time you perform \"Switch Character\": This switch will be considered a Fast Action instead of a Combat Action. (Can stack, no stack limit)",
                "related": "Iansan"
            },
            "kineticenergyscale": {
                "name": "Kinetic Energy Scale",
                "type": "Combat Status",
                "description": "When your character deals DMG: Deal +2 DMG for this instance. If Iansan is in Nightsoul's Blessing, Usage(s) is not consumed, but consume 1 of Iansan's Nightsoul points instead. \n\nUsage(s): 2",
                "related": "Iansan"
            },
            "dreamdrifter": {
                "name": "Dreamdrifter",
                "type": "Status",
                "description": "When you declare the end of your Round: Replace the active character with the character to which this is attached, and deal 1 Anemo DMG. \n\nUsage(s): 1",
                "related": "Yumemizuki Mizuki"
            },
            "yumemistylespecialsnacks": {
                "name": "Yumemi Style Special Snacks",
                "type": "Event",
                "cost": "0 White",
                "description": "When this card enters your Hand: If your active character's HP is above 5, deal 1 Anemo DMG. Otherwise, heal them for 2 HP. After this effect is applied, draw 1 card and then discard this card.",
                "related": "Yumemizuki Mizuki"
            },
            "minibaku": {
                "name": "Mini Baku",
                "type": "Summon",
                "description": "End Phase: Create 1 Yumemi Style Special Snacks and place it at the top of your deck. \n\nUsage(s): 3",
                "related": "Yumemizuki Mizuki"
            },
            "resentment": {
                "name": "Resentment",
                "type": "Status",
                "description": "Each stack causes the character to which this is attached to deal +1 DMG and +1 Elemental Burst Piercing DMG. (Can stack, no stack limit)",
                "related": "Lord of Eroded Primal Fire"
            },
            "suddenonrush": {
                "name": "Sudden Onrush",
                "type": "Status",
                "description": "Before your next action, switch the character to which this is attached to be the active character.",
                "related": "Varesa"
            },
            "apexdrive": {
                "name": "Apex Drive",
                "type": "Status",
                "description": "After Varesa is switched in to be the Active Character: Prepare Skill: Guardian Vent: Volcano Kablam. \n\nUsage(s): 1",
                "related": "Varesa"
            },
            "cacucu": {
                "name": "Cacucu",
                "type": "Event",
                "cost": "0 White",
                "description": "Technique: Supporting Fire \n\nWhen the character to which this is attached has 0 Nightsoul points, discard this card. When this card is discarded, the attached character's Nightsoul's Blessing ends.",
                "related": "Ifa"
            },
            "halftulpa": {
                "name": "Half-Tulpa",
                "type": "Summon",
                "description": "End Phase: Deal 1 Hydro DMG. \n\nWhen this card is discarded: Heal all your Hydro Tulpa for 2 HP. \n\nUsage(s): 2",
                "related": "Hydro Tulpa"
            },
            "cookingmekcoldstoragemode": {
                "name": "Cooking Mek: Cold Storage Mode",
                "type": "Summon",
                "description": "End Phase: Deal 1 Cryo DMG. \n\nUsage(s): 2",
                "related": "Escoffier"
            },
            "allspectrummultiusecookingmek": {
                "name": "All-Spectrum Multi-Use Cooking Mek",
                "type": "Event",
                "cost": "0 White",
                "description": "Upon triggering Cryo-Related Reactions by any side: Randomly create 1 Gilded Hall, Autumn Frost, Wave-Kissed Sands, or Verdant Gift and add it to your Hand. \n\nUsage(s): 2",
                "related": "Escoffier"
            },
            "wushouarts": {
                "name": "Wushou Arts",
                "type": "Status",
                "description": "Before your character chooses their action, if the character to which this is attached is your active character, use the Skill: Charmed Cloudstrider.",
                "related": "Gaming"
            },
            "suannimanchai": {
                "name": "Suanni: Man Chai",
                "type": "Status",
                "description": "The attached character's Elemental Skill spends 1 fewer Elemental Die and deals +1 DMG. \n\nWhen the attached character uses an Elemental Skill: If their current HP is 5 or higher, they don't spend Usage(s). Instead, they take 1 Piercing DMG. \n\nUsage(s): 2",
                "related": "Gaming"
            },
            "mightofstone": {
                "name": "Might of Stone",
                "type": "Status",
                "description": "The character to which this is attached deals +1 DMG. If the opposing character is under a shield or damage reduction effect, deal +3 DMG instead. \n\nUsage(s): 1 (Can stack, no stack limit)",
                "related": "Black Serpent Knight: Rockbreaker Ax"
            },
            "mutualweaponsmentorship": {
                "name": "Mutual Weapons Mentorship",
                "type": "Event",
                "cost": "0 White",
                "description": "This card attaches Seven-Phase Flash to your Skirk. \n\nAt the start of the Round or after your side performs a switch: Discard this card and gain 1 Serpent's Subtlety.",
                "related": "Skirk"
            },
            "voidrift": {
                "name": "Void Rift",
                "type": "Event",
                "cost": "0 White",
                "description": "Combat Action: If there is a card with a Current Elemental Dice Cost of 3 in your Hand, Discard 1 card with a Current Elemental Dice Cost of 3 from your Hand. Allied Skirk then gains 2 Serpent's Subtlety.",
                "related": "Skirk"
            },
            "spiritorb": {
                "name": "Spirit Orb",
                "type": "Combat Status",
                "description": "When the Action Phase begins: Deals 1 Electro DMG. \n\nUsage(s): 1",
                "related": "Ororon"
            },
            "supersonicoculus": {
                "name": "Supersonic Oculus",
                "type": "Summon",
                "description": "End Phase: Deal 1 Electro DMG. \n\nWhen your active character takes DMG: Reduce DMG taken by 1, then this card's Usage(s) -1. (Once per Round) \n\nUsage(s): 3",
                "related": "Ororon"
            },
            "bonecrunchersenergyblock": {
                "name": "Bonecruncher's Energy Block",
                "type": "Event",
                "cost": "0 White",
                "description": "Randomly Discard 1 card from your Hand with the highest Current Elemental Dice Cost and create 1 Elemental Die of your active character's Element. (Only 1 such card can be played per Round)",
                "related": "Consecrated Horned Crocodile"
            },
            "soulwind": {
                "name": "Soulwind",
                "type": "Combat Status",
                "description": "After an allied character uses Normal Attack: The next time this character uses Normal Attack this turn costs 2 fewer Unaligned Element. \n\nUsage(s): 1",
                "related": "Mika"
            },
            "eagleplumeexperience": {
                "name": "Eagleplume Experience",
                "type": "Combat Status",
                "description": "When your character uses a Normal Attack, spend 1 less Elemental Die. \n\nUsage(s): 2",
                "related": "Mika"
            },
            "eagleplumeencomium": {
                "name": "Eagleplume Encomium",
                "type": "Combat Status",
                "description": "After your character uses a Normal Attack: Heal self for 1 HP. \n\nUsage(s): 2",
                "related": "Mika"
            },
            "shield": {
                "name": "Shield",
                "type": "Combat Status",
                "description": "Grants 1 Shield point to your active character. (Can stack, no stack limit)",
                "related": "Ineffa"
            },
            "birgitta": {
                "name": "Birgitta",
                "type": "Summon",
                "description": "End Phase: Deal 1 Electro DMG. \n\nUsage(s): 2",
                "related": "Ineffa"
            },
            "flyingswirl": {
                "name": "Flying Swirl",
                "type": "Status",
                "description": "Next time you take damage: -1 DMG. \n\nUsage(s): 1 (Can stack. No stack limit)",
                "related": "Goldflame Qucusaur Tyrant"
            },
            "goldflamestate": {
                "name": "Goldflame State",
                "type": "Status",
                "description": "End Phase: If the character to which this is attached is your active character, deal 1 Pyro DMG, and deal 1 Piercing DMG to all opposing characters on standby. \n\nUsage(s): 1 (Can stack, no stack limit)",
                "related": "Goldflame Qucusaur Tyrant"
            },
            "sacramentalshower": {
                "name": "Sacramental Shower",
                "type": "Combat Status",
                "description": "After your opponent switches characters: Deal 1 Hydro DMG to the opponent's active character. \n\nAfter you switch characters: Create 1 random basic Elemental Die. \n\nUsage(s): 1",
                "related": "Dahlia"
            },
            "favonianfavor": {
                "name": "Favonian Favor",
                "type": "Combat Status",
                "description": "After your character receives DMG: Generate 1 Shield. \n\nUsage(s): 2",
                "related": "Dahlia"
            },
            "coolyourjetsducky": {
                "name": "Cool Your Jets Ducky",
                "type": "Summon",
                "description": "End Phase: Deal 2 Hydro DMG. \n\nUsage(s): 2",
                "related": "Aino"
            },
            "manifestflame": {
                "name": "Manifest Flame",
                "type": "Status",
                "description": "During this Round, the attached character's Physical DMG is converted to Electro DMG. The character's Normal Attack deals +1 DMG. \n\nDuration (Rounds): 1",
                "related": "Flins"
            },
            "thundercloud": {
                "name": "Thundercloud",
                "type": "Summon",
                "description": "End Phase: Deal 2 Electro DMG. \n\nUsage(s)(s): 1 (Can stack, no stack limit) \n\nWhen this card enters the field, or its usages increase: Apply Electric Shock to 1 random card in your opponent's Hand.",
                "related": "Flins"
            },
            "frostgrovesanctuary": {
                "name": "Frostgrove Sanctuary",
                "type": "Combat Status",
                "description": "End Phase: Deal 1 Dendro DMG. \n\nUsage(s): 2",
                "related": "Lauma"
            },
            "palehymn": {
                "name": "Pale Hymn",
                "type": "Combat Status",
                "description": "Your Lunar-Bloom reactions deal +1 DMG. \n\nUsage(s): 3",
                "related": "Lauma"
            },
            "lowgravitybackground": {
                "name": "Low Gravity Background",
                "type": "Combat Status",
                "description": "After either side uses a Skill: Attaches Evasion to this character and switches to the next character. \n\nDuration (Rounds): 2",
                "related": "Experimental Field Generator"
            },
            "shockblast": {
                "name": "Shock Blast",
                "type": "Combat Status",
                "description": "End Phase: Deal 1 Piercing DMG to all opposing characters who have not been afflicted by Evasion. \n\nDuration (Rounds): 2",
                "related": "Experimental Field Generator"
            },
            "res": {
                "name": "RES",
                "type": "Status",
                "description": "When the character to which this is attached takes DMG: Decrease DMG taken by 1. (Can stack, no stack limit)",
                "related": "Nefer"
            },
            "seedsofdeceit": {
                "name": "Seeds of Deceit",
                "type": "Event",
                "cost": "5 Dendro",
                "description": "Combat Action: Can be used when Nefer is the active character. \n\nNefer uses the Skill: Phantasm Performance.",
                "related": "Nefer"
            },
            "radianthues": {
                "name": "Radiant Hues",
                "type": "Event",
                "cost": "2 Cryo",
                "description": "Combat Action: Create 2 stacks of Shield.",
                "related": "Wayward Hermetic Spiritspeaker"
            },
            "essentialtransmutation": {
                "name": "Essential Transmutation",
                "type": "Status",
                "description": "When the attached character uses a Normal Attack: Deals 1 Pyro DMG. \n\nWhen the attached character uses an Elemental Skill: Generate 1 stack of Efficient Switch.",
                "related": "Durin"
            },
            "confirmationofpurity": {
                "name": "Confirmation of Purity",
                "type": "Combat Status",
                "description": "After your character uses a Skill: Deal 1 Pyro DMG. \n\nUsage(s): 4",
                "related": "Durin"
            },
            "purrloinedtreasureflask": {
                "name": "Purr-loined Treasure Flask",
                "type": "Event",
                "cost": "4 White",
                "description": "When Jahoda switches to become the active character: If the opponent's active character is affected by Pyro/Hydro/Electro/Cryo, convert this card to the corresponding element. \n\nCombat Action: Deal 2 Anemo DMG to the opponent's active character. Then, deal 1 Anemo DMG once again.",
                "related": "Jahoda"
            },
            "purrsonalcoordinatedassistancerobots": {
                "name": "Purrsonal Coordinated Assistance Robots",
                "type": "Combat Status",
                "description": "End Phase: Deals 1 Anemo DMG if your active character is Dendro or Geo; otherwise, deals 1 DMG of that character's Elemental Type. Heal the character on your team that has taken the most damage for 2 HP. \n\nUsage(s): 2",
                "related": "Jahoda"
            },
            "waterdroplet": {
                "name": "Water Droplet",
                "type": "Summon",
                "description": "End Phase: If your Hydro Hypostasis does not have Hydro Crystal Core attached, attach Hydro Crystal Core to this character. Otherwise, deal 2 Hydro DMG. \n\nUsage(s): 2",
                "related": "Hydro Hypostasis"
            },
            "hydrocrystalcore": {
                "name": "Hydro Crystal Core",
                "type": "Status",
                "description": "When the character to which this is attached would be defeated: Remove this effect, ensure the character will not be defeated, and heal them to 1 HP.",
                "related": "Hydro Hypostasis"
            },
            "gravityripple": {
                "name": "Gravity Ripple",
                "type": "Combat Status",
                "description": "End Phase: Deal 1 Hydro DMG. \n\nUsage(s): 2",
                "related": "Columbina"
            },
            "lunardomain": {
                "name": "Lunar Domain",
                "type": "Combat Status",
                "description": "When the opponent is affected by Lunar-Charged: Also apply Electric Shock to 3 random cards in the opponent's Hand, increase DMG dealt by your Lunar-Charged by 2, and set the DMG dealt by your Thundercloud to 3. \n\nWhen the opponent is affected by Lunar-Bloom: Apply Cost Reduction to a random card in your Hand 3 times instead. \n\nWhen the opponent is affected by Lunar-Crystallize: The number of Moondrift Harmony generated is changed to 3. \n\nUsage(s): 3",
                "related": "Columbina"
            },
            "aedon": {
                "name": "Aedon",
                "type": "Event",
                "cost": "2 White",
                "description": "Combat Action: Select 1 opposing character and deal 1 Geo DMG to them.",
                "related": "Illuga"
            },
            "nightingalessong": {
                "name": "Nightingale's Song",
                "type": "Combat Status",
                "description": "Enemy target takes +1 Geo DMG. \n\nUsage(s): 1 (Can stack, no stack limit) \n\nAfter you bring forth a Summon, this card gains 1 Usage.",
                "related": "Illuga"
            },
            "chillingpenalty": {
                "name": "Chilling Penalty",
                "type": "Status",
                "description": "When the character to which this is attached uses a Normal Attack: Deal +1 DMG. If this character has at least 6 HP, this Skill costs 1 less Cryo Die. \n\nAfter this Skill finalizes, if this character has at least 6 HP, deal 1 Piercing DMG to them; if this character has no more than 5 HP, heal them for 2 HP. \n\nUsage(s): 2",
                "related": "Wriothesley"
            },
            "lingeringicicles": {
                "name": "Lingering Icicles",
                "type": "Combat Status",
                "description": "Before you choose your action: Deal 2 Cryo DMG. \n\nUsage(s): 1",
                "related": "Wriothesley"
            },
            "goldenchalicesbounty": {
                "name": "Golden Chalice's Bounty",
                "type": "Combat Status",
                "description": "After opponent's characters are affected by the Bloom reaction: Your team no longer generates Dendro Core, but instead summons Bountiful Core.",
                "related": "Nilou"
            },
            "lingeringaeon": {
                "name": "Lingering Aeon",
                "type": "Status",
                "description": "End Phase: Deal 2 Hydro DMG to affected character. \n\nUsage(s): 1",
                "related": "Nilou"
            },
            "seatssacredandsecular": {
                "name": "Seats Sacred and Secular",
                "type": "Event",
                "cost": "0 White",
                "description": "When in Arkhe: Ousia or Arkhe: Pneuma states, switch Furina's state. \n\nIf you have Salon Members or Singer of Many Waters on the field, change their state as well.",
                "related": "Furina"
            },
            "salonmembers": {
                "name": "Salon Members",
                "type": "Summon",
                "description": "End Phase: Deal 1 Hydro DMG. If your side has characters with at least 6 HP, deal 1 Piercing DMG to your character who has taken the least DMG, and deal another 1 Hydro DMG. \n\nUsage(s): 2 (Can stack. Max 4 stacks)",
                "related": "Furina"
            },
            "singerofmanywaters": {
                "name": "Singer of Many Waters",
                "type": "Summon",
                "description": "End Phase: Heal all your characters for 1 HP. If your side has characters with no more than 5 HP, heal the most injured character for an additional 1 HP. \n\nUsage(s): 2 (Can stack. Max 4 stacks)",
                "related": "Furina"
            },
            "universalrevelry": {
                "name": "Universal Revelry",
                "type": "Combat Status",
                "description": "After your active character takes DMG or is healed: Add 1 stack of Revelry. \n\nDuration (Rounds): 2",
                "related": "Furina"
            },
            "shieldofpassion": {
                "name": "Shield of Passion",
                "type": "Combat Status",
                "description": "Grants 2 Shield points to your active character.",
                "related": "Xinyan"
            },
            "festivefires": {
                "name": "Festive Fires",
                "type": "Combat Status",
                "description": "When you declare the end of your Round: If your Hand has no more than 1 card, deal 1 Pyro DMG \n\nUsage(s): 2",
                "related": "Xinyan"
            },
            "overwhelmingice_": {
                "name": "Overwhelming Ice",
                "type": "Status",
                "description": "When the character uses a Normal Attack: Deal 1 Piercing DMG to all opposing characters on standby .  \n\nUsage(s): 1",
                "related": "Cryo Hypostasis"
            },
            "cryocrystalcore_": {
                "name": "Cryo Crystal Core",
                "type": "Status",
                "description": "When the character to which this is attached would be defeated: Remove this effect, ensure the character will not be defeated, and heal them to 1 HP.",
                "related": "Cryo Hypostasis"
            },
            "curseoftheundercurrent": {
                "name": "Curse of the Undercurrent",
                "type": "Combat Status",
                "description": "When character(s) on this side of the playing field use Elemental Skills or Elemental Bursts: They must spend 1 extra Elemental Die. \n\nUsage(s): 2",
                "related": "Abyss Herald: Wicked Torrents"
            },
            "wateryrebirth": {
                "name": "Watery Rebirth",
                "type": "Status",
                "description": "When the character to which this is attached would be defeated: Remove this effect, ensure the character will not be defeated, and heal them to 4 HP. After this effect is triggered, Physical DMG this character deals is converted to Hydro DMG, and Hydro DMG +1.",
                "related": "Abyss Herald: Wicked Torrents"
            },
            "darkshadow": {
                "name": "Dark Shadow",
                "type": "Summon",
                "description": "When played: Gain \"Attack Power\" equal to the Current Elemental Dice Cost of the devoured card with the highest cost, and gain Usage(s) based on the number of devoured cards with said cost. \n\nEnd Phase: Deal Electro DMG equal to the \"Attack Power\" of this card. \n\nWhen your active character takes DMG: Reduce DMG taken by 1, then this card's Usage(s) -2.",
                "related": "All Devouring Narwhal"
            },
            "deepdevourersdomain": {
                "name": "Deep Devourer's Domain",
                "type": "Combat Status",
                "description": "Cards you Discard from your Hand or use for Tune will be devoured. \n\nFor every 3 cards devoured: All-Devouring Narwhal gains 1 extra Max HP when the Round ends. If there are any cards among these that have the same Current Elemental Dice Cost, gain another 1 extra Max HP. If all 3 cards have the same Current Elemental Dice Cost, gain yet another 1 extra Max HP.",
                "related": "All Devouring Narwhal"
            },
            "armoredcrabcarapace": {
                "name": "Armored Crab Carapace",
                "type": "Status",
                "description": "Each stack provides 1 Shield to protect the equipped character.",
                "related": "Emperor of Fire and Iron"
            },
            "thunderboretrap": {
                "name": "Thunderbore Trap",
                "type": "Combat Status",
                "description": "After a character on this side of the field uses a Skill: Deals 2 Electro DMG to their team's active character. \n\nUsage(s): Initial amount equal to the number of Bonecruncher's Energy Block discarded when created. (Max 3 stacks)",
                "related": "Consecrated Scorpion"
            },
            "awakenmykindred": {
                "name": "Awaken My Kindred",
                "type": "Event",
                "cost": "2 Dendro",
                "description": "When you play this card or Discard this card: Summon 1 independent Proliferated Organism.",
                "related": "Guardian of Apep's Oasis"
            },
            "oasisnourishment": {
                "name": "Oasis Nourishment",
                "type": "Combat Status",
                "description": "When you play Awaken, My Kindred: Spend 1 fewer Elemental Die. \n\nUsage(s): 1 (Up to 3 stacks)",
                "related": "Guardian of Apep's Oasis"
            },
            "proliferatedorganism": {
                "name": "Proliferated Organism",
                "type": "Summon",
                "description": "End Phase: Deal 1 Dendro DMG. \n\nUsage(s): 1",
                "related": "Guardian of Apep's Oasis"
            },
            "reignitedheartofoasis": {
                "name": "Reignited Heart of Oasis",
                "type": "Status",
                "description": "The character to which this is attached deals +3 DMG. \n\nAfter the character to which this is attached uses a Skill: Remove the Oasis Nourishment on your side. Each stack removed heals the attached character for 1 HP.",
                "related": "Guardian of Apep's Oasis"
            },
            "burstscan": {
                "name": "Burst Scan",
                "type": "Combat Status",
                "description": "Before either side chooses their action: If your side has Dendro Core or Bountiful Core, Reduce their Usage(s) by 1, and Discard the card at the top of your deck. After this, deal Dendro DMG equal to the Current Elemental Dice Cost of the card you Discarded. \n\nUsage(s): 1 (Can stack. Max 3 stacks)",
                "related": "Kaveh"
            },
            "mehraksassistance": {
                "name": "Mehrak's Assistance",
                "type": "Status",
                "description": "The character's Normal Attacks deal +1 DMG, and the Physical DMG they deal is converted to Dendro DMG.  \n\nAfter the character uses a Normal Attack: Create a Burst Scan. \n\nDuration (Rounds): 2",
                "related": "Kaveh"
            },
            "aftersalesservicerounds": {
                "name": "After-Sales Service Rounds",
                "type": "Summon",
                "description": "End Phase: Deal 1 Electro DMG. \n\nUsage(s): 1",
                "related": "Dori"
            },
            "jinni": {
                "name": "Jinni",
                "type": "Summon",
                "description": "End Phase: Heal your active character for 2 HP and that character gains 1 Energy. \n\nUsage(s): 2",
                "related": "Dori"
            },
            "flyingcloudflagformation": {
                "name": "Flying Cloud Flag Formation",
                "type": "Combat Status",
                "description": "When your character uses a Normal Attack: If you have no more than 1 card in your Hand, this Skill costs 1 fewer Elemental Die. \n\nUsage(s): 1 (Can stack. Max 4 stacks)",
                "related": "Yun Jin"
            },
            "shieldofswirlingclouds": {
                "name": "Shield of Swirling Clouds",
                "type": "Status",
                "description": "While preparing this Skill: Grant 2 Shield points to the character to which this is attached.",
                "related": "Yun Jin"
            },
            "gossamersprite": {
                "name": "Gossamer Sprite",
                "type": "Summon",
                "description": "End Phase: Deal 1 Dendro DMG, heal your active character for 1 HP. \n\nUsage(s): 1",
                "related": "Baizhu"
            },
            "pulsingclarity": {
                "name": "Pulsing Clarity",
                "type": "Combat Status",
                "description": "When Action Phase begins: Create Seamless Shield. \n\nUsage(s): 2",
                "related": "Baizhu"
            },
            "seamlessshield": {
                "name": "Seamless Shield",
                "type": "Combat Status",
                "description": "Provides 1 Shield, protecting your active character. \n\nWhen this effect is removed, or generated again: Deal 1 Dendro DMG, and heal your active character for 1 HP.",
                "related": "Baizhu"
            },
        },
    
        "nullchar": {
            "icon": Nullchar_Icon   
        },
    
        "elements": {
            'anemo': Anemo_Sort,
            'anemo_activated': Anemo_Sort_Activated,
            'cryo': Cryo_Sort,
            'cryo_activated': Cryo_Sort_Activated,
            'dendro':Dendro_Sort,
            'dendro_activated': Dendro_Sort_Activated,
            'electro': Electro_Sort,
            'electro_activated': Electro_Sort_Activated,
            'geo': Geo_Sort,
            'geo_activated': Geo_Sort_Activated,
            'hydro': Hydro_Sort,
            'hydro_activated': Hydro_Sort_Activated,
            'pyro': Pyro_Sort,
            'pyro_activated': Pyro_Sort_Activated,
            'noelement': NoElement_Sort
        },
    
        "factions": {
            'fatui': Fatui_Sort,
            'hilichurl': Hilichurl_Sort,
            'inazuma': Inazuma_Sort,
            'kairagi': Kairagi_Sort,
            'liyue': Liyue_Sort,
            'mondstadt': Mond_Sort,
            'monster': Monster_Sort,
            'sumeru': Sumeru_Sort,
        },
    
        "dice": {
            'pyro': Pyro_Dice,
            'hydro': Hydro_Dice,
            'anemo': Anemo_Dice,
            'electro': Electro_Dice,
            'dendro': Dendro_Dice,
            'cryo': Cryo_Dice,
            'geo': Geo_Dice,
            'omni': Omni_Dice,
            'white': White_Dice,
            'black': Black_Dice,
            'energy': Energy,
            'arcane': Arcane
        },
    
        "menu": {
            'char_sort': Char_Sort,
            "action_sort": Action_Sort,
            "char_sort_hover": Char_Sort_Hover,
            "action_sort_hover": Action_Sort_Hover
        }
    }
}
else {
    
    var db = {
        "chars": {
            "ganyu": {
                "name": "Ganyu",
                'na': 'Liutian Archery \n2 Black, 1 Cryo \nDeals 2 Physical DMG.',
                'skill': "Trail of the Qilin \n3 Cryo \nDeals 1 Cryo DMG, creates 1 'Ice Lotus'.",
                'burst': "Celestial Shower \n3 Cryo, 3 Energy \nDeals 2 Cryo DMG, deals 1 Piercing DMG to all opposing characters on standby, summons 1 Sacred Cryo Pearl.",
                'special': "Normal Attack: Frostflake Arrow \n5 Cryo \nDeals 2 Cryo DMG, deals 2 Piercing DMG to all opposing characters on standby.",
                'hi_res_image': '/cards/i_n330000_gcg_high_resolution.webp',
                "card": Ganyu_Card,
                "card_selected": '/cards/i_n334000.webp',
                "icon": Ganyu_Icon,
                "element": 'cryo',
                "region": 'liyue',
                'related': 'Ice Lotus, Sacred Cryo Pearl',
                "flavor": "“This press release is due tomorrow… I suppose I could work through the night and get it done.”",
                "id": '03',
                "keyword": "bow"
            },
    
            "diona": {
                "name": 'Diona',
                'na': "Kätzlein Style \n2 Black, 1 Cryo \nDeals 2 Physical DMG.",
                'skill': "Icy Paws \n3 Cryo \nDeals 2 Cryo DMG, creates 1 'Cat-Claw Shield'.",
                'burst': "Signature Mix \n3 Cryo, 3 Energy \nDeals 1 Cryo DMG, heals this character for 2 HP, summons 1 'Drunken Mist'.",
                'hi_res_image': "/cards/i_n330023_gcg_high_resolution.webp",
                "card": '/cards/i_n330023.webp',
                "card_selected": '/cards/i_n334023.webp',
                "icon": Diona_Icon,
                "element": 'cryo',
                "region": 'mondstadt',
                'related': 'Cat-Claw Shield, Drunken Mist',
                "flavor": "1% energy dedicated to mixing drinks, 99% to... denying the reality of familiar.",
                "id": '02',
                "keyword": "bow"
            },
    
            "kaeya": {
                "name": 'Kaeya',
                'na': "Ceremonial Bladework \n2 Black, 1 Cryo \nDeals 2 Physical DMG.",
                'skill': "Frostgnaw \n3 Cryo \nDeals 3 Cryo DMG.",
                'burst': "Glacial Waltz \n4 Cryo, 2 Energy \nDeals 1 Cryo DMG, creates 1 'Icicle'.",
                'hi_res_image': "/cards/i_n330001_gcg_high_resolution.webp",
                "card": Kaeya_Card,
                "card_selected": '/cards/i_n334001.webp',
                "icon": Kaeya_Icon,
                "element": 'cryo',
                "region": 'mondstadt',
                'related': 'Icicle',
                "flavor": "Specializes in awakening knightly virtue in others.",
                "id": '01',
                "keyword": "sword"
            },
    
            "chongyun": {
                "name": 'Chongyun',
                'na': 'Demonbane \n2 Black, 1 Cryo \nDeals 2 Physical DMG.',
                'skill': "Chonghua’s Layered Frost \n3 Cryo \nDeals 3 Cryo DMG, creates 1 'Chonghua Frost Field'.",
                'burst': "Cloud-Parting Star \n3 Cryo, 3 Energy \nDeals 7 Cryo DMG.",
                'hi_res_image': '/cards/i_n330002_gcg_high_resolution.webp',
                "card": Chongyun_Card,
                "card_selected": '/cards/i_n334002.webp',
                "icon": Chongyun_Icon,
                "element": 'cryo',
                "region": 'liyue',
                'related': 'Chonghua Frost Field',
                "flavor": "“Ugh, summer… Please pass us by in peace…”",
                "id": '04',
                "keyword": "claymore"
            },
    
            "ayaka": {
                "name": 'Kamisato Ayaka',
                'na': 'Kamisato Art: Kabuki \n2 Black, 1 Cryo \nDeals 2 Physical DMG.',
                'skill': 'Kamisato Art: Hyouka \n3 Cryo \nDeals 3 Cryo DMG.',
                'burst': "Kamisato Art: Soumetsu \n3 Cryo, 3 Energy\nDeals 4 Cryo DMG, summons 1 'Frostflake Seki no To'.",
                'special': "Kamisato Art: Senho \n(Passive) \nWhen switched to be the active character, this character gains 'Cryo Infusion.'",
                'hi_res_image': '/cards/i_n330003_gcg_high_resolution.webp',
                "card": Ayaka_Card,
                "card_selected": '/cards/i_n334003.webp',
                "icon": Ayaka_Icon,
                "element": 'cryo',
                "region": 'inazuma',
                'related': "Frostflake Seki no To, Kamisato Ayaka's Cryo Infusion",
                "flavor": "As graceful as the frost drifting in the wind, as elegant as a heron perched in a courtyard.",
                "id": '05',
                "keyword": "sword"
            },
    
            "eula": {
                "name": "Eula",
                "na": "Favonius Bladework - Edel\n2 Black, 1 Cryo\nDeals 2 Physical DMG.",
                "skill": "Ice Tide Vortex\n3 Cryo \nDeals 2 Cryo DMG. If this character has not yet gained Grimheart, they will gain Grimheart.",
                "burst": "Glacial Illumination\n3 Cryo, 2 Energy\n Deals 2 Cryo DMG, summons 1 Lightfall Sword.",
                'hi_res_image': '/cards/i_n330028_gcg_high_resolution.webp',
                "card": '/cards/i_n330028.webp',
                "card_selected": '/cards/i_n334030.webp',
                "icon": Eula_Icon,
                "element": "cryo",
                "region": 'mondstadt',
                "related": "Grimheart, Lightfall Sword",
                "flavor": "It's but a game. I won't hold a grudge should luck happen to be on your side.",
                "id": '49',
                "keyword": "claymore"
            },
    
            'shenhe': {
                'name': 'Shenhe',
                'na': "Dawnstar Piercer \n2 Black, 1 Cryo \nDeals 2 Physical DMG.",
                'skill': "Spring Spirit Summoning \n3 Cryo \nDeals 2 Cryo DMG, creates 1 Icy Quill.",
                'burst': "Divine Maiden's Deliverance \n3 Cryo, 2 Energy \nDeals 1 Cryo DMG, summons 1 Talisman Spirit.",
                'hi_res_image': '/cards/i_n330048_gcg_high_resolution.webp',
                'card': '/cards/i_n330048.webp',
                'card_selected': '/cards/i_n334048.webp',
                'icon': Shenhe_Icon,
                'element': 'cryo',
                'region': 'liyue',
                'related': 'Icy Quill, Talisman Spirit',
                'flavor': 'The mortal realm briefly gracing, like a wisp of smoke vanishing.',
                'id': '4Y',
                "keyword": "polearm"
            },

            'qiqi': {
                'name': 'Qiqi',
                'na': "Ancient Sword Art \n2 Black, 1 Cryo \nDeals 2 Physical DMG.",
                'skill': "Adeptus Art: Herald of Frost \n3 Cryo \nSummons 1 Herald of Frost.",
                'burst': "Adeptus Art: Preserver of Fortune \n3 Cryo, 3 Energy \nDeals 3 Cryo DMG, creates 1 Fortune-Preserving Talisman.",
                'hi_res_image': '/cards/i_n330052_gcg_high_resolution.webp',
                'card': '/cards/i_n330052.webp',
                'card_selected': '/cards/i_n334052.webp',
                'icon': Qiqi_Icon,
                'element': 'cryo',
                'region': 'liyue',
                'related': 'Herald of Frost, Fortune-Preserving Talisman',
                'flavor': 'Circulating endlessly, life goes on.',
                'id': '6S',
                "keyword": "sword"
            },

            'layla': {
                'name': 'Layla',
                'na': "Sword of the Radiant Path \n2 Black, 1 Cryo \nDeals 2 Physical DMG.",
                'skill': "Nights of Formal Focus \n3 Cryo \nCreates Curtain of Slumber Shield and Shooting Star, and collects 1 Night Star for Shooting Star. (If Shooting Staralready exists, then collect an extra 2 Night Stars)",
                'burst': "Dream of the Star-Stream Shaker \n3 Cryo, 2 Energy\nDeals 3 Cryo DMG, summons 1 Celestial Dreamsphere.",
                'hi_res_image': '/cards/i_n330062_gcg_high_resolution.webp',
                'card': '/cards/i_n330062.webp',
                'card_selected': '/cards/i_n334062.webp',
                'icon': Layla_Icon,
                'element': 'cryo',
                'region': 'sumeru',
                'related': 'Curtain of Slumber Shield, Shooting Star, Celestial Dreamsphere',
                'flavor': "As night falls, the stars swirl and the moon wanders amidst dreams.",
                'id': '7P',
                'keyword': 'sword',
            },
    
            "barbara": {
                "name": "Barbara",
                'na': 'Whisper of Water \n2 Black, 1 Hydro \nDeals 1 Hydro DMG.',
                'skill': "Let the Show Begin♪ \n3 Hydro \nDeals 1 Hydro DMG, summons 1 'Melody Loop'.",
                'burst': "Shining Miracle♪ \n3 Hydro, 3 Energy \nHeals all of your characters for 4 HP.",
                'hi_res_image': '/cards/i_n330025_gcg_high_resolution.webp',
                "card": '/cards/i_n330025.webp',
                "card_selected": '/cards/i_n334025.webp',
                "icon": Barbara_Icon,
                "element": 'hydro',
                "region": 'mondstadt',
                'related': 'Melody Loop',
                "flavor": "Ready to heal hearts and soothe souls at any time.",
                "id": '07',
                "keyword": "catalyst"        
            },
    
            "xingqiu": {
                "name": 'Xingqiu',
                'na': 'Guhua Style \n2 Black, 1 Hydro \nDeals 2 Physical DMG.',
                'skill': "Fatal Rainscreen \n3 Hydro \nDeals 2 Hydro DMG, grants this character 'Hydro Application', creates 1 'Rain Sword'.",
                'burst': "Raincutter \n3 Hydro, 2 Energy \nDeals 2 Hydro DMG, grants this character 'Hydro Application', creates 1 'Rainbow Bladework'.",
                'hi_res_image': '/cards/i_n330004_gcg_high_resolution.webp',
                "card": Xingqiu_Card,
                "card_selected": '/cards/i_n334004.webp',
                "icon": Xingqiu_Icon,
                "element": 'hydro',
                "region": 'liyue',
                'related': 'Rain Sword, Rainbow Bladework',
                "flavor": "“Is it just me, or are the protagonists in novels nowadays all students of some private school or another…”",
                "id": '08',
                "keyword": "sword"        
            },
    
            "mona": {
                "name": "Mona",
                'na': 'Ripple of Fate \n2 Black, 1 Hydro \nDeals 1 Hydro DMG.',
                'skill': "Mirror Reflection of Doom \n3 Hydro \nDeals 1 Hydro DMG, summons 1 'Reflection'.",
                'burst': "Stellaris Phantasm \n3 Hydro, 3 Energy \nDeals 4 Hydro DMG, creates 1 'Illusory Bubble.",
                'special': "Illusory Torrent \n(Passive) \n(Once per Round) When this character switches to another character, this switch is considered a 'Fast Action' instead of a 'Combat Action'.",
                'hi_res_image': '/cards/i_n330005_gcg_high_resolution.webp',
                "card": '/cards/i_n330005.webp',
                "card_selected": '/cards/i_n334005.webp',
                "icon": Mona_Icon,
                "element": 'hydro',
                "region": 'mondstadt',
                'related': 'Reflection, Illusory Bubble',
                "flavor": "Victory or defeat — it has all been written in the stars.",
                "id": '06',
                "keyword": "catalyst"        
            },

            'tartaglia': {
                'name': 'Tartaglia',
                'na': 'Cutting Torent \n2 Black, 1 Hydro \nDeals 2 Physical DMG.',
                'skill': 'Foul Legacy: Raging Tide \n3 Hydro \nSwitches to Melee Stance and deals 2 Hydro DMG, and attach Riptide to the target character.',
                'burst': 'Havoc: Obliteration \n3 Hydro, 3 Energy \nPerform different attacks based on the current state that Tartaglia is in. \nRanged Stance - Flash of Havoc: Deal 5 Hydro DMG, reclaim 2 Energy, and apply Riptide to the target. \nMelee Stance - Light of Obliteration: Deal 7 Hydro DMG.',
                'special': 'Tide Withholder \n(Passive) \nWhen the battle begins, this character gains Ranged Stance. Once the Melee Stance attached to the character ends, reapplys Ranged Stance.',
                'hi_res_image': '/cards/i_n330029_gcg_high_resolution.webp',
                'card': '/cards/i_n330029.webp',
                'card_selected': '/cards/i_n334036.webp',
                'related': 'Melee Stance, Ranged Stance, Riptide',
                'icon': Childe_Icon,
                'element': 'hydro',
                'region': 'fatui',
                'flavor': 'Should this table be considered a battlefield, then may the strongest claim the win.',
                'id': '4Z',
                "keyword": "bow"
            },
    
            "kokomi": {
                "name": "Sangonomiya Kokomi",
                "na": "The Shape of Water\n2 Black, 1 Hydro \nDeals 1 Hydro DMG.",
                "skill": "Kurage's Oath\n3 Hydro \nThis character gains Hydro Application and summons 1 Bake-Kurage.",
                "burst": "Nereid's Ascension\n3 Hydro, 2 Energy\n Deals 2 Hydro DMG. Heal all allied characters for 1 point. This character gains Ceremonial Garment.",
                'hi_res_image': '/cards/i_n330030_gcg_high_resolution.webp',
                "card": "/cards/i_n330030.webp",
                "card_selected": "/cards/i_n334031.webp",
                "icon": Kokomi_Icon,
                "element": 'hydro',
                "region": "inazuma",
                'related': "Bake-Kurage, Ceremonial Garment",
                "flavor": "To survive hardship, you must prepare for hardship.",
                "id": '48',
                "keyword": "catalyst"
            },
    
            "ayato": {
                "name": "Kamisato Ayato",
                "na": "Kamisato Art: Marobashi\n2 Black, 1 Hydro \nDeals 2 Physical DMG.",
                'skill': "Kamisato Art: Kyouka\n3 Hydro \nDeals 2 Hydro DMG. This character gains 'Takimeguri Kanka'.",
                'burst': "Kamisato Art: Suiyuu\n3 Hydro, 2 Energy \nDeals 1 Hydro DMG, summons 1 'Garden of Purity'.",
                "hi_res_image": '/cards/i_n330031_gcg_high_resolution.webp',
                "card": '/cards/i_n330031.webp',
                "card_selected": '/cards/i_n334033.webp',
                'related': 'Takimeguri Kanka, Garden of Purity',
                "icon": Ayato_Icon,
                "element": 'hydro',
                "region": "inazuma",
                "flavor": "The divinely-blessed cypress sprouts new leaves.",
                "id": '4F',
                "keyword": "sword"
            },

            "candace": {
                "name": "Candace",
                "na": "Gleaming Spear - Guardian Stance\n2 Black, 1 Hydro \nDeals 2 Physical DMG.",
                'skill': "Sacred Rite: Heron's Sanctum\n3 Hydro \nAttaches a Heron Shield to character and prepares Heron Strike.",
                'burst': "Sacred Rite: Wagtail's Tide\n3 Hydro, 2 Energy \nDeals 2 Hydro DMG and creates 1 Prayer of the Crimson Crown.",
                "special": "Heron Strike\n(Prepare for 1 turn)\nDeals 3 Hydro DMG.",
                "hi_res_image": '/cards/i_n330049_gcg_high_resolution.webp',
                "card": '/cards/i_n330049.webp',
                "card_selected": '/cards/i_n334049.webp',
                'related': 'Heron Shield, Prayer of the Crimson Crown',
                "icon": Candace_Icon,
                "element": 'hydro',
                "region": "sumeru",
                "flavor": "The crimson sand flows, an oath to defend.",
                "id": '6G',
                "keyword": "polearm "
            },

            "nilou": {
                "name": "Nilou",
                "na": "Dance of Samser\n2 Black, 1 Hydro \nDeals 2 Physical DMG.",
                'skill': "Dance of Haftkarsvar\n3 Hydro \nDeals 3 Hydro DMG, if the party includes Hydro Characters and Dendro Characters and characters from no other Elements, create 1 Golden Chalice's Bounty.",
                'burst': "Dance of Abzendegi: Distant Dreams, Listening Spring\n3 Hydro, 2 Energy \nDeals 2 Hydro DMG. The target character receives Lingering Aeon.",
                "hi_res_image": '/cards/i_n330057_gcg_high_resolution.webp',
                "card": '/cards/i_n330057.webp',
                "card_selected": '/cards/i_n334057.webp',
                'related': 'Golden Chalice\'s Bounty, Lingering Aeon',
                "icon": Nilou_Icon,
                "element": 'hydro',
                "region": "sumeru",
                "flavor": "Steps floating like lotus petals, emerging from an intoxicating dream.",
                "id": '7E',
                "keyword": "sword"
            },

            'yelan': {
                'name': 'Yelan',
                'na': "Stealthy Bowshot \n2 Black, 1 Hydro \nDeals 2 Physical DMG.",
                'skill': "Lingering Lifeline \n3 Hydro \nDeals 3 Hydro DMG, adds 2 stacks of Breakthrough to this character.",
                'burst': "Depth-Clarion Dice \n3 Hydro, 3 Energy\nDeals 1 Hydro DMG, creates 1 Exquisite Throw.",
                'special': "Breakthrough \n(Passive) \nWhen the battle begins, this character gains Breakthrough.",
                'hi_res_image': '/cards/i_n330063_gcg_high_resolution.webp',
                'card': '/cards/i_n330063.webp',
                'card_selected': '/cards/i_n334063.webp',
                'icon': Yelan_Icon,
                'element': 'hydro',
                'region': 'liyue',
                'related': 'Exquisite Throw, Breakthrough',
                'flavor': "The world is vast and infinite, the solitary one comes and goes as she pleases.",
                'id': '7Q',
                'keyword': 'bow',
            },
    
            "diluc": {
                "name": "Diluc",
                'na': 'Tempered Sword \n2 Black, 1 Pyro \nDeals 2 Physical DMG.',
                'skill': 'Searing Onslaught \n3 Pyro \nDeals 3 Pyro DMG. For the third use of this Skill each Round, deals +2 DMG.',
                'burst': "Dawn \n4 Pyro, 3 Energy \nDeals 8 Pyro DMG. This character gains 'Pyro Infusion'.",
                'hi_res_image': '/cards/i_n330006_gcg_high_resolution.webp',
                "card": '/cards/i_n330006.webp',
                "card_selected": '/cards/i_n334006.webp',
                "icon": Diluc_Icon,
                "element": 'pyro',
                "region": 'mondstadt',
                'related': "Diluc's Pyro Infusion",
                "flavor": "His heart is his greatest foe.",
                "id": '0B',
                "keyword": "claymore"
            },
    
            "xiangling": {
                "name": "Xiangling",
                'na': 'Dough-Fu \n2 Black, 1 Pyro \nDeals 2 Physical DMG.',
                'skill': "Guoba Attack \n3 Pyro \nSummons 1 'Guoba'.",
                'burst': "Pyronado \n4 Pyro, 2 Energy \nDeals 3 Pyro DMG, creates 1 'Pyronado'.",
                'hi_res_image': '/cards/i_n330007_gcg_high_resolution.webp',
                "card": '/cards/i_n330007.webp',
                "card_selected": '/cards/i_n334007.webp',
                "icon": Xiangling_Icon,
                "element": 'pyro',
                "region": 'liyue',
                'related': 'Guoba, Pyronado',
                "flavor": "As a chef, she is practically omnipotent.",
                "id": '0D',
                "keyword": "polearm"        
            },
    
            "bennett": {
                "name": "Bennett",
                'na': 'Strike of Fortune \n2 Black, 1 Pyro \nDeals 2 Physical DMG.',
                'skill': 'Passion Overload \n3 Pyro \nDeals 3 Pyro DMG.',
                'burst': "Fantastic Voyage \n4 Pyro, 2 Energy \nDeals 2 Pyro DMG, creates 1 'Inspiration Field'.",
                'hi_res_image': '/cards/i_n330008_gcg_high_resolution.webp',
                "card": '/cards/i_n330008.webp',
                "card_selected": '/cards/i_n334008.webp',
                "icon": Bennett_Icon,
                "element": 'pyro',
                "region": 'mondstadt',
                'related': 'Inspiration Field',
                "flavor": "Once you know that you will certainly lose, then you must certainly know the way to win.",
                "id": '0C',
                "keyword": "sword"        
            },
    
            "amber": {
                'name': 'Amber',
                'na': 'Sharpshooter \n2 Black, 1 Pyro \nDeals 2 Physical DMG.',
                'skill': 'Explosive Puppet \n3 Pyro \nSummons 1 Baron Bunny.',
                'burst': 'Fiery Rain \n3 Pyro, 2 Energy \nDeals 2 Pyro DMG, deals 2 Piercing DMG to all opposing characters on standby.',
                'hi_res_image': '/cards/i_n330009_gcg_high_resolution.webp',
                'card': '/cards/i_n330009.webp',
                "card_selected": '/cards/i_n334009.webp',
                "icon": Amber_Icon,
                "element": 'pyro',
                'region': 'mondstadt',
                'related': 'Baron Bunny',
                'flavor': 'If you want to be a great player...\nFirst, you have to have the courage to sit down and play.',
                'id': '4N',
                "keyword": "bow"
            },
    
            "yoimiya": {
                "name": 'Yoimiya',
                'na': 'Firework Flare-Up \n2 Black, 1 Pyro \nDeals 2 Physical DMG.',
                'skill': "Niwabi Fire-Dance \n1 Pyro \nThis character gains 'Niwabi Enshou'. (This Skill does not grant Energy)",
                'burst': "Ryuukin Saxifrage \n3 Pyro, 3 Energy \nDeals 3 Pyro DMG, creates 1 'Aurous Blaze'.",
                'hi_res_image': '/cards/i_n330010_gcg_high_resolution.webp',
                "card": '/cards/i_n330010.webp',
                "card_selected": '/cards/i_n334010.webp',
                "icon": Yoimiya_Icon,
                "element": 'pyro',
                "region": 'inazuma',
                'related': 'Niwabi Enshou, Aurous Blaze',
                "flavor": "Captain and Vanguard of Team Naganohara for the 11th Hanamizaka Street Invitational.",
                "id": '0E',
                "keyword": "bow"        
            },
    
            "klee": {
                "name": "Klee",
                "na": 'Kaboom!\n2 Black, 1 Pyro \nDeals 1 Pyro DMG.',
                "skill": "Jumpy Dumpty\n3 Pyro \nDeals 3 Pyro DMG. This character gains 'Explosive Spark'.",
                "burst": "Sparks'n'Splash\n3 Pyro, 3 Energy\nDeals 3 Pyro DMG, creates 1 'Sparks'n'Splash' at the opponent's play area.",
                'hi_res_image': '/cards/i_n330032_gcg_high_resolution.webp',
                "card": '/cards/i_n330032.webp',
                "card_selected": '/cards/i_n334029.webp',
                "icon": Klee_Icon,
                "element": 'pyro',
                "region": 'mondstadt',
                'related': "Explosive Spark, Sparks'n'Splash",
                "flavor": "Every card you draw may bring an “explosive surprise.”",
                "id": '43',
                "keyword": "catalyst"
            },
    
            "hutao": {
                'name': "Hu Tao",
                'na': "Secret Spear of Wangsheng \n2 Black, 1 Pyro \nDeals 2 Physical DMG.",
                'skill': "Guide to Afterlife \n2 Pyro \nAttach Paramita Papilio to this character.",
                'burst': "Spirit Soother \n3 Pyro, 3 Energy \nDeals 4 Pyro DMG, heals herself for 2 HP. If this character's HP is no more than 6, +1 DMG dealt and Healing.",
                'hi_res_image': '/cards/i_n330033_gcg_high_resolution.webp',
                'card': '/cards/i_n330033.webp',
                'card_selected': '/cards/i_n334037.webp',
                'icon': Hutao_Icon,
                'element': 'pyro',
                'region': "liyue",
                'related': 'Paramita Papilio, Blood Blossom',
                'flavor': '\"Send one, send \'em all!\"',
                'id': '4O',
                "keyword": "polearm"
            },

            "yanfei": {
                'name': "Yanfei",
                'na': "Seal of Approval \n2 Black, 1 Pyro \nDeals 1 Pyro DMG.",
                'skill': "Signed Edict \n3 Pyro \nDeals 3 Pyro DMG and attach Scarlet Seal to your character.",
                'burst': "Done Deal \n3 Pyro, 2 Energy \nDeals 3 Pyro DMG, attach Scarlet Seal and Brilliance to your character.",
                'hi_res_image': '/cards/i_n330050_gcg_high_resolution.webp',
                'card': '/cards/i_n330050.webp',
                'card_selected': '/cards/i_n334050.webp',
                'icon': Yanfei_Icon,
                'element': 'pyro',
                'region': "liyue",
                'related': 'Scarlet Seal, Brilliance',
                'flavor': 'One who fails to revise the classics is liable to fall foul of the law.',
                'id': '6H',
                "keyword": "catalyst"
            },

            "dehya": {
                'name': "Dehya",
                'na': "Sandstorm Assault \n2 Black, 1 Pyro \nDeals 2 Physical DMG.",
                'skill': "Molten Inferno \n3 Pyro \nSummon Fiery Sanctum Field. If Fiery Sanctum Field already exists, then first deal 1 Pyro DMG.",
                'burst': "Leonine Bite\n4 Pyro, 2 Energy \nDeals 3 Pyro DMG, then performs \"Prepare Skill\" for Incineration Drive.",
                'special': "Incineration Drive\n(Prepare for 1 turn)\nDeals 3 Pyro DMG.",
                'hi_res_image': '/cards/i_n330055_gcg_high_resolution.webp',
                'card': '/cards/i_n330055.webp',
                'card_selected': '/cards/i_n334054.webp',
                'icon': Dehya_Icon,
                'element': 'pyro',
                'region': "sumeru",
                'related': 'Fiery Sanctum Field',
                'flavor': 'The eyes of the vulture, the soul of the lion, the free daughter of the desert.',
                'id': '73',
                "keyword": "claymore"
            },

            'lyney': { 
                'name': 'Lyney', 
                'na': "Card Force Translocation \n2 Black, 1 Pyro \nDeals 2 Physical DMG.", 
                'skill': "Bewildering Lights \n3 Pyro \nDeals 3 Pyro DMG.", 
                'burst': "Wondrous Trick: Miracle Parade\n3 Pyro, 2 Energy\nDeals 3 Pyro DMG, summons 1 Grin-Malkin Hat, and gains 1 stack of Prop Surplus.", 
                'special': "Normal Attack: Prop Arrow \n3 Pyro \nDeals 2 Pyro DMG, summons a Grin-Malkin Hat, and gains 1 stack of Prop Surplus. \n\nIf this character has at least 6 HP, then they deal 1 Piercing DMG to themself.", 
                'hi_res_image': '/cards/i_n330064_gcg_high_resolution.webp', 
                'card': '/cards/i_n330064.webp', 
                'card_selected': '/cards/i_n334064.webp', 
                'icon': Lyney_Icon, 
                'element': 'pyro',
                'region': 'fatui',
                'related': 'Prop Surplus, Grin-Malkin Hat', 
                'flavor': "Those flowers in the mirror... who are they for?", 
                'id': '7R', 
                'keyword': 'bow',
            },

            'thoma': { 
                'name': 'Thoma', 
                'na': "Swiftshatter Spear\n2 Black, 1 Pyro \nDeals 2 Physical DMG.", 
                'skill': "Blazing Blessing \n3 Pyro \nDeals 2 Pyro DMG, creates 1 Blazing Barrier.", 
                'burst': "Crimson Ooyoroi\n3 Pyro, 2 Energy\nDeals 2 Pyro DMG, creates 1 Blazing Barrier and Scorching Ooyoroi.", 
                'hi_res_image': '/cards/i_n330071_gcg_high_resolution.webp', 
                'card': '/cards/i_n330071.webp', 
                'card_selected': '/cards/i_n334071.webp', 
                'icon': Thoma_Icon, 
                'element': 'pyro',
                'region': 'inazuma',
                'related': 'Blazing Barrier, Scorching Ooyoroi', 
                'flavor': "A protector from abroad, loyal to the end.", 
                'id': '8V', 
                'keyword': 'polearm',
            },
    
            "fischl": {
                "name": "Fischl",
                'na': 'Bolts of Downfall \n2 Black, 1 Electro \nDeals 2 Physical DMG.',
                'skill': "Nightrider \n3 Electro \nDeals 1 Electro DMG, summons 1 'Oz'.",
                'burst': "Midnight Phantasmagoria \n3 Electro, 3 Energy \nDeals 4 Electro DMG, deals 2 Piercing DMG to all opposing characters on standby.",
                'hi_res_image': '/cards/i_n330011_gcg_high_resolution.webp',
                "card": '/cards/i_n330011.webp',
                "card_selected": '/cards/i_n334011.webp',
                "icon": Fischl_Icon,
                "element": 'electro',
                "region": 'mondstadt',
                'related': 'Oz',
                "flavor": "“Oz, mine familiar, spread thine wings and weave for me a new fate in the gloom of this night!”\n“Mein Fräulein, you cannot expect me to fetch you a replacement card…”",
                "id": '0G',
                "keyword": "bow"        
            },
    
            "razor": {
                "name": "Razor",
                'na': 'Steel Fang \n2 Black, 1 Electro \nDeals 2 Physical DMG.',
                'skill': 'Claw and Thunder \n3 Electro \nDeals 3 Electro DMG.',
                'burst': "Lightning Fang \n3 Electro, 2 Energy \nDeals 3 Electro DMG. This character gains 'The Wolf Within'.",
                'hi_res_image': '/cards/i_n330012_gcg_high_resolution.webp',
                "card": '/cards/i_n330012.webp',
                "card_selected": '/cards/i_n334012.webp',
                "icon": Razor_Icon,
                "element": 'electro',
                "region": 'mondstadt',
                'related': 'The Wolf Within',
                "flavor": "“Cards, hard.”\n“But… friends…”",
                "id": '0H',
                "keyword": "claymore"        
            },
    
            "keqing": {
                "name": "Keqing",
                'na': 'Yunlai Swordsmanship \n2 Black, 1 Electro \nDeals 2 Physical DMG.',
                'skill': "Stellar Restoration \n3 Electro \nDeals 3 Electro DMG, create 1 'Lightning Stilleto'.",
                'burst': "Starward Sword \n4 Electro, 3 Energy \nDeals 4 Electro DMG, deals 3 Piercing DMG to all opposing characters on standby.",
                'hi_res_image': '/cards/i_n330013_gcg_high_resolution.webp',
                "card": '/cards/i_n330013.webp',
                "card_selected": '/cards/i_n334013.webp',
                "icon": Keqing_Icon,
                "element": 'electro',
                "region": 'liyue',
                'related': "Lightning Stilleto, Keqing's Electro Infusion",
                "flavor": "She can build decks heretofore not conceived and win battles in which victory is unthinkable.",
                "id": '0I',
                "keyword": "sword"        
            },
    
            "cyno": {
                "name": "Cyno",
                'na': 'Invoker’s Spear\n2 Black, 1 Electro \nDeals 2 Physical DMG.',
                'skill': 'Secret Rite: Chasmic Soulfarer\n3 Electro \nDeals 3 Electro DMG.',
                'burst': "Sacred Rite: Wolf’s Swiftness\n4 Electro, 2 Energy \nDeals 4 Electro DMG. Pactsworn Pathclearer's Indwelling Level +2.",
                'special': "Lawful Enforcer \n(Passive) \nWhen the battle begins, this character gains 'Pactsworn Pathclearer'.",
                'hi_res_image': '/cards/i_n330024_gcg_high_resolution.webp',
                "card": '/cards/i_n330024.webp',
                "card_selected": '/cards/i_n334024.webp',
                "icon": Cyno_Icon,
                "element": 'electro',
                "region": 'sumeru',
                'related': 'Pactsworn Pathclearer',
                "flavor": "These card covers bear the weight of the General Mahamatra’s incomparable passion.",
                "id": '0J',
                "keyword": "polearm"        
            },
    
            "beidou": {
                "name": "Beidou",
                "na": 'Oceanborne\n2 Black, 1 Electro \nDeals 2 Physical DMG.',
                "skill": "Tidecaller\n3 Electro \nThis character gains 'Tidecaller: Surf Embrace'. Prepare Skill: Wavestrider.",
                "burst": "Stormbreaker\n3 Electro, 3 Energy\nDeals 2 Electro DMG, creates 1 'Thunderbeast's Targe'.",
                "special": "Wavestrider\n(Prepare for 1 turn)\nDeal 3 Electro DMG.",
                'hi_res_image': '/cards/i_n330034_gcg_high_resolution.webp',
                "card": '/cards/i_n330034.webp',
                "card_selected": '/cards/i_n334028.webp',
                "icon": Beidou_Icon,
                "element": 'electro',
                "region": 'liyue',
                'related': "Tidecaller: Surf Embrace, Thunderbeast's Targe",
                "flavor": "“Remember this day, you almost won money from the Captain of the Crux.”",
                "id": '44',
                "keyword": "claymore"
            },
    
            "sara": {
                "name": "Kujou Sara",
                "na": 'Tengu Bowmanship\n2 Black, 1 Electro \nDeals 2 Phyiscal DMG.',
                "skill": "Tengu Stormcall\n3 Electro \nDeals 1 Electro DMG, summons 1 Tengu Jurrai: Ambush.",
                "burst": "Subjugation: Koukou Sendou \n4 Electro, 2 Energy \n Deals 1 Electro DMG, summons 1 Tenguu Jurrai: Stormcluser.",
                'hi_res_image': "/cards/i_n330035_gcg_high_resolution.webp",
                "card": "/cards/i_n330035.webp",
                "card_selected": "/cards/i_n334032.webp",
                "icon": Sara_Icon,
                "element": 'electro',
                "region": "inazuma",
                'related': "Tengu Jurrai: Ambush, Tengu Jurrai: Stormcluster, Crowfeather Cover",
                "flavor": "“This is an act of righteousness.”",
                "id": '47',
                "keyword": "bow"
            },
    
            "raiden": {
                'name': "Raiden Shogun",
                'na': "Origin \n2 Black, 1 Electro \nDeals 2 Physical DMG.",
                'skill': "Transcendence: Baleful Omen \n3 Electro \nSummons 1 Eye of Stormy Judgment.",
                'burst': "Secret Art: Musou Shinsetsu \n4 Electro, 2 Energy \nDeals 3 Electro DMG. All of your other characters gain 2 Energy.",
                'special': "Chakra Desiderata \n(Passive) \nWhen the battle begins, this character gains Chakra Desiderata.",
                'hi_res_image': '/cards/i_n330036_gcg_high_resolution.webp',
                'card': '/cards/i_n330036.webp',
                'card_selected': "/cards/i_n334038.webp",
                'icon': Raiden_Icon,
                'element': 'electro',
                'region': 'inazuma',
                'related': "Eye of Stormy Judgement, Chakra Desiderata",
                'flavor': 'The tranquil thunder shall scatter this world most ephemeral.',
                'id': '4P',
                "keyword": "polearm broken"
            },
    
            "yae": {
                'name': 'Yae Miko',
                'na': "Spiritfox Sin-Eater \n2 Black, 1 Electro \nDeals 1 Electro DMG.",
                'skill': "Yakan Evocation: Sesshou Sakura \n3 Electro \nSummons 1 Sesshou Sakura.",
                'burst': "Great Secret Art: Tenko Kenshin \n3 Electro, 2 Energy \nDeals 4 Electro DMG. If your side of the field has any Sesshou Sakura, destroy them and create Tenko Thunderbolts.",
                'hi_res_image': '/cards/i_n330037_gcg_high_resolution.webp',
                'card': '/cards/i_n330037.webp',
                'card_selected': "/cards/i_n334039.webp",
                'icon': Yae_Icon,
                'element': 'electro',
                'region': 'inazuma',
                'related': 'Sesshou Sakura, Tenko Thunderbolts',
                'flavor': 'The wise and beautiful Yae Miko.',
                'id': '4Q',
                "keyword": "catalyst"
            },

            "lisa": {
                'name': 'Lisa',
                'na': "Lightning Touch\n2 Black, 1 Electro \nDeals 1 Electro DMG. If this Skill is a Charged Attack, attach Conductive to the opponent's active character.",
                'skill': "Violet Arc\n3 Electro \nDeals 2 Electro DMG. If Conductive is not attached to the opponent's active character, Conductive will be attached.",
                'burst': "Lightning Rose\n3 Electro, 2 Energy \nDeals 2 Electro DMG, summons Lightning Rose.",
                'hi_res_image': '/cards/i_n330053_gcg_high_resolution.webp',
                'card': '/cards/i_n330053.webp',
                'card_selected': "/cards/i_n334053.webp",
                'icon': Lisa_Icon,
                'element': 'electro',
                'region': 'mond',
                'related': 'Conductive, Lightning Rose',
                'flavor': 'Pursuing the arcane mysteries of magic, and waiting quietly for an encounter with truth.',
                'id': '6T',
                "keyword": "catalyst"
            },

            "dori": {
                'name': 'Dori',
                'na': "Lightning Touch\n2 Black, 1 Electro \nDeals 1 Electro DMG. If this Skill is a Charged Attack, attach Conductive to the opponent's active character.",
                'skill': "Violet Arc\n3 Electro \nDeals 2 Electro DMG. If Conductive is not attached to the opponent's active character, Conductive will be attached.",
                'burst': "Lightning Rose\n3 Electro, 2 Energy \nDeals 2 Electro DMG, summons Lightning Rose.",
                'hi_res_image': '/cards/i_n330058_gcg_high_resolution.webp',
                'card': '/cards/i_n330058.webp',
                'card_selected': "/cards/i_n334058.webp",
                'icon': Dori_Icon,
                'element': 'electro',
                'region': 'sumeru',
                'related': 'Conductive, Lightning Rose',
                'flavor': 'Pursuing the arcane mysteries of magic, and waiting quietly for an encounter with truth.',
                'id': '7F',
                "keyword": "claymore"
            },
    
            "sucrose": {
                "name": "Sucrose",
                'na': 'Wind Spirit Creation \n2 Black, 1 Anemo \nDeals 1 Anemo DMG.',
                'skill': 'Astable Anemohypostasis Creation – 6308 \n3 Anemo \nDeals 3 Anemo DMG, the target is forcibly switched to the previous character.',
                'burst': "Forbidden Creation – Isomer 75 / Type II \n3 Anemo, 2 Energy \nDeals 1 Anemo DMG, summons 1 'Large Wind Spirit.'",
                'hi_res_image': '/cards/i_n330014_gcg_high_resolution.webp',
                "card": '/cards/i_n330014.webp',
                "card_selected": '/cards/i_n334014.webp',
                "icon": Sucrose_Icon,
                "element": 'anemo',
                "region": 'mondstadt',
                'related': 'Large Wind Spirit',
                "flavor": "“You can’t rate the strength of an as-yet untested deck!”",
                "id": '0K',
                "keyword": "catalyst"        
            },
    
            "jean": {
                "name": "Jean",
                'na': 'Favonius Bladework \n2 Black, 1 Anemo \nDeals 2 Physical DMG.',
                'skill': 'Gale Blade \n3 Anemo \nDeals 3 Anemo DMG, the target is forcibly switched to the next character.',
                'burst': "Dandelion Breeze \n4 Anemo, 3 Energy \nHeals all your characters for 2 HP, summons 1 'Dandelion Field'.",
                'hi_res_image': '/cards/i_n330015_gcg_high_resolution.webp',
                "card": '/cards/i_n330015.webp',
                "card_selected": '/cards/i_n334015.webp',
                "icon": Jean_Icon,
                "element": 'anemo',
                "region": 'mondstadt',
                'related': 'Dandelion Field',
                "flavor": "Never believes that she has done well enough — not until final victory is hers, anyway.",
                "id": '0L',
                "keyword": "sword"        
            },
    
            "venti": {
                'name': "Venti",
                'na': "Divine Marksmanship \n2 Black, 1 Anemo \nDeals 2 Physical DMG.",
                'skill': "Skyward Sonnet \n3 Anemo \nDeals 2 Anemo DMG, creates 1 Stormzone.",
                'burst': "Wind's Grand Ode \n3 Anemo, 2 Energy \nDeals 2 Anemo DMG, summons 1 Stormeye.",
                'hi_res_image': '/cards/i_n330038_gcg_high_resolution.webp',
                'card': '/cards/i_n330038.webp',
                'card_selected': '/cards/i_n334040.webp',
                'icon': Venti_Icon,
                'element': 'anemo',
                'region': 'mondstadt',
                'related': 'Stormzone, Stormeye',
                'flavor': '"As the four seasons in turn shall say their piece, so the four winds too shall never cease. \n"Of course, to look at it differently, I am the one who should be credited here, and not they."\nCredits should be given where credits belong — if not for the bard who pens the song, then who shall ensure that these tales are passed on!?"',
                'id': '4R',
                "keyword": "bow"
            },
    
            "xiao": {
                'name': "Xiao",
                'na': "Whirlwind Thrust \n2 Black, 1 Anemo \nDeals 2 Physical DMG.",
                'skill': "Lemniscatic Wind Cycling \n3 Anemo \nDeals 3 Anemo DMG.",
                'burst': "Bane of All Evil \n3 Anemo, 2 Energy \nDeals 4 Anemo DMG. This character gains Yaksha's Mask.",
                'hi_res_image': '/cards/i_n330039_gcg_high_resolution.webp',
                'card': '/cards/i_n330039.webp',
                'card_selected': '/cards/i_n334041.webp',
                'icon': Xiao_Icon,
                'element': 'anemo',
                'region': 'liyue',
                'related': "Yaksha's Mask",
                'flavor': 'The Vigilant Yaksha, the bane of all evil',
                'id': '4S',
                "keyword": "polearm"
            },

            "kazuha": {
                'name': "Kaedehara Kazuha",
                'na': "Garyuu Bladework \n2 Black, 1 Anemo \nDeals 2 Physical DMG.",
                'skill': "Chihayaburu \n3 Anemo \nDeals 3 Anemo DMG, attach Midare Ranzan to your character. If this skill triggers Swirl, Midare Ranzan is converted to the Swirled Element. After the Skill DMG is finalized: Your team switches to the next character.",
                'burst': "Kazuha Slash \n3 Anemo, 2 Energy \nDeals 3 Anemo DMG and summons Autumn Whirlwind.",
                'hi_res_image': '/cards/i_n330051_gcg_high_resolution.webp',
                'card': '/cards/i_n330051.webp',
                'card_selected': '/cards/i_n334051.webp',
                'icon': Kazuha_Icon,
                'element': 'anemo',
                'region': 'inazuma',
                'related': "Midare Ranzan, Autumn Whirlwind",
                'flavor': 'Flowers and birds are a dear pleasure to one winding under the moonlight.',
                'id': '6I',
                "keyword": "sword"
            },

            "wanderer": {
                'name': "Wanderer",
                'na': "Garyuu Bladework \n2 Black, 1 Anemo \nDeals 1 Anemo DMG.",
                'skill': "Hanega: Song of the Wind\n3 Anemo \nDeals 2 Anemo DMG. This character gains Windfavored.",
                'burst': "Kyougen: Five Ceremonial Plays\n3 Anemo, 3 Energy \nDeals 7 Anemo DMG. If the character has Windfavored attached, then remove it and increase DMG by 1.",
                'hi_res_image': '/cards/i_n330054_gcg_high_resolution.webp',
                'card': '/cards/i_n330054.webp',
                'card_selected': '/cards/i_n334055.webp',
                'icon': Wanderer_Icon,
                'element': 'anemo',
                'region': 'sumeru',
                'related': "Windfavored",
                'flavor': 'Tribulations Uncounted, Trials Unknowable.',
                'id': '72',
                "keyword": "catalyst"
            },

            'lynette': {
                'name': 'Lynette',
                'na': "Rapid Ritesword \n2 Black, 1 Anemo \nDeals 2 Physical DMG.",
                'skill': "Enigmatic Feint \n3 Anemo \nDeals 3 Anemo DMG. The first time this Skill is used this Round, heal the character for 2 HP if they have no more than 8 HP, but apply Overawing Assault to said character.",
                'burst': "Magic Trick: Astonishing Shift \n3 Anemo, 2 Energy\nDeals 2 Anemo DMG, summons 1 Bogglecat Box.",
                'hi_res_image': '/cards/i_n330065_gcg_high_resolution.webp',
                'card': '/cards/i_n330065.webp',
                'card_selected': '/cards/i_n334065.webp',
                'icon': Lynette_Icon,
                'element': 'anemo',
                'region': 'fatui',
                'related': 'Overawing Assault, Bogglecat Box',
                'flavor': "The firmament glimpsed in a reflected moon.",
                'id': '7S',
                'keyword': 'sword',
            },

            'sayu': {
                'name': 'Sayu',
                'na': "Shuumatsuban Ninja Blade \n2 Black, 1 Anemo \nDeals 2 Physical DMG.",
                'skill': "Yoohoo Art: Fuuin Dash\n3 Anemo \nDeals 1 Anemo DMG, and this character prepares Fuufuu Whirlwind Kick. \n\nIf this usage of the skill triggers Swirl, then Fuufuu Whirlwind Kick is converted to DMG of the Swirled Element.",
                'burst': "Yoohoo Art: Mujina Flurry\n3 Anemo, 2 Energy\nDeals 1 Anemo DMG, summons 1 Muji-Muji Daruma.",
                'special': "Fuufuu Whirlwind Kick\n(Prepare for 1 turn)\nDeals 2 Anemo DMG.",
                'hi_res_image': '/cards/i_n330072_gcg_high_resolution.webp',
                'card': '/cards/i_n330072.webp',
                'card_selected': '/cards/i_n334072.webp',
                'icon': Sayu_Icon,
                'element': 'anemo',
                'region': 'inazuma',
                'related': 'Muji-Muji Daruma',
                'flavor': "By your side without a trace, like a character from a dream.",
                'id': '8W',
                'keyword': 'claymore',
            },

            "ningguang": {
                "name": "Ningguang",
                'na': 'Sparkling Scatter \n2 Black, 1 Geo \nDeals 1 Geo DMG.',
                'skill': "Jade Screen \n3 Geo \nDeals 2 Geo DMG, creates 1 'Jade Screen'.",
                'burst': "Starshatter \n3 Geo, 3 Energy \nDeals 6 Geo DMG. If 'Jade Screen' is on the field, deals +2 DMG.",
                'hi_res_image': '/cards/i_n330016_gcg_high_resolution.webp',
                "card": '/cards/i_n330016.webp',
                "card_selected": '/cards/i_n334016.webp',
                "icon": Ningguang_Icon,
                "element": 'geo',
                "region": 'liyue',
                'related': 'Jade Screen',
                "flavor": "The greatest secret she keeps is that she keeps a great many of Liyue’s secrets.",
                "id": '0O',
                "keyword": "catalyst"        
            },
    
            "noelle": {
                "name": "Noelle",
                'na': 'Favonius Bladework – Maid \n2 Black, 1 Geo \nDeals 2 Physical DMG.',
                'skill': "Breastplate \n3 Geo \nDeals 1 Geo DMG, creates 1 'Full Plate'.",
                'burst': "Sweeping Time \n4 Geo, 2 Energy \nDeals 4 Geo DMG. This character gains 'Sweeping Time'.",
                'hi_res_image': '/cards/i_n330017_gcg_high_resolution.webp',
                "card": '/cards/i_n330017.webp',
                "card_selected": '/cards/i_n334017.webp',
                "icon": Noelle_Icon,
                "element": 'geo',
                "region": 'mondstadt',
                'related': 'Full Plate, Sweeping Time',
                "flavor": "You can leave arranging the table to her — really, you can.",
                "id": '0N',
                "keyword": "claymore"        
            },

            "zhongli": {
                'name': "Zhongli",
                'na': "Rain of Stone \n2 Black, 1 Geo \nDeals 2 Physical DMG.",
                'skill': "Dominus Lapidis \n3 Geo \nDeals 1 Geo DMG, summons 1 Stone Stele.",
                'special': "Dominus Lapidis: Striking Stone \n5 Geo \nDeals 3 Geo DMG, summons 1 Stone Stele, creates 1 Jade Shield.",       
                'burst': "Planet Befall \n3 Geo, 3 Energy \nDeals 4 Geo DMG. The target character receives Petrification.",
                'hi_res_image': '/cards/i_n330040_gcg_high_resolution.webp',
                'card': '/cards/i_n330040.webp',
                'card_selected': '/cards/i_n334042.webp',
                'icon': Zhongli_Icon,
                'element': 'geo',
                'region': 'liyue',
                'related': 'Stone Stele, Jade Shield, Petrification',
                'flavor': 'A hidden gemstone can illuminate the whole earth, bright and unrivaled as a star.',
                'id': '4T',
                "keyword": "polearm"
            },

            "albedo": {
                "name": "Albedo",
                'na': 'Favonius Bladework - Weiss \n2 Black, 1 Geo \n Deals 2 Physical DMG.',
                'skill': "Abiogenesis: Solar Isotoma \n3 Geo \nSummons Solar Isotoma.",
                'burst': "Rite of Progeniture: Tectonic Tide\n3 Geo, 2 Energy \nDeals 4 Geo DMG. If Solar Isotoma is on the field, deals +2 DMG.",
                'hi_res_image': '/cards/i_n330041_gcg_high_resolution.webp',
                "card": '/cards/i_n330041.webp',
                "card_selected": '/cards/i_n334043.webp',
                "icon": Albedo_Icon,
                "element": 'geo',
                "region": 'mond',
                'related': "Solar Isotoma",
                'flavor': "Nigredo and calx, rubedo and citrinitas.",
                "id": '6R',
                "keyword": "sword"
            },
    
            "itto": {
                "name": "Arataki Itto",
                'na': 'Fight Club Legend \n2 Black, 1 Geo \n Deals 2 Physical DMG.',
                'skill': "Masatsu Zetsugi: Akaushi Burst! \n3 Geo \nDeals 1 Geo DMG. Summons 'Ushi'. This character gains 'Superlative Superstrength'.",
                'burst': "Royal Descent: Behold, Itto the Evil!\n3 Geo, 3 Energy \nDeals 5 Geo DMG. This character gains 'Raging Oni King'.",
                'hi_res_image': '/cards/i_n330042_gcg_high_resolution.webp',
                "card": '/cards/i_n330042.webp',
                "card_selected": '/cards/i_n334034.webp',
                "icon": Itto_Icon,
                "element": 'geo',
                "region": 'inazuma',
                'related': "Ushi, Superlative Superstrength, Raging Oni King",
                'flavor': "Arataki \"The Ultimate TCG Champion\" Itto",
                "id": '4G',
                "keyword": "claymore"
            },

            'gorou': {
                'name': 'Gorou',
                'na': "Ripping Fang Fletching \n2 Black, 1 Geo \nDeals 2 Physical DMG.",
                'skill': "Inuzaka All-Round Defense \n3 Geo \nDeals 2 Geo DMG, creates 1 General's War Banner.",
                'burst': "Juuga: Forward Unto Victory \n3 Geo, 2 Energy\nDeals 2 Geo DMG, creates 1 General's War Banner, summons General's Glory.",
                'hi_res_image': '/cards/i_n330066_gcg_high_resolution.webp',
                'card': '/cards/i_n330066.webp',
                'card_selected': '/cards/i_n334066.webp',
                'icon': Gorou_Icon,
                'element': 'geo',
                'region': 'inazuma',
                'related': "General's War Banner, General's Glory",
                'flavor': "The leader of the pack, leading the soldiers onward!",
                'id': '7T',
                'keyword': 'bow',
            },
    
            "collei": {
                "name": "Collei",
                'na': 'Supplicant’s Bowmanship \n2 Black, 1 Dendro \nDeals 2 Physical DMG.',
                'skill': 'Floral Brush \n3 Dendro \nDeals 3 Dendro DMG.',
                'burst': "Trump-Card Kitty \n3 Dendro, 2 Energy \nDeals 2 Dendro DMG, summons 1 'Cuilein-Anbar.",
                'hi_res_image': '/cards/i_n330018_gcg_high_resolution.webp',
                "card": '/cards/i_n330018.webp',
                "card_selected": '/cards/i_n334018.webp',
                "icon": Collei_Icon,
                "element": 'dendro',
                "region": 'sumeru',
                'related': 'Cuilein-Anbar',
                "flavor": "“‘Shouting the name of your card loudly will increase its power many-fold”… You’ve got to be kidding, right?”",
                "id": '0Q',
                "keyword": "bow"        
            },
    
            "tighnari": {
                "name": "Tighnari",
                "na": "Khanda Barrier-Buster\n2 Black, 1 Dendro \nDeals 2 Physical DMG.",
                "skill": "Vijnana-Phala Mine \n3 Dendro \nDeals 2 Dendro DMG. This character gains 'Vijnana Suffusion'.",
                "burst": "Fashioner's Tanglevine Shaft \n 3 Dendro, 2 Energy \n Deals 4 Dendro DMG, deals 1 Piercing DMG to all opposing characters on standby.",
                'hi_res_image': '/cards/i_n330043_gcg_high_resolution.webp',
                "card": '/cards/i_n330043.webp',
                "card_selected": '/cards/i_n334035.webp',
                "icon": Tighnari_Icon,
                "element": 'dendro',
                "region": 'sumeru',
                'related': 'Vijnana Suffusion, Clusterbloom Arrow',
                "flavor": "From a certain perspective, experience does not hold parity with wisdom.",
                "id": '4H',
                "keyword": "bow"  
            },
    
            "nahida": {
                'name': "Nahida",
                'na': "Akara \n2 Black, 1 Dendro \nDeals 1 Dendro DMG.",
                'skill': "All Schemes to Know \n3 Dendro \nDeals 2 Dendro DMG, applies Seed of Skandha to target character. If the target character already had Seed of Skandha applied to them, then apply Seed of Skandha to all opposing characters instead.",
                'special': "All Schemes to Know: Tathata \n5 Dendro \nDeals 3 Dendro DMG. Applies Seed of Skandha to all opposing characters.",
                'burst': "Illusory Heart \n3 Dendro, 2 Energy \nDeals 4 Dendro DMG, creates 1 Shrine of Maya.",
                'hi_res_image': '/cards/i_n330044_gcg_high_resolution.webp',
                'card': '/cards/i_n330044.webp',
                'card_selected': '/cards/i_n334044.webp',
                'icon': Nahida_Icon,
                'element': 'dendro',
                'region': 'sumeru',
                'related': 'Seed of Skandha, Shrine of Maya',
                'flavor': 'The panacea brings purity, and from the palace depths is spring renewed.',
                'id': '4U',
                "keyword": "catalyst"
            },

            "yaoyao": {
                'name': "Yaoyao",
                'na': "Toss 'N' Turn Spear\n2 Black, 1 Dendro \nDeals 2 Physical DMG.",
                'skill': "Raphanus Sky Cluster \n3 Dendro \nSummons 1 Yuegui: Throwing Mode.",
                'burst': "Moonjade Descent \n4 Dendro, 2 Energy \nDeals 1 Dendro DMG, creates 1 Adeptal Legacy.",
                'hi_res_image': '/cards/i_n330056_gcg_high_resolution.webp',
                'card': '/cards/i_n330056.webp',
                'card_selected': '/cards/i_n334056.webp',
                'icon': Yaoyao_Icon,
                'element': 'dendro',
                'region': 'liyue',
                'related': 'Yuegui: Throwing Mode, Adeptal Legacy',
                'flavor': 'Constitution of jade, adepti bones.',
                'id': '74',
                "keyword": "polearm"
            },

            "baizhu": {
                'name': "Baizhu",
                'na': "Toss 'N' Turn Spear\n2 Black, 1 Dendro \nDeals 2 Physical DMG.",
                'skill': "Raphanus Sky Cluster \n3 Dendro \nSummons 1 Yuegui: Throwing Mode.",
                'burst': "Moonjade Descent \n4 Dendro, 2 Energy \nDeals 1 Dendro DMG, creates 1 Adeptal Legacy.",
                'hi_res_image': '/cards/i_n330059_gcg_high_resolution.webp',
                'card': '/cards/i_n330059.webp',
                'card_selected': '/cards/i_n334059.webp',
                'icon': Baizhu_Icon,
                'element': 'dendro',
                'region': 'liyue',
                'related': 'Yuegui: Throwing Mode, Adeptal Legacy',
                'flavor': 'Constitution of jade, adepti bones.',
                'id': '7G',
                "keyword": "catalyst"
            },

            'alhaitham': {
                'name': 'Alhaitham',
                'na': "Abductive Reasoning \n2 Black, 1 Dendro \nDeals 2 Physical DMG.",
                'skill': "Universality: An Elaboration on Form \n3 Dendro \nDeals 2 Dendro DMG. This character gains Chisel-Light Mirror.",
                'burst': "Particular Field: Fetters of Phenomena \n3 Dendro, 2 Energy\nDeals 4 Dendro DMG, consumes Chisel-Light Mirror, with the DMG bonus based on Chisel-Light Mirror's Duration (Rounds) consumed. \nIf Chisel-Light Mirror Duration (Rounds) consumed is 0/1/2, then apply Chisel-Light Mirror with 3/2/1 Duration (Rounds) to this character.",
                'hi_res_image': '/cards/i_n330067_gcg_high_resolution.webp',
                'card': '/cards/i_n330067.webp',
                'card_selected': '/cards/i_n334067.webp',
                'icon': Alhaitham_Icon,
                'element': 'dendro',
                'region': 'sumeru',
                'related': 'Chisel-Light Mirror',
                'flavor': "Learning, thinking, and taking care of business.",
                'id': '7U',
                'keyword': 'sword',
            },
    
            'cryocicinmage': {
                'name': "Fatui Cryo Cicin Mage",
                'na': "Cicin Icicle \n2 Black, 1 Cryo \nDeals 1 Cryo DMG.",
                'skill': "Misty Summons \n3 Cryo \nDeals 1 Cryo DMG, summons 1 Cryo Cicin.",
                'burst': "Blizzard, Branch, Blossom \n3 Cryo, 3 Energy \nDeals 5 Cryo DMG, grants this character Cryo Application, creates 1 Flowing Cicin Shield.",
                'hi_res_image': '/cards/i_n330045_gcg_high_resolution.webp',
                'card': '/cards/i_n330045.webp',
                'card_selected': '/cards/i_n334045.webp',
                'icon': Cryocicin_Icon,
                'element': 'cryo',
                'region': 'fatui',
                'related': 'Cryo Cicin, Flowing Cicin Shield',
                'flavor': 'And so long as the Mist Grass yet lingers, the Cryo Cicins will not abandon her.',
                'id': '4V',
                "keyword": ""
            },

            'signora': {
                'name': 'La Signora',
                'na': "Frostblade Hailstorm \n2 Black, 1 Cryo \nDeals 1 Cryo DMG.",
                'skill': "Biting Shards \n3 Cryo \nDeals 2 Cryo DMG. The target character receives Sheer Cold.",
                'burst': "Carmine Chrysalis \n3 Cryo, 2 Energy\nDeals 4 Cryo DMG, heals this character for 2 HP. Removes Ice-Sealed Crimson Witch of Embers. This character permanently switches to Crimson Witch of Embers state.",
                'special': "Might of Delusion \n(Passive) \nWhen the battle begins,  this character gains Ice-Sealed Crimson Witch of Embers.",
                'hi_res_image': '/cards/i_n330060_gcg_high_resolution.webp',
                'card': '/cards/i_n330060.webp',
                'card_selected': '/cards/i_n334060.webp',
                'icon': Signora_Icon,
                'element': 'cryo',
                'region': 'fatui',
                'related': 'Blazing Heat, Sheer Cold, Ice-Sealed Crimson Witch of Embers',
                'flavor': "The crimson dawn was reflected in her pupils, and at last, she unfolded her flaming wings and flew towards the light.\n\"But that light is not the dawn, dear Rosalyne. That is a sea of flame that will consume everything.\"\nYet it mattered not, for she knew in her heart that the flames had devoured her long ago.",
                'id': '7V',
                'keyword': '',
            },

            'cryohypo': {
                'name': 'Cryo Hypostasis',
                'na': "Frostblade Hailstorm \n2 Black, 1 Cryo \nDeals 1 Cryo DMG.",
                'skill': "Ice Ring Waltz \n3 Cryo \nDeals 3 Cryo DMG. This character gains Overwhelming Ice.",
                'burst': "Plunging Ice Shards \n3 Cryo, 2 Energy\nDeals 2 Cryo DMG, deals 1 Piercing DMG to all opposing characters on standby, summons 1 Piercing Iceridge.",
                'special': "Cryocrystal Core\n(Passive) \nWhen the battle begins, this character gains Cryocrystal Core.",
                'hi_res_image': '/cards/i_n330073_gcg_high_resolution.webp',
                'card': '/cards/i_n330073.webp',
                'card_selected': '/cards/i_n334073.webp',
                'icon': CryoCube_Icon,
                'element': 'cryo',
                'region': 'monster',
                'related': 'Overwhelming Ice, Piercing Iceridge, Cryocrystal Core',
                'flavor': "Code name: Daleth. A high-purity Cryo entity.\nIt doesn't seem all that good at ball sports...",
                'id': '8X',
                'keyword': '',
            },
    
            "oceanid": {
                "name": "Rhodeia of Loch",
                'na': 'Surge \n2 Black, 1 Hydro \nDeals 1 Hydro DMG.',
                'skill': "Oceanid Mimic Summoning \n3 Hydro \nRandomly summons 1 'Oceanid Mimic' (Prioritizes summoning a different type from preexisting ones).",
                'burst': "Tide and Torrent \n3 Hydro, 3 Energy \nDeals 2 Hydro DMG. For each Summon on your field, deals +2 additional DMG.",
                'special': "Elemental Skill: The Myriad Wilds \n5 Hydro \nRandomly summons 2 'Oceanid Mimics' (Prioritizes summoning different types).",
                'hi_res_image': '/cards/i_n330019_gcg_high_resolution.webp',
                "card": '/cards/i_n330019.webp',
                "card_selected": '/cards/i_n334019.webp',
                "icon": Oceanoid_Icon,
                "element": 'hydro',
                "region": 'monster',
                'related': 'Oceanic Mimic: Squirrel, Oceanic Mimic: Raptor, Oceanic Mimic: Frog',
                "flavor": "“As long as rain falls and rivers flow… water will exist forever… “",
                "id": '09',
                "keyword": ""        
            },
    
            "mirrormaiden": {
                "name": "Mirror Maiden",
                'na': 'Water Ball \n2 Black, 1 Hydro \nDeals 1 Hydro DMG.',
                'skill': "Influx Blast \n3 Hydro \nDeals 2 Hydro DMG. The target character receives 'Refraction'.",
                'burst': "Rippled Reflection \n3 Hydro, 2 Energy \nDeals 5 Hydro DMG.",
                'hi_res_image': '/cards/i_n330026_gcg_high_resolution.webp',
                "card": '/cards/i_n330026.webp',
                "card_selected": '/cards/i_n334026.webp',
                "icon": Mirrormaiden_Icon,
                "element": 'hydro',
                "region": 'fatui',
                'related': 'Refraction',
                "flavor": "All secrets shall be concealed within the mirror of glaring brightness…",
                "id": '0A',
                "keyword": ""        
            },
    
            "pyroagent": {
                "name": "Fatui Pyro Agent",
                'na': 'Thrust \n2 Black, 1 Pyro \nDeals 2 Physical DMG.',
                'skill': "Prowl \n3 Pyro \nDeals 1 Pyro DMG. This character gains 'Stealth'.",
                'burst': "Blade Ablaze \n3 Pyro, 2 Energy \nDeals 5 Pyro DMG.",
                'special': "Stealth Master \n(Passive) \nWhen the battle begins, this character gains 'Stealth'.",
                'hi_res_image': '/cards/i_n330020_gcg_high_resolution.webp',
                "card": '/cards/i_n330020.webp',
                "card_selected": '/cards/i_n334020.webp',
                "icon": Pyroagent_Icon,
                "element": 'pyro',
                "region": 'fatui',
                'related': 'Stealth',
                "flavor": "“There is no running from your debt, be you living or otherwise.”",
                "id": '0F',
                "keyword": ""        
            },
    
            'abysslector': {
                'name': "Abyss Lector: Fathomless Flames",
                'na': "Flame of Salvation \n2 Black, 1 Pyro \nDeals 1 Pyro DMG.",
                'skill': "Searing Precept \n3 Pyro \nDeals 3 Pyro DMG.",
                'burst': "Ominous Star \n4 Pyro, 2 Energy \nDeals 3 Pyro DMG, summons 1 Darkfire Furnace.",
                'special': "Fiery Rebirth \n(Passive) \nWhen the battle begins, this character gains Fiery Rebirth.\n\nNote: This character starts the battle with 6 HP.",
                'hi_res_image': '/cards/i_n330046_gcg_high_resolution.webp',
                'card': '/cards/i_n330046.webp',
                'card_selected': '/cards/i_n334046.webp',
                'icon': Abysslector_Icon,
                'element': 'pyro',
                'region': 'monster',
                'related': 'Fiery Rebirth, Darkfire Furnace',
                'flavor': 'From chapters of canon revealed comes much heeded admonishments.',
                'id': '4W',
                "keyword": ""
            },

            'eremitescorchingloremaster': {
                'name': 'Eremite Scorching Loremaster',
                'na': "Searing Glare \n2 Black, 1 Pyro \nDeals 1 Pyro DMG.",
                'skill': "Blazing Strike \n3 Pyro \nDeals 3 Pyro DMG.",
                'burst': "Spirit of Omen's Awakening: Pyro Scorpion \n3 Pyro, 2 Energy\nDeals 2 Pyro DMG, summons 1 Spirit of Omen: Pyro Scorpion.",
                'special': "Spirit of Omen's Power \n (Passive) \nAfter this character takes DMG: If this character has no greater than 7 HP, they gain 1 Energy. (Once per Match)",
                'hi_res_image': '/cards/i_n330068_gcg_high_resolution.webp',
                'card': '/cards/i_n330068.webp',
                'card_selected': '/cards/i_n334068.webp',
                'icon': PyroEremite_Icon,
                'element': 'pyro',
                'region': 'the eremites',
                'related': 'Spirit of Omen: Pyro Scorpion',
                'flavor': "Those who still remember will never betray the spirit of the sands yet flowing through their veins.",
                'id': '7W',
                'keyword': '',
            },

            "electrohypostasis": {
                'name': "Electro Hypostasis",
                'na': "Electro Crystal Projection \n2 Black, 1 Electro \nDeals 1 Electro DMG.",
                'skill': "Rock-Paper-Scissors Combo \n5 Electro \nDeals 2 Electro DMG and then separately performs \"Prepare Skill\" for Rock-Paper-Scissors Combo: Scissors and Rock-Paper-Scissors Combo: Paper. \n\nRock-Paper-Scissors Combo: Scissors: Deals 2 Electro DMG, then performs \"Prepare Skill\" for Rock-Paper-Scissors Combo: Paper.\n\nRock-Paper-Scissors Combo: Paper: Deals 3 Electro DMG.",
                'burst': "Lightning Lockdown\n3 Electro, 2 Energy \nDeals 2 Electro DMG, summons 1 Chains of Warding Thunder.",
                'special': "Electro Crystal Core\n(Passive) \nWhen the battle begins, this character gains Electro Crystal Core.\n\nNote: This character begins the battle with 8 HP.",
                'special2': "Rock-Paper-Scissors Combo: Scissors: Deals 2 Electro DMG, then Prepare Skill: Rock-Paper-Scissors Combo: Paper.",
                'special3': "Rock-Paper-Scissors Combo: Paper: Deals 3  Electro DMG.",
                'hi_res_image': '/cards/i_n330047_gcg_high_resolution.webp',
                'card': '/cards/i_n330047.webp',
                'card_selected': '/cards/i_n334047.webp',
                'icon': Electrohypostasis_Icon,
                'element': 'electro',
                'region': 'monster',
                'related': 'Electro Crystal Core, Chains of Warding Thunder',
                'flavor': 'A high-level Electro being. Code name: Aleph.\nJust like how one might act in a game of rock paper scissors, Aleph is not one to admit defeat.',
                'id': '4X',
                "keyword": ""
            },

            'thundermanifestation': {
                'name': 'Thunder Manifestation',
                'na': "Thunderous Wingslash \n2 Black, 1 Electro \nDeals 1 Electro DMG.",
                'skill': "Strifeful Lightning \n3 Electro \nDeals 3 Electro DMG to opposing characters affected by Lightning Rod. (If there are no eligible opposing characters, deals DMG to the active character instead).",
                'burst': "Thundering Shackles \n3 Electro, 2 Energy\nDeals 2 Electro DMG, creates 1 Thundering Shackles.",
                'special': "Lightning Probe \n(Passive) \nWhen battle begins, create a Lightning Strike Probe on the opponent's side of the field.",
                'hi_res_image': '/cards/i_n330069_gcg_high_resolution.webp',
                'card': '/cards/i_n330069.webp',
                'card_selected': '/cards/i_n334069.webp',
                'icon': ThunderManifestation_Icon,
                'element': 'electro',
                'region': 'monster',
                'related': 'Lightning Rod, Thundering Shackles, Lightning Strike Probe',
                'flavor': "As long as the grudges of the land do not fade, so will the roaring thunder persist.",
                'id': '7X',
                'keyword': '',
            },

            'seahorse': {
                'name': 'Millennial Pearl Seahorse',
                'na': "Tail Sweep \n2 Black, 1 Electro \nDeals 2 Physical DMG.",
                'skill': "Swirling School of Fish\n3 Electro \nDeals 3 Electro DMG. Once per Round: If this character has Fontemer Pearl attached, that Usage(s) +1.",
                'burst': "Fontemer Hoarthunder \n3 Electro, 2 Energy\nDeals 1 Electro DMG, attaches Fontemer Pearl to this character, and summons 1 Resonant Coral Orb.",
                'special': "Pearl Armor \n(Passive) \nWhen the battle begins, attach Fontemer Pearl to this character.",
                'hi_res_image': '/cards/i_n330074_gcg_high_resolution.webp',
                'card': '/cards/i_n330074.webp',
                'card_selected': '/cards/i_n334074.webp',
                'icon': Seahorse_Icon,
                'element': 'electro',
                'region': 'monster',
                'related': 'Fontemer Pearl, Resonant Coral Orb',
                'flavor': "One of the two sovereigns standing at the apex of the Fontemer Aberrants. Poets and authors view it as a proud and noble creature, thus bestowing it with its high-flown title.",
                'id': '8Y',
                'keyword': '',
            },
    
            "maguu": {
                "name": 'Maguu Kenki',
                'na': 'Ichimonji\n2 Black, 1 Anemo \nDeals 2 Physical DMG.',
                'skill': "Blustering Blade\n3 Anemo \nSummons 1 'Shadowsword: Lone Gale'.",
                'burst': "False Tengu Sweeper\n3 Anemo, 3 Energy \nDeals 4 Anemo DMG, triggers the effect(s) of all your Shadowsword Summon(s). (Does not consume their Usages)",
                'special': "Elemental Skill: Frosty Assault\n3 Cryo\nSummons 1 'Shadowsword: Galloping Frost'.",
                'hi_res_image': '/cards/i_n330021_gcg_high_resolution.webp',
                "card": '/cards/i_n330021.webp',
                "card_selected": '/cards/i_n334021.webp',
                "icon": Maguu_Icon,
                "element": 'anemo',
                "region": 'monster',
                'related': 'Shadowsword: Lone Gale, Shadowsword: Galloping Frost',
                "flavor": "Even today, it still patrols the place where fate was severed.",
                "id": '0M',
                "keyword": ""        
            },

            'dvalin': {
                'name': 'Dvalin',
                'na': "Lacerating Slash \n2 Black, 1 Anemo \nDeals 2 Physical DMG.",
                'skill': "Tempestuous Barrage \n3 Anemo \nDeals 2 Anemo DMG. The target character receives Total Collapse.",
                'burst': "Caelestinum Finale Termini \n4 Anemo, 2 Energy\nDeals 5 Anemo DMG. Applies Total Collapse to all opposing standby characters.",
                'special': "Elemental Skill: Dvalin's Cleansing \n5 Anemo \nDeals 2 Anemo DMG and then separately performs \"Prepare Skill\" for Perpetual Cleansing and Ultimate Cleansing. \n\nPerpetual Cleansing \n(Prepare for 1 turn) \nDeals 1 Anemo DMG the next opposing character on standby. After this, Prepare Skill: Ultimate Cleansing. (If there are no opposing characters on standby, deals DMG to active character instead) \n\nUltimate Cleansing \n(Prepare for 1 turn) \nDeals 2 Anemo DMG to the previous opposing character on standby. (If there are no opposing characters on standby, deals DMG to the active character instead)",
                'special2': "Perpetual Cleansing \n(Prepare for 1 turn) \nDeals 1 Anemo DMG the next opposing character on standby. After this, Prepare Skill: Ultimate Cleansing. (If there are no opposing characters on standby, deals DMG to active character instead)",
                'special3': "Ultimate Cleansing \n(Prepare for 1 turn) \nDeals 2 Anemo DMG to the previous opposing character on standby. (If there are no opposing characters on standby, deals DMG to the active character instead)",
                'hi_res_image': '/cards/i_n330070_gcg_high_resolution.webp',
                'card': '/cards/i_n330070.webp',
                'card_selected': '/cards/i_n334070.webp',
                'icon': Dvalin_Icon,
                'element': 'anemo',
                'region': 'monster',
                'related': 'Total Collapse',
                'flavor': "\"How wonderful it would have been if you were as I, witnessing your noble, beautiful form as you soared through the blue sky.\n\"Then you would know that this sky and this earth are both things worth fighting for.\"",
                'id': '7Y',
                'keyword': '',
            },
    
            "stonehidelawachurl": {
                "name": "Stonehide Lawachurl",
                'na': 'Plama Lawa \n2 Black, 1 Geo \nDeals 2 Physical DMG.',
                'skill': 'Movo Lawa \n3 Geo \nDeals 3 Physical DMG.',
                'burst': "Upa Shato \n3 Geo, 2 Energy \nDeals 5 Physical DMG.",
                'special': "Infused Stonehide \n(Passive) \nWhen the battle begins, this character gains 'Stonehide' and 'Stone Force'.\n\nNote: This character starts the battle with 8 HP.",
                'hi_res_image': '/cards/i_n330022_gcg_high_resolution.webp',
                "card": '/cards/i_n330022.webp',
                "card_selected": '/cards/i_n334022.webp',
                "icon": Stonehidelawachurl_Icon,
                "element": 'geo',
                "region": 'monster',
                'related': 'Stonehide, Stone Force',
                "flavor": "Go around — the way ahead is the realm of the “king.”",
                "id": '0P',
                "keyword": ""        
            },

            'azhdaha': {
                'name': 'Azhdaha',
                'na': "Sundering Charge \n2 Black, 1 Geo \nDeals 2 Physical DMG.",
                'skill': "Aura of Majesty \n3 Geo \nDeals 3 Geo DMG. If a Crystallize reaction occurs, this character: Absorbs the corresponding element's power. If the character hasn't absorbed an element's power yet, then Stone Facets: Elemental Crystallization will be attached.",
                'burst': "Decimating Rockfall \n3 Geo, 2 Energy\nDeals 4 Geo DMG. DMG +1 for each element previously absorbed.",
                'special': "Stone Facets \n(Passive) \n When the battle begins, this character gains  Stone Facets: Elemental Absorption. \n\nSpecial: Elemental Skill: \nFrostspike Wave / Torrential Rebuke / Blazing Rebuke / Thunderstorm Wave \n3 Cryo / Hydro / Pyro / Electro \nDeals 3 Cryo / Hydro / Pyro / Electro DMG. This character gains Stone Facets: Elemental Crystallization.",
                'hi_res_image': '/cards/i_n330061_gcg_high_resolution.webp',
                'card': '/cards/i_n330061.webp',
                'card_selected': '/cards/i_n334061.webp',
                'icon': Azhdaha_Icon,
                'element': 'geo',
                'region': 'monster',
                'related': 'Stone Facets: Elemental Crystallization, Stone Facets: Elemental Absorption',
                'flavor': "The faint rattling of this dragon lord's shackles and his deep, angry growl echo through the bowels of the mountains like memories of a bygone era.",
                'id': '7Z',
                'keyword': '',
            },
    
            "terrorshroom": {
                "name": "Jadeplume Terrorshroom",
                'na': 'Majestic Dance\n2 Black, 1 Dendro \nDeals 2 Physical DMG.',
                'skill': 'Volatile Spore Cloud\n3 Dendro \nDeals 3 Dendro DMG.',
                'burst': "Feather Spreading \n3 Dendro, 2 Energy \nDeals 4 Dendro DMG, then consumes all 'Radical Vitality' stacks. For each stack consumed, deals +1 DMG.",
                'special': "Radical Vitality \n(Passive) \nWhen the battle begins, this character gains 'Radical Vtality'.",
                'hi_res_image': '/cards/i_n330027_gcg_high_resolution.webp',
                "card": '/cards/i_n330027.webp',
                "card_selected": '/cards/i_n334027.webp',
                "icon": Terrorshroom_Icon,
                "element": 'dendro',
                "region": 'monster',
                'related': 'Radical Vitality',
                "flavor": "If you keep silent and listen closely, you can here the sound of the ruler of the Shroom-Kin inspecting its territory…",
                "id": '0R'        
            },
        },
    
        "actions": {
            "undividedheart": {
                "name": "Undivided Heart",
                "tags": ['modify', 'talent', 'slowly'],
                "image": "/cards/i_n330500.webp",
                "golden_image": "/cards/i_n334500.webp",
                "hi_res_image": "/cards/i_n330500_gcg_high_resolution.webp",
                "cost": '5 Cryo',
                "description": "'Combat Action': When your active character is Ganyu, equip this card.\n\nAfter Ganyu equips this card, immediately use 'Normal Attack: Frostflake Arrow' once.\n\nWhen your Ganyu, who has this card equipped, uses 'Normal Attack: Frostflake Arrow': If this Skill has been used before during this match, the Piercing DMG dealt to all opposing characters on standby is changed to 3.\n\n(You must have Ganyu in your deck to add this card to your deck.)",
                "flavor": "First the arrow strikes, and then it turns to frost.",
                "required": "ganyu",
                "id": '0S'     
            },
    
            "shakennotpurred": {
                "name": "Shaken, Not Purred",
                "tags": ['modify', 'talent', 'slowly'],
                "image": "/cards/i_n330523.webp",
                "golden_image": "/cards/i_n334523.webp",
                "hi_res_image": "/cards/i_n330523_gcg_high_resolution.webp",
                "cost": '3 Cryo',
                "description": "'Combat Action': When your active character is Diona, equip this card.\n\nAfter Diona equips this card, immediately use 'Elemental Skill: Icy Paws' once.\n\nWhen your Diona, who has this card equipped, creates a 'Cat-Claw Shield', its 'Shield' points +1.\n\n(You must have Diona in your deck to add this card to your deck.)",
                "flavor": "Shake and stir till its all evenly mixed… and there! Your refill’s ready!",
                "required": "diona",
                "id": '1E'        
            },
            
            "coldbloodedstrike": {
                "name": "Cold-Blooded Strike",
                "tags": ['modify', 'talent', 'slowly'],
                "image": "/cards/i_n330501.webp",
                "golden_image": "/cards/i_n334501.webp",
                "hi_res_image": "/cards/i_n330501_gcg_high_resolution.webp",
                "cost": '4 Cryo',
                "description": "'Combat Action': When your active character is Kaeya, equip this card.\n\nAfter Kaeya equips this card, immediately use 'Elemental Skill: Frostgnaw' once.\n\nAfter your Kaeya, who has this card equipped, uses 'Elemental Skill: Frostgnaw', he heals himself for 2 HP. (Once per Round)\n\n(You must have Kaeya in your deck to add this card to your deck.)",
                "flavor": "A slightly cold joke.",
                "required": "kaeya",
                "id": '0T'        
            },
            
            "steadybreathing": {
                "name": "Steady Breathing",
                "tags": ['modify', 'talent', 'slowly'],
                "image": "/cards/i_n330502.webp",
                "golden_image": "/cards/i_n334502.webp",
                "hi_res_image": "/cards/i_n330502_gcg_high_resolution.webp",
                "cost": '3 Cryo',
                "description": "'Combat Action': When your active character is Chongyun, equip this card.\n\nAfter Chongyun equips this card, immediately use 'Elemental Skill: Chonghua's Layered Frost' once.\n\nWhen your Chongyun, who has this card equipped, creates a 'Chonghua Frost Field', it will have the following effects: Starting 'Duration (Rounds)' +1, and its effect will cause your Sword, Claymore, and Polearm-wielding characters’ Normal Attacks to deal +1 DMG.\n\n(You must have Chongyun in your deck to add this card to your deck.)",
                "flavor": "Steady breathing makes a steady heart.",
                "required": "chongyun",
                "id": '0U'        
            },
            
            "kantensenmyoublessing": {
                "name": "Kanten Senmyou Blessing",
                "tags": ['modify', 'talent'],
                "image": "/cards/i_n330503.webp",
                "golden_image": "/cards/i_n334503.webp",
                "hi_res_image": "/cards/i_n330503_gcg_high_resolution.webp",
                "cost": '2 Cryo',
                "description": "The 'Cryo Infusion' created by your Kamisato Ayaka, who has this card equipped, allows the character to which it is attached to deal +1 'Cryo DMG'.\n\nWhen you switch to a Kamisato Ayaka who has this card equipped: Spend 1 less Elemental Dice. (Once per Round)\n\n(You must have Kamisato Ayaka in your deck to add this card to your deck.)",
                "flavor": "The heron holds upon the ice on elegant wing.",
                "required": "ayaka",
                "id": '0V'
            },
    
            "wellspringofwarlust": {
                "name": "Wellspring of War-Lust",
                "tags": ['modify', 'talent', 'slowly'],
                "image": "/cards/i_n330528.webp",
                "golden_image": "/cards/i_n334530.webp",
                "hi_res_image": "/cards/i_n330528_gcg_high_resolution.webp",
                "cost": '3 Cryo 2 Energy',
                "description": "'Combat Action': When your active character is Eula, equip this card.\n\nAfter Eula equips this card, immediately use 'Elemental Burst: Glacial Illumination' once.\n\nWhen your Eula, who has this card equipped, uses Icetide Vortex, this will generate 1 more Zeal for Lightfall Sword.\n\n(You must have Eula in your deck to add this card to your deck.)",
                "flavor": "Flood of frost will ensure that vengeance is mine.",
                "required": "eula",
                "id": '4A' 
            },
    
            "mysticalabandon": {
                "name": "Mystical Abandon",
                "tags": ['modify', 'talent', 'slowly'],
                "image": "/cards/i_n330540.webp",
                "golden_image": "/cards/i_n334540.webp",
                "hi_res_image": "/cards/i_n330540_gcg_high_resolution.webp",
                "cost": '3 Cryo',
                "description": "Combat Action: When your active character is Shenhe, equip this card. \n\nAfter Shenhe equips this card, immediately use Spring Spirit Summoning once. \n\nWhen a Icy Quill is created by your Shenhe who has this card equipped, its Usages will not decrease when triggered by your characters' Normal Attacks. (Once per Round) \n\n(You must have Shenhe in your deck to add this card to your deck.)",
                "flavor": 'Transfigure, and let my will be embodied!',
                'required': 'shenhe',
                'related': 'Icy Quill',
                'id': '55'
            },

            "riteofresurrection": {
                "name": "Rite of Resurrection",
                "tags": ['modify', 'talent', 'slowly'],
                "image": "/cards/i_n330552.webp",
                "golden_image": "/cards/i_n334552.webp",
                "hi_res_image": "/cards/i_n330552_gcg_high_resolution.webp",
                "cost": '5 Cryo 3 Energy',
                "description": "Combat Action: When your active character is Qiqi, equip this card. \n\nAfter Qiqi equips this card, immediately use Adeptus Art: Preserver of Fortune once. \n\nAfter your Qiqi, who has this card equipped, uses Adeptus Art: Preserver of Fortune, she revives all your fallen characters and heals them for 2 HP. (Can happen 2 times per match) \n\n(You must have Qiqi in your deck to add this card to your deck.)",
                "flavor": '\"Not scared... not scared. It\'s just... a game.\"',
                'required': 'qiqi',
                'id': '6V'
            },

            'lightsremit': { 
                'name': 'Light\'s Remit',
                'tags': ['modify', 'talent', 'slowly'],
                'hi_res_image': '/cards/i_n330560_gcg_high_resolution.webp',
                'image': '/cards/i_n330560.webp',
                'golden_image': '/cards/i_n334560.webp',
                'cost': '3 Cryo',
                'description': "Combat Action: When your active character is Layla, equip this card.\nAfter Layla equips this card, immediately use Nights of Formal Focus.\nWhen Layla is on the field and has this card equipped, every time Shooting Star deals DMG, draw 1 card.\n(You must have Layla in your deck to add this card to your deck.)",
                'flavor': "\"My guiding stars.\"",
                'required': 'layla',
                'id': '80',
            },
    
            "gloriousseason": {
                "name": "Glorious Season",
                "tags": ['modify', 'talent', 'slowly'],
                "image": "/cards/i_n330525.webp",
                "golden_image": "/cards/i_n334525.webp",
                "hi_res_image": "/cards/i_n330525_gcg_high_resolution.webp",
                "cost": '3 Hydro',
                "description": "'Combat Action': When your active character is Barbara, equip this card.\n\nAfter Barbara equips this card, immediately use 'Elemental Skill: Let the Show Begin' once.\n\nWhen your Barbara, who has this card equipped, is on the field, 'Melody Loop' will allow you to spend 1 less Elemental Die the next time you use 'Switch Character'. (Once per Round)\n\n(You must have Barbara in your deck to add this card to your deck.)",
                "flavor": "Here’s a song for you~",
                "required": "barbara",
                "id": '1G'        
            },
            
            "thescentremained": {
                "name": "The Scent Remained",
                "tags": ['modify', 'talent', 'slowly'],
                "image": "/cards/i_n330504.webp",
                "golden_image": "/cards/i_n334504.webp",
                "hi_res_image": "/cards/i_n330504_gcg_high_resolution.webp",
                "cost": '3 Hydro',
                "description": "'Combat Action': When your active character is Xingqiu, equip this card.\n\nAfter Xingqiu equips this card, immediately use 'Elemental Skill: Fatal Rainscreen' once.\n\nWhen your Xingqiu, who has this card equipped, creates a 'Rain Sword', its starting Usage(s) +1.\n\n(You must have Xingqiu in your deck to add this card to your deck.)",
                "flavor": "His penmanship leaves quite the impression.",
                "required": "xingqiu",
                "id": '0W'        
            },
            
            "prophecyofsubmersion": {
                "name": "Prophecy of Submersion",
                "tags": ['modify', 'talent', 'slowly'],
                "image": "/cards/i_n330505.webp",
                "golden_image": "/cards/i_n334505.webp",
                "hi_res_image": "/cards/i_n330505_gcg_high_resolution.webp",
                "cost": '3 Hydro 3 Energy',
                "description": "'Combat Action': When your active character is Mona, equip this card.\n\nWhen Mona equips this card, immediately use 'Elemental Burst: Stellaris Phantasm' once.\n\nWhen your Mona, who has this card equipped, is the active character, the 'Hydro Reactions' you trigger deal +2 additional DMG.\n\n(You must have Mona in your deck to add this card to your deck.)",
                "flavor": "“Hey! You should be playing that card!”\n“…Well, alright then, do what you want.”",
                "required": "mona",
                "id": '0X'
            },

            "abyssalmayhemhydrosprout": {
                "name": "Abyssal Mayhem: Hydrosprout",
                "tags": ['modify', 'talent', 'slowly'],
                "image": "/cards/i_n330541.webp",
                "golden_image": "/cards/i_n334541.webp",
                "hi_res_image": "/cards/i_n330541_gcg_high_resolution.webp",
                "cost": '3 Hydro',
                "description": "Combat Action: When your active character is Tartaglia, equip this card.\n\nAfter Tartaglia equips this card, immediately use Foul Legacy: Raging Tide once.\n\nEnd Phase: When Tartaglia is on the field and has this card equipped, deal 1 Piercing DMG to the opponent's active character if they have Riptide attached.\n\n(You must have Tartaglia in your deck to add this card to your deck.)",
                "flavor": 'A reckless yet precise blow.',
                'required': 'tartaglia',
                'id': '56'
            },
    
            "tamakushicasket": {
                "name": "Tamakushi Casket",
                "tags": ['modify', 'talent', 'slowly'],
                "image": "/cards/i_n330529.webp",
                "golden_image": "/cards/i_n334531.webp",
                "hi_res_image": "/cards/i_n330529_gcg_high_resolution.webp",
                "cost": '3 Hydro 2 Energy',
                "description": "'Combat Action': When your active character is Sangonomiya Kokomi, equip this card.\n\nAfter Sangonomiya Kokomi equips this card, immediately use 'Elemental Burst: Nereid's Ascension' once.\n\nWhen your Sangonomiya Kokomi, who has this card equipped, uses Nereid's Ascension while Bake-Kurage is on the field, its Usages will be reset. While Ceremonial Garment exists, Bake-Kurage deals +1 DMG.\n\n(You must have Sangonomiya Kokomi in your deck to add this card to your deck.)",
                "flavor": "Wisdom yet revealed from the casket parallels tides yet unfolded by the sea.",
                "required": "kokomi",
                "id": '4B'
            },
    
            "kyoukafuushi": {
                "name": "Kyouka Fuushi",
                "tags": ['modify', 'talent', 'slowly'],
                "image": "/cards/i_n330538.webp",
                "golden_image": "/cards/i_n334533.webp",
                "hi_res_image": "/cards/i_n330538_gcg_high_resolution.webp",
                "cost": '3 Hydro',
                "description": "'Combat Action': When your active character is Kamisato Ayato, equip this card.\n\nAfter Kamisato Ayato equips this card, immediately use 'Elemental Skill: Kamisato Art: Kyouka' once.\n\nWhen your Kamisato Ayato, who has this card equipped, triggers the effects of 'Takimeguri Kanka', deal +1 additional DMG if the target's remaining HP is equal to or less than 6.\n\n(You must have Kamisato Ayato in your deck to add this card to your deck.)",
                "flavor": "The courtyard remains fragrant even in the bitterest winter.",
                "required": "ayato",
                "id": '4I'
            },

            "theoverflow": {
                "name": "The Overflow",
                "tags": ['modify', 'talent', 'slowly'],
                "image": "/cards/i_n330549.webp",
                "golden_image": "/cards/i_n334549.webp",
                "hi_res_image": "/cards/i_n330549_gcg_high_resolution.webp",
                "cost": '3 Hydro 2 Energy',
                "description": "Combat Action: When Candace is your active character, equip this card. \n\nAfter Candace equips this card, she will immediately use Sacred Rite: Heron's Sanctum once. \n\nWhen this card is equipped by Candace, her Prayer of the Crimson Crown has the following extra effect: After your character uses a Normal Attack: Deals 1 Hydro DMG. (Once per Round) \n\n(You must have Candace in your deck to add this card to your deck.)",
                "flavor": "Those who do not respect the regulations at cards...\nAre the enemy of all who love the game.",
                "required": "candace",
                "id": '6J'
            },

            "thestarryskiestheirflowersrain": { //needs update
                "name": "The Starry Skies Their Flowers Rain",
                "tags": ['modify', 'talent', 'slowly'],
                "image": "/cards/i_n330557.webp",
                "golden_image": "/cards/i_n334557.webp",
                "hi_res_image": "/cards/i_n330557_gcg_high_resolution.webp",
                "cost": '3 Hydro',
                "description": "Combat Action: When Candace is your active character, equip this card. \n\nAfter Candace equips this card, she will immediately use Sacred Rite: Heron's Sanctum once. \n\nWhen this card is equipped by Candace, her Prayer of the Crimson Crown has the following extra effect: After your character uses a Normal Attack: Deals 1 Hydro DMG. (Once per Round) \n\n(You must have Candace in your deck to add this card to your deck.)",
                "flavor": "Those who do not respect the regulations at cards...\nAre the enemy of all who love the game.",
                "required": "nilou",
                "id": '7H'
            },

            'turncontrol': { 
                'name': 'Turn Control',
                'tags': ['modify', 'talent', 'slowly'],
                'hi_res_image': '/cards/i_n330561_gcg_high_resolution.webp',
                'image': '/cards/i_n330561.webp',
                'golden_image': '/cards/i_n334561.webp',
                'cost': '3 Hydro',
                'description': "Combat Action: When your active character is Yelan, equip this card. \n\nAfter Yelan equips this card, immediately use Lingering Lifeline once. \n\nRoll Phase: If Yelan, who has this card equipped, is on the field, 1 Elemental Dice will be rolled as Omni Element for each Elemental Type in your party. (Max 3) \n\n(You must have Yelan in your deck to add this card to your deck.)",
                'flavor': "\"Things are about to get dicey.\"",
                'required': 'yelan',
                'id': '81',
            },
            
            "flowingflame": {
                "name": "Flowing Flame",
                "tags": ['modify', 'talent', 'slowly'],
                "image": "/cards/i_n330506.webp",
                "golden_image": "/cards/i_n334506.webp",
                "hi_res_image": "/cards/i_n330506_gcg_high_resolution.webp",
                "cost": '3 Pyro',
                "description": "'Combat Action': When your active character is Diluc, equip this card.\n\nAfter Diluc equips this card, immediately use 'Elemental Skill: Searing Onslaught' once.\n\nWhen your Diluc, who has this card equipped, uses 'Elemental Skill: Searing Onslaught' for the second time in one Round, spend 1 less Pyro Die.\n\n(You must have Diluc in your deck to add this card to your deck.)",
                "flavor": "A simple way out of perilous situations.",
                "required": "diluc",
                "id": '0Y'        
            },
            
            "crossfire": {
                "name": "Crossfire",
                "tags": ['modify', 'talent', 'slowly'],
                "image": "/cards/i_n330507.webp",
                "golden_image": "/cards/i_n334507.webp",
                "hi_res_image": "/cards/i_n330507_gcg_high_resolution.webp",
                "cost": '3 Pyro',
                "description": "'Combat Action': When your active character is Xiangling, equip this card.\n\nAfter Xiangling equips this card, immediately use 'Elemental Skill: Guoba Attack' once.\n\nWhen your Xiangling, who has this card equipped, uses 'Elemental Skill: Guoba Attack', she will also deal 1 'Pyro DMG'.\n\n(You must have Xiangling in your deck to add this card to your deck.)",
                "flavor": "This heat’s just normal for a restaurant’s standards!",
                "required": "xiangling",
                "id": '0Z'        
            },
            
            "grandexpectation": {
                "name": "Grand Expectation",
                "tags": ['modify', 'talent', 'slowly'],
                "image": "/cards/i_n330508.webp",
                "golden_image": "/cards/i_n334508.webp",
                "hi_res_image": "/cards/i_n330508_gcg_high_resolution.webp",
                "cost": '4 Pyro 2 Energy',
                "description": "'Combat Action': When your active character is Bennett, equip this card.\n\nAfter Bennett equips this card, immediately use 'Elemental Burst: Fantastic Voyage' once.\n\nWhen your Bennett, who has this card equipped, creates an 'Inspiration Field', its DMG Bonus is now always active and will no longer have an HP restriction.\n\n(You must have Bennett in your deck to add this card to your deck.)",
                "flavor": "The best adventure is always yet to be.",
                "required": "bennett",
                "id": '10'        
            },
    
            "bunnytriggered": {
                "name": "Bunny Triggered",
                "tags": ['modify', 'talent', 'slowly'],
                "image": "/cards/i_n330509.webp",
                "golden_image": "/cards/i_n334509.webp",
                "hi_res_image": "/cards/i_n330509_gcg_high_resolution.webp",
                "cost": '3 Pyro',
                "description": "Combat Action: When your active character is Amber, equip this card. \n\nAfter Amber equips this card, immediately use Explosive Puppet once. \n\nThe Baron Bunny created by your Amber will explode after your Amber uses a Normal Attack, dealing 3 Pyro DMG. \n\n(You must have Amber in your deck to add this card to your deck.)",
                "flavor": '"Go go Baron Bunny!"',
                "required": "amber",
                'id': '50'
            },
            
            "naganoharameteorswarm": {
                "name": "Naganohara Meteor Swarm",
                "tags": ['modify', 'talent', 'slowly'],
                "image": "/cards/i_n330510.webp",
                "golden_image": "/cards/i_n334510.webp",
                "hi_res_image": "/cards/i_n330510_gcg_high_resolution.webp",
                "cost": '2 Pyro',
                "description": "'Combat Action': When your active character is Yoimiya, equip this card.\n\nAfter Yoimiya equips this card, immediately use 'Elemental Skill: Niwabi Fire Dance' once.\n\nAfter your Yoimiya, who has this card equipped, triggers 'Niwabi Enshou': Deal 1 additional 'Pyro DMG'.\n\n(You must have Yoimiya in your deck to add this card to your deck.)",
                "flavor": "Naganohara Ideal Firework Reserve Theory.",
                "required": "yoimiya",
                "id": '11'        
            },
    
            "poundingsurprise": {
                "name": "Pounding Surprise",
                "tags": ['modify', 'talent', 'slowly'],
                "image": "/cards/i_n330530.webp",
                "golden_image": "/cards/i_n334529.webp",
                "hi_res_image": "/cards/i_n330530_gcg_high_resolution.webp",
                "cost": '3 Pyro',
                "description": "'Combat Action': When your active character is Klee, equip this card.\n\nAfter Klee equips this card, immediately use 'Elemental Skill: Jumpy Dumpty' once.\n\nWhen your Klee, who has this card equipped, creates an 'Explosive Spark', its Usage(s) +1.\n\n(You must have Klee in your deck to add this card to your deck.)",
                "flavor": "Let out a good laugh when you draw this card!",
                "required": "klee",
                "id": '45'     
            },
    
            "sanguinerouge": {
                "name": "Sanguine Rouge",
                "tags": ['modify', 'talent', 'slowly'],
                "image": "/cards/i_n330542.webp",
                "golden_image": "/cards/i_n334542.webp",
                "hi_res_image": "/cards/i_n330542_gcg_high_resolution.webp",
                "cost": '2 Pyro',
                "description": "Combat Action: When your active character is Hu Tao, equip this card.\n\nAfter Hu Tao equips this card, immediately use Guide to Afterlife once.\n\nWhen your Hu Tao, who has this card equipped, has no more than 6 HP, Pyro DMG dealt +1.\n\n(You must have Hu Tao in your deck to add this card to your deck.)",
                "flavor": 'Director Hu needs a bit more firepower to settle certain unique affairs.',
                'required': 'hutao',
                'id': '57'
            },

            "rightoffinalinterpretation": {
                "name": "Right of Final Interpretation",
                "tags": ['modify', 'talent', 'slowly'],
                "image": "/cards/i_n330550.webp",
                "golden_image": "/cards/i_n334550.webp",
                "hi_res_image": "/cards/i_n330550_gcg_high_resolution.webp",
                "cost": '2 Black 1 Pyro',
                "description": "Combat Action: When Yanfei is your active character, equip this card.\n\nAfter Yanfei equips this card, she will immediately use Seal of Approval once.\n\nWhen Yanfei uses a Charged Attack with this card equipped: Deal +1 DMG to enemies with 6 or less HP.\n\n(You must have Yanfei in your deck to add this card to your deck.)",
                "flavor": '"When it comes to cards... Well, anything is permissible, so long as the rules don\'t forbid it."',
                'required': 'yanfei',
                'id': '6K'
            },

            "stalwartandtrue": {
                "name": "Stalwart and True",
                "tags": ['modify', 'talent', 'slowly'],
                "image": "/cards/i_n330554.webp",
                "golden_image": "/cards/i_n334554.webp",
                "hi_res_image": "/cards/i_n330554_gcg_high_resolution.webp",
                "cost": '4 Pyro',
                "description": "Combat Action: When your active character is Dehya, equip this card.\n\nAfter Dehya equips this card, immediately use Molten Inferno once.\n\nEnd Phase: If your Dehya, who has this card equipped, has no more than 6 HP, heal that character for 2HP.\n\n(You must have Dehya in your deck to add this card to your deck.)",
                "flavor": '""Don\'t hold back, let\'s rock!"',
                'required': 'dehya',
                'id': '75'
            },

            'conclusiveovation': { 
                'name': 'Conclusive Ovation',
                'tags': ['modify', 'talent', 'slowly'],
                'hi_res_image': '/cards/i_n330562_gcg_high_resolution.webp',
                'image': '/cards/i_n330562.webp',
                'golden_image': '/cards/i_n334562.webp',
                'cost': '3 Pyro',
                'description': "Combat Action: When your active character is Lyney, equip this card. \nAfter Lyney equips this card, immediately use Prop Arrow. \nWhen Lyney is on the field and has this card equipped, the damage dealt by Lyney and your Grin-Malkin Hat will deal +2 DMG to characters affected by Pyro. (Once per Round)\n(You must have Lyney in your deck to add this card to your deck.)",
                'flavor': "\"A round of applause!\"",
                'required': 'lyney',
                'id': '82',
            },

            'asubordinate\'sskills': { 
                'name': 'A Subordinate\'s Skills',
                'tags': ['modify', 'talent', 'slowly'],
                'hi_res_image': '/cards/i_n330571_gcg_high_resolution.webp',
                'image': '/cards/i_n330571.webp',
                'golden_image': '/cards/i_n334571.webp',
                'cost': '3 Pyro 2 Energy',
                'description': "Combat Action: When your active character is Thoma, equip this card. \n\nAfter Thoma equips this card, immediately use Crimson Ooyoroi once. \n\nWhen your Thoma, who has this card equipped, creates a Scorching Ooyoroi, its starting Usage(s) +1. \n\n(You must have Thoma in your deck to add this card to your deck.)",
                'flavor': "\"It looks like I'm responsible for another smile.\"",
                'required': 'thoma',
                'id': '8Z',
            },
            
            "stellarpredator": {
                "name": "Stellar Predator",
                "tags": ['modify', 'talent', 'slowly'],
                "image": "/cards/i_n330511.webp",
                "golden_image": "/cards/i_n334511.webp",
                "hi_res_image": "/cards/i_n330511_gcg_high_resolution.webp",
                "cost": '3 Electro',
                "description": "'Combat Action': When your active character is Fischl, equip this card.\n\nAfter Fischl equips this card, immediately use 'Elemental Skill: Nightrider' once.\n\nWhen your Fischl, who has this card equipped, creates an 'Oz', and after Fischl uses a Normal Attack: Deal 2 'Electro DMG'.(Consumes Usage(s))\n\n(You must have Fischl in your deck to add this card to your deck.)",
                "flavor": "“The instant in which Ozvaldo Hrafnavins shows his great might.”",
                "required": "fischl",
                "id": '12'        
            },
            
            "awakening": {
                "name": "Awakening",
                "tags": ['modify', 'talent', 'slowly'],
                "image": "/cards/i_n330512.webp",
                "golden_image": "/cards/i_n334512.webp",
                "hi_res_image": "/cards/i_n330512_gcg_high_resolution.webp",
                "cost": '3 Electro',
                "description": "'Combat Action': When your active character is Razor, equip this card.\n\nAfter Razor equips this card, immediately use 'Elemental Skill: Claw and Thunder' once.\n\nAfter your Razor, who has this card equipped, uses 'Elemental Skill: Claw and Thunder': 1 of your Electro characters gains 1 Energy.\n\n(You must have Razor in your deck to add this card to your deck.)",
                "flavor": "The hunt is about to begin.",
                "required": "razor",
                "id": '13'        
            },
            
            "thunderingpenance": {
                "name": "Thundering Penance",
                "tags": ['modify', 'talent', 'slowly'],
                "image": "/cards/i_n330513.webp",
                "golden_image": "/cards/i_n334513.webp",
                "hi_res_image": "/cards/i_n330513_gcg_high_resolution.webp",
                "cost": '3 Electro',
                "description": "'Combat Action': When your active character is Keqing, equip this card.\n\nAfter Keqing equips this card, immediately use 'Elemental Skill: Stellar Restoration' once.\n\nWhen your Keqing, who has this card equipped, creates an 'Electro Infusion', it will have the following effects: Starting 'Duration (Rounds)' +1, and 'Electro DMG' dealt by the attached character +1.\n\n(You must have Keqing in your deck to add this card to your deck.)",
                "flavor": "As long as you’re not actually cheating, this is just the name of a card.",
                "required": "keqing",
                "id": '14'        
            },
    
            "featherfalljudgment": {
                "name": "Featherfall Judgment",
                "tags": ['modify', 'talent', 'slowly'],
                "image": "/cards/i_n330524.webp",
                "golden_image": "/cards/i_n334524.webp",
                "hi_res_image": "/cards/i_n330524_gcg_high_resolution.webp",
                "cost": '3 Electro',
                "description": "'Combat Action': When your active character is Cyno, equip this card.\n\nAfter Cyno equips this card, immediately use 'Elemental Skill: Secret Rite: Chasmic Soulfarer' once.\n\nWhen your Cyno, who has this card equipped, uses 'Elemental Skill: Secret Rite: Chasmic Soulfarer' with 3 or 5 levels of Pactsworn Pathclearer's 'Indwelling' effect, deal +1 additional DMG.\n\n(You must have Cyno in your deck to add this card to your deck.)",
                "flavor": "“This is my duel soul.”",
                "required": "cyno",
                "id": '1F'        
            },
    
            "lightningstorm": {
                "name": "Lightning Storm",
                "tags": ['modify', 'talent', 'slowly'],
                "image": "/cards/i_n330531.webp",
                "golden_image": "/cards/i_n334528.webp",
                "hi_res_image": "/cards/i_n330531_gcg_high_resolution.webp",
                "cost": '3 Electro',
                "description": "'Combat Action': When your active character is Beidou, equip this card.\n\nAfter Beidou equips this card, immediately use 'Elemental Skill: Tidecaller' once.\n\nWhen your Beidou, who has this card equipped, uses 'Wavestrider': If DMG is taken while 'Prepare Skill' is active, Beidou's Normal Attacks this Round will cost 1 less 'Unaligned Element'. (Can be triggered 2 times)\n\n(You must have Beidou in your deck to add this card to your deck.)",
                "flavor": "Rumbling thunder goes well with lightning storm!",
                "required": "beidou",
                "id": '46'     
            },
    
            "sinofpride": {
                "name": "Sin of Pride",
                "tags": ['modify', 'talent', 'slowly'],
                "image": "/cards/i_n330537.webp",
                "golden_image": "/cards/i_n334532.webp",
                "hi_res_image": "/cards/i_n330537_gcg_high_resolution.webp",
                "cost": '3 Electro',
                "description": "'Combat Action': When your active character is Kujou Sara, equip this card.\n\nAfter Kujou Sara equips this card, immediately use 'Elemental Burst: Subjugation: Koukou Sendou' once.\n\nWhen Kujou Sara is active and has this card equipped, all allied Electro characters with Crowfeather Cover will deal +1 additional Elemental Skill and Elemental Burst DMG.\n\n(You must have Kujou Sara in your deck to add this card to your deck.)",
                "flavor": "“With this unity between my mind, arrow, and bow, any enemy will be struck down!”",
                "required": "sara",
                "id": '4C' 
            },
    
            "wishesunnumbered": {
                "name": "Wishes Unnumbered",
                "tags": ['modify', 'talent', 'slowly'],
                "image": "/cards/i_n330543.webp",
                "golden_image": "/cards/i_n334543.webp",
                "hi_res_image": "/cards/i_n330543_gcg_high_resolution.webp",
                "cost": '4 Electro 2 Energy',
                "description": "Combat Action: When your active character is Raiden Shogun, equip this card.\n\nAfter Raiden Shogun equips this card, immediately use Secret Art: Musou Shinsetsu once.\n\nWhen your Raiden Shogun, who has this card equipped, uses Secret Art: Musou Shinsetsu, it will deal +1 additional DMG for every point of Resolve consumed.\n\n(You must have Raiden Shogun in your deck to add this card to your deck.)",
                "flavor": 'Transcendence: Shine down!',
                'required': 'raiden',
                'id': '58'
            },
    
            "theshrinessacredshade": {
                "name": "The Shrine's Sacred Shade",
                "tags": ['modify', 'talent', 'slowly'],
                "image": "/cards/i_n330544.webp",
                "golden_image": "/cards/i_n334544.webp",
                "hi_res_image": "/cards/i_n330544_gcg_high_resolution.webp",
                "cost": '3 Electro 2 Energy',
                "description": "Combat Action: When your active character is Yae Miko, equip this card. \n\nAfter Yae Miko equips this card, immediately use Great Secret Art: Tenko Kenshin once. \n\nAfter your Yae Miko, who has this card equipped, destroys a Sesshou Sakura through Great Secret Art: Tenko Kenshin, the next use of Yakan Evocation: Sesshou Sakura this Round will cost 2 less Elemental Dice. \n\n(You must have Yae Miko in your deck to add this card to your deck.)",
                "flavor": '"Ah... A sight to behold..."',
                'required': 'yae',
                'id': '59'
            },

            "pulsatingwitch": {
                "name": "Pulsating Witch",
                "tags": ['modify', 'talent'],
                "image": "/cards/i_n330553.webp",
                "golden_image": "/cards/i_n334553.webp",
                "hi_res_image": "/cards/i_n330553_gcg_high_resolution.webp",
                "cost": '1 Electro',
                "description": "After you switch to Lisa, who has this card equipped: Attach Conductive to the opposing active character. (Once per Round) \n\n(You must have Lisa in your deck to add this card to your deck.)",
                "flavor": 'As a Librarian who has read through tens of thousands of volumes, of course it\'s trivial for me to remember how to win...',
                'required': 'lisa',
                'id': '6W'
            },

            "discretionarysupplement": {
                "name": "Discretionary Supplement",
                "tags": ['modify', 'talent', 'slowly'],
                "image": "/cards/i_n330558.webp",
                "golden_image": "/cards/i_n334558.webp",
                "hi_res_image": "/cards/i_n330558_gcg_high_resolution.webp",
                "cost": '3 Electro 2 Energy',
                "description": "After you switch to Lisa, who has this card equipped: Attach Conductive to the opposing active character. (Once per Round) \n\n(You must have Lisa in your deck to add this card to your deck.)",
                "flavor": 'As a Librarian who has read through tens of thousands of volumes, of course it\'s trivial for me to remember how to win...',
                'required': 'dori',
                'id': '7I'
            },
            
            "chaoticentropy": {
                "name": "Chaotic Entropy",
                "tags": ['modify', 'talent', 'slowly'],
                "image": "/cards/i_n330514.webp",
                "golden_image": "/cards/i_n334514.webp",
                "hi_res_image": "/cards/i_n330514_gcg_high_resolution.webp",
                "cost": '3 Anemo 2 Energy',
                "description": "'Combat Action': When your active character is Sucrose, equip this card.\n\nAfter Sucrose equips this card, immediately use 'Elemental Burst: Forbidden Creation - Isomer 75 / Type II' once.\n\nAfter the 'Large Wind Spirit' created by your Sucrose, who had this card equipped, has converted to another Element: Deal +1 DMG of this Element.\n\n(You must have Sucrose in your deck to add this card to your deck.)",
                "flavor": "The wild winds gather — and amidst the chaos, victory.",
                "required": "sucrose",
                "id": '15'        
            },
            
            "landsofdandelion": {
                "name": "Lands of Dandelion",
                "tags": ['modify', 'talent', 'slowly'],
                "image": "/cards/i_n330515.webp",
                "golden_image": "/cards/i_n334515.webp",
                "hi_res_image": "/cards/i_n330515_gcg_high_resolution.webp",
                "cost": '4 Anemo 2 Energy',
                "description": "'Combat Action': When your active character is Jean, equip this card.\n\nAfter Jean equips this card, immediately use 'Elemental Burst: Dandelion Breeze' once.\n\nWhen your Jean, who has this card equipped, is on the field, 'Dandelion Field' will cause you to deal +1 'Anemo DMG'.\n\n(You must have Jean in your deck to add this card to your deck.)",
                "flavor": "“Wind, hear me!”",
                "required": "jean",
                "id": '16'        
            },
    
            "embraceofwinds": {
                "name": "Embrace of Winds",
                "tags": ['modify', 'talent', 'slowly'],
                "image": "/cards/i_n330532.webp",
                "golden_image": "/cards/i_n334536.webp",
                "hi_res_image": "/cards/i_n330532_gcg_high_resolution.webp",
                "cost": '3 Anemo',
                "description": "Combat Action: When your active character is Venti, equip this card. \n\nAfter Venti equips this card, immediately use Skyward Sonnet once. \n\nAfter a Stormzone created by your Venti, who has this card equipped, is triggered, the next Normal Attack performed by your character in this Round will cost 1 less Unaligned Element. \n\n(You must have Venti in your deck to add this card to your deck.)",
                "flavor": '"Watch your step."',
                'required': 'venti',
                'id': '51'
            },
    
            "conquerorofevilguardianyaksha": {
                "name": "Conqueror of Evil: Guardian Yaksha",
                "tags": ['modify', 'talent', 'slowly'],
                "image": "/cards/i_n330533.webp",
                "golden_image": "/cards/i_n334537.webp",
                "hi_res_image": "/cards/i_n330533_gcg_high_resolution.webp",
                "cost": '3 Anemo 2 Energy',
                "description": "Combat Action: When your active character is Xiao, equip this card. \n\nAfter Xiao equips this card, immediately use Bane of All Evil once. \n\nWhile your Xiao, who has this card equipped, has Yaksha's Mask attached, your use of Lemniscatic Wind Cycling will cost 1 less Anemo Die. (Every attachment of Yaksha's Mask allows the effect to be triggered twice)\n\n(You must have Xiao in your deck to add this card to your deck.)",
                "flavor": 'Evil shall be dispersed, and the vile will be scattered.',
                'required': 'xiao',
                'id': '52'
            },

            'poeticsoffuubutsu': {
                "name": "Poetics of Fuubutsu",
                "tags": ['modify', 'talent', 'slowly'],
                "image": "/cards/i_n330551.webp",
                "golden_image": "/cards/i_n334551.webp",
                "hi_res_image": "/cards/i_n330551_gcg_high_resolution.webp",
                "cost": '3 Anemo',
                "description": "Combat Action: When Kaedehara Kazuha is your active character, equip this card.\n\nAfter Kaedehara Kazuha equips this card, he will immediately use Chihayaburu once.\n\nAfter Kaedehara Kazuha triggers Swirl with this card equipped: For the next 2 instances, your characters and Summons will deal +1 DMG for the Elemental Type Swirled. (Each Elemental Type is counted independently as one instance)\n\n(You must have Kaedehara Kazuha in your deck to add this card to your deck.)",
                "flavor": 'There is something elegant about this match.\nIf nothing else, both sides may concede defeat without regrets.',
                'required': 'kazuha',
                'id': '6L'
            },

            'galesofreverie': {
                "name": "Gales of Reverie",
                "tags": ['modify', 'talent', 'slowly'],
                "image": "/cards/i_n330555.webp",
                "golden_image": "/cards/i_n334555.webp",
                "hi_res_image": "/cards/i_n330555_gcg_high_resolution.webp",
                "cost": '4 Anemo',
                "description": "Combat Action: When your active character is Wanderer, equip this card.\n\nAfter Wanderer equips this card, immediately use Hanega: Song of the Wind once.\n\nWhen your Wanderer, who has this card equipped, is in Windfavored state and after using Charged Attack: you will spend 1 less Elemental Die the next time you use \"Switch Character\" and deal Anemo DMG.\n\n(You must have Wanderer in your deck to add this card to your deck.)",
                "flavor": '"Squall and fury!"',
                'required': 'wanderer',
                'id': '76'
            },

            'acoldbladelikeashadow': {
                "name": "A Cold Blade Like a Shadow",
                "tags": ['modify', 'talent', 'slowly'],
                "image": "/cards/i_n330563.webp",
                "golden_image": "/cards/i_n334563.webp",
                "hi_res_image": "/cards/i_n330563_gcg_high_resolution.webp",
                "cost": '3 Anemo',
                "description": "Combat Action: When your active character is Lynette, equip this card. \nAfter Lynette equips this card, immediately use Enigmatic Feint once. \nAfter your Lynette, who has this card equipped, uses Enigmatic Feint for the second time this Round: deals +2 DMG and forces your opponent to switch to their previous character. \n(You must have Lynette in your deck to add this card to your deck.)",
                "flavor": '"Step on up!"',
                'required': 'lynette',
                'id': '83'
            },

            'skivingnewandimproved': {
                "name": "Skiving: New and Improved",
                "tags": ['modify', 'talent', 'slowly'],
                "image": "/cards/i_n330572.webp",
                "golden_image": "/cards/i_n334572.webp",
                "hi_res_image": "/cards/i_n330572_gcg_high_resolution.webp",
                "cost": '3 Anemo',
                "description": "Combat Action: When your active character is Sayu, equip this card. \n\nWhen Sayu equips this card, immediately use Yoohoo Art: Fuuin Dash once. \n\nWhen your Sayu who has this card equipped is the active character, draw 2 cards when you trigger a Swirl reaction. (Once per Round) \n\n(You must have Sayu in your deck to add this card to your deck.)",
                "flavor": '"I should have just stayed in bed today."',
                'required': 'sayu',
                'id': '90'
            },
            
            "strategicreserve": {
                "name": "Strategic Reserve",
                "tags": ['modify', 'talent', 'slowly'],
                "image": "/cards/i_n330516.webp",
                "golden_image": "/cards/i_n334516.webp",
                "hi_res_image": "/cards/i_n330516_gcg_high_resolution.webp",
                "cost": '4 Geo',
                "description": "'Combat Action': When your active character is Ningguang, equip this card.\n\nAfter Ningguang equips this card, immediately use 'Elemental Skill: Jade Screen' once.\n\nWhen your Ningguang, who has this card equipped, is on the field, 'Jade Screen' will cause you to deal +1 'Geo DMG'.\n\n(You must have Ningguang in your deck to add this card to your deck.)",
                "flavor": "Abundance is synonymous with confidence.",
                "required": "ningguang",
                "id": '17'        
            },
            
            "igotyourback": {
                "name": "I Got Your Back",
                "tags": ['modify', 'talent', 'slowly'],
                "image": "/cards/i_n330517.webp",
                "golden_image": "/cards/i_n334517.webp",
                "hi_res_image": "/cards/i_n330517_gcg_high_resolution.webp",
                "cost": '3 Geo',
                "description": "'Combat Action': When your active character is Noelle, equip this card.\n\nAfter Noelle equips this card, immediately use 'Elemental Skill: Breastplate' once.\n\nWhen your Noelle, who has this card equipped, creates a 'Full Plate', it will heal all your characters for 1 HP after Noelle uses a Normal Attack. (Once per Round)\n\n(You must have Noelle in your deck to add this card to your deck.)",
                "flavor": "A stout heart is the sternest armor.",
                "required": "noelle",
                "id": '18'        
            },

            "dominanceofearth": {
                "name": "Dominance of Earth",
                "tags": ['modify', 'talent', 'slowly'],
                "image": "/cards/i_n330534.webp",
                "golden_image": "/cards/i_n334538.webp",
                "hi_res_image": "/cards/i_n330534_gcg_high_resolution.webp",
                "cost": '5 Geo',
                "description": "Combat Action: When your active character is Zhongli, equip this card. \n\nAfter Zhongli equips this card, immediately use Dominus Lapidis: Striking Stone once. \n\nWhen your active character is protected by a Shield Character Status or a Shield Combat Status, your Summons deal +1 Geo DMG. \n\n(You must have Zhongli in your deck to add this card to your deck.)",
                "flavor": 'The vastness of rivers flows endless, perpetual upon the tapestry of eons.',
                'required': 'zhongli',
                'id': '53'
            },

            "descentofdivinity": {
                "name": "Descent of Divinity",
                "tags": ['modify', 'talent', 'slowly'],
                "image": "/cards/i_n330545.webp",
                "golden_image": "/cards/i_n334545.webp",
                "hi_res_image": "/cards/i_n330545_gcg_high_resolution.webp",
                "cost": '3 Geo',
                "description": "Combat Action: When your active character is Albedo, equip this card. \n\nAfter Albedo equips this card, immediately use Abiogenesis: Solar Isotoma. \n\nWhen there is Albedo on the field who has this card equipped, if your side of the field has Solar Isotoma, then your characters' Plunging Attack deals +1 DMG. \n\n(You must have Albedo in your deck to add this card to your deck.)",
                "flavor": '	"The process of confirming the strategy for a duel also requires meticulous calculations..."',
                'required': 'albedo',
                'id': '6U'
            },
    
            "aratakiichiban": {
                "name": "Arataki Ichiban",
                "tags": ['modify', 'talent', 'slowly'],
                "image": "/cards/i_n330539.webp",
                "golden_image": "/cards/i_n334534.webp",
                "hi_res_image": "/cards/i_n330539_gcg_high_resolution.webp",
                "cost": '2 Black 1 Geo',
                "description": "'Combat Action': When your active character is Arataki Itto, equip this card.\n\nAfter Arataki Itto equips this card, immediately use 'Normal Attack: Fight Club Legend' once.\n\nAfter your Arataki Itto, who has this card equipped, uses 'Fight Club Legend' for the second time or more in one Round: If 'Superlative Superstrength' is triggered, deal +1 additional DMG.\n\n(You must have Arataki Itto in your deck to add this card to your deck.)",
                "flavor": "Whatever you do, remember to ride the momentum.",
                "required": "itto",
                "id": '4J'        
            },

            'rushinghound:swiftasthewind': { 
                'name': 'Rushing Hound: Swift as the Wind',
                'tags': ['modify', 'talent', 'slowly'],
                'hi_res_image': '/cards/i_n330564_gcg_high_resolution.webp',
                'image': '/cards/i_n330564.webp',
                'golden_image': '/cards/i_n334564.webp',
                'cost': '3 Geo',
                'description': "Combat Action: When your active character is Gorou, equip this card. \nAfter Gorou equips this card, immediately use Inuzaka All-Round Defense once. \nWhen your Gorou, who has this card equipped, is on the field, and after any of your characters deals Geo DMG: If General's War Banner is in play, draw 1 card. (Once per Round) \n(You must have Gorou in your deck to add this card to your deck.)",
                'flavor': "\"Rally!\"",
                'required': 'gorou',
                'id': '84',
            },
            
            "floralsidewinder": {
                "name": "Floral Sidewinder",
                "tags": ['modify', 'talent', 'slowly'],
                "image": "/cards/i_n330518.webp",
                "golden_image": "/cards/i_n334518.webp",
                "hi_res_image": "/cards/i_n330518_gcg_high_resolution.webp",
                "cost": '4 Dendro',
                "description": "'Combat Action': When your active character is Collei, equip this card.\n\nAfter Collei equips this card, immediately use 'Elemental Skill: Floral Brush' once.\n\nAfter your Collei, who has this card equipped, uses 'Elemental Skill: Floral Brush', during this Round, after your characters’ Skills trigger a 'Dendro Reaction': Deal 1 'Dendro DMG'. (Once per Round)\n\n(You must have Collei in your deck to add this card to your deck.)",
                "flavor": "Never underestimate Collei, and never underestimate her cat.",
                "required": "collei",
                "id": '19'        
            },
    
            "keensight": {
                "name": "Keen Sight",
                "tags": ['modify', 'talent', 'slowly'],
                "image": "/cards/i_n330535.webp",
                "golden_image": "/cards/i_n334535.webp",
                "hi_res_image": "/cards/i_n330535_gcg_high_resolution.webp",
                "cost": '4 Dendro',
                "description": "'Combat Action': When your active character is Tighnari, equip this card.\n\nAfter Tighnari equips this card, immediately use 'Elemental Skill: Vijnana-Phala Mine' once.\n\nWhen your Tighnari, who has this card equipped, is affected by 'Vijnana Suffusion', the character's Charged Attack costs 1 less Unaligned Element.\n\n(You must have Tighnari in your deck to add this card to your deck.)",
                "flavor": "Mistakes are part of learning... However, these mistakes should be corrected upon being discovered.",
                "required": "tighnari",
                "id": '4K'        
            },
    
            "theseedofstoredknowledge": {
                "name": "The Seed of Stored Knowledge",
                "tags": ['modify', 'talent', 'slowly'],
                "image": "/cards/i_n330546.webp",
                "golden_image": "/cards/i_n334546.webp",
                "hi_res_image": "/cards/i_n330546_gcg_high_resolution.webp",
                "cost": '3 Dendro 2 Energy',
                "description": "Combat Action: When your active character is Nahida, equip this card.\n\nAfter Nahida equips this card, immediately use Illusory Heart once.\n\nWhen your Nahida, who has this card equipped, is on the field, the following effects will take place based on your party's Elemental Types: \n\nPyro: When Shrine of Maya is on the field, characters who trigger Seed of Skandha due to Elemental Reactions they are affected by will have the Piercing DMG they take from Seed of Skandha converted to Dendro DMG. \n\nElectro: When the Shrine of Maya enters the field, Seed of Skandha currently present of the opposition will gain 1 Usage(s). \n\nHydro: After your Nahida, who has this card equipped unleashes Shrine of Maya, Duration (Rounds) +1.\n\n(You must have Nahida in your deck to add this card to your deck.)",
                "flavor": '"Share in my knowledge."',
                'required': 'nahida',
                'id': '5A'
            },

            "beneficent": {
                "name": "Beneficent",
                "tags": ['modify', 'talent', 'slowly'],
                "image": "/cards/i_n330556.webp",
                "golden_image": "/cards/i_n334556.webp",
                "hi_res_image": "/cards/i_n330556_gcg_high_resolution.webp",
                "cost": '3 Dendro',
                "description": "Combat Action: When your active character is Yaoyao, equip this card.\n\nAfter Yaoyao equips this card, immediately use Raphanus Sky Cluster once.\n\nWhen Yuegui: Throwing Mode is created by your Yaoyao, who has this card equipped, and it has only 1 Usage(s) remaining, it deals +1 DMG and healing is increased by 1.\n\n(You must have Yaoyao in your deck to add this card to your deck.)",
                "flavor": '"Pain, pain, go away!"',
                'required': 'yaoyao',
                'id': '77'
            },

            "allthingsareoftheearth": {
                "name": "All Things Are of the Earth",
                "tags": ['modify', 'talent', 'slowly'],
                "image": "/cards/i_n330559.webp",
                "golden_image": "/cards/i_n334559.webp",
                "hi_res_image": "/cards/i_n330559_gcg_high_resolution.webp",
                "cost": '4 Dendro 2 Energy',
                "description": "Combat Action: When your active character is Yaoyao, equip this card.\n\nAfter Yaoyao equips this card, immediately use Raphanus Sky Cluster once.\n\nWhen Yuegui: Throwing Mode is created by your Yaoyao, who has this card equipped, and it has only 1 Usage(s) remaining, it deals +1 DMG and healing is increased by 1.\n\n(You must have Yaoyao in your deck to add this card to your deck.)",
                "flavor": '"Pain, pain, go away!"',
                'required': 'baizhu',
                'id': '7J'
            },

            'structuration': { 
                'name': 'Structuration',
                'tags': ['modify', 'talent', 'slowly'],
                'hi_res_image': '/cards/i_n330565_gcg_high_resolution.webp',
                'image': '/cards/i_n330565.webp',
                'golden_image': '/cards/i_n334565.webp',
                'cost': '3 Dendro 2 Energy',
                'description': "Combat Action: When your active character is Alhaitham, equip this card. \n\nAfter Alhaitham equips this card, immediately use Particular Field: Fetters of Phenomena once. \n\nWhen your Alhaitham, who has this card equipped, uses Particular Field: Fetters of Phenomena, if the character consumes a Chisel-Light Mirror with at least 1 Duration (Rounds), then always attach Chisel-Light Mirror with 3 Duration (Rounds) and draw 1 card. \n\n(You must have Alhaitham in your deck to add this card to your deck.)",
                'flavor': "\"A process of elimination.\"",
                'required': 'alhaitham',
                'id': '85',
            },
    
            "cicinscoldglare": {
                "name": "Cicin's Cold Glare",
                "tags": ['modify', 'talent', 'slowly'],
                "image": "/cards/i_n330547.webp",
                "golden_image": "/cards/i_n334547.webp",
                "hi_res_image": "/cards/i_n330547_gcg_high_resolution.webp",
                "cost": '3 Cryo',
                "description": "Combat Action: When your active character is Fatui Cryo Cicin Mage, equip this card.\n\nAfter Fatui Cryo Cicin Mage equips this card, immediately use Misty Summons once. \n\nAfter your Fatui Cryo Cicin Mage, who has this card equipped, uses a Skill: If Cryo Cicin's Usage(s) stacks have surpassed their upper limit, Cryo Cicin will deal 2 Cryo DMG.\n\n(You must have Fatui Cryo Cicin Mage in your deck to add this card to your deck.)",
                "flavor": 'More Mist Grass means more friendly Cicin.\n...But what happens when the Mist Grass is used up?\nPerhaps she never considered this.',
                'required': 'cryocicinmage',
                'id': '5B'
            },

            'painforpain': { 
                'name': 'Pain for Pain',
                'tags': ['modify', 'talent'],
                'hi_res_image': '/cards/i_n330566_gcg_high_resolution.webp',
                'image': '/cards/i_n330566.webp',
                'golden_image': '/cards/i_n334566.webp',
                'cost': '3 White',
                'description': "Can only be played if your active character is La Signora: When entering play, generate 3 Elemental Dice of the same Type as La Signora. \n\nWhen this character takes at least 3 DMG: Negates 1 DMG, then apply Sheer Cold or Blazing Heat to the opposing active character based on La Signora's state. (Once per Round) \n(Your deck must contain La Signora to add this card to your deck)",
                'flavor': "\"You too will experience this suffering.\"",
                "required": "signora",
                'id': '86',
            },

            'sternfrostprism': { 
                'name': 'Sternfrost Prism',
                'tags': ['modify', 'talent'],
                'hi_res_image': '/cards/i_n330573_gcg_high_resolution.webp',
                'image': '/cards/i_n330573.webp',
                'golden_image': '/cards/i_n334573.webp',
                'cost': '1 Cryo',
                'description': "Can only be played if your active character is Cryo Hypostasis: Attach Cryocrystal Core to them. \n\nAfter Cryo Hypostasis, who has this card equipped, triggers Cryocrystal Core: Attach Sheer Cold to the opposing active character. \n\n(Your deck must contain Cryo Hypostasis to add this card to your deck)",
                'flavor': "Despite its highly stable form and almost machine-like movements, it must still meticulously defend its weak spot...",
                "required": "cryohypo",
                'id': '91',
            },
            
            "streamingsurge": {
                "name": "Streaming Surge",
                "tags": ['modify', 'talent', 'slowly'],
                "image": "/cards/i_n330519.webp",
                "golden_image": "/cards/i_n334519.webp",
                "hi_res_image": "/cards/i_n330519_gcg_high_resolution.webp",
                "cost": '4 Hydro 3 Energy',
                "description": "'Combat Action': When your active character is Rhodeia of Loch, equip this card.\n\nAfter Rhodeia of Loch equips this card, immediately use 'Elemental Burst: Tide and Torrent' once.\n\nWhen your Rhodeia of Loch, who has this card equipped, uses 'Elemental Burst: Tide and Torrent', all of your Summon(s) gain +1 Usage(s).\n\n(You must have Rhodeia of Loch in your deck to add this card to your deck.)",
                "flavor": "The racing waters are a display of love toward a deceased deity.",
                "required": "oceanid",
                "id": '1A'        
            },
    
            "mirrorcage": {
                "name": "Mirror Cage",
                "tags": ['modify', 'talent', 'slowly'],
                "image": "/cards/i_n330526.webp",
                "golden_image": "/cards/i_n334526.webp",
                "hi_res_image": "/cards/i_n330526_gcg_high_resolution.webp",
                "cost": '3 Hydro',
                "description": "'Combat Action': When your active character is Mirror Maiden, equip this card.\n\nAfter Mirror Maiden equips this card, immediately use 'Elemental Skill: Influx Blast' once.\n\nWhen your Mirror Maiden, who has this card equipped, creates a 'Refraction', it will have the following effects: Starting 'Duration (Rounds)' +1, and it will increase the Elemental Dice Cost of switching from the character to which this is attached to another character by 1.\n\n(You must have Mirror Maiden in your deck to add this card to your deck.)",
                "flavor": "“Mirror, mirror, in my hand, where do our foes lurk in this land?”",
                "required": "mirrormaiden",
                "id": '1H'        
            },
            
            "paidinfull": {
                "name": "Paid in Full",
                "tags": ['modify', 'talent', 'slowly'],
                "image": "/cards/i_n330520.webp",
                "golden_image": "/cards/i_n334520.webp",
                "hi_res_image": "/cards/i_n330520_gcg_high_resolution.webp",
                "cost": '3 Pyro',
                "description": "'Combat Action': When your active character is Fatui Pyro Agent, equip this card.\n\nAfter Fatui Pyro Agent equips this card, immediately use 'Elemental Skill: Prowl' once.\n\nWhen your Fatui Pyro Agent, who has this card equipped, creates a 'Stealth', it will have the following effects: Starting Usage(s) +1, and the 'Physical DMG' the character this is attached to deals will be converted to 'Pyro DMG'.\n\n(You must have Fatui Pyro Agent in your deck to add this card to your deck.)",
                "flavor": "Remember this for so long as you live: You know who it is you owe, and you know when you must pay.",
                "required": "pyroagent",
                "id": '1B'        
            },
    
            "embersrekindled": {
                "name": "Embers Rekindled",
                "tags": ['modify', 'talent'],
                "image": "/cards/i_n330548.webp",
                "golden_image": "/cards/i_n334548.webp",
                "hi_res_image": "/cards/i_n330548_gcg_high_resolution.webp",
                "cost": '2 Pyro',
                "description": "When played: If Abyss Lector: Fathomless Flames, who equips this card, has already triggered Fiery Rebirth, immediately discard this card and apply Aegis of Abyssal Flame to the character.\n\nWhen Abyss Lector: Fathomless Flames, who has this card equipped, triggers Fiery Rebirth: discard this card and apply Aegis of Abyssal Flame to the character.\n\n(You must have Abyss Lector: Fathomless Flames in your deck to add this card to your deck.)",
                "flavor": 'The path toward sowing grace is not assured to be one free of obstructions.',
                'required': 'abysslector',
                'related': 'Aegis of Abyssal Flame',
                'id': '5C'
            },

            'scorpocalypse': { 
                'name': 'Scorpocalypse',
                'tags': ['modify', 'talent', 'slowly'],
                'hi_res_image': '/cards/i_n330567_gcg_high_resolution.webp',
                'image': '/cards/i_n330567.webp',
                'golden_image': '/cards/i_n334567.webp',
                'cost': '3 Pyro 2 Energy',
                'description': "Combat Action: When your active character is Eremite Scorching Loremaster, equip this card.\n\nAfter Eremite Scorching Loremaster equips this card, immediately use Spirit of Omen's Awakening: Pyro Scorpion once.\n\nSpirit of Omen: Pyro Scorpion created by Eremite Scorching Loremaster with this card equipped will deal +1 DMG in Rounds when Eremite Scorching Loremaster has used a Normal Attack or Elemental Skill.\n\nSpirit of Omen: Pyro Scorpion's DMG reduction effect can now be triggered twice per Round.\n\n(Your deck must contain Eremite Scorching Loremaster to add this card to it)",
                'flavor': "\"For the Eternal Oasis!\"",
                "required": "eremitescorchingloremaster",
                'id': '87',
            },
    
            "absorbingprism": {
                "name": "Absorbing Prism",
                "tags": ['modify', 'talent', 'slowly'],
                "image": "/cards/i_n330536.webp",
                "golden_image": "/cards/i_n334539.webp",
                "hi_res_image": "/cards/i_n330536_gcg_high_resolution.webp",
                "cost": '2 Electro',
                "description": "Combat Action: When your active character is Electro Hypostasis, heal that character for 3 HP and attach Electro Crystal Core to them. \n\n(You must have Electro Hypostasis in your deck to add this card to your deck.)",
                "flavor": '"Here\'s our chance!"\n"Hey, it\'s on our side!"',
                'required': 'electrohypostasis',
                'related': 'Electro Crystal Core',
                'id': '54'
            },

            'grievingecho': { 
                'name': 'Grieving Echo',
                'tags': ['modify', 'talent'],
                'hi_res_image': '/cards/i_n330568_gcg_high_resolution.webp',
                'image': '/cards/i_n330568.webp',
                'golden_image': '/cards/i_n334568.webp',
                'cost': '0 White',
                'description': "When your Thunder Manifestation, who has this card equipped, is on the field, when an opposing character affected by Lightning Rod takes DMG, you will draw 1 card.\n\n(You must have Thunder Manifestation in your deck to add this card to your deck)",
                'flavor': "That which drives the Thunder Manifestation is a much more primal fury...",
                "required": "thundermanifestation",
                'id': '88',
            },

            'pearlsolidification': { 
                'name': 'Pearl Solidification',
                'tags': ['modify', 'talent'],
                'hi_res_image': '/cards/i_n330574_gcg_high_resolution.webp',
                'image': '/cards/i_n330574.webp',
                'golden_image': '/cards/i_n334574.webp',
                'cost': '0 White',
                'description': "Can only be played if your active character is Millennial Pearl Seahorse: When entering play, Millennial Pearl Seahorse will have Fontemer Pearl with 1 Usage(s) attached to them. If they already have Fontemer Pearl attached, Usage(s) +1 instead. \n\nWhen the Fontemer Pearl attached to Millennial Pearl Seahorse negates DMG from Summons, change to Usage(s) not being consumed twice per Round. \n\n(Your deck must contain Millennial Pearl Seahorse to add this card to your deck)",
                'flavor': "Xenomare Pearl, Fontemer Hoarthunder... The seahorse-shaped phantasmal beast, though a solitary king, has neither an opulent court nor the ruins of one. What it does have, however, is the majesty and might to send other Fontemer Aberrants skittering away from it in terror...",
                "required": "seahorse",
                'id': '92',
            },
            
            "transcendentautomaton": {
                "name": "Transcendent Automaton",
                "tags": ['modify', 'talent', 'slowly'],
                "image": "/cards/i_n330521.webp",
                "golden_image": "/cards/i_n334521.webp",
                "hi_res_image": "/cards/i_n330521_gcg_high_resolution.webp",
                "cost": "3 Anemo",
                "description": "'Combat Action': When your active character is Maguu Kenki, equip this card.\n\nAfter Maguu Kenki equips this card, immediately use 'Elemental Skill: Blustering Blade' once.\n\nAfter your Maguu Kenki, who has this card equipped, uses 'Elemental Skill: Blustering Blade', you will switch to your next character. You will switch to your previous character when your Maguu Kenki, who has this card equipped, uses 'Special Elemental Skill: Frosty Assault'.\n\n(You must have Maguu Kenki in your deck to add this card to your deck.)",
                "flavor": "That unerring strike has been delivered countless times.",
                "required": "maguu",
                "id": '1C'        
            },

            'rendingvortex': { 
                'name': 'Rending Vortex',
                'tags': ['modify', 'talent', 'slowly'],
                'hi_res_image': '/cards/i_n330569_gcg_high_resolution.webp',
                'image': '/cards/i_n330569.webp',
                'golden_image': '/cards/i_n334569.webp',
                'cost': '3 Anemo',
                'description': "Combat Action: When your active character is Dvalin, equip this card.\n\nAfter Dvalin equips this card, immediately use Tempestuous Barrage once. \n\nWhen your Dvalin, who has this card equipped, is on the field, when Total Collapse attached to opposing character(s) is removed: Apply Total Collapse to the next opposing standby character. (Once per Round) \n\n(You must have Dvalinin your deck to add this card to your deck.)",
                'flavor': "But never forget that dust can be wiped away, and the power of doubt and poison can be shattered.",
                "required": "dvalin",
                'id': '89',
            },
            
            "stonehidereforged": {
                "name": "Stonehide Reforged",
                "tags": ['modify', 'talent', 'slowly'],
                "image": "/cards/i_n330522.webp",
                "golden_image": "/cards/i_n334522.webp",
                "hi_res_image": "/cards/i_n330522_gcg_high_resolution.webp",
                "cost": "4 Geo 2 Energy",
                "description": "'Combat Action': When your active character is Stonehide Lawachurl, equip this card.\n\nAfter Stonehide Lawachurl equips this card, immediately use 'Elemental Burst: Upa Shato' once.\n\nWhen your Stonehide Lawachurl, who has this card equipped, defeats an opposing character: Stonehide Lawachurl will re-attach 'Stonehide' and 'Stone Force'.\n\n(You must have Stonehide Lawachurl in your deck to add this card to your deck.)",
                "flavor": "An enduring force flows through that craggy form.",
                "required": "stonehidelawachurl",
                "id": '1D'        
            },

            'lunarcyclesunending': { 
                'name': 'Lunar Cycles Unending',
                'tags': ['modify', 'talent', 'slowly'],
                'hi_res_image': '/cards/i_n330570_gcg_high_resolution.webp',
                'image': '/cards/i_n330570.webp',
                'golden_image': '/cards/i_n334570.webp',
                'cost': '2 White',
                'description': "When your active character is Azhdaha, use this as a Combat Action: Attach Stone Facets: Elemental Crystallization to Azhdaha, then create 1 Elemental Die for each character on your side of the same Elemental Type as that character. \n\n(Deck must contain Azhdaha to add this card to it)",
                'flavor': "\"Today is the day... We settle this now!\"",
                "required": "azhdaha",
                'id': '8A',
            },
                    
            "proliferatingspores": {
                "name": "Proliferating Spores",
                "tags": ['modify', 'talent', 'slowly'],
                "image": "/cards/i_n330527.webp",
                "golden_image": "/cards/i_n334527.webp",
                "hi_res_image": "/cards/i_n330527_gcg_high_resolution.webp",
                "cost": '3 Dendro',
                "description": "'Combat Action': When your active character is Jadeplume Terrorshroom, equip this card.\n\nAfter Jadeplume Terrorshroom equips this card, immediately use 'Elemental Skill: Volatile Spore Cloud' once.\n\nYour Jadeplume Terrorshroom, who has this card equipped, can gain 1 more stack of Radical Vitality.\n\n(You must have Jadeplume Terrorshroom in your deck to add this card to your deck.)",
                "flavor": "Few can safely traverse the traps laid by the Fungus with intelligence above that of the average living being.",
                "required": "terrorshroom",
                "id": '1I'        
            },
            
            "magicguide": {
                "name": "Magic Guide",
                "tags": ['modify', 'weapon', 'weapon_catalyst'],
                "image": "/cards/i_n331000.webp",
                "golden_image": "/cards/i_n335000.webp",
                "hi_res_image": "/cards/i_n331000_gcg_high_resolution.webp",
                "cost": '2 White',
                "description": "The character deals +1 DMG.\n\n(Only Catalyst Characters can equip this. A character can equip a maximum of 1 Weapon)",
                "flavor": "The 12th edition of the Magic Guide.\nIt contains a great detail of errata, but nonetheless remains the most authoritative guide to magic in existence.",
                "id": '1J'
            },
            
            "sacrificialfragments": {
                "name": "Sacrificial Fragments",
                "tags": ['modify', 'weapon', 'weapon_catalyst'],
                "image": "/cards/i_n331001.webp",
                "golden_image": "/cards/i_n335001.webp",
                "hi_res_image": "/cards/i_n331001_gcg_high_resolution.webp",
                "cost": '3 White',
                "description": "The character deals +1 DMG.\n\nAfter the character uses an Elemental Skill: Create 1 Elemental Die of the same Elemental Type as this character. (Once per Round)\n\n(Only Catalyst Characters can equip this. A character can equip a maximum of 1 Weapon)",
                "flavor": "A weathered musical score, the content of which is no longer legible.",
                "id": '1K'        
            },
            
            "skywardatlas": {
                "name": "Skyward Atlas",
                "tags": ['modify', 'weapon', 'weapon_catalyst'],
                "image": "/cards/i_n331002.webp",
                "golden_image": "/cards/i_n335002.webp",
                "hi_res_image": "/cards/i_n331002_gcg_high_resolution.webp",
                "cost": '3 White',
                "description": "The character deals +1 DMG.\n\nOnce per Round: This character’s Normal Attacks deal +1 additional DMG.\n\n(Only Catalyst Characters can equip this. A character can equip a maximum of 1 Weapon)",
                "flavor": "Its full name is the “An atlas of the winds and clouds.”\nThis text records the winds and clouds of the northern lands’ skies in poetic and archival forms.",
                "id": '1L'        
            },
    
            "athousandfloatingdreams": {
                "name": "A Thousand Floating Dreams",
                "tags": ['modify', 'weapon', 'weapon_catalyst'],
                "image": "/cards/i_n331038.webp",
                "golden_image": "/cards/i_n335039.webp",
                "hi_res_image": "/cards/i_n331038_gcg_high_resolution.webp",
                "cost": '3 White',
                "description": "The character deals +1 DMG.\n\nWhen your character triggers an Elemental Reaction: Deal +1 DMG. (Twice per Round)\n\n(Only Catalyst Characters can equip this. A character can equip a maximum of 1 Weapon)",
                "flavor": '"There is an appointed time for all things to live and die, just like the ceaseless cycles of night and dawn."',
                'id': '5E'
            },

            "fruitoffulfillment": {
                "name": "Fruit of Fulfillment",
                "tags": ['modify', 'weapon', 'weapon_catalyst'],
                "image": "/cards/i_n331052.webp",
                "golden_image": "/cards/i_n335052.webp",
                "hi_res_image": "/cards/i_n331052_gcg_high_resolution.webp",
                "cost": '3 Black',
                "description": "Character deals +1 DMG.\n\nWhen played: Draw 2 cards.\n\n(Can only be equipped by Catalyst characters. Characters can equip at most 1 Weapon)",
                "flavor": '"Even the most bitter of stories contain courage and strength... the story of the good Golden Nara\'s adventures with us will help good Nara defend the forest."',
                'id': '6M'
            },

            'lostprayertothesacredwinds': { 
                'name': 'Lost Prayer to the Sacred Winds',
                'tags': ['modify', 'weapon', 'weapon_catalyst'],
                'hi_res_image': '/cards/i_n331058_gcg_high_resolution.webp',
                'image': '/cards/i_n331058.webp',
                'golden_image': '/cards/i_n335058.webp',
                'cost': '3 White',
                'description': "For each point of \"Bonus DMG\" this card has, character deals +1 DMG. \n\nEnd Phase: This card gains 1 point of \"Bonus DMG.\" (Max 2 points) \n\n(Can only be equipped by Catalyst Characters. Each Character can equip at most 1 Weapon.",
                'flavor': "\"When flowers bloom, when leaves sway, that is me who sings the songs of freedom, of the winds.\"",
                'id': '8B',
            },

            'tulaytullahsremembrance': { 
                'name': 'Tulaytullah\'s Remembrance',
                'tags': ['modify', 'weapon', 'weapon_catalyst'],
                'hi_res_image': '/cards/i_n331059_gcg_high_resolution.webp',
                'image': '/cards/i_n331059.webp',
                'golden_image': '/cards/i_n335059.webp',
                'cost': '3 White',
                'description': "The character deals +1 DMG. \n\nWhen the character uses a Charged Attack: Spend 1 less Unaligned Element. (Can be triggered up to twice per Round) \n\n(Only Catalyst Characters can equip this. A character can equip a maximum of 1 Weapon)",
                'flavor': "\"In the end, all people, good or evil, will find themselves ground beneath the wheels of fate, and the sapphire city would fade, dissipating like tears beneath the scorching sun.\"",
                'id': '8C',
            },
            
            "ravenbow": {
                "name": "Raven Bow",
                "tags": ['modify', 'weapon', 'weapon_bow'],
                "image": "/cards/i_n331003.webp",
                "golden_image": "/cards/i_n335003.webp",
                "hi_res_image": "/cards/i_n331003_gcg_high_resolution.webp",
                "cost": '2 White',
                "description": "The character deals +1 DMG.\n\n(Only Bow Characters can equip this. A character can equip a maximum of 1 Weapon)",
                "flavor": "Ravens are known to be the ferrymen of the dead. As such, hunters would decorate their bows’ limbs with feathers which forebode the imminent death of their targets.",
                "id": '1M'        
            },
            
            "sacrificialbow": {
                "name": "Sacrificial Bow",
                "tags": ['modify', 'weapon', 'weapon_bow'],
                "image": "/cards/i_n331004.webp",
                "golden_image": "/cards/i_n335004.webp",
                "hi_res_image": "/cards/i_n331004_gcg_high_resolution.webp",
                "cost": '3 White',
                "description": "The character deals +1 DMG.\n\nAfter the character uses an Elemental Skill: Create 1 Elemental Die of the same Elemental Type as this character. (Once per Round)\n\n(Only Bow Characters can equip this. A character can equip a maximum of 1 Weapon)",
                "flavor": "A ceremonial hunting bow that has seen the passage of many years. The trinkets on it are still visible.",
                "id": '1N'        
            },
            
            "skywardharp": {
                "name": "Skyward Harp",
                "tags": ['modify', 'weapon', 'weapon_bow'],
                "image": "/cards/i_n331005.webp",
                "golden_image": "/cards/i_n335005.webp",
                "hi_res_image": "/cards/i_n331005_gcg_high_resolution.webp",
                "cost": '3 White',
                "description": "The character deals +1 DMG.\n\nOnce per Round: This character’s Normal Attacks deal +1 additional DMG.\n\n(Only Bow Characters can equip this. A character can equip a maximum of 1 Weapon)",
                "flavor": "The sound of this sky-piercing lyre firing is music to the Anemo Archon’s ears.",
                "id": '1O'        
            },
    
            "amosbow": {
                "name": "Amos' Bow",
                "tags": ['modify', 'weapon', 'weapon_bow'],
                "image": "/cards/i_n331037.webp",
                "golden_image": "/cards/i_n335038.webp",
                "hi_res_image": "/cards/i_n331037_gcg_high_resolution.webp",
                "cost": '3 White',
                "description": "The character deals +1 DMG.\n\nWhen the character uses a Skill that costs at least a total of 5 Elemental Dice and Energy, +2 additional DMG. (Once per Round)\n\n(Only Bow Characters can equip this. A character can equip a maximum of 1 Weapon)",
                "flavor": '"I dreamt of ocean waves and sand, of lush forests and land."\n"I dreamt of boars playing in berry bushes, of a towering spire."',
                'id': '5D'
            },
    
            "elegyfortheend": {
                "name": "Elegy for the End",
                "tags": ['modify', 'weapon', 'weapon_bow'],
                "image": "/cards/i_n331039.webp",
                "golden_image": "/cards/i_n335040.webp",
                "hi_res_image": "/cards/i_n331039_gcg_high_resolution.webp",
                "cost": '3 White',
                "description": "The character deals +1 DMG.\n\nAfter the character uses an Elemental Burst: Create Millennial Movement: Farewell Song. (Your character deals +1 DMG, Duration (Rounds): 2)\n\n(Only Bow Characters can equip this. A character can equip a maximum of 1 Weapon)",
                "flavor": '"...But no wind in any season on earth"\n"Shall have you gaze upon me again."',
                'id': '5F'
            },

            "kingssquire": {
                "name": "King's Squire",
                "tags": ['modify', 'weapon', 'weapon_bow'],
                "image": "/cards/i_n331053.webp",
                "golden_image": "/cards/i_n335053.webp",
                "hi_res_image": "/cards/i_n331053_gcg_high_resolution.webp",
                "cost": '3 White',
                "description": "Character deals +1 DMG. \n\nWhen played: The character to which this is attached will spend 2 less Elemental Dice next time they use Elemental Skill or equip a Talent card. \n\n(Only Bow Characters can equip this. A character can equip a maximum of 1 Weapon.)",
                "flavor": 'A weapon from the stories of the Aranara, it has the shape of a bow.\n\n"Remember, this world is only the dream of the forest... Remember the forest\'s words, and pass the responsibility of protecting the forest on to more people."',
                'id': '6X'
            },
            
            "whiteirongreatsword": {
                "name": "White Iron Greatsword",
                "tags": ['modify', 'weapon', 'weapon_claymore'],
                "image": "/cards/i_n331006.webp",
                "golden_image": "/cards/i_n335006.webp",
                "hi_res_image": "/cards/i_n331006_gcg_high_resolution.webp",
                "cost": '2 White',
                "description": "The character deals +1 DMG.\n\n(Only Claymore Characters can equip this. A character can equip a maximum of 1 Weapon)",
                "flavor": "A lightweight greatsword made of white iron with a silver sheen.",
                "id": '1P'        
            },
            
            "sacrificialgreatsword": {
                "name": "Sacrificial Greatsword",
                "tags": ['modify', 'weapon', 'weapon_claymore'],
                "image": "/cards/i_n331007.webp",
                "golden_image": "/cards/i_n335007.webp",
                "hi_res_image": "/cards/i_n331007_gcg_high_resolution.webp",
                "cost": '3 White',
                "description": "The character deals +1 DMG.\n\nAfter the character uses an Elemental Skill: Create 1 Elemental Die of the same Elemental Type as this character. (Once per Round)\n\n(Only Claymore Characters can equip this. A character can equip a maximum of 1 Weapon)",
                "flavor": "This greatsword has seen the passage of many years, and was once owned by a clan of brave and gifted warriors who fought hard and died young.",
                "id": '1Q'        
            },
            
            "wolfsgravestone": {
                "name": "Wolf’s Gravestone",
                "tags": ['modify', 'weapon', 'weapon_claymore'],
                "image": "/cards/i_n331008.webp",
                "golden_image": "/cards/i_n335008.webp",
                "hi_res_image": "/cards/i_n331008_gcg_high_resolution.webp",
                "cost": '3 White',
                "description": "The character deals +1 DMG.\n\nDeal +2 additional DMG if the target’s remaining HP is equal to or less than 6.\n\n(Only Claymore Characters can equip this. A character can equip a maximum of 1 Weapon)",
                "flavor": "A longsword said to have been used by the knight of the north wind. It became endowed with legendary power owing to his friendship with the wolves.",
                "id": '1R'        
            },
    
            "skywardpride": {
                "name": "Skyward Pride",
                "tags": ['modify', 'weapon', 'weapon_claymore'],
                "image": "/cards/i_n331040.webp",
                "golden_image": "/cards/i_n335041.webp",
                "hi_res_image": "/cards/i_n331040_gcg_high_resolution.webp",
                "cost": '3 White',
                "description": "The character deals +1 DMG.\n\nOnce per Round: This character's Normal Attacks deal +1 additional DMG.\n\n(Only Claymore Characters can equip this. A character can equip a maximum of 1 Weapon)",
                "flavor": 'Sundering the courage of the skies and bearing the will to defend all, let the wind dragon bestow wrath upon its vile nemesis.',
                'id': '5G'
            },
    
            "thebell": {
                "name": "The Bell",
                "tags": ['modify', 'weapon', 'weapon_claymore'],
                "image": "/cards/i_n331041.webp",
                "golden_image": "/cards/i_n335042.webp",
                "hi_res_image": "/cards/i_n331041_gcg_high_resolution.webp",
                "cost": '3 White',
                "description": "The character deals +1 DMG.\n\nAfter the character uses a skill: Gives 1 Shield point to your active character. (Once per Round, stacks up to 2 points)\n\n(Only Claymore Characters can equip this. A character can equip a maximum of 1 Weapon)",
                "flavor": 'There once was a traitor who brandished a blade against his fallen clan.\nThough this individual was eventual cast out from his clan, rumor has that his organization continued their chosen duties.\nLegend claims that even the Wolf Pup Rostam might have been involved...',
                'id': '5H'
            },

            'beaconofthereedsea': { 
                'name': 'Beacon of the Reed Sea',
                'tags': ['modify', 'weapon', 'weapon_claymore'],
                'hi_res_image': '/cards/i_n331060_gcg_high_resolution.webp',
                'image': '/cards/i_n331060.webp',
                'golden_image': '/cards/i_n335060.webp',
                'cost': '3 White',
                'description': "The character deals +1 DMG. \n\nAfter the character uses an Elemental Skill: +1 additional DMG dealt by character this Round the next time they deal DMG. (Once per Round) \n\nAfter this character takes DMG: +1 additional DMG dealt by character this Round the next time they deal DMG. (Once per Round) \n\n(Only Claymore Characters can equip this. A character can equip a maximum of 1 Weapon)",
                'flavor': "\"On top of the ruins of the pool where the regalia of past executions of offenders was excavated, those who had lost the dream of the desert, yet were unwilling to give up their vast sea of sand gathered.\nIn the name of the Reed Sea that never existed, they connected with the dream that was promised to them...\"",
                'id': '8D',
            },
            
            "whitetassel": {
                "name": "White Tassel",
                "tags": ['modify', 'weapon', 'weapon_pole'],
                "image": "/cards/i_n331009.webp",
                "golden_image": "/cards/i_n335009.webp",
                "hi_res_image": "/cards/i_n331009_gcg_high_resolution.webp",
                "cost": '2 White',
                "description": "The character deals +1 DMG.\n\n(Only Polearm Characters can equip this. A character can equip a maximum of 1 Weapon)",
                "flavor": "A standard-issue weapon of the Millelith soldiers. It has a sturdy shaft and sharp spearhead. It’s a reliable weapon.",
                "id": '1S'        
            },
            
            "lithicspear": {
                "name": "Lithic Spear",
                "tags": ['modify', 'weapon', 'weapon_pole'],
                "image": "/cards/i_n331010.webp",
                "golden_image": "/cards/i_n335010.webp",
                "hi_res_image": "/cards/i_n331010_gcg_high_resolution.webp",
                "cost": '3 White',
                "description": "The character deals +1 DMG.\n\nWhen played: For each party member from Liyue, grant 1 'Shield' point to the character to which this is attached. (Max 3 points)\n\n(Only Polearm Characters can equip this. A character can equip a maximum of 1 Weapon)",
                "flavor": "These spears were forged from the rocks of the Guyun Stone Forest, and were favored by the Millelith of old. Their hardness knows no equal.",
                "id": '1T'        
            },
            
            "skywardspine": {
                "name": "Skyward Spine",
                "tags": ['modify', 'weapon', 'weapon_pole'],
                "image": "/cards/i_n331011.webp",
                "golden_image": "/cards/i_n335011.webp",
                "hi_res_image": "/cards/i_n331011_gcg_high_resolution.webp",
                "cost": '3 White',
                "description": "The character deals +1 DMG.\n\nOnce per Round: This character’s Normal Attacks deal +1 additional DMG.\n\n(Only Polearm Characters can equip this. A character can equip a maximum of 1 Weapon)",
                "flavor": "A spear that can hold up the skies. It was this unshakable resolve that sustained the wind dragon through its mortal battle against its vile nemesis.",
                "id": '1U'        
            },
    
            "vortexvanquisher": {
                "name": "Vortex Vanquisher",
                "tags": ['modify', 'weapon', 'weapon_pole'],
                "image": "/cards/i_n331042.webp",
                "golden_image": "/cards/i_n335043.webp",
                "hi_res_image": "/cards/i_n331042_gcg_high_resolution.webp",
                "cost": '3 White',
                "description": "The character deals +1 DMG.\n\nWhen protected by a Shield Character Status or a Shield Combat Status, the character deals +1 additional DMG.\n\nAfter the character uses a Elemental Skill: If you have a Combat Status that grants Shield on your side, add 1 Shield to that Combat Status. (Once per Round)\n\n(Only Polearm Characters can equip this. A character can equip a maximum of 1 Weapon)",
                "flavor": 'Folklore spoke of a vast shadow entrenched in the depths of the ocean capable of swallowing passing warships...\nAt tale\'s end, they believe that Rex Lapis once wielded a spear that pierced the rainbow, pinning the churning vortex that had once terrorized the oceans in the center of the deep sea.',
                'id': '5I'
            },
    
            "engulfinglightning": {
                "name": "Engulfing Lightning",
                "tags": ['modify', 'weapon', 'weapon_pole'],
                "image": "/cards/i_n331043.webp",
                "golden_image": "/cards/i_n335044.webp",
                "hi_res_image": "/cards/i_n331043_gcg_high_resolution.webp",
                "cost": '3 White',
                "description": "The character deals +1 DMG.\n\nTriggers automatically once per Round: If the character to which this is attached does not have Energy, they will gain 1 Energy.\n\n(Only Polearm Characters can equip this. A character can equip a maximum of 1 Weapon)",
                "flavor": 'The naginata was a lethal weapon by which scattered dross might be cut away.\nAnd the one who wielded that naginata was one who guarded the path to eternity.',
                'id': '5J'
            },

            "moonpiercer": {
                "name": "Moonpiercer",
                "tags": ['modify', 'weapon', 'weapon_pole'],
                "image": "/cards/i_n331054.webp",
                "golden_image": "/cards/i_n335054.webp",
                "hi_res_image": "/cards/i_n331054_gcg_high_resolution.webp",
                "cost": '3 White',
                "description": "Character deals +1 DMG.\n\nWhen played: The character to which this is attached will spend 2 less Elemental Dice next time they use an Elemental Skill or equip a Talent card.\n\n(Only Polearm Characters can equip this. A character can equip a maximum of 1 Weapon.)",
                "flavor": '"Children fascinated by the moon will weep when they gaze upon it, for the moon has turned into fine sand and entered their eyes. In many stories, no tears are shed in vain."',
                'id': '78'
            },

            'primordialjadewinged-spear': { 
                'name': 'Primordial Jade Winged-Spear',
                'tags': ['modify', 'weapon', 'weapon_pole'],
                'hi_res_image': '/cards/i_n331061_gcg_high_resolution.webp',
                'image': '/cards/i_n331061.webp',
                'golden_image': '/cards/i_n335061.webp',
                'cost': '3 White',
                'description': "The character deals +1 DMG. \n\nAfter this character uses a Skill: Until the end of this turn, +1 additional DMG provided by this card. (Up to +2 DMG total.) \n\n(Only Polearm Characters can equip this. A character can equip a maximum of 1 Weapon)",
                'flavor': "\"The stone bird took to the unbound skies once forged. Into the heart of the ocean it dove, into the battlefield with the behemoth and the whale. Into the depths of the sea the behemoth sank, there to stay forever. Released from its thundering roars were the people of Liyue.\"",
                'id': '8E',
            },
            
            "travelershandysword": {
                "name": "Traveler’s Handy Sword",
                "tags": ['modify', 'weapon', 'weapon_sword'],
                "image": "/cards/i_n331012.webp",
                "golden_image": "/cards/i_n335012.webp",
                "hi_res_image": "/cards/i_n331012_gcg_high_resolution.webp",
                "cost": '2 White',
                "description": "The character deals +1 DMG.\n\n(Only Sword Characters can equip this. A character can equip a maximum of 1 Weapon)",
                "flavor": "A handy steel sword that contains all manner of useful items in its sheath.",
                "id": '1V'        
            },
            
            "sacrificialsword": {
                "name": "Sacrificial Sword",
                "tags": ['modify', 'weapon', 'weapon_sword'],
                "image": "/cards/i_n331013.webp",
                "golden_image": "/cards/i_n335013.webp",
                "hi_res_image": "/cards/i_n331013_gcg_high_resolution.webp",
                "cost": '3 White',
                "description": "The character deals +1 DMG.\n\nAfter the character uses an Elemental Skill: Create 1 Elemental Die of the same Elemental Type as this character. (Once per Round)\n\n(Only Sword Characters can equip this. A character can equip a maximum of 1 Weapon)",
                "flavor": "This blade was just a prop before its blade was sharpened by the passage of time.",
                "id": '1W'        
            },
            
            "aquilafavonia": {
                "name": "Aquila Favonia",
                "tags": ['modify', 'weapon', 'weapon_sword'],
                "image": "/cards/i_n331014.webp",
                "golden_image": "/cards/i_n335014.webp",
                "hi_res_image": "/cards/i_n331014_gcg_high_resolution.webp",
                "cost": '3 White',
                "description": "The character deals +1 DMG.\n\nAfter the opposing character uses a Skill: If the character with this attached is the active character, heal this character for 1 HP. (Max twice per Round)\n\n(Only Sword Characters can equip this. A character can equip a maximum of 1 Weapon)",
                "flavor": "This sword was ever at the hip of the warrior from another land, and it bore witness to her achievement in spreading justice and freedom across Mondstadt.",
                "id": '1X'        
            },

            "skywardblade": {
                "name": "Skyward Blade",
                "tags": ['modify', 'weapon', 'weapon_sword'],
                "image": "/cards/i_n331044.webp",
                "golden_image": "/cards/i_n335045.webp",
                "hi_res_image": "/cards/i_n331044_gcg_high_resolution.webp",
                "cost": '3 White',
                "description": "The character deals +1 DMG.\n\nOnce per Round: This character's Normal Attacks deal +1 additional DMG.\n\n(Only Sword Characters can equip this. A character can equip a maximum of 1 Weapon)",
                "flavor": 'The sky-piercing fang. With nemesis vanquished, the wind dragon fell into a deep slumber.\nCenturies passed, and the people of Mondstadt gradually forgot Dvalin\'s desperate struggle.\nThis sword represents the oath offered toward the restoration of Dvalin\'s reputation.',
                'id': '5K'
            },
    
            "favoniussword": {
                "name": "Favonius Sword",
                "tags": ['modify', 'weapon', 'weapon_sword'],
                "image": "/cards/i_n331045.webp",
                "golden_image": "/cards/i_n335037.webp",
                "hi_res_image": "/cards/i_n331045_gcg_high_resolution.webp",
                "cost": '3 White',
                "description": "The character deals +1 DMG.\n\nAfter the character uses an Elemental Skill: The character gains 1 additional Energy. (Once per Round)\n\n(Only Sword Characters can equip this. A character can equip a maximum of 1 Weapon)",
                "flavor": "\"Legend has it that the knight that bore the title of Wolf Pup could cleave even raindrops with his blade, and the gales spurred by his blows were strong enough to snap roses. Though none could match the heights of the Wolf Pup's prowess, the knights bear his oath of protection yet, his legacy lasting even to the present.\"",
                "id": '4L'
            },

            'lightoffoliarincision': { 
                'name': 'Light of Foliar Incision',
                'tags': ['modify', 'weapon', 'weapon_sword'],
                'hi_res_image': '/cards/i_n331062_gcg_high_resolution.webp',
                'image': '/cards/i_n331062.webp',
                'golden_image': '/cards/i_n335062.webp',
                'cost': '3 White',
                'description': "The character deals +1 DMG. \n\nAfter the character uses a Normal Attack: Create 1 random Elemental Die. (Can be triggered up to twice per Round) \n\n(Only Sword Characters can equip this. A character can equip a maximum of 1 Weapon)",
                'flavor': "\"If you believe that he yet has the potential to reclaim his honor in the maze, then guide him to break off the pale branch...\nOnly then can the bright moon and the newborn stars grant him pure wisdom and help him shed his bitter memories and desires.\"",
                'id': '8F',
            },

            'sapwoodblade': { 
                'name': 'Sapwood Blade',
                'tags': ['modify', 'weapon', 'weapon_sword'],
                'hi_res_image': '/cards/i_n331068_gcg_high_resolution.webp',
                'image': '/cards/i_n331068.webp',
                'golden_image': '/cards/i_n335068.webp',
                'cost': '3 Black',
                'description': "The character deals +1 DMG. \n\nWhen entering play: When the character to which this is attached next uses a Normal Attack during this Round: Create 2 Elemental Dice of this character's Elemental Type. \n\n(Only Sword Characters can equip this. A character can equip a maximum of 1 Weapon)",
                'flavor': "\"...Even so, your stories and mine will leave their traces in the depths of the desert, like the footprints of the Forest Kind.\"\n\"So shall past friendships peacefully sleep, like an Aranara transformed into a seed.\"",
                'id': '93',
            },
            
            "adventurersbandana": {
                "name": "Adventurer’s Bandana",
                "tags": ['modify', 'artifact'],
                "image": "/cards/i_n331015.webp",
                "golden_image": "/cards/i_n335015.webp",
                "hi_res_image": "/cards/i_n331015_gcg_high_resolution.webp",
                "cost": '1 White',
                "description": "After this character uses a Normal Attack: Heal self for 1 HP. (Max 3 times per Round)\n\n(A character can equip a maximum of 1 Artifact)",
                "flavor": "“All the secrets of the stars and the abyss await discovery by mere mortals.”",
                "id": '1Y'        
            },
            
            "luckydogssilvercirclet": {
                "name": "Lucky Dog’s Silver Circlet",
                "tags": ['modify', 'artifact'],
                "image": "/cards/i_n331016.webp",
                "golden_image": "/cards/i_n335016.webp",
                "hi_res_image": "/cards/i_n331016_gcg_high_resolution.webp",
                "cost": '2 Black',
                "description": "After this character uses an Elemental Skill: Heal self for 2 HP. (Once per Round)\n\n(A character can equip a maximum of 1 Artifact)",
                "flavor": "“One who is favored by fortune can even find priceless treasures in the most deadly of traps.”",
                "id": '1Z'        
            },
            
            "travelingdoctorshandkerchief": {
                "name": "Traveling Doctor’s Handkerchief",
                "tags": ['modify', 'artifact'],
                "image": "/cards/i_n331017.webp",
                "golden_image": "/cards/i_n335017.webp",
                "hi_res_image": "/cards/i_n331017_gcg_high_resolution.webp",
                "cost": '1 White',
                "description": "After this character uses an Elemental Burst: Heal all your characters for 1 HP. (Once per Round)\n\n(A character can equip a maximum of 1 Artifact)",
                "flavor": "“Come sun or rain, nothing could stay the traveling doctor’s steps.”",
                "id": '20'        
            },
            
            "gamblersearrings": {
                "name": "Gambler’s Earrings",
                "tags": ['modify', 'artifact'],
                "image": "/cards/i_n331018.webp",
                "golden_image": "/cards/i_n335018.webp",
                "hi_res_image": "/cards/i_n331018_gcg_high_resolution.webp",
                "cost": '1 White',
                "description": "After an opposing character is defeated: If the character this card is attached to is the active character, create 'Omni Element' ×2.(Can happen 3 times per match)\n\n(A character can equip a maximum of 1 Artifact)",
                "flavor": "“In games where one gambles with life and death, remaining calm and composed is key to increasing one’s odds of victory.”",
                "id": '21'          
            },
            
            "instructorscap": {
                "name": "Instructor’s Cap",
                "tags": ['modify', 'artifact'],
                "image": "/cards/i_n331019.webp",
                "golden_image": "/cards/i_n335019.webp",
                "hi_res_image": "/cards/i_n331019_gcg_high_resolution.webp",
                "cost": '2 Black',
                "description": "After this character triggers an Elemental Reaction: Create 1 Elemental Die that matches this Character’s Elemental Type. (Max 3 times per Round)\n\n(A character can equip a maximum of 1 Artifact)",
                "flavor": "“I don’t have the talent to command an army as its general, nor am I qualified for anything beyond being a soldier.”\n“All I can do is to be a strict instructor to these children, so that they might survive on the battlefield a bit longer.”",
                "id": '22'        
            },
            
            "exilescirclet": {
                "name": "Exile’s Circlet",
                "tags": ['modify', 'artifact'],
                "image": "/cards/i_n331020.webp",
                "golden_image": "/cards/i_n335020.webp",
                "hi_res_image": "/cards/i_n331020_gcg_high_resolution.webp",
                "cost": '2 Black',
                "description": "After this character uses an Elemental Burst: All your characters on standby gain 1 Energy. (Once per Round)\n\n(A character can equip a maximum of 1 Artifact)",
                "flavor": "“Woe to thee, oh great hall with silver piled high! Why is your crown drenched in blood?”",
                "id": '23'        
            },
    
            "ornatekabuto": {
                "name": "Ornate Kabuto",
                "tags": ['modify', 'artifact'],
                "image": "/cards/i_n331035.webp",
                "golden_image": "/cards/i_n335035.webp",
                "hi_res_image": "/cards/i_n331035_gcg_high_resolution.webp",
                "cost": '1 White',
                "description": "After another character of yours uses an Elemental Burst: The character to which this is attached gains 1 Energy. (A character can equip a maximum of 1 Artifact)",
                "flavor": "",
                "id": '4D'        
            },
    
            "emblemofseveredfate": {
                "name": "Emblem of Severed Fate",
                "tags": ['modify', 'artifact'],
                "image": "/cards/i_n331046.webp",
                "golden_image": "/cards/i_n335046.webp",
                "hi_res_image": "/cards/i_n331046_gcg_high_resolution.webp",
                "cost": '2 White',
                "description": "After another character of yours uses an Elemental Burst: The character to which this is attached gains 1 Energy.\n\nThe DMG dealt by the character's Elemental Bursts is increased by 2 (once per Round).\n\n(A character can equip a maximum of 1 Artifact)",
                "flavor": 'Thirteen years went by like a dream.\nThe scarlet snow flies through the shadowed pass like smoke.\nYou have now gone afar.',
                'id': '5L'
            },
    
            "generalsancienthelm": {
                "name": "General's Ancient Helm",
                "tags": ['modify', 'artifact'],
                "image": "/cards/i_n331036.webp",
                "golden_image": "/cards/i_n335036.webp",
                "hi_res_image": "/cards/i_n331036_gcg_high_resolution.webp",
                "cost": '2 White',
                "description": "When Action Phase begins: Grant 2 Shield Points to attached characters. (A character can equip a maximum of 1 Artifact)",
                "flavor": "",
                "id": '4E' 
            },
    
            "tenacityofthemillelith": {
                "name": "Tenacity of the Millelith",
                "tags": ['modify', 'artifact'],
                "image": "/cards/i_n331047.webp",
                "golden_image": "/cards/i_n335047.webp",
                "hi_res_image": "/cards/i_n331047_gcg_high_resolution.webp",
                "cost": '3 White',
                "description": "When Action Phase begins: The character to which this is attached gains Unmovable Mountain that provides 2 Shield points.\n\nAfter this character takes DMG: If this character is the active character, Create 1 Elemental Die matching this character's Elemental Type. (Once per Round)\n\n(A character can equip a maximum of 1 Artifact)",
                "flavor": '"...To ensure that the afflicted civilians could safely escape, and to maintain their honor in the eyes of the Lord of Geo, the helmet-clad troops of the front line took the lead, pointing their spears towards the Abyss and charging into battle."',
                'id': '5M',
            },
    
            "thunderingpoise": {
                "name": "Thundering Poise",
                "tags": ['modify', 'artifact'],
                "image": "/cards/i_n331048.webp",
                "golden_image": "/cards/i_n335048.webp",
                "hi_res_image": "/cards/i_n331048_gcg_high_resolution.webp",
                "cost": '2 Black',
                "description": "When a character uses a Normal Attack or equips a Talent: Spend 1 less Elemental Die. (Once per Round)\n\n(A character can equip a maximum of 1 Artifact)",
                "flavor": '"...Tianqiu once played host to a Yaksha, four-armed and mighty."\n"He came to The Chasm from afar, to the praises of the tribes."',
                'id': '5N'
            },
    
            "vermillionhereafter": {
                "name": "Vermillion Hereafter",
                "tags": ['modify', 'artifact'],
                "image": "/cards/i_n331049.webp",
                "golden_image": "/cards/i_n335049.webp",
                "hi_res_image": "/cards/i_n331049_gcg_high_resolution.webp",
                "cost": '3 Black',
                "description": "When a character uses a Normal Attack or equips a Talent: Spend 1 less Elemental Die. (Once per Round)\n\nAfter a character is switched to the active character: During this Round, character deals +1 Normal Attack DMG.\n\n(A character can equip a maximum of 1 Artifact)",
                "flavor": '"...Tianqiu once played host to a Yaksha, four-armed and mighty."\n"He came to The Chasm from afar, to the praises of the tribes."',
                'id': '5O'
            },
            "capriciousvisage": {
                "name": "Capricious Visage",
                "tags": ['modify', 'artifact'],
                "image": "/cards/i_n331050.webp",
                "golden_image": "/cards/i_n335050.webp",
                "hi_res_image": "/cards/i_n331050_gcg_high_resolution.webp",
                "cost": '2 Black',
                "description": "When a character uses an Elemental Skill or equips a Talent: Spend 1 less die. (Once per Round)\n\n(A character can equip a maximum of 1  Artifact)",
                "flavor": 'Even a faint smile could not conceal her sorrow.\nThough this is a festive day, it seems more like a farewell...',
                'id': '5P'
            },
            "shimenawasreminiscence": {
                "name": "Shimenawa's Reminiscence",
                "tags": ['modify', 'artifact'],
                "image": "/cards/i_n331051.webp",
                "golden_image": "/cards/i_n335051.webp",
                "hi_res_image": "/cards/i_n331051_gcg_high_resolution.webp",
                "cost": '3 Black',
                "description": "When a character uses an Elemental Skill or equips a Talent: Spend 1 less die. (Once per Round)\n\nIf the character had at least 2 Energy, this character's Normal Attacks and Elemental Skills will deal +1 DMG.\n\n(A character can equip a maximum of 1 Artifact)",
                "flavor": '"...Losing one\'s memory is no different from losing one\'s life. It is like death amidst darkness eternal."\n"Life is full of uncertainty. Love is fleeting, and even lasting memories may be lost..."',
                'id': '5Q'
            },
            "crownofwatatsumi": {
                "name": "Crown of Watatsumi",
                "tags": ['modify', 'artifact'],
                "image": "/cards/i_n331055.webp",
                "golden_image": "/cards/i_n335055.webp",
                "hi_res_image": "/cards/i_n331055_gcg_high_resolution.webp",
                "cost": '1 White',
                "description": "For every 3 HP of healing your characters receive, this card accumulates 1 Sea-Dyed Foam (maximum of 2).\n\nWhen this character deals DMG: Consume all Sea-Dyed Foam. DMG is increased by 1 for each Sea-Dyed Foam consumed.\n\n(A character can equip a maximum of 1 Artifact)",
                "flavor": '"Bringing hopes and memories from the depths, permeating long-lost civilizations and history, these graceful and exquisite crowns slide into the forgotten rifts with their owners."',
                'id': '79'
            },

            "oceanhuedclam": {
                "name": "Ocean Hued Clam",
                "tags": ['modify', 'artifact'],
                "image": "/cards/i_n331056.webp",
                "golden_image": "/cards/i_n335056.webp",
                "hi_res_image": "/cards/i_n331056_gcg_high_resolution.webp",
                "cost": '3 Black',
                "description": "For every 3 HP of healing your characters receive, this card accumulates 1 Sea-Dyed Foam (maximum of 2).\n\nWhen this character deals DMG: Consume all Sea-Dyed Foam. DMG is increased by 1 for each Sea-Dyed Foam consumed.\n\n(A character can equip a maximum of 1 Artifact)",
                "flavor": '"Bringing hopes and memories from the depths, permeating long-lost civilizations and history, these graceful and exquisite crowns slide into the forgotten rifts with their owners."',
                'id': '7K'
            },

            "shadowofthesandking": {
                "name": "Shadow of the Sand King",
                "tags": ['modify', 'artifact'],
                "image": "/cards/i_n331057.webp",
                "golden_image": "/cards/i_n335057.webp",
                "hi_res_image": "/cards/i_n331057_gcg_high_resolution.webp",
                "cost": '1 White',
                "description": "For every 3 HP of healing your characters receive, this card accumulates 1 Sea-Dyed Foam (maximum of 2).\n\nWhen this character deals DMG: Consume all Sea-Dyed Foam. DMG is increased by 1 for each Sea-Dyed Foam consumed.\n\n(A character can equip a maximum of 1 Artifact)",
                "flavor": '"Bringing hopes and memories from the depths, permeating long-lost civilizations and history, these graceful and exquisite crowns slide into the forgotten rifts with their owners."',
                'id': '7L'
            },

            'gildeddreams': { 
                'name': 'Gilded Dreams',
                'tags': ['modify', 'artifact'],
                'hi_res_image': '/cards/i_n331063_gcg_high_resolution.webp',
                'image': '/cards/i_n331063.webp',
                'golden_image': '/cards/i_n335063.webp',
                'cost': '3 White',
                'description': "When played: Generate 1 Die of the same Element as the attached character. If you have 3 different Elemental Types in your party, generate 1 Omni Element in addition to this. \n\nWhen the character to which this card is attached is your active character, then when an opposing character takes Elemental Reaction DMG: Draw 1 card. (Up to twice per Round) \n\n(A character can equip a maximum of 1 Artifact)",
                'flavor': "\"Some time later, absurd decisions would be issued alongside illusory madness, using lovely expectations as bait to lead the people towards a bitter end.\"",
                'id': '8G',
            },

            'flowingrings': { 
                'name': 'Flowing Rings',
                'tags': ['modify', 'artifact'],
                'hi_res_image': '/cards/i_n331064_gcg_high_resolution.webp',
                'image': '/cards/i_n331064.webp',
                'golden_image': '/cards/i_n335064.webp',
                'cost': '0 White',
                'description': "After the character uses a Normal Attack: Draw 1 card. (Once per Round) \n\n(A character can equip a maximum of 1 Artifact)",
                'flavor': "\"...And the stone that had been lost to the waters may have been a lesser jade, or perhaps just a simple cup. Some even say that the \"jade\" in the tale is in fact an analogy for a beautiful person.\"",
                'id': '8H',
            },

            'echoesofanoffering': { 
                'name': 'Echoes of an Offering',
                'tags': ['modify', 'artifact'],
                'hi_res_image': '/cards/i_n331065_gcg_high_resolution.webp',
                'image': '/cards/i_n331065.webp',
                'golden_image': '/cards/i_n335065.webp',
                'cost': '2 White',
                'description': "After this character uses Normal Attack: Draw 1 card. (Once per Round) \n\nAfter this character uses a Skill: If you have fewer Elemental Dice than cards in your Hand, you will gain 1 Elemental Die of the attached character's Type. (Once per Round) \n\n(A character can equip a maximum of 1 Artifact)",
                'flavor': "\"The wide river of a legend will oft produce many tributaries. One of these goes like this: This gem was once jade from a sacred mountain, carved into its current shape only by the hand of Rex Lapis himself.\"", 
                'id': '8I',
            },

            'heartofkhvarenasbrilliance': { 
                'name': 'Heart of Khvarena\'s Brilliance',
                'tags': ['modify', 'artifact'],
                'hi_res_image': '/cards/i_n331066_gcg_high_resolution.webp',
                'image': '/cards/i_n331066.webp',
                'golden_image': '/cards/i_n335066.webp',
                'cost': '0 White',
                'description': "After this character takes DMG: If the character to which this is attached is the active character, then draw 1 card. (Once per Round) \n\n(A character can equip a maximum of 1 Artifact)",
                'flavor': "\"If the darkness of death did not threaten it, no life would have any importance.\nIf the waves of forgetfulness did not surge against them, there would be no histories worth recording...\"",
                'id': '8J',
            },

            'vourukashasglow': { 
                'name': 'Vourukasha\'s Glow',
                'tags': ['modify', 'artifact'],
                'hi_res_image': '/cards/i_n331067_gcg_high_resolution.webp',
                'image': '/cards/i_n331067.webp',
                'golden_image': '/cards/i_n335067.webp',
                'cost': '1 White',
                'description': "After this character takes DMG: If the character to which this is attached is the active character, then draw 1 card. (Once per Round) \n\nEnd Phase: Heal the attached character for 1 HP. \n\n(A character can equip a maximum of 1 Artifact)",
                'flavor': "\"Many spirits dwell in the sea, and they carry the wishes of grass, tree, and dew, cleansing all filth.\nMany spirits dwell in the sea, and they sing of the three mothers — of verdure, of sweet dew, and fresh flowers.\"",
                'id': '8K',
            },

            'veteransvisage': { 
                'name': 'Veteran\'s Visage',
                'tags': ['modify', 'artifact'],
                'hi_res_image': '/cards/i_n331069_gcg_high_resolution.webp',
                'image': '/cards/i_n331069.webp',
                'golden_image': '/cards/i_n335069.webp',
                'cost': '2 Black',
                'description': "After this character takes DMG or is healed: Based on the number of times this effect has been triggered this Round, the effects will be different. \n\nFirst Trigger: Create 1 Elemental Die of the character's Elemental Type. \n\nSecond Trigger: Draw 1 card. \n\n(A character can equip a maximum of 1 Artifact)",
                'flavor': "\"Yet even though the scars can be covered, the wounds laid on one's heart will not disappear.\"",
                'id': '94',
            },
            
            "brokenrimesecho": {
                "name": "Broken Rime’s Echo",
                "tags": ['modify', 'artifact'],
                "image": "/cards/i_n331021.webp",
                "golden_image": "/cards/i_n335021.webp",
                "hi_res_image": "/cards/i_n331021_gcg_high_resolution.webp",
                "cost": '2 Black',
                "description": "When a character uses a Skill or equips a Talent: Spend 1 less Cryo Die. (Once per Round)\n\n(A character can equip a maximum of 1 Artifact)",
                "flavor": "“Past the ice-sealed door, walking down the corridors to the depths, he will break off a branch of silver-white, and bring hope to the snowy land.”",
                "id": '24'        
            },
            
            "blizzardstrayer": {
                "name": "Blizzard Strayer",
                "tags": ['modify', 'artifact'],
                "image": "/cards/i_n331022.webp",
                "golden_image": "/cards/i_n335022.webp",
                "hi_res_image": "/cards/i_n331022_gcg_high_resolution.webp",
                "cost": '2 White',
                "description": "When a character uses a Skill or equips a Talent: Spend 1 less Cryo Die. (Once per Round)\n\nRoll Phase: 2 of the starting Elemental Dice you roll are always guaranteed to be Cryo Dice.\n\n(A character can equip a maximum of 1 Artifact)",
                "flavor": "“…Then please, live on. Do not accompany us unto our doom — to languish forgotten in the snow.”",
                "id": '25'        
            },
            
            "winestainedtricorne": {
                "name": "Wine-Stained Tricorne",
                "tags": ['modify', 'artifact'],
                "image": "/cards/i_n331023.webp",
                "golden_image": "/cards/i_n335023.webp",
                "hi_res_image": "/cards/i_n331023_gcg_high_resolution.webp",
                "cost": '2 Black',
                "description": "When a character uses a Skill or equips a Talent: Spend 1 less Hydro Die. (Once per Round)\n\n(A character can equip a maximum of 1 Artifact)",
                "flavor": "“The wine-sodden sea hat was thrust by a storm into the sky, and then carried away on the roiling waves, while those fated to lose their homelands engaged in battles bereft of hope and want.”",
                "id": '26'        
            },
            
            "heartofdepth": {
                "name": "Heart of Depth",
                "tags": ['modify', 'artifact'],
                "image": "/cards/i_n331024.webp",
                "golden_image": "/cards/i_n335024.webp",
                "hi_res_image": "/cards/i_n331024_gcg_high_resolution.webp",
                "cost": '2 White',
                "description": "When a character uses a Skill or equips a Talent: Spend 1 less Hydro Die. (Once per Round)\n\nRoll Phase: 2 of the starting Elemental Dice you roll are always guaranteed to be Hydro Dice.\n\n(A character can equip a maximum of 1 Artifact)",
                "flavor": "“For all deaths are in vain. There is no saving those who indulge in the past.”",
                "id": '27'        
            },
            
            "witchsscorchinghat": {
                "name": "Witch’s Scorching Hat",
                "tags": ['modify', 'artifact'],
                "image": "/cards/i_n331025.webp",
                "golden_image": "/cards/i_n335025.webp",
                "hi_res_image": "/cards/i_n331025_gcg_high_resolution.webp",
                "cost": '2 Black',
                "description": "When a character uses a Skill or equips a Talent: Spend 1 less Pyro Die. (Once per Round)\n\n(A character can equip a maximum of 1 Artifact)",
                "flavor": "“…You ashes who dance so wildly, answer me — why have you taken all that I love?”",
                "id": '28'        
            },
            
            "crimsonwitchofflames": {
                "name": "Crimson Witch of Flames",
                "tags": ['modify', 'artifact'],
                "image": "/cards/i_n331026.webp",
                "golden_image": "/cards/i_n335026.webp",
                "hi_res_image": "/cards/i_n331026_gcg_high_resolution.webp",
                "cost": '2 White',
                "description": "When a character uses a Skill or equips a Talent: Spend 1 less Pyro Die. (Once per Round)\n\nRoll Phase: 2 of the starting Elemental Dice you roll are always guaranteed to be Pyro Dice.\n\n(A character can equip a maximum of 1 Artifact)",
                "flavor": "“I will sing no elegies. I refuse laments. I shall not sigh. I have no use for pointless noise.\nIf justice is long dead, then to whom can I offer redemption?”",
                "id": '29'        
            },
            
            "thundersummonerscrown": {
                "name": "Thunder Summoner’s Crown",
                "tags": ['modify', 'artifact'],
                "image": "/cards/i_n331027.webp",
                "golden_image": "/cards/i_n335027.webp",
                "hi_res_image": "/cards/i_n331027_gcg_high_resolution.webp",
                "cost": '2 Black',
                "description": "When a character uses a Skill or equips a Talent: Spend 1 less Electro Die. (Once per Round)\n\n(A character can equip a maximum of 1 Artifact)",
                "flavor": "“The song pierced the storm’s low hum, ripped through the clouds, and bestowed upon it, light.”",
                "id": '2A'        
            },
            
            "thunderingfury": {
                "name": "Thundering Fury",
                "tags": ['modify', 'artifact'],
                "image": "/cards/i_n331028.webp",
                "golden_image": "/cards/i_n335028.webp",
                "hi_res_image": "/cards/i_n331028_gcg_high_resolution.webp",
                "cost": '2 White',
                "description": "When a character uses a Skill or equips a Talent: Spend 1 less Electro Die. (Once per Round)\n\nRoll Phase: 2 of the starting Elemental Dice you roll are always guaranteed to be Electro Dice.\n\n(A character can equip a maximum of 1 Artifact)",
                "flavor": "“Then I shall sing you another tune — when you come again with thunder and rain!”",
                "id": '2B'        
            },
            
            "viridescentvenerersdiadem": {
                "name": "Viridescent Venerer’s Diadem",
                "tags": ['modify', 'artifact'],
                "image": "/cards/i_n331029.webp",
                "golden_image": "/cards/i_n335029.webp",
                "hi_res_image": "/cards/i_n331029_gcg_high_resolution.webp",
                "cost": '2 Black',
                "description": "When a character uses a Skill or equips a Talent: Spend 1 less Anemo Die. (Once per Round)\n\n(A character can equip a maximum of 1 Artifact)",
                "flavor": "“None could ever bestow a crown upon the queen of hunters, for only earth and heaven were higher than she.”",
                "id": '2C'        
            },
            
            "viridescentvenerer": {
                "name": "Viridescent Venerer",
                "tags": ['modify', 'artifact'],
                "image": "/cards/i_n331030.webp",
                "golden_image": "/cards/i_n335030.webp",
                "hi_res_image": "/cards/i_n331030_gcg_high_resolution.webp",
                "cost": '2 White',
                "description": "When a character uses a Skill or equips a Talent: Spend 1 less Anemo Die. (Once per Round)\n\nRoll Phase: 2 of the starting Elemental Dice you roll are always guaranteed to be Anemo Dice.\n\n(A character can equip a maximum of 1 Artifact)",
                "flavor": "“One day, in those boundless hunting grounds… we will meet again.”",
                "id": '2D'        
            },
            
            "maskofsolitudebasalt": {
                "name": "Mask of Solitude Basalt",
                "tags": ['modify', 'artifact'],
                "image": "/cards/i_n331031.webp",
                "golden_image": "/cards/i_n335031.webp",
                "hi_res_image": "/cards/i_n331031_gcg_high_resolution.webp",
                "cost": '2 Black',
                "description": "When a character uses a Skill or equips a Talent: Spend 1 less Geo Die. (Once per Round)\n\n(A character can equip a maximum of 1 Artifact)",
                "flavor": "“He knew right from wrong, and he never missed his mark.”",
                "id": '2E'        
            },
            
            "archaicpetra": {
                "name": "Archaic Petra",
                "tags": ['modify', 'artifact'],
                "image": "/cards/i_n331032.webp",
                "golden_image": "/cards/i_n335032.webp",
                "hi_res_image": "/cards/i_n331032_gcg_high_resolution.webp",
                "cost": '2 White',
                "description": "When a character uses a Skill or equips a Talent: Spend 1 less Geo Die. (Once per Round)\n\nRoll Phase: 2 of the starting Elemental Dice you roll are always guaranteed to be Geo Dice.\n\n(A character can equip a maximum of 1 Artifact)",
                "flavor": "“While the Millelith stands guard, evil shall never prevail!”",
                "id": '2F'        
            },
            
            "laurelcoronet": {
                "name": "Laurel Coronet",
                "tags": ['modify', 'artifact'],
                "image": "/cards/i_n331033.webp",
                "golden_image": "/cards/i_n335033.webp",
                "hi_res_image": "/cards/i_n331033_gcg_high_resolution.webp",
                "cost": '2 Black',
                "description": "When a character uses a Skill or equips a Talent: Spend 1 less Dendro Die. (Once per Round)\n\n(A character can equip a maximum of 1 Artifact)",
                "flavor": "“There is a time appointed for all things to live and die, and the cycle continues on forever.”",
                "id": '2G'        
            },
            
            "deepwoodmemories": {
                "name": "Deepwood Memories",
                "tags": ['modify', 'artifact'],
                "image": "/cards/i_n331034.webp",
                "golden_image": "/cards/i_n335034.webp",
                "hi_res_image": "/cards/i_n331034_gcg_high_resolution.webp",
                "cost": '2 White',
                "description": "When a character uses a Skill or equips a Talent: Spend 1 less Dendro Die. (Once per Round)\n\nRoll Phase: 2 of the starting Elemental Dice you roll are always guaranteed to be Dendro Dice.\n\n(A character can equip a maximum of 1 Artifact)",
                "flavor": "“For all those who follow nature must pass through the maze of the forest and reach that endless plain.”",
                "id": '2H'        
            },
            
            "liyueharborwharf": {
                "name": "Liyue Harbor Wharf",
                "tags": ['assist', 'place'],
                "image": "/cards/i_n332000.webp",
                "golden_image": "/cards/i_n336000.webp",
                "hi_res_image": "/cards/i_n332000_gcg_high_resolution.webp",
                "cost": '2 White',
                "description": "End Phase: Draw 2 cards.\n\nUsage(s): 2",
                "flavor": "“Nature provides, the mountains rejoice, we are blessed by heaven’s good grace.”",
                "id": '2I'        
            },
            
            "knightsoffavoniuslibrary": {
                "name": "Knights of Favonius Library",
                "tags": ['assist', 'place'],
                "image": "/cards/i_n332001.webp",
                "golden_image": "/cards/i_n336001.webp",
                "hi_res_image": "/cards/i_n332001_gcg_high_resolution.webp",
                "cost": '0 White',
                "description": "When played: Select any Elemental Die/Dice to reroll.\n\nRoll Phase: Gain another chance to reroll.",
                "flavor": "“Most of the books here can be lent out, but do bear in mind that you will have to return them… on time.”",
                "id": '2J'        
            },
            
            "jadechamber": {
                "name": "Jade Chamber",
                "tags": ['assist', 'place'],
                "image": "/cards/i_n332002.webp",
                "golden_image": "/cards/i_n336002.webp",
                "hi_res_image": "/cards/i_n332002_gcg_high_resolution.webp",
                "cost": '0 White',
                "description": "Roll Phase: 2 of the starting Elemental Dice you roll are always guaranteed to match the Elemental Type of your active character.",
                "flavor": "“They say that it contains thousand dazzling jewels.”",
                "id": '2K'        
            },
            
            "dawnwinery": {
                "name": "Dawn Winery",
                "tags": ['assist', 'place'],
                "image": "/cards/i_n332003.webp",
                "golden_image": "/cards/i_n336003.webp",
                "hi_res_image": "/cards/i_n332003_gcg_high_resolution.webp",
                "cost": '2 White',
                "description": "When you switch characters: Spend 1 less Elemental Die. (Once per Round)",
                "flavor": "“The best wine will always be brewed next year.”",
                "id": '2L'        
            },
            
            "wangshuinn": {
                "name": "Wangshu Inn",
                "tags": ['assist', 'place'],
                "image": "/cards/i_n332004.webp",
                "golden_image": "/cards/i_n336004.webp",
                "hi_res_image": "/cards/i_n332004_gcg_high_resolution.webp",
                "cost": '2 White',
                "description": "End Phase: Heal the most injured character on standby for 2 HP.\n\nUsage(s): 2",
                "flavor": "“Folk stories also have it that even ones as august as the adepti sometimes bask in the moonlight here.”",
                "id": '2M'        
            },
            
            "favoniuscathedral": {
                "name": "Favonius Cathedral",
                "tags": ['assist', 'place'],
                "image": "/cards/i_n332005.webp",
                "golden_image": "/cards/i_n336005.webp",
                "hi_res_image": "/cards/i_n332005_gcg_high_resolution.webp",
                "cost": '2 White',
                "description": "End Phase: Heal your active character for 2 HP.\n\nUsage(s): 2",
                "flavor": "“If you speak sincerely into the wind, your words will surely reach the archon’s ear one day.”",
                "id": '2N'        
            },

            "tenshukaku": {
                "name": "Tenshukaku",
                "tags": ['assist', 'place'],
                "image": "/cards/i_n332021.webp",
                "golden_image": "/cards/i_n336021.webp",
                "hi_res_image": "/cards/i_n332021_gcg_high_resolution.webp",
                "cost": '2 White',
                "description": "When the Action Phase begins: If you have 5 different kinds of Elemental Die, create 1 Omni Element.",
                "flavor": '"What matters is that I tread the path of eternity on my people\'s behalf."',
                'id': '5R'
            },
    
            "grandnarukamishrine": {
                "name": "Grand Narukami Shrine",
                "tags": ['assist', 'place'],
                "image": "/cards/i_n332020.webp",
                "golden_image": "/cards/i_n336020.webp",
                "hi_res_image": "/cards/i_n332020_gcg_high_resolution.webp",
                "cost": '2 White',
                "description": "Triggers automatically once per Round: Create 1 random Elemental Die.\n\nUsage(s)：3",
                "flavor": "\"May Mt. Yougou flourish eternal, and may its glory be everlasting.\"",
                "id": '4M'
            },
    
            "sangonomiyashrine": {
                "name": "Sangonomiya Shrine",
                "tags": ['assist', 'place'],
                "image": "/cards/i_n332022.webp",
                "golden_image": "/cards/i_n336022.webp",
                "hi_res_image": "/cards/i_n332022_gcg_high_resolution.webp",
                "cost": '2 White',
                "description": "End Phase: Heal all your characters for 1 HP.\n\nUsage(s): 2", 
                "flavor": '"Sangonomiya was once an ocean abyss, until the Great Serpent came, forming a vortex with its spiral movements, and fashioning the coral into an island."',
                'id': '5S'
            },
    
            "sumerucity": {
                "name": "Sumeru City",
                "tags": ['assist', 'place'],
                "image": "/cards/i_n332023.webp",
                "golden_image": "/cards/i_n336023.webp",
                "hi_res_image": "/cards/i_n332023_gcg_high_resolution.webp",
                "cost": '2 White',
                "description": "When your character uses a Skill or equips a Talent Card: If you do not have more Elemental Dice than cards in your hand, spend 1 less Elemental Die. (Once per Round)",
                "flavor": 'Under the luxuriant Divine Tree, the sages of the academy city have accumulated all the knowledge there is to be gathered.',
                'id': '5T'
            },
    
            "vanarana": {
                "name": "Vanarana",
                "tags": ['assist', 'place'],
                "image": "/cards/i_n332024.webp",
                "golden_image": "/cards/i_n336024.webp",
                "hi_res_image": "/cards/i_n332024_gcg_high_resolution.webp",
                "cost": '0 White',
                "description": "End Phase: Collect up to 2 unused die.\n\nWhen the Action Phase begins: Reclaim the die you collected using this card.",
                "flavor": '"Enter the memories of the trees in the forest, descend into seedbeds sprouting the dreams of slumbering leaves, and dive a world free of woes."',
                'id': '5U'
            },
    
            "chinjuforest": {
                "name": "Chinju Forest",
                "tags": ['assist', 'place'],
                "image": "/cards/i_n332025.webp",
                "golden_image": "/cards/i_n336025.webp",
                "hi_res_image": "/cards/i_n332025_gcg_high_resolution.webp",
                "cost": '1 White',
                "description": "When Action Phase begins: If you do not start first, create 1 die that matches the Type of your active character.\n\nUsage(s): 3",
                "flavor": 'Legend has it that this sacred forest was once home to many demons.',
                'id': '5V'
            },

            "goldenhouse": {
                "name": "Golden House",
                "tags": ['assist', 'place'],
                "image": "/cards/i_n332034.webp",
                "golden_image": "/cards/i_n336034.webp",
                "hi_res_image": "/cards/i_n332034_gcg_high_resolution.webp",
                "cost": '0 White',
                "description": "When you play a Weapon card or an Artifact card with an original cost of at least 3: Spend 1 less Elemental Die. (Once per Round) \n\nUsage(s): 2",
                "flavor": 'All the contracts that circulate throughout the land are forged here.',
                'id': '6Y'
            },

            "gandharvaville": {
                "name": "Gandharva Ville",
                "tags": ['assist', 'place'],
                "image": "/cards/i_n332036.webp",
                "golden_image": "/cards/i_n336036.webp",
                "hi_res_image": "/cards/i_n332036_gcg_high_resolution.webp",
                "cost": '1 White',
                "description": "Before you choose your action, when the number of Elemental Dice you have is 0: Create 1 Omni Element (once per Round).\n\nUsage(s): 3",
                "flavor": 'The village place the Traveler and Forest Rangers celebrated, the village that listens to the heartbeat of the rainforest.',
                'id': '7A'
            },

            "stormterrorslair": {
                "name": "Stormterror's Lair",
                "tags": ['assist', 'place'],
                "image": "/cards/i_n332038.webp",
                "golden_image": "/cards/i_n336038.webp",
                "hi_res_image": "/cards/i_n332038_gcg_high_resolution.webp",
                "cost": '2 White',
                "description": "Before you choose your action, when the number of Elemental Dice you have is 0: Create 1 Omni Element (once per Round).\n\nUsage(s): 3",
                "flavor": 'The village place the Traveler and Forest Rangers celebrated, the village that listens to the heartbeat of the rainforest.',
                'id': '7M'
            },

            'weepingwillowofthelake': { 
                'name': 'Weeping Willow of the Lake',
                'tags': ['assist', 'place'],
                'hi_res_image': '/cards/i_n332039_gcg_high_resolution.webp',
                'image': '/cards/i_n332039.webp',
                'golden_image': '/cards/i_n336039.webp',
                'cost': '1 White',
                'description': "End Phase: If your Hand has no more than 2 cards in it, draw 2 cards.\nUsage(s): 2",
                'flavor': "In ancient times, the weeping willow of the lake was an object of reverence. All the water veins converge upon Erinnyes and the weeping willow flourishes or withers when the waters are sweet or bitter.",        
                'id': '8L',
            },

            'operaepiclese': { 
                'name': 'Opera Epiclese',
                'tags': ['assist', 'place'],
                'hi_res_image': '/cards/i_n332040_gcg_high_resolution.webp',
                'image': '/cards/i_n332040.webp',
                'golden_image': '/cards/i_n336040.webp',
                'cost': '1 White',
                'description': "Before you choose an Action: If the total dice cost of the Equipment Cards attached to your characters is less than that of your opponent, then you will generate 1 Elemental Die of your active character's element. (Once per Round)\nUsage(s): 3",
                'flavor': "The true and the fantastical, the comedic and tragic find a stage here equally. Perhaps it truly is as an ancient Fontainian playwright once said \"All the world's a stage, and all of us merely players.\"",      
                'id': '8M',
            },
            
            "paimon": {
                "name": "Paimon",
                "tags": ['assist', 'companion'],
                "image": "/cards/i_n332006.webp",
                "golden_image": "/cards/i_n336006.webp",
                "hi_res_image": "/cards/i_n332006_gcg_high_resolution.webp",
                "cost": '3 White',
                "description": "When Action Phase begins: Create 'Omni Element' ×2.\n\nUsage(s): 2",
                "flavor": "“That’s right! Your fortune is Paimon’s fortune! And vice versa, Paimon’s fortune is also your fortune.”",
                "id": '2O'        
            },
            
            "katheryne": {
                "name": "Katheryne",
                "tags": ['assist', 'companion'],
                "image": "/cards/i_n332007.webp",
                "golden_image": "/cards/i_n336007.webp",
                "hi_res_image": "/cards/i_n332007_gcg_high_resolution.webp",
                "cost": '1 White',
                "description": "When you switch characters: This switch is considered a 'Fast Action' instead of a 'Combat Action'. (Once per Round)",
                "flavor": "“Ad astra abyssosque! Welcome to the Adventurers’ Guild.”",
                "id": '2P'        
            },
            
            "timaeus": {
                "name": "Timaeus",
                "tags": ['assist', 'companion'],
                "image": "/cards/i_n332008.webp",
                "golden_image": "/cards/i_n336008.webp",
                "hi_res_image": "/cards/i_n332008_gcg_high_resolution.webp",
                "cost": '2 White',
                "description": "Comes with 2 Transmutation Materials when played.\n\nEnd Phase: Gain 1 Transmutation Material.\n\nWhen playing an Artifact Card: If possible, spend Transmutation Materials equal to the total cost of the Artifact and equip this Artifact for free. (Once per Round)",
                "flavor": "“Hello there… Oh, you’d like to use the Crafting Bench? Sure, be my guest.”",
                "id": '2Q'        
            },
            
            "wagner": {
                "name": "Wagner",
                "tags": ['assist', 'companion'],
                "image": "/cards/i_n332009.webp",
                "golden_image": "/cards/i_n336009.webp",
                "hi_res_image": "/cards/i_n332009_gcg_high_resolution.webp",
                "cost": '2 White',
                "description": "Comes with 2 Forging Billets when played.\n\nEnd Phase: Gain 1 Forging Billet.\n\nWhen playing a Weapon Card: If possible, spend Forging Billets equal to the total cost of the Weapon and equip this Weapon for free. (Once per Round)",
                "flavor": "“Smithing is not dependent on brute strength. You need the sweat on your brow from constant hard work, and perseverance stronger than the metals we forge!”",
                "id": '2R'        
            },
            
            "chefmao": {
                "name": "Chef Mao",
                "tags": ['assist', 'companion'],
                "image": "/cards/i_n332010.webp",
                "golden_image": "/cards/i_n336010.webp",
                "hi_res_image": "/cards/i_n332010_gcg_high_resolution.webp",
                "cost": '1 White',
                "description": "After playing a Food Event Card: Create 1 random Elemental Die (once per Round). After playing a Food Event Card: Draw 1 random Food Event Card from your deck (once per match).",
                "flavor": "“We just concern ourselves with making the most delicious food imaginable using everyday ingredients, universally loved flavors, and truly excellent cooking.”",
                "id": '2S'        
            },
            
            "tubby": {
                "name": "Tubby",
                "tags": ['assist', 'companion'],
                "image": "/cards/i_n332011.webp",
                "golden_image": "/cards/i_n336011.webp",
                "hi_res_image": "/cards/i_n332011_gcg_high_resolution.webp",
                "cost": '2 White',
                "description": "When playing a Location Support Card: Spend 2 less Elemental Dice. (Once per Round)",
                "flavor": "“Steeping a pot of tea, watching over the abode, accompanying the Traveler and Paimon to await the arrival of Ping and the others, watching the cloud-filled sky. These days of not having to concern myself with matters of adeptal import truly are ones of leisure…”\n“Oh! Oh dear, I must have fallen asleep again. It’s a good thing that no one noticed…”",
                "id": '2T'        
            },
            
            "timmie": {
                "name": "Timmie",
                "tags": ['assist', 'companion'],
                "image": "/cards/i_n332012.webp",
                "golden_image": "/cards/i_n336012.webp",
                "hi_res_image": "/cards/i_n332012_gcg_high_resolution.webp",
                "cost": '0 White',
                "description": "Triggers automatically once per Round: This card gains 1 Pigeon.\n\nWhen this card gains 3 Pigeons, discard this card, then draw 1 card and create 'Omni Element' ×1.",
                "flavor": "“Will pigeons that have flown away come back?”",
                "id": '2U'        
            },
            
            "liben": {
                "name": "Liben",
                "tags": ['assist', 'companion'],
                "image": "/cards/i_n332013.webp",
                "golden_image": "/cards/i_n336013.webp",
                "hi_res_image": "/cards/i_n332013_gcg_high_resolution.webp",
                "cost": '0 White',
                "description": "End Phase: Collect your unused Elemental Dice (Max 1 of each Elemental Type).\n\nWhen Action Phase begins: If this card has collected 3 Elemental Dice, draw 2 cards and create 'Omni Element' ×2, then discard this card.",
                "flavor": "Big things are about to happen, big things! Oh, and I have an excellent business proposition for you, so, if I could just have a moment of your time?",
                "id": '2V'        
            },
            
            "changtheninth": {
                "name": "Chang the Ninth",
                "tags": ['assist', 'companion'],
                "image": "/cards/i_n332014.webp",
                "golden_image": "/cards/i_n336014.webp",
                "hi_res_image": "/cards/i_n332014_gcg_high_resolution.webp",
                "cost": '0 White',
                "description": "When either side uses a Skill: If 'Physical DMG' or Piercing DMG was dealt, or an Elemental Reaction was triggered, this card gains 1 Inspiration.\n\nWhen this card gains 3 Inspiration, discard this card, then draw 2 cards.",
                "flavor": "“He who has not known poverty has yet to become a true man, and at least this man has books to keep him company!”",
                "id": '2W'        
            },
            
            "ellin": {
                "name": "Ellin",
                "tags": ['assist', 'companion'],
                "image": "/cards/i_n332015.webp",
                "golden_image": "/cards/i_n336015.webp",
                "hi_res_image": "/cards/i_n332015_gcg_high_resolution.webp",
                "cost": '2 White',
                "description": "When you use a Skill that has already been used in this Round: Spend 1 less Elemental Die. (Once per Round)",
                "flavor": "“I’ve got to hone my spirit and strength both if my sword arm is to be as steady as Master Jean’s!”",
                "id": '2X'        
            },
            
            "irontonguetian": {
                "name": "Iron Tongue Tian",
                "tags": ['assist', 'companion'],
                "image": "/cards/i_n332016.webp",
                "golden_image": "/cards/i_n336016.webp",
                "hi_res_image": "/cards/i_n332016_gcg_high_resolution.webp",
                "cost": '2 Black',
                "description": "End Phase: One of your characters without maximum energy gains 1 Energy. (Active Character prioritized) \n\nUsage(s): 2",
                "flavor": "“Listen, I’ll tell you how is it… Let me show you real storytelling tradition!”",
                "id": '2Y'        
            },
            
            "liusu": {
                "name": "Liu Su",
                "tags": ['assist', 'companion'],
                "image": "/cards/i_n332017.webp",
                "golden_image": "/cards/i_n336017.webp",
                "hi_res_image": "/cards/i_n332017_gcg_high_resolution.webp",
                "cost": '1 White',
                "description": "After you switch characters: If the character you switched to does not have Energy, they will gain 1 Energy. (Once per Round)\n\nUsage(s): 2",
                "flavor": "“Well then, dear guests, what would you all like to hear next?”",
                "id": '2Z'        
            },
    
            "hanachirusato": {
                "name": "Hanachirusato",
                "tags": ['assist', 'companion'],
                "image": "/cards/i_n332026.webp",
                "golden_image": "/cards/i_n336026.webp",
                "hi_res_image": "/cards/i_n332026_gcg_high_resolution.webp",
                "cost": '0 White',
                "description": "When a Summon disappears: This card gains 1 Cleansing Ritual Progress. (Max 3)\n\nWhen you play a Weapon or Artifact Card: If you already have 3 Cleansing Ritual Progress, discard this card and cause the card you play to cost 2 less Elemental Dice.",
                "flavor": '"When shall we meet again after this parting? For life is like the morning dew."',
                'id': '5W'
            },
            "kidkujirai": {
                "name": "Kid Kujirai",
                "tags": ['assist', 'companion'],
                "image": "/cards/i_n332027.webp",
                "golden_image": "/cards/i_n336027.webp",
                "hi_res_image": "/cards/i_n332027_gcg_high_resolution.webp",
                "cost": '0 White',
                "description": "When the Action Phase begins: Create 1 Omni Element. Then if your opponent's Support Zone is not full, transfer this card to your opponent's Support Zone.",
                "flavor": '"When you hide a Temari, you have to hide it within the time of a Temari song. The person who is looking for it will also find it within a song\'s time. That will make the game fair!"',
                'id': '5X'
            },
            "xudong": {
                "name": "Xudong",
                "tags": ['assist', 'companion'],
                "image": "/cards/i_n332028.webp",
                "golden_image": "/cards/i_n336028.webp",
                "hi_res_image": "/cards/i_n332028_gcg_high_resolution.webp",
                "cost": '2 Black',
                "description": "When playing a Food Event Card: Spend 2 less Elemental Dice. (Once per Round)",
                "flavor": '"Hmm? A problem. Agh. We can deal with it after we finish eating."',
                'id': '5Y'
            },
            "dunyarzad": {
                "name": "Dunyarzad",
                "tags": ['assist', 'companion'],
                "image": "/cards/i_n332029.webp",
                "golden_image": "/cards/i_n336029.webp",
                "hi_res_image": "/cards/i_n332029_gcg_high_resolution.webp",
                "cost": '1 White',
                "description": "When playing a Companion Support Card: Spend 1 less Elemental Dice (Once per Round). After playing a Companion Support Card: Draw 1 random Companion Support Card from your deck (once per match).",
                "flavor": '"The point of living is to not leave behind any regrets."',
                'id': '5Z'
            },
            "rana": {
                "name": "Rana",
                "tags": ['assist', 'companion'],
                "image": "/cards/i_n332030.webp",
                "golden_image": "/cards/i_n336030.webp",
                "hi_res_image": "/cards/i_n332030_gcg_high_resolution.webp",
                "cost": '2 White',
                "description": "After your character uses an Elemental Skill: Create 1 Elemental Die of the same Type as your next off-field character. (Once per Round)",
                "flavor": '"We still have a lot of time with each other. We can explore the vastness of the forest, the world, and the future together."',
                'id': '60'
            },

            "masterzhang": {
                "name": "Master Zhang",
                "tags": ['assist', 'companion'],
                "image": "/cards/i_n332033.webp",
                "golden_image": "/cards/i_n336033.webp",
                "hi_res_image": "/cards/i_n332033_gcg_high_resolution.webp",
                "cost": '1 White',
                "description": "When you play a Weapon from your hand: Use 1 less Elemental Die. On top of that, for each of your character already equipped with a Weapon on the field, you spend 1 less Elemental Die. (Once per Round.)",
                "flavor": 'Much burning frustration must transpire before a hunk of metal may become a keen blade.',
                'id': '6N'
            },

            "setaria": {
                "name": "Setaria",
                "tags": ['assist', 'companion'],
                "image": "/cards/i_n332035.webp",
                "golden_image": "/cards/i_n336035.webp",
                "hi_res_image": "/cards/i_n332035_gcg_high_resolution.webp",
                "cost": '1 White',
                "description": "After you perform any action, if you have 0 cards in your hand: Draw 1 card. (Once per Round) \n\nUsage(s): 3",
                "flavor": 'A genius from the desert, deep within the rainforest\'s temple...',
                'id': '6Z'
            },

            "yayoinanatsuki": {
                "name": "Yayoi Nanatsuki",
                "tags": ['assist', 'companion'],
                "image": "/cards/i_n332037.webp",
                "golden_image": "/cards/i_n336037.webp",
                "hi_res_image": "/cards/i_n332037_gcg_high_resolution.webp",
                "cost": '1 White',
                "description": "When playing a Artifact card: Spend 1 less Elemental Die. On top of that, for each of your characters already equipped with an Artifact on the field, you spend 1 less Elemental Die (once per Round).",
                "flavor": '"If my skill can reach that apex, I am sure that my lacquerware will bear out the pattern of the truth..."',
                'id': '7B'
            },

            'mamere': { 
                'name': 'Mamere',
                'tags': ['assist', 'companion'],
                'hi_res_image': '/cards/i_n332041_gcg_high_resolution.webp',
                'image': '/cards/i_n332041.webp',
                'golden_image': '/cards/i_n336041.webp',
                'cost': '0 White',
                'description': "After you play a Food/Location/Companion/Item Action Card other than Mamere: Randomly create 1 Food/Location/Companion/Item Action Card other than Mamere, and add it to your hand. (Once per Round). \n\nUsage(s): 3",
                'flavor': "A Melusine that paints every day. \n\"Because painting the things that I want to brings me happiness!\"",
                'id': '8N',
            },

            'jeht': { 
                'name': 'Jeht',
                'tags': ['assist', 'companion'],
                'hi_res_image': '/cards/i_n332044_gcg_high_resolution.webp',
                'image': '/cards/i_n332044.webp',
                'golden_image': '/cards/i_n336044.webp',
                'cost': '2 Black',
                'description': "This card will record the number of cards discarded from your Support Zone during this match as Sophistication points. (Max 6 points) \n\nAfter your characters use an Elemental Burst: If this card has recorded at least 5 Sophistication points, discard this card and generate Omni Element equal to the number of Sophistication points minus 2.",
                'flavor': "\"Here's a thousand hugs! We will meet again!\"\n\"May we meet again under a lovelier sun.\"",
                'id': '95',
            },

            'silverandmelus': { 
                'name': 'Silver and Melus',
                'tags': ['assist', 'companion'],
                'hi_res_image': '/cards/i_n332045_gcg_high_resolution.webp',
                'image': '/cards/i_n332045.webp',
                'golden_image': '/cards/i_n336045.webp',
                'cost': '1 White',
                'description': "This card will record the number of types of Elemental DMG opposing characters have taken during this match as points of Attendant's Attentiveness. (Max 4 points) \n\nEnd Phase: If you have at least 3 Attendant's Attentiveness points, discard this card and draw cards equal to the amount of Attendant's Attentiveness points.",
                'flavor': "\"Don't be afraid. We will protect you to the very end.\"",
                'id': '96',
            },
            
            "parametrictransformer": {
                "name": "Parametric Transformer",
                "tags": ['assist', 'item'],
                "image": "/cards/i_n332018.webp",
                "golden_image": "/cards/i_n336018.webp",
                "hi_res_image": "/cards/i_n332018_gcg_high_resolution.webp",
                "cost": '2 Black',
                "description": "After either side uses Skills: If Elemental DMG was dealt, this card gains 1 Qualitative Progress.\n\nWhen this card gains 3 Qualitative Progress, discard this card, then create 3 different Basic Elemental Dice.",
                "flavor": "“Simply put, everything on this earth and below it has cycles. Memories and elements surge throughout the Ley Lines.”\n“Perhaps the ancient civilizations were attempting to uncover the cycle that governs the conversion of dust to treasure.”",
                "id": '30'        
            },
            
            "nre": {
                "name": "NRE",
                "tags": ['assist', 'item'],
                "image": "/cards/i_n332019.webp",
                "golden_image": "/cards/i_n336019.webp",
                "hi_res_image": "/cards/i_n332019_gcg_high_resolution.webp",
                "cost": '1 White',
                "description": "When played: Draw 1 Food Event Card from your deck.\n\nWhen you play a Food Event Card: Draw 1 Food Event Card from your deck. (Once per Round)",
                "flavor": "“Regular nutrition helps in case of physical exertion.”",
                "id": '31'        
            },
    
            "redfeatherfan": {
                "name": "Red Feather Fan",
                "tags": ['assist', 'item'],
                "image": "/cards/i_n332031.webp",
                "golden_image": "/cards/i_n336031.webp",
                "hi_res_image": "/cards/i_n332031_gcg_high_resolution.webp",
                "cost": '2 White',
                "description": "After you switch characters: The next Switch Character action you perform this Round will be considered a Fast Action instead of a Combat Action. It will also cost 1 less die. (Once per Round)",
                "flavor": 'Legend has that this fan is capable of unleashing all kinds of power in the hands of a tengu warrior.\nWhen held by someone of mundane make, however, it only possesses the power to imbue their body weight a little more lightness.\nEven so, this degree of power is more than useful for the average individual.',
                'id': '61'
            },
    
            "treasureseekingseelie": {
                "name": "Treasure-Seeking Seelie",
                "tags": ['assist', 'item'],
                "image": "/cards/i_n332032.webp",
                "golden_image": "/cards/i_n336032.webp",
                "hi_res_image": "/cards/i_n332032_gcg_high_resolution.webp",
                "cost": '1 White',
                "description": "After your character uses a skill: This card will accumulate 1 Treasure Clue. \n\nWhen this card has stored 3 Treasure Clues, discard this card and draw 3 cards.",
                "flavor": 'Strange Seelie capable of guiding people toward treasure. Legend has it that some individuals know how to communicate with these Seelie...',
                'id': '62'
            },

            'seeddispensary': { 
                'name': 'Seed Dispensary',
                'tags': ['assist', 'item'],
                'hi_res_image': '/cards/i_n332042_gcg_high_resolution.webp',
                'image': '/cards/i_n332042.webp',
                'golden_image': '/cards/i_n336042.webp',
                'cost': '0 White',
                'description': "When you play an Equipment or Support Card with an original cost of 1 Elemental Die: Spend 1 less Elemental Die. (Once per Round)\nUsage(s): 2",
                'flavor': "A special container obtained from Madame Ping. According to her, this dispensary has the power to \"generate seeds\"...",
                'id': '8O',
            },

            'mementolens': { 
                'name': 'Memento Lens',
                'tags': ['assist', 'item'],
                'hi_res_image': '/cards/i_n332043_gcg_high_resolution.webp',
                'image': '/cards/i_n332043.webp',
                'golden_image': '/cards/i_n336043.webp',
                'cost': '1 White',
                'description': "When you play a Weapon, Artifact, Location, or Companion card: If you have played a card with the same name previously during this match, spend 2 less Elemental Dice to play it. (Once per Round) \n\nUsage(s): 2",
                'flavor': "They say that in the distant past, the legendary Kitsune Saiguu left a catalyst for the then-Hiiragi Clan head, Hiroshi, as a tool to be used in exorcisms.\nThe Hiiragis would have a special Kamera made to order from overseas with that catalyst mounted on its lens assembly, before giving it back to the Grand Narukami Shrine as a symbol of their friendship.",
                'id': '8P',
            },

            "ancientcourtyardMAX1": {
                "name": "Ancient Courtyard",
                "tags": ['event', 'arcane legend'],
                "image": "/cards/i_n333050.webp",
                "golden_image": "/cards/i_n337050.webp",
                "hi_res_image": "/cards/i_n333050_gcg_high_resolution.webp",
                "cost": '0 White',
                "description": "You must have a character who has already equipped a Weapon or Artifact: The next time you play a Weapon or Artifact card in this Round: Spend 2 less Elemental Dice.\n\n(Only one \"Arcane Legend\" card can be played for the entire game. This card will be in your starting hand.)",
                "flavor": '"Is mortal life not an empty shell, as unto a dream?"',
                'id': '6O'
            },

            "covenantofrockMAX1": {
                "name": "Covenant of Rock",
                "tags": ['event', 'arcane legend'],
                "image": "/cards/i_n333051.webp",
                "golden_image": "/cards/i_n337051.webp",
                "hi_res_image": "/cards/i_n333051_gcg_high_resolution.webp",
                "cost": '0 White',
                "description": "Can only be played when you have 0 Elemental Dice left: Generate 2 different basic Elemental Dice.\n\n(Only one \"Arcane Legend\" card can be played for the entire game. This card will be in your starting hand.)",
                "flavor": '"Rex Lapis bestowed him with a pair of eyes to see the world, and came to an agreement with him. The dragon then accompanied the Lord of Geo, fighting campaigns alongside him in the four corners of the world..."',
                'id': '6P'
            },

            'joyouscelebrationMAX1': {
                'name': "Joyous Celebration",
                "tags": ['event', 'arcane legend'],
                "image": Joyous_Celebration,
                "golden_image": "/cards/i_n337053.webp",
                "hi_res_image": "/cards/i_n333053_gcg_high_resolution.webp",
                "cost": '0 White',
                "description": "Your active character must be one of the following elemental types to play this card: Cryo/Hydro/Pyro/Electro/Dendro: The element corresponding to your active character's Elemental Type will be applied to all your characters. \n\n(Only one \"Arcane Legend\" card can be played per match. This card will be in your starting hand.)",
                "flavor": '"Celebration should be shared with everyone."',
                'id': '70'
            },

            'freshwindoffreedomMAX1': {
                'name': "Fresh Wind of Freedom",
                "tags": ['event', 'arcane legend'],
                "image": "/cards/i_n333055.webp",
                "golden_image": "/cards/i_n337055.webp",
                "hi_res_image": "/cards/i_n333055_gcg_high_resolution.webp",
                "cost": '0 White',
                "description": "In this Round, when an opposing character is defeated during your Action, you can continue to act again when that Action ends.\n\nUsage(s)：1\n\n(Only one \"Arcane Legend\" card can be played for the entire game. This card will be in your starting hand.)",
                "flavor": '"The heavenly bard brushes the strings of the lyre, summoning forth the gale, dispersing the ice and snow, cleaving the peaks, and making the new Mondstadt the home of freedom."',
                'id': '7C'
            },

            'ineveryhouseastoveMAX1': {
                'name': "In Every House a Stove",
                "tags": ['event', 'arcane legend'],
                "image": "/cards/i_n333057.webp",
                "golden_image": "/cards/i_n337057.webp",
                "hi_res_image": "/cards/i_n333057_gcg_high_resolution.webp",
                "cost": '0 White',
                "description": "Draw a number of cards equal to the current Round number minus 1. (Up to 4 cards can be drawn in this way).\n\n(Only one \"Arcane Legend\" card can be played for the entire game. This card will be in your starting hand.)",
                "flavor": '"The heavenly bard brushes the strings of the lyre, summoning forth the gale, dispersing the ice and snow, cleaving the peaks, and making the new Mondstadt the home of freedom."',
                'id': '7N'
            },

            'passingofjudgmentMAX1': { 
                'name': 'Passing of Judgment',
                'tags': ['event', 'arcane legend'],
                'hi_res_image': '/cards/i_n333059_gcg_high_resolution.webp',
                'image': '/cards/i_n333059.webp',
                'golden_image': '/cards/i_n337059.webp',
                'cost': '1 White',
                'description': "3 Event Cards played by your opponent in this Round will take no effect.\n(Only one \"Arcane Legend\" card can be played per match. This card will be in your starting hand.)",
                'flavor': "\"It is time to make the final decision on this case.\"",
                'id': '8Q',
            },
            
            "elementalresonancewovenice": {
                "name": "Elemental Resonance: Woven Ice",
                "tags": ['event', 'resonance'],
                "image": "/cards/i_n333000.webp",
                "golden_image": "/cards/i_n337000.webp",
                "hi_res_image": "/cards/i_n333000_gcg_high_resolution.webp",
                "cost": '0 White',
                "description": "Create 1 Cryo Die.\n\n(You must have at least 2 Cryo characters in your deck to add this card to your deck.)",
                "flavor": "Even the sky shall shiver before the ice.",
                "required": "2cryo",
                "id": '32'        
            },
            
            "elementalresonanceshatteringice": {
                "name": "Elemental Resonance: Shattering Ice",
                "tags": ['event', 'resonance'],
                "image": "/cards/i_n333001.webp",
                "golden_image": "/cards/i_n337001.webp",
                "hi_res_image": "/cards/i_n333001_gcg_high_resolution.webp",
                "cost": '1 Cryo',
                "description": "During this Round, your current active character will deal +2 DMG for the next instance.\n\n(You must have at least 2 Cryo characters in your deck to add this card to your deck.)",
                "flavor": "The frost flower blooms as a heart undivided.",
                "required": "2cryo",
                "id": '33'            
            },
            
            "elementalresonancewovenwaters": {
                "name": "Elemental Resonance: Woven Waters",
                "tags": ['event', 'resonance'],
                "image": "/cards/i_n333002.webp",
                "golden_image": "/cards/i_n337002.webp",
                "hi_res_image": "/cards/i_n333002_gcg_high_resolution.webp",
                "cost": '0 White',
                "description": "Create 1 Hydro Die.\n\n(You must have at least 2 Hydro characters in your deck to add this card to your deck.)",
                "flavor": "The dance of water nourishes life.",
                "required": "2hydro",
                "id": '34'        
            },
            
            "elementalresonancesoothingwater": {
                "name": "Elemental Resonance: Soothing Water",
                "tags": ['event', 'resonance'],
                "image": "/cards/i_n333003.webp",
                "golden_image": "/cards/i_n337003.webp",
                "hi_res_image": "/cards/i_n333003_gcg_high_resolution.webp",
                "cost": '1 Hydro',
                "description": "Heal your active characters for 2 HP, and also heals all your characters on standby for 1 HP.\n\n(You must have at least 2 Hydro characters in your deck to add this card to your deck.)",
                "flavor": "With purest water flows prosperity.",
                "required": "2hydro",
                "id": '35'        
            },
            
            "elementalresonancewovenflames": {
                "name": "Elemental Resonance: Woven Flames",
                "tags": ['event', 'resonance'],
                "image": "/cards/i_n333004.webp",
                "golden_image": "/cards/i_n337004.webp",
                "hi_res_image": "/cards/i_n333004_gcg_high_resolution.webp",
                "cost": '0 White',
                "description": "Create 1 Pyro Die.\n\n(You must have at least 2 Pyro characters in your deck to add this card to your deck.)",
                "flavor": "The scarlet flame reduces the vanquished to dust.",
                "required": "2pyro",
                "id": '36'        
            },
            
            "elementalresonanceferventflames": {
                "name": "Elemental Resonance: Fervent Flames",
                "tags": ['event', 'resonance'],
                "image": "/cards/i_n333005.webp",
                "golden_image": "/cards/i_n337005.webp",
                "hi_res_image": "/cards/i_n333005_gcg_high_resolution.webp",
                "cost": '1 Pyro',
                "description": "During this round, the next instance of 'Pyro Reaction DMG' your current active character triggers deals +3 DMG.\n\n(You must have at least 2 Pyro characters in your deck to add this card to your deck.)",
                "flavor": "A burning heart may match the sun and moon.",
                "required": "2pyro",
                "id": '37'        
            },
            
            "elementalresonancewoventhunder": {
                "name": "Elemental Resonance: Woven Thunder",
                "tags": ['event', 'resonance'],
                "image": "/cards/i_n333006.webp",
                "golden_image": "/cards/i_n337006.webp",
                "hi_res_image": "/cards/i_n333006_gcg_high_resolution.webp",
                "cost": '0 White',
                "description": "Create 1 Electro Die.\n\n(You must have at least 2 Electro characters in your deck to add this card to your deck.)",
                "flavor": "Lightning falls on the land of eternity.",
                "required": "2electro",
                "id": '38'        
            },
            
            "elementalresonancehighvoltage": {
                "name": "Elemental Resonance: High Voltage",
                "tags": ['event', 'resonance'],
                "image": "/cards/i_n333007.webp",
                "golden_image": "/cards/i_n337007.webp",
                "hi_res_image": "/cards/i_n333007_gcg_high_resolution.webp",
                "cost": '1 Electro',
                "description": "One of your characters without maximum Energy gains 1 Energy. (Active Character prioritized) \n\n(You must have at least 2 Electro characters in your deck to add this card to your deck.)",
                "flavor": "The storm rises in majesty.",
                "required": "2electro",
                "id": '39'        
            },
            
            "elementalresonancewovenwinds": {
                "name": "Elemental Resonance: Woven Winds",
                "tags": ['event', 'resonance'],
                "image": "/cards/i_n333008.webp",
                "golden_image": "/cards/i_n337008.webp",
                "hi_res_image": "/cards/i_n333008_gcg_high_resolution.webp",
                "cost": '0 White',
                "description": "Create 1 Anemo Die.\n\n(You must have at least 2 Anemo characters in your deck to add this card to your deck.)",
                "flavor": "The wind sings like a leisurely lyre.",
                "required": "2anemo",
                "id": '3A'        
            },
            
            "elementalresonanceimpetuouswinds": {
                "name": "Elemental Resonance: Impetuous Winds",
                "tags": ['event', 'resonance'],
                "image": "/cards/i_n333009.webp",
                "golden_image": "/cards/i_n337009.webp",
                "hi_res_image": "/cards/i_n333009_gcg_high_resolution.webp",
                "cost": '1 Anemo',
                "description": "Switch to the target character and create 'Omni Element' ×1.\n\n(You must have at least 2 Anemo characters in your deck to add this card to your deck.)",
                "flavor": "The gale gallops through the woods.",
                "required": "2anemo",
                "id": '3B'        
            },
            
            "elementalresonancewovenstone": {
                "name": "Elemental Resonance: Woven Stone",
                "tags": ['event', 'resonance'],
                "image": "/cards/i_n333010.webp",
                "golden_image": "/cards/i_n337010.webp",
                "hi_res_image": "/cards/i_n333010_gcg_high_resolution.webp",
                "cost": '0 White',
                "description": "Create 1 Geo Die.\n\n(You must have at least 2 Geo characters in your deck to add this card to your deck.)",
                "flavor": "The jagged mountains sign a lasting pact.",
                "required": "2geo",
                "id": '3C'        
            },
            
            "elementalresonanceenduringrock": {
                "name": "Elemental Resonance: Enduring Rock",
                "tags": ['event', 'resonance'],
                "image": "/cards/i_n333011.webp",
                "golden_image": "/cards/i_n337011.webp",
                "hi_res_image": "/cards/i_n333011_gcg_high_resolution.webp",
                "cost": '1 Geo',
                "description": "During this round, after your character deals 'Geo DMG' next time: Should there be any Combat Status on your side that provides 'Shield', grant one such Status with 3 'Shield' points. \n\n(You must have at least 2 Geo characters in your deck to add this card to your deck.)",
                "flavor": "Bedrock shall make the hills unshakable.",
                "required": "2geo",
                "id": '3D'        
            },
            
            "elementalresonancewovenweeds": {
                "name": "Elemental Resonance: Woven Weeds",
                "tags": ['event', 'resonance'],
                "image": "/cards/i_n333012.webp",
                "golden_image": "/cards/i_n337012.webp",
                "hi_res_image": "/cards/i_n333012_gcg_high_resolution.webp",
                "cost": '0 White',
                "description": "Create 1 Dendro Die.\n\n(You must have at least 2 Dendro characters in your deck to add this card to your deck.)",
                "flavor": "All shall dance in the dream forest.",
                "required": "2dendro",
                "id": '3E'        
            },
            
            "elementalresonancesprawlinggreenery": {
                "name": "Elemental Resonance: Sprawling Greenery",
                "tags": ['event', 'resonance'],
                "image": "/cards/i_n333013.webp",
                "golden_image": "/cards/i_n337013.webp",
                "hi_res_image": "/cards/i_n333013_gcg_high_resolution.webp",
                "cost": '1 Dendro',
                "description": "During this round, the next Elemental Reaction you triggers deals +2 DMG.\n\nYour 'Burning Flame', 'Dendro Core', and 'Catalyzing Field' gain +1 Usage(s).\n\n(You must have at least 2 Dendro characters in your deck to add this card to your deck.)",
                "flavor": "New branches and sprouts grow into a forest.",
                "required": "2dendro",
                "id": '3F'        
            },

            "windandfreedom": {
                "name": "Wind and Freedom",
                "tags": ['event'],
                "image": "/cards/i_n333037.webp",
                "golden_image": "/cards/i_n337037.webp",
                "hi_res_image": "/cards/i_n333037_gcg_high_resolution.webp",
                "cost": '0 White',
                "description": "During this turn, after one of your characters uses a Skill: Switch your next character in to be the active character.\n\n(You must have at least 2 Mondstadt characters in your deck to add this card to your deck.)", 
                "required": '2mond',
                "flavor": '"Someday, the winds will blow towards a brighter future."',
                'id': '63'
            },
    
            "stoneandcontracts": {
                "name": "Stone and Contracts",
                "tags": ['event'],
                "image": "/cards/i_n333038.webp",
                "golden_image": "/cards/i_n337038.webp",
                "hi_res_image": "/cards/i_n333038_gcg_high_resolution.webp",
                "cost": '3 Black',
                "description": "When the Action Phase of the next Round begins: create 3  Omni Element.\n\n(You must have at least 2 Liyue characters in your deck to add this card to your deck.)",
                "required": '2liyue',
                "flavor": '"Such is my faith in life itself, and to sully my trust is to tarnish my blood."',
                'id': '64'
            },
    
            "thunderandeternity": {
                "name": "Thunder and Eternity",
                "tags": ['event'],
                "image": "/cards/i_n333039.webp",
                "golden_image": "/cards/i_n337039.webp",
                "hi_res_image": "/cards/i_n333039_gcg_high_resolution.webp",
                "cost": '0 White',
                "description": "Convert all your dice to Omni Element.\n\n(You must have at least 2 Inazuma characters in your deck to add this card to your deck.)",
                "required": '2inazuma',
                "flavor": '"It once promised its people a dream: the never-changing \'eternity.\'"',
                'id': '65'
            },
    
            "natureandwisdom": {
                "name": "Nature and Wisdom",
                "tags": ['event'],
                "image": "/cards/i_n333040.webp",
                "golden_image": "/cards/i_n337040.webp",
                "hi_res_image": "/cards/i_n333040_gcg_high_resolution.webp",
                "cost": '1 White',
                "description": "Draw 1 card. After that, switch any cards in your hand.\n\n(You must have at least 2 Sumeru characters in your deck to add this card to your deck.)",
                "required": '2sumeru',
                "flavor": '"That dancing circle embodied everything about the universe. Life has always been the end, while it is wisdom that shall be the means."',
                'id': '66'
            },
            
            "thebestesttravelcompanion": {
                "name": "The Bestest Travel Companion!",
                "tags": ['event'],
                "image": "/cards/i_n333014.webp",
                "golden_image": "/cards/i_n337014.webp",
                "hi_res_image": "/cards/i_n333014_gcg_high_resolution.webp",
                "cost": '2 Black',
                "description": "Convert the Elemental Dice spent to 'Omni Element' ×2.",
                "flavor": "“You might be only one of countless stars, but you’re Paimon’s whole world!”",
                "id": '3G'        
            },
            
            "changingshifts": {
                "name": "Changing Shifts",
                "tags": ['event'],
                "image": "/cards/i_n333015.webp",
                "golden_image": "/cards/i_n337015.webp",
                "hi_res_image": "/cards/i_n333015_gcg_high_resolution.webp",
                "cost": '0 White',
                "description": "Your next character switch costs 1 less Elemental Die.",
                "flavor": "“It’s time for the adults to get to work, and for the kids to get some sleep.”",
                "id": '3H'        
            },
            
            "tossup": {
                "name": "Toss-Up",
                "tags": ['event'],
                "image": "/cards/i_n333016.webp",
                "golden_image": "/cards/i_n337016.webp",
                "hi_res_image": "/cards/i_n333016_gcg_high_resolution.webp",
                "cost": '0 White',
                "description": "Select any Elemental Die/Dice to reroll. Can reroll 2 times.",
                "flavor": "Before the dice are thrown, none can know their own destiny.",
                "id": '3I'        
            },
            
            "strategize": {
                "name": "Strategize",
                "tags": ['event'],
                "image": "/cards/i_n333017.webp",
                "golden_image": "/cards/i_n337017.webp",
                "hi_res_image": "/cards/i_n333017_gcg_high_resolution.webp",
                "cost": '1 White',
                "description": "Draw 2 cards.",
                "flavor": "“This might look quite complicated, but in truth, the possible scenarios do not exceed 187 in number.”",
                "id": '3J'        
            },
            
            "ihaventlostyet": {
                "name": "I Haven’t Lost Yet!",
                "tags": ['event'],
                "image": "/cards/i_n333018.webp",
                "golden_image": "/cards/i_n337018.webp",
                "hi_res_image": "/cards/i_n333018_gcg_high_resolution.webp",
                "cost": '0 White',
                "description": "Only playable if one of your characters is defeated this Round:\n\nCreate 'Omni Element' ×1 and your current active character gains 1 Energy. (Only one copy of I Haven't Lost Yet! can be played each round.)",
                "flavor": "Arataki “He Might Lose but He’ll Never Admit Defeatto” is always game for another round!",
                "id": '3K'        
            },
            
            "leaveittome": {
                "name": "Leave It to Me!",
                "tags": ['event'],
                "image": "/cards/i_n333019.webp",
                "golden_image": "/cards/i_n337019.webp",
                "hi_res_image": "/cards/i_n333019_gcg_high_resolution.webp",
                "cost": '0 White',
                "description": "The next time you perform 'Switch Character': This switch will be considered a 'Fast Action' instead of a 'Combat Action'.",
                "flavor": "“It’s fine, leave everything to me!” — This ranks first among “lines to put Mondstadter hearts at ease.”",
                "id": '3L'        
            },
            
            "whenthecranereturned": {
                "name": "When the Crane Returned",
                "tags": ['event'],
                "image": "/cards/i_n333020.webp",
                "golden_image": "/cards/i_n337020.webp",
                "hi_res_image": "/cards/i_n333020_gcg_high_resolution.webp",
                "cost": '1 White',
                "description": "The next time you use a Skill: Switch your next character in to be the active character.",
                "flavor": "“The crane once returned, and once, she was spurned, she turned, and left alone; now, she might be found, with friends all around, to whom she is bound — a home.”",
                "id": '3M'        
            },
            
            "starsigns": {
                "name": "Starsigns",
                "tags": ['event'],
                "image": "/cards/i_n333021.webp",
                "golden_image": "/cards/i_n337021.webp",
                "hi_res_image": "/cards/i_n333021_gcg_high_resolution.webp",
                "cost": '2 Black',
                "description": "Your current active character gains 1 Energy.",
                "flavor": "“This is destiny, and it cannot be defied.”",
                "id": '3N'        
            },
            
            "calxsarts": {
                "name": "Calx’s Arts",  
                "tags": ['event'],
                "image": "/cards/i_n333022.webp",
                "golden_image": "/cards/i_n337022.webp",
                "hi_res_image": "/cards/i_n333022_gcg_high_resolution.webp",
                "cost": '1 White',
                "description": "Shift 1 Energy from at most 2 of your characters on standby to your active character.",
                "flavor": "“Not to worry. The experiment has been completed, and it is — if I may say so — a great success.”",
                "id": '3O'        
            },
            
            "masterofweaponry": {
                "name": "Master of Weaponry",
                "tags": ['event'],
                "image": "/cards/i_n333023.webp",
                "golden_image": "/cards/i_n337023.webp",
                "hi_res_image": "/cards/i_n333023_gcg_high_resolution.webp",
                "cost": '0 White',
                "description": "Shift 1 Weapon Equipment Card that has been equipped to one of your characters to another one of your characters of the same Weapon Type, and reset the \"usages per Round\" limit on its effects.",
                "flavor": "“Watch and learn, comrade! A real warrior isn’t picky about their weapons!”",
                "id": '3P'        
            },
            
            "blessingofthedivinerelicsinstallation": {
                "name": "Blessing of the Divine Relic’s Installation",
                "tags": ['event'],
                "image": "/cards/i_n333024.webp",
                "golden_image": "/cards/i_n337024.webp",
                "hi_res_image": "/cards/i_n333024_gcg_high_resolution.webp",
                "cost": '0 White',
                "description": "Shift 1 Artifact Equipment Card that has been equipped to one of your characters to another one of your characters, , and reset the \"usages per Round\" limit on its effects.",
                "flavor": "“Hehe… Well now, isn’t this finally getting interesting?”",
                "id": '3Q'        
            },
            
            "quickknit": {
                "name": "Quick Knit",
                "tags": ['event'],
                "image": "/cards/i_n333025.webp",
                "golden_image": "/cards/i_n337025.webp",
                "hi_res_image": "/cards/i_n333025_gcg_high_resolution.webp",
                "cost": '1 White',
                "description": "Choose one Summon on your side and grant it +1 Usage(s).",
                "flavor": "‘Tis the secret to Baron Bunny the 893rd’s longevity.",
                "id": '3R'        
            },
            
            "sendoff": {
                "name": "Send Off",
                "tags": ['event'],
                "image": "/cards/i_n333026.webp",
                "golden_image": "/cards/i_n337026.webp",
                "hi_res_image": "/cards/i_n333026_gcg_high_resolution.webp",
                "cost": '2 White',
                "description": "Choose one Summon on the opposing side and cause it to lose usages by 2.",
                "flavor": "“Here at Wangsheng Funeral Parlor, you can count on us to go full send! Satisfaction guaranteed!”",
                "id": '3S'        
            },
            
            "guardiansoath": {
                "name": "Guardian’s Oath",
                "tags": ['event'],
                "image": "/cards/i_n333027.webp",
                "golden_image": "/cards/i_n337027.webp",
                "hi_res_image": "/cards/i_n333027_gcg_high_resolution.webp",
                "cost": '4 White',
                "description": "Destroy all Summons. (Affects both you and your opponent!)",
                "flavor": "“Adeptus Xiao. I will be here when you call.”",
                "id": '3T'        
            },
            
            "abyssalsummons": {
                "name": "Abyssal Summons",
                "tags": ['event'],
                "image": "/cards/i_n333028.webp",
                "golden_image": "/cards/i_n337028.webp",
                "hi_res_image": "/cards/i_n333028_gcg_high_resolution.webp",
                "cost": '2 White',
                "description": "Summon 1 'Random Hilichurl Summon'!\n\n(You must have at least 2 Monster characters in your deck to add this card to your deck.)",
                "related": "Electro Hilichurl Shooter, Cryo Hilichurl Shooter, Hilichurl Berserker, Hydro Samachurl, ",
                "flavor": "“Yaya ika!”",
                "required": "2monster",
                "id": '3U'        
            },
    
            "fatuiconspiracy": {
                "name": "Fatui Conspiracy",
                "tags": ['event'],
                "image": "/cards/i_n333041.webp",
                "golden_image": "/cards/i_n337041.webp",
                "hi_res_image": "/cards/i_n333041_gcg_high_resolution.webp",
                "cost": '2 White',
                "description": "Create 1 Fatui Ambushers of a random type on the opponent's field.\n\n(You must have at least 2 Fatui characters in your deck to add this card to your deck.)",
                'required': '2fatui',
                'related': 'Cryo Cicin Mage, Mirror Maiden, Pyroslinger Bracer, Electrohammer Vanguard',
                "flavor": '...But none know the intricacies of what they are plotting.',
                'id': '67'
            },
    
            "plungingstrike": {
                "name": "Plunging Strike",
                "tags": ['event', 'slowly'],
                "image": "/cards/i_n333042.webp",
                "golden_image": "/cards/i_n337042.webp",
                "hi_res_image": "/cards/i_n333042_gcg_high_resolution.webp",
                "cost": '3 White',
                "description": "Combat Action: Switch to the target character. That character then uses a Normal Attack.",
                "flavor": '"...Don\'t deploy your Wind Glider halfway down! You\'ll get discovered!"',
                'id': '68'
            },
    
            "heavystrike": {
                "name": "Heavy Strike",
                "tags": ['event'],
                "image": "/cards/i_n333043.webp",
                "golden_image": "/cards/i_n337043.webp",
                "hi_res_image": "/cards/i_n333043_gcg_high_resolution.webp",
                "cost": '1 White',
                "description": "During this round, your current active character's next Normal Attack deals +1 DMG.\n\nWhen this Normal Attack is a Charged Attack: +1 additional DMG.",
                "flavor": 'For those that aren\'t so strong...\nIt\'s best to regard the "The Shatterstone Method" as just a "metaphor."',
                'id': '69'
            },
    
            "thelegendofvennessa": {
                "name": "The Legend of Vennessa",
                "tags": ['event'],
                "image": "/cards/i_n333044.webp",
                "golden_image": "/cards/i_n337044.webp",
                "hi_res_image": "/cards/i_n333044_gcg_high_resolution.webp",
                "cost": '3 White',
                "description": "Create 4 basic Elemental Dice of different types.",
                "flavor": '"Lonely forest breezes converged, jointly they overthrew the tyrant\'s tower from the sky."\n"Broken free from shackles at last, the young lioness stood firm in the winds with her head held high."',
                'id': '6A'
            },

            "friendshipeternal": {
                "name": "Friendship Eternal",
                "tags": ['event'],
                "image": "/cards/i_n333045.webp",
                "golden_image": "/cards/i_n337045.webp",
                "hi_res_image": "/cards/i_n333045_gcg_high_resolution.webp",
                "cost": "2 White",
                "description": "Players with less than 4 cards in their hand draw cards until their hand has 4 cards in it.",
                "flavor": "Good friends never truly leave. They stay with us in another form.",
                "id": '6F'
            },

            "rhythmofthegreatdream": {
                "name": "Rhythm of the Great Dream",
                "tags": ['event'],
                "image": "/cards/i_n333052.webp",
                "golden_image": "/cards/i_n337052.webp",
                "hi_res_image": "/cards/i_n333052_gcg_high_resolution.webp",
                "cost": "0 White",
                "description": "The next time you play a Weapon or Artifact from your hand: Use 1 less Elemental Die.",
                "flavor": "\"Enter our dreams, our world.\"\n\"Write of deeds good, brave, and honest.\"",
                "id": '6Q'
            },

            "whereistheunseenrazor": {
                "name": "Where Is the Unseen Razor?",
                "tags": ['event'],
                "image": "/cards/i_n333054.webp",
                "golden_image": "/cards/i_n337054.webp",
                "hi_res_image": "/cards/i_n333054_gcg_high_resolution.webp",
                "cost": "0 White",
                "description": "Return a Weapon card equipped by your character to your Hand. \n\nDuring this Round, the next time you play a Weapon card: Spend 2 less Elemental Dice.",
                "flavor": "The origins of this Branch Master of the Adventurers' Guild are shrouded in mystery, yet she keeps looking for clues about the sword, constantly challenging powerful enemies along the way...",
                "id": '71'
            },

            "pankration": {
                "name": "Pankration!",
                "tags": ['event'],
                "image": "/cards/i_n333056.webp",
                "golden_image": "/cards/i_n337056.webp",
                "hi_res_image": "/cards/i_n333056_gcg_high_resolution.webp",
                "cost": "0 White",
                "description": "Can only be played when you have at least 8 Elemental Dice remaining, and your opponent has not yet ended their Round: After a player announces the end of their Round first, the other player, who has yet to announced the end of their Round, draws 2 cards.",
                "flavor": "\"For victory, Credit Coupons, and the hottest goods in the Rag and Bone Shop... and the freedom that may come someday, strike!\"",
                "id": '7D'
            },

            "lyresong": {
                "name": "Lyresong",
                "tags": ['event'],
                "image": "/cards/i_n333058.webp",
                "golden_image": "/cards/i_n337058.webp",
                "hi_res_image": "/cards/i_n333058_gcg_high_resolution.webp",
                "cost": "0 White",
                "description": "Can only be played when you have at least 8 Elemental Dice remaining, and your opponent has not yet ended their Round: After a player announces the end of their Round first, the other player, who has yet to announced the end of their Round, draws 2 cards.",
                "flavor": "\"For victory, Credit Coupons, and the hottest goods in the Rag and Bone Shop... and the freedom that may come someday, strike!\"",
                "id": '7O'
            },

            'theboarprincess': { 
                'name': 'The Boar Princess',
                'tags': ['event'],
                'hi_res_image': '/cards/i_n333060_gcg_high_resolution.webp',
                'image': '/cards/i_n333060.webp',
                'golden_image': '/cards/i_n337060.webp',
                'cost': '0 White',
                'description': "Each time you discard an Equipment Card from one of your characters during this Round: Gain 1 Omni Element. (Max 2) \n\n(This effect can be triggered by the loss of an Equipment Card from a character falling or from having their Weapon or Artifact replaced.)",
                'flavor': "In ancient legends, the Boat Kingdom was prosperous and filled with joy. The young princess of the Kingdom took the wise Fox and long-lived Tortoise, and set out on the road to the north, hoping to turn the little wolf back into that good child...",
                'id': '8R',
            },

            'fallsandfortune': { 
                'name': 'Falls and Fortune',
                'tags': ['event'],
                'hi_res_image': '/cards/i_n333061_gcg_high_resolution.webp',
                'image': '/cards/i_n333061.webp',
                'golden_image': '/cards/i_n337061.webp',
                'cost': '1 White',
                'description': "This card can only be played when your side has less than 8 Elemental Dice and your opponent has not declared the end of their Round: In this Round, both sides must spend 1 extra Elemental Die to switch characters.",
                'flavor': "The accident of falling into a pit can also be a chance to reveal the buried past beneath the dust.",
                'id': '8S',
            },

            'flickeringfour-leafsigil': { 
                'name': 'Flickering Four-Leaf Sigil',
                'tags': ['event'],
                'hi_res_image': '/cards/i_n333062_gcg_high_resolution.webp',
                'image': '/cards/i_n333062.webp',
                'golden_image': '/cards/i_n337062.webp',
                'cost': '0 White',
                'description': "Attached Four-Leaf Sigil to target character: At the End Phase of Every Round, you will switch to this character.",
                'flavor': "A wondrous symbol shaped like a four-leaf clover, it is of great assistance to one who manipulates the elements.",
                'related': 'Four-Leaf Sigil',
                'id': '8T',
            },

            'machineassemblyline': { 
                'name': 'Machine Assembly Line',
                'tags': ['event'],
                'hi_res_image': '/cards/i_n333064_gcg_high_resolution.webp',
                'image': '/cards/i_n333064.webp',
                'golden_image': '/cards/i_n337064.webp',
                'cost': '0 White',
                'description': "Each time after your character is targeted by and takes DMG or is healed: Accumulate 1 point of Battle-Readiness (Max 2 points). \n\nWhen you play a Weapon or Artifact with an original cost of fewer Dice than you have Battle-Readiness points: Clear all Battle-Readiness points and play that card for free.",
                'flavor': "Countless widgets, heated and forged, eventually go into making these exceptional machines, and to the inmates of the Fortress of Meropide, they mean valuable Credit Coupons...",
                'id': '97',
            },

            'sunyataflower': { 
                'name': 'Sunyata Flower',
                'tags': ['event'],
                'hi_res_image': '/cards/i_n333065_gcg_high_resolution.webp',
                'image': '/cards/i_n333065.webp',
                'golden_image': '/cards/i_n337065.webp',
                'cost': '0 White',
                'description': "Select a card from your Support Zone and discard it. After that, randomly generate 2 Support Cards in your hand. \n\nDuring the Round, the next time you play a Support Card: Spend 1 less Elemental Die.",
                'flavor': "\"This vibrant color is the miracle of life's flowing springs.\"\n\"Abide with me, sing and caper with me, and let us weave eternal joy\"...",
                'id': '98',
            },
            
            "jueyunguoba": {
                "name": "Jueyun Guoba",
                "tags": ['event', 'food'],
                "image": "/cards/i_n333029.webp",
                "golden_image": "/cards/i_n337029.webp",
                "hi_res_image": "/cards/i_n333029_gcg_high_resolution.webp",
                "cost": '0 White',
                "description": "During this Round, the target character’s next Normal Attack deals +1 DMG.\n\n(A character can consume at most 1 Food per Round)",
                "flavor": "Flavorful and crispy Jueyun Guoba — with Guoba’s stamp of approval.",
                "id": '3V'        
            },
            
            "adeptustemptation": {
                "name": "Adeptus’ Temptation",
                "tags": ['event', 'food'],
                "image": "/cards/i_n333030.webp",
                "golden_image": "/cards/i_n337030.webp",
                "hi_res_image": "/cards/i_n333030_gcg_high_resolution.webp",
                "cost": '2 Black',
                "description": "During this Round, the target character’s next Elemental Burst deals +3 DMG.\n\n(A character can consume at most 1 Food per Round)",
                "flavor": "It is said that this name was derived from this dish’s ability to tempt an adeptus to return to the mortal realm. But that begs the question… Which adeptus was that?",
                "id": '3W'        
            },
            
            "lotusflowercrisp": {
                "name": "Lotus Flower Crisp",
                "tags": ['event', 'food'],
                "image": "/cards/i_n333031.webp",
                "golden_image": "/cards/i_n337031.webp",
                "hi_res_image": "/cards/i_n333031_gcg_high_resolution.webp",
                "cost": '1 White',
                "description": "During this Round, the next time, the target character takes -3 DMG.\n\n(A character can consume at most 1 Food per Round)",
                "flavor": "Dough is formed into bud-like shapes and placed into a pot of oil as if upon the surface of a lake, causing them to slowly bloom layer by layer… A pleasing sight indeed.",
                "id": '3X'        
            },
            
            "northernsmokedchicken": {
                "name": "Northern Smoked Chicken",
                "tags": ['event', 'food'],
                "image": "/cards/i_n333032.webp",
                "golden_image": "/cards/i_n337032.webp",
                "hi_res_image": "/cards/i_n333032_gcg_high_resolution.webp",
                "cost": '0 White',
                "description": "During this Round, the target character’s next Normal Attack costs 1 less 'Unaligned Element'.\n\n(A character can consume at most 1 Food per Round)",
                "flavor": "This dish makes for a warm welcome for guests who come to the northern regions. Now, what manner of guests shall be “treated” to this hospitality this time?",
                "id": '3Y'        
            },
            
            "sweetmadame": {
                "name": "Sweet Madame",
                "tags": ['event', 'food'],
                "image": "/cards/i_n333033.webp",
                "golden_image": "/cards/i_n337033.webp",
                "hi_res_image": "/cards/i_n333033_gcg_high_resolution.webp",
                "cost": '0 White',
                "description": "Heal the target character for 1 HP.\n\n(A character can consume at most 1 Food per Round)",
                "flavor": "Perhaps some have never seen a chicken run… But there’s no one who hasn’t tried a Sweet Madame!",
                "id": '3Z'        
            },
            
            "mondstadthashbrown": {
                "name": "Mondstadt Hash Brown",
                "tags": ['event', 'food'],
                "image": "/cards/i_n333034.webp",
                "golden_image": "/cards/i_n337034.webp",
                "hi_res_image": "/cards/i_n333034_gcg_high_resolution.webp",
                "cost": '1 White',
                "description": "Heal the target character for 2 HP.\n\n(A character can consume at most 1 Food per Round)",
                "flavor": "The sweet taste verifies the famous words of a certain famous gourmet known throughout Mondstadt — a dish that may be called a regional specialty cannot taste bad.",
                "id": '40'        
            },
            
            "mushroompizza": {
                "name": "Mushroom Pizza",
                "tags": ['event', 'food'],
                "image": "/cards/i_n333035.webp",
                "golden_image": "/cards/i_n337035.webp",
                "hi_res_image": "/cards/i_n333035_gcg_high_resolution.webp",
                "cost": '1 White',
                "description": "Heal the target character for 1 HP. For the next two Rounds, heal this character for 1 HP again at the End Phase.\n\n(A character can consume at most 1 Food per Round)",
                "flavor": "They say that a researcher once used very precise calculations to uncover the “fairest way to cut pizza,” but as the process is far too bothersome, basically no one uses it…",
                "id": '41'        
            },
            
            "mintymeatrolls": {
                "name": "Minty Meat Rolls",
                "tags": ['event', 'food'],
                "image": "/cards/i_n333036.webp",
                "golden_image": "/cards/i_n337036.webp",
                "hi_res_image": "/cards/i_n333036_gcg_high_resolution.webp",
                "cost": '1 White',
                "description": "Before this Round ends, the target character’s next 3 Normal Attacks cost 1 less 'Unaligned Element'.\n\n(A character can consume at most 1 Food per Round)",
                "flavor": "Though this might be its current form, think about it for a moment: did this dish first start as mint rolled around meat, or meat rolled around mint?",
                "id": '42'        
            },  
    
            "teyvatfriedegg": {
                "name": "Teyvat Fried Egg",
                "tags": ['event', 'food'],
                "image": "/cards/i_n333046.webp",
                "golden_image": "/cards/i_n337046.webp",
                "hi_res_image": "/cards/i_n333046_gcg_high_resolution.webp",
                "cost": '2 White',
                'description': "Revives the target character and heals that character for 1 HP. \n\n(You can only revive 1 character via Food per Round, and a character can consume at most 1 Food per Round)",
                "flavor": '"Lonely forest breezes converged, jointly they overthrew the tyrant\'s tower from the sky."\n"Broken free from shackles at last, the young lioness stood firm in the winds with her head held high."',
                'id': '6B'
            },
    
            "sashimiplatter": {
                "name": "Sashimi Platter",
                "tags": ['event', 'food'],
                "image": "/cards/i_n333047.webp",
                "golden_image": "/cards/i_n337047.webp",
                "hi_res_image": "/cards/i_n333047_gcg_high_resolution.webp",
                "cost": '1 White',
                "description": "Before this Round ends, the target character's Normal Attacks deal +1 DMG.\n\n(A character can consume at most 1 Food per Round)",
                "flavor": 'Under the blade of a master chef, the texture of the ingredients remains pristine. Upon consumption, it is as if something living is leaping inside your mouth...\nHold on, could these ingredients still be...',
                'id': '6C'
            },
    
            "tandooriroastchicken": {
                "name": "Tandoori Roast Chicken",
                "tags": ['event', 'food'],
                "image": "/cards/i_n333048.webp",
                "golden_image": "/cards/i_n337048.webp",
                "hi_res_image": "/cards/i_n333048_gcg_high_resolution.webp",
                "cost": '2 Black',
                "description": "During this Round, all your characters' next Elemental Skills deal +2 DMG.\n\n(A character can consume at most 1  Food per Round)",
                "flavor": 'Under the blade of a master chef, the texture of the ingredients remains pristine. Upon consumption, it is as if something living is leaping inside your mouth...\nHold on, could these ingredients still be...',
                'id': '6D'
            },
            "buttercrab": {
                "name": "Butter Crab",
                "tags": ['event', 'food'],
                "image": "/cards/i_n333049.webp",
                "golden_image": "/cards/i_n337049.webp",
                "hi_res_image": "/cards/i_n333049_gcg_high_resolution.webp",
                "cost": '2 Black',
                "description": "During this Round, all your characters take -2 DMG the next time.\n\n(A character can consume at most 1 Food per Round)",
                "flavor": 'The butter-infused crab legs have a rich aroma that washes over the tastes buds so seductively that none can resist its allure.\n"Another dish, please!"',
                'id': '6E'
            },

            'fishandchips': { 
                'name': 'Fish and Chips',
                'tags': ['event', 'food'],
                'hi_res_image': '/cards/i_n333063_gcg_high_resolution.webp',
                'image': '/cards/i_n333063.webp',
                'golden_image': '/cards/i_n337063.webp',
                'cost': '2 Black',
                'description': "During this Round, all your characters will use 1 less Elemental Die when using their next Skill.\n(A character can consume at most 1 Food per Round)",
                'flavor': "Fish fried until golden and crispy, with chips and a smorgasbord of sauces. Every single bite is suffused with savory satisfaction...",
                'id': '8U',
            },

            'matsutakemeatrolls': { 
                'name': 'Matsutake Meat Rolls',
                'tags': ['event', 'food'],
                'hi_res_image': '/cards/i_n333066_gcg_high_resolution.webp',
                'image': '/cards/i_n333066.webp',
                'golden_image': '/cards/i_n337066.webp',
                'cost': '2 White',
                'description': "Heal the target character for 2 HP. For the next 3 Rounds, heal this character for 1 HP again during the End Phase. \n\n(A character can consume at most 1 3101_BuffFood per Round)",
                'flavor': "Ground meat is put on the Matsutake and gently pan-fried on low heat so the Matsutake can fully take in the aromatic juice of the meat. It's a mouthwatering delicacy in all of its glory.",
                'id': '99',
            },
        },
    
        "misc": {
            "lightningstilleto": {
                "name": "Lightning Stilleto",
                "type": "Event",
                "cost": "3 Electro",
                "description": "'Combat Action': Switch your Keqing in to be the active character and immediately use 'Stellar Restoration' once. This instance of 'Stellar Restoration' will grant Keqing 'Electro Infusion' without creating another Lightning Stiletto.\n\n(When Keqing uses 'Stellar Restoration' with this card in Hand: Instead of creating another Lightning Stiletto, discard this card and Keqing gains 'Electro Infusion'.)",
                "related": "Keqing",
                "image": Keqing_Summon
            },
            "electroinfusion": {
                "name": "Keqing's Electro Infusion",
                "type": "Status",
                "description": "The character to which this is attached has their Physical DMG dealt converted to Electro DMG. \n\n'Duration (Rounds)': 2",
                "related": "Keqing",
            },
            "oz": {
                "name": "Oz",
                "type": "Summon",
                "description": "End Phase: Deal 1 Electro DMG. \n\nUsage(s): 2",
                "related": "Fischl",
                "image": Fischl_Summon
            },
            "thewolfwithin": {
                "name": "The Wolf Within",
                "type": "Status",
                "description": "After the character to which this is attached uses a Normal Attack or Elemental Skill: Deal 2 additional Electro DMG. \n\n'Duration (Rounds)': 2",
                "related": "Razor",
                "image": Razor_Status
            },
            "pactswornpathclearer": {
                "name": "Pactsworn Pathclearer",
                "type": "Status",
                "description": "End Phase: Gain 1 level of 'Indwelling'. \n\nCreate the following effects based on the 'Indwelling' Level: \n -If equal to or greater than 2: Physical DMG dealt is converted to Electro DMG. \n -If equal to or greater than 4: DMG dealt +2 \n -If equal to or greater than 6: 'Indwelling' Level -4",
                "related": "Razor",
                "image": Cyno_Status
            },
            "icelotus": {
                "name": "Ice Lotus",
                "type": "Combat Status",
                "description": "When your active character receives DMG: reduce that DMG by 1. \n\nUsage(s): 2",
                "related": "Ganyu"
            },
            "sacredcryopearl": {
                "name": "Sacred Cryo Pearl",
                "type": "Summon",
                "description": "End Phase: Deal 1 Cryo DMG, and 1 Piercing DMG to all characters on standby. \n\nUsage(s): 2",
                "related": "Ganyu",
                "image": Ganyu_Summon
            },
            "frostflake": {
                "name": "Frostflake Seki no To",
                "type": "Summon",
                "description": "End Phase: Deal 2 Cryo DMG. \n\nUsage(s): 2",
                "related": "Ayaka",
                "image": Ayaka_Summon
            },
            "cryoinfusion": {
                "name": "Kamisato Ayaka's Cryo Infusion",
                "type": "Status",
                "description": "The character to which this is attached has their Physical DMG dealt converted to Cryo DMG. \n\n(Lasts until the Round ends)",
                "related": "Ayaka",
            },
            "catclawshield": {
                "name": "Cat-Claw Shield",
                "type": "Combat Status",
                "description": "Provides 1 Shield Point for your active character.",
                "related": "Diona"
            },
            "drunkenmist": {
                "name": "Drunken Mist",
                "type": "Summon",
                "description": "End Phase: Deal 1 Cryo DMG, and heal your active character for 2. \n\nUsage(s): 2",
                "related": "Diona",
                "image": Diona_Summon
            },
            "chonghuafrostfield": {
                "name": "Chonghua Frost Field",
                "type": "Combat Status",
                "description": "Physical DMG caused by your active sword, claymore, and polearm characters is converted to Cryo DMG. \n\n'Duration (Rounds)': 2",
                "related": "Chongyun"
            },
            "Icicle": {
                "name": "Icicle",
                "type": "Combat Status",
                "description": "After you switch characters: Deal 2 Cryo DMG. \n\nUsage(s): 3",
                "related": "Kaeya",
                "image": Kaeya_BStatus
            },
            "reflection": {
                "name": "Reflection",
                "type": "Summon",
                "description": "When your active character receives DMG: Decrease DMG taken by 1.\n\nUsage(s): 1. When this card's Usage(s) are depleted, this card will not be discarded.\n\nDuring the End Phase: Discard this card, deal 1 Hydro DMG.",
                "related": "Mona",
                "image": Mona_Summon
            },
            "illusorybubble": {
                "name": "Illusory Bubble",
                "type": "Combat Status",
                "description": "When you deal Skill DMG: remove this Combat Status and double the DMG dealt for the instance.",
                "related": "Mona",
                "image": Mona_BStatus
            },
            "melodyloop": {
                "name": "Melody Loop",
                "type": "Summon",
                "description": "End Phase: Heal all your characters for 1, then apply 'Hydro Application' on your active character. \n\nUsage(s): 2",
                "related": "Barbara",
                "image": Barbara_Summon
            },
            "rainsword": {
                "name": "Rain Sword",
                "type": "Combat Status",
                "description": "When your active character receives 3 or more DMG: reduce that DMG by 1. \n\nUsage(s): 2",
                "related": "Xingqiu",
            },
            "rainbowbladework": {
                "name": "Rainbow Bladework",
                "type": "Combat Status",
                "description": "After your active character uses a normal attack: Deal 1 Hydro DMG. \n\nUsage(s): 3",
                "related": "Xingqiu",
                "image": Xingqiu_BStatus1
            },
            "niwabienshou": {
                "name": "Niwabi Enshou",
                "type": "Status",
                "description": "The attached character's normal attacks deal +1 DMG and any Physical DMG becomes Pyro DMG. \n\nUsage(s): 2",
                "related": "Yoimiya"
            },
            "aurousblaze": {
                "name": "Aurous Blaze",
                "type": "Combat Status",
                "description": "After a character other than Yoimiya uses any skill: Deal 1 additional Pyro DMG. \n\n'Duration (Rounds)': 2",
                "related": "Yoimiya",
                "image": Yoimiya_BStatus
            },
            "guoba": {
                "name": "Guoba",
                "type": "Summon",
                "description": "End Phase: Deal 2 Pyro DMG. \n\nUsage(s): 2",
                "related": "Xiangling",
                "image": Xiangling_Summon
            },
            "pyronado": {
                "name": "Pyronado",
                "type": "Combat Status",
                "description": "After your active character uses any skill: Deal 2 additional Pyro DMG. \n\nUsage(s): 2",
                "related": "Xiangling",
                "image": Xiangling_BStatus
            },
            "inspirationfield": {
                "name": "Inspiration Field",
                "type": "Combat Status",
                "description": "When your active character uses any skill while they have 7 or more HP: Increase the DMG by 2. If your active character is at 6 or lower HP after performing an skill: Heal that character for 2. \n\n'Duration (Rounds)': 2",
                "related": "Bennett",
                "image": Bennett_BStatus
            },
            "dandelionfield": {
                "name": "Dandelion Field",
                "type": "Summon",
                "description": "End Phase: Deal 2 Anemo DMG, then restore 1 HP to your active character. \n\nUsage(s): 2",
                "related": "Jean",
                "image": Jean_Summon
            },
            "largewindspirit": {
                "name": "Large Wind Spirit",
                "type": "Summon",
                "description": "End Phase: Deal 2 Anemo DMG. \n\nUsage(s): 3. \n\nAfter this card or your active character triggers a swirl reaction: Convert the DMG dealt by this card to that element. (Only once)",
                "related": "Sucrose",
                "image": Sucrose_Summon
            },
            "jadescreen": {
                "name": "Jade Screen",
                "type": "Combat Status",
                "description": "After your active character recieves 2 or more DMG: reduce that DMG by 1. \n\nUsage(s): 2",
                "related": "Ningguang"
            },
            "fullplate": {
                "name": "Full Plate",
                "type": "Combat Status",
                "description": "Provides 2 shield points for your active character. While this shield is up, any Physical DMG recieves is halved.",
                "related": "Noelle"
            },
            "sweepingtime": {
                "name": "Sweeping Time",
                "type": "Status",
                "description": "Once per round: when the character this is attached to performs a normal attack, spend 1 less Geo Die. The DMG caused by this character's normal attacks deal +2 DMG and the Physical DMG is converted to Geo DMG. \n\n'Duration (Rounds)': 2",
                "related": "Noelle",
                "image": Noelle_Status
            },
            "stonehide": {
                "name": "Stonehide",
                "type": "Status",
                "description": "When the character to which this is attached to recieves DMG: Decrease DMG taken by 1. When Geo DMG is decreased, comsume 1 additional Usage(s). \n\nUsage(s): 3",
                "related": "Stonehide Lawachurl"
            },
            "stoneforce": {
                "name": "Stone Force",
                "type": "Status",
                "description": "The character to which this is attached has their Physical DMG converted to Geo DMG. \n\nOnce per Round: The character deals +1 DMG. \n\nOnce the Stonehide attached to this character is removed, this status is removed alongside it.",
                "related": "Stonehide Lawachurl"
            },
            "cuileinanbar": {
                "name": "Cuilein-Anbar",
                "type": "Summon",
                "description": "End Phase: Deal 2 Dendro DMG. \n\nUsage(s): 2",
                "related": "Collei",
                "image": Collei_Summon
            },
            "radicalvitality": {
                "name": "Radical Vitality",
                "type": "Status",
                "description": "When this character takes or deals Elemental DMG: gain 1 stack of 'Radical Vitality' (max 3 stacks). \n\nEnd Phase: If 'Radical Vitality' stacks reach maximum, they will be cleared and the character will lose all energy.",
                "related": "Jadeplume Terrorshroom",
                "image": Terrorshroom_Status
            },
            "hydromimicsquirrel": {
                "name": "Oceanic Mimic: Squirrel",
                "type": "Summon",
                "description": "End Phase: Deal 2 Hydro DMG. \n\nUsage(s): 2",
                "related": "Rhodeia of Loch",
                "image": Oceanoid_Summon1
            },
            "hydromimicraptor": {
                "name": "Oceanic Mimic: Raptor",
                "type": "Summon",
                "description": "End Phase: Deal 1 Hydro DMG. \n\nUsage(s): 3",
                "related": "Rhodeia of Loch",
                "image": Oceanoid_Summon2
            },
            "hydromimicfrog": {
                "name": "Oceanic Mimic: Frog",
                "type": "Summon",
                "description": "When your active character receives DMG: Reduce that DMG taken by 1.\n\nUsage(s): 2. When this card's Usage(s) are depleted, this card will not be discarded.\n\nDuring the End Phase, if this card's Usage(s) have been depleted: Discard this card and deal 2 Hydro DMG.\n\nNote: THE WORDING ON THIS SUMMON IN GAME IS SUPER WEIRD. AT THE MOMENT IT IS EXTREMELY SUBJECT TO CHANGE.",
                "related": "Rhodeia of Loch",
                "image": Oceanoid_Summon3
            },
            "stealth": {
                "name": "Stealth",
                "type": "Status",
                "description": "Reduce any DMG received by 1, and increase any DMG dealt by 1. \n\nUsage(s): 2",
                "related": "Fatui Pyro Agent"
            },
            "refraction": {
                "name": "Refraction",
                "type": "Status",
                "description": "Incoming Hydro DMG +1. \n\n'Duration (Rounds)': 2",
                "related": "Mirror Maiden"
            },
            "pyroinfusion": {
                "name": "Diluc's Pyro Infusion",
                "type": "Status",
                "description": "The character to which this is attached has their Physical DMG dealt converted to Pyro DMG. \n\n'Duration (Rounds)': 2",
                "related": "Diluc",
            },
            "maguuanemo": {
                "name": "Shadowsword: Lone Gale",
                "type": "Summon",
                "description": "End Phase: Deal 1 Anemo DMG.\n\nUsage(s): 2 \n",
                "related": "Maguu Kenki",
                "image": Maguu_Summon2
            },
            "maguucryo": {
                "name": "Shadowsword: Galloping Frost",
                "type": "Summon",
                "description": "End Phase: Deal 1 Cryo DMG. \n\nUsage(s): 2",
                "related": "Maguu Kenki",
                "image": Maguu_Summon1
            },
            "cryohilichurlshooter": {
                "name": "Cryo Hilichurl Shooter",
                "type": "Summon",
                "description": "End Phase: Deal 1 Cryo DMG. \n\nUsage(s): 2",
                "related": "Abyssal Summons",
                "image": Hilichurl_Summon1
            },
            "hydrosamachurl": {
                "name": "Hydro Samachurl",
                "type": "Summon",
                "description": "End Phase: Deal 1 Hydro DMG. \n\nUsage(s): 2",
                "related": "Abyssal Summons",
                "image": Hilichurl_Summon2
            },
            "hilichurlberserker": {
                "name": "Hilichurl Berserker",
                "type": "Summon",
                "description": "End Phase: Deal 1 Pyro DMG. \n\nUsage(s): 2",
                "related": "Abyssal Summons",
                "image": Hilichurl_Summon3
            },
            "electrohilichurlshooter": {
                "name": "Electro Hilichurl Shooter",
                "type": "Summon",
                "description": "End Phase: Deal 1 Electro DMG. \n\nUsage(s): 2",
                "related": "Abyssal Summons",
                "image": Hilichurl_Summon4
            },
            "explosivespark": {
                "name": "Explosive Spark",
                "type": "Status",
                "description": "When the character to which this is attached uses a Charged Attack: Spend 1 less Pyro Die and deal +1 DMG. \n\nUsage(s): 1 \n\nCharged Attack: When the total number of your Elemental Dice is even, the Normal Attack to use will be considered a Charged Attack.",
                "related": "Klee"
            },
            "sparks'n'splash": {
                "name": "Sparks'n'Splash",
                "type": "Combat Status",
                "description": "After a character to which Sparks 'n' Splash is attached uses a Skill: Deals 2 Pyro DMG to their team's active character. \n\nUsage(s): 2",
                "related": "Klee",
                "image": Klee_Status
            },
            "tidecallersurfembrace": {
                "name": "Tidecaller: Surf Embrace",
                "type": "Status",
                "description": "The next time this character acts, they will immediately use the Skill Wavestrider. While preparing this Skill: Grant 2 Shield points to the character to which this is attached.",
                "related": "Beidou"
            },
            "thunderbeaststarge": {
                "name": "Thunderbeast's Targe",
                "type": "Combat Status",
                "description": "After your character uses a Normal Attack: Deal 1 Electro DMG. When your character takes at least 3 DMG: Decrease DMG taken by 1. \n\nDuration (Rounds): 2",
                "related": "Beidou",
                "image": Beidou_BStatus
            },
            "tengujurraiambush": {
                "name": "Tengu Jurrai: Ambush",
                "type": "Summon",
                "description": "End Phase: Deal 1 Electro DMG, applies Crowfeather Cover to friendly active character. \n\nUsage(s): 1",
                "related": "Kujou Sara",
                "image": Sara_Summon1
            },
            "tengujurraistormcluster": {
                "name": "Tengu Jurrai: Stormcluster",
                "type": "Summon",
                "description": "End Phase: Deal 2 Electro DMG, applies Crowfeather Cover to friendly active character. \n\nUsage(s): 2",
                "related": "Kujou Sara",
                "image": Sara_Summon2
            },
            "crowfeathercover": {
                "name": "Crowfeather Cover",
                "type": "Status",
                "description": "The character with this attached deals +1 Elemental Skill and Elemental Burst DMG. \n\nUsage(s): 2 \n\nAfter this card effect is triggered: 1 Usage of it will be consumed. This card will be discarded immediately once it has 0 Usages remaining.",
                "related": "Kujou Sara"
            },
            "bakekurage": {
                "name": "Bake-Kurage",
                "type": "Summon",
                "description": "End Phase: Deal 1 Hydro DMG, heal your active character for 1 HP. \n\nUsage(s): 2",
                "related": "Sangonomiya Kokomi",
                "image": Kokomi_Summon
            },
            "ceremonialgarment": {
                "name": "Ceremonial Garment",
                "type": "Status",
                "description": "The character to which this is attached has their Normal Attacks deal +1 DMG, and after using a Normal Attack, heal 1 HP for all characters. \n\nDuration (Rounds): 2",
                "related": "Sangonomiya Kokomi",
                "image": Kokomi_Status
            },
            "grimheart": {
                "name": "Grimheart",
                "type": "Status",
                "description": "After the character to which this is attached uses Icetide Vortex: Remove this status, DMG +3.",
                "related": "Eula",
            },
            "lightfallsword": {
                "name": "Lightfall Sword",
                "type": "Summon",
                "description": "When Eula uses a Skill, this card will accumulate 2 Zeal stacks, but Eula will be unable to receive Energy. End Phase: Discard this card and deal 3 Physical DMG. Each Zeal stack adds 1 DMG to this damage instance.",
                "related": "Eula",
                "image": Eula_Summon
            },
            "takimegurikanka": {
                "name": "Takimeguri Kanka",
                "type": "Status",
                "description": "The character to which this is attached has their Normal Attacks deal +1 DMG, and their Physical DMG dealt converted to Hydro DMG. \n\nUsage(s): 3",
                "related": "Kamisato Ayato",
            },
            "gardenofpurity": {
                "name": "Garden of Purity",
                "type": "Summon",
                "description": "End Phase: Deal 2 Hydro DMG. \n\nUsage(s): 2 \n\nWhen this Summon is on the field: Your characters' Normal Attacks deal +1 DMG.",
                "related": "Kamisato Ayato",
                "image": Ayato_Summon
            },
            "ushi": {
                "name": "Ushi",
                "type": "Summon",
                "description": "When your active character receives DMG: Decrease DMG taken by 1. \n\nUsage(s): 1. \n\nWhen the Usage is depleted, this card will not be discarded. \n\nCan be triggered once while this Summon is present: When your character receives DMG, Arataki Itto gains Superlative Superstrength. \n\nEnd Phase: Discard this card, deal 1 Geo DMG.",
                "related": "Arataki Itto",
                "image": Itto_Summon
            },  
            "superlativesuperstrength": {
                "name": "Superlative Superstrength",
                "type": "Status",
                "description": "When the character to which this is attached uses a Charged Attack: Deal +1 DMG. If the Usage(s) are no less than 2, expend 1 less Unaligned Element. \n\nUsage(s): 1 (Can stack. Max 3 stacks.)\n\nCharged Attack: When the total number of your Elemental Dice is even, the Normal Attack to use will be considered a Charged Attack.",
                "related": "Arataki Itto"
            },
            "ragingoniking": {
                "name": "Raging Oni King",
                "type": "Status",
                "description": "The character to which this is attached has their Normal Attacks deal +2 DMG, and their Physical DMG dealt converted to Geo DMG. \n\nDuration (Rounds): 2 \n\nAfter the character to which this is attached uses a Normal Attack: Gains Superlative Superstrength. (Once per Round)",
                "related": "Arataki Itto"
            },
            'vijnanasuffusion': {
                "name": "Vijnana Suffusion",
                "type": "Status", 
                "description": "When the character to which this is attached uses a Charged Attack: Their Physical DMG dealt will be converted to Dendro DMG and after the Skill DMG is finalized, summon 1 'Clusterbloom Arrow'. \n\nUsage(s): 2\n\nCharged Attack: When the total number of your Elemental Dice is even, the Normal Attack to use will be considered a Charged Attack.",
                "related": "Tighnari"
            },
            'clusterbloomarrow': {
                "name": "Clusterbloom Arrow",
                "type": "Summon",
                "description": "End Phase: Deal 1 Dendro DMG. \n\nUsage(s): 1 (Can stack. Max 2 stacks.)",
                "related": "Tighnari",
                "image": Tighnari_Summon
            },
            'baronbunny': {
                "name": "Baron Bunny",
                "type": "Summon",
                "description": "When your active character takes DMG: Decrease DMG taken by 2. \n\nUsage(s): 1. When the Usages are depleted, this card will not be discarded. \n\nAt the End Phase, if Usage(s) have been depleted: Discard this card to deal 2 Pyro DMG.",
                "related": "Amber",
                "image": Amber_Summon
            },
            "paramitapapilio": {
                "name": "Paramita Papilio",
                "type": "Status",
                "description": "The character to which this is attached has their Physical DMG dealt converted to Pyro DMG, and they will deal +1 Pyro DMG. When the character to which this is attached uses a Charged Attack: Apply Blood Blossom to target character. \n\nDuration (Rounds): 2",
                "related": "Hu Tao"
            },
            "bloodblossom": {
                "name": "Blood Blossom",
                "type": "Status",
                "description": "End Phase: Deal 1 Pyro DMG to the character to which this is attached. \n\nUsage(s): 1",
                'related': "Hu Tao"
            },
            "eyeofstormyjudgement": {
                "name": "Eye of Stormy Judgement",
                "type": "Summon",
                "description": "End Phase: Deal 1 Electro DMG. \n\nUsage(s): 3 \n\nWhen this Summon is on the field: Your characters' Elemental Bursts deal +1 DMG.",
                "related": "Raiden Shogun",
                "image": Raiden_Summon
            },
            "chakradesiderata": {
                "name": "Chakra Desiderata",
                "type": "Status",
                "description": "After your other characters use Elemental Bursts: Gain 1 Resolve. (Max 3) \n\nWhen the character to which this is attached uses Secret Art: Musou Shinsetsu: Consume all Resolve and deal +1 DMG per Resolve.",
                "related": "Raiden Shogun"
            },
            "sesshousakura": {
                "name": "Sesshou Sakura",
                "type": "Summon",
                "description": "End Phase: Deal 1 Electro DMG. \n\nUsage(s): 3 (Can stack, max 6 stacks) \n\nWhen you declare the end of your Round: If this card's Usage(s) is at least 4, deal 1 Electro DMG. (Consumes Usage(s)s)",
                "related": "Yae Miko",
                "image": Yae_Summon
            },
            "tenkothunderbolts": {
                "name": "Tenko Thunderbolts",
                "type": "Combat Status",
                "description": "Before you choose your action: Deal 3 Electro DMG. \n\nUsage(s): 1",
                "related": "Yae Miko"
            },
            "stormzone": {
                "name": "Stormzone",
                "type": "Combat Status",
                "description": "When you perform \"Switch Character\": Spend 1 less Elemental Die. \n\nUsage(s): 2",
                "related": "Venti"
            },
            "stormeye": {
                "name": "Stormeye",
                "type": "Summon",
                "description": "End Phase: Deal 2 Anemo DMG, switch opposing character to Character closest to your current active character. \n\nUsage(s): 2 \n\nAfter your character or Summon triggers a Swirl reaction: Convert the Elemental Type of this card and change its DMG dealt to the element Swirled. (Can only be converted once before leaving the field)",
                "related": "Venti",
                "image": Venti_Summon
            },
            'yakshasmask': {
                'name': "Yaksha's Mask",
                "type": "Status",
                "description": "The character to which this is attached has their Physical DMG dealt converted to Anemo DMG, and they will deal +1 Anemo DMG. \n\nWhen the character to which this is attached uses a Plunging Attack: +2 extra DMG.\n\nIf the character to which this is attached is the active character, when you perform \"Switch Character\": Spend 1 less Elemental Die. (Once per Round)\n\nDuration (Rounds): 2",
                'related': "Xiao"
            },
            'stonestele': {
                'name': 'Stone Stele',
                'type': "Summon",
                "description": "End Phase: Deal 1  Geo DMG. \n\nUsage(s): 2",
                "related": "Zhongli",
                "image": Zhongli_Summon
            },
            'jadeshield': {
                'name': 'Jade Shield',
                'type': 'Combat Status',
                'description': 'Grants 2 Shield points for your active character.',
                'related': "Zhongli"
            },
            "petrification": {
                'name': 'Petrification',
                'type': "Status",
                'description': "Character cannot use Skills. (Lasts until the end of this Round)",
                "related": "Zhongli"
            },
            'seedsofskandha': {
                'name': 'Seed of Skandha',
                'type': 'Status',
                'description': 'After any character who has a Seed of Skandha takes Elemental Reaction DMG: Deals 1 Piercing DMG to the character(s) to which the Seed of Skandha is attached on the same side of the field. \n\nUsage(s): 2',
                'related': 'Nahida'
            },
            'shrineofmaya': {
                'name': 'Shrine of Maya',
                'type': 'Combat Status',
                'description': 'When your character triggers an Elemental Reaction: +1 additional DMG. \n\nDuration (Rounds): 2',
                'related': "Nahida"
            },
            'cryocicin': {
                'name': 'Cryo Cicin', 
                'type': 'Summon',
                'description': 'End Phase: Deal 1 Cryo DMG. \n\nUsage(s): 2 (Can stack, max 3 stacks) \n\nAfter Fatui Cryo Cicin Mage performs a Normal Attack: This card gains 1 Usage(s). After Fatui Cryo Cicin Mage takes Elemental Reaction DMG: This card loses 1 Usage(s).',
                'related': 'Fatui Cryo Cicin Mage',
                "image": Cicin_Summon
            },
            'flowingcicinshield': {
                'name': 'Flowing Cicin Shield',
                'type': 'Combat Status',
                'description': 'Provides 1 Shield for your active character. \n\nWhen created: If you have Cryo Cicin on the field, additionally increase Shield by the amount of Usage(s) it has. (Adds a maximum of 3 additional Shield)',
                'related': 'Fatui Cryo Cicin Mage'
            },
            'fieryrebirth': {
                'name': 'Fiery Rebirth',
                'type': 'Status',
                'description': 'When the character to which this is attached is defeated: Remove this effect, ensure the character will not be defeated, and heal them until they reach 3 HP.',
                'related': 'Abyss Lector: Fathomless Flames'
            },
            'darkfirefurnace': {
                'name': 'Darkfire Furnace',
                'type': 'Summon',
                'description': 'End Phase: Deal 1 Pyro DMG, deal 1 Piercing DMG to all opposing characters on standby. \n\nUsage(s): 2',
                'related': 'Abyss Lecor: Fathomless Flames',
                "image": Lector_Summon
            },
            'chainsofwardingthunder': {
                'name': 'Chains of Warding Thunder',
                'type': 'Summon',
                'description': 'End Phase: Deal 1 Electro DMG. \n\nUsage(s): 2 \n\nWhen this Summon is on the field: When your opponent uses Switch Character, they will have to spend 1 extra Elemental Die. (Once per Round)',
                'related': 'Electro Hypostasis',
                "image": Hypostasis_Summon
            },
            'electrocrystalcore': {
                'name': 'Electro Crystal Core',
                'type': 'Status',
                'description': 'When the character to which this is attached is defeated: Remove this effect, ensure the character will not be defeated, and heal them until they reach 1 HP.',
                'related': 'Electro Hypostasis'
            },
            'icyquill': {
                'name': 'Icy Quill',
                'type': 'Combat Status',
                'description': 'Your character deals 1 increased Cryo DMG (Includes the DMG triggered by Cryo-infused Swirl reactions) \n\nUsage(s): 3',
                'related': 'Shenhe'
            },
            'talismanspirit': {
                'name': 'Talisman Spirit',
                'type': 'Summon',
                'description': 'End Phase: Deal 1 Cryo DMG. \n\nUsage(s): 2 \n\nWhen this Summon is on the field: Opposing character(s) take +1 Cryo DMG and Physical DMG.',
                'related': 'Shenhe',
                "image": Shenhe_Summon
            },
            'meleestance': {
                'name': 'Melee Stance',
                'type': 'Status',
                'description': 'Physical DMG dealt by character is converted to Hydro DMG.\n\nAfter the character to which this is attached uses Charged Attack: Apply Riptide to target character.\n\nCharacter deals +1 DMG to target characters with Riptide attached.\n\nAfter Skills are used against characters affected by Riptide: Deal 1 Piercing DMG to the next opposing off-field character. (Twice per Round)\n\nDuration (Rounds): 2, switch back to Ranged Stance once 0 Usages remain.',
                'related': "Tartaglia"
            },
            'rangedstance': {
                'name': "Ranged Stance",
                'type': 'Status',
                'description': 'After the character to which this is attached uses Charged Attack: Apply Riptide to target character.',
                'related': 'Tartaglia'
            },
            'riptide': {
                'name': 'Riptide',
                'type': 'Status',
                'description': 'When the character to which this is attached is defeated: Apply Riptide to active character. \n\nWhen Tartaglia is in Melee Stance, he will deal additional DMG when attacking the character to which this is attached. \n\nDuration (Rounds): 2',
                'related': 'Tartaglia'
            },
            'cryocicinmage': {
                'name': 'Cryo Cicin Mage',
                'type': 'Combat Status',
                'description': "After a character to which Cryo Cicin Mage is attached uses a Skill: Deals 1 Cryo DMG to their team's active character. (Once per Round)\n\nUsage(s): 2"
            },
            'mirrormaiden': {
                'name': 'Mirror Maiden',
                'type': 'Combat Status',
                'description': "After a character to which Mirror Maiden is attached uses a Skill: Deals 1 Hydro DMG to their team's active character. (Once per Round)\n\nUsage(s): 2"
            },
            'pyroslingerbracker': {
                'name': 'Pyroslinger Bracer',
                'type': 'Combat Status',
                'description': "After a character to which Pyroslinger Bracer is attached uses a Skill: Deals 1 Pyro DMG to their team's active character. (Once per Round)\n\nUsage(s): 2"
            },
            'electrohammervanguard': {
                'name': 'Electrohammer Vanguard',
                'type': 'Combat Status',
                'description': "After a character to which Electrohammer Vanguard is attached uses a Skill: Deals 1 Electro DMG to their team's active character. (Once per Round)\n\nUsage(s): 2"
            },
            'aegisofabyssalflame': {
                'name': "Aegis of Abyssal Flame",
                "type": "Status",
                "description": "Grant the character to which this is attached 3 Shield points. \n\nBefore this Shield is depleted, the character to which this is attached will deal +1 Pyro DMG.",
                'related': 'Abyss Lector: Fathomless Flames'
            },
            'heronshield': {
                'name': "Heron Shield",
                "type": "Status",
                "description": "The next time this character acts, they will immediately use the Skill Heron Strike. While preparing this Skill: Grant 2 Shield points to the character to which this is attached.",
                'related': 'Candace'
            },
            "prayerofthecrimsoncrown": {
                'name': "Prayer of the Crimson Crown",
                "type": "Combat Status",
                "description": "Your characters' Normal Attacks deal +1 DMG. \nYour Sword, Claymore, and Polearm-wielding characters' Physical DMG is converted to Hydro DMG. \nAfter you switch characters, you deal 1 Hydro DMG. (Once per Round) \n\nDuration (Rounds): 2.",
                'related': 'Candace'
            },
            'scarletseal': {
                'name': "Scarlet Seal",
                "type": "Status",
                "description": "When the character uses a Charged Attack: Damage dealt +2. \n\nUsage(s): 1.",
                'related': 'Yanfei'
            },
            'brilliance': {
                'name': 'Brilliance',
                'type': 'Status',
                "description": "When the character uses a Charged Attack: Use 1 less Pyro Die. (Once every round.) \nEnd Phase: Attach Scarlet Seal to this character. \n\nDuration (Rounds): 2.",
                'related': 'Yanfei'
            },
            'midareranzan': {
                'name': "Midare Ranzan",
                "type": "Status",
                "description": "When the attached character uses a Plunging Attack: Physical DMG dealt becomes Anemo DMG, and deals +1 DMG. After the character uses a skill: This effect is removed.",
                'related': 'Kaedehara Kazuha'
            },
            'autumnwhirlwind': {
                'name': "Autumn Whirlwind",
                "type": "Summon",
                "description": "End Phase: Deal 1 Anemo DMG. \nUsage(s): 3 \n\nAfter your character or Summon triggers a Swirl reaction: Convert the Elemental Type of this card and change its DMG dealt to the element Swirled. (Can only be converted once before leaving the field)",
                'related': 'Kaedehara Kazuha'
            },
            'solarisotoma': {
                'name': 'Solar Isotoma',
                "type": 'Summon',
                "description": "Ending Phase: Deal 1 Geo DMG. \n\nUsage(s): 3 \n\nWhen this Summon is on the field: Your character's Plunging Attack spends 1 less Unaligned Element. (Once per Round)",
                'related': 'Albedo'
            },
            'heraldoffrost': {
                'name': 'Herald of Frost',
                "type": "Summon",
                "description": "End Phase: Deal 1 Cryo DMG. \n\nUsage(s): 3 \n\nWhen this Summon is on the field, after Qiqi uses Normal Attack: Heals your character who took the most DMG for 1 HP.",
                'related': 'Qiqi'
            },
            'fortunepreservingtalisman': {
                'name': 'Fortune-Preserving Talisman',
                "type": 'Combat Status',
                "description": "After your character uses a Skill: If that character does not have full HP, heal that character for 2 HP. \n\nUsage(s): 3",
                'related': 'Qiqi'
            },
            "conductive": {
                'name': 'Conductive',
                'type': 'Status',
                "description": 'This status starts with 2 stacks of Conductive. When attached repeatedly, Conductive stacks +1. Conductive can be stacked to a maximum of 4 stacks. \nEnd Phase: Accumulate 1 stack of Conductive.\n\nWhen the character attached by Conductive takes DMG from Violet Arc: Remove this status and DMG +1 for each stack of Conductive.',
                'related': 'Lisa'
            },
            "lightningrose": {
                'name': 'Lightning Rose',
                "type": "Summon",
                "description": "End Phase: Deal 2 Electro DMG. \n\nUsage(s): 2",
                'related': 'Lisa'
            },
            "windfavored": {
                'name': 'Windfavored',
                "type": "Status",
                "description": "When the character to which this is attached performs a Normal Attack: DMG dealt +2. If the opponent has characters on standby, then this Skill will deal damage to the next opposing character on standby instead.\n\nUsage(s): 2",
                'related': 'Wanderer'
            },
            "fierysanctumfield": {
                'name': 'Fiery Sanctum Field',
                "type": "Summon",
                "description": "End Phase:Deal 1 Pyro DMG.\n\nUsage(s): 3\n\nWhen this Summon is on the field and Dehya is on standby on your side, then when your active character takes damage: Decrease DMG taken by 1, and if Dehya has at least 7 HP, deal 1 Piercing DMG to the her (once per round).",
                'related': 'Dehya'
            },
            "yueguithrowingmode": {
                'name': 'Yuegui: Throwing Mode',
                "type": "Summon",
                "description": "End Phase: Deal 1 Dendro DMG, heal the character on your team that has taken the most damage for 1 HP.\n\nUsage(s): 2",
                'related': 'Yaoyao'
            },
            "adeptallegacy": {
                'name': 'Adeptal Legacy',
                "type": "Combat Status",
                "description": "After you switch characters: Deal 1 Dendro DMG, heal your active character for 1 HP.\n\nUsage(s): 3",
                'related': 'Yaoyao'
            },
            'curtainofslumbershield': {
                "name": 'Curtain of Slumber Shield',
                "type": 'Combat Status',
                "description": "Grants 2 Shield points to defend your active character.",
                'related': 'Layla',
            },
            'shootingstar': {
                "name": 'Shooting Star',
                "type": 'Combat Status',
                "description": "After your character uses a Skill: Accumulate 1 Night Star. If you have at least 4 Night Stars, consume 4 Night Stars and deal 1 Cryo DMG. (The Skill that causes this Combat Status will also trigger this effect) \n\nWhen causing this Combat Status again: Accumulate 2 Night Stars.",
                'related': 'Layla',
            },
            'celestialdreamsphere': {
                "name": 'Celestial Dreamsphere',
                "type": 'Summon',
                "description": "End Phase: Deal 1 Cryo DMG. If Shooting Star is in play, it will let it gain 1 Night Star.\n\nUsage(s): 2",  
                'related': 'Layla',
            },
            'exquisitethrow': {
                "name": 'Exquisite Throw',
                "type": 'Combat Status',
                "description": "After your character uses a Normal Attack: Deal 2 Hydro DMG. \n\nDuration (Rounds): 2",
                'related': 'Yelan',
            },
            'breakthrough': {
                "name": 'Breakthrough',
                "type": 'Status',
                "description": "This state starts with 1 Breakthrough stack. When re-attached, add 1 Breakthrough stack. Breakthrough can have a maximum of 3 stacks.\nEnd Phase: Gain 1 Breakthrough stack.\n\nWhen the character to which this is attached uses a Normal Attack: If Breakthrough has at least 2 stacks, consume 2 Breakthrough stacks to convert Physical DMG dealt into Hydro DMG and draw 1 card.",
                'related': 'Yelan',
            },
            'propsurplus': {
                "name": 'Prop Surplus',
                "type": 'Status',
                "description": "Prop Surplus can stack up to 3 times.\nWhen this character uses Bewildering Lights: +1 DMG for each Prop Surplus stack. After the skill is finalized, consume all Prop Surplus, healing 1 HP for this character per stack.", 
                'related': 'Lyney',
            },
            'grin-malkinhat': {
                "name": 'Grin-Malkin Hat',
                "type": 'Summon',
                "description": "End Phase: Deal 1 Pyro DMG.\n\nUsage(s): 1 (Can stack. Max 2 stacks.)",
                'related': 'Lyney',
            },
            'overawingassault': {
                "name": 'Overawing Assault',
                "type": 'Status',
                "description": "End Phase: If this character's HP is at least 6, then they will take 2 Piercing DMG.\n\nDuration (Rounds): 1",    
                'related': 'Lynette',
            },
            'bogglecatbox': {
                "name": 'Bogglecat Box',
                "type": 'Summon',
                "description": "End Phase: Deal 1 Anemo DMG.\n\nUsage(s): 2\n\nWhen your active character takes DMG: Decreases DMG taken by 1. (Once per Round)\nWhen your character(s) take Cryo/Hydro/Pyro/Electro DMG: Change the Elemental Type of this card to the element of the damage taken. (Once before leaving play)",
                'related': 'Lynette',
            },
            'generalswarbanner': {
                "name": "General's War Banner",
                "type": 'Combat Status',
                "description": "Your party's characters deal +1 Geo DMG.\n\nDuration (Rounds): 2 (Can stack, can stack till 3 Rounds)",
                'related': 'Gorou',
            },
            'generalsglory': {
                "name": "General's Glory",
                "type": 'Summon',
                "description": "End Phase: Deal 1 Geo DMG. If your party has 2 Geo characters, create 1 Crystallize.\n\nUsage(s): 2",
                'related': 'Gorou',
            },
            'chisel-lightmirror': {
                "name": 'Chisel-Light Mirror',
                "type": 'Status',
                "description": "Physical DMG dealt by the character is converted to Dendro DMG.\nAfter this character performs a Normal Attack: Deal 1 Dendro DMG. If it is a Charged Attack, this state's Duration (Rounds) +1.\nDuration (Rounds): 2 (Can stack, max 3 stacks)",
                'related': 'Alhaitham',
            },
            'blazingheat': {
                "name": 'Blazing Heat',
                "type": 'Status',
                "description": "End Phase: Deals 1 Pyro DMG to attached character.\n\nUsage(s): 1\n\nWhen attached character has Sheer Cold attached, remove this effect.",
                'related': 'Signora',
            },
            'sheercold': {
                "name": 'Sheer Cold',
                "type": 'Status',
                "description": "End Phase: Deals 1 Cryo DMG to attached character.\n\nUsage(s): 1\n\nWhen attached character has Blazing Heat attached, remove this effect.",
                'related': 'Signora',
            },
            'ice-sealedcrimsonwitchofembers': {
                "name": 'Ice-Sealed Crimson Witch of Embers',
                "type": 'Status',
                "description": "When the Action Phase starts: If the attached character has no more than 4 HP, remove this effect.\nWhen attached character is defeated: Remove this effect, ensure that character is not defeated and heal them to 1 HP.\n\nWhen this effect is removed: Attached character will transform into the Crimson Witch of Embers state.",
                'related': 'Signora',
            },

            'spiritofomen:pyroscorpion': {
                "name": 'Spirit of Omen: Pyro Scorpion',
                "type": 'Summon',
                "description": "End Phase: Deal 1 Pyro DMG.\n\nUsage(s): 2\n\nWhen entering play, when the Action Phase starts: Attach Pyro Scorpion: Guardian Stance to your Eremite Scorching Loremaster. (When Spirit of Omen: Pyro Scorpion is in play, the character will take -1 DMG, once per Round.)",
                'related': 'Eremite Scorching Loremaster',
            },
            'lightningrod': {
                "name": 'Lightning Rod',
                "type": 'Status',
                "description": "While this status is active, can be triggered once: The character to which it is attached will receive +1 DMG from Thunder Manifestation or its summons.\n\n(Only one of this status can exist on the field at once. Some of Thunder Manifestation's skills will target the character to which this is attached.)",
                'related': 'Thunder Manifestation',
            },
            'thunderingshackles': {
                "name": 'Thundering Shackles',
                "type": 'Summon',
                "description": "End Phase: Deals 3 Electro DMG to opposing characters affected by Lightning Rod. (If there are no eligible opposing characters, deals DMG to the active character instead)\n\nUsage(s): 1",
                'related': 'Thunder Manifestation',
            },
            'lightningstrikeprobe': {
                "name": 'Lightning Strike Probe',
                "type": 'Combat Status',
                "description": "After a character on whose side of the field this card is on uses a Skill: Attach Lightning Rod to the active character on that side. (Once per Round)",
                'related': 'Thunder Manifestation',
            },
            'totalcollapse': {
                "name": 'Total Collapse',
                "type": 'Status',
                "description": "Physical and Anemo DMG taken by the affected character increased by 2.\n\nUsage(s): 1",
                'related': 'Dvalin',
            },
            'stonefacets:elementalcrystallization': {
                "name": 'Stone Facets: Elemental Crystallization',
                "type": 'Status',
                "description": "After this character takes Cryo/Hydro/Pyro/Electro DMG: If this character currently has not absorbed the power of this element, remove this effect, and then this character performs Elemental Absorption.",
                'related': 'Azhdaha',
            },
            'stonefacets:elementalabsorption': {
                "name": 'Stone Facets: Elemental Absorption',
                "type": 'Status',
                "description": "The character can absorb the power of the Elements, including Cryo/Hydro/Pyro/Electro, and then based on the element absorbed, gain the skills Frostspike Wave/Torrential Rebuke/Blazing Rebuke/Thunderstorm Wave. (The character can only have one Elemental Type absorbed at once, and this status will record the Elemental Type previously absorbed) \n\nAfter this character absorbs an element of a different type than the currently absorbed element: Generate 1 Elemental Die of the same type as the Element that was just absorbed.",
                'related': 'Azhdaha',
            },
            'fourleafsigil': {
                "name": 'Four-Leaf Sigil',
                "type": 'Status',
                "description": "End Phase: Switch to the attached character.",
                'related': 'Flickering Four-Leaf Sigil',
            },
            'blazingbarrier': {
                "name": 'Blazing Barrier',
                "type": 'Combat Status',
                "description": "Grants 1 Shield point to your active character. (Can stack. Max 3 points.).",
                'related': 'Thoma',
            },
            'scorchingooyoroi': {
                "name": 'Scorching Ooyoroi',
                "type": "Combat Status",
                "description": "After your character uses a Normal Attack: Deal 1 Pyro DMG and create a Blazing Barrier. \n\nUsage(s): 2",
                "related": "Thoma"
            },
            'mujimujidaruma': {
                "name": "Muji-Muji Daruma",
                "type": "Summon",
                "description": "End Phase: Deal 1 Anemo DMG, heal the character on your team that has taken the most damage for 2 HP. \n\nUsage(s): 2",
                "related": "Sayu"
            },
            'overwhelmingice': {
                "name": " Overwhelming Ice",
                "type": "Status",
                "description": "When the character uses a Normal Attack: Deal 1 Piercing DMG to all opposing characters on standby. \n\nUsage(s): 1",
                "related": "Cryo Hypostasis"
            },
            'piercingiceridge': {
                "name": "Piercing Iceridge",
                "type": "Summon",
                "description": "End Phase: Deal 1 Cryo DMG to the opposing Character Closest to Your Current Active Character. \n\nUsage(s): 2",
                "related": "Cryo Hypostasis"
            },
            'cryocrystalcore': {
                "name": "Cryocrystal Core",
                "type": "Status",
                "description": "When the character to which this is attached would be defeated: Remove this effect, ensure the character is not defeated, and heal them to 1 HP.",
                "related": "Cryo Hypostasis"
            },
            'fontemerpearl': {
                "name": "Fontemer Pearl",
                "type": "Status",
                "description": "When the character to which this is attached takes DMG: Negate 1 DMG. Once per Round, Usage(s) will not be used when negating DMG from Summons. \n\nUsage(s): 2 \n\nWhen you declare the end of your Round: If the character to which this is attached is the active character, draw 1 card.",
                "related": "Millennial Pearl Seahorse"
            },
            'resonantcoralorb': {
                "name": "Resonant Coral Orb",
                "type": "Summon",
                "description": "End Phase: Deal 1 Electro DMG. \n\nUsage(s): 2",
                "related": "Millennial Pearl Seahorse"
            },
        },
    
        "nullchar": {
            "icon": Nullchar_Icon   
        },
    
        "elements": {
            'anemo': Anemo_Sort,
            'anemo_activated': Anemo_Sort_Activated,
            'cryo': Cryo_Sort,
            'cryo_activated': Cryo_Sort_Activated,
            'dendro':Dendro_Sort,
            'dendro_activated': Dendro_Sort_Activated,
            'electro': Electro_Sort,
            'electro_activated': Electro_Sort_Activated,
            'geo': Geo_Sort,
            'geo_activated': Geo_Sort_Activated,
            'hydro': Hydro_Sort,
            'hydro_activated': Hydro_Sort_Activated,
            'pyro': Pyro_Sort,
            'pyro_activated': Pyro_Sort_Activated,
            'noelement': NoElement_Sort
        },
    
        "factions": {
            'fatui': Fatui_Sort,
            'hilichurl': Hilichurl_Sort,
            'inazuma': Inazuma_Sort,
            'kairagi': Kairagi_Sort,
            'liyue': Liyue_Sort,
            'mondstadt': Mond_Sort,
            'monster': Monster_Sort,
            'sumeru': Sumeru_Sort,
        },
    
        "dice": {
            'pyro': Pyro_Dice,
            'hydro': Hydro_Dice,
            'anemo': Anemo_Dice,
            'electro': Electro_Dice,
            'dendro': Dendro_Dice,
            'cryo': Cryo_Dice,
            'geo': Geo_Dice,
            'omni': Omni_Dice,
            'white': White_Dice,
            'black': Black_Dice,
            'energy': Energy,
            'arcane': Arcane
        },
    
        "menu": {
            'char_sort': Char_Sort,
            "action_sort": Action_Sort,
            "char_sort_hover": Char_Sort_Hover,
            "action_sort_hover": Action_Sort_Hover
        }
    }
}

export default db